const SCHOOLS_DETAILS = [
  {
    "i": "0",
    "county": "Carlow",
    "rollNumber": "00651R",
    "schoolName": "Borris Mxd NS",
    "SETHours": "70",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "R95RH6F",
    "addressOne": "Lower Main Street",
    "addressTwo": "Borris",
    "addressThree": "Co. Carlow",
    "addressFour": "",
    "lat": "52.599655",
    "lng": "-6.9204334",
    "phone": "599773402",
    "email": "secborrisns@gmail.com"
  },
  {
    "i": "1",
    "county": "Carlow",
    "rollNumber": "00977B",
    "schoolName": "Ballyconnell NS",
    "SETHours": "60",
    "spClassTeachingPosts": "2",
    "mainSNA": "2",
    "spSNA": "3.32",
    "totalSNA": "5.32",
    "eircode": "R93VA44",
    "addressOne": "Ballyconnell",
    "addressTwo": "Tullow",
    "addressThree": "Co. Carlow",
    "addressFour": "",
    "lat": "52.8127077",
    "lng": "-6.6291924",
    "phone": "599156226",
    "email": "ballyconnellnationalschool@gmail.com"
  },
  {
    "i": "2",
    "county": "Carlow",
    "rollNumber": "01116A",
    "schoolName": "Baile An Chuilinn NS",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "R21Y803",
    "addressOne": "Ballinkillen",
    "addressTwo": "Muine Bheag",
    "addressThree": "Co. Carlow",
    "addressFour": "",
    "lat": "52.6488109",
    "lng": "-6.9300953",
    "phone": "599775153",
    "email": "bkns.ias@gmail.com"
  },
  {
    "i": "3",
    "county": "Carlow",
    "rollNumber": "01215C",
    "schoolName": "Newtown Dunleckney Mxd",
    "SETHours": "60",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "R21PP74",
    "addressOne": "Newtown",
    "addressTwo": "Muinebheag",
    "addressThree": "Co. Carlow",
    "addressFour": "",
    "lat": "52.7227975",
    "lng": "-6.8765454",
    "phone": "599727299",
    "email": "newtowndunleckneyns@gmail.com"
  },
  {
    "i": "4",
    "county": "Carlow",
    "rollNumber": "01415K",
    "schoolName": "Rathoe Ns",
    "SETHours": "80",
    "spClassTeachingPosts": "2",
    "mainSNA": "0",
    "spSNA": "4",
    "totalSNA": "4",
    "eircode": "R93XY18",
    "addressOne": "Rathoe",
    "addressTwo": "Co. Carlow",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.787528",
    "lng": "-6.7997597",
    "phone": "599148786",
    "email": "info@rathoens.com"
  },
  {
    "i": "5",
    "county": "Carlow",
    "rollNumber": "02124E",
    "schoolName": "Scoil Nais Molaise",
    "SETHours": "55",
    "spClassTeachingPosts": "2",
    "mainSNA": "1.5",
    "spSNA": "3.49",
    "totalSNA": "4.99",
    "eircode": "R93NX05",
    "addressOne": "Parknakyle",
    "addressTwo": "Old Leighlin",
    "addressThree": "Co. Carlow",
    "addressFour": "",
    "lat": "52.7397161",
    "lng": "-7.0338272",
    "phone": "599722166",
    "email": "oldleighlinns@eircom.net"
  },
  {
    "i": "6",
    "county": "Carlow",
    "rollNumber": "04077I",
    "schoolName": "Scoil Nais Bhride",
    "SETHours": "70",
    "spClassTeachingPosts": "2",
    "mainSNA": "1",
    "spSNA": "4.83",
    "totalSNA": "5.83",
    "eircode": "R93FX22",
    "addressOne": "Grange",
    "addressTwo": "Tullow",
    "addressThree": "Co. Carlow",
    "addressFour": "",
    "lat": "52.8375687",
    "lng": "-6.7821601",
    "phone": "599163881",
    "email": "grangens@ymail.com"
  },
  {
    "i": "7",
    "county": "Carlow",
    "rollNumber": "09320Q",
    "schoolName": "Scoil Nais Mhuire",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "R21D778",
    "addressOne": "Drumphea",
    "addressTwo": "Bagenalstown",
    "addressThree": "Co. Carlow",
    "addressFour": "",
    "lat": "52.6581496",
    "lng": "-6.8399515",
    "phone": "599727316",
    "email": "drumpheans@gmail.com"
  },
  {
    "i": "8",
    "county": "Carlow",
    "rollNumber": "11135K",
    "schoolName": "St Marys NS",
    "SETHours": "50",
    "spClassTeachingPosts": "1",
    "mainSNA": "2.83",
    "spSNA": "2",
    "totalSNA": "4.83",
    "eircode": "R21DX34",
    "addressOne": "Dunleckney",
    "addressTwo": "Muine Bheag",
    "addressThree": "Co. Carlow",
    "addressFour": "",
    "lat": "52.7003949",
    "lng": "-6.959789",
    "phone": "599721021",
    "email": "stmarysnsbagenalstown@gmail.com"
  },
  {
    "i": "9",
    "county": "Carlow",
    "rollNumber": "13105L",
    "schoolName": "St Bridgets Monastery Boys Sn School",
    "SETHours": "75",
    "spClassTeachingPosts": "2",
    "mainSNA": "1.75",
    "spSNA": "3.32",
    "totalSNA": "5.07",
    "eircode": "R21PR62",
    "addressOne": "Muinebheag",
    "addressTwo": "Co. Carlow",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.7003538",
    "lng": "-6.95498",
    "phone": "599721984",
    "email": "sbpupil.ias@eircom.net"
  },
  {
    "i": "10",
    "county": "Carlow",
    "rollNumber": "13507I",
    "schoolName": "SN Muire Lourdes",
    "SETHours": "75",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "R93Y960",
    "addressOne": "Mill Street",
    "addressTwo": "Tullow",
    "addressThree": "Co. Carlow",
    "addressFour": "",
    "lat": "52.8005708",
    "lng": "-6.7339136",
    "phone": "599151875",
    "email": "tullowgns.ias@eircom.net"
  },
  {
    "i": "11",
    "county": "Carlow",
    "rollNumber": "13607M",
    "schoolName": "St Columbas NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "R93R266",
    "addressOne": "Dublin Road",
    "addressTwo": "Tullow",
    "addressThree": "Co. Carlow",
    "addressFour": "",
    "lat": "52.8040472",
    "lng": "-6.7327755",
    "phone": "599151873",
    "email": "info@stcolumbasnstullow.com"
  },
  {
    "i": "12",
    "county": "Carlow",
    "rollNumber": "14837L",
    "schoolName": "SN Peadar Agus Pol",
    "SETHours": "90",
    "spClassTeachingPosts": "1",
    "mainSNA": "1.83",
    "spSNA": "3",
    "totalSNA": "4.83",
    "eircode": "R93WE29",
    "addressOne": "Ballon",
    "addressTwo": "Co. Carlow",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.7384237",
    "lng": "-6.7688751",
    "phone": "599159280",
    "email": "ballonns1@gmail.com"
  },
  {
    "i": "13",
    "county": "Carlow",
    "rollNumber": "16080N",
    "schoolName": "SN Phadraig Naofa",
    "SETHours": "110",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "R93C594",
    "addressOne": "The Course",
    "addressTwo": "Tullow",
    "addressThree": "Co. Carlow",
    "addressFour": "",
    "lat": "52.8032772",
    "lng": "-6.7327033",
    "phone": "599151625",
    "email": "info@tullowboysns.ie"
  },
  {
    "i": "14",
    "county": "Carlow",
    "rollNumber": "16938E",
    "schoolName": "Fr Cullen Memorial NS",
    "SETHours": "65",
    "spClassTeachingPosts": "2",
    "mainSNA": "1",
    "spSNA": "4",
    "totalSNA": "5",
    "eircode": "R93TR98",
    "addressOne": "Tinryland",
    "addressTwo": "Co. Carlow",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.7953308",
    "lng": "-6.8963234",
    "phone": "599132156",
    "email": "tinrylandns1@gmail.com"
  },
  {
    "i": "15",
    "county": "Carlow",
    "rollNumber": "17053P",
    "schoolName": "Bishop Foley Memorial School Boys Snr Sch",
    "SETHours": "152.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "R93P825",
    "addressOne": "Station Road",
    "addressTwo": "Co. Carlow",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.8411628",
    "lng": "-6.9246488",
    "phone": "599142919",
    "email": "bfnscarlow@gmail.com"
  },
  {
    "i": "16",
    "county": "Carlow",
    "rollNumber": "17096K",
    "schoolName": "SN Nmh Fhingin",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "R21V093",
    "addressOne": "Garryhill",
    "addressTwo": "Muinebheag",
    "addressThree": "Co. Carlow",
    "addressFour": "",
    "lat": "52.6774589",
    "lng": "-6.8527283",
    "phone": "599727355",
    "email": "garryhillschool@gmail.com"
  },
  {
    "i": "17",
    "county": "Carlow",
    "rollNumber": "17127S",
    "schoolName": "St Josephs Ns",
    "SETHours": "90",
    "spClassTeachingPosts": "1",
    "mainSNA": "3.83",
    "spSNA": "0.83",
    "totalSNA": "4.66",
    "eircode": "R93VH42",
    "addressOne": "Hacketstown",
    "addressTwo": "Co. Carlow",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.8632942",
    "lng": "-6.5563808",
    "phone": "596471199",
    "email": "htownns@gmail.com"
  },
  {
    "i": "18",
    "county": "Carlow",
    "rollNumber": "17330P",
    "schoolName": "Scoil N Moling-glynn",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "R95XH58",
    "addressOne": "Glynn",
    "addressTwo": "Saint Mulllins",
    "addressThree": "Co. Carlow",
    "addressFour": "",
    "lat": "52.5020626",
    "lng": "-6.9080752",
    "phone": "51424892",
    "email": "scoilmoling@gmail.com"
  },
  {
    "i": "19",
    "county": "Carlow",
    "rollNumber": "17462J",
    "schoolName": "Scoil Nais Mhichil",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "R95TP30",
    "addressOne": "Newtown",
    "addressTwo": "Borris",
    "addressThree": "Co. Carlow",
    "addressFour": "",
    "lat": "52.5466065",
    "lng": "-6.9037671",
    "phone": "599724499",
    "email": "stmichaels.newtown@gmail.com"
  },
  {
    "i": "20",
    "county": "Carlow",
    "rollNumber": "17481N",
    "schoolName": "St Brendans NS",
    "SETHours": "7.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "R95DX24",
    "addressOne": "Drummond",
    "addressTwo": "Saint Mullins",
    "addressThree": "Co. Carlow",
    "addressFour": "Via Kilkenny",
    "lat": "52.4727811",
    "lng": "-6.9012972",
    "phone": "51424744",
    "email": "stbrendansdrummond@gmail.com"
  },
  {
    "i": "21",
    "county": "Carlow",
    "rollNumber": "17501Q",
    "schoolName": "Bennekerry NS",
    "SETHours": "140",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "R93D535",
    "addressOne": "Bennekerry",
    "addressTwo": "Co. Carlow",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.8310042",
    "lng": "-6.8699984",
    "phone": "599143495",
    "email": "bennekerry@gmail.com"
  },
  {
    "i": "22",
    "county": "Carlow",
    "rollNumber": "17514C",
    "schoolName": "SN Cluain Na Gall",
    "SETHours": "35",
    "spClassTeachingPosts": "2",
    "mainSNA": "1.83",
    "spSNA": "4",
    "totalSNA": "5.83",
    "eircode": "Y21XK73",
    "addressOne": "Main Street",
    "addressTwo": "Clonegal",
    "addressThree": "Co Carlow",
    "addressFour": "",
    "lat": "52.6963012",
    "lng": "-6.6488076",
    "phone": "539377513",
    "email": "clonegalns@gmail.com"
  },
  {
    "i": "23",
    "county": "Carlow",
    "rollNumber": "17663T",
    "schoolName": "St Patricks NS",
    "SETHours": "70",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "R93RD98",
    "addressOne": "Rathvilly",
    "addressTwo": "Co. Carlow",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.8802368",
    "lng": "-6.69041",
    "phone": "599161304",
    "email": "rathvilly.ns@gmail.com"
  },
  {
    "i": "24",
    "county": "Carlow",
    "rollNumber": "17669I",
    "schoolName": "SN Treasa Naomha",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "W91TFN5",
    "addressOne": "Tynock",
    "addressTwo": "Kiltegan",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "52.8918319",
    "lng": "-6.6187199",
    "phone": "596473210",
    "email": "tynockschool@gmail.com"
  },
  {
    "i": "25",
    "county": "Carlow",
    "rollNumber": "17756D",
    "schoolName": "Ballinabranna Mxd NS",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "R93T9N4",
    "addressOne": "Milford",
    "addressTwo": "Co. Carlow",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.7856668",
    "lng": "-6.9829959",
    "phone": "599146253",
    "email": "ballinabrannans@gmail.com"
  },
  {
    "i": "26",
    "county": "Carlow",
    "rollNumber": "17796P",
    "schoolName": "Our Lady's NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "R93D340",
    "addressOne": "Nurney",
    "addressTwo": "Carlow",
    "addressThree": "Co Carlow",
    "addressFour": "",
    "lat": "52.748845",
    "lng": "-6.9120279",
    "phone": "599146297",
    "email": "nurneyns@gmail.com"
  },
  {
    "i": "27",
    "county": "Carlow",
    "rollNumber": "17994T",
    "schoolName": "SN Fhoirtcheirn/fhinin",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "R21HR22",
    "addressOne": "Myshall",
    "addressTwo": "Bagenalstown",
    "addressThree": "Co. Carlow",
    "addressFour": "",
    "lat": "52.6865065",
    "lng": "-6.7800936",
    "phone": "599157750",
    "email": "myshallschool@gmail.com"
  },
  {
    "i": "28",
    "county": "Carlow",
    "rollNumber": "18024N",
    "schoolName": "Scoil Muire Gan Smal",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "R93WC03",
    "addressOne": "Ardattin",
    "addressTwo": "Co. Carlow",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.7562339",
    "lng": "-6.7058036",
    "phone": "599155649",
    "email": "ardattin.ias@eircom.net"
  },
  {
    "i": "29",
    "county": "Carlow",
    "rollNumber": "18090D",
    "schoolName": "SN Cill Damhain",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "Y21EC60",
    "addressOne": "Kildavin",
    "addressTwo": "Co. Carlow",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6846657",
    "lng": "-6.6856625",
    "phone": "539376456",
    "email": "kildavin.ias@gmail.com"
  },
  {
    "i": "30",
    "county": "Carlow",
    "rollNumber": "18183K",
    "schoolName": "Queen Of Universe NS",
    "SETHours": "112.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "4.66",
    "spSNA": "4.83",
    "totalSNA": "9.49",
    "eircode": "R21T280",
    "addressOne": "Long Range",
    "addressTwo": "Muinebeagh",
    "addressThree": "Co. Carlow",
    "addressFour": "",
    "lat": "52.701557",
    "lng": "-6.9633388",
    "phone": "599721075",
    "email": "info@queenoftheuniversens.com"
  },
  {
    "i": "31",
    "county": "Carlow",
    "rollNumber": "18363M",
    "schoolName": "SN Muire Gan Smal",
    "SETHours": "165",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "R93FP57",
    "addressOne": "Green Lane",
    "addressTwo": "Carlow",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.8381424",
    "lng": "-6.9229284",
    "phone": "599142705",
    "email": "smgscarlow@gmail.com"
  },
  {
    "i": "32",
    "county": "Carlow",
    "rollNumber": "18424G",
    "schoolName": "Scoil Nais Iosef Naofa",
    "SETHours": "105",
    "spClassTeachingPosts": "2",
    "mainSNA": "1.83",
    "spSNA": "3.32",
    "totalSNA": "5.15",
    "eircode": "R93HP99",
    "addressOne": "St. Joseph's Road",
    "addressTwo": "Co. Carlow",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.838937",
    "lng": "-6.9234188",
    "phone": "599142502",
    "email": "stjosephs1960@gmail.com"
  },
  {
    "i": "33",
    "county": "Carlow",
    "rollNumber": "18510W",
    "schoolName": "St Patrick's NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "R95FH76",
    "addressOne": "Ballymurphy",
    "addressTwo": "Borris",
    "addressThree": "Co Carlow (via Kilkenny)",
    "addressFour": "",
    "lat": "52.5712906",
    "lng": "-6.8604961",
    "phone": "599773512",
    "email": "ballymurphynationalschool@gmail.com"
  },
  {
    "i": "34",
    "county": "Carlow",
    "rollNumber": "18609S",
    "schoolName": "SN Fiontain Naofa",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "R93YH51",
    "addressOne": "Rathmore",
    "addressTwo": "Tullow",
    "addressThree": "Co. Carlow",
    "addressFour": "",
    "lat": "52.8584021",
    "lng": "-6.7346688",
    "phone": "599161375",
    "email": "rathmorens.ias@gmail.com"
  },
  {
    "i": "35",
    "county": "Carlow",
    "rollNumber": "18615N",
    "schoolName": "SN Ceatharlach",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "R93A504",
    "addressOne": "Green Road",
    "addressTwo": "Carlow",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.8267689",
    "lng": "-6.932723",
    "phone": "599132175",
    "email": "carlownationalschool@yahoo.com"
  },
  {
    "i": "36",
    "county": "Carlow",
    "rollNumber": "19477J",
    "schoolName": "Holy Family BNS",
    "SETHours": "212.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "R93VX27",
    "addressOne": "Askea",
    "addressTwo": "Carlow",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.8363471",
    "lng": "-6.913121",
    "phone": "599142772",
    "email": "info@askeaboys.com"
  },
  {
    "i": "37",
    "county": "Carlow",
    "rollNumber": "19478L",
    "schoolName": "Holy Family Girls NS",
    "SETHours": "175",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "R93X793",
    "addressOne": "Askea",
    "addressTwo": "Co. Carlow",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.83561",
    "lng": "-6.9127226",
    "phone": "599142343",
    "email": "askeagns@eircom.net"
  },
  {
    "i": "38",
    "county": "Carlow",
    "rollNumber": "19784S",
    "schoolName": "St Laserians Mxd Ns",
    "SETHours": "70",
    "spClassTeachingPosts": "2",
    "mainSNA": "1",
    "spSNA": "3.49",
    "totalSNA": "4.49",
    "eircode": "R93YY72",
    "addressOne": "Leighlinbridge",
    "addressTwo": "Co. Carlow",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.7353257",
    "lng": "-6.9718633",
    "phone": "599721796",
    "email": "school@leighlin.net"
  },
  {
    "i": "39",
    "county": "Carlow",
    "rollNumber": "19811S",
    "schoolName": "Gaelscoil Eoghain Í­ Thuairisc",
    "SETHours": "130",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.66",
    "spSNA": "0",
    "totalSNA": "4.66",
    "eircode": "R93PX92",
    "addressOne": "Garrán Na Fuinseoige",
    "addressTwo": "Ceatharlach",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.8296693",
    "lng": "-6.9119131",
    "phone": "599131634",
    "email": "aingeal@cgscoil.ie"
  },
  {
    "i": "40",
    "county": "Carlow",
    "rollNumber": "19958C",
    "schoolName": "S.n. Naomh Fhiach",
    "SETHours": "250",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "R93KT68",
    "addressOne": "Killeshin Road",
    "addressTwo": "Graiguecullen",
    "addressThree": "Co. Carlow",
    "addressFour": "",
    "lat": "52.8376294",
    "lng": "-6.9455998",
    "phone": "599132444",
    "email": "st.fiaccs@gmail.com"
  },
  {
    "i": "41",
    "county": "Carlow",
    "rollNumber": "20295K",
    "schoolName": "Carlow Educate Together Ns",
    "SETHours": "177.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "4.83",
    "spSNA": "3.83",
    "totalSNA": "8.66",
    "eircode": "R93TW74",
    "addressOne": "Bestfield",
    "addressTwo": "Athy Road",
    "addressThree": "Carlow",
    "addressFour": "",
    "lat": "52.8549272",
    "lng": "-6.9279966",
    "phone": "599137541",
    "email": "siobhan@carloweducatetogether.ie"
  },
  {
    "i": "42",
    "county": "Cavan",
    "rollNumber": "01356U",
    "schoolName": "Kilnaleck Mixed NS",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "A82EY42",
    "addressOne": "Barrack Road",
    "addressTwo": "Kilnaleck",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "53.85972",
    "lng": "-7.321483",
    "phone": "494336728",
    "email": "kilnaleckns1@gmail.com"
  },
  {
    "i": "43",
    "county": "Cavan",
    "rollNumber": "05627W",
    "schoolName": "Bailieboro Model NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "A82FX62",
    "addressOne": "Bailieborough",
    "addressTwo": "Co. Cavan",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.9170783",
    "lng": "-6.9744546",
    "phone": "429665689",
    "email": "themodelns@gmail.com"
  },
  {
    "i": "44",
    "county": "Cavan",
    "rollNumber": "06998Q",
    "schoolName": "St Patrick's Ns",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "H14RP30",
    "addressOne": "Corlough",
    "addressTwo": "Belturbet",
    "addressThree": "C/o Belturbet Post Office",
    "addressFour": "Co. Cavan",
    "lat": "54.1235711",
    "lng": "-7.7691053",
    "phone": "499523655",
    "email": "stpatrickscorlough@gmail.com"
  },
  {
    "i": "45",
    "county": "Cavan",
    "rollNumber": "08143P",
    "schoolName": "SN Mhuire",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H14KX84",
    "addressOne": "Bawn Road",
    "addressTwo": "Swanlibar",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "54.1908831",
    "lng": "-7.7057354",
    "phone": "499521613",
    "email": "office@swanlinbarns.ie"
  },
  {
    "i": "46",
    "county": "Cavan",
    "rollNumber": "08453H",
    "schoolName": "SN Cruabanai",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "H12NY64",
    "addressOne": "Crubany",
    "addressTwo": "Co. Cavan",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.9653527",
    "lng": "-7.3216451",
    "phone": "494362202",
    "email": "crubany.ias@eircom.net"
  },
  {
    "i": "47",
    "county": "Cavan",
    "rollNumber": "08490N",
    "schoolName": "St Clares Primary School",
    "SETHours": "220",
    "spClassTeachingPosts": "1",
    "mainSNA": "3.49",
    "spSNA": "2",
    "totalSNA": "5.49",
    "eircode": "H12DR74",
    "addressOne": "Ard Mhuire",
    "addressTwo": "Cavan",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.9917564",
    "lng": "-7.356983",
    "phone": "494332671",
    "email": "admin@stclarescavan.ie"
  },
  {
    "i": "48",
    "county": "Cavan",
    "rollNumber": "08948L",
    "schoolName": "Milltown NS",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.33",
    "spSNA": "0",
    "totalSNA": "2.33",
    "eircode": "H14AK74",
    "addressOne": "Monea",
    "addressTwo": "Milltown",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "54.0643727",
    "lng": "-7.4752393",
    "phone": "499522802",
    "email": "milltownns@gmail.com"
  },
  {
    "i": "49",
    "county": "Cavan",
    "rollNumber": "10146K",
    "schoolName": "Corliss NS",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H12E621",
    "addressOne": "Corliss",
    "addressTwo": "Killeshandra",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "53.9748838",
    "lng": "-7.4972322",
    "phone": "494334888",
    "email": "schooloffice@corlissns.ie"
  },
  {
    "i": "50",
    "county": "Cavan",
    "rollNumber": "11205F",
    "schoolName": "Killeshandra NS ( C Of I)",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H12Y2N1",
    "addressOne": "Main Street",
    "addressTwo": "Killeshandra",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "54.0128709",
    "lng": "-7.528214",
    "phone": "494334822",
    "email": "killens@eircom.net"
  },
  {
    "i": "51",
    "county": "Cavan",
    "rollNumber": "11409V",
    "schoolName": "Ballyconell Central NS",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H14K125",
    "addressOne": "Church Street",
    "addressTwo": "Ballyconnell",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "54.1171497",
    "lng": "-7.5875073",
    "phone": "499526055",
    "email": "ballycns.ias@eircom.net"
  },
  {
    "i": "52",
    "county": "Cavan",
    "rollNumber": "11517B",
    "schoolName": "Cavan 1 NS",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "H12CX22",
    "addressOne": "Farnham Street",
    "addressTwo": "Cavan",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "53.9902",
    "lng": "-7.3628395",
    "phone": "494362122",
    "email": "cavanno1.ias@eircom.net"
  },
  {
    "i": "53",
    "county": "Cavan",
    "rollNumber": "11541V",
    "schoolName": "Dromaili SN",
    "SETHours": "62.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "H12DW77",
    "addressOne": "Drumelis",
    "addressTwo": "Cavan",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "54.0029941",
    "lng": "-7.383981",
    "phone": "494332011",
    "email": "Office@farnhamschool.com"
  },
  {
    "i": "54",
    "county": "Cavan",
    "rollNumber": "12099O",
    "schoolName": "Billis NS",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "A82CK31",
    "addressOne": "New Inns",
    "addressTwo": "Ballyjamesduff",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "53.8868492",
    "lng": "-7.1453675",
    "phone": "498544653",
    "email": "billisns.ias@eircom.net"
  },
  {
    "i": "55",
    "county": "Cavan",
    "rollNumber": "12312L",
    "schoolName": "Darley NS",
    "SETHours": "35",
    "spClassTeachingPosts": "1",
    "mainSNA": "2",
    "spSNA": "1",
    "totalSNA": "3",
    "eircode": "H16NH02",
    "addressOne": "Monaghan Road",
    "addressTwo": "Cootehill",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "54.0761079",
    "lng": "-7.0865149",
    "phone": "495556055",
    "email": "darley.ias@eircom.net"
  },
  {
    "i": "56",
    "county": "Cavan",
    "rollNumber": "13203L",
    "schoolName": "St Patricks Mxd NS",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "H12R596",
    "addressOne": "Loch Gowna",
    "addressTwo": "Co. Cavan",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.8739753",
    "lng": "-7.5345335",
    "phone": "436683514",
    "email": "gownans@gmail.com"
  },
  {
    "i": "57",
    "county": "Cavan",
    "rollNumber": "13271F",
    "schoolName": "Fairgreen NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H14HK71",
    "addressOne": "Railway Road",
    "addressTwo": "Belturbet",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "54.0988844",
    "lng": "-7.4436699",
    "phone": "499522803",
    "email": "fairgreenbelturbet@eircom.net"
  },
  {
    "i": "58",
    "county": "Cavan",
    "rollNumber": "14073G",
    "schoolName": "Castletara NS",
    "SETHours": "62.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "1",
    "spSNA": "7",
    "totalSNA": "8",
    "eircode": "H12PK74",
    "addressOne": "Castletara",
    "addressTwo": "Ballyhaise",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "54.0305148",
    "lng": "-7.2916968",
    "phone": "494338225",
    "email": "castletarans@gmail.com"
  },
  {
    "i": "59",
    "county": "Cavan",
    "rollNumber": "14211P",
    "schoolName": "SN Lathrach 2",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "A82XD80",
    "addressOne": "Muff",
    "addressTwo": "Kingscourt",
    "addressThree": "Co Cavan",
    "addressFour": "",
    "lat": "53.9028116",
    "lng": "-6.8622664",
    "phone": "429667744",
    "email": "muffschool@gmail.com"
  },
  {
    "i": "60",
    "county": "Cavan",
    "rollNumber": "14320U",
    "schoolName": "Corlea NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "A82AT88",
    "addressOne": "Corlea",
    "addressTwo": "Kingscourt",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "53.9444084",
    "lng": "-6.8732002",
    "phone": "429667338",
    "email": "corleaschool@gmail.com"
  },
  {
    "i": "61",
    "county": "Cavan",
    "rollNumber": "14336M",
    "schoolName": "Searcog I NS",
    "SETHours": "75",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "A81DK60",
    "addressOne": "Kingscourt Road",
    "addressTwo": "Shercock",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "53.9923207",
    "lng": "-6.8928934",
    "phone": "429669593",
    "email": "office@shercockns.ie"
  },
  {
    "i": "62",
    "county": "Cavan",
    "rollNumber": "14399N",
    "schoolName": "Killygarry NS",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.66",
    "spSNA": "0",
    "totalSNA": "2.66",
    "eircode": "H12AX85",
    "addressOne": "Killygarry",
    "addressTwo": "Co. Cavan",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.9863188",
    "lng": "-7.3056288",
    "phone": "494362144",
    "email": "info@killygarryns.ie"
  },
  {
    "i": "63",
    "county": "Cavan",
    "rollNumber": "14732U",
    "schoolName": "Scoil Bhride",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "A82WV61",
    "addressOne": "Mountnugent",
    "addressTwo": "Co. Cavan",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.8150395",
    "lng": "-7.2533231",
    "phone": "498540390",
    "email": "mountnugentnationalschool@gmail.com"
  },
  {
    "i": "64",
    "county": "Cavan",
    "rollNumber": "15120R",
    "schoolName": "Killyconnan NS",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H12F622",
    "addressOne": "Stradone",
    "addressTwo": "Co. Cavan",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.9630134",
    "lng": "-7.2578419",
    "phone": "494330540",
    "email": "killyconnanns.ias@eircom.net"
  },
  {
    "i": "65",
    "county": "Cavan",
    "rollNumber": "15452T",
    "schoolName": "Kildallon NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H14Y902",
    "addressOne": "Kildallan",
    "addressTwo": "Ballyconnell",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "54.0656726",
    "lng": "-7.5506157",
    "phone": "499526721",
    "email": "kildallanschool@gmail.com"
  },
  {
    "i": "66",
    "county": "Cavan",
    "rollNumber": "15502I",
    "schoolName": "Killinkere NS",
    "SETHours": "80",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "A82T959",
    "addressOne": "Corratinner",
    "addressTwo": "Virginia",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "53.8861844",
    "lng": "-7.0688276",
    "phone": "498547611",
    "email": "killinkerens@outlook.ie"
  },
  {
    "i": "67",
    "county": "Cavan",
    "rollNumber": "16057S",
    "schoolName": "Convent Of Mercy NS",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "H14A009",
    "addressOne": "Upper Bridge Street",
    "addressTwo": "Belturbet",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "54.1005645",
    "lng": "-7.4464551",
    "phone": "499522992",
    "email": "info@comns.ie"
  },
  {
    "i": "68",
    "county": "Cavan",
    "rollNumber": "16083T",
    "schoolName": "Virginia Mxd NS",
    "SETHours": "152.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "4.33",
    "spSNA": "1",
    "totalSNA": "5.33",
    "eircode": "A82FA09",
    "addressOne": "Virginia",
    "addressTwo": "Co. Cavan",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.8353623",
    "lng": "-7.0756405",
    "phone": "498547035",
    "email": "info@virginians.ie"
  },
  {
    "i": "69",
    "county": "Cavan",
    "rollNumber": "16093W",
    "schoolName": "Ballyconnell Mxd NS",
    "SETHours": "62.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "0.5",
    "spSNA": "4",
    "totalSNA": "4.5",
    "eircode": "H14HK81",
    "addressOne": "Ballyconnell",
    "addressTwo": "Co. Cavan",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.1136246",
    "lng": "-7.5816976",
    "phone": "499526673",
    "email": "office.bcns@gmail.com"
  },
  {
    "i": "70",
    "county": "Cavan",
    "rollNumber": "16316Q",
    "schoolName": "St Marys NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "H12XT66",
    "addressOne": "Drumalt",
    "addressTwo": "Arva",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "53.9215534",
    "lng": "-7.5809138",
    "phone": "494335560",
    "email": "stmarysarva@gmail.com"
  },
  {
    "i": "71",
    "county": "Cavan",
    "rollNumber": "16390F",
    "schoolName": "Scoil Bhride",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H12P738",
    "addressOne": "Killeshandra",
    "addressTwo": "Co. Cavan",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.0067662",
    "lng": "-7.5261543",
    "phone": "494334886",
    "email": "killeshandrans@eircom.net"
  },
  {
    "i": "72",
    "county": "Cavan",
    "rollNumber": "16520P",
    "schoolName": "St Mary's NS",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "H12P598",
    "addressOne": "Drung",
    "addressTwo": "Ballyhaise",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "54.0416536",
    "lng": "-7.2229339",
    "phone": "495553144",
    "email": "stmarysdrung@hotmail.com"
  },
  {
    "i": "73",
    "county": "Cavan",
    "rollNumber": "16767D",
    "schoolName": "Coronea NS",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H12W984",
    "addressOne": "Arva",
    "addressTwo": "Co. Cavan",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.9381909",
    "lng": "-7.5235505",
    "phone": "494335780",
    "email": "coronea.ias@eircom.net"
  },
  {
    "i": "74",
    "county": "Cavan",
    "rollNumber": "16921K",
    "schoolName": "SN Beal Atha Na Neach",
    "SETHours": "75",
    "spClassTeachingPosts": "2",
    "mainSNA": "3",
    "spSNA": "4",
    "totalSNA": "7",
    "eircode": "H12K727",
    "addressOne": "Ballinagh",
    "addressTwo": "Co. Cavan",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.931755",
    "lng": "-7.4134147",
    "phone": "494337546",
    "email": "secretary@stfelimsns.ie"
  },
  {
    "i": "75",
    "county": "Cavan",
    "rollNumber": "16959M",
    "schoolName": "SN Corrabha",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "N41CV06",
    "addressOne": "Curraghvagh",
    "addressTwo": "Glangevlin",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "54.1953161",
    "lng": "-7.9246708",
    "phone": "719643290",
    "email": "curravaghns@gmail.com"
  },
  {
    "i": "76",
    "county": "Cavan",
    "rollNumber": "17230L",
    "schoolName": "Scoil Naomh Brid",
    "SETHours": "55",
    "spClassTeachingPosts": "3",
    "mainSNA": "1",
    "spSNA": "5.49",
    "totalSNA": "6.49",
    "eircode": "H14X017",
    "addressOne": "Killoughter",
    "addressTwo": "Redhills",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "54.0855968",
    "lng": "-7.3144343",
    "phone": "4755222",
    "email": "am@stbrigidsns.ie"
  },
  {
    "i": "77",
    "county": "Cavan",
    "rollNumber": "17240O",
    "schoolName": "SN Tamhnach Dhuibh",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "A82V903",
    "addressOne": "Tunnyduff",
    "addressTwo": "Bailieborough",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "53.9594548",
    "lng": "-7.0591317",
    "phone": "429660368",
    "email": "office@tunnyduffns.ie"
  },
  {
    "i": "78",
    "county": "Cavan",
    "rollNumber": "17326B",
    "schoolName": "Sn Naomh Feidhlim Boys Snr Sch",
    "SETHours": "125",
    "spClassTeachingPosts": "2",
    "mainSNA": "2.34",
    "spSNA": "0.66",
    "totalSNA": "3",
    "eircode": "H12YN73",
    "addressOne": "Farnham Street",
    "addressTwo": "Cavan",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.9909606",
    "lng": "-7.3636147",
    "phone": "494332366",
    "email": "office@stfelimsnscavan.ie"
  },
  {
    "i": "79",
    "county": "Cavan",
    "rollNumber": "17440W",
    "schoolName": "SN Naomh Maodhog",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H14Y861",
    "addressOne": "Currin",
    "addressTwo": "Ballyconnell",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "54.0908626",
    "lng": "-7.6355624",
    "phone": "499526562",
    "email": "currinschool@gmail.com"
  },
  {
    "i": "80",
    "county": "Cavan",
    "rollNumber": "17479D",
    "schoolName": "Scoil Mhuire",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H12E171",
    "addressOne": "Lacken",
    "addressTwo": "Ballinagh",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "53.9167731",
    "lng": "-7.4386365",
    "phone": "494337822",
    "email": "scoilmhuirelacken@gmail.com"
  },
  {
    "i": "81",
    "county": "Cavan",
    "rollNumber": "17531C",
    "schoolName": "Baile Na Mona",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "A82W264",
    "addressOne": "Bailieboro",
    "addressTwo": "Co. Cavan",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.8970085",
    "lng": "-6.9531972",
    "phone": "429665960",
    "email": "office@ballinamoneyns.ie"
  },
  {
    "i": "82",
    "county": "Cavan",
    "rollNumber": "17601U",
    "schoolName": "SN Doire Na Ceise",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "H16KP86",
    "addressOne": "Maudabawn",
    "addressTwo": "Cootehill",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "54.0301488",
    "lng": "-7.0411689",
    "phone": "495552220",
    "email": "info@dernakeshns.ie"
  },
  {
    "i": "83",
    "county": "Cavan",
    "rollNumber": "17625L",
    "schoolName": "Cnoc An Teampaill",
    "SETHours": "57.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "1",
    "spSNA": "6",
    "totalSNA": "7",
    "eircode": "A82PF98",
    "addressOne": "Knocktemple",
    "addressTwo": "Virginia",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "53.8036377",
    "lng": "-7.0883414",
    "phone": "498547081",
    "email": "knocktempleschool@gmail.com"
  },
  {
    "i": "84",
    "county": "Cavan",
    "rollNumber": "17630E",
    "schoolName": "SN Maodhog",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "A82A567",
    "addressOne": "Knockbride East",
    "addressTwo": "Bailieborough",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "53.9877475",
    "lng": "-6.9946269",
    "phone": "429660244",
    "email": "eastknockbridens@yahoo.com"
  },
  {
    "i": "85",
    "county": "Cavan",
    "rollNumber": "17780A",
    "schoolName": "Ballyhaise NS",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "H12F825",
    "addressOne": "Cavan Road",
    "addressTwo": "Ballyhaise",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "54.0449327",
    "lng": "-7.3195504",
    "phone": "494338411",
    "email": "ballyhaisens@gmail.com"
  },
  {
    "i": "86",
    "county": "Cavan",
    "rollNumber": "17990L",
    "schoolName": "SN Drom Cnamh",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "H12FX65",
    "addressOne": "Drumcrave",
    "addressTwo": "Co. Cavan",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.9969833",
    "lng": "-7.3234808",
    "phone": "494361496",
    "email": "drumcravens@yahoo.ie"
  },
  {
    "i": "87",
    "county": "Cavan",
    "rollNumber": "18059J",
    "schoolName": "Bailieboro NS",
    "SETHours": "125",
    "spClassTeachingPosts": "5",
    "mainSNA": "6",
    "spSNA": "7.66",
    "totalSNA": "13.66",
    "eircode": "A82DR53",
    "addressOne": "Tanderagee",
    "addressTwo": "Bailieborough",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "53.9159247",
    "lng": "-6.9748814",
    "phone": "429665242",
    "email": "office@stannesns.ie"
  },
  {
    "i": "88",
    "county": "Cavan",
    "rollNumber": "18127A",
    "schoolName": "Sn Mhuire Boys Sn School",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "H14WA46",
    "addressOne": "Railway Road",
    "addressTwo": "Belturbet",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "54.0981227",
    "lng": "-7.4433774",
    "phone": "499522906",
    "email": "belturbetns.ias@eircom.net"
  },
  {
    "i": "89",
    "county": "Cavan",
    "rollNumber": "18340A",
    "schoolName": "SN Padraig",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H16X981",
    "addressOne": "Lisboduff",
    "addressTwo": "Cootehill",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "54.0726981",
    "lng": "-7.2256977",
    "phone": "495553407",
    "email": "bunnoe.ns@gmail.com"
  },
  {
    "i": "90",
    "county": "Cavan",
    "rollNumber": "18346M",
    "schoolName": "SN Greach Rathain",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H14CH74",
    "addressOne": "Greaghrahan",
    "addressTwo": "Belturbet",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.0980774",
    "lng": "-7.533636",
    "phone": "499526502",
    "email": "greaghrahanns@eircom.net"
  },
  {
    "i": "91",
    "county": "Cavan",
    "rollNumber": "18355N",
    "schoolName": "Aughadreena NS",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "H12D923",
    "addressOne": "Aughadreena",
    "addressTwo": "Stradone",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "53.9347894",
    "lng": "-7.2198842",
    "phone": "494330549",
    "email": "aughadreenans@gmail.com"
  },
  {
    "i": "92",
    "county": "Cavan",
    "rollNumber": "18393V",
    "schoolName": "SN Cillin",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "A82H704",
    "addressOne": "Crossreagh",
    "addressTwo": "Mullagh",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "53.8541815",
    "lng": "-7.0122897",
    "phone": "498547800",
    "email": "crossns4@gmail.com"
  },
  {
    "i": "93",
    "county": "Cavan",
    "rollNumber": "18518P",
    "schoolName": "SN Corr Lorgan",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "H12F786",
    "addressOne": "Corlurgan",
    "addressTwo": "Cavan",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.960476",
    "lng": "-7.3585853",
    "phone": "494361718",
    "email": "corlurganprincipal@outlook.ie"
  },
  {
    "i": "94",
    "county": "Cavan",
    "rollNumber": "18564W",
    "schoolName": "SN Leitir",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "A82CX30",
    "addressOne": "Leiter",
    "addressTwo": "Bailieborough",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "53.9275233",
    "lng": "-7.0114826",
    "phone": "429665605",
    "email": "thevalens@outlook.ie"
  },
  {
    "i": "95",
    "county": "Cavan",
    "rollNumber": "18833A",
    "schoolName": "SN Lathrach",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "H12P924",
    "addressOne": "Laragh",
    "addressTwo": "Stradone",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "53.9931512",
    "lng": "-7.2150598",
    "phone": "494330522",
    "email": "laraghschool@gmail.com"
  },
  {
    "i": "96",
    "county": "Cavan",
    "rollNumber": "18857O",
    "schoolName": "SN Carraig A Bruis",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "A82HX80",
    "addressOne": "Virginia",
    "addressTwo": "Co. Cavan",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.8018869",
    "lng": "-7.0324318",
    "phone": "498548165",
    "email": "carrigabruise@eircom.net"
  },
  {
    "i": "97",
    "county": "Cavan",
    "rollNumber": "19202Q",
    "schoolName": "Drumkilly Ns",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "A82VY00",
    "addressOne": "Kilnaleck",
    "addressTwo": "Co. Cavan",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.8904697",
    "lng": "-7.3431473",
    "phone": "494336517",
    "email": "office@drumkillyns.ie"
  },
  {
    "i": "98",
    "county": "Cavan",
    "rollNumber": "19285A",
    "schoolName": "Kill NS",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H16H580",
    "addressOne": "Cootehill",
    "addressTwo": "Co. Cavan",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.0360885",
    "lng": "-7.1181525",
    "phone": "495553149",
    "email": "killnscootehill@gmail.com"
  },
  {
    "i": "99",
    "county": "Cavan",
    "rollNumber": "19322D",
    "schoolName": "Kilmore Central NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H12EE03",
    "addressOne": "Kilmore",
    "addressTwo": "Co. Cavan",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.9720761",
    "lng": "-7.4206905",
    "phone": "494332661",
    "email": "kilmorecns1@gmail.com"
  },
  {
    "i": "100",
    "county": "Cavan",
    "rollNumber": "19326L",
    "schoolName": "Butlersbridge Ns",
    "SETHours": "82.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.5",
    "spSNA": "0",
    "totalSNA": "3.5",
    "eircode": "H12RR66",
    "addressOne": "Butlersbridge",
    "addressTwo": "Co. Cavan",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.0459842",
    "lng": "-7.3760635",
    "phone": "494361730",
    "email": "bbcns.ias@eircom.net"
  },
  {
    "i": "101",
    "county": "Cavan",
    "rollNumber": "19363R",
    "schoolName": "Mullahoran Central NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "N39KA44",
    "addressOne": "Mullaghoran",
    "addressTwo": "Kilcogy",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "53.8392707",
    "lng": "-7.4342128",
    "phone": "436681100",
    "email": "mullahoranns.ias@eircom.net"
  },
  {
    "i": "102",
    "county": "Cavan",
    "rollNumber": "19378H",
    "schoolName": "Ballynarry NS",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "A82T993",
    "addressOne": "Ballyheelan",
    "addressTwo": "Kilnaleck",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "53.8375188",
    "lng": "-7.3481407",
    "phone": "494336833",
    "email": "ballynarry@gmail.com"
  },
  {
    "i": "103",
    "county": "Cavan",
    "rollNumber": "19418Q",
    "schoolName": "Castlerahan Central Ns",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "A82N673",
    "addressOne": "Castlerahan",
    "addressTwo": "Ballyjamesduff",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "53.8209603",
    "lng": "-7.1798157",
    "phone": "498544201",
    "email": "castlerahanns@gmail.com"
  },
  {
    "i": "104",
    "county": "Cavan",
    "rollNumber": "19432K",
    "schoolName": "Crosskeys Central NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H12Y998",
    "addressOne": "Carrickatober",
    "addressTwo": "Crosskeys",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "53.9196265",
    "lng": "-7.2643844",
    "phone": "494336704",
    "email": "crosskeysns@gmail.com"
  },
  {
    "i": "105",
    "county": "Cavan",
    "rollNumber": "19527V",
    "schoolName": "Cabra Central NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "A82FX44",
    "addressOne": "Cabra",
    "addressTwo": "Kingscourt",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "53.9205208",
    "lng": "-6.8116262",
    "phone": "429667194",
    "email": "cabracentral@eircom.net"
  },
  {
    "i": "106",
    "county": "Cavan",
    "rollNumber": "19568M",
    "schoolName": "St Patricks",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "H12YY15",
    "addressOne": "Bruskey",
    "addressTwo": "Ballinagh",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "53.8857684",
    "lng": "-7.4077132",
    "phone": "494337836",
    "email": "admin@bruskeyns.com"
  },
  {
    "i": "107",
    "county": "Cavan",
    "rollNumber": "19596R",
    "schoolName": "Crosserlough NS",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "A82TK30",
    "addressOne": "Crosserlough",
    "addressTwo": "Co. Cavan",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.8760873",
    "lng": "-7.2879241",
    "phone": "494336128",
    "email": "crosserloughns1@eircom.net"
  },
  {
    "i": "108",
    "county": "Cavan",
    "rollNumber": "19608V",
    "schoolName": "St Killians NS",
    "SETHours": "125",
    "spClassTeachingPosts": "3",
    "mainSNA": "2.5",
    "spSNA": "6.66",
    "totalSNA": "9.16",
    "eircode": "A82EA36",
    "addressOne": "Mullagh",
    "addressTwo": "Co. Cavan",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.8128454",
    "lng": "-6.9549988",
    "phone": "469242222",
    "email": "mullaghns@gmail.com"
  },
  {
    "i": "109",
    "county": "Cavan",
    "rollNumber": "19679V",
    "schoolName": "SN Aodhain Naofa",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H14V128",
    "addressOne": "Bawnboy",
    "addressTwo": "Co. Cavan",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.1185139",
    "lng": "-7.6784249",
    "phone": "499523544",
    "email": "staidansbawnboy@gmail.com"
  },
  {
    "i": "110",
    "county": "Cavan",
    "rollNumber": "19871N",
    "schoolName": "St Patricks NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F91VF61",
    "addressOne": "Loughan",
    "addressTwo": "Blacklion",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "54.2849643",
    "lng": "-7.9157491",
    "phone": "719853332",
    "email": "stpatricksblacklion@gmail.com"
  },
  {
    "i": "111",
    "county": "Cavan",
    "rollNumber": "19921C",
    "schoolName": "Drung No 2 Ns",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "H12YR91",
    "addressOne": "Doohassan",
    "addressTwo": "Drung",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "54.0432702",
    "lng": "-7.2328686",
    "phone": "494338317",
    "email": "drungcent.ias@eircom.net"
  },
  {
    "i": "112",
    "county": "Cavan",
    "rollNumber": "19983B",
    "schoolName": "St Clares Ns",
    "SETHours": "175",
    "spClassTeachingPosts": "1",
    "mainSNA": "1.5",
    "spSNA": "1.66",
    "totalSNA": "3.16",
    "eircode": "A82XN67",
    "addressOne": "Virginia Road",
    "addressTwo": "Ballyjamesduff",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "53.8658964",
    "lng": "-7.199304",
    "phone": "498544908",
    "email": "stclaresbjdns@gmail.com"
  },
  {
    "i": "113",
    "county": "Cavan",
    "rollNumber": "20026G",
    "schoolName": "Gaelscoil Bhreifne",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "H12TD54",
    "addressOne": "Cnoc An Choiligh",
    "addressTwo": "An Cabhán",
    "addressThree": "Co An Chabháin",
    "addressFour": "",
    "lat": "53.9926014",
    "lng": "-7.3555744",
    "phone": "494890049",
    "email": "info@gaelscoilbhreifne.ie"
  },
  {
    "i": "114",
    "county": "Cavan",
    "rollNumber": "20134J",
    "schoolName": "St Michaels N. S.",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "H12H272",
    "addressOne": "Clifferna",
    "addressTwo": "Stradon",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "53.9596417",
    "lng": "-7.1759591",
    "phone": "494330096",
    "email": "clifferna.ias@eircom.net"
  },
  {
    "i": "115",
    "county": "Cavan",
    "rollNumber": "20172R",
    "schoolName": "St Josephs NS",
    "SETHours": "122.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "2",
    "spSNA": "6.66",
    "totalSNA": "8.66",
    "eircode": "A82RD70",
    "addressOne": "Kingscourt",
    "addressTwo": "Co. Cavan",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.9013399",
    "lng": "-6.8050132",
    "phone": "429667528",
    "email": "stjosephg.ias@eircom.net"
  },
  {
    "i": "116",
    "county": "Cavan",
    "rollNumber": "20277I",
    "schoolName": "St Michaels NS",
    "SETHours": "112.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "H16P304",
    "addressOne": "Cootehill",
    "addressTwo": "Co. Cavan",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.0741601",
    "lng": "-7.074585",
    "phone": "495552008",
    "email": "stmichaelssns.ias@gmail.com"
  },
  {
    "i": "117",
    "county": "Clare",
    "rollNumber": "02439G",
    "schoolName": "SN Mhuire",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V94R8Y1",
    "addressOne": "Bauroe",
    "addressTwo": "Feakle",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.9241713",
    "lng": "-8.6492567",
    "phone": "61924116",
    "email": "feaklens@gmail.com"
  },
  {
    "i": "118",
    "county": "Clare",
    "rollNumber": "03898U",
    "schoolName": "Toonagh NS",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "V95DF88",
    "addressOne": "Fountain",
    "addressTwo": "Ennis",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.8902367",
    "lng": "-9.0343871",
    "phone": "656820143",
    "email": "toonaghschool@gmail.com"
  },
  {
    "i": "119",
    "county": "Clare",
    "rollNumber": "03928D",
    "schoolName": "Mullach NS",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.25",
    "spSNA": "0",
    "totalSNA": "1.25",
    "eircode": "V95HN22",
    "addressOne": "Mullagh",
    "addressTwo": "Ennis",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.7996645",
    "lng": "-9.4192938",
    "phone": "657087472",
    "email": "principal@mullaghschool.ie"
  },
  {
    "i": "120",
    "county": "Clare",
    "rollNumber": "04548V",
    "schoolName": "Scoil Seanain Naofa",
    "SETHours": "155",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.5",
    "spSNA": "0",
    "totalSNA": "3.5",
    "eircode": "V94FP92",
    "addressOne": "Clonlara",
    "addressTwo": "Co. Clare",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.7241076",
    "lng": "-8.5548517",
    "phone": "61354299",
    "email": "office@clonlarans.ie"
  },
  {
    "i": "121",
    "county": "Clare",
    "rollNumber": "04919H",
    "schoolName": "Cratloe NS",
    "SETHours": "105",
    "spClassTeachingPosts": "2",
    "mainSNA": "0.5",
    "spSNA": "4",
    "totalSNA": "4.5",
    "eircode": "V95V596",
    "addressOne": "Cratloe",
    "addressTwo": "Co. Clare",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6993005",
    "lng": "-8.7554634",
    "phone": "61357111",
    "email": "cratloenationalschool@gmail.com"
  },
  {
    "i": "122",
    "county": "Clare",
    "rollNumber": "05253H",
    "schoolName": "O Callaghans Mills NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "V94A5D1",
    "addressOne": "Iragh",
    "addressTwo": "O'callaghan's Mills",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.8404449",
    "lng": "-8.6721829",
    "phone": "656835730",
    "email": "ocallaghansmillsns@gmail.com"
  },
  {
    "i": "123",
    "county": "Clare",
    "rollNumber": "07315N",
    "schoolName": "Holy Family Snr",
    "SETHours": "255",
    "spClassTeachingPosts": "2",
    "mainSNA": "6",
    "spSNA": "2.5",
    "totalSNA": "8.5",
    "eircode": "V95TF67",
    "addressOne": "Station Road",
    "addressTwo": "Ennis",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.841871",
    "lng": "-8.9813144",
    "phone": "656828893",
    "email": "lucy.finn@hfss.ie"
  },
  {
    "i": "124",
    "county": "Clare",
    "rollNumber": "09390O",
    "schoolName": "Rockmount Mixed NS",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "V95NW93",
    "addressOne": "Rockmount",
    "addressTwo": "Miltown Malbay",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.8687254",
    "lng": "-9.3472806",
    "phone": "657084599",
    "email": "rockmountnationalschool@gmail.com"
  },
  {
    "i": "125",
    "county": "Clare",
    "rollNumber": "09425H",
    "schoolName": "Rineen NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "V95KV24",
    "addressOne": "Rineen",
    "addressTwo": "Miltown Malbay",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.8908117",
    "lng": "-9.3889783",
    "phone": "657084534",
    "email": "rineenschool@gmail.com"
  },
  {
    "i": "126",
    "county": "Clare",
    "rollNumber": "10763L",
    "schoolName": "Boston NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H91XV70",
    "addressOne": "Boston",
    "addressTwo": "Tubber",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "53.0314984",
    "lng": "-8.9327407",
    "phone": "91633211",
    "email": "bostonns@gmail.com"
  },
  {
    "i": "127",
    "county": "Clare",
    "rollNumber": "10886E",
    "schoolName": "Tubber NS",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H91P2V5",
    "addressOne": "Tubber",
    "addressTwo": "Co. Clare",
    "addressThree": "Via Galway",
    "addressFour": "",
    "lat": "52.9901702",
    "lng": "-8.8940996",
    "phone": "91633230",
    "email": "TubberNationalSchool@gmail.com"
  },
  {
    "i": "129",
    "county": "Clare",
    "rollNumber": "11714D",
    "schoolName": "Bansha NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "V15HK30",
    "addressOne": "Bansha",
    "addressTwo": "Kilkee",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.697585",
    "lng": "-9.5899178",
    "phone": "852384968",
    "email": "banshans@banshaschool.com"
  },
  {
    "i": "130",
    "county": "Clare",
    "rollNumber": "11765U",
    "schoolName": "Doonbeg NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.25",
    "spSNA": "0",
    "totalSNA": "1.25",
    "eircode": "V15HW73",
    "addressOne": "Killard Road",
    "addressTwo": "Doonbeg",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.7314324",
    "lng": "-9.528819",
    "phone": "659055311",
    "email": "doonbeg.ns.clare@gmail.com"
  },
  {
    "i": "131",
    "county": "Clare",
    "rollNumber": "11990E",
    "schoolName": "Bodyke NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "V94N5K0",
    "addressOne": "Coolreagh",
    "addressTwo": "Bodyke",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.8827725",
    "lng": "-8.5968742",
    "phone": "61921285",
    "email": "bodykens@gmail.com"
  },
  {
    "i": "132",
    "county": "Clare",
    "rollNumber": "12633I",
    "schoolName": "Coolmeen NS",
    "SETHours": "5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "V15KR50",
    "addressOne": "Coolmeen",
    "addressTwo": "Kilmurray Mcmahon",
    "addressThree": "Kilrush",
    "addressFour": "Co. Clare",
    "lat": "52.6599457",
    "lng": "-9.212848",
    "phone": "656832320",
    "email": "coolmeenns.ias@eircom.net"
  },
  {
    "i": "133",
    "county": "Clare",
    "rollNumber": "12848G",
    "schoolName": "Doonaha NS",
    "SETHours": "7.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "V15FV08",
    "addressOne": "Doonaha West",
    "addressTwo": "Kilkee",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.6231638",
    "lng": "-9.6478359",
    "phone": "659057084",
    "email": "dunatha@gmail.com"
  },
  {
    "i": "134",
    "county": "Clare",
    "rollNumber": "13379C",
    "schoolName": "SN Padraig Nfa Fanoir",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "H91P6F7",
    "addressOne": "Fanore",
    "addressTwo": "Ballyvaughan",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "53.1169699",
    "lng": "-9.2840013",
    "phone": "657076197",
    "email": "fans2@eircom.net"
  },
  {
    "i": "135",
    "county": "Clare",
    "rollNumber": "13418J",
    "schoolName": "Ballyea Mixed NS",
    "SETHours": "60",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V95Y025",
    "addressOne": "Ballyea",
    "addressTwo": "Darragh",
    "addressThree": "Ennis",
    "addressFour": "Co. Clare",
    "lat": "52.7837324",
    "lng": "-9.0295908",
    "phone": "656838144",
    "email": "ballyeans.ias@eircom.net"
  },
  {
    "i": "136",
    "county": "Clare",
    "rollNumber": "13625O",
    "schoolName": "Kilnamona NS",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V95XY88",
    "addressOne": "Kilnamona",
    "addressTwo": "Ennis",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.867855",
    "lng": "-9.0785584",
    "phone": "656822986",
    "email": "kilnamona.ias@eircom.net"
  },
  {
    "i": "137",
    "county": "Clare",
    "rollNumber": "13730L",
    "schoolName": "Clohanes NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V95X326",
    "addressOne": "Mullagh",
    "addressTwo": "Ennis",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.76806",
    "lng": "-9.4760041",
    "phone": "657087533",
    "email": "clohanesns.ias@eircom.net"
  },
  {
    "i": "138",
    "county": "Clare",
    "rollNumber": "13738E",
    "schoolName": "Burrane NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "V15EW83",
    "addressOne": "Burrane Upper",
    "addressTwo": "Killimer",
    "addressThree": "Kilrush",
    "addressFour": "Co. Clare",
    "lat": "52.6257475",
    "lng": "-9.3584822",
    "phone": "659053144",
    "email": "burranens.ias@eircom.net"
  },
  {
    "i": "139",
    "county": "Clare",
    "rollNumber": "13804O",
    "schoolName": "SN Na Crannaighe",
    "SETHours": "7.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "V15EK02",
    "addressOne": "Carrowreagh East",
    "addressTwo": "Cranny",
    "addressThree": "Kilrush",
    "addressFour": "Co. Clare",
    "lat": "52.6932506",
    "lng": "-9.2243307",
    "phone": "656832345",
    "email": "crannyns@gmail.com"
  },
  {
    "i": "140",
    "county": "Clare",
    "rollNumber": "13826B",
    "schoolName": "Kilmihil NS",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.75",
    "spSNA": "0",
    "totalSNA": "1.75",
    "eircode": "V15VE04",
    "addressOne": "Kilmihil",
    "addressTwo": "Co. Clare",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.7227428",
    "lng": "-9.3191248",
    "phone": "659050366",
    "email": "principal@kilmihilns.ie"
  },
  {
    "i": "141",
    "county": "Clare",
    "rollNumber": "13870E",
    "schoolName": "Kilkishen NS",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "V95EK54",
    "addressOne": "Kilkishen",
    "addressTwo": "Ennis",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.804917",
    "lng": "-8.7426471",
    "phone": "61367289",
    "email": "kilkishennationalschool@gmail.com"
  },
  {
    "i": "142",
    "county": "Clare",
    "rollNumber": "13876Q",
    "schoolName": "Moveen NS",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "V15NF43",
    "addressOne": "Kilkee",
    "addressTwo": "Co. Clare",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6434192",
    "lng": "-9.684215",
    "phone": "659056248",
    "email": "info@moveenns.ie"
  },
  {
    "i": "143",
    "county": "Clare",
    "rollNumber": "13942D",
    "schoolName": "SN Cill Muire",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "V95NX71",
    "addressOne": "Kilmurry",
    "addressTwo": "Sixmilebridge",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.7783624",
    "lng": "-8.7828853",
    "phone": "61367623",
    "email": "principal@kilmurry-ns.ie"
  },
  {
    "i": "144",
    "county": "Clare",
    "rollNumber": "14468G",
    "schoolName": "Kilmaley NS",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.33",
    "spSNA": "0",
    "totalSNA": "3.33",
    "eircode": "V95CF30",
    "addressOne": "Kilmaley",
    "addressTwo": "Ennis",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.8203258",
    "lng": "-9.1099744",
    "phone": "656839360",
    "email": "kns@kilmaleyns.ie"
  },
  {
    "i": "145",
    "county": "Clare",
    "rollNumber": "14571W",
    "schoolName": "Tomgraney NS",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "V94R9F8",
    "addressOne": "Tuamgraney",
    "addressTwo": "Co. Clare",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.8978666",
    "lng": "-8.5412159",
    "phone": "61921550",
    "email": "tuamgraneyns@eircom.net"
  },
  {
    "i": "146",
    "county": "Clare",
    "rollNumber": "14622N",
    "schoolName": "Eidhneach NS",
    "SETHours": "55",
    "spClassTeachingPosts": "2",
    "mainSNA": "1.5",
    "spSNA": "5",
    "totalSNA": "6.5",
    "eircode": "V95C2C9",
    "addressOne": "Carrowkeel",
    "addressTwo": "Inagh",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.8775301",
    "lng": "-9.1776606",
    "phone": "656836778",
    "email": "inaghns@eircom.net"
  },
  {
    "i": "147",
    "county": "Clare",
    "rollNumber": "14830U",
    "schoolName": "Barefield Mixed NS",
    "SETHours": "152.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "7",
    "spSNA": "1.66",
    "totalSNA": "8.66",
    "eircode": "V95FD28",
    "addressOne": "Barefield",
    "addressTwo": "Ennis",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.8906088",
    "lng": "-8.9438886",
    "phone": "656820303",
    "email": "john.burns@barefieldns.com"
  },
  {
    "i": "148",
    "county": "Clare",
    "rollNumber": "15042A",
    "schoolName": "Ennis NS",
    "SETHours": "323",
    "spClassTeachingPosts": "3",
    "mainSNA": "5.66",
    "spSNA": "4",
    "totalSNA": "9.66",
    "eircode": "V95DE44",
    "addressOne": "Ashline",
    "addressTwo": "Kilrush Road",
    "addressThree": "Ennis",
    "addressFour": "Co. Clare",
    "lat": "52.8307648",
    "lng": "-9.0035534",
    "phone": "656829158",
    "email": "info@ennisns.ie"
  },
  {
    "i": "149",
    "county": "Clare",
    "rollNumber": "15221A",
    "schoolName": "Annagh NS",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "V95NP38",
    "addressOne": "Annagh",
    "addressTwo": "Miltown Malbay",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.8220525",
    "lng": "-9.41445",
    "phone": "657084850",
    "email": "annaghns@gmail.com"
  },
  {
    "i": "150",
    "county": "Clare",
    "rollNumber": "15279I",
    "schoolName": "Clooney NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.58",
    "spSNA": "0",
    "totalSNA": "1.58",
    "eircode": "V95WC56",
    "addressOne": "Carrahan",
    "addressTwo": "Tulla",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.871172",
    "lng": "-8.8615097",
    "phone": "656835806",
    "email": "clooneyns@gmail.com"
  },
  {
    "i": "151",
    "county": "Clare",
    "rollNumber": "15301V",
    "schoolName": "Kildysart NS",
    "SETHours": "60",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V95DK19",
    "addressOne": "Ennis Road",
    "addressTwo": "Kildysart",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.6779505",
    "lng": "-9.1029904",
    "phone": "656832477",
    "email": "Kildysartns.ias@eircom.net"
  },
  {
    "i": "152",
    "county": "Clare",
    "rollNumber": "15350L",
    "schoolName": "Stonehall NS",
    "SETHours": "47.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "3.25",
    "spSNA": "1.66",
    "totalSNA": "4.91",
    "eircode": "V95EY06",
    "addressOne": "Stonehall",
    "addressTwo": "Newmarket-on-fergus",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.7252016",
    "lng": "-8.910086",
    "phone": "61362863",
    "email": "stonehallschool@gmail.com"
  },
  {
    "i": "153",
    "county": "Clare",
    "rollNumber": "15370R",
    "schoolName": "Killaloe Boys NS",
    "SETHours": "85",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.75",
    "spSNA": "0",
    "totalSNA": "1.75",
    "eircode": "V94D590",
    "addressOne": "Convent Hill",
    "addressTwo": "Killaloe",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.8042803",
    "lng": "-8.4447302",
    "phone": "61376407",
    "email": "killaloebns@live.ie"
  },
  {
    "i": "154",
    "county": "Clare",
    "rollNumber": "15408Q",
    "schoolName": "Connolly NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "V95Y066",
    "addressOne": "Connolly",
    "addressTwo": "Ennis",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.8304508",
    "lng": "-9.1808284",
    "phone": "656839550",
    "email": "connollynationalschool@gmail.com"
  },
  {
    "i": "155",
    "county": "Clare",
    "rollNumber": "15981A",
    "schoolName": "Lakyle NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "V94HH27",
    "addressOne": "Lakyle",
    "addressTwo": "Whitegate",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.9532314",
    "lng": "-8.3621322",
    "phone": "61927288",
    "email": "lakylens@yahoo.com"
  },
  {
    "i": "156",
    "county": "Clare",
    "rollNumber": "16186G",
    "schoolName": "Inch NS",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "V95TC60",
    "addressOne": "Ennis",
    "addressTwo": "Co Clare",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.822702",
    "lng": "-9.0585241",
    "phone": "656839353",
    "email": "inchns.ias@gmail.com"
  },
  {
    "i": "157",
    "county": "Clare",
    "rollNumber": "16677C",
    "schoolName": "Bunscoil Na Mbraithre",
    "SETHours": "237.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "5.17",
    "spSNA": "0.33",
    "totalSNA": "5.5",
    "eircode": "V95NX02",
    "addressOne": "New Road",
    "addressTwo": "Ennis",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.8483435",
    "lng": "-8.9775077",
    "phone": "656822150",
    "email": "priomhoide@gmail.com"
  },
  {
    "i": "158",
    "county": "Clare",
    "rollNumber": "16908S",
    "schoolName": "Sixmilebridge NS",
    "SETHours": "262.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "3",
    "spSNA": "4",
    "totalSNA": "7",
    "eircode": "V95TKV0",
    "addressOne": "School Road",
    "addressTwo": "Sixmilebridge",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.7438995",
    "lng": "-8.780035",
    "phone": "61369544",
    "email": "info@sixmilebridgens.ie"
  },
  {
    "i": "159",
    "county": "Clare",
    "rollNumber": "16930L",
    "schoolName": "Scoil An Sraith SN",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "V15PY88",
    "addressOne": "Shragh",
    "addressTwo": "Doonbeg",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.7038089",
    "lng": "-9.4939037",
    "phone": "659055295",
    "email": "office@shraghns.ie"
  },
  {
    "i": "160",
    "county": "Clare",
    "rollNumber": "16946D",
    "schoolName": "Sn An Phairtin Mixed",
    "SETHours": "170",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.25",
    "spSNA": "0",
    "totalSNA": "4.25",
    "eircode": "V94EY64",
    "addressOne": "Parteen",
    "addressTwo": "Co. Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6951413",
    "lng": "-8.6149724",
    "phone": "61340457",
    "email": "parteenoffice@gmail.com"
  },
  {
    "i": "161",
    "county": "Clare",
    "rollNumber": "17020A",
    "schoolName": "Quilty Ns",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.25",
    "spSNA": "0",
    "totalSNA": "1.25",
    "eircode": "V95K091",
    "addressOne": "Quilty",
    "addressTwo": "Ennis",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.8105521",
    "lng": "-9.4546928",
    "phone": "657087250",
    "email": "quilty.ias@eircom.net"
  },
  {
    "i": "162",
    "county": "Clare",
    "rollNumber": "17026M",
    "schoolName": "Clarecastle NS",
    "SETHours": "127.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.66",
    "spSNA": "0",
    "totalSNA": "3.66",
    "eircode": "V95T253",
    "addressOne": "Ennis Road",
    "addressTwo": "Clarecastle",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.8170451",
    "lng": "-8.9704356",
    "phone": "656828274",
    "email": "school.secretary@clarecastlens.com"
  },
  {
    "i": "163",
    "county": "Clare",
    "rollNumber": "17246D",
    "schoolName": "SN Cluain An Atha",
    "SETHours": "7.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "V95HN76",
    "addressOne": "Eidhneach",
    "addressTwo": "Inis",
    "addressThree": "Co Clare",
    "addressFour": "",
    "lat": "52.8676793",
    "lng": "-9.273437",
    "phone": "656836916",
    "email": "scoilcluain.ias@eircom.net"
  },
  {
    "i": "164",
    "county": "Clare",
    "rollNumber": "17270A",
    "schoolName": "SN Colm Cille",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "V95YD43",
    "addressOne": "Scoil Cholmcille",
    "addressTwo": "Clouna NS",
    "addressThree": "Ennistymon",
    "addressFour": "",
    "lat": "52.932219",
    "lng": "-9.2293047",
    "phone": "657071949",
    "email": "clounans@gmail.com"
  },
  {
    "i": "165",
    "county": "Clare",
    "rollNumber": "17517I",
    "schoolName": "Doolin Mixed NS",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "V95TC66",
    "addressOne": "Ennis",
    "addressTwo": "Co. Clare",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.0131242",
    "lng": "-9.371841",
    "phone": "657074403",
    "email": "doolinns.ias@eircom.net"
  },
  {
    "i": "166",
    "county": "Clare",
    "rollNumber": "17563P",
    "schoolName": "Ogonnelloe NS",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V94N599",
    "addressOne": "Ogonnelloe",
    "addressTwo": "Scariff",
    "addressThree": "Co Clare",
    "addressFour": "",
    "lat": "52.8722206",
    "lng": "-8.4583762",
    "phone": "61923144",
    "email": "office@ogonnelloens.com"
  },
  {
    "i": "167",
    "county": "Clare",
    "rollNumber": "17583V",
    "schoolName": "SN Cnoc An Ein",
    "SETHours": "112.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "V95FW42",
    "addressOne": "Knockanean",
    "addressTwo": "Ennis",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.8546151",
    "lng": "-8.9287169",
    "phone": "656840088",
    "email": "cnocanein@gmail.com"
  },
  {
    "i": "168",
    "county": "Clare",
    "rollNumber": "17633K",
    "schoolName": "SN Eoin Baiste",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H91F6P2",
    "addressOne": "Ballyvaughan",
    "addressTwo": "Via Galway",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "53.1142042",
    "lng": "-9.1542311",
    "phone": "657077079",
    "email": "info@ballyvaughanns.com"
  },
  {
    "i": "169",
    "county": "Clare",
    "rollNumber": "17816S",
    "schoolName": "Cooraclare BNS",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.75",
    "spSNA": "0",
    "totalSNA": "1.75",
    "eircode": "V15D728",
    "addressOne": "Cooraclare",
    "addressTwo": "Kilrush",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.7054463",
    "lng": "-9.4214235",
    "phone": "659059169",
    "email": "cooraclarens@gmail.com"
  },
  {
    "i": "170",
    "county": "Clare",
    "rollNumber": "17832Q",
    "schoolName": "Kilnaboy NS",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "V95HX58",
    "addressOne": "Kilnaboy,",
    "addressTwo": "Ennis,",
    "addressThree": "County Clare",
    "addressFour": "",
    "lat": "52.9721603",
    "lng": "-9.0794016",
    "phone": "656837702",
    "email": "kilnaboyns@gmail.com"
  },
  {
    "i": "171",
    "county": "Clare",
    "rollNumber": "17847G",
    "schoolName": "SN Aibhistin Naofa",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "V95XF75",
    "addressOne": "Fanaleen",
    "addressTwo": "Kilshanny",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.9834975",
    "lng": "-9.3011128",
    "phone": "657071344",
    "email": "kilshannyns.ias@eircom.net"
  },
  {
    "i": "172",
    "county": "Clare",
    "rollNumber": "17957N",
    "schoolName": "Holy Family Jn School",
    "SETHours": "135",
    "spClassTeachingPosts": "3",
    "mainSNA": "3.66",
    "spSNA": "4",
    "totalSNA": "7.66",
    "eircode": "V95YR79",
    "addressOne": "Station Road",
    "addressTwo": "Ennis",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.8425077",
    "lng": "-8.9811387",
    "phone": "656829808",
    "email": "info.hfj@gmail.com"
  },
  {
    "i": "173",
    "county": "Clare",
    "rollNumber": "18032M",
    "schoolName": "SN Cluain Muinge",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "V95AH94",
    "addressOne": "Clonmoney",
    "addressTwo": "Newmarket-on-fergus",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.7165497",
    "lng": "-8.8363286",
    "phone": "61362672",
    "email": "clonmoneyns2@gmail.com"
  },
  {
    "i": "174",
    "county": "Clare",
    "rollNumber": "18109V",
    "schoolName": "SN Inis Cealtrach",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V94YP68",
    "addressOne": "Mountshannon",
    "addressTwo": "Co. Clare",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.9328223",
    "lng": "-8.441591",
    "phone": "61927299",
    "email": "mountshannonns@gmail.com"
  },
  {
    "i": "176",
    "county": "Clare",
    "rollNumber": "18190H",
    "schoolName": "SN Cronain Nfa An Carn",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "V95YA22",
    "addressOne": "Carron",
    "addressTwo": "Ennis",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "53.0377995",
    "lng": "-9.0751662",
    "phone": "657089201",
    "email": "carronschool@gmail.com"
  },
  {
    "i": "177",
    "county": "Clare",
    "rollNumber": "18225A",
    "schoolName": "SN Mhuire Miliuc",
    "SETHours": "65",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.75",
    "spSNA": "0",
    "totalSNA": "1.75",
    "eircode": "V94E0C0",
    "addressOne": "Luimneach",
    "addressTwo": "Co Luimni",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6969217",
    "lng": "-8.6739748",
    "phone": "61327088",
    "email": "meelickprimsch.ias@eircom.net"
  },
  {
    "i": "178",
    "county": "Clare",
    "rollNumber": "18227E",
    "schoolName": "Scoil Mhuire Naisiunta",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.75",
    "spSNA": "0",
    "totalSNA": "1.75",
    "eircode": "V95YP02",
    "addressOne": "Newtown",
    "addressTwo": "Corofin",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.945187",
    "lng": "-9.0587004",
    "phone": "656837302",
    "email": "corofinnsclare@gmail.com"
  },
  {
    "i": "179",
    "county": "Clare",
    "rollNumber": "18327I",
    "schoolName": "SN Cnoc Doire",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "V15AR27",
    "addressOne": "Knockerra",
    "addressTwo": "Kilrush",
    "addressThree": "Co Clare",
    "addressFour": "",
    "lat": "52.6551011",
    "lng": "-9.3962604",
    "phone": "659052379",
    "email": "knockerraschool.ias@gmail.com"
  },
  {
    "i": "180",
    "county": "Clare",
    "rollNumber": "18339P",
    "schoolName": "Sn Iosef Naofa",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "V95NW99",
    "addressOne": "Maigh Mór",
    "addressTwo": "An Leacht",
    "addressThree": "Co. An Chláir",
    "addressFour": "",
    "lat": "52.9014376",
    "lng": "-9.3319596",
    "phone": "657081553",
    "email": "scoiliosef@gmail.com"
  },
  {
    "i": "181",
    "county": "Clare",
    "rollNumber": "18359V",
    "schoolName": "SN Cuan",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "V15AY68",
    "addressOne": "Kilbaha",
    "addressTwo": "Kilrush",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.5761862",
    "lng": "-9.865817",
    "phone": "659058212",
    "email": "kilbahaschool@gmail.com"
  },
  {
    "i": "182",
    "county": "Clare",
    "rollNumber": "18410S",
    "schoolName": "SN Liosceanuir",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.25",
    "spSNA": "0",
    "totalSNA": "1.25",
    "eircode": "V95WV32",
    "addressOne": "Liscannor",
    "addressTwo": "Co. Clare",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.9356996",
    "lng": "-9.3951327",
    "phone": "657081838",
    "email": "liscannorprimaryschool@gmail.com"
  },
  {
    "i": "183",
    "county": "Clare",
    "rollNumber": "18467B",
    "schoolName": "SN Baile An Droichid",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "V94CD83",
    "addressOne": "Bridgetown",
    "addressTwo": "O'brien's Bridge",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.7615233",
    "lng": "-8.5246343",
    "phone": "61377836",
    "email": "secretary@bridgetownns.ie"
  },
  {
    "i": "184",
    "county": "Clare",
    "rollNumber": "18526O",
    "schoolName": "Ballycar NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "0.75",
    "spSNA": "1.83",
    "totalSNA": "2.58",
    "eircode": "V95VR74",
    "addressOne": "Ballycar",
    "addressTwo": "Newmarket-on-fergus",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.7682854",
    "lng": "-8.8531686",
    "phone": "61368852",
    "email": "ballycarns@gmail.com"
  },
  {
    "i": "185",
    "county": "Clare",
    "rollNumber": "18540I",
    "schoolName": "Cluain Draigneach",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "V95DK15",
    "addressOne": "Cluain Draighneach",
    "addressTwo": "Lios Ui Chatasaigh",
    "addressThree": "Inis",
    "addressFour": "Co An Chlair",
    "lat": "52.7331203",
    "lng": "-9.1189019",
    "phone": "656834164",
    "email": "clondrinagh.ns@outlook.com"
  },
  {
    "i": "186",
    "county": "Clare",
    "rollNumber": "18541K",
    "schoolName": "SN Chathair Aodha",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V95AY67",
    "addressOne": "Caherea",
    "addressTwo": "Lissycasey",
    "addressThree": "Ennis",
    "addressFour": "Co. Clare",
    "lat": "52.7666813",
    "lng": "-9.100979",
    "phone": "656834029",
    "email": "principal.cahereans@gmail.com"
  },
  {
    "i": "187",
    "county": "Clare",
    "rollNumber": "18555V",
    "schoolName": "Lissycasey NS",
    "SETHours": "52.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "1.5",
    "spSNA": "3.33",
    "totalSNA": "4.83",
    "eircode": "V95DH58",
    "addressOne": "Lissycasey",
    "addressTwo": "Ennis",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.7383304",
    "lng": "-9.1770115",
    "phone": "656834454",
    "email": "office@lissycaseyns.ie"
  },
  {
    "i": "188",
    "county": "Clare",
    "rollNumber": "18565B",
    "schoolName": "SN Ma Sheasta",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "V15W635",
    "addressOne": "Moyasta",
    "addressTwo": "Co Clare",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6703963",
    "lng": "-9.5395302",
    "phone": "659051551",
    "email": "moyastans.ias@eircom.net"
  },
  {
    "i": "189",
    "county": "Clare",
    "rollNumber": "18624O",
    "schoolName": "Mercy Convent Killaloe",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "V94D328",
    "addressOne": "Killaloe",
    "addressTwo": "Co Clare",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.806104",
    "lng": "-8.4411336",
    "phone": "61376861",
    "email": "info@cpskillaloe.ie"
  },
  {
    "i": "190",
    "county": "Clare",
    "rollNumber": "18630J",
    "schoolName": "Carrigaholt Mixed NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V15A271",
    "addressOne": "Carrigaholt",
    "addressTwo": "Kilrush",
    "addressThree": "Co Clare",
    "addressFour": "",
    "lat": "52.6027333",
    "lng": "-9.7087644",
    "phone": "659058270",
    "email": "carriga.ias@eircom.net"
  },
  {
    "i": "191",
    "county": "Clare",
    "rollNumber": "18639E",
    "schoolName": "SN Baile Na Cailli",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "V95DE48",
    "addressOne": "Ballynacally",
    "addressTwo": "Ennis",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.7189284",
    "lng": "-9.0652823",
    "phone": "656832533",
    "email": "ballynacallynationalschool@gmail.com"
  },
  {
    "i": "192",
    "county": "Clare",
    "rollNumber": "18696Q",
    "schoolName": "SN Dubh Rath",
    "SETHours": "35",
    "spClassTeachingPosts": "1",
    "mainSNA": "1",
    "spSNA": "1",
    "totalSNA": "2",
    "eircode": "V95YW31",
    "addressOne": "Ballyvonnavaun",
    "addressTwo": "Clarecastle",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.8197831",
    "lng": "-8.9131783",
    "phone": "656829636",
    "email": "doorans1@gmail.com"
  },
  {
    "i": "193",
    "county": "Clare",
    "rollNumber": "18720K",
    "schoolName": "Miltown Malbay BNS",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V95EY86",
    "addressOne": "Mullagh Road",
    "addressTwo": "Miltown Malbay",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.8531238",
    "lng": "-9.4026544",
    "phone": "657084414",
    "email": "malbay.ias@eircom.net"
  },
  {
    "i": "194",
    "county": "Clare",
    "rollNumber": "18739I",
    "schoolName": "Shannon Airport 1 NS",
    "SETHours": "85",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "V14N795",
    "addressOne": "Corrib Drive",
    "addressTwo": "Shannon",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.6993571",
    "lng": "-8.8903209",
    "phone": "61472005",
    "email": "stsenans.ias@eircom.net"
  },
  {
    "i": "195",
    "county": "Clare",
    "rollNumber": "18740Q",
    "schoolName": "Shannon Airport No 2 Ns",
    "SETHours": "32.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "1.5",
    "spSNA": "1.83",
    "totalSNA": "3.33",
    "eircode": "V14Y970",
    "addressOne": "Shannon Airport No 2",
    "addressTwo": "Drumggely Ave",
    "addressThree": "Shannon",
    "addressFour": "",
    "lat": "52.7000969",
    "lng": "-8.894967",
    "phone": "61471485",
    "email": "principal@stjohnsnationalschool.ie"
  },
  {
    "i": "196",
    "county": "Clare",
    "rollNumber": "18753C",
    "schoolName": "Saint Marys NS Lahinch",
    "SETHours": "80.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V95FD70",
    "addressOne": "Lahinch",
    "addressTwo": "Co. Clare",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.9291353",
    "lng": "-9.3448329",
    "phone": "657081844",
    "email": "lahinchschool2016@gmail.com"
  },
  {
    "i": "197",
    "county": "Clare",
    "rollNumber": "18768P",
    "schoolName": "Forgleann NS",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "V95CC42",
    "addressOne": "Furraglaun",
    "addressTwo": "Lahinch",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.9080385",
    "lng": "-9.2745811",
    "phone": "657071979",
    "email": "furglanns.ias@eircom.net"
  },
  {
    "i": "198",
    "county": "Clare",
    "rollNumber": "18950E",
    "schoolName": "Dromindoora NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "V94XP71",
    "addressOne": "Dromindoora",
    "addressTwo": "Caher",
    "addressThree": "Feakle",
    "addressFour": "",
    "lat": "52.9974243",
    "lng": "-8.7212797",
    "phone": "861713061",
    "email": "dromindoora.ias@eircom.net"
  },
  {
    "i": "199",
    "county": "Clare",
    "rollNumber": "19043W",
    "schoolName": "New Quay Ns",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H91HY40",
    "addressOne": "New Quay",
    "addressTwo": "Burrin",
    "addressThree": "County Clare",
    "addressFour": "H91 Hy40",
    "lat": "53.145745",
    "lng": "-9.0788634",
    "phone": "657078188",
    "email": "scoilnaboirne@gmail.com"
  },
  {
    "i": "200",
    "county": "Clare",
    "rollNumber": "19274S",
    "schoolName": "St Conaires Ns",
    "SETHours": "187.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "V14X272",
    "addressOne": "Tullyvarraga",
    "addressTwo": "Shannon",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.706164",
    "lng": "-8.8705604",
    "phone": "61364694",
    "email": "conaires@gmail.com"
  },
  {
    "i": "201",
    "county": "Clare",
    "rollNumber": "19338S",
    "schoolName": "Flagmount Central Ns",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "V94YW70",
    "addressOne": "Flagmount",
    "addressTwo": "Caher",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.9862226",
    "lng": "-8.6455985",
    "phone": "61925177",
    "email": "flagmountns2019@gmail.com"
  },
  {
    "i": "202",
    "county": "Clare",
    "rollNumber": "19366A",
    "schoolName": "Scariff Central NS",
    "SETHours": "60",
    "spClassTeachingPosts": "1",
    "mainSNA": "0",
    "spSNA": "2",
    "totalSNA": "2",
    "eircode": "V94A9W3",
    "addressOne": "Scariff",
    "addressTwo": "Co. Clare",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.9160098",
    "lng": "-8.531734",
    "phone": "61921481",
    "email": "scariffnationalschool@gmail.com"
  },
  {
    "i": "203",
    "county": "Clare",
    "rollNumber": "19386G",
    "schoolName": "Labasheeda Central NS",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "V15XF84",
    "addressOne": "Labasheeda",
    "addressTwo": "Kilrush",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.6218815",
    "lng": "-9.2528563",
    "phone": "656826063",
    "email": "labasheedans1@gmail.com"
  },
  {
    "i": "204",
    "county": "Clare",
    "rollNumber": "19442N",
    "schoolName": "Ruan Central Ns",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "V95R206",
    "addressOne": "Dromore",
    "addressTwo": "Ruan",
    "addressThree": "Ennis",
    "addressFour": "Co. Clare",
    "lat": "52.9337259",
    "lng": "-8.988681",
    "phone": "656837301",
    "email": "ruanschool@gmail.com"
  },
  {
    "i": "205",
    "county": "Clare",
    "rollNumber": "19551S",
    "schoolName": "Inchicronan Central Ns",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "V95KX43",
    "addressOne": "Clonmooney",
    "addressTwo": "Crusheen",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.9360327",
    "lng": "-8.8939351",
    "phone": "656827183",
    "email": "crusheen@eircom.net"
  },
  {
    "i": "206",
    "county": "Clare",
    "rollNumber": "19552U",
    "schoolName": "Naomh Tola",
    "SETHours": "112.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.75",
    "spSNA": "0",
    "totalSNA": "1.75",
    "eircode": "V14Y625",
    "addressOne": "Tullyglass",
    "addressTwo": "Shannon",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.7037784",
    "lng": "-8.8860634",
    "phone": "61362894",
    "email": "office@tolasns.com"
  },
  {
    "i": "207",
    "county": "Clare",
    "rollNumber": "19559L",
    "schoolName": "Chriost Ri",
    "SETHours": "160",
    "spClassTeachingPosts": "0",
    "mainSNA": "7.33",
    "spSNA": "0",
    "totalSNA": "7.33",
    "eircode": "V95YD26",
    "addressOne": "Cloughleigh",
    "addressTwo": "Ennis",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.8477708",
    "lng": "-8.9928232",
    "phone": "656820105",
    "email": "criostriennis@gmail.com"
  },
  {
    "i": "208",
    "county": "Clare",
    "rollNumber": "19698C",
    "schoolName": "St Aidans Ns",
    "SETHours": "112.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.33",
    "spSNA": "0",
    "totalSNA": "3.33",
    "eircode": "V14AW77",
    "addressOne": "Smithstown",
    "addressTwo": "Shannon",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.7111313",
    "lng": "-8.864134",
    "phone": "61363147",
    "email": "staidansns@hotmail.com"
  },
  {
    "i": "209",
    "county": "Clare",
    "rollNumber": "19700J",
    "schoolName": "Lisdoonvarna NS",
    "SETHours": "65",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.75",
    "spSNA": "0",
    "totalSNA": "2.75",
    "eircode": "V95P226",
    "addressOne": "Main Street",
    "addressTwo": "Lisdoonvarna",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "53.0310712",
    "lng": "-9.2887346",
    "phone": "657074231",
    "email": "lisdoonvarnans@gmail.com"
  },
  {
    "i": "210",
    "county": "Clare",
    "rollNumber": "19838P",
    "schoolName": "Gael Sc Mhichil Chiosog",
    "SETHours": "135",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "V95DW35",
    "addressOne": "Bóthar An Ghoirt",
    "addressTwo": "Inis",
    "addressThree": "Co. An Chláir",
    "addressFour": "",
    "lat": "52.8558898",
    "lng": "-8.980846",
    "phone": "656821220",
    "email": "runai@gmci.ie"
  },
  {
    "i": "211",
    "county": "Clare",
    "rollNumber": "19849U",
    "schoolName": "Gaelscoil Donncha Rua",
    "SETHours": "30",
    "spClassTeachingPosts": "2",
    "mainSNA": "0.25",
    "spSNA": "3.66",
    "totalSNA": "3.91",
    "eircode": "V14AY84",
    "addressOne": "Bóthar Linne",
    "addressTwo": "Sionna",
    "addressThree": "Co An Chláir",
    "addressFour": "",
    "lat": "52.7056481",
    "lng": "-8.8763854",
    "phone": "61363165",
    "email": "gaelscoildrua@gmail.com"
  },
  {
    "i": "212",
    "county": "Clare",
    "rollNumber": "19999Q",
    "schoolName": "Gaelscoil Ui Choimin",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V15KT32",
    "addressOne": "Pound Street",
    "addressTwo": "Cill Rois",
    "addressThree": "Co An Chlair",
    "addressFour": "",
    "lat": "52.6401576",
    "lng": "-9.4862016",
    "phone": "659052791",
    "email": "gaelscoiluichoimin@eircom.net"
  },
  {
    "i": "213",
    "county": "Clare",
    "rollNumber": "20041C",
    "schoolName": "Convent Of Mercy NS",
    "SETHours": "187.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "3.66",
    "spSNA": "2.83",
    "totalSNA": "6.49",
    "eircode": "V15HX06",
    "addressOne": "Kilrush",
    "addressTwo": "Co. Clare",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6400116",
    "lng": "-9.4871553",
    "phone": "659051792",
    "email": "office@kilrushns.ie"
  },
  {
    "i": "214",
    "county": "Clare",
    "rollNumber": "20075T",
    "schoolName": "St Mochullas NS",
    "SETHours": "102.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "1.33",
    "spSNA": "2",
    "totalSNA": "3.33",
    "eircode": "V95XH26",
    "addressOne": "Ennis Road",
    "addressTwo": "Tulla",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.8677279",
    "lng": "-8.761921",
    "phone": "656835840",
    "email": "tullans.ias@eircom.net"
  },
  {
    "i": "215",
    "county": "Clare",
    "rollNumber": "20078C",
    "schoolName": "Sn Realt Na Mara",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "V15VY11",
    "addressOne": "Chapel Street",
    "addressTwo": "Kilkee",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.678643",
    "lng": "-9.6467157",
    "phone": "659056583",
    "email": "scoilrealtnamara@eircom.net"
  },
  {
    "i": "216",
    "county": "Clare",
    "rollNumber": "20086B",
    "schoolName": "Ennis Educate Together Ns",
    "SETHours": "125",
    "spClassTeachingPosts": "2",
    "mainSNA": "5.66",
    "spSNA": "3.66",
    "totalSNA": "9.32",
    "eircode": "V95KP29",
    "addressOne": "Gort Road",
    "addressTwo": "Ennis",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.8591746",
    "lng": "-8.9830962",
    "phone": "656820070",
    "email": "info@eetns.ie"
  },
  {
    "i": "217",
    "county": "Clare",
    "rollNumber": "20127M",
    "schoolName": "Scoil Na Maighdine Mhuire",
    "SETHours": "117.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "3.75",
    "spSNA": "2",
    "totalSNA": "5.75",
    "eircode": "V95FX59",
    "addressOne": "Ennis Road",
    "addressTwo": "Newmarket-on-fergus",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.7633679",
    "lng": "-8.8973683",
    "phone": "61368333",
    "email": "office@scoilnamaighdinemhuire.ie"
  },
  {
    "i": "218",
    "county": "Clare",
    "rollNumber": "20149W",
    "schoolName": "St Fachnan & St Attractas NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.25",
    "spSNA": "0",
    "totalSNA": "1.25",
    "eircode": "V95EY90",
    "addressOne": "Kilcarragh",
    "addressTwo": "Kilfenora",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.9896546",
    "lng": "-9.2212247",
    "phone": "657088217",
    "email": "kilfenorans@gmail.com"
  },
  {
    "i": "219",
    "county": "Clare",
    "rollNumber": "20245S",
    "schoolName": "Ennistymon NS",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "V95YP46",
    "addressOne": "Ennistymon",
    "addressTwo": "Co. Clare",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.9384866",
    "lng": "-9.2984037",
    "phone": "657071722",
    "email": "etynns@gmail.com"
  },
  {
    "i": "220",
    "county": "Clare",
    "rollNumber": "20312H",
    "schoolName": "Raheen Wood Community NS",
    "SETHours": "65",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "V94RW32",
    "addressOne": "Raheen Road",
    "addressTwo": "Tuamgraney",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.892682",
    "lng": "-8.5210141",
    "phone": "61921494",
    "email": "info@raheenwood.org"
  },
  {
    "i": "221",
    "county": "Clare",
    "rollNumber": "20313J",
    "schoolName": "Mol An óige Community NS",
    "SETHours": "85",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.33",
    "spSNA": "0",
    "totalSNA": "3.33",
    "eircode": "V95D372",
    "addressOne": "Glencree",
    "addressTwo": "Ennistymon",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.9407405",
    "lng": "-9.295591",
    "phone": "657072814",
    "email": "molanoigens@gmail.com"
  },
  {
    "i": "222",
    "county": "Clare",
    "rollNumber": "20404M",
    "schoolName": "Coore NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "V95T972",
    "addressOne": "Coore",
    "addressTwo": "Mullagh",
    "addressThree": "Ennis",
    "addressFour": "",
    "lat": "52.8125914",
    "lng": "-9.3513917",
    "phone": "657087592",
    "email": "coorenational@gmail.com"
  },
  {
    "i": "223",
    "county": "Clare",
    "rollNumber": "20434V",
    "schoolName": "Scoil Mhichil",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "V15W892",
    "addressOne": "Cahermurphy",
    "addressTwo": "Kilmihil",
    "addressThree": "Kilrush",
    "addressFour": "",
    "lat": "52.7514922",
    "lng": "-9.3394462",
    "phone": "659050460",
    "email": "scoilmhichil3@gmail.com"
  },
  {
    "i": "224",
    "county": "Clare",
    "rollNumber": "20447H",
    "schoolName": "Kilmurry Mcmahon NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "V15D899",
    "addressOne": "Kilmurry Mcmahon",
    "addressTwo": "Kilrush",
    "addressThree": "Co. Clare",
    "addressFour": "",
    "lat": "52.6634333",
    "lng": "-9.3114789",
    "phone": "659053008",
    "email": "drumnsias@eircom.net"
  },
  {
    "i": "225",
    "county": "Clare",
    "rollNumber": "20452A",
    "schoolName": "Broadford & Kilbane NS",
    "SETHours": "60",
    "spClassTeachingPosts": "1",
    "mainSNA": "0",
    "spSNA": "2",
    "totalSNA": "2",
    "eircode": "V94AP28",
    "addressOne": "Broadford",
    "addressTwo": "Co. Clare",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.803766",
    "lng": "-8.6328171",
    "phone": "61473353",
    "email": "office@broadfordns.com"
  },
  {
    "i": "226",
    "county": "Clare",
    "rollNumber": "20476O",
    "schoolName": "Scoil Na Mainistreach Quin Dangan",
    "SETHours": "105",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.33",
    "spSNA": "0",
    "totalSNA": "2.33",
    "eircode": "V95P659",
    "addressOne": "Newline Road",
    "addressTwo": "Quin",
    "addressThree": "Co Clare",
    "addressFour": "",
    "lat": "52.8172797",
    "lng": "-8.8606316",
    "phone": "656825785",
    "email": "quindanganns@gmail.com"
  },
  {
    "i": "227",
    "county": "Cork",
    "rollNumber": "00467B",
    "schoolName": "Ballinspittle NS",
    "SETHours": "85",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "P17FN27",
    "addressOne": "Ballycatten",
    "addressTwo": "Ballinspittle",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.6641662",
    "lng": "-8.5960993",
    "phone": "214778239",
    "email": "secretaryballinspittlens@gmail.com"
  },
  {
    "i": "228",
    "county": "Cork",
    "rollNumber": "00512D",
    "schoolName": "Midleton Convent NS",
    "SETHours": "157.5",
    "spClassTeachingPosts": "4",
    "mainSNA": "2.83",
    "spSNA": "6.98",
    "totalSNA": "9.81",
    "eircode": "P25R248",
    "addressOne": "Midleton",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.9082139",
    "lng": "-8.1641518",
    "phone": "214631593",
    "email": "scoilbhridemidleton@gmail.com"
  },
  {
    "i": "230",
    "county": "Cork",
    "rollNumber": "01272O",
    "schoolName": "SN Chuan Doir",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "P81VE04",
    "addressOne": "Drombeg",
    "addressTwo": "Glandore",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.5680658",
    "lng": "-9.0951286",
    "phone": "2833796",
    "email": "glandorenationalschool@gmail.com"
  },
  {
    "i": "231",
    "county": "Cork",
    "rollNumber": "01687U",
    "schoolName": "Dromleigh NS",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "P12DY26",
    "addressOne": "Dromleigh",
    "addressTwo": "Kilmichael",
    "addressThree": "Macroom",
    "addressFour": "Co. Cork",
    "lat": "51.8345313",
    "lng": "-9.03862",
    "phone": "2646212",
    "email": "dromleighns@gmail.com"
  },
  {
    "i": "232",
    "county": "Cork",
    "rollNumber": "01692N",
    "schoolName": "Firmount Mixed NS",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "P32TX21",
    "addressOne": "Firmount",
    "addressTwo": "Donoughmore",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.9877858",
    "lng": "-8.6979135",
    "phone": "217337344",
    "email": "info@firmountns.ie"
  },
  {
    "i": "233",
    "county": "Cork",
    "rollNumber": "01867W",
    "schoolName": "Castlelyons BNS",
    "SETHours": "95",
    "spClassTeachingPosts": "2",
    "mainSNA": "3.83",
    "spSNA": "2",
    "totalSNA": "5.83",
    "eircode": "P61PH66",
    "addressOne": "Castlelyons",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.0826376",
    "lng": "-8.2290992",
    "phone": "2536220",
    "email": "castlelyonsns@gmail.com"
  },
  {
    "i": "234",
    "county": "Cork",
    "rollNumber": "02114B",
    "schoolName": "SN Baile Ui Ghiblin",
    "SETHours": "77.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "P67PK30",
    "addressOne": "Ballygiblin",
    "addressTwo": "Mitchelstown",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.2730037",
    "lng": "-8.1996996",
    "phone": "2524933",
    "email": "ballygiblins19@gmail.com"
  },
  {
    "i": "235",
    "county": "Cork",
    "rollNumber": "02278I",
    "schoolName": "Millstreet Convent NS",
    "SETHours": "75",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "P51V599",
    "addressOne": "West End",
    "addressTwo": "Millstreet",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.0588015",
    "lng": "-9.0655658",
    "phone": "2970957",
    "email": "millpns@gmail.com"
  },
  {
    "i": "236",
    "county": "Cork",
    "rollNumber": "02452V",
    "schoolName": "Cloyne NS",
    "SETHours": "130",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.33",
    "spSNA": "0",
    "totalSNA": "3.33",
    "eircode": "P25K220",
    "addressOne": "Cloyne",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.861849",
    "lng": "-8.1270856",
    "phone": "214652567",
    "email": "secretary@cloynens.com"
  },
  {
    "i": "238",
    "county": "Cork",
    "rollNumber": "02803B",
    "schoolName": "Banteer NS",
    "SETHours": "77.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "P51TK64",
    "addressOne": "Banteer",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.1313649",
    "lng": "-8.8912837",
    "phone": "2956262",
    "email": "office@banteerns.ie"
  },
  {
    "i": "239",
    "county": "Cork",
    "rollNumber": "03704E",
    "schoolName": "SN Sean Baile Mor",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.75",
    "spSNA": "0",
    "totalSNA": "1.75",
    "eircode": "P51VW63",
    "addressOne": "Main Street",
    "addressTwo": "Shanballymore",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.2184088",
    "lng": "-8.4765267",
    "phone": "2225611",
    "email": "shanballymorens@gmail.com"
  },
  {
    "i": "240",
    "county": "Cork",
    "rollNumber": "04054T",
    "schoolName": "Ballindangan Mixed NS",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "P67EW90",
    "addressOne": "Ballindangan",
    "addressTwo": "Mitchelstown",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.236282",
    "lng": "-8.3364923",
    "phone": "2584654",
    "email": "ballindangan.ias@eircom.net"
  },
  {
    "i": "241",
    "county": "Cork",
    "rollNumber": "04118T",
    "schoolName": "Leamlara Mixed NS",
    "SETHours": "102.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "T56NH57",
    "addressOne": "Leamlara",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.9698585",
    "lng": "-8.2636779",
    "phone": "214642430",
    "email": "leamlara.n.s@gmail.com"
  },
  {
    "i": "242",
    "county": "Cork",
    "rollNumber": "04152T",
    "schoolName": "SN Cnoc An Bhile",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "T12F981",
    "addressOne": "Knockavilla",
    "addressTwo": "Innishannon",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.8004657",
    "lng": "-8.6854445",
    "phone": "214775662",
    "email": "knockavillaschool@gmail.com"
  },
  {
    "i": "243",
    "county": "Cork",
    "rollNumber": "04186N",
    "schoolName": "SN Bhiorainn",
    "SETHours": "92.5",
    "spClassTeachingPosts": "4",
    "mainSNA": "4",
    "spSNA": "7.66",
    "totalSNA": "11.66",
    "eircode": "P12FX45",
    "addressOne": "Berrings",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.9380418",
    "lng": "-8.6981482",
    "phone": "217332101",
    "email": "berringsns.ias@eircom.net"
  },
  {
    "i": "244",
    "county": "Cork",
    "rollNumber": "04230N",
    "schoolName": "Scoil Naomh Eoin",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "T56KR89",
    "addressOne": "Ballincurrig",
    "addressTwo": "Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.9892119",
    "lng": "-8.2280084",
    "phone": "214642222",
    "email": "principalballincurrigns@gmail.com"
  },
  {
    "i": "245",
    "county": "Cork",
    "rollNumber": "04442F",
    "schoolName": "Kyle NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "P36WR52",
    "addressOne": "Kyle",
    "addressTwo": "Youghal",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.9534214",
    "lng": "-7.9435335",
    "phone": "2495198",
    "email": "kylens.ias@eircom.net"
  },
  {
    "i": "246",
    "county": "Cork",
    "rollNumber": "04578H",
    "schoolName": "Ballyvongane Mixed NS",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "P12YD30",
    "addressOne": "Ballyvongane",
    "addressTwo": "Aghinagh,",
    "addressThree": "Coachford",
    "addressFour": "",
    "lat": "51.9319827",
    "lng": "-8.8591553",
    "phone": "2648188",
    "email": "ballyvonganens@gmail.com"
  },
  {
    "i": "247",
    "county": "Cork",
    "rollNumber": "04953H",
    "schoolName": "Ballyhass Mixed NS",
    "SETHours": "95",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.83",
    "spSNA": "0",
    "totalSNA": "4.83",
    "eircode": "P51K590",
    "addressOne": "Ballyhass",
    "addressTwo": "Cecilstown",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.1741451",
    "lng": "-8.8047292",
    "phone": "2227937",
    "email": "ballyhassmixedns@gmail.com"
  },
  {
    "i": "248",
    "county": "Cork",
    "rollNumber": "05257P",
    "schoolName": "Presentation Convent",
    "SETHours": "125",
    "spClassTeachingPosts": "2",
    "mainSNA": "3",
    "spSNA": "4",
    "totalSNA": "7",
    "eircode": "P72DF21",
    "addressOne": "Dunmanway Road",
    "addressTwo": "Bandon",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.7488205",
    "lng": "-8.7439247",
    "phone": "238841809",
    "email": "presprimbandon@eircom.net"
  },
  {
    "i": "249",
    "county": "Cork",
    "rollNumber": "05477G",
    "schoolName": "Laragh NS",
    "SETHours": "60",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "P72RY79",
    "addressOne": "Laragh",
    "addressTwo": "Bandon",
    "addressThree": "Co Cork",
    "addressFour": "",
    "lat": "51.7578958",
    "lng": "-8.7899784",
    "phone": "238843313",
    "email": "laraghns@gmail.com"
  },
  {
    "i": "250",
    "county": "Cork",
    "rollNumber": "05508O",
    "schoolName": "St Columbas N.s",
    "SETHours": "155",
    "spClassTeachingPosts": "6",
    "mainSNA": "3.5",
    "spSNA": "7.83",
    "totalSNA": "11.33",
    "eircode": "T12WK3D",
    "addressOne": "With Facility For Deaf Children",
    "addressTwo": "Douglas West",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.8735692",
    "lng": "-8.443765",
    "phone": "214893947",
    "email": "office@stcolumbasgns.ie"
  },
  {
    "i": "251",
    "county": "Cork",
    "rollNumber": "05565D",
    "schoolName": "Trafrask Mixed NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "P75PD68",
    "addressOne": "Trafrask",
    "addressTwo": "Adrigole (beara)",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.687246",
    "lng": "-9.6648592",
    "phone": "2760201",
    "email": "trafraskns@gmail.com"
  },
  {
    "i": "252",
    "county": "Cork",
    "rollNumber": "05636A",
    "schoolName": "Dunmanway Model NS",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "P47NW66",
    "addressOne": "Bantry Road",
    "addressTwo": "Dunmanway",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.7168714",
    "lng": "-9.1159218",
    "phone": "238845034",
    "email": "anmhodhscoil@gmail.com"
  },
  {
    "i": "253",
    "county": "Cork",
    "rollNumber": "05656G",
    "schoolName": "SN An Ghoilin",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "P81YW27",
    "addressOne": "Goleen",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.4925363",
    "lng": "-9.7133996",
    "phone": "2835660",
    "email": "mgoleenns@gmail.com"
  },
  {
    "i": "254",
    "county": "Cork",
    "rollNumber": "05940D",
    "schoolName": "Scoil Ursula",
    "SETHours": "120",
    "spClassTeachingPosts": "2",
    "mainSNA": "4.66",
    "spSNA": "3.66",
    "totalSNA": "8.32",
    "eircode": "T12XC91",
    "addressOne": "Blackrock Road",
    "addressTwo": "Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.8959232",
    "lng": "-8.4140977",
    "phone": "214358476",
    "email": "sublackrock.ias@eircom.net"
  },
  {
    "i": "255",
    "county": "Cork",
    "rollNumber": "06295F",
    "schoolName": "Freemount Mixed NS",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "P56FN30",
    "addressOne": "Freemount",
    "addressTwo": "Charleville",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.2780394",
    "lng": "-8.8846127",
    "phone": "2228834",
    "email": "freemountns@gmail.com"
  },
  {
    "i": "256",
    "county": "Cork",
    "rollNumber": "06342L",
    "schoolName": "Vicarstown Mixed NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "1.75",
    "spSNA": "5.49",
    "totalSNA": "7.24",
    "eircode": "P32DX40",
    "addressOne": "Gilclough",
    "addressTwo": "Vicarstown",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.9546618",
    "lng": "-8.6564766",
    "phone": "217332179",
    "email": "office@vicarstownns.com"
  },
  {
    "i": "257",
    "county": "Cork",
    "rollNumber": "07006A",
    "schoolName": "Ballyclough Mixed NS",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "P51CY80",
    "addressOne": "Ballyclough",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.1669049",
    "lng": "-8.7359371",
    "phone": "2227857",
    "email": "ballycloughns@gmail.com"
  },
  {
    "i": "258",
    "county": "Cork",
    "rollNumber": "07242M",
    "schoolName": "Cloghroe Mixed NS",
    "SETHours": "212.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "10.66",
    "spSNA": "1",
    "totalSNA": "11.66",
    "eircode": "T23AH2R",
    "addressOne": "Cloghroe",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.9177617",
    "lng": "-8.616287",
    "phone": "214385547",
    "email": "oifig@cloghroens.ie"
  },
  {
    "i": "259",
    "county": "Cork",
    "rollNumber": "07651G",
    "schoolName": "St Joseph's GNS",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "P85AX90",
    "addressOne": "Convent Road",
    "addressTwo": "Clonakilty",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.6263394",
    "lng": "-8.880393",
    "phone": "238833050",
    "email": "info@stjosephsclon.com"
  },
  {
    "i": "260",
    "county": "Cork",
    "rollNumber": "08393P",
    "schoolName": "SN Rath Dubh",
    "SETHours": "107.5",
    "spClassTeachingPosts": "4",
    "mainSNA": "3.5",
    "spSNA": "7.49",
    "totalSNA": "10.99",
    "eircode": "T23X029",
    "addressOne": "Rathduff",
    "addressTwo": "Grenagh",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.013761",
    "lng": "-8.5945138",
    "phone": "214886388",
    "email": "rathdubhns@eircom.net"
  },
  {
    "i": "261",
    "county": "Cork",
    "rollNumber": "08430S",
    "schoolName": "Scoil Naomh Seosamh",
    "SETHours": "87.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "1.5",
    "spSNA": "2",
    "totalSNA": "3.5",
    "eircode": "P81A364",
    "addressOne": "Gortnaclohy",
    "addressTwo": "Skibberreen",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.5526685",
    "lng": "-9.2604096",
    "phone": "2821804",
    "email": "stjosskibb.ias@eircom.net"
  },
  {
    "i": "262",
    "county": "Cork",
    "rollNumber": "08828B",
    "schoolName": "Kilcorney Mixed NS",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "P51PE86",
    "addressOne": "Kilcorney",
    "addressTwo": "Rathcoole",
    "addressThree": "Mallow",
    "addressFour": "Co. Cork",
    "lat": "52.0619591",
    "lng": "-8.9623524",
    "phone": "2958380",
    "email": "kilcorneynationalschool@gmail.com"
  },
  {
    "i": "263",
    "county": "Cork",
    "rollNumber": "08972I",
    "schoolName": "Castlealack NS",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "P72A327",
    "addressOne": "Castlelack",
    "addressTwo": "Bandon",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.7803185",
    "lng": "-8.7394327",
    "phone": "238843786",
    "email": "castlelackns@gmail.com"
  },
  {
    "i": "264",
    "county": "Cork",
    "rollNumber": "09161W",
    "schoolName": "Our Lady Of Mercy NS",
    "SETHours": "87.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "4.83",
    "spSNA": "4",
    "totalSNA": "8.83",
    "eircode": "P75XE75",
    "addressOne": "Summerhill",
    "addressTwo": "Bantry",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.6789947",
    "lng": "-9.4437033",
    "phone": "2750590",
    "email": "olomnsmpower@gmail.com"
  },
  {
    "i": "265",
    "county": "Cork",
    "rollNumber": "09537S",
    "schoolName": "Ballinadee NS",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "P72TW82",
    "addressOne": "Ballinadee",
    "addressTwo": "Bandon",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.7137764",
    "lng": "-8.6267371",
    "phone": "214778554",
    "email": "ballinadeens@gmail.com"
  },
  {
    "i": "266",
    "county": "Cork",
    "rollNumber": "09815U",
    "schoolName": "Tullaslease Mixed NS",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "P56V977",
    "addressOne": "Tullylease",
    "addressTwo": "Charleville",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.3156271",
    "lng": "-8.9422117",
    "phone": "6383205",
    "email": "nstullylease@gmail.com"
  },
  {
    "i": "267",
    "county": "Cork",
    "rollNumber": "09872J",
    "schoolName": "Cloghoola Mixed NS",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "P51NH77",
    "addressOne": "Cloughoulamore",
    "addressTwo": "Millstreet",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.0255614",
    "lng": "-9.0673704",
    "phone": "2970432",
    "email": "cloghoulans@gmail.com"
  },
  {
    "i": "268",
    "county": "Cork",
    "rollNumber": "10047I",
    "schoolName": "Macroom Convent NS",
    "SETHours": "145",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "P12RW14",
    "addressOne": "New Road",
    "addressTwo": "Macroom",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.9030719",
    "lng": "-8.9575673",
    "phone": "2641847",
    "email": "stjosephsmacroom@gmail.com"
  },
  {
    "i": "269",
    "county": "Cork",
    "rollNumber": "10243I",
    "schoolName": "SN Achadh Eochaille",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "P47VY31",
    "addressOne": "Ahiohill",
    "addressTwo": "Enniskeane",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.7059737",
    "lng": "-8.8842388",
    "phone": "238839477",
    "email": "ahiohill@gmail.com"
  },
  {
    "i": "270",
    "county": "Cork",
    "rollNumber": "10499U",
    "schoolName": "Kilgariffe NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.25",
    "spSNA": "0",
    "totalSNA": "1.25",
    "eircode": "P85KR27",
    "addressOne": "Old Timoleague Road",
    "addressTwo": "Clonakilty",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.625736",
    "lng": "-8.8743077",
    "phone": "238834965",
    "email": "kilgarriffens.office@gmail.com"
  },
  {
    "i": "271",
    "county": "Cork",
    "rollNumber": "10523O",
    "schoolName": "Fermoy Adair NS",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "P61V603",
    "addressOne": "Greenhill",
    "addressTwo": "Fermoy",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.1427199",
    "lng": "-8.2744455",
    "phone": "2533765",
    "email": "fermoyadair@gmail.com"
  },
  {
    "i": "272",
    "county": "Cork",
    "rollNumber": "10548H",
    "schoolName": "St Brendans NS",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "P75KF96",
    "addressOne": "Wolfe Tone Square",
    "addressTwo": "Bantry",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.6814766",
    "lng": "-9.4547775",
    "phone": "2751126",
    "email": "sbnsbantry@gmail.com"
  },
  {
    "i": "273",
    "county": "Cork",
    "rollNumber": "10724B",
    "schoolName": "South Abbey Ns",
    "SETHours": "128",
    "spClassTeachingPosts": "2",
    "mainSNA": "3.83",
    "spSNA": "4",
    "totalSNA": "7.83",
    "eircode": "P36HN47",
    "addressOne": "Golf Links Road",
    "addressTwo": "Youghal",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.9479179",
    "lng": "-7.8505681",
    "phone": "2491060",
    "email": "southabbeyoffice@gmail.com"
  },
  {
    "i": "274",
    "county": "Cork",
    "rollNumber": "10739O",
    "schoolName": "Ballincarriga Mxd NS",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "P47K312",
    "addressOne": "Ballincarriga",
    "addressTwo": "Dunmanway",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.7046111",
    "lng": "-9.0366606",
    "phone": "238845944",
    "email": "info@ballinacarriga-ns.ie"
  },
  {
    "i": "275",
    "county": "Cork",
    "rollNumber": "10771K",
    "schoolName": "Cobh NS",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "P24FE08",
    "addressOne": "Bellevue",
    "addressTwo": "Cobh",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.8520031",
    "lng": "-8.2872247",
    "phone": "214811755",
    "email": "cobhmixednationalschool@gmail.com"
  },
  {
    "i": "276",
    "county": "Cork",
    "rollNumber": "11236Q",
    "schoolName": "Newmarket BNS",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "P51CP23",
    "addressOne": "West End",
    "addressTwo": "Newmarket",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.2144999",
    "lng": "-9.0046874",
    "phone": "2960956",
    "email": "office@newmarketbns.ie"
  },
  {
    "i": "277",
    "county": "Cork",
    "rollNumber": "11245R",
    "schoolName": "Sn Cill Mhic Abhaidh",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "P81NY10",
    "addressOne": "Kilmacabea",
    "addressTwo": "Leap",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.582147",
    "lng": "-9.1381264",
    "phone": "2833574",
    "email": "nationalschoolleap@gmail.com"
  },
  {
    "i": "278",
    "county": "Cork",
    "rollNumber": "11249C",
    "schoolName": "Burnfort NS",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "P51FN32",
    "addressOne": "Burnfort",
    "addressTwo": "Mallow",
    "addressThree": "Co Cork",
    "addressFour": "",
    "lat": "52.067231",
    "lng": "-8.5980063",
    "phone": "2229438",
    "email": "office@burnfortns.com"
  },
  {
    "i": "279",
    "county": "Cork",
    "rollNumber": "11262R",
    "schoolName": "Druimne NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "P56T293",
    "addressOne": "Dromina",
    "addressTwo": "Charleville",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.3146223",
    "lng": "-8.79978",
    "phone": "6370268",
    "email": "office@drominans.org"
  },
  {
    "i": "280",
    "county": "Cork",
    "rollNumber": "11337W",
    "schoolName": "Kilmagner NS",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "P61V968",
    "addressOne": "Kilmagner",
    "addressTwo": "Fermoy",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.124531",
    "lng": "-8.1705138",
    "phone": "2536802",
    "email": "kilmagner1878@gmail.com"
  },
  {
    "i": "281",
    "county": "Cork",
    "rollNumber": "11496T",
    "schoolName": "Shandrum NS",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "P56X803",
    "addressOne": "Newtownshandrum",
    "addressTwo": "Charleville",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.3453596",
    "lng": "-8.7677613",
    "phone": "6370236",
    "email": "shandrumsec@gmail.com"
  },
  {
    "i": "282",
    "county": "Cork",
    "rollNumber": "11931L",
    "schoolName": "SN Ioseph",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "P47YY30",
    "addressOne": "Derryclogh Lower",
    "addressTwo": "Drinagh",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.633412",
    "lng": "-9.2053388",
    "phone": "2830328",
    "email": "derrycloughns@gmail.com"
  },
  {
    "i": "283",
    "county": "Cork",
    "rollNumber": "11992I",
    "schoolName": "Whitegate Mixed NS",
    "SETHours": "50.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "P25A062",
    "addressOne": "Corkbeg",
    "addressTwo": "Whitegate",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.823434",
    "lng": "-8.2355337",
    "phone": "214661622",
    "email": "secretarywhitegatens@gmail.com"
  },
  {
    "i": "284",
    "county": "Cork",
    "rollNumber": "12012W",
    "schoolName": "St Lukes NS Douglas",
    "SETHours": "75",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "T12A395",
    "addressOne": "Churchyard Lane",
    "addressTwo": "Douglas",
    "addressThree": "Cork",
    "addressFour": "",
    "lat": "51.8738391",
    "lng": "-8.4363824",
    "phone": "214361388",
    "email": "office@stlukesschool.ie"
  },
  {
    "i": "285",
    "county": "Cork",
    "rollNumber": "12015F",
    "schoolName": "Liscarrol NS",
    "SETHours": "112.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "6.24",
    "spSNA": "5.66",
    "totalSNA": "11.9",
    "eircode": "P51DA33",
    "addressOne": "Liscarroll",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.2589846",
    "lng": "-8.8063001",
    "phone": "2248491",
    "email": "office@liscarrollns.org"
  },
  {
    "i": "286",
    "county": "Cork",
    "rollNumber": "12041G",
    "schoolName": "St John The Baptist NS",
    "SETHours": "117.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "7.16",
    "spSNA": "0",
    "totalSNA": "7.16",
    "eircode": "P25P028",
    "addressOne": "The Park",
    "addressTwo": "Midleton",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.9160628",
    "lng": "-8.1688249",
    "phone": "214632587",
    "email": "sjbns@eircom.net"
  },
  {
    "i": "287",
    "county": "Cork",
    "rollNumber": "12147W",
    "schoolName": "SN An Aird",
    "SETHours": "60",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "P85H566",
    "addressOne": "Ardfield",
    "addressTwo": "Clonakilty",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.5711474",
    "lng": "-8.9104874",
    "phone": "238840860",
    "email": "scoilanaird@gmail.com"
  },
  {
    "i": "288",
    "county": "Cork",
    "rollNumber": "12169J",
    "schoolName": "Templebrady NS",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "P43D854",
    "addressOne": "Church Road",
    "addressTwo": "Crosshaven",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.8001977",
    "lng": "-8.2974385",
    "phone": "214831329",
    "email": "templebreedyns@eircom.net"
  },
  {
    "i": "289",
    "county": "Cork",
    "rollNumber": "12203G",
    "schoolName": "SN Naomh Antaine",
    "SETHours": "332.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "16.99",
    "spSNA": "1",
    "totalSNA": "17.99",
    "eircode": "T12E400",
    "addressOne": "Beechwood Park",
    "addressTwo": "Ballinlough",
    "addressThree": "Cork",
    "addressFour": "",
    "lat": "51.8881874",
    "lng": "-8.4479023",
    "phone": "214291958",
    "email": "stanthonysns@gmail.com"
  },
  {
    "i": "290",
    "county": "Cork",
    "rollNumber": "12259K",
    "schoolName": "SN Oir Cheann",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "P75X652",
    "addressOne": "Urhan",
    "addressTwo": "Eyeries",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.6727055",
    "lng": "-9.9997521",
    "phone": "2774418",
    "email": "principal@urhanns.ie"
  },
  {
    "i": "291",
    "county": "Cork",
    "rollNumber": "12263B",
    "schoolName": "Gogginshill NS",
    "SETHours": "70",
    "spClassTeachingPosts": "2",
    "mainSNA": "3",
    "spSNA": "4",
    "totalSNA": "7",
    "eircode": "T12E443",
    "addressOne": "Goggins Hill",
    "addressTwo": "Ballinhassig",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.8234628",
    "lng": "-8.5784522",
    "phone": "214885241",
    "email": "info@gogginshillschool.com"
  },
  {
    "i": "292",
    "county": "Cork",
    "rollNumber": "12281D",
    "schoolName": "Walterstown NS",
    "SETHours": "90",
    "spClassTeachingPosts": "3",
    "mainSNA": "3.66",
    "spSNA": "5.66",
    "totalSNA": "9.32",
    "eircode": "P24T329",
    "addressOne": "Walterstown",
    "addressTwo": "Cobh",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.86684",
    "lng": "-8.2362501",
    "phone": "214812625",
    "email": "office@walterstownns.ie"
  },
  {
    "i": "293",
    "county": "Cork",
    "rollNumber": "12292I",
    "schoolName": "Canovee Mixed NS",
    "SETHours": "72.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "P12W628",
    "addressOne": "Carrigadrohid",
    "addressTwo": "Macroom",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.889291",
    "lng": "-8.8561854",
    "phone": "2648142",
    "email": "office@canoveens.com"
  },
  {
    "i": "294",
    "county": "Cork",
    "rollNumber": "12382J",
    "schoolName": "Curriglass Ns",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "P51AX94",
    "addressOne": "Blackpool",
    "addressTwo": "Curraglass",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.0943718",
    "lng": "-8.0490424",
    "phone": "5856707",
    "email": "curraglassns@gmail.com"
  },
  {
    "i": "295",
    "county": "Cork",
    "rollNumber": "12383L",
    "schoolName": "Union Hall Mixed NS",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "P81EK52",
    "addressOne": "Union Hall",
    "addressTwo": "Skibbereen",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.5533931",
    "lng": "-9.1441092",
    "phone": "2833717",
    "email": "unionhallns@gmail.com"
  },
  {
    "i": "296",
    "county": "Cork",
    "rollNumber": "12395S",
    "schoolName": "Rusheen Ns",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "P12C981",
    "addressOne": "Rusheen",
    "addressTwo": "Coachford",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.9374631",
    "lng": "-8.904",
    "phone": "2642733",
    "email": "office@rusheenns.ie"
  },
  {
    "i": "297",
    "county": "Cork",
    "rollNumber": "12446J",
    "schoolName": "SN Gleann Na Huladh",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.33",
    "spSNA": "0",
    "totalSNA": "3.33",
    "eircode": "P67CP29",
    "addressOne": "Cloughleafin",
    "addressTwo": "Mitchelstown",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.2537984",
    "lng": "-8.3645483",
    "phone": "2225476",
    "email": "glenahullans.ias@eircom.net"
  },
  {
    "i": "298",
    "county": "Cork",
    "rollNumber": "12447L",
    "schoolName": "Baltydaniel NS",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "P51ND35",
    "addressOne": "Newtwopothouse",
    "addressTwo": "Mallow",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.1863637",
    "lng": "-8.6704629",
    "phone": "2242646",
    "email": "baltydanielns@gmail.com"
  },
  {
    "i": "299",
    "county": "Cork",
    "rollNumber": "12456M",
    "schoolName": "Timoleague NS",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.33",
    "spSNA": "0",
    "totalSNA": "3.33",
    "eircode": "P72Y058",
    "addressOne": "School Road",
    "addressTwo": "Timoleague",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.6424247",
    "lng": "-8.7641375",
    "phone": "238846550",
    "email": "timoleaguens2@gmail.com"
  },
  {
    "i": "300",
    "county": "Cork",
    "rollNumber": "12473M",
    "schoolName": "Greenmount Monastery Ns",
    "SETHours": "195",
    "spClassTeachingPosts": "3",
    "mainSNA": "8.16",
    "spSNA": "3.16",
    "totalSNA": "11.32",
    "eircode": "T12HE14",
    "addressOne": "Green Street",
    "addressTwo": "Greenmount",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.891243",
    "lng": "-8.4803084",
    "phone": "214966242",
    "email": "principal@greenmount.ie"
  },
  {
    "i": "301",
    "county": "Cork",
    "rollNumber": "12505W",
    "schoolName": "Kilbarry NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "P12VK54",
    "addressOne": "Kilbarry",
    "addressTwo": "Macroom",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.8621986",
    "lng": "-9.0605686",
    "phone": "2649203",
    "email": "kilbarryns@gmail.com"
  },
  {
    "i": "302",
    "county": "Cork",
    "rollNumber": "12598J",
    "schoolName": "Ardagh Boys Sn NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "P85E063",
    "addressOne": "Ardagh",
    "addressTwo": "Rosscarbery",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.5803061",
    "lng": "-9.0295883",
    "phone": "238848777",
    "email": "ardaghbns@eircom.net"
  },
  {
    "i": "303",
    "county": "Cork",
    "rollNumber": "12676D",
    "schoolName": "Clogheen Mxd NS",
    "SETHours": "77.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.25",
    "spSNA": "0",
    "totalSNA": "1.25",
    "eircode": "T23A406",
    "addressOne": "Kerry Pike",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.908528",
    "lng": "-8.5622139",
    "phone": "214873241",
    "email": "ckpnscork@gmail.com"
  },
  {
    "i": "304",
    "county": "Cork",
    "rollNumber": "12685E",
    "schoolName": "Rushnacahara NS",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "P75TH52",
    "addressOne": "Rushnachara",
    "addressTwo": "Durrus",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.6053956",
    "lng": "-9.6230035",
    "phone": "2767286",
    "email": "rusnacaharans@gmail.com"
  },
  {
    "i": "305",
    "county": "Cork",
    "rollNumber": "12967O",
    "schoolName": "Inchigeela NS",
    "SETHours": "47.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "3",
    "spSNA": "1",
    "totalSNA": "4",
    "eircode": "P12DH22",
    "addressOne": "Carrighleigh",
    "addressTwo": "Inchigeelagh",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.8408739",
    "lng": "-9.1254215",
    "phone": "2649197",
    "email": "inchigeelans@gmail.com"
  },
  {
    "i": "306",
    "county": "Cork",
    "rollNumber": "13031I",
    "schoolName": "St Josephs Convent NS",
    "SETHours": "95",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.15",
    "spSNA": "0",
    "totalSNA": "5.15",
    "eircode": "P56AC85",
    "addressOne": "Smith's Road",
    "addressTwo": "Charleville",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.354623",
    "lng": "-8.6859319",
    "phone": "6389467",
    "email": "stjosephsconventns@gmail.com"
  },
  {
    "i": "307",
    "county": "Cork",
    "rollNumber": "13095L",
    "schoolName": "SN An Droma Mhoir",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.33",
    "spSNA": "0",
    "totalSNA": "1.33",
    "eircode": "P75VX24",
    "addressOne": "Dromore",
    "addressTwo": "Bantry",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.6562759",
    "lng": "-9.3590187",
    "phone": "2831541",
    "email": "Dromorens@gmail.com"
  },
  {
    "i": "308",
    "county": "Cork",
    "rollNumber": "13125R",
    "schoolName": "Scoil Dhairbhre",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "P85VX62",
    "addressOne": "Cruary",
    "addressTwo": "Clonakilty",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.6155022",
    "lng": "-8.8282857",
    "phone": "238834160",
    "email": "office@darrarans.ie"
  },
  {
    "i": "309",
    "county": "Cork",
    "rollNumber": "13234W",
    "schoolName": "Cloughduv NS",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "P14TN92",
    "addressOne": "Cloughduv",
    "addressTwo": "Crookstown",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.8463701",
    "lng": "-8.7887102",
    "phone": "217336548",
    "email": "cloughduvnationalschool@gmail.com"
  },
  {
    "i": "310",
    "county": "Cork",
    "rollNumber": "13286S",
    "schoolName": "Tirelton NS Mxd",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "P12HR24",
    "addressOne": "Tarelton",
    "addressTwo": "Macroom",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.8372603",
    "lng": "-8.9904989",
    "phone": "2646362",
    "email": "tarelton.ias@eircom.net"
  },
  {
    "i": "311",
    "county": "Cork",
    "rollNumber": "13375R",
    "schoolName": "Scoil Bhride",
    "SETHours": "75",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "P72XK20",
    "addressOne": "Crossmahon",
    "addressTwo": "Bandon",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.7271603",
    "lng": "-8.7699498",
    "phone": "238844266",
    "email": "principal@crossmahonns.com"
  },
  {
    "i": "312",
    "county": "Cork",
    "rollNumber": "13402R",
    "schoolName": "Knockraha NS",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.08",
    "spSNA": "0",
    "totalSNA": "3.08",
    "eircode": "T56CY50",
    "addressOne": "Knockraha",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.9582712",
    "lng": "-8.3396858",
    "phone": "214866727",
    "email": "officeknockrahans@gmail.com"
  },
  {
    "i": "313",
    "county": "Cork",
    "rollNumber": "13450F",
    "schoolName": "Bunscoil Rinn An Chabhlaigh",
    "SETHours": "315",
    "spClassTeachingPosts": "4",
    "mainSNA": "4.24",
    "spSNA": "8",
    "totalSNA": "12.24",
    "eircode": "P24VN20",
    "addressOne": "Rushbrooke",
    "addressTwo": "Cobh",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.8501048",
    "lng": "-8.3144419",
    "phone": "214811019",
    "email": "jdonoghue@bsrac.ie"
  },
  {
    "i": "314",
    "county": "Cork",
    "rollNumber": "13483U",
    "schoolName": "SN Ath Na Lionta",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "P51PF72",
    "addressOne": "Mourneabbey",
    "addressTwo": "Mallow",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.0688707",
    "lng": "-8.6379998",
    "phone": "2229277",
    "email": "analeentha.ias@eircom.net"
  },
  {
    "i": "315",
    "county": "Cork",
    "rollNumber": "13543M",
    "schoolName": "Derrinacahara NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "1.5",
    "spSNA": "2",
    "totalSNA": "3.5",
    "eircode": "P47VX89",
    "addressOne": "Derrinacahara",
    "addressTwo": "Dunmanway",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.7530348",
    "lng": "-9.1765861",
    "phone": "877633558",
    "email": "gabriellecrowley5@gmail.com"
  },
  {
    "i": "316",
    "county": "Cork",
    "rollNumber": "13647B",
    "schoolName": "Castlemartyr NS",
    "SETHours": "100",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "P25FK64",
    "addressOne": "Gortnahomnamore",
    "addressTwo": "Castlemartyr",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.91129",
    "lng": "-8.0516519",
    "phone": "214667689",
    "email": "castlemartyrns@gmail.com"
  },
  {
    "i": "317",
    "county": "Cork",
    "rollNumber": "13648D",
    "schoolName": "St Lukes Mxd NS",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "T23DF30",
    "addressOne": "O' Mahony's Avenue",
    "addressTwo": "Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.9040063",
    "lng": "-8.4565531",
    "phone": "214503686",
    "email": "stlukesjackie@gmail.com"
  },
  {
    "i": "318",
    "county": "Cork",
    "rollNumber": "13661S",
    "schoolName": "Dunmanway Convent Girls Sn NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "0.83",
    "spSNA": "4.83",
    "totalSNA": "5.66",
    "eircode": "P47CF70",
    "addressOne": "Dunmanway",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.7239376",
    "lng": "-9.1139748",
    "phone": "238845108",
    "email": "smgssd@gmail.com"
  },
  {
    "i": "319",
    "county": "Cork",
    "rollNumber": "13662U",
    "schoolName": "Dunmanway Convent Inf",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.66",
    "spSNA": "0",
    "totalSNA": "2.66",
    "eircode": "P47CF70",
    "addressOne": "Dunmanway",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.7239376",
    "lng": "-9.1139748",
    "phone": "238856820",
    "email": "scoilnaionain.ias@eircom.net"
  },
  {
    "i": "320",
    "county": "Cork",
    "rollNumber": "13663W",
    "schoolName": "Lower Glanmire NS",
    "SETHours": "87.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "1",
    "spSNA": "3.66",
    "totalSNA": "4.66",
    "eircode": "T45VX70",
    "addressOne": "New Inn",
    "addressTwo": "Glanmire",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.9199516",
    "lng": "-8.41297",
    "phone": "214866293",
    "email": "sgmi@eircom.net"
  },
  {
    "i": "321",
    "county": "Cork",
    "rollNumber": "13696O",
    "schoolName": "St Vincents Convent NS",
    "SETHours": "125",
    "spClassTeachingPosts": "1",
    "mainSNA": "1.83",
    "spSNA": "1.66",
    "totalSNA": "3.49",
    "eircode": "T23PC43",
    "addressOne": "Wolfe Tone Street",
    "addressTwo": "Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.9058913",
    "lng": "-8.4799784",
    "phone": "214306909",
    "email": "principal@stvincentsns.ie"
  },
  {
    "i": "322",
    "county": "Cork",
    "rollNumber": "13728B",
    "schoolName": "Castletownsend Mxd NS",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "P81VY73",
    "addressOne": "Gurranes",
    "addressTwo": "Castletownshend",
    "addressThree": "Skibbereen",
    "addressFour": "Co. Cork",
    "lat": "51.5303702",
    "lng": "-9.196603",
    "phone": "2836392",
    "email": "castletownshendns@gmail.com"
  },
  {
    "i": "323",
    "county": "Cork",
    "rollNumber": "13747F",
    "schoolName": "Riverstown NS",
    "SETHours": "310",
    "spClassTeachingPosts": "2",
    "mainSNA": "8.33",
    "spSNA": "4",
    "totalSNA": "12.33",
    "eircode": "T45XY22",
    "addressOne": "Riverstown",
    "addressTwo": "Glanmire",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.9302205",
    "lng": "-8.3927718",
    "phone": "214866233",
    "email": "office@riverstownns.ie"
  },
  {
    "i": "324",
    "county": "Cork",
    "rollNumber": "13779S",
    "schoolName": "SN Dhrom Athain",
    "SETHours": "105",
    "spClassTeachingPosts": "0",
    "mainSNA": "5",
    "spSNA": "0",
    "totalSNA": "5",
    "eircode": "P51HW92",
    "addressOne": "Dromahane",
    "addressTwo": "Mallow",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.1041409",
    "lng": "-8.693744",
    "phone": "2243573",
    "email": "dromahanens@gmail.com"
  },
  {
    "i": "325",
    "county": "Cork",
    "rollNumber": "13828F",
    "schoolName": "Douglas BNS",
    "SETHours": "157.5",
    "spClassTeachingPosts": "4",
    "mainSNA": "2.5",
    "spSNA": "8",
    "totalSNA": "10.5",
    "eircode": "T12FW11",
    "addressOne": "Douglas West",
    "addressTwo": "Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.8736504",
    "lng": "-8.4410568",
    "phone": "214364938",
    "email": "office@stcolumbasbns.ie"
  },
  {
    "i": "326",
    "county": "Cork",
    "rollNumber": "13889C",
    "schoolName": "Shanbally NS",
    "SETHours": "112.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "4",
    "spSNA": "0.5",
    "totalSNA": "4.5",
    "eircode": "P43W990",
    "addressOne": "Shanbally",
    "addressTwo": "Ringaskiddy",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.8314019",
    "lng": "-8.3538659",
    "phone": "214378178",
    "email": "office@shanballyns.ie"
  },
  {
    "i": "327",
    "county": "Cork",
    "rollNumber": "13910N",
    "schoolName": "SN Bun An Tsabhairne",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "P43X242",
    "addressOne": "Crosshaven",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.8022449",
    "lng": "-8.2983286",
    "phone": "214831646",
    "email": "secretary@scoilbhridecrosshaven.ie"
  },
  {
    "i": "328",
    "county": "Cork",
    "rollNumber": "13976U",
    "schoolName": "St Matthias NS",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "P81K544",
    "addressOne": "Church Road",
    "addressTwo": "Ballydehob",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.563541",
    "lng": "-9.4677856",
    "phone": "2837500",
    "email": "stmatthiasns.ias@eircom.net"
  },
  {
    "i": "329",
    "county": "Cork",
    "rollNumber": "13980L",
    "schoolName": "SN B Togher Cork",
    "SETHours": "140",
    "spClassTeachingPosts": "2",
    "mainSNA": "4.33",
    "spSNA": "4",
    "totalSNA": "8.33",
    "eircode": "T12Y710",
    "addressOne": "Togher Road",
    "addressTwo": "Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.8741795",
    "lng": "-8.4964373",
    "phone": "214964640",
    "email": "office@togherboys.com"
  },
  {
    "i": "330",
    "county": "Cork",
    "rollNumber": "14000C",
    "schoolName": "Scoil Naomh Mhuire",
    "SETHours": "235",
    "spClassTeachingPosts": "4",
    "mainSNA": "4.08",
    "spSNA": "8",
    "totalSNA": "12.08",
    "eircode": "T12DW99",
    "addressOne": "Bishop Street",
    "addressTwo": "Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.8950212",
    "lng": "-8.480767",
    "phone": "214963994",
    "email": "info@stmariesps.ie"
  },
  {
    "i": "331",
    "county": "Kerry",
    "rollNumber": "14002G",
    "schoolName": "Knockaclarig Mxd NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "P51XC03",
    "addressOne": "Knockaclarig",
    "addressTwo": "Brosna",
    "addressThree": "Tralee",
    "addressFour": "Co. Kerry",
    "lat": "52.2757699",
    "lng": "-9.2175208",
    "phone": "6844555",
    "email": "knockaclarigns91@gmail.com"
  },
  {
    "i": "332",
    "county": "Cork",
    "rollNumber": "14014N",
    "schoolName": "SN Baile Deasmumhan",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.66",
    "spSNA": "0",
    "totalSNA": "2.66",
    "eircode": "P51CF30",
    "addressOne": "Church Road",
    "addressTwo": "Ballydesmond",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.1823501",
    "lng": "-9.2358943",
    "phone": "647751351",
    "email": "secretary@ballydesmondns.ie"
  },
  {
    "i": "333",
    "county": "Cork",
    "rollNumber": "14022M",
    "schoolName": "Coachford NS",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "P12TW53",
    "addressOne": "Coachford",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.9103505",
    "lng": "-8.7927711",
    "phone": "217334542",
    "email": "info@coachfordnationalschool.ie"
  },
  {
    "i": "335",
    "county": "Cork",
    "rollNumber": "14107U",
    "schoolName": "Castletownroche NS",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.75",
    "spSNA": "0",
    "totalSNA": "1.75",
    "eircode": "P51KT98",
    "addressOne": "Close Road",
    "addressTwo": "Castletownroche",
    "addressThree": "Mallow",
    "addressFour": "Co. Cork",
    "lat": "52.1721986",
    "lng": "-8.4681442",
    "phone": "2226024",
    "email": "castletownrochens@gmail.com"
  },
  {
    "i": "336",
    "county": "Cork",
    "rollNumber": "14116V",
    "schoolName": "Kilbrittain Mixed NS",
    "SETHours": "102.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "3",
    "spSNA": "6.66",
    "totalSNA": "9.66",
    "eircode": "P72N668",
    "addressOne": "Kilbrittain",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.6731231",
    "lng": "-8.6946326",
    "phone": "238849890",
    "email": "info@kilbrittainns.com"
  },
  {
    "i": "337",
    "county": "Cork",
    "rollNumber": "14225D",
    "schoolName": "Scoil Bhride",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "P81V294",
    "addressOne": "Greenmount Road",
    "addressTwo": "Ballydehob",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.5604539",
    "lng": "-9.4595671",
    "phone": "2837161",
    "email": "contactscoilbhride@gmail.com"
  },
  {
    "i": "338",
    "county": "Cork",
    "rollNumber": "14227H",
    "schoolName": "Kilcoe Ns",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "P81R802",
    "addressOne": "Kilcoe",
    "addressTwo": "Skibbereen",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.5598055",
    "lng": "-9.3904171",
    "phone": "2838233",
    "email": "kilcoens@gmail.com"
  },
  {
    "i": "339",
    "county": "Cork",
    "rollNumber": "14303U",
    "schoolName": "SN Cleire",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "P81FY05",
    "addressOne": "Oileán Chléire",
    "addressTwo": "An Sciobairí­n",
    "addressThree": "Co. Chorcaí­",
    "addressFour": "",
    "lat": "51.4353689",
    "lng": "-9.4983068",
    "phone": "2839171",
    "email": "snchleire@gmail.com"
  },
  {
    "i": "340",
    "county": "Cork",
    "rollNumber": "14430E",
    "schoolName": "Derrycreha NS",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "P75YD52",
    "addressOne": "Derrycreha",
    "addressTwo": "Glengarriff",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.7377939",
    "lng": "-9.5100354",
    "phone": "2763143",
    "email": "derrycrehans@gmail.com"
  },
  {
    "i": "341",
    "county": "Cork",
    "rollNumber": "14433K",
    "schoolName": "Abbeystrewry NS",
    "SETHours": "85",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "P81X386",
    "addressOne": "Castletownsend Road",
    "addressTwo": "Skibbereen",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.5409509",
    "lng": "-9.2611739",
    "phone": "2821261",
    "email": "abbeystrewryns1@gmail.com"
  },
  {
    "i": "342",
    "county": "Cork",
    "rollNumber": "14726C",
    "schoolName": "Kinsale NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.25",
    "spSNA": "0",
    "totalSNA": "1.25",
    "eircode": "P17AF10",
    "addressOne": "Knocknabohilly",
    "addressTwo": "Kinsale",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.7099803",
    "lng": "-8.5144732",
    "phone": "214774106",
    "email": "multosens.ias@eircom.net"
  },
  {
    "i": "343",
    "county": "Cork",
    "rollNumber": "14784Q",
    "schoolName": "Dunmanway Boys Sn NS",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "P47YF85",
    "addressOne": "Dunmanway",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.7220449",
    "lng": "-9.1074407",
    "phone": "238845458",
    "email": "sphnd@hotmail.com"
  },
  {
    "i": "344",
    "county": "Cork",
    "rollNumber": "14813U",
    "schoolName": "Roscarbery Con NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "P85VP86",
    "addressOne": "Ardagh East",
    "addressTwo": "Rosscarbery",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.5834014",
    "lng": "-9.0246932",
    "phone": "238848023",
    "email": "stmarysnsross@gmail.com"
  },
  {
    "i": "345",
    "county": "Cork",
    "rollNumber": "14816D",
    "schoolName": "Scoil Lachtain Naofa",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "P12AY06",
    "addressOne": "Cill Na Martra",
    "addressTwo": "Maigh Chromtha",
    "addressThree": "Co. Chorcaí­",
    "addressFour": "",
    "lat": "51.8996809",
    "lng": "-9.0880876",
    "phone": "2640000",
    "email": "scoil.cillnamartra@gmail.com"
  },
  {
    "i": "346",
    "county": "Cork",
    "rollNumber": "14839P",
    "schoolName": "Clondrohid NS",
    "SETHours": "100",
    "spClassTeachingPosts": "3",
    "mainSNA": "3.67",
    "spSNA": "5.49",
    "totalSNA": "9.16",
    "eircode": "P12XP28",
    "addressOne": "Clondrohid",
    "addressTwo": "Macroom",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.9286819",
    "lng": "-9.0218209",
    "phone": "2661800",
    "email": "clondrohid@gmail.com"
  },
  {
    "i": "347",
    "county": "Cork",
    "rollNumber": "14993C",
    "schoolName": "SN Rae Na Ndoiri",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "P12D738",
    "addressOne": "Rae Na Ndoirí­",
    "addressTwo": "Maigh Chromtha",
    "addressThree": "Co. Chorcaí­",
    "addressFour": "",
    "lat": "51.9009461",
    "lng": "-9.1610643",
    "phone": "2645441",
    "email": "reidhnandoiri2@gmail.com"
  },
  {
    "i": "348",
    "county": "Cork",
    "rollNumber": "15135H",
    "schoolName": "Bantry Boys Sn NS",
    "SETHours": "67.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "4",
    "spSNA": "2",
    "totalSNA": "6",
    "eircode": "P75NY51",
    "addressOne": "Seskin",
    "addressTwo": "Bantry",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.6766897",
    "lng": "-9.441164",
    "phone": "2750477",
    "email": "info@sfbns.net"
  },
  {
    "i": "349",
    "county": "Cork",
    "rollNumber": "15140A",
    "schoolName": "Ballingree Mxd NS",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "P12Y938",
    "addressOne": "Ballinagree",
    "addressTwo": "Macroom,",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.9776342",
    "lng": "-8.9250789",
    "phone": "2642466",
    "email": "nsballinagree@gmail.com"
  },
  {
    "i": "350",
    "county": "Cork",
    "rollNumber": "15165Q",
    "schoolName": "Ballintotas NS",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "P25Y272",
    "addressOne": "Ballintotis",
    "addressTwo": "Castlemartyr",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.90959",
    "lng": "-8.0959667",
    "phone": "214667513",
    "email": "ballintotasns@gmail.com"
  },
  {
    "i": "351",
    "county": "Cork",
    "rollNumber": "15346U",
    "schoolName": "Scoil Abán Naofa",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "P12HW02",
    "addressOne": "Baile Mhúirne",
    "addressTwo": "Maigh Chromtha",
    "addressThree": "Co. Chorcaí­",
    "addressFour": "",
    "lat": "51.9375929",
    "lng": "-9.1490631",
    "phone": "2645407",
    "email": "scoilaban@gmail.com"
  },
  {
    "i": "352",
    "county": "Cork",
    "rollNumber": "15380U",
    "schoolName": "Dromagh Mixed NS",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "P51A037",
    "addressOne": "Dromagh",
    "addressTwo": "Mallow",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.1344257",
    "lng": "-8.9504697",
    "phone": "2956067",
    "email": "dromaghns@gmail.com"
  },
  {
    "i": "353",
    "county": "Cork",
    "rollNumber": "15410D",
    "schoolName": "Kilcrohane NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "P75Y239",
    "addressOne": "Kilcrohane",
    "addressTwo": "Bantry",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.5809317",
    "lng": "-9.7030605",
    "phone": "2767285",
    "email": "kilcrohanens@gmail.com"
  },
  {
    "i": "354",
    "county": "Cork",
    "rollNumber": "15484J",
    "schoolName": "Glounthaune Mixed NS",
    "SETHours": "167.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "6",
    "spSNA": "0.33",
    "totalSNA": "6.33",
    "eircode": "T45AX78",
    "addressOne": "Glounthane",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.9143977",
    "lng": "-8.3418414",
    "phone": "214353645",
    "email": "principal@sncn.ie"
  },
  {
    "i": "355",
    "county": "Cork",
    "rollNumber": "15516T",
    "schoolName": "Clonpriest NS",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "P36DY22",
    "addressOne": "Youghal",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.9295929",
    "lng": "-7.9223028",
    "phone": "2493722",
    "email": "clonpriestns2020@gmail.com"
  },
  {
    "i": "356",
    "county": "Cork",
    "rollNumber": "15550T",
    "schoolName": "Ballyheeda NS",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "T12KT99",
    "addressOne": "Ballinhassig",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.7925737",
    "lng": "-8.5716666",
    "phone": "214885066",
    "email": "admin@ballyheadans.ie"
  },
  {
    "i": "357",
    "county": "Cork",
    "rollNumber": "15563F",
    "schoolName": "Lisheen Mixed NS",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "P81HX88",
    "addressOne": "Lisheen",
    "addressTwo": "Church Cross",
    "addressThree": "Skibbereen",
    "addressFour": "Co. Cork",
    "lat": "51.5322983",
    "lng": "-9.3761281",
    "phone": "2838481",
    "email": "lisheen15563@gmail.com"
  },
  {
    "i": "358",
    "county": "Cork",
    "rollNumber": "15594Q",
    "schoolName": "Grange Fermoy NS",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.75",
    "spSNA": "0",
    "totalSNA": "1.75",
    "eircode": "P61K240",
    "addressOne": "Grange",
    "addressTwo": "Fermoy",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.1510841",
    "lng": "-8.3065486",
    "phone": "2532799",
    "email": "gnschoolfermoy@gmail.com"
  },
  {
    "i": "359",
    "county": "Cork",
    "rollNumber": "15597W",
    "schoolName": "Macroom Boys Sn NS",
    "SETHours": "115",
    "spClassTeachingPosts": "4",
    "mainSNA": "4",
    "spSNA": "7.83",
    "totalSNA": "11.83",
    "eircode": "P12RV06",
    "addressOne": "Sleaveen East",
    "addressTwo": "Macroom",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.9027667",
    "lng": "-8.9543705",
    "phone": "2642705",
    "email": "mcrmbns@iol.ie"
  },
  {
    "i": "360",
    "county": "Cork",
    "rollNumber": "15646J",
    "schoolName": "Coomhola NS",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "P75W984",
    "addressOne": "Cooryleary",
    "addressTwo": "Bantry",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.7429145",
    "lng": "-9.448793",
    "phone": "2751173",
    "email": "principal@coomholans.ie"
  },
  {
    "i": "361",
    "county": "Cork",
    "rollNumber": "15701O",
    "schoolName": "Bartlemy NS",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "P61P761",
    "addressOne": "Rathcormac",
    "addressTwo": "Fermoy",
    "addressThree": "Co Cork",
    "addressFour": "",
    "lat": "52.047233",
    "lng": "-8.2651962",
    "phone": "2536121",
    "email": "bobrienns@gmail.com"
  },
  {
    "i": "362",
    "county": "Cork",
    "rollNumber": "15718I",
    "schoolName": "SN Seosamh Cobh",
    "SETHours": "172.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "4.25",
    "spSNA": "2.5",
    "totalSNA": "6.75",
    "eircode": "P24P270",
    "addressOne": "Cobh",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.8546559",
    "lng": "-8.2924936",
    "phone": "214812424",
    "email": "scoiliosaefias@gmail.com"
  },
  {
    "i": "363",
    "county": "Cork",
    "rollNumber": "15781P",
    "schoolName": "Ballintemple NS",
    "SETHours": "97.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "T12WA02",
    "addressOne": "Ballintemple NS",
    "addressTwo": "Crab Lane",
    "addressThree": "Cork",
    "addressFour": "",
    "lat": "51.8931341",
    "lng": "-8.4396624",
    "phone": "214293608",
    "email": "oifig@ballintemplens.com"
  },
  {
    "i": "364",
    "county": "Cork",
    "rollNumber": "15792U",
    "schoolName": "Upper Glanmire NS",
    "SETHours": "125",
    "spClassTeachingPosts": "1",
    "mainSNA": "3.33",
    "spSNA": "2",
    "totalSNA": "5.33",
    "eircode": "T23AE00",
    "addressOne": "Ballinvriskig",
    "addressTwo": "White's Cross",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.9510644",
    "lng": "-8.430522",
    "phone": "214308885",
    "email": "ugns.principal@gmail.com"
  },
  {
    "i": "365",
    "county": "Cork",
    "rollNumber": "15903D",
    "schoolName": "Killavullen NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "P51AP92",
    "addressOne": "Killavullen",
    "addressTwo": "Mallow",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.1458427",
    "lng": "-8.5161955",
    "phone": "2226368",
    "email": "killavullenns@gmail.com"
  },
  {
    "i": "366",
    "county": "Cork",
    "rollNumber": "16087E",
    "schoolName": "Kealkil NS",
    "SETHours": "60",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "P75FF21",
    "addressOne": "Bantry",
    "addressTwo": "Co Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.7487639",
    "lng": "-9.3778168",
    "phone": "2766298",
    "email": "info@kealkillns.ie"
  },
  {
    "i": "367",
    "county": "Cork",
    "rollNumber": "16109L",
    "schoolName": "Scoil Realt Na Mara",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "P25RX22",
    "addressOne": "Ballycotton",
    "addressTwo": "Midleton",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.8305617",
    "lng": "-8.0160851",
    "phone": "214646068",
    "email": "scoilrealtnamara@gmail.com"
  },
  {
    "i": "368",
    "county": "Cork",
    "rollNumber": "16128P",
    "schoolName": "Bunscoil Na Toirbhirte",
    "SETHours": "125",
    "spClassTeachingPosts": "1",
    "mainSNA": "4.49",
    "spSNA": "1.66",
    "totalSNA": "6.15",
    "eircode": "P67FE82",
    "addressOne": "Church Road",
    "addressTwo": "Mitchelstown",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.2655589",
    "lng": "-8.2660143",
    "phone": "2524264",
    "email": "officebunscoil@gmail.com"
  },
  {
    "i": "369",
    "county": "Cork",
    "rollNumber": "16159D",
    "schoolName": "Convent Girls Sn NS",
    "SETHours": "100",
    "spClassTeachingPosts": "4",
    "mainSNA": "1.84",
    "spSNA": "7.66",
    "totalSNA": "9.5",
    "eircode": "P51D958",
    "addressOne": "Mallow",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.1431908",
    "lng": "-8.6427339",
    "phone": "2242211",
    "email": "conventpsmallow@eircom.net"
  },
  {
    "i": "370",
    "county": "Cork",
    "rollNumber": "16246V",
    "schoolName": "Drumclugh NS",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "P75VA47",
    "addressOne": "Bantry",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.7153631",
    "lng": "-9.3515299",
    "phone": "2750868",
    "email": "dromclough@gmail.com"
  },
  {
    "i": "371",
    "county": "Cork",
    "rollNumber": "16259H",
    "schoolName": "Kilcolman NS",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "P47X526",
    "addressOne": "Kilcolman",
    "addressTwo": "Enniskeane",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.7221283",
    "lng": "-8.8547641",
    "phone": "238839460",
    "email": "kilcolmanns@gmail.com"
  },
  {
    "i": "372",
    "county": "Cork",
    "rollNumber": "16271U",
    "schoolName": "Watergrasshill NS",
    "SETHours": "160",
    "spClassTeachingPosts": "1",
    "mainSNA": "6.25",
    "spSNA": "2",
    "totalSNA": "8.25",
    "eircode": "T56EW80",
    "addressOne": "Watergrasshill",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.0091081",
    "lng": "-8.342318",
    "phone": "214889163",
    "email": "office@watergrasshillns.ie"
  },
  {
    "i": "373",
    "county": "Cork",
    "rollNumber": "16286K",
    "schoolName": "Carrigboy NS",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "P75FH76",
    "addressOne": "Durrus",
    "addressTwo": "Bantry",
    "addressThree": "Co Cork",
    "addressFour": "",
    "lat": "51.6222738",
    "lng": "-9.523612",
    "phone": "2761399",
    "email": "carrigboyns.ias@eircom.net"
  },
  {
    "i": "374",
    "county": "Cork",
    "rollNumber": "16335U",
    "schoolName": "Rylane NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "P32FD99",
    "addressOne": "Rylane",
    "addressTwo": "Co Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.9805303",
    "lng": "-8.8374256",
    "phone": "217339143",
    "email": "rylanens3@gmail.com"
  },
  {
    "i": "375",
    "county": "Cork",
    "rollNumber": "16339F",
    "schoolName": "SN Iosef Naofa",
    "SETHours": "75",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.75",
    "spSNA": "0",
    "totalSNA": "2.75",
    "eircode": "T12YY07",
    "addressOne": "Mardyke Walk",
    "addressTwo": "Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.8969516",
    "lng": "-8.4873124",
    "phone": "214274549",
    "email": "infojoes@gmail.com"
  },
  {
    "i": "376",
    "county": "Cork",
    "rollNumber": "16377N",
    "schoolName": "St Marys NS",
    "SETHours": "132.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "P24FR98",
    "addressOne": "Orilia Terrace,",
    "addressTwo": "Cobh",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.8546049",
    "lng": "-8.2951152",
    "phone": "214812038",
    "email": "office@stmarysnscobh.com"
  },
  {
    "i": "377",
    "county": "Cork",
    "rollNumber": "16396R",
    "schoolName": "Boherbue NS",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "P51RY99",
    "addressOne": "Boherbue",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.1584031",
    "lng": "-9.0717146",
    "phone": "879644553",
    "email": "office@boherbuens.ie"
  },
  {
    "i": "378",
    "county": "Cork",
    "rollNumber": "16648S",
    "schoolName": "Ath Treasna GNS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "P51KW83",
    "addressOne": "Poundhill",
    "addressTwo": "Newmarket",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.2136982",
    "lng": "-8.9900703",
    "phone": "2960723",
    "email": "gnsnewmarket@eircom.net"
  },
  {
    "i": "379",
    "county": "Cork",
    "rollNumber": "16680O",
    "schoolName": "Scoil Colmcille",
    "SETHours": "212.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "4",
    "spSNA": "1.83",
    "totalSNA": "5.83",
    "eircode": "T23H968",
    "addressOne": "Blarney Street",
    "addressTwo": "Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.9014344",
    "lng": "-8.4831347",
    "phone": "214397000",
    "email": "office@blarneystreet.com"
  },
  {
    "i": "380",
    "county": "Cork",
    "rollNumber": "16681Q",
    "schoolName": "Scoil Na Mbraithre Boys Snr Sch",
    "SETHours": "117.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "5.25",
    "spSNA": "5",
    "totalSNA": "10.25",
    "eircode": "P56FX51",
    "addressOne": "Baker's Road",
    "addressTwo": "Charleville",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.354943",
    "lng": "-8.6795426",
    "phone": "6389544",
    "email": "office@charlevillecbsprimary.ie"
  },
  {
    "i": "381",
    "county": "Cork",
    "rollNumber": "16683U",
    "schoolName": "Bishop Murphy Memorial Boys Sn NS",
    "SETHours": "72.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "3.25",
    "spSNA": "4",
    "totalSNA": "7.25",
    "eircode": "P61XN80",
    "addressOne": "Mccurtain Street",
    "addressTwo": "Fermoy",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.1374823",
    "lng": "-8.2796099",
    "phone": "2531116",
    "email": "principal@bishopmurphyschool.com"
  },
  {
    "i": "382",
    "county": "Cork",
    "rollNumber": "16684W",
    "schoolName": "Scoil Na Mbraithre Boys Sn School",
    "SETHours": "135",
    "spClassTeachingPosts": "3",
    "mainSNA": "4",
    "spSNA": "7",
    "totalSNA": "11",
    "eircode": "P25EK13",
    "addressOne": "Rosary Place",
    "addressTwo": "Midleton",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.9084586",
    "lng": "-8.170187",
    "phone": "214631419",
    "email": "office@midletoncbsprimary.ie"
  },
  {
    "i": "383",
    "county": "Cork",
    "rollNumber": "16746S",
    "schoolName": "Ballygarvan NS",
    "SETHours": "167.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "7.33",
    "spSNA": "0",
    "totalSNA": "7.33",
    "eircode": "T12RY1T",
    "addressOne": "School Road",
    "addressTwo": "Ballygarvan",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.8236744",
    "lng": "-8.4601559",
    "phone": "214888390",
    "email": "school@ballygarvanns.com"
  },
  {
    "i": "385",
    "county": "Cork",
    "rollNumber": "16876I",
    "schoolName": "SN Caipin",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "P47YF43",
    "addressOne": "Coppeen",
    "addressTwo": "Enniskeane",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.7934099",
    "lng": "-8.9917885",
    "phone": "238847089",
    "email": "sncaipin@eircom.net"
  },
  {
    "i": "386",
    "county": "Cork",
    "rollNumber": "16885J",
    "schoolName": "Adrigole NS",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "P75EC64",
    "addressOne": "Adrigole",
    "addressTwo": "Bantry",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.6956554",
    "lng": "-9.7206905",
    "phone": "2760118",
    "email": "fiachnanaofa.ias@eircom.net"
  },
  {
    "i": "387",
    "county": "Cork",
    "rollNumber": "16940O",
    "schoolName": "Dundar Mhuighe NS",
    "SETHours": "77.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.25",
    "spSNA": "0",
    "totalSNA": "3.25",
    "eircode": "P17K504",
    "addressOne": "Dunderrow",
    "addressTwo": "Kinsale",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.7274453",
    "lng": "-8.5938087",
    "phone": "214774041",
    "email": "info@dunderrow.ie"
  },
  {
    "i": "388",
    "county": "Cork",
    "rollNumber": "16945B",
    "schoolName": "Lisgriffin NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "P51T685",
    "addressOne": "Buttevant",
    "addressTwo": "Co Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.2217864",
    "lng": "-8.7443683",
    "phone": "2223855",
    "email": "lisgriffinns@gmail.com"
  },
  {
    "i": "389",
    "county": "Cork",
    "rollNumber": "16955E",
    "schoolName": "SN Na Mona Fliche",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.75",
    "spSNA": "0",
    "totalSNA": "1.75",
    "eircode": "P12YH56",
    "addressOne": "Macroom",
    "addressTwo": "Co Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.9680886",
    "lng": "-8.9826791",
    "phone": "2644077",
    "email": "info@muinefliuchns.scoilnet.ie"
  },
  {
    "i": "390",
    "county": "Cork",
    "rollNumber": "17011W",
    "schoolName": "Mocomhog NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "P75RX97",
    "addressOne": "Cappabue",
    "addressTwo": "Kealkill",
    "addressThree": "Bantry",
    "addressFour": "Co. Cork",
    "lat": "51.7843027",
    "lng": "-9.3088919",
    "phone": "2766256",
    "email": "cappabuens@gmail.com"
  },
  {
    "i": "391",
    "county": "Cork",
    "rollNumber": "17024I",
    "schoolName": "Scoil Na Croise Naofa",
    "SETHours": "178",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.83",
    "spSNA": "0",
    "totalSNA": "5.83",
    "eircode": "T12R252",
    "addressOne": "Avenue De Rennes",
    "addressTwo": "Mahon",
    "addressThree": "Cork",
    "addressFour": "",
    "lat": "51.894357",
    "lng": "-8.4019863",
    "phone": "214357852",
    "email": "info@holycrosscork.ie"
  },
  {
    "i": "392",
    "county": "Cork",
    "rollNumber": "17045Q",
    "schoolName": "St Patricks BNS",
    "SETHours": "220",
    "spClassTeachingPosts": "0",
    "mainSNA": "6",
    "spSNA": "0",
    "totalSNA": "6",
    "eircode": "T23AX20",
    "addressOne": "Gardiner's Hill",
    "addressTwo": "Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.9075662",
    "lng": "-8.4546846",
    "phone": "214502024",
    "email": "stpatricksboysschool@gmail.com"
  },
  {
    "i": "393",
    "county": "Cork",
    "rollNumber": "17050J",
    "schoolName": "SN Naomh Sheamuis",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "P75C429",
    "addressOne": "Durrus",
    "addressTwo": "Bantry",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.6221972",
    "lng": "-9.5346192",
    "phone": "2761330",
    "email": "stjamesdurrus.ias@eircom.net"
  },
  {
    "i": "394",
    "county": "Cork",
    "rollNumber": "17079K",
    "schoolName": "SN Carraig An Ime",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "P12DW92",
    "addressOne": "Carriganima,",
    "addressTwo": "Macroom,",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.9785782",
    "lng": "-9.0408409",
    "phone": "2644107",
    "email": "carriganima.ias@eircom.net"
  },
  {
    "i": "396",
    "county": "Cork",
    "rollNumber": "17103E",
    "schoolName": "Scoil Chlochair Mhuire NS",
    "SETHours": "145",
    "spClassTeachingPosts": "2",
    "mainSNA": "5.16",
    "spSNA": "3.32",
    "totalSNA": "8.48",
    "eircode": "T45VX82",
    "addressOne": "Carrigtwohill",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.9098745",
    "lng": "-8.2584548",
    "phone": "214883293",
    "email": "scoilchm.ias@eircom.net"
  },
  {
    "i": "397",
    "county": "Cork",
    "rollNumber": "17105I",
    "schoolName": "Muire Gan Smal C",
    "SETHours": "122.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "4.08",
    "spSNA": "2",
    "totalSNA": "6.08",
    "eircode": "T12V084",
    "addressOne": "School Avenue",
    "addressTwo": "Glasheen Road",
    "addressThree": "Cork",
    "addressFour": "",
    "lat": "51.8869031",
    "lng": "-8.4987233",
    "phone": "214542294",
    "email": "gnsoffice@eircom.net"
  },
  {
    "i": "398",
    "county": "Cork",
    "rollNumber": "17112F",
    "schoolName": "Ballyhea NS",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "P56KA44",
    "addressOne": "Ballyhea",
    "addressTwo": "Rathluirc",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.308612",
    "lng": "-8.6640323",
    "phone": "6381086",
    "email": "Ballyhea.ias@gmail.com"
  },
  {
    "i": "399",
    "county": "Cork",
    "rollNumber": "17152R",
    "schoolName": "SN Cnoc Sceach",
    "SETHours": "130",
    "spClassTeachingPosts": "3",
    "mainSNA": "4.58",
    "spSNA": "6.49",
    "totalSNA": "11.07",
    "eircode": "P85AV90",
    "addressOne": "Knockskeagh",
    "addressTwo": "Clonakilty",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.664888",
    "lng": "-8.9285685",
    "phone": "238838070",
    "email": "cnocsceachns@gmail.com"
  },
  {
    "i": "400",
    "county": "Cork",
    "rollNumber": "17156C",
    "schoolName": "Scoil Naomh Aine Girls Sn School",
    "SETHours": "92.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.25",
    "spSNA": "0",
    "totalSNA": "2.25",
    "eircode": "P56AH79",
    "addressOne": "Smith's Road",
    "addressTwo": "Charleville",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.3549853",
    "lng": "-8.6856965",
    "phone": "6389451",
    "email": "stannescharleville@hotmail.com"
  },
  {
    "i": "401",
    "county": "Cork",
    "rollNumber": "17168J",
    "schoolName": "SN Inis Eoghanain",
    "SETHours": "110",
    "spClassTeachingPosts": "1",
    "mainSNA": "3.83",
    "spSNA": "1.83",
    "totalSNA": "5.66",
    "eircode": "T12PX94",
    "addressOne": "Scoil Eoin",
    "addressTwo": "Inis Eonáin",
    "addressThree": "Co.chorcaí­",
    "addressFour": "",
    "lat": "51.7668582",
    "lng": "-8.6571163",
    "phone": "214775457",
    "email": "inisheoin@gmail.com"
  },
  {
    "i": "402",
    "county": "Cork",
    "rollNumber": "17171V",
    "schoolName": "SN Cuilinn Ui Caoimh",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "P51TK70",
    "addressOne": "Mullaghroe",
    "addressTwo": "Cullen",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.1183871",
    "lng": "-9.1274155",
    "phone": "2979201",
    "email": "cullennats.ias@eircom.net"
  },
  {
    "i": "403",
    "county": "Cork",
    "rollNumber": "17245B",
    "schoolName": "Dripsey NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "1.5",
    "spSNA": "1.66",
    "totalSNA": "3.16",
    "eircode": "P12HE64",
    "addressOne": "Dripsey",
    "addressTwo": "Co Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.9133618",
    "lng": "-8.719764",
    "phone": "217334415",
    "email": "office@dripseyns.ie"
  },
  {
    "i": "404",
    "county": "Cork",
    "rollNumber": "17251T",
    "schoolName": "Ovens NS",
    "SETHours": "147.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.5",
    "spSNA": "0",
    "totalSNA": "4.5",
    "eircode": "P31EP63",
    "addressOne": "Knockanemore",
    "addressTwo": "Ovens",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.8757338",
    "lng": "-8.6662856",
    "phone": "214872531",
    "email": "ovensnationalschool@gmail.com"
  },
  {
    "i": "405",
    "county": "Cork",
    "rollNumber": "17281F",
    "schoolName": "Togher NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "P47D628",
    "addressOne": "Togher",
    "addressTwo": "Dunmanway",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.7676184",
    "lng": "-9.1564116",
    "phone": "238855322",
    "email": "togherns@gmail.com"
  },
  {
    "i": "406",
    "county": "Cork",
    "rollNumber": "17297U",
    "schoolName": "SN Fearghail Naofa",
    "SETHours": "110",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "P36CP74",
    "addressOne": "Main Street",
    "addressTwo": "Killeagh",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.9402838",
    "lng": "-7.9954487",
    "phone": "2495250",
    "email": "linda.bashford@stfergals.ie"
  },
  {
    "i": "407",
    "county": "Cork",
    "rollNumber": "17300G",
    "schoolName": "Lios Maighir",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.75",
    "spSNA": "0",
    "totalSNA": "1.75",
    "eircode": "P51R156",
    "addressOne": "Lismire",
    "addressTwo": "Newmarket",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.2286555",
    "lng": "-8.9428143",
    "phone": "2960531",
    "email": "lismireschool.ias@eircom.net"
  },
  {
    "i": "408",
    "county": "Cork",
    "rollNumber": "17313P",
    "schoolName": "Our Lady Of Lourdes",
    "SETHours": "60",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.25",
    "spSNA": "0",
    "totalSNA": "2.25",
    "eircode": "T12RR98",
    "addressOne": "Ballinlough Road",
    "addressTwo": "Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.8898649",
    "lng": "-8.4547909",
    "phone": "214963616",
    "email": "info@ourladyoflourdesns.com"
  },
  {
    "i": "409",
    "county": "Cork",
    "rollNumber": "17323S",
    "schoolName": "Monkstown NS",
    "SETHours": "75",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.5",
    "spSNA": "0",
    "totalSNA": "3.5",
    "eircode": "T12RX23",
    "addressOne": "Chapel Hill",
    "addressTwo": "Monkstown",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.8491666",
    "lng": "-8.3342784",
    "phone": "214842159",
    "email": "info@scoilbarranaofa.ie"
  },
  {
    "i": "410",
    "county": "Cork",
    "rollNumber": "17324U",
    "schoolName": "Scoil Naomh Breandan",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "P51A562",
    "addressOne": "Hollymount",
    "addressTwo": "Rathmore",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.0634891",
    "lng": "-9.2080278",
    "phone": "647758269",
    "email": "hollymountns@gmail.com"
  },
  {
    "i": "411",
    "county": "Cork",
    "rollNumber": "17338I",
    "schoolName": "SN Cill Bonain",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "P31WK25",
    "addressOne": "Knocknahilan",
    "addressTwo": "Aherla",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.8401097",
    "lng": "-8.7283277",
    "phone": "217331730",
    "email": "kilbonaneprincipal@gmail.com"
  },
  {
    "i": "412",
    "county": "Cork",
    "rollNumber": "17360B",
    "schoolName": "SN Mhuire",
    "SETHours": "130",
    "spClassTeachingPosts": "0",
    "mainSNA": "7.33",
    "spSNA": "0",
    "totalSNA": "7.33",
    "eircode": "T23F799",
    "addressOne": "Rathpeacon",
    "addressTwo": "Mallow Road",
    "addressThree": "Cork",
    "addressFour": "",
    "lat": "51.936846",
    "lng": "-8.4989152",
    "phone": "214394265",
    "email": "office.rathpeaconns@gmail.com"
  },
  {
    "i": "413",
    "county": "Cork",
    "rollNumber": "17362F",
    "schoolName": "SN Breandan Naofa",
    "SETHours": "55",
    "spClassTeachingPosts": "2",
    "mainSNA": "2.83",
    "spSNA": "2.83",
    "totalSNA": "5.66",
    "eircode": "P51A038",
    "addressOne": "Rathcoole",
    "addressTwo": "Mallow",
    "addressThree": "Co Cork",
    "addressFour": "",
    "lat": "52.0941818",
    "lng": "-8.9734061",
    "phone": "2958410",
    "email": "stbrendansrathcoole@gmail.com"
  },
  {
    "i": "414",
    "county": "Cork",
    "rollNumber": "17363H",
    "schoolName": "Sn Cros Tseain",
    "SETHours": "95",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "P43W993",
    "addressOne": "Crosshaven Boy's Ns",
    "addressTwo": "Crosshaven",
    "addressThree": "Cork",
    "addressFour": "",
    "lat": "51.8032603",
    "lng": "-8.3013469",
    "phone": "214831681",
    "email": "info@crosshavenbns.com"
  },
  {
    "i": "415",
    "county": "Cork",
    "rollNumber": "17505B",
    "schoolName": "SN Cill Ruadhain",
    "SETHours": "152.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "5.83",
    "spSNA": "2",
    "totalSNA": "7.83",
    "eircode": "T45CA19",
    "addressOne": "Glanmire",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.9304747",
    "lng": "-8.3820329",
    "phone": "214866044",
    "email": "scr@brooklodgens.net"
  },
  {
    "i": "416",
    "county": "Cork",
    "rollNumber": "17515E",
    "schoolName": "SN Achadh Bolg",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "P12P406",
    "addressOne": "Aghabullogue",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.9446628",
    "lng": "-8.8076165",
    "phone": "217334727",
    "email": "office@aghabulloguens.com"
  },
  {
    "i": "417",
    "county": "Cork",
    "rollNumber": "17527L",
    "schoolName": "Scoil Bhrugh Thuinne",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "P51KN79",
    "addressOne": "Churchtown",
    "addressTwo": "Mallow",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.2688508",
    "lng": "-8.7301058",
    "phone": "2223656",
    "email": "churchtownns@gmail.com"
  },
  {
    "i": "418",
    "county": "Cork",
    "rollNumber": "17528N",
    "schoolName": "SN Naomh Caitriona",
    "SETHours": "77.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "P51EY05",
    "addressOne": "Conna",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.0965557",
    "lng": "-8.1191087",
    "phone": "5859440",
    "email": "office@connans.com"
  },
  {
    "i": "419",
    "county": "Cork",
    "rollNumber": "17533G",
    "schoolName": "SN Rathain",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "P51DP79",
    "addressOne": "Mallow",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.1257777",
    "lng": "-8.592766",
    "phone": "2222901",
    "email": "office@rahanns.org"
  },
  {
    "i": "420",
    "county": "Cork",
    "rollNumber": "17579H",
    "schoolName": "SN Ath Fhada",
    "SETHours": "155.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "7",
    "spSNA": "3.49",
    "totalSNA": "10.49",
    "eircode": "P25X922",
    "addressOne": "Aghada",
    "addressTwo": "Midleton",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.8378903",
    "lng": "-8.2071886",
    "phone": "214661549",
    "email": "info@aghadans.ie"
  },
  {
    "i": "421",
    "county": "Cork",
    "rollNumber": "17600S",
    "schoolName": "SN Na Scairte Leithe",
    "SETHours": "200",
    "spClassTeachingPosts": "5",
    "mainSNA": "9.49",
    "spSNA": "11",
    "totalSNA": "20.49",
    "eircode": "P25K286",
    "addressOne": "Saleen",
    "addressTwo": "Midleton",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.8692617",
    "lng": "-8.1625007",
    "phone": "214652094",
    "email": "secretary@scartleigh.com"
  },
  {
    "i": "422",
    "county": "Cork",
    "rollNumber": "17602W",
    "schoolName": "SN Naomh Lachtin",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "P32PW68",
    "addressOne": "Domhnach Mor",
    "addressTwo": "Co Chorcai",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.9920327",
    "lng": "-8.7527039",
    "phone": "217337248",
    "email": "stlaichtin.ias@eircom.net"
  },
  {
    "i": "423",
    "county": "Cork",
    "rollNumber": "17609N",
    "schoolName": "Rathcormac NS",
    "SETHours": "182.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "6.58",
    "spSNA": "0",
    "totalSNA": "6.58",
    "eircode": "P61ER24",
    "addressOne": "Rathcormac",
    "addressTwo": "Fermoy",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.0779797",
    "lng": "-8.2847515",
    "phone": "2536616",
    "email": "principal@sbrathcormac.ie"
  },
  {
    "i": "424",
    "county": "Cork",
    "rollNumber": "17639W",
    "schoolName": "Scoil Na Mbraithre",
    "SETHours": "175",
    "spClassTeachingPosts": "1",
    "mainSNA": "8.75",
    "spSNA": "2",
    "totalSNA": "10.75",
    "eircode": "P67FY81",
    "addressOne": "Brigown",
    "addressTwo": "Mitchelstown",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.2631382",
    "lng": "-8.2664422",
    "phone": "2524505",
    "email": "cbsmitchprimoffice@gmail.com"
  },
  {
    "i": "425",
    "county": "Cork",
    "rollNumber": "17667E",
    "schoolName": "SN Padraig Naofa",
    "SETHours": "132.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "6.33",
    "spSNA": "0",
    "totalSNA": "6.33",
    "eircode": "T34AY74",
    "addressOne": "Farranastig",
    "addressTwo": "Whitechurch",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.9806631",
    "lng": "-8.5313263",
    "phone": "214884326",
    "email": "imelda.desmond@whitechurchns.ie"
  },
  {
    "i": "426",
    "county": "Cork",
    "rollNumber": "17706L",
    "schoolName": "SN An Mhaoilinn",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "P51FH27",
    "addressOne": "Meelin",
    "addressTwo": "Newmarket",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.2651726",
    "lng": "-9.0345312",
    "phone": "2968103",
    "email": "office@meelinns.org"
  },
  {
    "i": "427",
    "county": "Cork",
    "rollNumber": "17715M",
    "schoolName": "SN Rath A Bharraigh",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "P85E542",
    "addressOne": "Clonakilty",
    "addressTwo": "Co Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.5620061",
    "lng": "-8.9459594",
    "phone": "238840651",
    "email": "rathbarryns.ias@eircom.net"
  },
  {
    "i": "428",
    "county": "Cork",
    "rollNumber": "17754W",
    "schoolName": "SN Naomh Eoin B",
    "SETHours": "182.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "5",
    "spSNA": "0",
    "totalSNA": "5",
    "eircode": "P31XW21",
    "addressOne": "Station Road",
    "addressTwo": "Ballincollig",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.8863392",
    "lng": "-8.5905336",
    "phone": "214871321",
    "email": "reception@scoileoin.com"
  },
  {
    "i": "429",
    "county": "Cork",
    "rollNumber": "17755B",
    "schoolName": "Scoil Naomh Mhuire C",
    "SETHours": "115",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.5",
    "spSNA": "0",
    "totalSNA": "3.5",
    "eircode": "P31N265",
    "addressOne": "Ballincollig",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.8865728",
    "lng": "-8.5928992",
    "phone": "214870809",
    "email": "scoilmhuireballincollig@gmail.com"
  },
  {
    "i": "430",
    "county": "Cork",
    "rollNumber": "17761T",
    "schoolName": "SN Mhuire",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "P61KF82",
    "addressOne": "Billeragh",
    "addressTwo": "Araglin",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.2042686",
    "lng": "-8.1674925",
    "phone": "5850513",
    "email": "info@araglinns.ie"
  },
  {
    "i": "431",
    "county": "Cork",
    "rollNumber": "17763A",
    "schoolName": "Rockchapel NS",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "P51YX84",
    "addressOne": "Lyraneag",
    "addressTwo": "Rockchapel",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.2899075",
    "lng": "-9.1407278",
    "phone": "2969129",
    "email": "office@rockchapelns.ie"
  },
  {
    "i": "432",
    "county": "Cork",
    "rollNumber": "17765E",
    "schoolName": "SN Re Na Scrine",
    "SETHours": "0",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.66",
    "spSNA": "0",
    "totalSNA": "1.66",
    "eircode": "P85XE17",
    "addressOne": "Maulyregan",
    "addressTwo": "Rosscarbery",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.6269097",
    "lng": "-9.0525414",
    "phone": "238848000",
    "email": "rnsns@eircom.net"
  },
  {
    "i": "433",
    "county": "Cork",
    "rollNumber": "17790D",
    "schoolName": "Curraghagalla NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "P61AV80",
    "addressOne": "Curraghagalla",
    "addressTwo": "Kilworth",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.2073053",
    "lng": "-8.292952",
    "phone": "2527449",
    "email": "curraghagallans@yahoo.ie"
  },
  {
    "i": "434",
    "county": "Cork",
    "rollNumber": "17794L",
    "schoolName": "SN An Phairc",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "P36CK76",
    "addressOne": "Youghal",
    "addressTwo": "Co Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.9847013",
    "lng": "-7.9420146",
    "phone": "2497282",
    "email": "parkschool.ias@eircom.net"
  },
  {
    "i": "435",
    "county": "Cork",
    "rollNumber": "17804L",
    "schoolName": "SN Cnoc Na Manach",
    "SETHours": "55",
    "spClassTeachingPosts": "2",
    "mainSNA": "1",
    "spSNA": "3.66",
    "totalSNA": "4.66",
    "eircode": "P17RX71",
    "addressOne": "Knocknamanagh",
    "addressTwo": "Minane Bridge",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.762924",
    "lng": "-8.3768289",
    "phone": "214887272",
    "email": "minanebridgens@gmail.com"
  },
  {
    "i": "436",
    "county": "Cork",
    "rollNumber": "17823P",
    "schoolName": "Glantane BNS",
    "SETHours": "80",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "P51PK65",
    "addressOne": "Brittas",
    "addressTwo": "Lombardstown",
    "addressThree": "Mallow",
    "addressFour": "Co. Cork",
    "lat": "52.1086119",
    "lng": "-8.7632743",
    "phone": "2247101",
    "email": "office@glantanens.ie"
  },
  {
    "i": "437",
    "county": "Cork",
    "rollNumber": "17829E",
    "schoolName": "SN Ath An Mhuillinn",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "P56FA00",
    "addressOne": "Kilbolane",
    "addressTwo": "Milford",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.3392592",
    "lng": "-8.8544241",
    "phone": "6380210",
    "email": "kilbolane.n.s@gmail.com"
  },
  {
    "i": "438",
    "county": "Cork",
    "rollNumber": "17848I",
    "schoolName": "SN Mhuire",
    "SETHours": "85",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.75",
    "spSNA": "0",
    "totalSNA": "3.75",
    "eircode": "T56PP79",
    "addressOne": "Glenville",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.0458221",
    "lng": "-8.4242068",
    "phone": "214880261",
    "email": "glenvill@iol.ie"
  },
  {
    "i": "439",
    "county": "Cork",
    "rollNumber": "17868O",
    "schoolName": "Scoil Freastogail Muire",
    "SETHours": "140",
    "spClassTeachingPosts": "5",
    "mainSNA": "6.16",
    "spSNA": "8.98",
    "totalSNA": "15.14",
    "eircode": "P61N562",
    "addressOne": "College Road",
    "addressTwo": "Fermoy",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.1351681",
    "lng": "-8.2738218",
    "phone": "2531550",
    "email": "office@presfermoy.ie"
  },
  {
    "i": "440",
    "county": "Cork",
    "rollNumber": "17887S",
    "schoolName": "SN Naomh Padraig Boys Sn School",
    "SETHours": "145",
    "spClassTeachingPosts": "1",
    "mainSNA": "3.5",
    "spSNA": "2",
    "totalSNA": "5.5",
    "eircode": "P51TD30",
    "addressOne": "New Road",
    "addressTwo": "Mallow",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.1390424",
    "lng": "-8.6412176",
    "phone": "2222368",
    "email": "stpatsmallow@eircom.net"
  },
  {
    "i": "441",
    "county": "Cork",
    "rollNumber": "17921P",
    "schoolName": "SN Moing Na Miol",
    "SETHours": "60",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "P51D409",
    "addressOne": "Clashbee",
    "addressTwo": "Mallow",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.0400239",
    "lng": "-8.7113722",
    "phone": "217333163",
    "email": "bweengns@gmail.com"
  },
  {
    "i": "442",
    "county": "Cork",
    "rollNumber": "17950W",
    "schoolName": "Shanagarry NS",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "P25V599",
    "addressOne": "Shanagarry",
    "addressTwo": "Midleton",
    "addressThree": "Co Cork",
    "addressFour": "",
    "lat": "51.8546425",
    "lng": "-8.0360076",
    "phone": "214646238",
    "email": "shanagarryns@gmail.com"
  },
  {
    "i": "443",
    "county": "Cork",
    "rollNumber": "17955J",
    "schoolName": "Muire Gan Smal",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "P61PW10",
    "addressOne": "Cluain Dilleain",
    "addressTwo": "Fermoy",
    "addressThree": "Co Cork",
    "addressFour": "",
    "lat": "52.1439062",
    "lng": "-8.2230088",
    "phone": "2532863",
    "email": "info@clondulanens.org"
  },
  {
    "i": "444",
    "county": "Cork",
    "rollNumber": "17972J",
    "schoolName": "SN Cill Mhuire B",
    "SETHours": "77.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "2",
    "spSNA": "3.83",
    "totalSNA": "5.83",
    "eircode": "P14R670",
    "addressOne": "Lisardagh",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.8453406",
    "lng": "-8.8807494",
    "phone": "217336324",
    "email": "info@kilmurrynationalschool.ie"
  },
  {
    "i": "445",
    "county": "Cork",
    "rollNumber": "17993R",
    "schoolName": "Scoil Mhuire Gan Smal B",
    "SETHours": "245",
    "spClassTeachingPosts": "1",
    "mainSNA": "10.16",
    "spSNA": "3",
    "totalSNA": "13.16",
    "eircode": "T12V084",
    "addressOne": "School Avenue",
    "addressTwo": "Glasheen Road",
    "addressThree": "Cork",
    "addressFour": "",
    "lat": "51.8869031",
    "lng": "-8.4987233",
    "phone": "214544750",
    "email": "office@glasheenboys.com"
  },
  {
    "i": "446",
    "county": "Cork",
    "rollNumber": "18000W",
    "schoolName": "Scoil Mhuire Naofa",
    "SETHours": "220",
    "spClassTeachingPosts": "2",
    "mainSNA": "5.5",
    "spSNA": "3.49",
    "totalSNA": "8.99",
    "eircode": "T45AK65",
    "addressOne": "Carrigtwohill",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.908902",
    "lng": "-8.2634777",
    "phone": "214883271",
    "email": "office@carrigtwohill.com"
  },
  {
    "i": "447",
    "county": "Cork",
    "rollNumber": "18020F",
    "schoolName": "SN An Gharrain",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "T12C799",
    "addressOne": "Gurranes",
    "addressTwo": "Innishannon",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.8323085",
    "lng": "-8.6566099",
    "phone": "217331481",
    "email": "gurrane1.ias@eircom.net"
  },
  {
    "i": "448",
    "county": "Cork",
    "rollNumber": "18128C",
    "schoolName": "SN Mhuire Mxd",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "P51X478",
    "addressOne": "Kiskeam",
    "addressTwo": "Mallow",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.1765891",
    "lng": "-9.1622037",
    "phone": "2976456",
    "email": "info@scoilmhuirekiskeam.ie"
  },
  {
    "i": "449",
    "county": "Cork",
    "rollNumber": "18153B",
    "schoolName": "SN Padraig Naofa C",
    "SETHours": "97.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "T23VAD9",
    "addressOne": "Gardiner's Hill",
    "addressTwo": "Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.9083032",
    "lng": "-8.4545283",
    "phone": "214509246",
    "email": "office@stpatricksgirls.net"
  },
  {
    "i": "450",
    "county": "Cork",
    "rollNumber": "18154D",
    "schoolName": "SN Padraig Naofa",
    "SETHours": "60",
    "spClassTeachingPosts": "2",
    "mainSNA": "3.82",
    "spSNA": "3.32",
    "totalSNA": "7.14",
    "eircode": "T23AX20",
    "addressOne": "Dillon's Cross",
    "addressTwo": "Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.9075662",
    "lng": "-8.4546846",
    "phone": "214551593",
    "email": "stpinfants@eircom.net"
  },
  {
    "i": "451",
    "county": "Cork",
    "rollNumber": "18196T",
    "schoolName": "St Patrick's NS",
    "SETHours": "95",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.33",
    "spSNA": "0",
    "totalSNA": "3.33",
    "eircode": "P51DP04",
    "addressOne": "Boherash",
    "addressTwo": "Glanworth",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.1923814",
    "lng": "-8.3583749",
    "phone": "2538404",
    "email": "stpatricksnsglanworth@gmail.com"
  },
  {
    "i": "452",
    "county": "Cork",
    "rollNumber": "18217B",
    "schoolName": "Scoil Padre Pio NS",
    "SETHours": "290",
    "spClassTeachingPosts": "5",
    "mainSNA": "7.66",
    "spSNA": "9.32",
    "totalSNA": "16.98",
    "eircode": "T23DH24",
    "addressOne": "Churchfield Terrace West",
    "addressTwo": "Churchfield",
    "addressThree": "Cork",
    "addressFour": "",
    "lat": "51.9070851",
    "lng": "-8.4921628",
    "phone": "214302045",
    "email": "scoilpadrepio1@eircom.net"
  },
  {
    "i": "453",
    "county": "Cork",
    "rollNumber": "18246I",
    "schoolName": "SN Baile Muine",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "P47NW40",
    "addressOne": "Ballymoney",
    "addressTwo": "Ballineen",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.7326248",
    "lng": "-8.9515322",
    "phone": "238847583",
    "email": "ballymoneyns.ias@gmail.com"
  },
  {
    "i": "454",
    "county": "Cork",
    "rollNumber": "18253F",
    "schoolName": "Scoil Naomh Caitriona",
    "SETHours": "120",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "T12TF74",
    "addressOne": "Bishopstown Avenue",
    "addressTwo": "Model Farm Road",
    "addressThree": "Cork",
    "addressFour": "",
    "lat": "51.886685",
    "lng": "-8.5161235",
    "phone": "214546868",
    "email": "stcathns@gmail.com"
  },
  {
    "i": "455",
    "county": "Cork",
    "rollNumber": "18266O",
    "schoolName": "Ballygown Ns",
    "SETHours": "60",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.25",
    "spSNA": "0",
    "totalSNA": "3.25",
    "eircode": "P51FK18",
    "addressOne": "Castletownroche",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.1919525",
    "lng": "-8.5196865",
    "phone": "2226611",
    "email": "ballygownschool2@gmail.com"
  },
  {
    "i": "456",
    "county": "Cork",
    "rollNumber": "18279A",
    "schoolName": "St Mary's Church Of Ireland N.s",
    "SETHours": "77.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "2.5",
    "spSNA": "4",
    "totalSNA": "6.5",
    "eircode": "P43V243",
    "addressOne": "Waterpark",
    "addressTwo": "Carrigaline",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.8193339",
    "lng": "-8.3854643",
    "phone": "214371995",
    "email": "carrigalinens@eircom.net"
  },
  {
    "i": "457",
    "county": "Cork",
    "rollNumber": "18292P",
    "schoolName": "Gaelscoil An Teaghlaigh Naofa",
    "SETHours": "87.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.5",
    "spSNA": "0",
    "totalSNA": "3.5",
    "eircode": "T12K039",
    "addressOne": "Tory Top Road",
    "addressTwo": "Ballyphehane",
    "addressThree": "Cork",
    "addressFour": "",
    "lat": "51.8834321",
    "lng": "-8.4754115",
    "phone": "214311473",
    "email": "teaghlaighnaofa@gmail.com"
  },
  {
    "i": "458",
    "county": "Cork",
    "rollNumber": "18296A",
    "schoolName": "Dromdhallagh NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "P47V072",
    "addressOne": "Drimoleague",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.6625593",
    "lng": "-9.2606111",
    "phone": "2831854",
    "email": "drimoleaguens.ias@eircom.net"
  },
  {
    "i": "459",
    "county": "Cork",
    "rollNumber": "18301N",
    "schoolName": "Sn Mhuire BNS",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "P51H278",
    "addressOne": "Killarney Road",
    "addressTwo": "Millstreet",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.0601019",
    "lng": "-9.0681734",
    "phone": "2970776",
    "email": "bnsmillstreet@gmail.com"
  },
  {
    "i": "460",
    "county": "Cork",
    "rollNumber": "18316D",
    "schoolName": "SN Fhursa",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "P51D2HY",
    "addressOne": "Lyre",
    "addressTwo": "Banteer",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.0811079",
    "lng": "-8.8589869",
    "phone": "2958384",
    "email": "scoilfhursalyre@yahoo.ie"
  },
  {
    "i": "461",
    "county": "Cork",
    "rollNumber": "18356P",
    "schoolName": "SN Barra Naofa",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.58",
    "spSNA": "0",
    "totalSNA": "2.58",
    "eircode": "T12CH96",
    "addressOne": "Gilabbey Terrace",
    "addressTwo": "Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.8945284",
    "lng": "-8.4844542",
    "phone": "214314009",
    "email": "stfinbarresns@gmail.com"
  },
  {
    "i": "462",
    "county": "Cork",
    "rollNumber": "18377A",
    "schoolName": "Iosef Naofa",
    "SETHours": "97.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "2.75",
    "spSNA": "2",
    "totalSNA": "4.75",
    "eircode": "P61YR82",
    "addressOne": "Barrack Hill",
    "addressTwo": "St. Bernard's Place",
    "addressThree": "Fermoy",
    "addressFour": "",
    "lat": "52.1446802",
    "lng": "-8.2802327",
    "phone": "2532284",
    "email": "stjosephsnsfermoy@gmail.com"
  },
  {
    "i": "463",
    "county": "Cork",
    "rollNumber": "18388F",
    "schoolName": "Scoil Naomh Micheal",
    "SETHours": "25",
    "spClassTeachingPosts": "1",
    "mainSNA": "0.83",
    "spSNA": "1.66",
    "totalSNA": "2.49",
    "eircode": "T12E620",
    "addressOne": "Church Road",
    "addressTwo": "Blackrock",
    "addressThree": "Cork",
    "addressFour": "",
    "lat": "51.8957366",
    "lng": "-8.4200767",
    "phone": "214358140",
    "email": "stmichaelsblackrock@gmail.com"
  },
  {
    "i": "464",
    "county": "Cork",
    "rollNumber": "18422C",
    "schoolName": "Scoil Na Nog",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "T45RW94",
    "addressOne": "Gleann Maghair",
    "addressTwo": "Co Chorcai",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.9189448",
    "lng": "-8.3975428",
    "phone": "214821204",
    "email": "scoilnanog1959@gmail.com"
  },
  {
    "i": "465",
    "county": "Cork",
    "rollNumber": "18428O",
    "schoolName": "SN Baile Nora",
    "SETHours": "105",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "T12D500",
    "addressOne": "Ballynora",
    "addressTwo": "Waterfall",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.8541731",
    "lng": "-8.5654",
    "phone": "214871664",
    "email": "oifig@ballinorans.ie"
  },
  {
    "i": "466",
    "county": "Cork",
    "rollNumber": "18431D",
    "schoolName": "Sn Droichead Na Bandan",
    "SETHours": "102.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "P72HC65",
    "addressOne": "Clancool More",
    "addressTwo": "Bandon",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.7372624",
    "lng": "-8.7450692",
    "phone": "858590506",
    "email": "bandonbridgeoffice@gmail.com"
  },
  {
    "i": "467",
    "county": "Cork",
    "rollNumber": "18444M",
    "schoolName": "SN Clogach",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "P72EP38",
    "addressOne": "Clogagh North",
    "addressTwo": "Timoleague",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.6754106",
    "lng": "-8.7964235",
    "phone": "238839225",
    "email": "snclogach.ias@eircom.net"
  },
  {
    "i": "468",
    "county": "Cork",
    "rollNumber": "18461M",
    "schoolName": "SN Muire Na Doirini",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "P81E023",
    "addressOne": "Dreeny",
    "addressTwo": "Skibbereen",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.6062246",
    "lng": "-9.2648107",
    "phone": "2822683",
    "email": "dreenyns@yahoo.ie"
  },
  {
    "i": "469",
    "county": "Cork",
    "rollNumber": "18468D",
    "schoolName": "Scoil Mhuire",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "P47E735",
    "addressOne": "Castledonovan",
    "addressTwo": "Drimoleague",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.6906319",
    "lng": "-9.2799205",
    "phone": "2831844",
    "email": "castledonovanns@gmail.com"
  },
  {
    "i": "470",
    "county": "Cork",
    "rollNumber": "18472R",
    "schoolName": "Scoil Chaitriona",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "P51YD60",
    "addressOne": "Ballynoe",
    "addressTwo": "Mallow",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.0530261",
    "lng": "-8.1092481",
    "phone": "5859411",
    "email": "nsballynoe@eircom.net"
  },
  {
    "i": "471",
    "county": "Cork",
    "rollNumber": "18475A",
    "schoolName": "SN Baile Ui Chroinin",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "P25TK38",
    "addressOne": "Ballycroneen",
    "addressTwo": "Cloyne",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.8178216",
    "lng": "-8.1202527",
    "phone": "214652181",
    "email": "nspballycroneen@yahoo.ie"
  },
  {
    "i": "472",
    "county": "Cork",
    "rollNumber": "18487H",
    "schoolName": "SN Naomh Mhuire",
    "SETHours": "77.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "3",
    "spSNA": "7",
    "totalSNA": "10",
    "eircode": "P31E443",
    "addressOne": "Fearann",
    "addressTwo": "Ovens",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.8756432",
    "lng": "-8.7390566",
    "phone": "217331623",
    "email": "info@snmfearann.com"
  },
  {
    "i": "473",
    "county": "Cork",
    "rollNumber": "18491V",
    "schoolName": "SN Garran An Easaigh",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "P72YP78",
    "addressOne": "Killbrittain",
    "addressTwo": "Co Cork",
    "addressThree": "P72 Yp78",
    "addressFour": "",
    "lat": "51.6482128",
    "lng": "-8.6412072",
    "phone": "238849700",
    "email": "secretary@gurraneasigns.com"
  },
  {
    "i": "474",
    "county": "Cork",
    "rollNumber": "18497K",
    "schoolName": "Little Island Ns",
    "SETHours": "92.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "T45VA49",
    "addressOne": "Little Island",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.9008532",
    "lng": "-8.3626475",
    "phone": "214354087",
    "email": "info@littleislandns.com"
  },
  {
    "i": "475",
    "county": "Cork",
    "rollNumber": "18549D",
    "schoolName": "SN Cnoc Na Croighe",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "P51YA36",
    "addressOne": "Cnoc Na Groighe",
    "addressTwo": "Mallow",
    "addressThree": "Co Cork",
    "addressFour": "",
    "lat": "52.123808",
    "lng": "-9.2102841",
    "phone": "647756237",
    "email": "knocknagree.ias@eircom.net"
  },
  {
    "i": "476",
    "county": "Cork",
    "rollNumber": "18563U",
    "schoolName": "Scoil Naomh Brid C",
    "SETHours": "132.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.33",
    "spSNA": "0",
    "totalSNA": "3.33",
    "eircode": "T12AK09",
    "addressOne": "Douglas Road",
    "addressTwo": "Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.8831812",
    "lng": "-8.4458944",
    "phone": "214295551",
    "email": "scoilbhrideeglantine@gmail.com"
  },
  {
    "i": "477",
    "county": "Cork",
    "rollNumber": "18566D",
    "schoolName": "SN Athair Maitiu C",
    "SETHours": "140",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "T12T996",
    "addressOne": "Togher",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.8742517",
    "lng": "-8.4967665",
    "phone": "214964923",
    "email": "toghergsoifig@gmail.com"
  },
  {
    "i": "478",
    "county": "Cork",
    "rollNumber": "18567F",
    "schoolName": "SN Inis",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "P36YW81",
    "addressOne": "Ballymakibbot",
    "addressTwo": "Inch",
    "addressThree": "Killeagh",
    "addressFour": "Co. Cork",
    "lat": "51.985924",
    "lng": "-7.991325",
    "phone": "2495490",
    "email": "inchns.school@gmail.com"
  },
  {
    "i": "479",
    "county": "Cork",
    "rollNumber": "18659K",
    "schoolName": "Lisavaird Mxd NS",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.25",
    "spSNA": "0",
    "totalSNA": "1.25",
    "eircode": "P85HK88",
    "addressOne": "Lisavaird",
    "addressTwo": "Clonakilty",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.6000863",
    "lng": "-8.9550257",
    "phone": "238834987",
    "email": "office.lisavairdns@gmail.com"
  },
  {
    "i": "480",
    "county": "Cork",
    "rollNumber": "18713N",
    "schoolName": "SN Fionan Na Reanna",
    "SETHours": "70",
    "spClassTeachingPosts": "2",
    "mainSNA": "2.5",
    "spSNA": "5",
    "totalSNA": "7.5",
    "eircode": "P17A386",
    "addressOne": "Rennies",
    "addressTwo": "Nohoval",
    "addressThree": "Belgooly",
    "addressFour": "Co. Cork",
    "lat": "51.7275707",
    "lng": "-8.3712059",
    "phone": "214887415",
    "email": "scoilrenniesoffice@gmail.com"
  },
  {
    "i": "481",
    "county": "Cork",
    "rollNumber": "18734V",
    "schoolName": "Realt Na Maidine",
    "SETHours": "100",
    "spClassTeachingPosts": "4",
    "mainSNA": "3.5",
    "spSNA": "8.49",
    "totalSNA": "11.99",
    "eircode": "T12R657",
    "addressOne": "Ballyphehane",
    "addressTwo": "Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.8790056",
    "lng": "-8.4792542",
    "phone": "214962696",
    "email": "morningstarcorkoffice@gmail.com"
  },
  {
    "i": "482",
    "county": "Cork",
    "rollNumber": "18786R",
    "schoolName": "Scoil Iosagain",
    "SETHours": "220",
    "spClassTeachingPosts": "1",
    "mainSNA": "6.33",
    "spSNA": "2",
    "totalSNA": "8.33",
    "eircode": "T23EW70",
    "addressOne": "Knockpogue Avenue",
    "addressTwo": "Farranree",
    "addressThree": "Cork",
    "addressFour": "",
    "lat": "51.9107465",
    "lng": "-8.4850235",
    "phone": "214303302",
    "email": "farranreeoffice@gmail.com"
  },
  {
    "i": "483",
    "county": "Cork",
    "rollNumber": "18829J",
    "schoolName": "SN Chobh Chionn Tsaile",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.5",
    "spSNA": "0",
    "totalSNA": "3.5",
    "eircode": "P17HY83",
    "addressOne": "Cionn Tsáile",
    "addressTwo": "Co.chorcaí­.",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.7032305",
    "lng": "-8.5028134",
    "phone": "214774488",
    "email": "info@summercovens.ie"
  },
  {
    "i": "484",
    "county": "Cork",
    "rollNumber": "18883P",
    "schoolName": "SN Iosagain",
    "SETHours": "75",
    "spClassTeachingPosts": "2",
    "mainSNA": "2.49",
    "spSNA": "3.32",
    "totalSNA": "5.81",
    "eircode": "P51TD36",
    "addressOne": "Spa Glen",
    "addressTwo": "Mallow",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.1436671",
    "lng": "-8.6422629",
    "phone": "2242766",
    "email": "scoiliosagainmallow@gmail.com"
  },
  {
    "i": "485",
    "county": "Cork",
    "rollNumber": "19000E",
    "schoolName": "SN An Spioraid Naomh C",
    "SETHours": "90",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "T12RR68",
    "addressOne": "Curraheen Road",
    "addressTwo": "Bishopstown",
    "addressThree": "Cork",
    "addressFour": "",
    "lat": "51.8786822",
    "lng": "-8.5281022",
    "phone": "214543305",
    "email": "admin@bishopstowngirlsschool.ie"
  },
  {
    "i": "486",
    "county": "Cork",
    "rollNumber": "19224D",
    "schoolName": "SN Cillmin",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.33",
    "spSNA": "0",
    "totalSNA": "1.33",
    "eircode": "P85YV21",
    "addressOne": "Rossmore",
    "addressTwo": "Clonakilty",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.6614609",
    "lng": "-9.0084913",
    "phone": "238838795",
    "email": "kilmeenoffice@gmail.com"
  },
  {
    "i": "487",
    "county": "Cork",
    "rollNumber": "19231A",
    "schoolName": "SN Barra Naofa Bhuach",
    "SETHours": "157.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "5.83",
    "spSNA": "4",
    "totalSNA": "9.83",
    "eircode": "T12A564",
    "addressOne": "Beaumont",
    "addressTwo": "Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.8890122",
    "lng": "-8.4284208",
    "phone": "214293387",
    "email": "info@beaumontboys.ie"
  },
  {
    "i": "488",
    "county": "Cork",
    "rollNumber": "19232C",
    "schoolName": "SN Barra Naofa Cailini",
    "SETHours": "100",
    "spClassTeachingPosts": "1",
    "mainSNA": "4.08",
    "spSNA": "2",
    "totalSNA": "6.08",
    "eircode": "T12EK77",
    "addressOne": "Woodvale Road",
    "addressTwo": "Beaumont",
    "addressThree": "Cork",
    "addressFour": "",
    "lat": "51.8894326",
    "lng": "-8.4288074",
    "phone": "214364364",
    "email": "beaumontoffice@gmail.com"
  },
  {
    "i": "489",
    "county": "Cork",
    "rollNumber": "19249T",
    "schoolName": "Barryroe Ns",
    "SETHours": "62.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "2.33",
    "spSNA": "0.5",
    "totalSNA": "2.83",
    "eircode": "P72YE28",
    "addressOne": "Lislevane",
    "addressTwo": "Bandon",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.6086841",
    "lng": "-8.7475569",
    "phone": "238840381",
    "email": "barryroens@gmail.com"
  },
  {
    "i": "490",
    "county": "Cork",
    "rollNumber": "19256Q",
    "schoolName": "Scoil Ghobnatan",
    "SETHours": "325",
    "spClassTeachingPosts": "2",
    "mainSNA": "12.33",
    "spSNA": "1.33",
    "totalSNA": "13.66",
    "eircode": "P51KW86",
    "addressOne": "Bellevue",
    "addressTwo": "Mallow",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.1300956",
    "lng": "-8.646081",
    "phone": "2222192",
    "email": "office@scoilghobnatan.com"
  },
  {
    "i": "491",
    "county": "Cork",
    "rollNumber": "19307H",
    "schoolName": "Derrinagree NS",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "P51PT63",
    "addressOne": "Derrinagree",
    "addressTwo": "Mallow",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.1236892",
    "lng": "-9.0358037",
    "phone": "2978223",
    "email": "office@derinagreens.ie"
  },
  {
    "i": "492",
    "county": "Cork",
    "rollNumber": "19342J",
    "schoolName": "Scoil Naomh Eoin Baiste",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "P51Y223",
    "addressOne": "Kilbrin",
    "addressTwo": "Kanturk",
    "addressThree": "Co Cork",
    "addressFour": "",
    "lat": "52.2107872",
    "lng": "-8.8333296",
    "phone": "2248164",
    "email": "office@kilbrinns.org"
  },
  {
    "i": "493",
    "county": "Cork",
    "rollNumber": "19348V",
    "schoolName": "Newcestown NS",
    "SETHours": "82.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "P72VY04",
    "addressOne": "Newcestown",
    "addressTwo": "Bandon",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.7824754",
    "lng": "-8.8699423",
    "phone": "217338158",
    "email": "secretary@newcestownns.ie"
  },
  {
    "i": "494",
    "county": "Cork",
    "rollNumber": "19351K",
    "schoolName": "SN Cill Criodain",
    "SETHours": "107.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "P25FW50",
    "addressOne": "Kilcredan",
    "addressTwo": "Ladysbridge",
    "addressThree": "Co. Corik",
    "addressFour": "",
    "lat": "51.8880772",
    "lng": "-7.9735247",
    "phone": "2498220",
    "email": "kilcredanoffice@gmail.com"
  },
  {
    "i": "495",
    "county": "Cork",
    "rollNumber": "19381T",
    "schoolName": "Rathmore NS",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "P81PW52",
    "addressOne": "Baltimore",
    "addressTwo": "Skibbereen",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.498566",
    "lng": "-9.3521813",
    "phone": "2820135",
    "email": "rathnationalsc@gmail.com"
  },
  {
    "i": "496",
    "county": "Cork",
    "rollNumber": "19404F",
    "schoolName": "Sn Mhuire",
    "SETHours": "75",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "P51K284",
    "addressOne": "Main Street",
    "addressTwo": "Ballyhooly",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "52.1454011",
    "lng": "-8.3994635",
    "phone": "2539428",
    "email": "principal@scoilmhuireballyhooly.ie"
  },
  {
    "i": "497",
    "county": "Cork",
    "rollNumber": "19415K",
    "schoolName": "Scoil An Athar Tadhg",
    "SETHours": "237.5",
    "spClassTeachingPosts": "5",
    "mainSNA": "9.49",
    "spSNA": "9.49",
    "totalSNA": "18.98",
    "eircode": "T34N276",
    "addressOne": "Carraig Na Bhfear",
    "addressTwo": "Co. Chorcaí­",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.9898996",
    "lng": "-8.4778379",
    "phone": "214884509",
    "email": "secretary@athartadhg.ie"
  },
  {
    "i": "498",
    "county": "Cork",
    "rollNumber": "19420D",
    "schoolName": "Sn Fhiachna",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "P75DY24",
    "addressOne": "Kenmare Road",
    "addressTwo": "Glengarriff",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.7516375",
    "lng": "-9.5538918",
    "phone": "2763596",
    "email": "scoilfhiachna@gmail.com"
  },
  {
    "i": "499",
    "county": "Cork",
    "rollNumber": "19426P",
    "schoolName": "SN Mharcuis B",
    "SETHours": "140",
    "spClassTeachingPosts": "3",
    "mainSNA": "2.83",
    "spSNA": "5.83",
    "totalSNA": "8.66",
    "eircode": "T23P5FY",
    "addressOne": "An Gleann",
    "addressTwo": "Corcaigh",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.9112295",
    "lng": "-8.4577081",
    "phone": "214506225",
    "email": "stmarksbns.ias@eircom.net"
  },
  {
    "i": "500",
    "county": "Cork",
    "rollNumber": "19427R",
    "schoolName": "SN Bhreanndain C",
    "SETHours": "87.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "2",
    "spSNA": "4.98",
    "totalSNA": "6.98",
    "eircode": "T23AK29",
    "addressOne": "Glen Avenue",
    "addressTwo": "Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.9103034",
    "lng": "-8.4646773",
    "phone": "214504877",
    "email": "info@stbrendansgns.ie"
  },
  {
    "i": "501",
    "county": "Cork",
    "rollNumber": "19501D",
    "schoolName": "Cahermore New Central S",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "P75R704",
    "addressOne": "Cahermore",
    "addressTwo": "Allihies",
    "addressThree": "Beara",
    "addressFour": "Co Cork",
    "lat": "51.6057512",
    "lng": "-10.0617692",
    "phone": "2773269",
    "email": "cahermorens1@gmail.com"
  },
  {
    "i": "502",
    "county": "Cork",
    "rollNumber": "19507P",
    "schoolName": "Scoil Chaitigheirn",
    "SETHours": "37.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "2",
    "spSNA": "1",
    "totalSNA": "3",
    "eircode": "P75E516",
    "addressOne": "Eyeries",
    "addressTwo": "Bantry",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.6922378",
    "lng": "-9.9527008",
    "phone": "2774053",
    "email": "eyeriesns@gmail.com"
  },
  {
    "i": "503",
    "county": "Cork",
    "rollNumber": "19525R",
    "schoolName": "Mhichil Naofa",
    "SETHours": "7.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "P75AK22",
    "addressOne": "Derrycreeveen",
    "addressTwo": "Bere Island",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.6356559",
    "lng": "-9.8823484",
    "phone": "2775094",
    "email": "bereislandschool@gmail.com"
  },
  {
    "i": "504",
    "county": "Cork",
    "rollNumber": "19526T",
    "schoolName": "Sn Cill Dairbhre",
    "SETHours": "62.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.08",
    "spSNA": "0",
    "totalSNA": "3.08",
    "eircode": "P67VY68",
    "addressOne": "Fermoy Road",
    "addressTwo": "Kildorrery",
    "addressThree": "Mitchelstown",
    "addressFour": "P67 Vy68",
    "lat": "52.2452585",
    "lng": "-8.4255207",
    "phone": "2225602",
    "email": "kildorreryschool@gmail.com"
  },
  {
    "i": "505",
    "county": "Cork",
    "rollNumber": "19557H",
    "schoolName": "Caheragh Ns",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.75",
    "spSNA": "0",
    "totalSNA": "1.75",
    "eircode": "P47AV25",
    "addressOne": "Caheragh",
    "addressTwo": "Drimoleague",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.6259038",
    "lng": "-9.2999714",
    "phone": "2831647",
    "email": "caheraghns@gmail.com"
  },
  {
    "i": "506",
    "county": "Cork",
    "rollNumber": "19595P",
    "schoolName": "St Marys Central School",
    "SETHours": "75",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "P47NP80",
    "addressOne": "Enniskeane",
    "addressTwo": "Co Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.7371771",
    "lng": "-8.9378838",
    "phone": "238847695",
    "email": "stmarysenniskeane@gmail.com"
  },
  {
    "i": "507",
    "county": "Cork",
    "rollNumber": "19637F",
    "schoolName": "Scoil Fionnbarra",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "P12PC04",
    "addressOne": "Béal átha An Ghaorthaidh",
    "addressTwo": "Co. Chorcaí­",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.8514294",
    "lng": "-9.2296301",
    "phone": "2647133",
    "email": "scoilfhionnbarra@eircom.net"
  },
  {
    "i": "508",
    "county": "Cork",
    "rollNumber": "19672H",
    "schoolName": "Scoil Muire Na Ngrast",
    "SETHours": "150",
    "spClassTeachingPosts": "0",
    "mainSNA": "6",
    "spSNA": "0",
    "totalSNA": "6",
    "eircode": "P17XT32",
    "addressOne": "Lacknacummeen",
    "addressTwo": "Belgooly",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.7444655",
    "lng": "-8.4919048",
    "phone": "214770712",
    "email": "belgoolyns@gmail.com"
  },
  {
    "i": "509",
    "county": "Cork",
    "rollNumber": "19714U",
    "schoolName": "Mhuire Ar Chnoc Haoine",
    "SETHours": "217.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "7.08",
    "spSNA": "2",
    "totalSNA": "9.08",
    "eircode": "T23AH26",
    "addressOne": "Knocknaheeny",
    "addressTwo": "Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.9051964",
    "lng": "-8.5067153",
    "phone": "214392507",
    "email": "smoth.mainoffice@gmail.com"
  },
  {
    "i": "510",
    "county": "Cork",
    "rollNumber": "19730S",
    "schoolName": "Scoil Oilibheir",
    "SETHours": "320",
    "spClassTeachingPosts": "2",
    "mainSNA": "6",
    "spSNA": "5",
    "totalSNA": "11",
    "eircode": "T23XF51",
    "addressOne": "Ballyvolane",
    "addressTwo": "Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.9215752",
    "lng": "-8.4596825",
    "phone": "214309171",
    "email": "info@scoiloilibheir.ie"
  },
  {
    "i": "511",
    "county": "Cork",
    "rollNumber": "19761G",
    "schoolName": "Dungourney Central N Sc",
    "SETHours": "72.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.75",
    "spSNA": "0",
    "totalSNA": "1.75",
    "eircode": "P25Y838",
    "addressOne": "Dungourney",
    "addressTwo": "Co Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.9682224",
    "lng": "-8.0961449",
    "phone": "214668436",
    "email": "dungourney_ns@yahoo.ie"
  },
  {
    "i": "512",
    "county": "Cork",
    "rollNumber": "19771J",
    "schoolName": "Scoil Barra",
    "SETHours": "230",
    "spClassTeachingPosts": "1",
    "mainSNA": "7.5",
    "spSNA": "0.83",
    "totalSNA": "8.33",
    "eircode": "P31H578",
    "addressOne": "Innishmore",
    "addressTwo": "Ballincollig",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.8902466",
    "lng": "-8.6065464",
    "phone": "214873459",
    "email": "info@scoilbarra.ie"
  },
  {
    "i": "513",
    "county": "Cork",
    "rollNumber": "19801P",
    "schoolName": "Drimoleague Jn Sch",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "P47PK50",
    "addressOne": "Drimoleague",
    "addressTwo": "Co Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.6626086",
    "lng": "-9.2613673",
    "phone": "2831101",
    "email": "drimojns1101@gmail.com"
  },
  {
    "i": "514",
    "county": "Cork",
    "rollNumber": "19833F",
    "schoolName": "Gaelscoil Chorain,",
    "SETHours": "110",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.08",
    "spSNA": "0",
    "totalSNA": "4.08",
    "eircode": "P36N263",
    "addressOne": "Sráid Na Trá",
    "addressTwo": "Eochaill",
    "addressThree": "Co. Chorcaí­",
    "addressFour": "",
    "lat": "51.9501167",
    "lng": "-7.8430122",
    "phone": "2493547",
    "email": "runaigsc@eircom.net"
  },
  {
    "i": "515",
    "county": "Cork",
    "rollNumber": "19839R",
    "schoolName": "Gael Scoil Ui Riordain",
    "SETHours": "220",
    "spClassTeachingPosts": "0",
    "mainSNA": "6",
    "spSNA": "0",
    "totalSNA": "6",
    "eircode": "P31V242",
    "addressOne": "Carraig An Earra",
    "addressTwo": "Baile An Chollaigh",
    "addressThree": "Co. Chorcaí­",
    "addressFour": "",
    "lat": "51.8824396",
    "lng": "-8.5782",
    "phone": "214872752",
    "email": "runai@gaelscoiluiriordain.ie"
  },
  {
    "i": "516",
    "county": "Cork",
    "rollNumber": "19851H",
    "schoolName": "Gaelscoil De Hide",
    "SETHours": "152.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.75",
    "spSNA": "0",
    "totalSNA": "4.75",
    "eircode": "P61PF63",
    "addressOne": "Dún Eala",
    "addressTwo": "Dún Teachain",
    "addressThree": "Mainistir Fheatmaí­",
    "addressFour": "Co. Chorcarí­",
    "lat": "52.1301714",
    "lng": "-8.2854599",
    "phone": "2531217",
    "email": "info@gaelscoildehide.com"
  },
  {
    "i": "517",
    "county": "Cork",
    "rollNumber": "19852J",
    "schoolName": "Gaelscoil Ui Riada",
    "SETHours": "90",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "T12D596",
    "addressOne": "Bealach An Cháirdinéil",
    "addressTwo": "Wilton",
    "addressThree": "Corcaigh",
    "addressFour": "",
    "lat": "51.8795833",
    "lng": "-8.5125911",
    "phone": "214342027",
    "email": "oifig@gaelscoiluiriada.ie"
  },
  {
    "i": "518",
    "county": "Cork",
    "rollNumber": "19881Q",
    "schoolName": "Gaelscoil Charraig Ui Leighin",
    "SETHours": "155",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "P43Y160",
    "addressOne": "Bridgemount",
    "addressTwo": "Carraig Í­ Leighin",
    "addressThree": "Co. Chorcaí­",
    "addressFour": "",
    "lat": "51.8205139",
    "lng": "-8.3870974",
    "phone": "214373399",
    "email": "oifig@gaelscoilcul.ie"
  },
  {
    "i": "519",
    "county": "Cork",
    "rollNumber": "19882S",
    "schoolName": "Scoil An Athair Tadhg O Murchu",
    "SETHours": "152.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "6.66",
    "spSNA": "0",
    "totalSNA": "6.66",
    "eircode": "T12D702",
    "addressOne": "Dúglas",
    "addressTwo": "Corcaigh",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.8773619",
    "lng": "-8.4435378",
    "phone": "214364193",
    "email": "oifig@gaelscoilnaduglaise.ie"
  },
  {
    "i": "520",
    "county": "Cork",
    "rollNumber": "19886D",
    "schoolName": "Gael Scoil Thomais Daibhis",
    "SETHours": "125",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "P51EY22",
    "addressOne": "Cnoc An Tsamhraidh",
    "addressTwo": "Magh Ealla",
    "addressThree": "Co. Chorcaí­",
    "addressFour": "",
    "lat": "52.1253542",
    "lng": "-8.6427286",
    "phone": "2242709",
    "email": "oifig@gaelscoilthomaisdaibhis.ie"
  },
  {
    "i": "521",
    "county": "Cork",
    "rollNumber": "19899M",
    "schoolName": "Gaelscoile Cobh",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "P24AF83",
    "addressOne": "Cobh",
    "addressTwo": "Co Chorcai",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.8543558",
    "lng": "-8.2869234",
    "phone": "214811283",
    "email": "gscobh.ias@eircom.net"
  },
  {
    "i": "522",
    "county": "Cork",
    "rollNumber": "19906G",
    "schoolName": "Cork Educate Together NS",
    "SETHours": "90",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.58",
    "spSNA": "0",
    "totalSNA": "3.58",
    "eircode": "T12NW65",
    "addressOne": "Grattan Street",
    "addressTwo": "Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.8991321",
    "lng": "-8.4788115",
    "phone": "214275640",
    "email": "corketns@gmail.com"
  },
  {
    "i": "523",
    "county": "Cork",
    "rollNumber": "19908K",
    "schoolName": "Gaelscoil Mhachan",
    "SETHours": "142.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "6.66",
    "spSNA": "0",
    "totalSNA": "6.66",
    "eircode": "T12RH66",
    "addressOne": "Ave De Rennes",
    "addressTwo": "Machan",
    "addressThree": "An Charraig Dhubh",
    "addressFour": "Corcaigh",
    "lat": "51.8922667",
    "lng": "-8.4032799",
    "phone": "214357688",
    "email": "info@gsmhachan.com"
  },
  {
    "i": "524",
    "county": "Cork",
    "rollNumber": "19909M",
    "schoolName": "Gaelscoil Peig Sayers",
    "SETHours": "107.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.33",
    "spSNA": "0",
    "totalSNA": "1.33",
    "eircode": "T23FK40",
    "addressOne": "Campas Oideachais",
    "addressTwo": "Fearann Phiarais",
    "addressThree": "Bothar Ri Na Haoine",
    "addressFour": "Corcaigh",
    "lat": "51.9119247",
    "lng": "-8.4781212",
    "phone": "214309619",
    "email": "eolas@peigsayers.com"
  },
  {
    "i": "525",
    "county": "Cork",
    "rollNumber": "19918N",
    "schoolName": "Drinagh Mixed Ns",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "P47E024",
    "addressOne": "Dunmanway",
    "addressTwo": "Co Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.6512498",
    "lng": "-9.148083",
    "phone": "2830389",
    "email": "drinaghns@gmail.com"
  },
  {
    "i": "526",
    "county": "Cork",
    "rollNumber": "19977G",
    "schoolName": "Bandon Boys Ns",
    "SETHours": "175",
    "spClassTeachingPosts": "4",
    "mainSNA": "5.08",
    "spSNA": "7.66",
    "totalSNA": "12.74",
    "eircode": "P72XH02",
    "addressOne": "Convent Hill",
    "addressTwo": "Bandon",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.7493344",
    "lng": "-8.7434715",
    "phone": "238844708",
    "email": "scoilphadraignaofa@eircom.net"
  },
  {
    "i": "527",
    "county": "Cork",
    "rollNumber": "19978I",
    "schoolName": "Maulatrahane Central Ns",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.33",
    "spSNA": "0",
    "totalSNA": "1.33",
    "eircode": "P81W952",
    "addressOne": "Leap",
    "addressTwo": "Skibbereen",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.5887765",
    "lng": "-9.200879",
    "phone": "2833827",
    "email": "maulatrahanens@gmail.com"
  },
  {
    "i": "528",
    "county": "Cork",
    "rollNumber": "19989N",
    "schoolName": "Scoil Mhuire Na Trocaire",
    "SETHours": "107.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "3",
    "spSNA": "2",
    "totalSNA": "5",
    "eircode": "P51X640",
    "addressOne": "Cill Na Mullach",
    "addressTwo": "Co Chorcai",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.2287411",
    "lng": "-8.6700164",
    "phone": "2223506",
    "email": "buttevantprimaryschool@gmail.com"
  },
  {
    "i": "529",
    "county": "Cork",
    "rollNumber": "19993E",
    "schoolName": "Gaelscoil An Ghoirt Alainn",
    "SETHours": "160",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.66",
    "spSNA": "0",
    "totalSNA": "4.66",
    "eircode": "T23EF20",
    "addressOne": "Aibhinne Murmont",
    "addressTwo": "Gort álainn",
    "addressThree": "Corcaigh",
    "addressFour": "",
    "lat": "51.9086957",
    "lng": "-8.4425846",
    "phone": "214551955",
    "email": "gaelscoilga@gortalainn.ie"
  },
  {
    "i": "530",
    "county": "Cork",
    "rollNumber": "20001N",
    "schoolName": "Gaelscoil Bheanntrai",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "P75VE44",
    "addressOne": "Seisceann",
    "addressTwo": "Beanntraí­",
    "addressThree": "Co. Chorcaí­",
    "addressFour": "",
    "lat": "51.6747519",
    "lng": "-9.4452418",
    "phone": "2751966",
    "email": "info@gaelscoilbheanntrai.ie"
  },
  {
    "i": "531",
    "county": "Cork",
    "rollNumber": "20004T",
    "schoolName": "Scoil An Croi Ro Naofa",
    "SETHours": "75",
    "spClassTeachingPosts": "2",
    "mainSNA": "2",
    "spSNA": "3",
    "totalSNA": "5",
    "eircode": "P75CF68",
    "addressOne": "Castletownbere",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.6524424",
    "lng": "-9.9105166",
    "phone": "2770788",
    "email": "ctbnsoffice@gmail.com"
  },
  {
    "i": "532",
    "county": "Cork",
    "rollNumber": "20006A",
    "schoolName": "Gaelscoil Mhichí­l Í­ Choileáin",
    "SETHours": "142.5",
    "spClassTeachingPosts": "4",
    "mainSNA": "4",
    "spSNA": "7.99",
    "totalSNA": "11.99",
    "eircode": "P85YV90",
    "addressOne": "Bóthar Chnoc Na Raithní­",
    "addressTwo": "Cloch Na Gcoillte",
    "addressThree": "Co. Chorcaí­",
    "addressFour": "",
    "lat": "51.6231609",
    "lng": "-8.9028371",
    "phone": "238834882",
    "email": "runai@gaelscoilcnag.ie"
  },
  {
    "i": "533",
    "county": "Cork",
    "rollNumber": "20009G",
    "schoolName": "Gaelscoil Dr M Ui Shuilleabhain",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "P81HY67",
    "addressOne": "Gort Na Cloiche",
    "addressTwo": "An Sciobairí­n",
    "addressThree": "Co. Chorcaí­",
    "addressFour": "",
    "lat": "51.5537196",
    "lng": "-9.2587022",
    "phone": "2821192",
    "email": "gaelscoil21192@hotmail.com"
  },
  {
    "i": "534",
    "county": "Cork",
    "rollNumber": "20022V",
    "schoolName": "Scoil Na Mbuachailli",
    "SETHours": "130",
    "spClassTeachingPosts": "2",
    "mainSNA": "2",
    "spSNA": "3.49",
    "totalSNA": "5.49",
    "eircode": "P85X788",
    "addressOne": "O'rahilly Street",
    "addressTwo": "Clonakilty",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.6207884",
    "lng": "-8.8916142",
    "phone": "238834487",
    "email": "info@snbclonakilty.com"
  },
  {
    "i": "535",
    "county": "Cork",
    "rollNumber": "20024C",
    "schoolName": "Bun Scoil Muire",
    "SETHours": "237.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "10.15",
    "spSNA": "3.66",
    "totalSNA": "13.81",
    "eircode": "P36PR62",
    "addressOne": "O'brien's Place",
    "addressTwo": "Youghal",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.9478191",
    "lng": "-7.8440255",
    "phone": "2493234",
    "email": "secbsm@bunscoilmhuire.com"
  },
  {
    "i": "536",
    "county": "Cork",
    "rollNumber": "20025E",
    "schoolName": "Gaelscoil Droichead Na Banndan",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.75",
    "spSNA": "0",
    "totalSNA": "1.75",
    "eircode": "P72T922",
    "addressOne": "Cloch Mhic Shí­omoin",
    "addressTwo": "Droichead Na Banndan",
    "addressThree": "Co. Chorcaí­",
    "addressFour": "",
    "lat": "51.741535",
    "lng": "-8.7307508",
    "phone": "238843378",
    "email": "gaelnabanndan@gmail.com"
  },
  {
    "i": "537",
    "county": "Cork",
    "rollNumber": "20036J",
    "schoolName": "North Presentation Primary School",
    "SETHours": "182.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "T23F344",
    "addressOne": "Cathedral Walk",
    "addressTwo": "Gerald Griffin Street",
    "addressThree": "Cork",
    "addressFour": "",
    "lat": "51.9055513",
    "lng": "-8.4761145",
    "phone": "214307132",
    "email": "northpres@gmail.com"
  },
  {
    "i": "538",
    "county": "Cork",
    "rollNumber": "20038N",
    "schoolName": "Scoil Aiseiri Chriost",
    "SETHours": "145",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "T23E634",
    "addressOne": "Farranree",
    "addressTwo": "Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.9119434",
    "lng": "-8.4841325",
    "phone": "214301383",
    "email": "info@scoilaiseirichriost.com"
  },
  {
    "i": "539",
    "county": "Cork",
    "rollNumber": "20049S",
    "schoolName": "Ringaskiddy Lower Harbour NS",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "P43C594",
    "addressOne": "Ringaskiddy",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.8244051",
    "lng": "-8.3222344",
    "phone": "214378238",
    "email": "office@ringaskiddyns.ie"
  },
  {
    "i": "540",
    "county": "Cork",
    "rollNumber": "20077A",
    "schoolName": "Scoil An Spioraid Naomh (boys)",
    "SETHours": "157.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "6.75",
    "spSNA": "0",
    "totalSNA": "6.75",
    "eircode": "T12X030",
    "addressOne": "Bishopstown",
    "addressTwo": "Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.8785928",
    "lng": "-8.5288776",
    "phone": "214543333",
    "email": "info@bishopstownboysschool.ie"
  },
  {
    "i": "541",
    "county": "Cork",
    "rollNumber": "20088F",
    "schoolName": "Scoil Mhuire NS,",
    "SETHours": "82.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.75",
    "spSNA": "0",
    "totalSNA": "2.75",
    "eircode": "P81Y163",
    "addressOne": "Schull",
    "addressTwo": "Co Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.528945",
    "lng": "-9.5457372",
    "phone": "2828400",
    "email": "info@schullns.com"
  },
  {
    "i": "542",
    "county": "Cork",
    "rollNumber": "20105C",
    "schoolName": "Star Of The Sea Primary School",
    "SETHours": "170",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "T12A381",
    "addressOne": "Maulbaun",
    "addressTwo": "Passage West",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.8651203",
    "lng": "-8.3410904",
    "phone": "214842072",
    "email": "office@staroftheseapw.ie"
  },
  {
    "i": "543",
    "county": "Cork",
    "rollNumber": "20106E",
    "schoolName": "Scoil Nioclais",
    "SETHours": "317.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "9.5",
    "spSNA": "0",
    "totalSNA": "9.5",
    "eircode": "T12HD86",
    "addressOne": "Frankfield",
    "addressTwo": "Grange",
    "addressThree": "Cork",
    "addressFour": "",
    "lat": "51.8651381",
    "lng": "-8.4570962",
    "phone": "214899567",
    "email": "scnioc@eircom.net"
  },
  {
    "i": "544",
    "county": "Cork",
    "rollNumber": "20107G",
    "schoolName": "Gaelscoil Mhainistir Na Corann",
    "SETHours": "177.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "P25CH73",
    "addressOne": "Bán Sheáin",
    "addressTwo": "Mainitir Na Corann",
    "addressThree": "Co. Chorcaí­",
    "addressFour": "",
    "lat": "51.911399",
    "lng": "-8.193244",
    "phone": "214613599",
    "email": "kobrolachain@gmail.com"
  },
  {
    "i": "545",
    "county": "Cork",
    "rollNumber": "20140E",
    "schoolName": "Scoil Mhuire Fatima Boys Sn",
    "SETHours": "130",
    "spClassTeachingPosts": "1",
    "mainSNA": "3",
    "spSNA": "1.66",
    "totalSNA": "4.66",
    "eircode": "T23VY17",
    "addressOne": "North Monastery Road",
    "addressTwo": "Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.9076604",
    "lng": "-8.4812271",
    "phone": "214305020",
    "email": "scoilmhuirefatima@eircom.net"
  },
  {
    "i": "546",
    "county": "Cork",
    "rollNumber": "20151J",
    "schoolName": "Gaelscoil Mhuscraí­",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "T23EA29",
    "addressOne": "Sean í­ochtarach",
    "addressTwo": "An Bhlárna",
    "addressThree": "Co. Chorcaí­",
    "addressFour": "",
    "lat": "51.9332198",
    "lng": "-8.5626973",
    "phone": "214516874",
    "email": "gaelscoilmhuscrai@gmail.com"
  },
  {
    "i": "547",
    "county": "Cork",
    "rollNumber": "20182U",
    "schoolName": "St Endas Ns",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "P47FV44",
    "addressOne": "Kilnadur",
    "addressTwo": "Dunmanway",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.7817275",
    "lng": "-9.0916131",
    "phone": "238855051",
    "email": "info@stendasns.ie"
  },
  {
    "i": "548",
    "county": "Cork",
    "rollNumber": "20204E",
    "schoolName": "Scoil Mháirtin",
    "SETHours": "125",
    "spClassTeachingPosts": "0",
    "mainSNA": "6.08",
    "spSNA": "0",
    "totalSNA": "6.08",
    "eircode": "P61D504",
    "addressOne": "Kilworth",
    "addressTwo": "Co. Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.1727695",
    "lng": "-8.2407603",
    "phone": "2527446",
    "email": "kilworthnationalschool@gmail.com"
  },
  {
    "i": "549",
    "county": "Cork",
    "rollNumber": "20222G",
    "schoolName": "Scoil Chuil Aodha Barr D Inse",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "P12A660",
    "addressOne": "Cúil-aodha",
    "addressTwo": "Máighchromtha",
    "addressThree": "Co. Chorcaí­",
    "addressFour": "",
    "lat": "51.9287828",
    "lng": "-9.2204462",
    "phone": "2645342",
    "email": "cuilaodhans@eircom.net"
  },
  {
    "i": "550",
    "county": "Cork",
    "rollNumber": "20239A",
    "schoolName": "Gaelscoil Ui Drisceoil",
    "SETHours": "127.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "T45YY19",
    "addressOne": "Dunkettle",
    "addressTwo": "Glanmire",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.9068589",
    "lng": "-8.3842877",
    "phone": "215003301",
    "email": "gaelscoiluidrisceoil@gmail.com"
  },
  {
    "i": "551",
    "county": "Cork",
    "rollNumber": "20265B",
    "schoolName": "Gaelscoil Chionn Tsáile",
    "SETHours": "75",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "P17VF84",
    "addressOne": "An Ceapach",
    "addressTwo": "Cionn Tsáile",
    "addressThree": "Co. Chorcaí­",
    "addressFour": "",
    "lat": "51.7078091",
    "lng": "-8.5385241",
    "phone": "214773731",
    "email": "eolas@gaelscoilchionntsaile.ie"
  },
  {
    "i": "552",
    "county": "Cork",
    "rollNumber": "20310D",
    "schoolName": "Educate Together Carrigaline",
    "SETHours": "217.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "7.66",
    "spSNA": "5.83",
    "totalSNA": "13.49",
    "eircode": "P43YX86",
    "addressOne": "Kilnagleary",
    "addressTwo": "Carrigaline",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.8097419",
    "lng": "-8.3832573",
    "phone": "214375616",
    "email": "secretary@cetns.org"
  },
  {
    "i": "553",
    "county": "Cork",
    "rollNumber": "20335T",
    "schoolName": "Scoil Phadraig Naofa",
    "SETHours": "160",
    "spClassTeachingPosts": "0",
    "mainSNA": "7.16",
    "spSNA": "0",
    "totalSNA": "7.16",
    "eircode": "T12HX79",
    "addressOne": "Foxwood",
    "addressTwo": "Rochestown",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.8688534",
    "lng": "-8.4039101",
    "phone": "214368499",
    "email": "info@rochestownns.ie"
  },
  {
    "i": "554",
    "county": "Cork",
    "rollNumber": "20336V",
    "schoolName": "Midleton Educate Together School",
    "SETHours": "240",
    "spClassTeachingPosts": "5",
    "mainSNA": "7.33",
    "spSNA": "9.32",
    "totalSNA": "16.65",
    "eircode": "P25NH94",
    "addressOne": "Broomfield West",
    "addressTwo": "Mill Road",
    "addressThree": "Midleton",
    "addressFour": "Co. Cork",
    "lat": "51.9279747",
    "lng": "-8.1820242",
    "phone": "214634563",
    "email": "info@midletonet.com"
  },
  {
    "i": "555",
    "county": "Cork",
    "rollNumber": "20388R",
    "schoolName": "Bunscoil Chriost Ri",
    "SETHours": "235",
    "spClassTeachingPosts": "1",
    "mainSNA": "4",
    "spSNA": "1.66",
    "totalSNA": "5.66",
    "eircode": "T12H6KA",
    "addressOne": "Evergreen Road",
    "addressTwo": "Turners Cross",
    "addressThree": "Cork",
    "addressFour": "",
    "lat": "51.8884679",
    "lng": "-8.4668332",
    "phone": "214963629",
    "email": "michelle@criostri.ie"
  },
  {
    "i": "556",
    "county": "Cork",
    "rollNumber": "20389T",
    "schoolName": "Scoil Maria Assumpta",
    "SETHours": "77.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "3",
    "spSNA": "4",
    "totalSNA": "7",
    "eircode": "T12HY44",
    "addressOne": "Ballyphehane",
    "addressTwo": "Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.883498",
    "lng": "-8.4801131",
    "phone": "214315724",
    "email": "mariaassumpta.ias@gmail.com"
  },
  {
    "i": "557",
    "county": "Cork",
    "rollNumber": "20399W",
    "schoolName": "Scoil Chroí­ í­osa",
    "SETHours": "155",
    "spClassTeachingPosts": "1",
    "mainSNA": "6",
    "spSNA": "0.33",
    "totalSNA": "6.33",
    "eircode": "T23E722",
    "addressOne": "St Anne's Road",
    "addressTwo": "Blarney",
    "addressThree": "Co. Cork",
    "addressFour": "",
    "lat": "51.9344308",
    "lng": "-8.5716492",
    "phone": "214385865",
    "email": "principal@scins.ie"
  },
  {
    "i": "558",
    "county": "Cork",
    "rollNumber": "20413N",
    "schoolName": "Douglas Rochestown Educate Together NS",
    "SETHours": "157.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "9",
    "spSNA": "0",
    "totalSNA": "9",
    "eircode": "T12A38N",
    "addressOne": "Garryduff Sports Centre",
    "addressTwo": "Rochestown",
    "addressThree": "Cork",
    "addressFour": "",
    "lat": "51.869243",
    "lng": "-8.3961911",
    "phone": "214890122",
    "email": "info@rochestownetns.ie"
  },
  {
    "i": "559",
    "county": "Cork",
    "rollNumber": "20435A",
    "schoolName": "Scoil Naomh Eltin",
    "SETHours": "182.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "6.5",
    "spSNA": "4",
    "totalSNA": "10.5",
    "eircode": "P17CF82",
    "addressOne": "Kinsale",
    "addressTwo": "Co Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.7042792",
    "lng": "-8.5250563",
    "phone": "214774040",
    "email": "info@scoilnaomheltin.ie"
  },
  {
    "i": "560",
    "county": "Cork",
    "rollNumber": "20440Q",
    "schoolName": "Scoil Aonghusa Community NS",
    "SETHours": "90",
    "spClassTeachingPosts": "2",
    "mainSNA": "2.66",
    "spSNA": "3.83",
    "totalSNA": "6.49",
    "eircode": "P51P5V2",
    "addressOne": "Kingsfort Avenue",
    "addressTwo": "Castlepark Village",
    "addressThree": "Mallow",
    "addressFour": "Co. Cork",
    "lat": "52.1397118",
    "lng": "-8.6306069",
    "phone": "2255314",
    "email": "scoilaonghusa@corketb.ie"
  },
  {
    "i": "561",
    "county": "Cork",
    "rollNumber": "20442U",
    "schoolName": "Scoil Chliodhna Community NS",
    "SETHours": "223.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.66",
    "spSNA": "0",
    "totalSNA": "2.66",
    "eircode": "T45P282",
    "addressOne": "C/o Carrigtwohill Gaa Club",
    "addressTwo": "Carrigtwohill",
    "addressThree": "",
    "addressFour": "Co Cork",
    "lat": "51.9088327",
    "lng": "-8.264061",
    "phone": "860080268",
    "email": "office@scoilchliodhnacns.ie"
  },
  {
    "i": "562",
    "county": "Cork",
    "rollNumber": "20477Q",
    "schoolName": "St Patrick's BNS",
    "SETHours": "130",
    "spClassTeachingPosts": "3",
    "mainSNA": "3",
    "spSNA": "5.66",
    "totalSNA": "8.66",
    "eircode": "P81KP63",
    "addressOne": "Skibbereen",
    "addressTwo": "Co Cork",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.5545329",
    "lng": "-9.260223",
    "phone": "2821948",
    "email": "skibns.ias@eircom.net"
  },
  {
    "i": "563",
    "county": "Cork",
    "rollNumber": "20493O",
    "schoolName": "Canon Sheehan Primary School",
    "SETHours": "67.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "1",
    "spSNA": "1",
    "totalSNA": "2",
    "eircode": "P51X796",
    "addressOne": "Turnpike",
    "addressTwo": "Doneraile",
    "addressThree": "Co.cork",
    "addressFour": "",
    "lat": "52.2221493",
    "lng": "-8.5824167",
    "phone": "2224499",
    "email": "cspsdoneraile@gmail.com"
  },
  {
    "i": "564",
    "county": "Cork",
    "rollNumber": "20497W",
    "schoolName": "Scoil Mhuire Agus Eoin",
    "SETHours": "180",
    "spClassTeachingPosts": "2",
    "mainSNA": "3.83",
    "spSNA": "3.83",
    "totalSNA": "7.66",
    "eircode": "T23CA33",
    "addressOne": "Boherboy Road",
    "addressTwo": "Lotabeg",
    "addressThree": "Mayfield",
    "addressFour": "",
    "lat": "51.9129433",
    "lng": "-8.4242238",
    "phone": "214503003",
    "email": "scoilmhuireaguseoin@gmail.com"
  },
  {
    "i": "565",
    "county": "Cork",
    "rollNumber": "20500I",
    "schoolName": "Gaelscoil An Chaisleáin",
    "SETHours": "38.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "P31DA38",
    "addressOne": "Cumann Rugbaí­ Bhaile An Chollaigh",
    "addressTwo": "Tanner Park",
    "addressThree": "Cúl Rua,",
    "addressFour": "Baile An Chollaigh",
    "lat": "51.8825507",
    "lng": "-8.623929",
    "phone": "214826181",
    "email": "gsanchaisleain@gmail.com"
  },
  {
    "i": "566",
    "county": "Cork",
    "rollNumber": "20511N",
    "schoolName": "Fermoy Educate Together Ns",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "P61HV07",
    "addressOne": "Fermoy Educate Together NS",
    "addressTwo": "Waterloo Lane",
    "addressThree": "",
    "addressFour": "Fermoy",
    "lat": "52.1380289",
    "lng": "-8.2795477",
    "phone": "834639007",
    "email": "secretary@fermoyetns.com"
  },
  {
    "i": "567",
    "county": "Cork",
    "rollNumber": "20522S",
    "schoolName": "Glasheen Pouladuff Cork City Primary School",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "T12W658",
    "addressOne": "C/o Colaiste Stiofain Naofa",
    "addressTwo": "Tramore Rd, Cork City",
    "addressThree": "",
    "addressFour": "",
    "lat": "",
    "lng": "",
    "phone": "867032408",
    "email": "office@southleeeducatetogether.com"
  },
  {
    "i": "568",
    "county": "Cork",
    "rollNumber": "20534C",
    "schoolName": "Owenabue Etns",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "",
    "addressOne": "",
    "addressTwo": "",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.8252833",
    "lng": "-8.3947437",
    "phone": "",
    "email": ""
  },
  {
    "i": "569",
    "county": "Cork",
    "rollNumber": "20550A",
    "schoolName": "Holy Well NS",
    "SETHours": "327.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "11.66",
    "spSNA": "5.66",
    "totalSNA": "17.32",
    "eircode": "",
    "addressOne": "",
    "addressTwo": "",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.8178414",
    "lng": "-8.3971053",
    "phone": "",
    "email": ""
  },
  {
    "i": "570",
    "county": "Donegal",
    "rollNumber": "01572D",
    "schoolName": "SN Naomh Padraig",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F93YY19",
    "addressOne": "Carrowhill",
    "addressTwo": "Drumfries",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "55.1988347",
    "lng": "-7.3935867",
    "phone": "749363396",
    "email": "admin@drumfriesschool.com"
  },
  {
    "i": "571",
    "county": "Donegal",
    "rollNumber": "01574H",
    "schoolName": "Scoil Naomh Iósaf",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F93HX30",
    "addressOne": "Connaghkinnego",
    "addressTwo": "Ballymagan",
    "addressThree": "Buncrana",
    "addressFour": "Co. Donegal",
    "lat": "55.1570106",
    "lng": "-7.3541334",
    "phone": "749362212",
    "email": "stjoesias@gmail.com"
  },
  {
    "i": "572",
    "county": "Donegal",
    "rollNumber": "01733B",
    "schoolName": "Ardara Mixed NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F94P279",
    "addressOne": "Back Road",
    "addressTwo": "Ardara",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.7640545",
    "lng": "-8.4113873",
    "phone": "749541539",
    "email": "woodns2001@gmail.com"
  },
  {
    "i": "573",
    "county": "Donegal",
    "rollNumber": "03294L",
    "schoolName": "SN Caiseal Na Gcorr",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F92YY24",
    "addressOne": "Gort A Choirce",
    "addressTwo": "Leitir Ceanainn",
    "addressThree": "Co. Dhún Na Ngall",
    "addressFour": "",
    "lat": "55.0883794",
    "lng": "-8.1288317",
    "phone": "749165129",
    "email": "scoilchaisealnagcorr@gmail.com"
  },
  {
    "i": "574",
    "county": "Donegal",
    "rollNumber": "04809A",
    "schoolName": "Scoil An Aingil Choimheadai",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F94W084",
    "addressOne": "An Céideadh,",
    "addressTwo": "Ailt An Chorráin",
    "addressThree": "Leitir Ceanainn",
    "addressFour": "Co Dhún Na Ngall",
    "lat": "54.9975043",
    "lng": "-8.4188455",
    "phone": "749542268",
    "email": "saac.ceideadh@gmail.com"
  },
  {
    "i": "575",
    "county": "Donegal",
    "rollNumber": "05164I",
    "schoolName": "Scoil Naomh Cholmcille",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "F92XV52",
    "addressOne": "Oileán Thoraí­",
    "addressTwo": "Co. Dhún Na Ngall",
    "addressThree": "",
    "addressFour": "",
    "lat": "55.2650089",
    "lng": "-8.2245572",
    "phone": "749165174",
    "email": "scoilcholmcille@yahoo.ie"
  },
  {
    "i": "576",
    "county": "Donegal",
    "rollNumber": "05230S",
    "schoolName": "Comhscoil Chonmha SN",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "F93NR7V",
    "addressOne": "Main Street",
    "addressTwo": "Convoy",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.8599466",
    "lng": "-7.6658028",
    "phone": "749147493",
    "email": "convoyjoint@gmail.com"
  },
  {
    "i": "577",
    "county": "Donegal",
    "rollNumber": "07143K",
    "schoolName": "Monreagh NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F93CV60",
    "addressOne": "Monreagh",
    "addressTwo": "Carrigans",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.9563564",
    "lng": "-7.4571041",
    "phone": "749140445",
    "email": "monreaghns@gmail.com"
  },
  {
    "i": "578",
    "county": "Donegal",
    "rollNumber": "07464H",
    "schoolName": "Browneknowe NS",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "F92P223",
    "addressOne": "Brownknowe",
    "addressTwo": "Ramelton",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "55.0605305",
    "lng": "-7.6216858",
    "phone": "749151392",
    "email": "brownknowens@gmail.com"
  },
  {
    "i": "579",
    "county": "Donegal",
    "rollNumber": "07626H",
    "schoolName": "SN An Iorball Riabaigh",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F93PN44",
    "addressOne": "Urblereagh",
    "addressTwo": "Malin Head",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "55.3360603",
    "lng": "-7.2878173",
    "phone": "749370237",
    "email": "urblereaghns@yahoo.co.uk"
  },
  {
    "i": "580",
    "county": "Donegal",
    "rollNumber": "09009Q",
    "schoolName": "Rockfield NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F94TD25",
    "addressOne": "Rockfield NS",
    "addressTwo": "Knocknashangan",
    "addressThree": "Ballyshannon",
    "addressFour": "",
    "lat": "54.4831583",
    "lng": "-8.1192783",
    "phone": "719852860",
    "email": "rockfieldns@gmail.com"
  },
  {
    "i": "581",
    "county": "Donegal",
    "rollNumber": "09660R",
    "schoolName": "St Francis Ns",
    "SETHours": "65",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.66",
    "spSNA": "0",
    "totalSNA": "3.66",
    "eircode": "F94WF78",
    "addressOne": "Mullanalamphry",
    "addressTwo": "Barnesmore",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.6844244",
    "lng": "-8.0327594",
    "phone": "749722109",
    "email": "stfrancisns@gmail.com"
  },
  {
    "i": "582",
    "county": "Donegal",
    "rollNumber": "09748I",
    "schoolName": "Glenmaquin No 2 NS",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F92F792",
    "addressOne": "Knockbrack",
    "addressTwo": "Letterkenny",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.9048756",
    "lng": "-7.6660308",
    "phone": "749147599",
    "email": "glenmaquinns@yahoo.ie"
  },
  {
    "i": "583",
    "county": "Donegal",
    "rollNumber": "10062E",
    "schoolName": "Creeslough NS",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F92W803",
    "addressOne": "Creeslough",
    "addressTwo": "Letterkenny",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "55.1230862",
    "lng": "-7.9084303",
    "phone": "749138453",
    "email": "creesloughns@gmail.com"
  },
  {
    "i": "584",
    "county": "Donegal",
    "rollNumber": "10595Q",
    "schoolName": "Kilbarron NS",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F94Y198",
    "addressOne": "Belleek Road",
    "addressTwo": "Ballyshannon",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.4987448",
    "lng": "-8.1808289",
    "phone": "719851380",
    "email": "kilbarronschool@gmail.com"
  },
  {
    "i": "585",
    "county": "Donegal",
    "rollNumber": "11843O",
    "schoolName": "SN Neill Mor",
    "SETHours": "82.5",
    "spClassTeachingPosts": "4",
    "mainSNA": "4",
    "spSNA": "5.83",
    "totalSNA": "9.83",
    "eircode": "F94FX76",
    "addressOne": "Killybegs",
    "addressTwo": "Co. Donegal",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.6385179",
    "lng": "-8.4405209",
    "phone": "749731794",
    "email": "office@niallmor.com"
  },
  {
    "i": "586",
    "county": "Donegal",
    "rollNumber": "12077E",
    "schoolName": "Scoil Naomh Fiachra",
    "SETHours": "235",
    "spClassTeachingPosts": "0",
    "mainSNA": "10",
    "spSNA": "0",
    "totalSNA": "10",
    "eircode": "F92WD21",
    "addressOne": "Illistrin",
    "addressTwo": "Letterkenny",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.9957929",
    "lng": "-7.7317757",
    "phone": "749125775",
    "email": "illistrinoffice@gmail.com"
  },
  {
    "i": "587",
    "county": "Donegal",
    "rollNumber": "13563S",
    "schoolName": "SN Chill Coinnigh",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "F94CX21",
    "addressOne": "Kilkenny",
    "addressTwo": "Glenties",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.8309851",
    "lng": "-8.3461559",
    "phone": "749544270",
    "email": "kilkennyns@gmail.com"
  },
  {
    "i": "588",
    "county": "Donegal",
    "rollNumber": "13755E",
    "schoolName": "Gartan NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F92DX92",
    "addressOne": "Gartan",
    "addressTwo": "Letterkenny",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "55.0047885",
    "lng": "-7.8988121",
    "phone": "749137443",
    "email": "gartanns@live.com"
  },
  {
    "i": "589",
    "county": "Donegal",
    "rollNumber": "13872I",
    "schoolName": "Robertson NS",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F94Y283",
    "addressOne": "Lisminton",
    "addressTwo": "Ballintra",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.5794582",
    "lng": "-8.1232482",
    "phone": "749734363",
    "email": "robertsonns@hotmail.com"
  },
  {
    "i": "590",
    "county": "Donegal",
    "rollNumber": "14194S",
    "schoolName": "Scoil Cholmcille",
    "SETHours": "80",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "F92YC85",
    "addressOne": "An Tearmann",
    "addressTwo": "Co. Dhún Na Ngall",
    "addressThree": "",
    "addressFour": "",
    "lat": "55.049562",
    "lng": "-7.8328612",
    "phone": "749139244",
    "email": "termonprincipal@gmail.com"
  },
  {
    "i": "591",
    "county": "Donegal",
    "rollNumber": "14502D",
    "schoolName": "Scoil Mhuire B&c",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F92NN82",
    "addressOne": "Na Doirí­ Beaga",
    "addressTwo": "Leitir Ceanainn",
    "addressThree": "Co. Dhún Na Ngall",
    "addressFour": "",
    "lat": "55.0764109",
    "lng": "-8.2849323",
    "phone": "749531557",
    "email": "smbc@eircom.net"
  },
  {
    "i": "592",
    "county": "Donegal",
    "rollNumber": "14631O",
    "schoolName": "Scoil Cholmchille",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "F93N663",
    "addressOne": "Ballymena",
    "addressTwo": "Glengad",
    "addressThree": "Malin",
    "addressFour": "Co. Donegal",
    "lat": "55.3210938",
    "lng": "-7.1819607",
    "phone": "749379211",
    "email": "glengadns@gmail.com"
  },
  {
    "i": "593",
    "county": "Donegal",
    "rollNumber": "14704P",
    "schoolName": "Murroe NS",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F92HT32",
    "addressOne": "Murroe",
    "addressTwo": "Dunfanaghy",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "55.1536496",
    "lng": "-8.011519",
    "phone": "749136702",
    "email": "murroenationalschool@gmail.com"
  },
  {
    "i": "594",
    "county": "Donegal",
    "rollNumber": "14910S",
    "schoolName": "St Mary's NS",
    "SETHours": "60",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F93FD92",
    "addressOne": "Castlefinn",
    "addressTwo": "Lifford",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.8032561",
    "lng": "-7.5951417",
    "phone": "749146206",
    "email": "secretary@stmarysnscastlefinn.com"
  },
  {
    "i": "595",
    "county": "Donegal",
    "rollNumber": "14941G",
    "schoolName": "Ray NS",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "F92YY86",
    "addressOne": "Ray",
    "addressTwo": "Manorcunningham",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.9378013",
    "lng": "-7.6176804",
    "phone": "749157364",
    "email": "rayns.ias@eircom.net"
  },
  {
    "i": "596",
    "county": "Donegal",
    "rollNumber": "15170J",
    "schoolName": "Cashelshanaghan NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "F92RF67",
    "addressOne": "Ballymaleel",
    "addressTwo": "Letterkenny",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "55.0006781",
    "lng": "-7.6608773",
    "phone": "749151803",
    "email": "cashelshanaghan@gmail.com"
  },
  {
    "i": "597",
    "county": "Donegal",
    "rollNumber": "15208I",
    "schoolName": "Scoil An Tstratha Mhóir",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F92P280",
    "addressOne": "Mí­n An Lábáin",
    "addressTwo": "Leitir Ceanainn",
    "addressThree": "Co. Dhún Na Ngall",
    "addressFour": "",
    "lat": "54.9674082",
    "lng": "-7.9672753",
    "phone": "749137454",
    "email": "stramore99@gmail.com"
  },
  {
    "i": "599",
    "county": "Donegal",
    "rollNumber": "15554E",
    "schoolName": "Gortnacart NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F94HD54",
    "addressOne": "Gortnacart",
    "addressTwo": "Ardara",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.7643485",
    "lng": "-8.3656146",
    "phone": "749541799",
    "email": "gortnacart1909@gmail.com"
  },
  {
    "i": "600",
    "county": "Donegal",
    "rollNumber": "15627F",
    "schoolName": "St Muras NS",
    "SETHours": "75",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F93TW54",
    "addressOne": "Burnfoot",
    "addressTwo": "Lifford",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "55.0654038",
    "lng": "-7.4341947",
    "phone": "749360325",
    "email": "saintmuras@gmail.com"
  },
  {
    "i": "601",
    "county": "Donegal",
    "rollNumber": "15729N",
    "schoolName": "Rathmullen NS",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F92VA89",
    "addressOne": "Rathmullen",
    "addressTwo": "Co Donegal",
    "addressThree": "",
    "addressFour": "",
    "lat": "55.0954794",
    "lng": "-7.54127",
    "phone": "749158388",
    "email": "stjosephsrathmullan123@gmail.com"
  },
  {
    "i": "602",
    "county": "Donegal",
    "rollNumber": "15763N",
    "schoolName": "Moville NS",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F93PF77",
    "addressOne": "Greencastle Road",
    "addressTwo": "Moville",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "55.1899815",
    "lng": "-7.0360695",
    "phone": "749382851",
    "email": "stcolumbns@yahoo.co.uk"
  },
  {
    "i": "603",
    "county": "Donegal",
    "rollNumber": "15770K",
    "schoolName": "SN Naomh Naille",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.66",
    "spSNA": "0",
    "totalSNA": "4.66",
    "eircode": "F94RW28",
    "addressOne": "Na Caologa",
    "addressTwo": "Inbhear",
    "addressThree": "Co. Dhún Na Ngall",
    "addressFour": "",
    "lat": "54.6562889",
    "lng": "-8.2770107",
    "phone": "749736416",
    "email": "stnaulsnskeelogs@gmail.com"
  },
  {
    "i": "604",
    "county": "Donegal",
    "rollNumber": "15847T",
    "schoolName": "SN Leitir Mhic An Bhaird",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F94R962",
    "addressOne": "Leitir Mhic A' Bhaird",
    "addressTwo": "Lettermacaward",
    "addressThree": "Co. Dhún Na Ngall",
    "addressFour": "",
    "lat": "54.8573406",
    "lng": "-8.3029051",
    "phone": "749544238",
    "email": "seamusmcbride@me.com"
  },
  {
    "i": "605",
    "county": "Donegal",
    "rollNumber": "15955W",
    "schoolName": "Sn Arainn Mhor I",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F92Y978",
    "addressOne": "Arainn Mór",
    "addressTwo": "Co. Dhún Na Ngall",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.9853874",
    "lng": "-8.4946302",
    "phone": "749520116",
    "email": "arranmorens1@hotmail.com"
  },
  {
    "i": "606",
    "county": "Donegal",
    "rollNumber": "16054M",
    "schoolName": "St Patricks NS",
    "SETHours": "112.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "4",
    "spSNA": "1",
    "totalSNA": "5",
    "eircode": "F93AP93",
    "addressOne": "Murlog",
    "addressTwo": "Lifford",
    "addressThree": "Co Donegal",
    "addressFour": "",
    "lat": "54.8425224",
    "lng": "-7.5019911",
    "phone": "749141450",
    "email": "murlogs@eircom.net"
  },
  {
    "i": "607",
    "county": "Donegal",
    "rollNumber": "16108J",
    "schoolName": "Scoil Naomh Treasa C",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F93KD53",
    "addressOne": "Tiernasligo Urris Clonmany",
    "addressTwo": "Lifford",
    "addressThree": "Co Donegal",
    "addressFour": "",
    "lat": "55.2681087",
    "lng": "-7.497856",
    "phone": "749376359",
    "email": "tiernasligo@yahoo.ie"
  },
  {
    "i": "608",
    "county": "Donegal",
    "rollNumber": "16137Q",
    "schoolName": "Drumfad NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F92P683",
    "addressOne": "Kerrykeel P O",
    "addressTwo": "Letterkenny",
    "addressThree": "",
    "addressFour": "",
    "lat": "55.1791192",
    "lng": "-7.6411641",
    "phone": "749159399",
    "email": "drumfadbally@gmail.com"
  },
  {
    "i": "609",
    "county": "Donegal",
    "rollNumber": "16138S",
    "schoolName": "Raphoe Central NS",
    "SETHours": "115",
    "spClassTeachingPosts": "0",
    "mainSNA": "7",
    "spSNA": "0",
    "totalSNA": "7",
    "eircode": "F93E367",
    "addressOne": "Raphoe",
    "addressTwo": "Lifford",
    "addressThree": "Co Donegal",
    "addressFour": "",
    "lat": "54.8752469",
    "lng": "-7.5981988",
    "phone": "749145361",
    "email": "raphoecentral.ias@eircom.net"
  },
  {
    "i": "610",
    "county": "Donegal",
    "rollNumber": "16242N",
    "schoolName": "SN Dumhach Beag",
    "SETHours": "5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F92D597",
    "addressOne": "Doaghbeg",
    "addressTwo": "Portalson",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "55.2451584",
    "lng": "-7.6239115",
    "phone": "749159311",
    "email": "doaghbegns@yahoo.ie"
  },
  {
    "i": "611",
    "county": "Donegal",
    "rollNumber": "16279N",
    "schoolName": "Scoil Choluim",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F92ND30",
    "addressOne": "Ballyheerin",
    "addressTwo": "Fanad",
    "addressThree": "Letterkenny",
    "addressFour": "Co. Donegal",
    "lat": "55.1961461",
    "lng": "-7.7272168",
    "phone": "749159526",
    "email": "info@ballyheerinschool.ie"
  },
  {
    "i": "612",
    "county": "Donegal",
    "rollNumber": "16349I",
    "schoolName": "SN An Droim Mor",
    "SETHours": "145",
    "spClassTeachingPosts": "5",
    "mainSNA": "9",
    "spSNA": "11",
    "totalSNA": "20",
    "eircode": "F93A275",
    "addressOne": "An Droim Mór",
    "addressTwo": "Killygordeon",
    "addressThree": "Lifford",
    "addressFour": "Co. Donegal",
    "lat": "54.7913313",
    "lng": "-7.684462",
    "phone": "749149455",
    "email": "dromorekillygordon@gmail.com"
  },
  {
    "i": "613",
    "county": "Donegal",
    "rollNumber": "16357H",
    "schoolName": "SN Fhionntra",
    "SETHours": "33",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.33",
    "spSNA": "0",
    "totalSNA": "2.33",
    "eircode": "F94PX38",
    "addressOne": "Fintra",
    "addressTwo": "Killybegs",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.6391521",
    "lng": "-8.4838025",
    "phone": "749731668",
    "email": "info@fintrans.ie"
  },
  {
    "i": "614",
    "county": "Donegal",
    "rollNumber": "16375J",
    "schoolName": "Frosses NS",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "F94PH26",
    "addressOne": "Frosses",
    "addressTwo": "Co. Donegal",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.6693103",
    "lng": "-8.2437186",
    "phone": "749736514",
    "email": "frossesschool@gmail.com"
  },
  {
    "i": "615",
    "county": "Donegal",
    "rollNumber": "16384K",
    "schoolName": "Sn Arainn Mhor Ii",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "F92AE75",
    "addressOne": "Arainn Mhór",
    "addressTwo": "Co. Dhún Na Ngall",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.9739495",
    "lng": "-8.5214347",
    "phone": "749520117",
    "email": "scoilathphoirt@gmail.com"
  },
  {
    "i": "616",
    "county": "Donegal",
    "rollNumber": "16458N",
    "schoolName": "Inver NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "F94HE42",
    "addressOne": "Inver",
    "addressTwo": "Co Donegal",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.6529459",
    "lng": "-8.2737605",
    "phone": "749736438",
    "email": "inverns1914@gmail.com"
  },
  {
    "i": "617",
    "county": "Donegal",
    "rollNumber": "16471F",
    "schoolName": "St Davadogs NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F92XH92",
    "addressOne": "Tamney",
    "addressTwo": "Letterkenny",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "55.2008983",
    "lng": "-7.689261",
    "phone": "749159527",
    "email": "tamneyns@gmail.com"
  },
  {
    "i": "618",
    "county": "Donegal",
    "rollNumber": "16603T",
    "schoolName": "SN An Chillin",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "F94RD30",
    "addressOne": "Killian",
    "addressTwo": "Inver",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.6860761",
    "lng": "-8.2628715",
    "phone": "749736322",
    "email": "admin@killianschool.com"
  },
  {
    "i": "619",
    "county": "Donegal",
    "rollNumber": "16608G",
    "schoolName": "Killybegs Common NS",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "F94XY84",
    "addressOne": "The Commons",
    "addressTwo": "Killybegs",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.6557398",
    "lng": "-8.4276082",
    "phone": "749731919",
    "email": "commonsns@gmail.com"
  },
  {
    "i": "620",
    "county": "Donegal",
    "rollNumber": "16611S",
    "schoolName": "Glentogher Con NS",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F93HC04",
    "addressOne": "Mullins",
    "addressTwo": "Carndonagh",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "55.2214293",
    "lng": "-7.2654108",
    "phone": "749374565",
    "email": "glentogherns.ias@eircom.net"
  },
  {
    "i": "621",
    "county": "Donegal",
    "rollNumber": "16642G",
    "schoolName": "St Francis' NS",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.5",
    "spSNA": "0",
    "totalSNA": "4.5",
    "eircode": "F93R621",
    "addressOne": "Clonmaney",
    "addressTwo": "Lifford",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "55.2617753",
    "lng": "-7.411771",
    "phone": "749376355",
    "email": "clonmanyns@yahoo.ie"
  },
  {
    "i": "622",
    "county": "Donegal",
    "rollNumber": "16664Q",
    "schoolName": "Bruckless NS",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F94E427",
    "addressOne": "Bruckless",
    "addressTwo": "Co. Donegal",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.6407255",
    "lng": "-8.390201",
    "phone": "749737366",
    "email": "bruckless.ias@eircom.net"
  },
  {
    "i": "623",
    "county": "Donegal",
    "rollNumber": "16671N",
    "schoolName": "SN Cnoc Na Naomh",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "F92H213",
    "addressOne": "Doire Chonaire",
    "addressTwo": "Gort A Choirce",
    "addressThree": "Leitir Ceanainn",
    "addressFour": "Co. Dhún Na Ngall",
    "lat": "55.1295953",
    "lng": "-8.1813526",
    "phone": "749165133",
    "email": "cnocnanaomh@gmail.com"
  },
  {
    "i": "624",
    "county": "Donegal",
    "rollNumber": "16672P",
    "schoolName": "St Patricks NS",
    "SETHours": "157.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "5.66",
    "spSNA": "6",
    "totalSNA": "11.66",
    "eircode": "F92HP82",
    "addressOne": "Lurgybrack",
    "addressTwo": "Letterkenny",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.9324009",
    "lng": "-7.6956003",
    "phone": "749125455",
    "email": "lurgybrackns@gmail.com"
  },
  {
    "i": "625",
    "county": "Donegal",
    "rollNumber": "16763S",
    "schoolName": "SN Glasain",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F92KV97",
    "addressOne": "Glassan",
    "addressTwo": "Croasloch",
    "addressThree": "Co. Dhún Na Ngall",
    "addressFour": "",
    "lat": "55.1008533",
    "lng": "-7.9478192",
    "phone": "749138246",
    "email": "glassanns@gmail.com"
  },
  {
    "i": "626",
    "county": "Donegal",
    "rollNumber": "16789N",
    "schoolName": "St Orans NS",
    "SETHours": "117.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "F93YD52",
    "addressOne": "Cockhill",
    "addressTwo": "Buncrana",
    "addressThree": "",
    "addressFour": "",
    "lat": "55.1505371",
    "lng": "-7.4412013",
    "phone": "749361807",
    "email": "office@storansbuncrana.com"
  },
  {
    "i": "627",
    "county": "Donegal",
    "rollNumber": "16819T",
    "schoolName": "SN Gort An Choirce",
    "SETHours": "20",
    "spClassTeachingPosts": "1",
    "mainSNA": "0.5",
    "spSNA": "2",
    "totalSNA": "2.5",
    "eircode": "F92W021",
    "addressOne": "Leitir Ceanainn",
    "addressTwo": "Co Dhun Na Ngall",
    "addressThree": "",
    "addressFour": "",
    "lat": "55.1205302",
    "lng": "-8.1345377",
    "phone": "749135094",
    "email": "scoilnaiste@eircom.net"
  },
  {
    "i": "628",
    "county": "Donegal",
    "rollNumber": "16820E",
    "schoolName": "Scoil Cholmcille",
    "SETHours": "122.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.83",
    "spSNA": "0",
    "totalSNA": "4.83",
    "eircode": "F93WN51",
    "addressOne": "Newtowncunningham",
    "addressTwo": "Co. Donegal",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.9974056",
    "lng": "-7.5165707",
    "phone": "749156308",
    "email": "scoilcholm@gmail.com"
  },
  {
    "i": "629",
    "county": "Donegal",
    "rollNumber": "16821G",
    "schoolName": "Clochar Padraig Naofa",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "F93XD74",
    "addressOne": "Convent Rd.,",
    "addressTwo": "Carndonagh",
    "addressThree": "",
    "addressFour": "",
    "lat": "55.2458252",
    "lng": "-7.2653279",
    "phone": "749374412",
    "email": "gnscarn@gmail.com"
  },
  {
    "i": "630",
    "county": "Donegal",
    "rollNumber": "16823K",
    "schoolName": "Min A Ghabhann NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F94K072",
    "addressOne": "Lettermacaward",
    "addressTwo": "Donegal",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.8512333",
    "lng": "-8.3257786",
    "phone": "749544675",
    "email": "meenagowanns@gmail.com"
  },
  {
    "i": "631",
    "county": "Donegal",
    "rollNumber": "16829W",
    "schoolName": "SN Loch An Iubhair",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F94X850",
    "addressOne": "Loch An Iúir",
    "addressTwo": "Anagaire",
    "addressThree": "Leitir Ceanainn",
    "addressFour": "",
    "lat": "55.0029551",
    "lng": "-8.2929119",
    "phone": "749548222",
    "email": "scoillochaniuir@eircom.net"
  },
  {
    "i": "632",
    "county": "Donegal",
    "rollNumber": "16836T",
    "schoolName": "Naomh Bridhid",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.25",
    "spSNA": "0",
    "totalSNA": "4.25",
    "eircode": "F93KN23",
    "addressOne": "Collon",
    "addressTwo": "Carndonagh",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "55.2709415",
    "lng": "-7.3098607",
    "phone": "749374054",
    "email": "glenmakeens@gmail.com"
  },
  {
    "i": "633",
    "county": "Donegal",
    "rollNumber": "16837V",
    "schoolName": "SN Duchoraidh",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F94YP28",
    "addressOne": "Duchoraidh",
    "addressTwo": "Co Dhun Na Ngall",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.9078801",
    "lng": "-8.2072104",
    "phone": "749546315",
    "email": "doocharyns.ias@eircom.net"
  },
  {
    "i": "634",
    "county": "Donegal",
    "rollNumber": "16850N",
    "schoolName": "St Garvans NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F92XA39",
    "addressOne": "Drumhalla",
    "addressTwo": "Rathmullan",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "55.1371551",
    "lng": "-7.5571619",
    "phone": "749158414",
    "email": "stgarvans.drumhalla@gmail.com"
  },
  {
    "i": "635",
    "county": "Donegal",
    "rollNumber": "16854V",
    "schoolName": "Buncrana NS",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F93WD98",
    "addressOne": "St. Mary's Road",
    "addressTwo": "Buncrana",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "55.1337583",
    "lng": "-7.4558696",
    "phone": "749362309",
    "email": "rosedunne.ias@eircom.net"
  },
  {
    "i": "636",
    "county": "Donegal",
    "rollNumber": "16869L",
    "schoolName": "SN An Bhreacaigh",
    "SETHours": "22.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "0.5",
    "spSNA": "2",
    "totalSNA": "2.5",
    "eircode": "F94CX52",
    "addressOne": "Ard A Ratha",
    "addressTwo": "Co Dhun Na Ngall",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.7467452",
    "lng": "-8.4326147",
    "phone": "749541279",
    "email": "glengesh.ias@eircom.net"
  },
  {
    "i": "637",
    "county": "Donegal",
    "rollNumber": "16880W",
    "schoolName": "Scoil Naomh Colmchille",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "F93RY20",
    "addressOne": "Craigtown",
    "addressTwo": "Carndonagh",
    "addressThree": "Co Donegal",
    "addressFour": "",
    "lat": "55.2363655",
    "lng": "-7.2274356",
    "phone": "749374022",
    "email": "craigtownns@gmail.com"
  },
  {
    "i": "638",
    "county": "Donegal",
    "rollNumber": "16903I",
    "schoolName": "SN Fothar",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F92X406",
    "addressOne": "Port Na Blaithche",
    "addressTwo": "Leitir Ceanainn",
    "addressThree": "Co Dun Na Ngall",
    "addressFour": "",
    "lat": "55.1659168",
    "lng": "-7.920832",
    "phone": "749136422",
    "email": "faugherschool@gmail.com"
  },
  {
    "i": "639",
    "county": "Donegal",
    "rollNumber": "16995Q",
    "schoolName": "SN Naomh Colmchille",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F92PC52",
    "addressOne": "Drumoghill",
    "addressTwo": "Manorcunningham",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.9372644",
    "lng": "-7.5977218",
    "phone": "749157262",
    "email": "dns.ias@eircom.net"
  },
  {
    "i": "640",
    "county": "Donegal",
    "rollNumber": "17018N",
    "schoolName": "Scoil Phadraig",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F92VK88",
    "addressOne": "Dobhar",
    "addressTwo": "An Bun Beag",
    "addressThree": "Co. Dhún Na Ngall",
    "addressFour": "",
    "lat": "55.0375547",
    "lng": "-8.2557606",
    "phone": "749531787",
    "email": "dobharns@gmail.com"
  },
  {
    "i": "641",
    "county": "Donegal",
    "rollNumber": "17035N",
    "schoolName": "SN Mhin Teineadh De",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F94Y886",
    "addressOne": "Mí­n Tine Dé",
    "addressTwo": "Ard An Rátha",
    "addressThree": "Co. Dhún Na Ngall",
    "addressFour": "",
    "lat": "54.7417479",
    "lng": "-8.3600982",
    "phone": "749541003",
    "email": "meentinadeans@gmail.com"
  },
  {
    "i": "642",
    "county": "Donegal",
    "rollNumber": "17036P",
    "schoolName": "SN Naomh Colmchille",
    "SETHours": "95",
    "spClassTeachingPosts": "1",
    "mainSNA": "4",
    "spSNA": "2",
    "totalSNA": "6",
    "eircode": "F92P934",
    "addressOne": "Kilmacrennan",
    "addressTwo": "Co. Donegal",
    "addressThree": "",
    "addressFour": "",
    "lat": "55.0278722",
    "lng": "-7.7811836",
    "phone": "749139295",
    "email": "kilmacrennanschool@eircom.net"
  },
  {
    "i": "643",
    "county": "Donegal",
    "rollNumber": "17040G",
    "schoolName": "Sn Naomh Samhthann",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "F93R529",
    "addressOne": "Drumdoit",
    "addressTwo": "Castlefin",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.7779012",
    "lng": "-7.5712143",
    "phone": "749146521",
    "email": "stsafans@hotmail.com"
  },
  {
    "i": "644",
    "county": "Donegal",
    "rollNumber": "17057A",
    "schoolName": "Scoil Phádraig",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "F93TP03",
    "addressOne": "Scoil Phádraig",
    "addressTwo": "Drumkeen",
    "addressThree": "Ballybofey",
    "addressFour": "",
    "lat": "54.8671907",
    "lng": "-7.7576299",
    "phone": "749134066",
    "email": "stpatricksnationalschool@gmail.com"
  },
  {
    "i": "645",
    "county": "Donegal",
    "rollNumber": "17122I",
    "schoolName": "Sn Eadan Fhionnfhaoich",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F94D267",
    "addressOne": "Na Gleannta",
    "addressTwo": "Co Dhun Na Ngall",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.793523",
    "lng": "-8.1699942",
    "phone": "749551663",
    "email": "edeninfagh@gmail.com"
  },
  {
    "i": "646",
    "county": "Donegal",
    "rollNumber": "17130H",
    "schoolName": "Scoil Naomh Dubhthach",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "F92AW64",
    "addressOne": "Machaire Rabhartaigh",
    "addressTwo": "Gort A Choirce",
    "addressThree": "Co. Dhún Na Ngall",
    "addressFour": "",
    "lat": "55.1440006",
    "lng": "-8.177566",
    "phone": "749135665",
    "email": "scoilnaomhdubhthach@yahoo.ie"
  },
  {
    "i": "647",
    "county": "Donegal",
    "rollNumber": "17180W",
    "schoolName": "SN Na Gcluainte",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "F93KP44",
    "addressOne": "Cloontagh",
    "addressTwo": "Clonmany",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "55.2496663",
    "lng": "-7.384818",
    "phone": "749376365",
    "email": "cloontaghns@hotmail.com"
  },
  {
    "i": "648",
    "county": "Donegal",
    "rollNumber": "17241Q",
    "schoolName": "SN Domhnach Mor",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F93WV78",
    "addressOne": "Liscooley",
    "addressTwo": "Castlefin",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.8008955",
    "lng": "-7.6404944",
    "phone": "749146588",
    "email": "office@donnsch.com"
  },
  {
    "i": "649",
    "county": "Donegal",
    "rollNumber": "17260U",
    "schoolName": "Scoil An Linbh í­osa",
    "SETHours": "92.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F94AW95",
    "addressOne": "Killymard",
    "addressTwo": "Donegal Town",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.6699215",
    "lng": "-8.1038182",
    "phone": "749722752",
    "email": "killymardschool@gmail.com"
  },
  {
    "i": "650",
    "county": "Donegal",
    "rollNumber": "17268N",
    "schoolName": "Sn An Br M O Cleirigh",
    "SETHours": "95",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.83",
    "spSNA": "0",
    "totalSNA": "5.83",
    "eircode": "F94X766",
    "addressOne": "Creevy",
    "addressTwo": "Ballyshannon",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.5205016",
    "lng": "-8.2269692",
    "phone": "719852090",
    "email": "office@creevyns.ie"
  },
  {
    "i": "651",
    "county": "Donegal",
    "rollNumber": "17328F",
    "schoolName": "Scoil Roisin",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.33",
    "spSNA": "0",
    "totalSNA": "3.33",
    "eircode": "F94WF64",
    "addressOne": "An Clochán Liath",
    "addressTwo": "Co. Dhún Na Ngall",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.932974",
    "lng": "-8.4180835",
    "phone": "749521047",
    "email": "scoilroisin@live.ie"
  },
  {
    "i": "652",
    "county": "Donegal",
    "rollNumber": "17447N",
    "schoolName": "SN Crannaighe Buidhe",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "F94H422",
    "addressOne": "Crannóg BÍ­",
    "addressTwo": "Ardara",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.7712767",
    "lng": "-8.4787241",
    "phone": "749541002",
    "email": "crannogbui1946@gmail.com"
  },
  {
    "i": "653",
    "county": "Donegal",
    "rollNumber": "17469A",
    "schoolName": "Scoil Cuilm Cille",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F93Y227",
    "addressOne": "Ballindrait",
    "addressTwo": "Lifford",
    "addressThree": "Co Donegal",
    "addressFour": "",
    "lat": "54.8440718",
    "lng": "-7.5654861",
    "phone": "749145705",
    "email": "scoilcholmcille@hotmail.com"
  },
  {
    "i": "654",
    "county": "Donegal",
    "rollNumber": "17503U",
    "schoolName": "SN Adhamhnain",
    "SETHours": "65",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "F92C963",
    "addressOne": "An Luinnigh",
    "addressTwo": "Doire Beaga",
    "addressThree": "Leitir Ceanainn",
    "addressFour": "Co. Dhun Na Ngall",
    "lat": "55.0973483",
    "lng": "-8.2790025",
    "phone": "749531547",
    "email": "scoilluinnigh@gmail.com"
  },
  {
    "i": "655",
    "county": "Donegal",
    "rollNumber": "17549V",
    "schoolName": "SN Ceathru Caol",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F92WC60",
    "addressOne": "Kerrykeel",
    "addressTwo": "Letterkenny",
    "addressThree": "Co Donegal",
    "addressFour": "",
    "lat": "55.1380342",
    "lng": "-7.6615427",
    "phone": "749150169",
    "email": "kerrykeelns5@gmail.com"
  },
  {
    "i": "656",
    "county": "Donegal",
    "rollNumber": "17553M",
    "schoolName": "SN Taodhbhog",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F93K028",
    "addressOne": "An Clochan",
    "addressTwo": "Leifearr",
    "addressThree": "Co Dhun Na Ngall",
    "addressFour": "",
    "lat": "54.8374628",
    "lng": "-7.9307288",
    "phone": "749133303",
    "email": "sntaobhoige@gmail.com"
  },
  {
    "i": "657",
    "county": "Donegal",
    "rollNumber": "17564R",
    "schoolName": "SN An Choimin",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F93CF67",
    "addressOne": "An Gharbháin",
    "addressTwo": "An Clochán",
    "addressThree": "Co. Dhún Na Ngall",
    "addressFour": "",
    "lat": "54.8205613",
    "lng": "-7.9681964",
    "phone": "749133330",
    "email": "oifig@coimin.com"
  },
  {
    "i": "658",
    "county": "Donegal",
    "rollNumber": "17575W",
    "schoolName": "SN Gleann Coimhead",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F93XF59",
    "addressOne": "Ballybofey",
    "addressTwo": "Co Donegal",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.7829449",
    "lng": "-7.7607576",
    "phone": "749132785",
    "email": "glencovittns@gmail.com"
  },
  {
    "i": "659",
    "county": "Donegal",
    "rollNumber": "17598L",
    "schoolName": "Sn An Leinbh Iosa",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "F93K662",
    "addressOne": "Carrigans",
    "addressTwo": "Lifford",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.9531985",
    "lng": "-7.4439035",
    "phone": "749140267",
    "email": "info@carrigansns.com"
  },
  {
    "i": "660",
    "county": "Donegal",
    "rollNumber": "17607J",
    "schoolName": "SN Seiseadh Ui Neill",
    "SETHours": "130",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "F93AE24",
    "addressOne": "Sessiaghoneill",
    "addressTwo": "Ballybofey",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.7885488",
    "lng": "-7.7886911",
    "phone": "749132396",
    "email": "principal@sessiaghoneillns.com"
  },
  {
    "i": "661",
    "county": "Donegal",
    "rollNumber": "17704H",
    "schoolName": "Scoil Fhionáin",
    "SETHours": "92.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "3.33",
    "spSNA": "1.66",
    "totalSNA": "4.99",
    "eircode": "F92FW44",
    "addressOne": "Baile Chonaill",
    "addressTwo": "An Fál Carrach",
    "addressThree": "Co. Dhún Na Ngall",
    "addressFour": "",
    "lat": "55.1383697",
    "lng": "-8.0961202",
    "phone": "749135122",
    "email": "scoilfhionain.anfalcarrach@gmail.com"
  },
  {
    "i": "662",
    "county": "Donegal",
    "rollNumber": "17716O",
    "schoolName": "St Riaghans Ns",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "F94NH95",
    "addressOne": "Drimnacrosh",
    "addressTwo": "Glenties",
    "addressThree": "Co Donegal",
    "addressFour": "",
    "lat": "54.7697938",
    "lng": "-8.3232937",
    "phone": "749551591",
    "email": "striaghans@gmail.com"
  },
  {
    "i": "663",
    "county": "Donegal",
    "rollNumber": "17721H",
    "schoolName": "Scoil Treasa Naofa",
    "SETHours": "42.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "3",
    "spSNA": "1",
    "totalSNA": "4",
    "eircode": "F93KP89",
    "addressOne": "Drumcarbit",
    "addressTwo": "Malin",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "55.2985634",
    "lng": "-7.2540623",
    "phone": "749370617",
    "email": "treasanaofamalin@gmail.com"
  },
  {
    "i": "664",
    "county": "Donegal",
    "rollNumber": "17728V",
    "schoolName": "SN Talamh Na Coille",
    "SETHours": "217.5",
    "spClassTeachingPosts": "6",
    "mainSNA": "13.17",
    "spSNA": "8.32",
    "totalSNA": "21.49",
    "eircode": "F92FF84",
    "addressOne": "Rough Park",
    "addressTwo": "Letterkenny",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.9789182",
    "lng": "-7.6764601",
    "phone": "749124498",
    "email": "woodlandnationalschool@gmail.com"
  },
  {
    "i": "665",
    "county": "Donegal",
    "rollNumber": "17729A",
    "schoolName": "Scoil Naomh Proinnseas",
    "SETHours": "60",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F92PK26",
    "addressOne": "Magherabeg",
    "addressTwo": "Manorcunningham",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.9694466",
    "lng": "-7.6119811",
    "phone": "749157400",
    "email": "magherabegns@gmail.com"
  },
  {
    "i": "666",
    "county": "Donegal",
    "rollNumber": "17822N",
    "schoolName": "Scoil Bhrighde",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F92XN81",
    "addressOne": "Mí­n An Chladaigh",
    "addressTwo": "Gort A Choirce",
    "addressThree": "Leitir Ceanainn",
    "addressFour": "Co. Dhún Na Ngall",
    "lat": "55.1408535",
    "lng": "-8.2284035",
    "phone": "749135658",
    "email": "scoilbhride@mail.com"
  },
  {
    "i": "667",
    "county": "Donegal",
    "rollNumber": "17828C",
    "schoolName": "Scoil Adhamhnain",
    "SETHours": "105",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F93K851",
    "addressOne": "Meetinghouse Street",
    "addressTwo": "Raphoe",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.871165",
    "lng": "-7.6054398",
    "phone": "749145764",
    "email": "steunansns.raphoe@gmail.com"
  },
  {
    "i": "668",
    "county": "Donegal",
    "rollNumber": "17831O",
    "schoolName": "Glebe Ns",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "F94K407",
    "addressOne": "The Glebe",
    "addressTwo": "Donegal",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.6506456",
    "lng": "-8.1098806",
    "phone": "749722183",
    "email": "admin@glebenationalschool.ie"
  },
  {
    "i": "669",
    "county": "Donegal",
    "rollNumber": "17837D",
    "schoolName": "Scoil Mhuire",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "F94C960",
    "addressOne": "Pettigo",
    "addressTwo": "Co Donegal",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.546535",
    "lng": "-7.8382406",
    "phone": "719861594",
    "email": "pettigoschool@live.ie"
  },
  {
    "i": "670",
    "county": "Donegal",
    "rollNumber": "17945G",
    "schoolName": "Scoil Naomh Chaitriona",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "F94RK10",
    "addressOne": "College Street",
    "addressTwo": "Ballyshannon",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.5014267",
    "lng": "-8.186165",
    "phone": "719851062",
    "email": "officescoilchaitriona@gmail.com"
  },
  {
    "i": "671",
    "county": "Donegal",
    "rollNumber": "17956L",
    "schoolName": "Scoil Cholmcille Naofa",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F93NC84",
    "addressOne": "Ballylast",
    "addressTwo": "Castlefin",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.8046506",
    "lng": "-7.5373821",
    "phone": "749141341",
    "email": "ballylastns@eircom.net"
  },
  {
    "i": "672",
    "county": "Donegal",
    "rollNumber": "18007N",
    "schoolName": "SN Olibhear Pluinceid",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F94AC96",
    "addressOne": "Rann Na Feirsde",
    "addressTwo": "Anagaire",
    "addressThree": "Co. Dhún Na Ngall",
    "addressFour": "",
    "lat": "55.0378388",
    "lng": "-8.3163087",
    "phone": "749548318",
    "email": "scoilrannnafeirsde@yahoo.com"
  },
  {
    "i": "673",
    "county": "Donegal",
    "rollNumber": "18052S",
    "schoolName": "SN Muire Gan Smal",
    "SETHours": "157.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "F92CK27",
    "addressOne": "Sentry Hill",
    "addressTwo": "Letterkenny",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.9523061",
    "lng": "-7.7414619",
    "phone": "749121171",
    "email": "letterkennysmgs@gmail.com"
  },
  {
    "i": "674",
    "county": "Donegal",
    "rollNumber": "18058H",
    "schoolName": "Scoil Naomh Seosamh",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "F92K403",
    "addressOne": "Rathdonnell",
    "addressTwo": "Letterkenny",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.9934992",
    "lng": "-7.8093834",
    "phone": "749137315",
    "email": "rathdonnellns@hotmail.com"
  },
  {
    "i": "675",
    "county": "Donegal",
    "rollNumber": "18076J",
    "schoolName": "Scoil Náisiúnta Muire Gan Smál",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "F93DE28",
    "addressOne": "Townparks",
    "addressTwo": "Lifford",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.8293895",
    "lng": "-7.4854018",
    "phone": "749141269",
    "email": "liffordns@gmail.com"
  },
  {
    "i": "676",
    "county": "Donegal",
    "rollNumber": "18086M",
    "schoolName": "Dunfanaghy NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F92HD96",
    "addressOne": "Hornhead Rd",
    "addressTwo": "Dunfanaghy",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "55.1824506",
    "lng": "-7.9758803",
    "phone": "749136319",
    "email": "scoiltrionoidenaofa@eircom.net"
  },
  {
    "i": "677",
    "county": "Donegal",
    "rollNumber": "18114O",
    "schoolName": "SN Naomh Eighneach",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F93YN52",
    "addressOne": "Diseart Eighnigh",
    "addressTwo": "Buncrannach",
    "addressThree": "Co Dun Na Ngall",
    "addressFour": "",
    "lat": "55.1871605",
    "lng": "-7.5156989",
    "phone": "749362008",
    "email": "stegneys@gmail.com"
  },
  {
    "i": "678",
    "county": "Donegal",
    "rollNumber": "18120J",
    "schoolName": "Scoil Mhuire",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F92V449",
    "addressOne": "Caiseal",
    "addressTwo": "Ceanndroma O.p.",
    "addressThree": "Fánaid",
    "addressFour": "",
    "lat": "55.2299935",
    "lng": "-7.7231271",
    "phone": "749159369",
    "email": "scoilmhuirecaiseal@gmail.com"
  },
  {
    "i": "679",
    "county": "Donegal",
    "rollNumber": "18129E",
    "schoolName": "Scoil Naomh Peadar",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "F94VX99",
    "addressOne": "Mountcharles",
    "addressTwo": "Co Dun Na Ngall",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.6447139",
    "lng": "-8.1970784",
    "phone": "749735459",
    "email": "stpetersns@gmail.com"
  },
  {
    "i": "680",
    "county": "Donegal",
    "rollNumber": "18131O",
    "schoolName": "SN Muire Gan Smal",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "F94X348",
    "addressOne": "Hillhead",
    "addressTwo": "Ardara",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.7643857",
    "lng": "-8.4066514",
    "phone": "749541903",
    "email": "stmarysardara1956@gmail.com"
  },
  {
    "i": "681",
    "county": "Donegal",
    "rollNumber": "18151U",
    "schoolName": "SN Mhuire",
    "SETHours": "82.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "F92D744",
    "addressOne": "Convent Road",
    "addressTwo": "Milford",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "55.0901852",
    "lng": "-7.7038431",
    "phone": "749153494",
    "email": "milfordns2016@gmail.com"
  },
  {
    "i": "682",
    "county": "Donegal",
    "rollNumber": "18172F",
    "schoolName": "Gleneely NS",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F93EV88",
    "addressOne": "Gleneely",
    "addressTwo": "Killygordon",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.7670889",
    "lng": "-7.6844034",
    "phone": "749149395",
    "email": "principal@gleneely.com"
  },
  {
    "i": "683",
    "county": "Donegal",
    "rollNumber": "18219F",
    "schoolName": "Sn Chonaill",
    "SETHours": "45",
    "spClassTeachingPosts": "3",
    "mainSNA": "1.83",
    "spSNA": "6.66",
    "totalSNA": "8.49",
    "eircode": "F92DD30",
    "addressOne": "Machaire Chlochair",
    "addressTwo": "Bun Beag",
    "addressThree": "Co. Dhún Na Ngall",
    "addressFour": "",
    "lat": "55.0603337",
    "lng": "-8.2985423",
    "phone": "749532535",
    "email": "scoilchonaill.ias@eircom.net"
  },
  {
    "i": "684",
    "county": "Donegal",
    "rollNumber": "18241V",
    "schoolName": "Scoil Naomh Cholmcille",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F92NY91",
    "addressOne": "Drumman",
    "addressTwo": "Ramelton",
    "addressThree": "Co Donegal",
    "addressFour": "",
    "lat": "55.0419955",
    "lng": "-7.7045682",
    "phone": "749151430",
    "email": "drumman@live.ie"
  },
  {
    "i": "685",
    "county": "Donegal",
    "rollNumber": "18250W",
    "schoolName": "SN Baile Mor",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F92E426",
    "addressOne": "Ballymore",
    "addressTwo": "Portnablagh",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "55.1600967",
    "lng": "-7.9223355",
    "phone": "749136255",
    "email": "ballymoreschool@yahoo.co.uk"
  },
  {
    "i": "686",
    "county": "Donegal",
    "rollNumber": "18251B",
    "schoolName": "Ayr Hill NS Ramelton",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F92WT21",
    "addressOne": "Tank Road",
    "addressTwo": "Ramelton",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "55.0360288",
    "lng": "-7.6466328",
    "phone": "749151512",
    "email": "ayrhillns@eircom.net"
  },
  {
    "i": "687",
    "county": "Donegal",
    "rollNumber": "18286U",
    "schoolName": "SN Na Hacrai",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "F94VY97",
    "addressOne": "Acres",
    "addressTwo": "Burtonport",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.9818981",
    "lng": "-8.4230211",
    "phone": "749542134",
    "email": "acresschool@gmail.com"
  },
  {
    "i": "688",
    "county": "Donegal",
    "rollNumber": "18295V",
    "schoolName": "SN Min An Aoire",
    "SETHours": "7.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F94DD80",
    "addressOne": "Meenaneary",
    "addressTwo": "Carrick",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.7028905",
    "lng": "-8.6063248",
    "phone": "749739347",
    "email": "meenanearyns@gmail.com"
  },
  {
    "i": "689",
    "county": "Donegal",
    "rollNumber": "18319J",
    "schoolName": "SN Trianta",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "F92XV20",
    "addressOne": "Triantagh",
    "addressTwo": "Letterkenny",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.9985814",
    "lng": "-7.8424187",
    "phone": "749137494",
    "email": "trentaghns@eircom.net"
  },
  {
    "i": "690",
    "county": "Donegal",
    "rollNumber": "18371L",
    "schoolName": "Scoil Mhuire",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "F92PN84",
    "addressOne": "An Craosloch",
    "addressTwo": "Letterkenny",
    "addressThree": "Co Donegal",
    "addressFour": "",
    "lat": "55.1245135",
    "lng": "-7.9120853",
    "phone": "749138282",
    "email": "creescoilmhuire@gmail.com"
  },
  {
    "i": "691",
    "county": "Donegal",
    "rollNumber": "18421A",
    "schoolName": "Sn Dun Ceannfhaolaidh",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "F94W744",
    "addressOne": "Dunkineely",
    "addressTwo": "Co. Donegal",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.6325129",
    "lng": "-8.3548293",
    "phone": "749737370",
    "email": "dunkineelyns.ias@eircom.net"
  },
  {
    "i": "692",
    "county": "Donegal",
    "rollNumber": "18446Q",
    "schoolName": "Scoil Naomh Mhuire",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F93FP76",
    "addressOne": "Carnmalin",
    "addressTwo": "Malin",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "55.3615766",
    "lng": "-7.3352857",
    "phone": "749370277",
    "email": "admin@malinheadns.com"
  },
  {
    "i": "693",
    "county": "Donegal",
    "rollNumber": "18508M",
    "schoolName": "Naomh Adhamhnain",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F94E365",
    "addressOne": "Laghey",
    "addressTwo": "Co. Donegal",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.6189838",
    "lng": "-8.0889915",
    "phone": "749722730",
    "email": "sainteunans@hotmail.com"
  },
  {
    "i": "694",
    "county": "Donegal",
    "rollNumber": "18517N",
    "schoolName": "Scoil Mhuire",
    "SETHours": "70",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "F93P212",
    "addressOne": "Dristernan",
    "addressTwo": "Gleneely",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "55.2418279",
    "lng": "-7.1511177",
    "phone": "749367236",
    "email": "office@theglen.ie"
  },
  {
    "i": "695",
    "county": "Donegal",
    "rollNumber": "18520C",
    "schoolName": "Scoil Phadraig",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F93PY90",
    "addressOne": "Rashenny",
    "addressTwo": "Clonmany",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "55.2795796",
    "lng": "-7.3492457",
    "phone": "749376310",
    "email": "office@rashennyns.ie"
  },
  {
    "i": "696",
    "county": "Donegal",
    "rollNumber": "18605K",
    "schoolName": "Scoil Naomh Padraig Boys",
    "SETHours": "90",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.5",
    "spSNA": "0",
    "totalSNA": "5.5",
    "eircode": "F93T935",
    "addressOne": "Carndonagh",
    "addressTwo": "Co Donegal",
    "addressThree": "",
    "addressFour": "",
    "lat": "55.2496609",
    "lng": "-7.266996",
    "phone": "749374136",
    "email": "stpatsboyscarn@gmail.com"
  },
  {
    "i": "697",
    "county": "Donegal",
    "rollNumber": "18611F",
    "schoolName": "SN Na Carraige",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F94H674",
    "addressOne": "An Charraig",
    "addressTwo": "Co. Dhún Na Ngall",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.6582278",
    "lng": "-8.6319995",
    "phone": "749739244",
    "email": "scoilnacarraige@gmail.com"
  },
  {
    "i": "698",
    "county": "Donegal",
    "rollNumber": "18625Q",
    "schoolName": "Scoil Choilmcille",
    "SETHours": "275",
    "spClassTeachingPosts": "0",
    "mainSNA": "9",
    "spSNA": "0",
    "totalSNA": "9",
    "eircode": "F92A386",
    "addressOne": "Convent Road",
    "addressTwo": "Letterkenny",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.9502264",
    "lng": "-7.7436384",
    "phone": "749122772",
    "email": "scoilcolmcillelk@eircom.net"
  },
  {
    "i": "699",
    "county": "Donegal",
    "rollNumber": "18652T",
    "schoolName": "SN An Chaiseal",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "F94W968",
    "addressOne": "An Caiseal",
    "addressTwo": "Gleann Cholmcille",
    "addressThree": "Co. Dhún Na Ngall",
    "addressFour": "",
    "lat": "54.7066213",
    "lng": "-8.7244286",
    "phone": "749730081",
    "email": "scoilanchaisil@gmail.com"
  },
  {
    "i": "700",
    "county": "Donegal",
    "rollNumber": "18700E",
    "schoolName": "SN Baile An Caislean",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F93Y291",
    "addressOne": "Castletown",
    "addressTwo": "St Johnston",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.9196402",
    "lng": "-7.4892886",
    "phone": "749148420",
    "email": "castletownn@gmail.com"
  },
  {
    "i": "701",
    "county": "Donegal",
    "rollNumber": "18703K",
    "schoolName": "SN Baile An Bhailsig",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F93EW74",
    "addressOne": "Welchtown",
    "addressTwo": "Ballybofey",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.8167944",
    "lng": "-7.8646221",
    "phone": "749131855",
    "email": "office@welchtownschool.com"
  },
  {
    "i": "702",
    "county": "Donegal",
    "rollNumber": "18710H",
    "schoolName": "Sn Na Croise Naofa",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F92T3Y8",
    "addressOne": "Dunfanaghy",
    "addressTwo": "Letterkenny",
    "addressThree": "",
    "addressFour": "",
    "lat": "55.1811518",
    "lng": "-7.9757615",
    "phone": "749136618",
    "email": "scoilnacroisenaofadunfanaghy@gmail.com"
  },
  {
    "i": "703",
    "county": "Donegal",
    "rollNumber": "18731P",
    "schoolName": "Robertson NS",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F93XV29",
    "addressOne": "Church Road",
    "addressTwo": "Stranordlar",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.8056141",
    "lng": "-7.7629089",
    "phone": "749132757",
    "email": "office@robertsonns.com"
  },
  {
    "i": "704",
    "county": "Donegal",
    "rollNumber": "18737E",
    "schoolName": "Scoil Bhride",
    "SETHours": "87.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "5.66",
    "spSNA": "1",
    "totalSNA": "6.66",
    "eircode": "F93V095",
    "addressOne": "Convoy",
    "addressTwo": "Lifford",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.8614027",
    "lng": "-7.6702166",
    "phone": "749147288",
    "email": "scoilbhrideconmhaigh@hotmail.com"
  },
  {
    "i": "705",
    "county": "Donegal",
    "rollNumber": "18766L",
    "schoolName": "Scoil Cholmcille",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "F92E680",
    "addressOne": "Dubhlinn Riabhach",
    "addressTwo": "Carraig Airt",
    "addressThree": "Leitir Ceanainn",
    "addressFour": "Co. Dhún Na Ngall",
    "lat": "55.1679072",
    "lng": "-7.7348657",
    "phone": "749155440",
    "email": "devlinreagh@gmail.com"
  },
  {
    "i": "706",
    "county": "Donegal",
    "rollNumber": "18791K",
    "schoolName": "Scoil Cholmcille",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F93E890",
    "addressOne": "Droim An Mhaoir",
    "addressTwo": "Moville",
    "addressThree": "Co Donegal",
    "addressFour": "",
    "lat": "55.2042043",
    "lng": "-6.9822018",
    "phone": "749381201",
    "email": "scoilcholmcille86@gmail.com"
  },
  {
    "i": "707",
    "county": "Donegal",
    "rollNumber": "18844F",
    "schoolName": "Scoil Mhuire",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "F94EK09",
    "addressOne": "Belcruit",
    "addressTwo": "Kincasslagh",
    "addressThree": "Letterkenny",
    "addressFour": "Co. Donegal",
    "lat": "55.0176694",
    "lng": "-8.3967904",
    "phone": "749543364",
    "email": "scoilmhuirebelcruit@gmail.com"
  },
  {
    "i": "708",
    "county": "Donegal",
    "rollNumber": "18874O",
    "schoolName": "Killygordan NS",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F93A0CP",
    "addressOne": "Main Street",
    "addressTwo": "Killygordon",
    "addressThree": "Lifford",
    "addressFour": "Co. Donegal",
    "lat": "54.7970214",
    "lng": "-7.6856342",
    "phone": "749149052",
    "email": "killygordonns64@gmail.com"
  },
  {
    "i": "709",
    "county": "Donegal",
    "rollNumber": "18939Q",
    "schoolName": "SN Donaigh",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F93CX21",
    "addressOne": "Carndonagh",
    "addressTwo": "Co Donegal",
    "addressThree": "",
    "addressFour": "",
    "lat": "55.241917",
    "lng": "-7.2770193",
    "phone": "749374556",
    "email": "office@donaghns.ie"
  },
  {
    "i": "710",
    "county": "Donegal",
    "rollNumber": "19009W",
    "schoolName": "Cranford NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F92TV00",
    "addressOne": "Cranford",
    "addressTwo": "Letterkenny",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "55.1383396",
    "lng": "-7.6970095",
    "phone": "749153437",
    "email": "cranfordns.ias@gmail.com"
  },
  {
    "i": "711",
    "county": "Donegal",
    "rollNumber": "19089A",
    "schoolName": "Killaghtee NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "F94PY82",
    "addressOne": "Killaghtee",
    "addressTwo": "Dunkineely",
    "addressThree": "Co Donegal",
    "addressFour": "",
    "lat": "54.6323769",
    "lng": "-8.3710133",
    "phone": "749737433",
    "email": "killaghteejunior@gmail.com"
  },
  {
    "i": "712",
    "county": "Donegal",
    "rollNumber": "19228L",
    "schoolName": "SN Naomh Brid",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "F92XP86",
    "addressOne": "Na Dúnaibh",
    "addressTwo": "Leitir Ceanainn",
    "addressThree": "Co. Dhún Na Ngall",
    "addressFour": "",
    "lat": "55.1948468",
    "lng": "-7.8228374",
    "phone": "749155490",
    "email": "scoilnaomhbridns@gmail.com"
  },
  {
    "i": "713",
    "county": "Donegal",
    "rollNumber": "19235I",
    "schoolName": "Portlean NS",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F92T256",
    "addressOne": "Kilmacrennan",
    "addressTwo": "Letterkenny",
    "addressThree": "",
    "addressFour": "",
    "lat": "55.058351",
    "lng": "-7.7294345",
    "phone": "749153556",
    "email": "portleanns1@gmail.com"
  },
  {
    "i": "714",
    "county": "Donegal",
    "rollNumber": "19252I",
    "schoolName": "Scoil Eoin Baiste",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "F92HD88",
    "addressOne": "Umlagh",
    "addressTwo": "Carrigart",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "55.1698481",
    "lng": "-7.8012956",
    "phone": "749155132",
    "email": "carrigartns@gmail.com"
  },
  {
    "i": "715",
    "county": "Donegal",
    "rollNumber": "19260H",
    "schoolName": "SN Cholmcille",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F94VR04",
    "addressOne": "Baile Na Finne",
    "addressTwo": "Co Dhun Na Ngall",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.8700333",
    "lng": "-8.1169144",
    "phone": "749546209",
    "email": "sncolmcille@gmail.com"
  },
  {
    "i": "716",
    "county": "Donegal",
    "rollNumber": "19280N",
    "schoolName": "Scoil Naomh Brid",
    "SETHours": "65",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "F93YV78",
    "addressOne": "Muff",
    "addressTwo": "Lifford",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "55.0734125",
    "lng": "-7.2695013",
    "phone": "749384136",
    "email": "scoilnaomhbrid.ias@eircom.net"
  },
  {
    "i": "717",
    "county": "Donegal",
    "rollNumber": "19310T",
    "schoolName": "Scoil Naomh Earnan",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "F94W018",
    "addressOne": "Lisminton",
    "addressTwo": "Ballintra",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.583966",
    "lng": "-8.1196743",
    "phone": "749734440",
    "email": "sternansns@hotmail.com"
  },
  {
    "i": "718",
    "county": "Donegal",
    "rollNumber": "19313C",
    "schoolName": "Glenswilly NS",
    "SETHours": "132.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.5",
    "spSNA": "0",
    "totalSNA": "5.5",
    "eircode": "F92RH94",
    "addressOne": "Newmills",
    "addressTwo": "Letterkenny",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.9359231",
    "lng": "-7.8492826",
    "phone": "749137342",
    "email": "glenswillyns@glenswilly.com"
  },
  {
    "i": "719",
    "county": "Donegal",
    "rollNumber": "19333I",
    "schoolName": "Dooish NS",
    "SETHours": "57.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "3",
    "spSNA": "2.83",
    "totalSNA": "5.83",
    "eircode": "F93N768",
    "addressOne": "Ballybofey",
    "addressTwo": "Co Donegal",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.809337",
    "lng": "-7.8447762",
    "phone": "749131471",
    "email": "dooish@hotmail.com"
  },
  {
    "i": "720",
    "county": "Donegal",
    "rollNumber": "19343L",
    "schoolName": "SN Dhubhthaigh",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F94YH05",
    "addressOne": "Anagaire",
    "addressTwo": "Leitir Ceanainn",
    "addressThree": "Co Dhun Na Ngall",
    "addressFour": "",
    "lat": "55.0214356",
    "lng": "-8.3071716",
    "phone": "749548162",
    "email": "annagryns@gmail.com"
  },
  {
    "i": "721",
    "county": "Donegal",
    "rollNumber": "19359D",
    "schoolName": "SN Naomh Aonghus",
    "SETHours": "102.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F93YX38",
    "addressOne": "Bunnmayne",
    "addressTwo": "Bridge End",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "55.0364143",
    "lng": "-7.3825398",
    "phone": "749368352",
    "email": "aengusns@gmail.com"
  },
  {
    "i": "722",
    "county": "Donegal",
    "rollNumber": "19411C",
    "schoolName": "SN Baile Raighin",
    "SETHours": "112.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "6.5",
    "spSNA": "0",
    "totalSNA": "6.5",
    "eircode": "F92CX29",
    "addressOne": "Letterkenny",
    "addressTwo": "Co. Donegal",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.9515556",
    "lng": "-7.712518",
    "phone": "749124758",
    "email": "ballyrainens@gmail.com"
  },
  {
    "i": "723",
    "county": "Donegal",
    "rollNumber": "19491D",
    "schoolName": "Scoil Mhuire",
    "SETHours": "82.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "F92XHW5",
    "addressOne": "Ramelton",
    "addressTwo": "Co. Donegal",
    "addressThree": "",
    "addressFour": "",
    "lat": "55.0335902",
    "lng": "-7.6495876",
    "phone": "749151215",
    "email": "scoilmhuireno1@gmail.com"
  },
  {
    "i": "724",
    "county": "Donegal",
    "rollNumber": "19518U",
    "schoolName": "SN Naomh Baoithin",
    "SETHours": "77.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "4",
    "spSNA": "2",
    "totalSNA": "6",
    "eircode": "F93WN24",
    "addressOne": "St Johnston",
    "addressTwo": "Lifford",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.933029",
    "lng": "-7.4627133",
    "phone": "749148327",
    "email": "stbaithins.ias@eircom.net"
  },
  {
    "i": "725",
    "county": "Donegal",
    "rollNumber": "19614Q",
    "schoolName": "Naomh Bodain",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "F93EP30",
    "addressOne": "Culdaff",
    "addressTwo": "Lifford",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "55.2849215",
    "lng": "-7.1670254",
    "phone": "749379179",
    "email": "stbodensoffice@gmail.com"
  },
  {
    "i": "726",
    "county": "Donegal",
    "rollNumber": "19633U",
    "schoolName": "Moyle NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "F93XD25",
    "addressOne": "Moyle NS",
    "addressTwo": "Newtowncunningham",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.9989738",
    "lng": "-7.531385",
    "phone": "749156192",
    "email": "moylen.s@gmail.com"
  },
  {
    "i": "727",
    "county": "Donegal",
    "rollNumber": "19685Q",
    "schoolName": "Scoil Chartha Naofa",
    "SETHours": "60",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F94KC99",
    "addressOne": "Chill Chartha",
    "addressTwo": "Co Dhun Na Ngall",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.6363938",
    "lng": "-8.5902988",
    "phone": "749738092",
    "email": "sncillchartha@eircom.net"
  },
  {
    "i": "728",
    "county": "Donegal",
    "rollNumber": "19686S",
    "schoolName": "St Macartans Central",
    "SETHours": "117.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.16",
    "spSNA": "0",
    "totalSNA": "3.16",
    "eircode": "F94EH33",
    "addressOne": "Bundoran",
    "addressTwo": "Co. Donegal",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.4758022",
    "lng": "-8.2816309",
    "phone": "719841711",
    "email": "ronantighe@stmacartans.ie"
  },
  {
    "i": "729",
    "county": "Donegal",
    "rollNumber": "19756N",
    "schoolName": "St Conals",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "F94P021",
    "addressOne": "Narin",
    "addressTwo": "Portnoo",
    "addressThree": "Co Donegal",
    "addressFour": "",
    "lat": "54.8285548",
    "lng": "-8.4450241",
    "phone": "749545379",
    "email": "school@stconals.ie"
  },
  {
    "i": "730",
    "county": "Donegal",
    "rollNumber": "19912B",
    "schoolName": "Scoil Mhuire",
    "SETHours": "70",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "F94HT62",
    "addressOne": "Glenties",
    "addressTwo": "Co. Donegal",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.7947958",
    "lng": "-8.2789301",
    "phone": "749551521",
    "email": "glentiesns@gmail.com"
  },
  {
    "i": "731",
    "county": "Donegal",
    "rollNumber": "19927O",
    "schoolName": "Scoil Mhuire B & C",
    "SETHours": "200",
    "spClassTeachingPosts": "2",
    "mainSNA": "6.5",
    "spSNA": "3.66",
    "totalSNA": "10.16",
    "eircode": "F93F9TF",
    "addressOne": "Main Street",
    "addressTwo": "Stranorlar",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.8025272",
    "lng": "-7.7758624",
    "phone": "749131877",
    "email": "stranorlarprincipal@gmail.com"
  },
  {
    "i": "732",
    "county": "Donegal",
    "rollNumber": "19959E",
    "schoolName": "Scoil Naomh Fionan",
    "SETHours": "85",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.49",
    "spSNA": "0",
    "totalSNA": "4.49",
    "eircode": "F93XR29",
    "addressOne": "Whitecastle",
    "addressTwo": "Quigley's Point",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "55.1403981",
    "lng": "-7.1772731",
    "phone": "749383228",
    "email": "snf.ias@eircom.net"
  },
  {
    "i": "733",
    "county": "Donegal",
    "rollNumber": "19963S",
    "schoolName": "Scoil Aodh Rua&nuala",
    "SETHours": "67.5",
    "spClassTeachingPosts": "4",
    "mainSNA": "3",
    "spSNA": "8.16",
    "totalSNA": "11.16",
    "eircode": "F94H792",
    "addressOne": "Upper Main Street",
    "addressTwo": "Donegal Town",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.6547046",
    "lng": "-8.1003327",
    "phone": "749722661",
    "email": "scoilaodhrua@gmail.com"
  },
  {
    "i": "734",
    "county": "Donegal",
    "rollNumber": "19967D",
    "schoolName": "Scoil Iosagain",
    "SETHours": "350",
    "spClassTeachingPosts": "10",
    "mainSNA": "12",
    "spSNA": "25.16",
    "totalSNA": "37.16",
    "eircode": "F93RF77",
    "addressOne": "St Mary's Road",
    "addressTwo": "Buncrana",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "53.3302878",
    "lng": "-6.2879901",
    "phone": "749362450",
    "email": "receptionists@scoiliosagain.ie"
  },
  {
    "i": "735",
    "county": "Donegal",
    "rollNumber": "19971R",
    "schoolName": "Gaelscoil Adhamhnain",
    "SETHours": "120",
    "spClassTeachingPosts": "0",
    "mainSNA": "5",
    "spSNA": "0",
    "totalSNA": "5",
    "eircode": "F92PV04",
    "addressOne": "Gleann Cearra",
    "addressTwo": "Leitir Ceanainn",
    "addressThree": "Co. Dhún Na Ngall",
    "addressFour": "",
    "lat": "54.9570044",
    "lng": "-7.7499051",
    "phone": "749126117",
    "email": "gs.ias@eircom.net"
  },
  {
    "i": "736",
    "county": "Donegal",
    "rollNumber": "20054L",
    "schoolName": "Scoil Eoghan",
    "SETHours": "127.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.83",
    "spSNA": "0",
    "totalSNA": "5.83",
    "eircode": "F93A970",
    "addressOne": "Bath Terrace Lane",
    "addressTwo": "Moville",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "55.1906113",
    "lng": "-7.0383659",
    "phone": "749382951",
    "email": "scoileoghain@gmail.com"
  },
  {
    "i": "737",
    "county": "Donegal",
    "rollNumber": "20096E",
    "schoolName": "Gaelscoil Na Gceithre Maistri",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "F94T863",
    "addressOne": "Páirc An Tsrutháin",
    "addressTwo": "Baile Dhún Na Ngall",
    "addressThree": "Co Dhún Na Ngall",
    "addressFour": "",
    "lat": "54.6429131",
    "lng": "-8.0963746",
    "phone": "749721095",
    "email": "gaelscoil4m@gmail.com"
  },
  {
    "i": "738",
    "county": "Donegal",
    "rollNumber": "20097G",
    "schoolName": "Gaelscoil Bhun Crannach",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "F93YW18",
    "addressOne": "Ascaill An Chaisleain",
    "addressTwo": "Bun Cranncha",
    "addressThree": "Co. Dhún Na Ngall",
    "addressFour": "",
    "lat": "55.1376866",
    "lng": "-7.4602392",
    "phone": "749361988",
    "email": "gsbc1999@gmail.com"
  },
  {
    "i": "739",
    "county": "Donegal",
    "rollNumber": "20144M",
    "schoolName": "Gaelscoil Chois Feabhaill",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.33",
    "spSNA": "0",
    "totalSNA": "2.33",
    "eircode": "F93YXD2",
    "addressOne": "Carn Na Gairbhe",
    "addressTwo": "Bun An Phobail",
    "addressThree": "Co. Dhún Na Ngall",
    "addressFour": "",
    "lat": "55.1946354",
    "lng": "-7.0226352",
    "phone": "749385762",
    "email": "info@gaelscoilcoisfeabhail.com"
  },
  {
    "i": "740",
    "county": "Donegal",
    "rollNumber": "20150H",
    "schoolName": "Holy Family NS",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F94F259",
    "addressOne": "East Rock",
    "addressTwo": "Ballyshannon",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.4989249",
    "lng": "-8.1910115",
    "phone": "719851689",
    "email": "principal@holyfamilyballyshannon.ie"
  },
  {
    "i": "741",
    "county": "Donegal",
    "rollNumber": "20167B",
    "schoolName": "Gaelscoil Eirne",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "F94KP62",
    "addressOne": "Fearainn An Bhaile",
    "addressTwo": "Béal átha Seannaigh",
    "addressThree": "Co. Dhún Na Ngall",
    "addressFour": "",
    "lat": "54.5039824",
    "lng": "-8.189812",
    "phone": "719822780",
    "email": "gaelscoileirne@gmail.com"
  },
  {
    "i": "742",
    "county": "Donegal",
    "rollNumber": "20235P",
    "schoolName": "Letterkenny Educate Together",
    "SETHours": "160",
    "spClassTeachingPosts": "2",
    "mainSNA": "7",
    "spSNA": "4",
    "totalSNA": "11",
    "eircode": "F92XCW9",
    "addressOne": "Kiltoy",
    "addressTwo": "Letterkenny",
    "addressThree": "Co. Donegal",
    "addressFour": "",
    "lat": "54.9607156",
    "lng": "-7.7062437",
    "phone": "749103794",
    "email": "info@letterkennyetns.ie"
  },
  {
    "i": "743",
    "county": "Donegal",
    "rollNumber": "20421M",
    "schoolName": "Scoil Chróine",
    "SETHours": "115",
    "spClassTeachingPosts": "3",
    "mainSNA": "8",
    "spSNA": "6",
    "totalSNA": "14",
    "eircode": "F94YV26",
    "addressOne": "An Clochán Liath",
    "addressTwo": "Co. Dhún Na Ngall",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.9490104",
    "lng": "-8.3570796",
    "phone": "749521316",
    "email": "dungloens.ias@eircom.net"
  },
  {
    "i": "744",
    "county": "Dublin",
    "rollNumber": "00697S",
    "schoolName": "St Brigids Mxd NS",
    "SETHours": "240",
    "spClassTeachingPosts": "0",
    "mainSNA": "12.49",
    "spSNA": "0",
    "totalSNA": "12.49",
    "eircode": "D15P820",
    "addressOne": "Beechpark Lawn",
    "addressTwo": "Castleknock",
    "addressThree": "Dublin 15",
    "addressFour": "",
    "lat": "53.3750893",
    "lng": "-6.3621838",
    "phone": "18214040",
    "email": "principal@saintbrigids.ie"
  },
  {
    "i": "745",
    "county": "Dublin",
    "rollNumber": "00714P",
    "schoolName": "Lucan BNS",
    "SETHours": "170",
    "spClassTeachingPosts": "0",
    "mainSNA": "8.66",
    "spSNA": "0",
    "totalSNA": "8.66",
    "eircode": "K78YD27",
    "addressOne": "Chapel Hill",
    "addressTwo": "Lucan",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.3595512",
    "lng": "-6.443592",
    "phone": "16281857",
    "email": "info@stmarysbnslucan.com"
  },
  {
    "i": "746",
    "county": "Dublin",
    "rollNumber": "00729F",
    "schoolName": "Clochar Loreto NS",
    "SETHours": "100",
    "spClassTeachingPosts": "1",
    "mainSNA": "5.33",
    "spSNA": "1.83",
    "totalSNA": "7.16",
    "eircode": "D14YY28",
    "addressOne": "Grange Road",
    "addressTwo": "Rathfarnham",
    "addressThree": "Dublin 14",
    "addressFour": "",
    "lat": "53.2912791",
    "lng": "-6.2788294",
    "phone": "14931640",
    "email": "info@loretograngeroad.ie"
  },
  {
    "i": "747",
    "county": "Dublin",
    "rollNumber": "00752A",
    "schoolName": "Central Sn Mxd NS",
    "SETHours": "107.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "D01P027",
    "addressOne": "Marlborough Street",
    "addressTwo": "Dublin 1",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3514878",
    "lng": "-6.2560091",
    "phone": "18788103",
    "email": "modesenmix@eircom.net"
  },
  {
    "i": "748",
    "county": "Dublin",
    "rollNumber": "01170G",
    "schoolName": "SN Na H-aille",
    "SETHours": "45",
    "spClassTeachingPosts": "1",
    "mainSNA": "2.5",
    "spSNA": "1",
    "totalSNA": "3.5",
    "eircode": "K32PX40",
    "addressOne": "Westown",
    "addressTwo": "Naul",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.5788742",
    "lng": "-6.2856359",
    "phone": "18413821",
    "email": "naulns@eircom.net"
  },
  {
    "i": "749",
    "county": "Dublin",
    "rollNumber": "01795A",
    "schoolName": "Central Infs School",
    "SETHours": "87.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.49",
    "spSNA": "0",
    "totalSNA": "2.49",
    "eircode": "D01ER24",
    "addressOne": "Marlborough Street",
    "addressTwo": "Dublin 1",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3512359",
    "lng": "-6.255884",
    "phone": "18788344",
    "email": "info@centralmodelinfantschool.ie"
  },
  {
    "i": "750",
    "county": "Dublin",
    "rollNumber": "02872U",
    "schoolName": "St. Mary's NS",
    "SETHours": "137.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.5",
    "spSNA": "0",
    "totalSNA": "5.5",
    "eircode": "D18XV90",
    "addressOne": "Lamb's Cross",
    "addressTwo": "Sandyford",
    "addressThree": "Dublin 18",
    "addressFour": "",
    "lat": "53.2642149",
    "lng": "-6.2294858",
    "phone": "12954173",
    "email": "saintmarys@eircom.net"
  },
  {
    "i": "751",
    "county": "Dublin",
    "rollNumber": "03359N",
    "schoolName": "Ballyroan BNS",
    "SETHours": "150",
    "spClassTeachingPosts": "0",
    "mainSNA": "6",
    "spSNA": "0",
    "totalSNA": "6",
    "eircode": "D16YX54",
    "addressOne": "Ballyroan Road",
    "addressTwo": "Rathfarnham",
    "addressThree": "Dublin 16",
    "addressFour": "",
    "lat": "53.2864382",
    "lng": "-6.294438",
    "phone": "14931805",
    "email": "secretary@ballyroanbns.ie"
  },
  {
    "i": "752",
    "county": "Dublin",
    "rollNumber": "03917V",
    "schoolName": "Naomh Padraig Boys",
    "SETHours": "82.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "D04AP98",
    "addressOne": "Cambridge Road",
    "addressTwo": "Ringsend",
    "addressThree": "Dublin 4",
    "addressFour": "",
    "lat": "53.3434257",
    "lng": "-6.2253096",
    "phone": "16606825",
    "email": "ringsendbns@gmail.com"
  },
  {
    "i": "753",
    "county": "Dublin",
    "rollNumber": "04992R",
    "schoolName": "Scoil An Croi Naofa",
    "SETHours": "175",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.16",
    "spSNA": "0",
    "totalSNA": "5.16",
    "eircode": "D11XE17",
    "addressOne": "St Canice's Road",
    "addressTwo": "Ballygall",
    "addressThree": "Dublin 11",
    "addressFour": "",
    "lat": "53.3841758",
    "lng": "-6.2743337",
    "phone": "18379586",
    "email": "shbns1ballygall@gmail.com"
  },
  {
    "i": "754",
    "county": "Dublin",
    "rollNumber": "05600C",
    "schoolName": "Clochar San Dominic",
    "SETHours": "90",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "A96V2P2",
    "addressOne": "Convent Road",
    "addressTwo": "Dun Laoghaire",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.292207",
    "lng": "-6.1380643",
    "phone": "12809011",
    "email": "mail@dominicandunlaoghaire.ie"
  },
  {
    "i": "755",
    "county": "Dublin",
    "rollNumber": "05933G",
    "schoolName": "Presentation Primary School",
    "SETHours": "70",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "D07YF43",
    "addressOne": "George's Hill",
    "addressTwo": "Halston Street",
    "addressThree": "Dublin 7",
    "addressFour": "",
    "lat": "53.3483046",
    "lng": "-6.2717822",
    "phone": "18733061",
    "email": "secretary@georgeshillschool.ie"
  },
  {
    "i": "756",
    "county": "Dublin",
    "rollNumber": "06200O",
    "schoolName": "Booterstown Boys",
    "SETHours": "112.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "8.16",
    "spSNA": "0",
    "totalSNA": "8.16",
    "eircode": "A94AC97",
    "addressOne": "Grotto Place",
    "addressTwo": "Booterstown",
    "addressThree": "Blackrock",
    "addressFour": "Co. Dublin",
    "lat": "53.3089685",
    "lng": "-6.1989355",
    "phone": "12886830",
    "email": "booterstownbns.ias@eircom.net"
  },
  {
    "i": "757",
    "county": "Dublin",
    "rollNumber": "07546J",
    "schoolName": "Goldenbridge Convent",
    "SETHours": "152.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "6.83",
    "spSNA": "0",
    "totalSNA": "6.83",
    "eircode": "D08AY94",
    "addressOne": "Saint Vincent Street West",
    "addressTwo": "Goldenbridge",
    "addressThree": "Inchicore",
    "addressFour": "Dublin 8",
    "lat": "53.3366757",
    "lng": "-6.3190909",
    "phone": "14541265",
    "email": "ololns.ias@gmail.com"
  },
  {
    "i": "758",
    "county": "Dublin",
    "rollNumber": "09492W",
    "schoolName": "Balscadden NS",
    "SETHours": "107.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.33",
    "spSNA": "0",
    "totalSNA": "4.33",
    "eircode": "K32VK33",
    "addressOne": "Balscadden",
    "addressTwo": "Ring Commons",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.6152784",
    "lng": "-6.2321771",
    "phone": "18412579",
    "email": "balscadden.ias@eircom.net"
  },
  {
    "i": "759",
    "county": "Dublin",
    "rollNumber": "09642P",
    "schoolName": "Burrow NS",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "D13TC04",
    "addressOne": "Howth Road",
    "addressTwo": "Sutton",
    "addressThree": "Dublin 13",
    "addressFour": "",
    "lat": "53.3912904",
    "lng": "-6.1002848",
    "phone": "18325784",
    "email": "burrowsecretary@gmail.com"
  },
  {
    "i": "760",
    "county": "Dublin",
    "rollNumber": "09750S",
    "schoolName": "St Josephs Boys NS",
    "SETHours": "152.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "D06ED86",
    "addressOne": "Terenure Road East",
    "addressTwo": "Dublin 6",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.30966",
    "lng": "-6.2820528",
    "phone": "14906905",
    "email": "office@stjosephsterenure.ie"
  },
  {
    "i": "761",
    "county": "Dublin",
    "rollNumber": "09932B",
    "schoolName": "Stanhope St Convent",
    "SETHours": "203.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.66",
    "spSNA": "0",
    "totalSNA": "3.66",
    "eircode": "D07DY60",
    "addressOne": "Manor Street",
    "addressTwo": "Stoneybatter",
    "addressThree": "Dublin 7",
    "addressFour": "",
    "lat": "53.3526296",
    "lng": "-6.2807151",
    "phone": "16716686",
    "email": "admin@stanhopestreetprimary.ie"
  },
  {
    "i": "762",
    "county": "Dublin",
    "rollNumber": "10296G",
    "schoolName": "Scoil Naomh Mearnog",
    "SETHours": "197.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "7.66",
    "spSNA": "0.33",
    "totalSNA": "7.99",
    "eircode": "D13PF29",
    "addressOne": "Strand Road",
    "addressTwo": "Portmarnock",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.4222165",
    "lng": "-6.1349945",
    "phone": "18462060",
    "email": "stmarnocksns@gmail.com"
  },
  {
    "i": "763",
    "county": "Dublin",
    "rollNumber": "10494K",
    "schoolName": "All Saints NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "A94RC44",
    "addressOne": "Carysfort Avenue",
    "addressTwo": "Blackrock",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.2893756",
    "lng": "-6.1808775",
    "phone": "12885355",
    "email": "allsaintsnsblackrock@gmail.com"
  },
  {
    "i": "764",
    "county": "Dublin",
    "rollNumber": "10653E",
    "schoolName": "Chapelizod NS",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "D20PH32",
    "addressOne": "Martin's Row",
    "addressTwo": "Chapelizod",
    "addressThree": "Dublin 20",
    "addressFour": "",
    "lat": "53.3502723",
    "lng": "-6.3447082",
    "phone": "860205494",
    "email": "info@stlaurenceschapelizod.com"
  },
  {
    "i": "765",
    "county": "Dublin",
    "rollNumber": "11525A",
    "schoolName": "St Patricks N School",
    "SETHours": "167.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "7",
    "spSNA": "1.33",
    "totalSNA": "8.33",
    "eircode": "D09H008",
    "addressOne": "Millbourne Avenue",
    "addressTwo": "Drumcondra",
    "addressThree": "Dublin 9",
    "addressFour": "",
    "lat": "53.3702038",
    "lng": "-6.2582926",
    "phone": "18372714",
    "email": "saintpatricksbns@gmail.com"
  },
  {
    "i": "766",
    "county": "Dublin",
    "rollNumber": "11578V",
    "schoolName": "City Quay Ns",
    "SETHours": "112.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "D02H277",
    "addressOne": "City Quay",
    "addressTwo": "Gloucester Street South",
    "addressThree": "Dublin 2",
    "addressFour": "",
    "lat": "53.3466149",
    "lng": "-6.251301",
    "phone": "16713754",
    "email": "cityquayns@hotmail.com"
  },
  {
    "i": "767",
    "county": "Dublin",
    "rollNumber": "11583O",
    "schoolName": "St Andrews NS",
    "SETHours": "82.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "K36HD54",
    "addressOne": "Church Road",
    "addressTwo": "Malahide",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.4489088",
    "lng": "-6.1529635",
    "phone": "18450185",
    "email": "office@standrewsns.ie"
  },
  {
    "i": "768",
    "county": "Dublin",
    "rollNumber": "11638N",
    "schoolName": "Whitechurch Nat School",
    "SETHours": "87.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "5",
    "spSNA": "0",
    "totalSNA": "5",
    "eircode": "D16Y1X3",
    "addressOne": "Whitechurch Road",
    "addressTwo": "Rathfarnham",
    "addressThree": "Dublin 16",
    "addressFour": "",
    "lat": "53.2719354",
    "lng": "-6.2822762",
    "phone": "14942177",
    "email": "office@whitechurchns.biz"
  },
  {
    "i": "769",
    "county": "Dublin",
    "rollNumber": "11873A",
    "schoolName": "Rathmichael NS",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.16",
    "spSNA": "0",
    "totalSNA": "3.16",
    "eircode": "D18ET38",
    "addressOne": "Rathmichael",
    "addressTwo": "Shankill",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.2361475",
    "lng": "-6.1277044",
    "phone": "12824794",
    "email": "caroline.senior@rathmichaelschool.com"
  },
  {
    "i": "770",
    "county": "Dublin",
    "rollNumber": "11894I",
    "schoolName": "Scoil Mhuire",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "D04DC04",
    "addressOne": "Gilford Road",
    "addressTwo": "Sandymount",
    "addressThree": "Dublin 4",
    "addressFour": "",
    "lat": "53.3282428",
    "lng": "-6.2121813",
    "phone": "12695273",
    "email": "scoil.mhuire@hotmail.com"
  },
  {
    "i": "771",
    "county": "Dublin",
    "rollNumber": "12014D",
    "schoolName": "St Andrews NS",
    "SETHours": "122.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "11.66",
    "spSNA": "2.83",
    "totalSNA": "14.49",
    "eircode": "K78NX88",
    "addressOne": "St Edmundsbury",
    "addressTwo": "Lucan Road",
    "addressThree": "Lucan",
    "addressFour": "Co. Dublin",
    "lat": "53.3601474",
    "lng": "-6.4350713",
    "phone": "16280975",
    "email": "stanso@eircom.net"
  },
  {
    "i": "772",
    "county": "Dublin",
    "rollNumber": "12358M",
    "schoolName": "Swords Borough NS",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "K67Y179",
    "addressOne": "Church Road",
    "addressTwo": "Swords",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.4574521",
    "lng": "-6.22313",
    "phone": "18407036",
    "email": "info@oldboroughschool.ie"
  },
  {
    "i": "773",
    "county": "Dublin",
    "rollNumber": "12448N",
    "schoolName": "Gardiner Street Convent",
    "SETHours": "185.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "D01H9C5",
    "addressOne": "Gardiner Street",
    "addressTwo": "Belvedere Court",
    "addressThree": "Dublin 1",
    "addressFour": "",
    "lat": "53.3580992",
    "lng": "-6.2588875",
    "phone": "18722894",
    "email": "eileengardinerstreet@eircom.net"
  },
  {
    "i": "774",
    "county": "Dublin",
    "rollNumber": "12755W",
    "schoolName": "Kildare Place NS",
    "SETHours": "100",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "D06XE18",
    "addressOne": "92/96 Rathmines Road Upper",
    "addressTwo": "Dublin 6",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.318538",
    "lng": "-6.2636198",
    "phone": "14978215",
    "email": "info@kildareplace.ie"
  },
  {
    "i": "775",
    "county": "Dublin",
    "rollNumber": "13217W",
    "schoolName": "Holy Family NS",
    "SETHours": "213",
    "spClassTeachingPosts": "0",
    "mainSNA": "7",
    "spSNA": "0",
    "totalSNA": "7",
    "eircode": "D24XH22",
    "addressOne": "Rathcoole",
    "addressTwo": "Co. Dublin",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.2802253",
    "lng": "-6.4756846",
    "phone": "14580570",
    "email": "holyfamilyrathcoole@gmail.com"
  },
  {
    "i": "776",
    "county": "Dublin",
    "rollNumber": "13447Q",
    "schoolName": "Scoil Mhuire",
    "SETHours": "160",
    "spClassTeachingPosts": "0",
    "mainSNA": "8.66",
    "spSNA": "0",
    "totalSNA": "8.66",
    "eircode": "K78DK18",
    "addressOne": "Lucan Road",
    "addressTwo": "Lucan",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.358935",
    "lng": "-6.4399693",
    "phone": "16280056",
    "email": "smgns.lucan@gmail.com"
  },
  {
    "i": "777",
    "county": "Dublin",
    "rollNumber": "13611D",
    "schoolName": "Presentation Primary School",
    "SETHours": "110",
    "spClassTeachingPosts": "2",
    "mainSNA": "2.99",
    "spSNA": "3.32",
    "totalSNA": "6.31",
    "eircode": "D08XR62",
    "addressOne": "Warrenmount",
    "addressTwo": "Blackpitts",
    "addressThree": "Dublin 8",
    "addressFour": "",
    "lat": "53.335648",
    "lng": "-6.2763376",
    "phone": "14539547",
    "email": "warrenmt@eircom.net"
  },
  {
    "i": "778",
    "county": "Dublin",
    "rollNumber": "13612F",
    "schoolName": "Presentation Primary School",
    "SETHours": "150",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "D6WAW64",
    "addressOne": "Terenure Road West",
    "addressTwo": "Dublin 6w",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3106506",
    "lng": "-6.2881369",
    "phone": "868678093",
    "email": "office@presterenure.ie"
  },
  {
    "i": "779",
    "county": "Dublin",
    "rollNumber": "13815T",
    "schoolName": "Howth Rd Mxd NS",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "D03E166",
    "addressOne": "Clontarf Road",
    "addressTwo": "Clontarf",
    "addressThree": "Dublin 3",
    "addressFour": "",
    "lat": "53.3642204",
    "lng": "-6.2261522",
    "phone": "18335124",
    "email": "howthrdns@gmail.com"
  },
  {
    "i": "780",
    "county": "Dublin",
    "rollNumber": "14180H",
    "schoolName": "Holmpatrick NS",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "K34W573",
    "addressOne": "Convent Lane",
    "addressTwo": "Skerries",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.5796754",
    "lng": "-6.1075466",
    "phone": "18491409",
    "email": "office@holmpatrickns.ie"
  },
  {
    "i": "781",
    "county": "Dublin",
    "rollNumber": "14463T",
    "schoolName": "St Columbas NS Mxd",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.33",
    "spSNA": "0",
    "totalSNA": "2.33",
    "eircode": "D03NH34",
    "addressOne": "North Strand",
    "addressTwo": "Dublin 3",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3587253",
    "lng": "-6.2422703",
    "phone": "18556805",
    "email": "principal@stcolumbasns.com"
  },
  {
    "i": "782",
    "county": "Dublin",
    "rollNumber": "14556D",
    "schoolName": "St Endas Primary School",
    "SETHours": "85",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "D08FW29",
    "addressOne": "Whitefriar Street",
    "addressTwo": "Dublin 8",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3403502",
    "lng": "-6.2671614",
    "phone": "14757566",
    "email": "saintendasns@yahoo.ie"
  },
  {
    "i": "783",
    "county": "Dublin",
    "rollNumber": "14586M",
    "schoolName": "Carysfort Ns",
    "SETHours": "147.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "7.16",
    "spSNA": "0",
    "totalSNA": "7.16",
    "eircode": "A94Y516",
    "addressOne": "Convent Road",
    "addressTwo": "Blackrock",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.2971033",
    "lng": "-6.1830429",
    "phone": "12885803",
    "email": "office@carysfortns.ie"
  },
  {
    "i": "784",
    "county": "Dublin",
    "rollNumber": "14647G",
    "schoolName": "Dalkey NS (2)",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "A96RR04",
    "addressOne": "Harbour Road",
    "addressTwo": "Dalkey",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.2815787",
    "lng": "-6.1030265",
    "phone": "12803647",
    "email": "stpatricks2@gmail.com"
  },
  {
    "i": "785",
    "county": "Dublin",
    "rollNumber": "14717B",
    "schoolName": "Rathgar NS",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "D06DK35",
    "addressOne": "Rathgar Avenue",
    "addressTwo": "Dublin 6",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3140678",
    "lng": "-6.2754398",
    "phone": "14907661",
    "email": "rathgarns@rathgarns.ie"
  },
  {
    "i": "786",
    "county": "Dublin",
    "rollNumber": "14917J",
    "schoolName": "Zion Parish Primary School",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "D06K062",
    "addressOne": "Bushy Park Road",
    "addressTwo": "Rathgar",
    "addressThree": "Dublin 6",
    "addressFour": "",
    "lat": "53.3079547",
    "lng": "-6.2746826",
    "phone": "14910065",
    "email": "zionparishschool@gmail.com"
  },
  {
    "i": "787",
    "county": "Dublin",
    "rollNumber": "14939T",
    "schoolName": "Rathfarnham Parish NS",
    "SETHours": "92.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "D14X051",
    "addressOne": "Washington Lane",
    "addressTwo": "Rathfarnham",
    "addressThree": "Dublin 14",
    "addressFour": "",
    "lat": "53.2933994",
    "lng": "-6.3034388",
    "phone": "14943470",
    "email": "principal@rpns.ie"
  },
  {
    "i": "788",
    "county": "Dublin",
    "rollNumber": "14980Q",
    "schoolName": "Glasnevin NS",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "D09TW63",
    "addressOne": "Botanic Avenue",
    "addressTwo": "Glasnevin",
    "addressThree": "Dublin 9",
    "addressFour": "",
    "lat": "53.3725974",
    "lng": "-6.267463",
    "phone": "18373727",
    "email": "secretary.gns@gmail.com"
  },
  {
    "i": "789",
    "county": "Dublin",
    "rollNumber": "15056L",
    "schoolName": "SN San Vinseann Cailin",
    "SETHours": "110",
    "spClassTeachingPosts": "1",
    "mainSNA": "4",
    "spSNA": "2",
    "totalSNA": "6",
    "eircode": "D01XT04",
    "addressOne": "North William Street",
    "addressTwo": "Dublin 1",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3573928",
    "lng": "-6.2466488",
    "phone": "18740048",
    "email": "Stvincentsnws@eircom.net"
  },
  {
    "i": "790",
    "county": "Dublin",
    "rollNumber": "15132B",
    "schoolName": "Harold Boys NS",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "6",
    "spSNA": "0",
    "totalSNA": "6",
    "eircode": "A96PY94",
    "addressOne": "St. Patrick's Road",
    "addressTwo": "Dalkey",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.2784005",
    "lng": "-6.103682",
    "phone": "12856193",
    "email": "info@haroldboysdalkey.ie"
  },
  {
    "i": "791",
    "county": "Dublin",
    "rollNumber": "15253N",
    "schoolName": "St Patricks Girls Ns",
    "SETHours": "72.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "D04CH58",
    "addressOne": "Cambridge Road",
    "addressTwo": "Ringsend",
    "addressThree": "Dublin 4",
    "addressFour": "",
    "lat": "53.3433281",
    "lng": "-6.2256515",
    "phone": "16685928",
    "email": "ringsendgns@gmail.com"
  },
  {
    "i": "792",
    "county": "Dublin",
    "rollNumber": "15284B",
    "schoolName": "Taney NS",
    "SETHours": "135",
    "spClassTeachingPosts": "0",
    "mainSNA": "5",
    "spSNA": "0",
    "totalSNA": "5",
    "eircode": "D14PN29",
    "addressOne": "Sydenham Villas",
    "addressTwo": "Dundrum",
    "addressThree": "Dublin 14",
    "addressFour": "",
    "lat": "53.2887079",
    "lng": "-6.2382648",
    "phone": "12985015",
    "email": "ecarpenter@taneyschool.ie"
  },
  {
    "i": "793",
    "county": "Dublin",
    "rollNumber": "15315J",
    "schoolName": "St Georges NS",
    "SETHours": "202.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "7.49",
    "spSNA": "0",
    "totalSNA": "7.49",
    "eircode": "K32KC95",
    "addressOne": "Naul Road",
    "addressTwo": "Balbriggan",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.6070967",
    "lng": "-6.2038442",
    "phone": "18410107",
    "email": "office@stgeorgesns.com"
  },
  {
    "i": "794",
    "county": "Dublin",
    "rollNumber": "15569R",
    "schoolName": "Scoil Moibhi",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "K34WP77",
    "addressOne": "Milverton",
    "addressTwo": "Skerries",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.5646445",
    "lng": "-6.1475341",
    "phone": "18492467",
    "email": "scoilmoibhi.ias@eircom.net"
  },
  {
    "i": "795",
    "county": "Dublin",
    "rollNumber": "15618E",
    "schoolName": "Sandford Parish NS",
    "SETHours": "60",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "D06V2V6",
    "addressOne": "Sandford Close",
    "addressTwo": "Ranelagh",
    "addressThree": "Dublin 6",
    "addressFour": "",
    "lat": "53.3208795",
    "lng": "-6.2481682",
    "phone": "14974277",
    "email": "secretary@sandfordparishns.ie"
  },
  {
    "i": "796",
    "county": "Dublin",
    "rollNumber": "15622S",
    "schoolName": "St Patricks Ns",
    "SETHours": "72.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.66",
    "spSNA": "0",
    "totalSNA": "5.66",
    "eircode": "D20TW71",
    "addressOne": "Chapelizod Village",
    "addressTwo": "Dublin 20",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3485735",
    "lng": "-6.3433716",
    "phone": "16265752",
    "email": "chapelizodstpatricks@gmail.com"
  },
  {
    "i": "797",
    "county": "Dublin",
    "rollNumber": "15625B",
    "schoolName": "St Catherines West NS",
    "SETHours": "85",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "D08YR66",
    "addressOne": "Donore Avenue",
    "addressTwo": "South Circular Road",
    "addressThree": "Dublin 8",
    "addressFour": "",
    "lat": "53.3330962",
    "lng": "-6.2832322",
    "phone": "14542679",
    "email": "info@stcatherinesns.net"
  },
  {
    "i": "798",
    "county": "Dublin",
    "rollNumber": "15650A",
    "schoolName": "Corduff NS",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "K45XV34",
    "addressOne": "Lusk",
    "addressTwo": "Co. Dublin",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.516735",
    "lng": "-6.1906869",
    "phone": "18438274",
    "email": "office@corduffns.scoilnet.ie"
  },
  {
    "i": "799",
    "county": "Dublin",
    "rollNumber": "15816I",
    "schoolName": "St Vincents Inf Boys",
    "SETHours": "95",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.98",
    "spSNA": "0",
    "totalSNA": "4.98",
    "eircode": "D01VW63",
    "addressOne": "North William Street",
    "addressTwo": "Dublin 1",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3570601",
    "lng": "-6.2468642",
    "phone": "18363074",
    "email": "stvincentsbns@gmail.com"
  },
  {
    "i": "800",
    "county": "Dublin",
    "rollNumber": "15895H",
    "schoolName": "Drumcondra NS",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "D09VY58",
    "addressOne": "Church Avenue",
    "addressTwo": "Drumcondra",
    "addressThree": "Dublin 9",
    "addressFour": "",
    "lat": "53.3692582",
    "lng": "-6.2495372",
    "phone": "18374886",
    "email": "office@drumcondrans.ie"
  },
  {
    "i": "801",
    "county": "Dublin",
    "rollNumber": "15995L",
    "schoolName": "Star Of The Sea",
    "SETHours": "112.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "D04XW14",
    "addressOne": "Leahy's Terrace",
    "addressTwo": "Sandymount",
    "addressThree": "Dublin 4",
    "addressFour": "",
    "lat": "53.3361098",
    "lng": "-6.2181304",
    "phone": "16686394",
    "email": "office@starofthesea.ie"
  },
  {
    "i": "802",
    "county": "Dublin",
    "rollNumber": "16177F",
    "schoolName": "Lindsay Road NS",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "D09YH93",
    "addressOne": "Lindsay Road",
    "addressTwo": "Glasnevin",
    "addressThree": "Dublin 9",
    "addressFour": "",
    "lat": "53.3648971",
    "lng": "-6.2647557",
    "phone": "18600247",
    "email": "lindsayroadns@hotmail.com"
  },
  {
    "i": "803",
    "county": "Dublin",
    "rollNumber": "16267G",
    "schoolName": "St Patricks BNS",
    "SETHours": "197.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "14.81",
    "spSNA": "0",
    "totalSNA": "14.81",
    "eircode": "K36W309",
    "addressOne": "Donabate",
    "addressTwo": "Co. Dublin",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.4929602",
    "lng": "-6.1362503",
    "phone": "18436168",
    "email": "info@stpatsbns.ie"
  },
  {
    "i": "804",
    "county": "Dublin",
    "rollNumber": "16332O",
    "schoolName": "St Patricks Snr Mixed",
    "SETHours": "130",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "K34X751",
    "addressOne": "Beau Piers Lane",
    "addressTwo": "Skerries",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.5779987",
    "lng": "-6.1101673",
    "phone": "18490945",
    "email": "stpatsskerries@gmail.com"
  },
  {
    "i": "805",
    "county": "Dublin",
    "rollNumber": "16333Q",
    "schoolName": "St Patricks Jnr Mixed",
    "SETHours": "80",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.66",
    "spSNA": "0",
    "totalSNA": "4.66",
    "eircode": "K34D799",
    "addressOne": "Beau Piers",
    "addressTwo": "Skerries",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.5780488",
    "lng": "-6.1094071",
    "phone": "18490836",
    "email": "admin@stps.ie"
  },
  {
    "i": "806",
    "county": "Dublin",
    "rollNumber": "16352U",
    "schoolName": "St Brigids Boys NS",
    "SETHours": "192.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "9",
    "spSNA": "0",
    "totalSNA": "9",
    "eircode": "D18W406",
    "addressOne": "Mart Lane",
    "addressTwo": "Foxrock",
    "addressThree": "Dublin 18",
    "addressFour": "",
    "lat": "53.2688888",
    "lng": "-6.1692549",
    "phone": "12893199",
    "email": "principal@stbrigids.ie"
  },
  {
    "i": "807",
    "county": "Dublin",
    "rollNumber": "16353W",
    "schoolName": "St Brigids Girls NS",
    "SETHours": "117.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "D18TN66",
    "addressOne": "The Park",
    "addressTwo": "Cabinteely",
    "addressThree": "Dublin 18",
    "addressFour": "",
    "lat": "53.2614958",
    "lng": "-6.1616706",
    "phone": "12847422",
    "email": "scoilbride@eircom.net"
  },
  {
    "i": "808",
    "county": "Dublin",
    "rollNumber": "16461C",
    "schoolName": "Caisleain Nua Liamhna",
    "SETHours": "202.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "4",
    "spSNA": "3.66",
    "totalSNA": "7.66",
    "eircode": "D22A388",
    "addressOne": "Main Street",
    "addressTwo": "Newcastle",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.2983355",
    "lng": "-6.500621",
    "phone": "14580114",
    "email": "info@stfiniansprimaryschool.ie"
  },
  {
    "i": "809",
    "county": "Dublin",
    "rollNumber": "16577V",
    "schoolName": "St Brigids Convent",
    "SETHours": "110",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "D11VF95",
    "addressOne": "Finglas Road Old",
    "addressTwo": "Glasnevin",
    "addressThree": "Dublin 11",
    "addressFour": "",
    "lat": "53.3768599",
    "lng": "-6.2756033",
    "phone": "18376653",
    "email": "stbrigid.glasnevin@gmail.com"
  },
  {
    "i": "810",
    "county": "Dublin",
    "rollNumber": "16629O",
    "schoolName": "Kilternan Church Of Ireland Ns",
    "SETHours": "110",
    "spClassTeachingPosts": "0",
    "mainSNA": "6",
    "spSNA": "0",
    "totalSNA": "6",
    "eircode": "D18A599",
    "addressOne": "Glebe Road",
    "addressTwo": "Enniskerry Road",
    "addressThree": "Kilternan",
    "addressFour": "Dublin 18",
    "lat": "53.2427804",
    "lng": "-6.200168",
    "phone": "12953235",
    "email": "secretary@kcoins.ie"
  },
  {
    "i": "811",
    "county": "Dublin",
    "rollNumber": "16651H",
    "schoolName": "St Clares Convent NS",
    "SETHours": "150",
    "spClassTeachingPosts": "2",
    "mainSNA": "5.83",
    "spSNA": "4",
    "totalSNA": "9.83",
    "eircode": "D6WWC86",
    "addressOne": "Harold's Cross Road",
    "addressTwo": "Dublin 6w",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3265516",
    "lng": "-6.2756944",
    "phone": "14963237",
    "email": "info@stclares.ie"
  },
  {
    "i": "812",
    "county": "Dublin",
    "rollNumber": "16659A",
    "schoolName": "St Columbas Con G & I",
    "SETHours": "112.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.66",
    "spSNA": "0",
    "totalSNA": "5.66",
    "eircode": "D09YX46",
    "addressOne": "Iona Road",
    "addressTwo": "Glasnevin",
    "addressThree": "Dublin 9",
    "addressFour": "",
    "lat": "53.3667595",
    "lng": "-6.263518",
    "phone": "18305040",
    "email": "principal@ionaroadschool.ie"
  },
  {
    "i": "813",
    "county": "Dublin",
    "rollNumber": "16675V",
    "schoolName": "Scoil Naomh Lucais",
    "SETHours": "262.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "9.49",
    "spSNA": "0",
    "totalSNA": "9.49",
    "eircode": "D15CH64",
    "addressOne": "Hollywood Road",
    "addressTwo": "Tyrellstown",
    "addressThree": "Dublin 15",
    "addressFour": "",
    "lat": "53.4231681",
    "lng": "-6.3824572",
    "phone": "18856015",
    "email": "katemns@hotmail.com"
  },
  {
    "i": "814",
    "county": "Dublin",
    "rollNumber": "16695E",
    "schoolName": "Scoil Na Mbrathar Boys Sn School",
    "SETHours": "110",
    "spClassTeachingPosts": "0",
    "mainSNA": "6",
    "spSNA": "0",
    "totalSNA": "6",
    "eircode": "D07P529",
    "addressOne": "North Brunswick Street",
    "addressTwo": "Dublin 7",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3505046",
    "lng": "-6.2767608",
    "phone": "18722167",
    "email": "brunnerprimary@gmail.com"
  },
  {
    "i": "815",
    "county": "Dublin",
    "rollNumber": "16753P",
    "schoolName": "St Vincent De Paul's Girls Sn School",
    "SETHours": "72.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "D09AD80",
    "addressOne": "Griffith Avenue",
    "addressTwo": "Dublin 9",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3700654",
    "lng": "-6.2304069",
    "phone": "18334697",
    "email": "stvincentsgns.ias@eircom.net"
  },
  {
    "i": "816",
    "county": "Dublin",
    "rollNumber": "16754R",
    "schoolName": "St Vincents Convent Inf NS",
    "SETHours": "92.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.66",
    "spSNA": "0",
    "totalSNA": "1.66",
    "eircode": "D09AP26",
    "addressOne": "67 Griffith Avenue",
    "addressTwo": "Dublin 9",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3699992",
    "lng": "-6.2304907",
    "phone": "18334538",
    "email": "principalsvdp@gmail.com"
  },
  {
    "i": "817",
    "county": "Dublin",
    "rollNumber": "16759E",
    "schoolName": "SN Mhuire Na Mbrathar",
    "SETHours": "112.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "D09NW62",
    "addressOne": "Marino",
    "addressTwo": "Dublin 9",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3707391",
    "lng": "-6.2324421",
    "phone": "18336421",
    "email": "smmgriffithave@gmail.com"
  },
  {
    "i": "818",
    "county": "Dublin",
    "rollNumber": "16786H",
    "schoolName": "St Brigids Primary School",
    "SETHours": "150",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.66",
    "spSNA": "0",
    "totalSNA": "3.66",
    "eircode": "D08E377",
    "addressOne": "The Coombe",
    "addressTwo": "Dublin 8",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.338755",
    "lng": "-6.2749302",
    "phone": "14547734",
    "email": "stbrigidsthecoombe@eircom.net"
  },
  {
    "i": "819",
    "county": "Dublin",
    "rollNumber": "16792C",
    "schoolName": "St Brigids Convent NS",
    "SETHours": "87.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "D05YV44",
    "addressOne": "St.brigid's Road",
    "addressTwo": "Killester",
    "addressThree": "Dublin 5",
    "addressFour": "",
    "lat": "53.3785688",
    "lng": "-6.2057196",
    "phone": "18315138",
    "email": "principal@stbrigidsgns.ie"
  },
  {
    "i": "820",
    "county": "Dublin",
    "rollNumber": "16794G",
    "schoolName": "St Brigids NS",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "A94X066",
    "addressOne": "Merville Road",
    "addressTwo": "Stillorgan",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.2853162",
    "lng": "-6.1967055",
    "phone": "12833095",
    "email": "staffbrigidsns@gmail.com"
  },
  {
    "i": "821",
    "county": "Dublin",
    "rollNumber": "16844S",
    "schoolName": "Scoil N. Breandan",
    "SETHours": "97.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.66",
    "spSNA": "0",
    "totalSNA": "4.66",
    "eircode": "K34T853",
    "addressOne": "Loughshinny",
    "addressTwo": "Skerries",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.5464518",
    "lng": "-6.0901684",
    "phone": "18490394",
    "email": "secretary@loughshinnyns.ie"
  },
  {
    "i": "822",
    "county": "Dublin",
    "rollNumber": "16860Q",
    "schoolName": "Corpus Christi NS",
    "SETHours": "90",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "D09K270",
    "addressOne": "Home Farm Road",
    "addressTwo": "Drumcondra",
    "addressThree": "Dublin 9",
    "addressFour": "",
    "lat": "53.3748501",
    "lng": "-6.2574691",
    "phone": "18379745",
    "email": "ccgns.principal@gmail.com"
  },
  {
    "i": "823",
    "county": "Dublin",
    "rollNumber": "16893I",
    "schoolName": "SN Naomh Lorcan",
    "SETHours": "157.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "6.83",
    "spSNA": "0",
    "totalSNA": "6.83",
    "eircode": "A94KD62",
    "addressOne": "Upper Kilmacud Road",
    "addressTwo": "Stillorgan",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.288529",
    "lng": "-6.2071175",
    "phone": "12882486",
    "email": "stlaurencesbns@outlook.ie"
  },
  {
    "i": "824",
    "county": "Dublin",
    "rollNumber": "16964F",
    "schoolName": "Scoil Mhuire Ogh 1",
    "SETHours": "125",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.5",
    "spSNA": "0",
    "totalSNA": "3.5",
    "eircode": "D12EH28",
    "addressOne": "Crumlin Road",
    "addressTwo": "Dublin 12",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3292003",
    "lng": "-6.2958826",
    "phone": "14541669",
    "email": "loretoseniorprimarycrumlin@gmail.com"
  },
  {
    "i": "825",
    "county": "Dublin",
    "rollNumber": "16966J",
    "schoolName": "Scoil Naisiunta Stratford",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "D06E161",
    "addressOne": "1 Zion Road",
    "addressTwo": "Rathgar",
    "addressThree": "Dublin 6",
    "addressFour": "",
    "lat": "53.3096452",
    "lng": "-6.2748588",
    "phone": "14922315",
    "email": "admin@stratfordcollege.ie"
  },
  {
    "i": "826",
    "county": "Dublin",
    "rollNumber": "16970A",
    "schoolName": "St Molaga Sn Ns",
    "SETHours": "167.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "6",
    "spSNA": "0",
    "totalSNA": "6",
    "eircode": "K32Y662",
    "addressOne": "Bremore",
    "addressTwo": "Balbriggan",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.61583",
    "lng": "-6.1904194",
    "phone": "18413133",
    "email": "stmolaga@gmail.com"
  },
  {
    "i": "827",
    "county": "Dublin",
    "rollNumber": "16972E",
    "schoolName": "SN Peadar Agus Pol N",
    "SETHours": "145",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.66",
    "spSNA": "0",
    "totalSNA": "4.66",
    "eircode": "K32PD27",
    "addressOne": "Chapel Street",
    "addressTwo": "Balbriggan",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.6099636",
    "lng": "-6.1884352",
    "phone": "18412670",
    "email": "office@sspeterandpauljns.ie"
  },
  {
    "i": "828",
    "county": "Dublin",
    "rollNumber": "16983J",
    "schoolName": "SN Naomh Cillin",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "D12W563",
    "addressOne": "Robinhood Road",
    "addressTwo": "Bluebell",
    "addressThree": "Dublin 12",
    "addressFour": "",
    "lat": "53.3250976",
    "lng": "-6.3457871",
    "phone": "14500440",
    "email": "office@stcilliansns.net"
  },
  {
    "i": "829",
    "county": "Dublin",
    "rollNumber": "16988T",
    "schoolName": "Christ The King BNS",
    "SETHours": "87.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "6.83",
    "spSNA": "6",
    "totalSNA": "12.83",
    "eircode": "D07EF63",
    "addressOne": "Annaly Road",
    "addressTwo": "Cabra",
    "addressThree": "Dublin 7",
    "addressFour": "",
    "lat": "53.3635807",
    "lng": "-6.2852461",
    "phone": "18680503",
    "email": "principal@christthekingbns.ie"
  },
  {
    "i": "830",
    "county": "Dublin",
    "rollNumber": "16989V",
    "schoolName": "Christ The King Girls Sn School",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "D07HV12",
    "addressOne": "Annaly Road",
    "addressTwo": "Cabra",
    "addressThree": "Dublin 7",
    "addressFour": "",
    "lat": "53.3636601",
    "lng": "-6.2858575",
    "phone": "18680115",
    "email": "christthekingsenior@gmail.com"
  },
  {
    "i": "831",
    "county": "Dublin",
    "rollNumber": "17055T",
    "schoolName": "SN Naomh Mhuire",
    "SETHours": "257.5",
    "spClassTeachingPosts": "4",
    "mainSNA": "5.66",
    "spSNA": "8.66",
    "totalSNA": "14.32",
    "eircode": "D24VW9P",
    "addressOne": "Garter's Lane",
    "addressTwo": "Saggart",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.2801014",
    "lng": "-6.4421008",
    "phone": "14589020",
    "email": "stmaryssaggart2@gmail.com"
  },
  {
    "i": "832",
    "county": "Dublin",
    "rollNumber": "17083B",
    "schoolName": "SN Muire Gan Smal B",
    "SETHours": "202.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.83",
    "spSNA": "0",
    "totalSNA": "5.83",
    "eircode": "D08Y9T4",
    "addressOne": "Tyrconnell Road",
    "addressTwo": "Inchicore",
    "addressThree": "Dublin 8",
    "addressFour": "",
    "lat": "53.337632",
    "lng": "-6.3250901",
    "phone": "14541641",
    "email": "Office@smgs.ie"
  },
  {
    "i": "833",
    "county": "Dublin",
    "rollNumber": "17104G",
    "schoolName": "St Francis Jn NS",
    "SETHours": "122.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.66",
    "spSNA": "0",
    "totalSNA": "3.66",
    "eircode": "D17KH30",
    "addressOne": "Clonshaugh Drive",
    "addressTwo": "Priorswood",
    "addressThree": "Dublin 17",
    "addressFour": "",
    "lat": "53.4035234",
    "lng": "-6.2049377",
    "phone": "18470804",
    "email": "stfrancisjs17@gmail.com"
  },
  {
    "i": "834",
    "county": "Dublin",
    "rollNumber": "17110B",
    "schoolName": "Naomh Lorcan O Tuathail Sn Boys",
    "SETHours": "100",
    "spClassTeachingPosts": "1",
    "mainSNA": "6",
    "spSNA": "2",
    "totalSNA": "8",
    "eircode": "D01A439",
    "addressOne": "Seville Place",
    "addressTwo": "Dublin 1",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3531329",
    "lng": "-6.2437706",
    "phone": "18363490",
    "email": "info@larriers.ie"
  },
  {
    "i": "835",
    "county": "Dublin",
    "rollNumber": "17148D",
    "schoolName": "SN Eoin Baisde Girls Sn",
    "SETHours": "85",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "D03T803",
    "addressOne": "Seafield Road West",
    "addressTwo": "Clontarf",
    "addressThree": "Dublin 3",
    "addressFour": "",
    "lat": "53.3636531",
    "lng": "-6.1994126",
    "phone": "18331888",
    "email": "info@belgroveseniorgirls.ie"
  },
  {
    "i": "838",
    "county": "Dublin",
    "rollNumber": "17214N",
    "schoolName": "St. Vincent's Primary School",
    "SETHours": "137.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.58",
    "spSNA": "0",
    "totalSNA": "4.58",
    "eircode": "D11HX78",
    "addressOne": "St Philomenas Road",
    "addressTwo": "Glasnevin",
    "addressThree": "Dublin 11",
    "addressFour": "",
    "lat": "53.3676579",
    "lng": "-6.2750058",
    "phone": "18302328",
    "email": "office@vincentsprimary.com"
  },
  {
    "i": "839",
    "county": "Dublin",
    "rollNumber": "17263D",
    "schoolName": "SN Muire An Sean Baile",
    "SETHours": "50",
    "spClassTeachingPosts": "1",
    "mainSNA": "3",
    "spSNA": "3",
    "totalSNA": "6",
    "eircode": "A45YD60",
    "addressOne": "Oldtown",
    "addressTwo": "Co. Dublin",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.5244717",
    "lng": "-6.3185069",
    "phone": "18432060",
    "email": "oldtownns@gmail.com"
  },
  {
    "i": "840",
    "county": "Dublin",
    "rollNumber": "17318C",
    "schoolName": "Scoil An Leinbh Iosa Boys Seniors",
    "SETHours": "112.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "5",
    "spSNA": "2",
    "totalSNA": "7",
    "eircode": "D09K104",
    "addressOne": "Larkhill Road",
    "addressTwo": "Whitehall",
    "addressThree": "Dublin 9",
    "addressFour": "",
    "lat": "53.3848353",
    "lng": "-6.2461083",
    "phone": "18372472",
    "email": "secretary@holychildbns.ie"
  },
  {
    "i": "841",
    "county": "Dublin",
    "rollNumber": "17355I",
    "schoolName": "Muire Na Dea Coirle Girls Sn",
    "SETHours": "70",
    "spClassTeachingPosts": "2",
    "mainSNA": "2",
    "spSNA": "5.15",
    "totalSNA": "7.15",
    "eircode": "D12XD51",
    "addressOne": "Mourne Road",
    "addressTwo": "Drimnagh",
    "addressThree": "Dublin 12",
    "addressFour": "",
    "lat": "53.3301193",
    "lng": "-6.3184594",
    "phone": "14557011",
    "email": "carmelreidmourneroad@gmail.com"
  },
  {
    "i": "842",
    "county": "Dublin",
    "rollNumber": "17356K",
    "schoolName": "Muire Na Dea Coirle Inf",
    "SETHours": "97.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "4.15",
    "spSNA": "1.66",
    "totalSNA": "5.81",
    "eircode": "D12E228",
    "addressOne": "Mourne Road",
    "addressTwo": "Drimnagh",
    "addressThree": "Dublin 12",
    "addressFour": "",
    "lat": "53.3306296",
    "lng": "-6.3168518",
    "phone": "14556594",
    "email": "infantschoolmourneroad@gmail.com"
  },
  {
    "i": "843",
    "county": "Dublin",
    "rollNumber": "17367P",
    "schoolName": "Mary, Help Of Christians G.n.s.",
    "SETHours": "120",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.66",
    "spSNA": "0",
    "totalSNA": "5.66",
    "eircode": "D07EH68",
    "addressOne": "Navan Road",
    "addressTwo": "Dublin 7",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3678069",
    "lng": "-6.3144791",
    "phone": "18380471",
    "email": "principal@maryhelpofchristians.ie"
  },
  {
    "i": "844",
    "county": "Dublin",
    "rollNumber": "17459U",
    "schoolName": "Christ The King I G",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.66",
    "spSNA": "0",
    "totalSNA": "1.66",
    "eircode": "D07HV12",
    "addressOne": "Annaly Road",
    "addressTwo": "Cabra",
    "addressThree": "Dublin 7",
    "addressFour": "",
    "lat": "53.3636601",
    "lng": "-6.2858575",
    "phone": "18680115",
    "email": "ckjgns@gmail.com"
  },
  {
    "i": "845",
    "county": "Dublin",
    "rollNumber": "17464N",
    "schoolName": "Fionnbarra Naofa B.n.s.,",
    "SETHours": "105",
    "spClassTeachingPosts": "1",
    "mainSNA": "4.66",
    "spSNA": "1.66",
    "totalSNA": "6.32",
    "eircode": "D07A522",
    "addressOne": "Kilkieran Road",
    "addressTwo": "Cabra West",
    "addressThree": "Dublin 7",
    "addressFour": "",
    "lat": "53.3691115",
    "lng": "-6.297561",
    "phone": "18380060",
    "email": "chairman.ias@eircom.net"
  },
  {
    "i": "846",
    "county": "Dublin",
    "rollNumber": "17465P",
    "schoolName": "Dominican Convent Girls Sn School",
    "SETHours": "77.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "D07V045",
    "addressOne": "Ratoath Road",
    "addressTwo": "Cabra West",
    "addressThree": "Dublin 7",
    "addressFour": "",
    "lat": "53.3699148",
    "lng": "-6.3070662",
    "phone": "18387194",
    "email": "principalstcatherinessns@gmail.com"
  },
  {
    "i": "847",
    "county": "Dublin",
    "rollNumber": "17466R",
    "schoolName": "St Catherines Infant School",
    "SETHours": "82.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "4.98",
    "spSNA": "4.15",
    "totalSNA": "9.13",
    "eircode": "D07TP21",
    "addressOne": "Ratoath Road",
    "addressTwo": "Cabra",
    "addressThree": "Dublin 7",
    "addressFour": "",
    "lat": "53.3703308",
    "lng": "-6.3071721",
    "phone": "18684046",
    "email": "principal@stcatherinesinfants.com"
  },
  {
    "i": "848",
    "county": "Dublin",
    "rollNumber": "17470I",
    "schoolName": "St Raphaelas NS",
    "SETHours": "97.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "A94R7N8",
    "addressOne": "Saint Raphaela's Road",
    "addressTwo": "Stillorgan",
    "addressThree": "Blackrock",
    "addressFour": "Co. Dublin",
    "lat": "53.2818723",
    "lng": "-6.2049616",
    "phone": "12886878",
    "email": "Secretary@straphaelasns.ie"
  },
  {
    "i": "849",
    "county": "Dublin",
    "rollNumber": "17472M",
    "schoolName": "Baile Falbach",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "K45YP02",
    "addressOne": "Jordanstown",
    "addressTwo": "Lusk",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.5507115",
    "lng": "-6.2075662",
    "phone": "18438372",
    "email": "hedgestownnationalschool@gmail.com"
  },
  {
    "i": "850",
    "county": "Dublin",
    "rollNumber": "17507F",
    "schoolName": "SN Padraig Naofa",
    "SETHours": "60",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "D18H504",
    "addressOne": "Ballybetagh Road",
    "addressTwo": "Kiltiernan",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.2223215",
    "lng": "-6.2173292",
    "phone": "12954255",
    "email": "secretary@glencullenschool.ie"
  },
  {
    "i": "851",
    "county": "Dublin",
    "rollNumber": "17559B",
    "schoolName": "SN Mhuire",
    "SETHours": "87.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "5",
    "spSNA": "0",
    "totalSNA": "5",
    "eircode": "A42V673",
    "addressOne": "The Green",
    "addressTwo": "Garristown",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.5627784",
    "lng": "-6.3850647",
    "phone": "18354505",
    "email": "garristownschooloffice@gmail.com"
  },
  {
    "i": "852",
    "county": "Dublin",
    "rollNumber": "17569E",
    "schoolName": "Blessed Oliver NS",
    "SETHours": "120",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.83",
    "spSNA": "0",
    "totalSNA": "5.83",
    "eircode": "K32WR94",
    "addressOne": "Balrothery",
    "addressTwo": "Balbriggan",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.5896257",
    "lng": "-6.1858603",
    "phone": "18411494",
    "email": "office@balrotheryns.com"
  },
  {
    "i": "853",
    "county": "Dublin",
    "rollNumber": "17595F",
    "schoolName": "Cill Coscain",
    "SETHours": "52.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "2",
    "spSNA": "5.83",
    "totalSNA": "7.83",
    "eircode": "D11PW92",
    "addressOne": "Kilcoscan",
    "addressTwo": "The Ward",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.4636664",
    "lng": "-6.3447156",
    "phone": "18351508",
    "email": "kilcoskanprincipal@gmail.com"
  },
  {
    "i": "854",
    "county": "Dublin",
    "rollNumber": "17603B",
    "schoolName": "Scoil Iosagain Boys Sn",
    "SETHours": "55",
    "spClassTeachingPosts": "2",
    "mainSNA": "2.5",
    "spSNA": "3",
    "totalSNA": "5.5",
    "eircode": "D12W522",
    "addressOne": "Aughavannagh Road",
    "addressTwo": "Crumlin",
    "addressThree": "Dublin 12",
    "addressFour": "",
    "lat": "53.3300258",
    "lng": "-6.287325",
    "phone": "14541821",
    "email": "principalscoiliosagain@gmail.com"
  },
  {
    "i": "855",
    "county": "Dublin",
    "rollNumber": "17683C",
    "schoolName": "Muire Og 2 Loreto Con",
    "SETHours": "120",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.66",
    "spSNA": "0",
    "totalSNA": "4.66",
    "eircode": "D12P602",
    "addressOne": "Crumlin Road",
    "addressTwo": "Dublin 12",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3303736",
    "lng": "-6.2964208",
    "phone": "14541746",
    "email": "principal@loretojunior.ie"
  },
  {
    "i": "856",
    "county": "Dublin",
    "rollNumber": "17730I",
    "schoolName": "SN Na Lanai Glasa",
    "SETHours": "80",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "D03A024",
    "addressOne": "Seafield Avenue",
    "addressTwo": "Clontarf",
    "addressThree": "Dublin 3",
    "addressFour": "",
    "lat": "53.3653976",
    "lng": "-6.1894576",
    "phone": "18331554",
    "email": "cathy.harry@greenlanes.ie"
  },
  {
    "i": "857",
    "county": "Dublin",
    "rollNumber": "17732M",
    "schoolName": "Scoil Chiarain",
    "SETHours": "117.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "5",
    "spSNA": "8",
    "totalSNA": "13",
    "eircode": "D05Y578",
    "addressOne": "Collins Avenue East",
    "addressTwo": "Killester",
    "addressThree": "Dublin 5",
    "addressFour": "",
    "lat": "53.3739829",
    "lng": "-6.2148823",
    "phone": "18313072",
    "email": "cibeag@yahoo.com"
  },
  {
    "i": "858",
    "county": "Dublin",
    "rollNumber": "17785K",
    "schoolName": "San Nioclas Myra",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "D17FP52",
    "addressOne": "Malahide Road",
    "addressTwo": "Kinsealy",
    "addressThree": "Dublin 17",
    "addressFour": "",
    "lat": "53.4208233",
    "lng": "-6.1760376",
    "phone": "18464033",
    "email": "principal@kinsealyns.ie"
  },
  {
    "i": "859",
    "county": "Dublin",
    "rollNumber": "17820J",
    "schoolName": "Brighde Naofa",
    "SETHours": "125",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.83",
    "spSNA": "0",
    "totalSNA": "5.83",
    "eircode": "K67Y308",
    "addressOne": "Rowlestown Drive",
    "addressTwo": "Kilsallaghan",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.4914471",
    "lng": "-6.3000065",
    "phone": "18404130",
    "email": "rolestown.ns@gmail.com"
  },
  {
    "i": "860",
    "county": "Dublin",
    "rollNumber": "17881G",
    "schoolName": "Scoil Ui Chonaill Boys Seniors",
    "SETHours": "157.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "10",
    "spSNA": "2",
    "totalSNA": "12",
    "eircode": "D01H9X5",
    "addressOne": "North Richmond Street",
    "addressTwo": "Dublin 1",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3592965",
    "lng": "-6.2515085",
    "phone": "18557517",
    "email": "secretary@oconnellprimary.ie"
  },
  {
    "i": "861",
    "county": "Dublin",
    "rollNumber": "17891J",
    "schoolName": "Scoil Mhuire",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "D20HX04",
    "addressOne": "Tower Road",
    "addressTwo": "Chapelizod",
    "addressThree": "Dublin 20",
    "addressFour": "",
    "lat": "53.3602651",
    "lng": "-6.3588413",
    "phone": "18213105",
    "email": "scoilmhuiremountsackville@gmail.com"
  },
  {
    "i": "862",
    "county": "Dublin",
    "rollNumber": "17893N",
    "schoolName": "Sancta Maria C B S",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "D08V6R9",
    "addressOne": "Synge Strete",
    "addressTwo": "Dublin 8",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3333413",
    "lng": "-6.2672467",
    "phone": "14784316",
    "email": "principal@bunscoilsynge.ie"
  },
  {
    "i": "863",
    "county": "Dublin",
    "rollNumber": "17899C",
    "schoolName": "Scoil Carmel",
    "SETHours": "135",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.49",
    "spSNA": "0",
    "totalSNA": "5.49",
    "eircode": "D24NA44",
    "addressOne": "Firhouse Road",
    "addressTwo": "Dublin 24",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.2851399",
    "lng": "-6.3372881",
    "phone": "14514151",
    "email": "scoilcarmelns@eircom.net"
  },
  {
    "i": "864",
    "county": "Dublin",
    "rollNumber": "17912O",
    "schoolName": "SN Eoin Bosco Buach",
    "SETHours": "175",
    "spClassTeachingPosts": "0",
    "mainSNA": "10",
    "spSNA": "0",
    "totalSNA": "10",
    "eircode": "D07V654",
    "addressOne": "Navan Road",
    "addressTwo": "Dublin 7",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3678673",
    "lng": "-6.3137558",
    "phone": "18380371",
    "email": "boscosen.ias@eircom.net"
  },
  {
    "i": "865",
    "county": "Dublin",
    "rollNumber": "17914S",
    "schoolName": "St Oliver Plunkett",
    "SETHours": "302.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "12.32",
    "spSNA": "0",
    "totalSNA": "12.32",
    "eircode": "K36H998",
    "addressOne": "Grove Road",
    "addressTwo": "Malahide",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.4464181",
    "lng": "-6.1507554",
    "phone": "18452052",
    "email": "office@stops.ie"
  },
  {
    "i": "866",
    "county": "Dublin",
    "rollNumber": "17928G",
    "schoolName": "SN N Sailbheastar Nfa",
    "SETHours": "117.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.75",
    "spSNA": "0",
    "totalSNA": "3.75",
    "eircode": "K36PA66",
    "addressOne": "Yellow Walls Road",
    "addressTwo": "Malahide",
    "addressThree": "Co Dublin",
    "addressFour": "",
    "lat": "53.4495057",
    "lng": "-6.163405",
    "phone": "18450061",
    "email": "stsylvesters@gmail.com"
  },
  {
    "i": "867",
    "county": "Dublin",
    "rollNumber": "17936F",
    "schoolName": "Sn Eoin Baisde Boys Sn School",
    "SETHours": "112.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "D03HK82",
    "addressOne": "Seafield Road",
    "addressTwo": "Clontarf",
    "addressThree": "Dublin 3",
    "addressFour": "",
    "lat": "53.3636387",
    "lng": "-6.1974817",
    "phone": "18331852",
    "email": "info@belgroveseniorboys.ie"
  },
  {
    "i": "868",
    "county": "Dublin",
    "rollNumber": "17953F",
    "schoolName": "SN Bhaile Eamonn",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "D16XF86",
    "addressOne": "Edmondstown Road",
    "addressTwo": "Rathfarnham",
    "addressThree": "Dublin 16",
    "addressFour": "",
    "lat": "53.2687828",
    "lng": "-6.2994666",
    "phone": "14933255",
    "email": "edmondstownns@hotmail.com"
  },
  {
    "i": "869",
    "county": "Dublin",
    "rollNumber": "17954H",
    "schoolName": "Scoil Caoimhin Naofa",
    "SETHours": "195",
    "spClassTeachingPosts": "0",
    "mainSNA": "7.66",
    "spSNA": "0",
    "totalSNA": "7.66",
    "eircode": "A94KW94",
    "addressOne": "Mount Merrion",
    "addressTwo": "Blackrock",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.2911744",
    "lng": "-6.2052544",
    "phone": "12887108",
    "email": "office@oatlandsprimaryschool.ie"
  },
  {
    "i": "870",
    "county": "Dublin",
    "rollNumber": "17961E",
    "schoolName": "SN Lusca",
    "SETHours": "170",
    "spClassTeachingPosts": "0",
    "mainSNA": "5",
    "spSNA": "0",
    "totalSNA": "5",
    "eircode": "K45CX43",
    "addressOne": "Chapel Road",
    "addressTwo": "Lusk",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.5291863",
    "lng": "-6.1679166",
    "phone": "18437738",
    "email": "LuskSNSoffice@luskns.ie"
  },
  {
    "i": "871",
    "county": "Dublin",
    "rollNumber": "17970F",
    "schoolName": "Our Lady Of Mercy Convent School",
    "SETHours": "72.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "A94V656",
    "addressOne": "Rosemount Terrace",
    "addressTwo": "Booterstown",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.3053316",
    "lng": "-6.2003846",
    "phone": "12884223",
    "email": "ourladyofmercyoffice@gmail.com"
  },
  {
    "i": "872",
    "county": "Dublin",
    "rollNumber": "17976R",
    "schoolName": "Scoil Assaim Boys Seniors",
    "SETHours": "125",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "D05AW29",
    "addressOne": "Raheny",
    "addressTwo": "Dublin 5",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3784824",
    "lng": "-6.1768442",
    "phone": "18314044",
    "email": "secretary@scoilassaim.com"
  },
  {
    "i": "873",
    "county": "Dublin",
    "rollNumber": "17977T",
    "schoolName": "Scoil Aine Convent Sn",
    "SETHours": "95",
    "spClassTeachingPosts": "0",
    "mainSNA": "5",
    "spSNA": "0",
    "totalSNA": "5",
    "eircode": "D05PD34",
    "addressOne": "All Saints Drive",
    "addressTwo": "Raheny",
    "addressThree": "Dublin 5",
    "addressFour": "",
    "lat": "53.3783439",
    "lng": "-6.1773996",
    "phone": "18319463",
    "email": "scoilaineraheny1958@gmail.com"
  },
  {
    "i": "874",
    "county": "Dublin",
    "rollNumber": "17978V",
    "schoolName": "Naiscoil Ide",
    "SETHours": "97.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.98",
    "spSNA": "0",
    "totalSNA": "4.98",
    "eircode": "D05E932",
    "addressOne": "All Saints Drive",
    "addressTwo": "Raheny",
    "addressThree": "Dublin 5",
    "addressFour": "",
    "lat": "53.3779098",
    "lng": "-6.178314",
    "phone": "18317688",
    "email": "naiscoilide@gmail.com"
  },
  {
    "i": "875",
    "county": "Dublin",
    "rollNumber": "17979A",
    "schoolName": "SN Cnoc Ainbhil",
    "SETHours": "117.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "A94E2N7",
    "addressOne": "Lower Kilmacud Road",
    "addressTwo": "Stillorgan",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.2892001",
    "lng": "-6.2177477",
    "phone": "12831148",
    "email": "secretary@mountanvilleprimaryschool.com"
  },
  {
    "i": "876",
    "county": "Dublin",
    "rollNumber": "17996A",
    "schoolName": "Glen Na Smol NS",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "D24YC57",
    "addressOne": "Glenasmole",
    "addressTwo": "Bohernabreena",
    "addressThree": "Dublin 24",
    "addressFour": "",
    "lat": "53.2454664",
    "lng": "-6.3576089",
    "phone": "14624143",
    "email": "office@glenasmolens.com"
  },
  {
    "i": "877",
    "county": "Dublin",
    "rollNumber": "18038B",
    "schoolName": "St Margarets NS",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "K67PE80",
    "addressOne": "Sandyhill",
    "addressTwo": "Saint Margaret's",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.4301874",
    "lng": "-6.3005047",
    "phone": "18361669",
    "email": "stmargaretsns@hotmail.com"
  },
  {
    "i": "878",
    "county": "Dublin",
    "rollNumber": "18046A",
    "schoolName": "Scoil Bride B",
    "SETHours": "182.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "5.66",
    "spSNA": "2",
    "totalSNA": "7.66",
    "eircode": "D15H329",
    "addressOne": "Church Avenue",
    "addressTwo": "Blanchardstown",
    "addressThree": "Dublin 15",
    "addressFour": "",
    "lat": "53.3843546",
    "lng": "-6.3733118",
    "phone": "18201299",
    "email": "secretarysbb@gmail.com"
  },
  {
    "i": "879",
    "county": "Dublin",
    "rollNumber": "18047C",
    "schoolName": "Scoil Bride C",
    "SETHours": "75",
    "spClassTeachingPosts": "1",
    "mainSNA": "3.83",
    "spSNA": "2.49",
    "totalSNA": "6.32",
    "eircode": "D15R271",
    "addressOne": "Church Avenue",
    "addressTwo": "Blanchardstown",
    "addressThree": "Dublin 15",
    "addressFour": "",
    "lat": "53.3845479",
    "lng": "-6.3740176",
    "phone": "18201717",
    "email": "priomhoidesbc@gmail.com"
  },
  {
    "i": "880",
    "county": "Dublin",
    "rollNumber": "18080A",
    "schoolName": "Scoil Mhuire Mxd",
    "SETHours": "155",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.33",
    "spSNA": "0",
    "totalSNA": "4.33",
    "eircode": "D13PW99",
    "addressOne": "Tuckett's Lane",
    "addressTwo": "Howth",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.3843945",
    "lng": "-6.068928",
    "phone": "18323572",
    "email": "howthns@gmail.com"
  },
  {
    "i": "881",
    "county": "Dublin",
    "rollNumber": "18137D",
    "schoolName": "Sn Naomh Feargal Boys Sn",
    "SETHours": "112.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "4.5",
    "spSNA": "4.66",
    "totalSNA": "9.16",
    "eircode": "D11E925",
    "addressOne": "Finglas West",
    "addressTwo": "Dublin 11",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3876137",
    "lng": "-6.3067932",
    "phone": "18347609",
    "email": "stfergals@yahoo.ie"
  },
  {
    "i": "882",
    "county": "Dublin",
    "rollNumber": "18170B",
    "schoolName": "Sn Muire Na Freastogala Girls Sen",
    "SETHours": "75",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "D12FK49",
    "addressOne": "Assumption Sn Girls Ns",
    "addressTwo": "Long Mile Rd",
    "addressThree": "Walkinstown",
    "addressFour": "Dublin 12",
    "lat": "53.3232154",
    "lng": "-6.3323549",
    "phone": "14508309",
    "email": "info@assumptiongns.ie"
  },
  {
    "i": "883",
    "county": "Dublin",
    "rollNumber": "18173H",
    "schoolName": "SN Briotas",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "D24WK77",
    "addressOne": "Brittas",
    "addressTwo": "Co. Dublin",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.2350779",
    "lng": "-6.4523441",
    "phone": "14582311",
    "email": "smarbrit.ias@eircom.net"
  },
  {
    "i": "884",
    "county": "Dublin",
    "rollNumber": "18205R",
    "schoolName": "SN An Pharoiste",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "D11XT35",
    "addressOne": "Church Street",
    "addressTwo": "Finglas",
    "addressThree": "Dublin 11",
    "addressFour": "",
    "lat": "53.3883596",
    "lng": "-6.3035023",
    "phone": "18347349",
    "email": "principal@finglasparochialns.ie"
  },
  {
    "i": "885",
    "county": "Dublin",
    "rollNumber": "18282M",
    "schoolName": "Sn Paroiste Maitiu Nfa",
    "SETHours": "90",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "D04FK11",
    "addressOne": "Cranfield Place",
    "addressTwo": "Sandymount",
    "addressThree": "Dublin 4",
    "addressFour": "",
    "lat": "53.3373327",
    "lng": "-6.2211561",
    "phone": "16603145",
    "email": "secretary@stmatts.ie"
  },
  {
    "i": "886",
    "county": "Dublin",
    "rollNumber": "18323A",
    "schoolName": "Scoil Lorcain B",
    "SETHours": "160",
    "spClassTeachingPosts": "0",
    "mainSNA": "6",
    "spSNA": "0",
    "totalSNA": "6",
    "eircode": "D20W227",
    "addressOne": "The Oval",
    "addressTwo": "Palmerstown",
    "addressThree": "Dublin 20",
    "addressFour": "",
    "lat": "53.3524247",
    "lng": "-6.3690216",
    "phone": "16267493",
    "email": "stlorcans@eircom.net"
  },
  {
    "i": "887",
    "county": "Dublin",
    "rollNumber": "18324C",
    "schoolName": "Scoil Bride C",
    "SETHours": "105",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.66",
    "spSNA": "0",
    "totalSNA": "4.66",
    "eircode": "D20AC82",
    "addressOne": "Turret Road",
    "addressTwo": "Palmerstown",
    "addressThree": "Dublin 20",
    "addressFour": "",
    "lat": "53.3521058",
    "lng": "-6.3696231",
    "phone": "16265431",
    "email": "stbrigidsgns@gmail.com"
  },
  {
    "i": "888",
    "county": "Dublin",
    "rollNumber": "18360G",
    "schoolName": "Scoil Bhreandain",
    "SETHours": "95",
    "spClassTeachingPosts": "1",
    "mainSNA": "4",
    "spSNA": "2",
    "totalSNA": "6",
    "eircode": "D05P820",
    "addressOne": "Mcauley Road",
    "addressTwo": "Artane",
    "addressThree": "Dublin 5",
    "addressFour": "",
    "lat": "53.3842884",
    "lng": "-6.1961926",
    "phone": "18319047",
    "email": "stbrendansartane@gmail.com"
  },
  {
    "i": "889",
    "county": "Dublin",
    "rollNumber": "18361I",
    "schoolName": "Sn Caitriona Girls",
    "SETHours": "95",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "D05HR61",
    "addressOne": "Measc Avenue",
    "addressTwo": "Coolock",
    "addressThree": "Dublin 5",
    "addressFour": "",
    "lat": "53.3849953",
    "lng": "-6.1981399",
    "phone": "18480018",
    "email": "scoilchaitriona@gmail.com"
  },
  {
    "i": "890",
    "county": "Dublin",
    "rollNumber": "18362K",
    "schoolName": "SN Caitriona Naionain",
    "SETHours": "97.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.98",
    "spSNA": "0",
    "totalSNA": "4.98",
    "eircode": "D05FC92",
    "addressOne": "Measc Avenue",
    "addressTwo": "Coolock",
    "addressThree": "Dublin 5",
    "addressFour": "",
    "lat": "53.3851028",
    "lng": "-6.1989158",
    "phone": "18480142",
    "email": "scoilchaitriona.infants246@gmail.com"
  },
  {
    "i": "891",
    "county": "Dublin",
    "rollNumber": "18386B",
    "schoolName": "Marist NS",
    "SETHours": "125",
    "spClassTeachingPosts": "1",
    "mainSNA": "4.66",
    "spSNA": "1.83",
    "totalSNA": "6.49",
    "eircode": "D12YP98",
    "addressOne": "Clogher Road",
    "addressTwo": "Crumlin",
    "addressThree": "Dublin 12",
    "addressFour": "",
    "lat": "53.3260676",
    "lng": "-6.2932641",
    "phone": "14541228",
    "email": "maristps@hotmail.com"
  },
  {
    "i": "892",
    "county": "Dublin",
    "rollNumber": "18411U",
    "schoolName": "St Marys School",
    "SETHours": "217.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "8.66",
    "spSNA": "0",
    "totalSNA": "8.66",
    "eircode": "D24K248",
    "addressOne": "Greenhills Road",
    "addressTwo": "Tallaght",
    "addressThree": "Dublin 24",
    "addressFour": "",
    "lat": "53.2903925",
    "lng": "-6.3572988",
    "phone": "14515387",
    "email": "office@stmarystallaght.ie"
  },
  {
    "i": "893",
    "county": "Dublin",
    "rollNumber": "18412W",
    "schoolName": "SN C Naomh Padraig",
    "SETHours": "107.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.49",
    "spSNA": "0",
    "totalSNA": "4.49",
    "eircode": "K36KH36",
    "addressOne": "Portrane Road",
    "addressTwo": "Donabate",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.4927243",
    "lng": "-6.1356108",
    "phone": "18436201",
    "email": "scoilphadraic@gmail.com"
  },
  {
    "i": "894",
    "county": "Dublin",
    "rollNumber": "18451J",
    "schoolName": "Scoil Lorcáin",
    "SETHours": "125",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.83",
    "spSNA": "0",
    "totalSNA": "5.83",
    "eircode": "A94F596",
    "addressOne": "Cearnóg Eaton",
    "addressTwo": "Baile Na Manach",
    "addressThree": "Co. átha Cliath",
    "addressFour": "",
    "lat": "53.2966333",
    "lng": "-6.1647906",
    "phone": "12808906",
    "email": "scoillorcain1@scoillorcain.ie"
  },
  {
    "i": "895",
    "county": "Dublin",
    "rollNumber": "18477E",
    "schoolName": "Scoil Na Mbrathar",
    "SETHours": "77.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "3",
    "spSNA": "5",
    "totalSNA": "8",
    "eircode": "D08FE83",
    "addressOne": "John Dillon Street",
    "addressTwo": "Dublin 8",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3414328",
    "lng": "-6.2735045",
    "phone": "14531800",
    "email": "principal.francisstcbs@gmail.com"
  },
  {
    "i": "896",
    "county": "Dublin",
    "rollNumber": "18585H",
    "schoolName": "Sn Banrion Na Naingeal1",
    "SETHours": "160",
    "spClassTeachingPosts": "1",
    "mainSNA": "6.83",
    "spSNA": "2",
    "totalSNA": "8.83",
    "eircode": "D10A997",
    "addressOne": "Gurteen Road",
    "addressTwo": "Ballyfermot",
    "addressThree": "Dublin 10",
    "addressFour": "",
    "lat": "53.3464229",
    "lng": "-6.3611618",
    "phone": "16265207",
    "email": "mqa1@eircom.net"
  },
  {
    "i": "897",
    "county": "Dublin",
    "rollNumber": "18602E",
    "schoolName": "Scoil Mhuire",
    "SETHours": "122.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.66",
    "spSNA": "0",
    "totalSNA": "2.66",
    "eircode": "D22F851",
    "addressOne": "Convent Road",
    "addressTwo": "Clondalkin",
    "addressThree": "Dublin 22",
    "addressFour": "",
    "lat": "53.3179102",
    "lng": "-6.3943865",
    "phone": "14592986",
    "email": "scoilmhuireoffice@eircom.net"
  },
  {
    "i": "898",
    "county": "Dublin",
    "rollNumber": "18623M",
    "schoolName": "Scoil Naisunta Chnuacha",
    "SETHours": "70",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "D15PV38",
    "addressOne": "Main Street",
    "addressTwo": "Castleknock",
    "addressThree": "Dublin 15",
    "addressFour": "",
    "lat": "53.3742074",
    "lng": "-6.3622634",
    "phone": "18202611",
    "email": "office@castleknocknationalschool.ie"
  },
  {
    "i": "899",
    "county": "Dublin",
    "rollNumber": "18632N",
    "schoolName": "SN Eoin Bosco Nai Buac",
    "SETHours": "105",
    "spClassTeachingPosts": "1",
    "mainSNA": "4.49",
    "spSNA": "1.83",
    "totalSNA": "6.32",
    "eircode": "D07WP22",
    "addressOne": "Navan Road",
    "addressTwo": "Dublin 7",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3683529",
    "lng": "-6.3144301",
    "phone": "18380495",
    "email": "info@stjohnboscojbs.com"
  },
  {
    "i": "900",
    "county": "Dublin",
    "rollNumber": "18642Q",
    "schoolName": "SN Naomh Eoin",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "D22YN52",
    "addressOne": "Tower Road",
    "addressTwo": "Clondalkin",
    "addressThree": "Dublin 22",
    "addressFour": "",
    "lat": "53.3217472",
    "lng": "-6.3945363",
    "phone": "14570680",
    "email": "principal@stjohnsnsclondalkin.com"
  },
  {
    "i": "901",
    "county": "Dublin",
    "rollNumber": "18646B",
    "schoolName": "Springdale NS",
    "SETHours": "102.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "7",
    "spSNA": "0",
    "totalSNA": "7",
    "eircode": "D05E954",
    "addressOne": "Lough Derg Road",
    "addressTwo": "Raheny",
    "addressThree": "Dublin 5",
    "addressFour": "",
    "lat": "53.3822925",
    "lng": "-6.1795354",
    "phone": "18317149",
    "email": "principal@springdale.ie"
  },
  {
    "i": "902",
    "county": "Dublin",
    "rollNumber": "18647D",
    "schoolName": "SN San Treasa",
    "SETHours": "147.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "A94EK75",
    "addressOne": "The Rise",
    "addressTwo": "Mount Merrion",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.2948638",
    "lng": "-6.2100336",
    "phone": "12881505",
    "email": "principal@sstreasa.ie"
  },
  {
    "i": "903",
    "county": "Dublin",
    "rollNumber": "18655C",
    "schoolName": "Scoil Naomh Seosamh",
    "SETHours": "172.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "8",
    "spSNA": "0",
    "totalSNA": "8",
    "eircode": "D22PY13",
    "addressOne": "Boot Road",
    "addressTwo": "Clondalkin",
    "addressThree": "Dublin 22",
    "addressFour": "",
    "lat": "53.3173069",
    "lng": "-6.3950079",
    "phone": "14592951",
    "email": "secretary@stjosephsbns.ie"
  },
  {
    "i": "904",
    "county": "Dublin",
    "rollNumber": "18682F",
    "schoolName": "St Canices BNS",
    "SETHours": "230",
    "spClassTeachingPosts": "0",
    "mainSNA": "6.66",
    "spSNA": "0",
    "totalSNA": "6.66",
    "eircode": "D11TW01",
    "addressOne": "Glasanaon Road",
    "addressTwo": "Finglas",
    "addressThree": "Dublin 11",
    "addressFour": "",
    "lat": "53.3892302",
    "lng": "-6.2920388",
    "phone": "18341585",
    "email": "info@stcanices.com"
  },
  {
    "i": "905",
    "county": "Dublin",
    "rollNumber": "18683H",
    "schoolName": "St Canices GNS",
    "SETHours": "147.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "D11C927",
    "addressOne": "Seamus Ennis Road",
    "addressTwo": "Finglas",
    "addressThree": "Dublin 11",
    "addressFour": "",
    "lat": "53.3894636",
    "lng": "-6.2967774",
    "phone": "18342072",
    "email": "info@stcanicesgns.ie"
  },
  {
    "i": "906",
    "county": "Dublin",
    "rollNumber": "18726W",
    "schoolName": "SN Seosamh Na Mbrathar",
    "SETHours": "95.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "3.5",
    "spSNA": "6",
    "totalSNA": "9.5",
    "eircode": "D03H524",
    "addressOne": "Marino Park Avenue",
    "addressTwo": "Fairview",
    "addressThree": "Dublin 3",
    "addressFour": "",
    "lat": "53.3639026",
    "lng": "-6.2336681",
    "phone": "18336127",
    "email": "barbara@stjosephscbs.ie"
  },
  {
    "i": "907",
    "county": "Dublin",
    "rollNumber": "18778S",
    "schoolName": "SN Naomh Mochta",
    "SETHours": "252.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "12.32",
    "spSNA": "0",
    "totalSNA": "12.32",
    "eircode": "D15Y316",
    "addressOne": "Porterstown Road",
    "addressTwo": "Clonsilla",
    "addressThree": "Dublin 15",
    "addressFour": "",
    "lat": "53.3820015",
    "lng": "-6.4051662",
    "phone": "18130430",
    "email": "info@stmochtas.ie"
  },
  {
    "i": "908",
    "county": "Dublin",
    "rollNumber": "18806U",
    "schoolName": "Kilternan NS 1",
    "SETHours": "110",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.33",
    "spSNA": "0",
    "totalSNA": "4.33",
    "eircode": "D18CY28",
    "addressOne": "Kilternan",
    "addressTwo": "Dublin 18",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.2357197",
    "lng": "-6.1960453",
    "phone": "12955682",
    "email": "school@ourladyofthewaysidens.ie"
  },
  {
    "i": "909",
    "county": "Dublin",
    "rollNumber": "18817C",
    "schoolName": "SN Brighde",
    "SETHours": "100",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "D06E8K7",
    "addressOne": "Cullenswood House",
    "addressTwo": "Bóthar Feadha Cuilinn",
    "addressThree": "Raghnallach",
    "addressFour": "Baile átha Cliath 6",
    "lat": "53.3218661",
    "lng": "-6.2572303",
    "phone": "14973390",
    "email": "scoilbhride01@gmail.com"
  },
  {
    "i": "910",
    "county": "Dublin",
    "rollNumber": "18843D",
    "schoolName": "Bainrion Na N-aingal 2",
    "SETHours": "132.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "7.83",
    "spSNA": "1.83",
    "totalSNA": "9.66",
    "eircode": "D10C527",
    "addressOne": "Gurteen Road",
    "addressTwo": "Ballyfermot",
    "addressThree": "Dublin 10",
    "addressFour": "",
    "lat": "53.3464229",
    "lng": "-6.3611618",
    "phone": "16235067",
    "email": "maryqueenofangels2@gmail.com"
  },
  {
    "i": "911",
    "county": "Dublin",
    "rollNumber": "18886V",
    "schoolName": "Kill-o'-the-grange Ns",
    "SETHours": "95",
    "spClassTeachingPosts": "0",
    "mainSNA": "7",
    "spSNA": "0",
    "totalSNA": "7",
    "eircode": "A94X225",
    "addressOne": "Deansgrange",
    "addressTwo": "Blackrock",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.2781547",
    "lng": "-6.1618314",
    "phone": "12894578",
    "email": "admin@kogrange.com"
  },
  {
    "i": "912",
    "county": "Dublin",
    "rollNumber": "18910P",
    "schoolName": "Bantiarna Na Mbuanna Boys",
    "SETHours": "120",
    "spClassTeachingPosts": "0",
    "mainSNA": "8",
    "spSNA": "0",
    "totalSNA": "8",
    "eircode": "D09HC90",
    "addressOne": "Ballymun Rd",
    "addressTwo": "Dublin 9",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3890528",
    "lng": "-6.2682797",
    "phone": "18375255",
    "email": "olvboys.ias@eircom.net"
  },
  {
    "i": "913",
    "county": "Dublin",
    "rollNumber": "18911R",
    "schoolName": "Bantiarna Na Mbuanna Girls",
    "SETHours": "85",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.5",
    "spSNA": "0",
    "totalSNA": "4.5",
    "eircode": "D09NY99",
    "addressOne": "Ballymun Road",
    "addressTwo": "Dublin 9",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.38871",
    "lng": "-6.266596",
    "phone": "18379833",
    "email": "victories.ias@eircom.net"
  },
  {
    "i": "914",
    "county": "Dublin",
    "rollNumber": "18968A",
    "schoolName": "St Malachys BNS",
    "SETHours": "155",
    "spClassTeachingPosts": "3",
    "mainSNA": "5.66",
    "spSNA": "6",
    "totalSNA": "11.66",
    "eircode": "D05HP30",
    "addressOne": "Edenmore Park",
    "addressTwo": "Raheny",
    "addressThree": "Dublin 5",
    "addressFour": "",
    "lat": "53.3881716",
    "lng": "-6.1805702",
    "phone": "18478952",
    "email": "stmalachyse.ias@eircom.net"
  },
  {
    "i": "915",
    "county": "Dublin",
    "rollNumber": "18969C",
    "schoolName": "St Eithnes Sn Girls Ns",
    "SETHours": "57.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "2.5",
    "spSNA": "3.66",
    "totalSNA": "6.16",
    "eircode": "D05NH04",
    "addressOne": "Edenmore",
    "addressTwo": "Raheny",
    "addressThree": "Dublin 5",
    "addressFour": "",
    "lat": "53.3895053",
    "lng": "-6.1807765",
    "phone": "18480630",
    "email": "steithnesgns@gmail.com"
  },
  {
    "i": "916",
    "county": "Dublin",
    "rollNumber": "18976W",
    "schoolName": "SN Cholmille B",
    "SETHours": "220",
    "spClassTeachingPosts": "0",
    "mainSNA": "8.66",
    "spSNA": "0",
    "totalSNA": "8.66",
    "eircode": "K67WP65",
    "addressOne": "Chapel Lane",
    "addressTwo": "Swords",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.4584828",
    "lng": "-6.214772",
    "phone": "18405132",
    "email": "colmcilles@gmail.com"
  },
  {
    "i": "917",
    "county": "Dublin",
    "rollNumber": "18977B",
    "schoolName": "SN Cholmcille C",
    "SETHours": "127.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "K67H337",
    "addressOne": "Chapel Lane",
    "addressTwo": "Swords",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.4576702",
    "lng": "-6.214372",
    "phone": "18404168",
    "email": "colmcillesgns@gmail.com"
  },
  {
    "i": "918",
    "county": "Dublin",
    "rollNumber": "19001G",
    "schoolName": "Ballyboghill NS",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "A41RC98",
    "addressOne": "Ballyboughal",
    "addressTwo": "Co. Dublin",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.5210805",
    "lng": "-6.2664566",
    "phone": "18433469",
    "email": "principal@ballyboughalns.ie"
  },
  {
    "i": "919",
    "county": "Dublin",
    "rollNumber": "19006Q",
    "schoolName": "Eoin Baisde B Sois",
    "SETHours": "110",
    "spClassTeachingPosts": "1",
    "mainSNA": "5.49",
    "spSNA": "1.66",
    "totalSNA": "7.15",
    "eircode": "D03TD21",
    "addressOne": "Seafield Road",
    "addressTwo": "Clontarf",
    "addressThree": "Dublin 3",
    "addressFour": "",
    "lat": "53.3639162",
    "lng": "-6.197803",
    "phone": "18336539",
    "email": "info@belgrovejbs.ie"
  },
  {
    "i": "920",
    "county": "Dublin",
    "rollNumber": "19007S",
    "schoolName": "Eoin Baisde C Naoidh",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "D03XK27",
    "addressOne": "Seafield Road West",
    "addressTwo": "Clontarf",
    "addressThree": "Dublin 3",
    "addressFour": "",
    "lat": "53.3636216",
    "lng": "-6.1997732",
    "phone": "18332459",
    "email": "secretary@belgrove.ie"
  },
  {
    "i": "921",
    "county": "Dublin",
    "rollNumber": "19015R",
    "schoolName": "St Josephs GNS",
    "SETHours": "110",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "D11A8PD",
    "addressOne": "Barry Avenue",
    "addressTwo": "Finglas West",
    "addressThree": "Dublin 11",
    "addressFour": "",
    "lat": "53.3951771",
    "lng": "-6.309877",
    "phone": "18342433",
    "email": "principal@stjosephsfinglas.net"
  },
  {
    "i": "922",
    "county": "Dublin",
    "rollNumber": "19037E",
    "schoolName": "St Monicas NS",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "D05VX21",
    "addressOne": "Edenmore Park",
    "addressTwo": "Raheny",
    "addressThree": "Dublin 5",
    "addressFour": "",
    "lat": "53.3893635",
    "lng": "-6.1805892",
    "phone": "18674540",
    "email": "scoilmonica@gmail.com"
  },
  {
    "i": "923",
    "county": "Dublin",
    "rollNumber": "19066L",
    "schoolName": "Loreto NS",
    "SETHours": "67.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "2.5",
    "spSNA": "2",
    "totalSNA": "4.5",
    "eircode": "A96P8N3",
    "addressOne": "Loreto Avenue",
    "addressTwo": "Dalkey",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.2803316",
    "lng": "-6.101368",
    "phone": "12802128",
    "email": "secretary@loretopsdalkey.ie"
  },
  {
    "i": "924",
    "county": "Dublin",
    "rollNumber": "19114T",
    "schoolName": "St Patrick GNS",
    "SETHours": "167.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "8.32",
    "spSNA": "0",
    "totalSNA": "8.32",
    "eircode": "D16XK80",
    "addressOne": "Ballyroan",
    "addressTwo": "Rathfarnham",
    "addressThree": "Dublin 16",
    "addressFour": "",
    "lat": "53.2863572",
    "lng": "-6.3001664",
    "phone": "14946566",
    "email": "info@snp.ie"
  },
  {
    "i": "925",
    "county": "Dublin",
    "rollNumber": "19177U",
    "schoolName": "St Pius X NS Boys",
    "SETHours": "220",
    "spClassTeachingPosts": "0",
    "mainSNA": "8.66",
    "spSNA": "0",
    "totalSNA": "8.66",
    "eircode": "D6WHP92",
    "addressOne": "Fortfield Park",
    "addressTwo": "Terenure",
    "addressThree": "Dublin 6",
    "addressFour": "",
    "lat": "53.3027676",
    "lng": "-6.3054478",
    "phone": "14903057",
    "email": "secretary@piusxbns.ie"
  },
  {
    "i": "926",
    "county": "Dublin",
    "rollNumber": "19178W",
    "schoolName": "St Pius X GNS",
    "SETHours": "137.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.83",
    "spSNA": "0",
    "totalSNA": "5.83",
    "eircode": "D6WPN27",
    "addressOne": "Fortfield Park",
    "addressTwo": "Terenure",
    "addressThree": "Dublin 6w",
    "addressFour": "",
    "lat": "53.3026534",
    "lng": "-6.3047333",
    "phone": "14901052",
    "email": "secretary@piusxgns.ie"
  },
  {
    "i": "927",
    "county": "Dublin",
    "rollNumber": "19197D",
    "schoolName": "St Kevins BNS",
    "SETHours": "107.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.66",
    "spSNA": "0",
    "totalSNA": "5.66",
    "eircode": "D11VW22",
    "addressOne": "Barry Avenue",
    "addressTwo": "Finglas West",
    "addressThree": "Dublin 11",
    "addressFour": "",
    "lat": "53.3960121",
    "lng": "-6.3093259",
    "phone": "18343061",
    "email": "stkevinsadmin@eircom.net"
  },
  {
    "i": "928",
    "county": "Dublin",
    "rollNumber": "19208F",
    "schoolName": "Holy Spirit BNS",
    "SETHours": "210",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.66",
    "spSNA": "0",
    "totalSNA": "5.66",
    "eircode": "D11N207",
    "addressOne": "Sillogue Road",
    "addressTwo": "Ballymun",
    "addressThree": "Dublin 11",
    "addressFour": "",
    "lat": "53.3959344",
    "lng": "-6.2699076",
    "phone": "18421230",
    "email": "holyspiritbns@yahoo.co.uk"
  },
  {
    "i": "929",
    "county": "Dublin",
    "rollNumber": "19209H",
    "schoolName": "Sn An Spioraid Naiomh C",
    "SETHours": "167.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "D11X26P",
    "addressOne": "Sillogue Road",
    "addressTwo": "Ballymun",
    "addressThree": "Dublin 11",
    "addressFour": "",
    "lat": "53.3956358",
    "lng": "-6.2710977",
    "phone": "18420207",
    "email": "principal@holyspiritgns.ie"
  },
  {
    "i": "930",
    "county": "Dublin",
    "rollNumber": "19220S",
    "schoolName": "Scoil Naomh Ide",
    "SETHours": "102.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "D22ED72",
    "addressOne": "New Road",
    "addressTwo": "Clondalkin",
    "addressThree": "Dublin 22",
    "addressFour": "",
    "lat": "53.3176525",
    "lng": "-6.392453",
    "phone": "14592766",
    "email": "secretary@scoilidepps.com"
  },
  {
    "i": "931",
    "county": "Dublin",
    "rollNumber": "19221U",
    "schoolName": "Scoil Naomh Aine",
    "SETHours": "100",
    "spClassTeachingPosts": "1",
    "mainSNA": "2.83",
    "spSNA": "1.66",
    "totalSNA": "4.49",
    "eircode": "D22X577",
    "addressOne": "New Road",
    "addressTwo": "Clondalkin Village",
    "addressThree": "Dublin 22",
    "addressFour": "",
    "lat": "53.3171118",
    "lng": "-6.3922382",
    "phone": "14591645",
    "email": "admin@scoilaine.ie"
  },
  {
    "i": "932",
    "county": "Dublin",
    "rollNumber": "19242F",
    "schoolName": "Our Lady Of Victories Infant NS",
    "SETHours": "120",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.48",
    "spSNA": "0",
    "totalSNA": "5.48",
    "eircode": "D09YC99",
    "addressOne": "Ballymun Road",
    "addressTwo": "Dublin 9",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3886953",
    "lng": "-6.2670763",
    "phone": "18372372",
    "email": "office@olvinfants.com"
  },
  {
    "i": "933",
    "county": "Dublin",
    "rollNumber": "19258U",
    "schoolName": "Scoil Padraig Naofa B",
    "SETHours": "202.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "9",
    "spSNA": "0",
    "totalSNA": "9",
    "eircode": "A94FE02",
    "addressOne": "Hollypark",
    "addressTwo": "Blackrock",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.2801917",
    "lng": "-6.1749565",
    "phone": "12896042",
    "email": "info@hollyparkbns.ie"
  },
  {
    "i": "934",
    "county": "Dublin",
    "rollNumber": "19259W",
    "schoolName": "St Patricks GNS",
    "SETHours": "120",
    "spClassTeachingPosts": "0",
    "mainSNA": "6",
    "spSNA": "0",
    "totalSNA": "6",
    "eircode": "D18V659",
    "addressOne": "Foxrock Avenue",
    "addressTwo": "Foxrock",
    "addressThree": "Dublin 18",
    "addressFour": "",
    "lat": "53.2796325",
    "lng": "-6.17549",
    "phone": "12893293",
    "email": "hollyparkgns@gmail.com"
  },
  {
    "i": "935",
    "county": "Dublin",
    "rollNumber": "19297H",
    "schoolName": "Cromcastle Green BNS",
    "SETHours": "147.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.83",
    "spSNA": "0",
    "totalSNA": "4.83",
    "eircode": "D05YP68",
    "addressOne": "Cromcastle Green",
    "addressTwo": "Kilmore West",
    "addressThree": "Dublin 5",
    "addressFour": "",
    "lat": "53.3948577",
    "lng": "-6.220007",
    "phone": "18476709",
    "email": "mrstynes@scoilfhursa.ie"
  },
  {
    "i": "936",
    "county": "Dublin",
    "rollNumber": "19298J",
    "schoolName": "Scoil Nais Ide Cailini",
    "SETHours": "100",
    "spClassTeachingPosts": "1",
    "mainSNA": "2",
    "spSNA": "1.66",
    "totalSNA": "3.66",
    "eircode": "D05TN12",
    "addressOne": "Cromcastle Green",
    "addressTwo": "Kilmore West",
    "addressThree": "Dublin 5",
    "addressFour": "",
    "lat": "53.3951573",
    "lng": "-6.2199655",
    "phone": "18476048",
    "email": "info@scoilidegns.ie"
  },
  {
    "i": "937",
    "county": "Dublin",
    "rollNumber": "19302U",
    "schoolName": "Sn Na Maighdine Muire B",
    "SETHours": "105",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.66",
    "spSNA": "0",
    "totalSNA": "4.66",
    "eircode": "D09H2F2",
    "addressOne": "Shangan Road",
    "addressTwo": "Ballymun",
    "addressThree": "Dublin 9",
    "addressFour": "",
    "lat": "53.3957116",
    "lng": "-6.2604495",
    "phone": "18421314",
    "email": "Info@virginmarybns.ie"
  },
  {
    "i": "938",
    "county": "Dublin",
    "rollNumber": "19303W",
    "schoolName": "Virgin Mary GNS",
    "SETHours": "80",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.41",
    "spSNA": "0",
    "totalSNA": "3.41",
    "eircode": "D09T2X6",
    "addressOne": "Shangan Road",
    "addressTwo": "Ballymun",
    "addressThree": "Dublin 9",
    "addressFour": "",
    "lat": "53.3957788",
    "lng": "-6.2610331",
    "phone": "18421614",
    "email": "info@virginmarygns.ie"
  },
  {
    "i": "939",
    "county": "Dublin",
    "rollNumber": "19308J",
    "schoolName": "St Brigids Boys NS",
    "SETHours": "162.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "7.33",
    "spSNA": "0",
    "totalSNA": "7.33",
    "eircode": "D05A386",
    "addressOne": "Howth Road",
    "addressTwo": "Killester",
    "addressThree": "Dublin 5",
    "addressFour": "",
    "lat": "53.3748068",
    "lng": "-6.1954114",
    "phone": "18336149",
    "email": "info@stbrigidsbns.ie"
  },
  {
    "i": "940",
    "county": "Dublin",
    "rollNumber": "19309L",
    "schoolName": "Scoil Neasain",
    "SETHours": "82.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "D05VF95",
    "addressOne": "Baile Harmain",
    "addressTwo": "Baile átha Cliath 5",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3821258",
    "lng": "-6.1964247",
    "phone": "18316338",
    "email": "oifigscn@gmail.com"
  },
  {
    "i": "941",
    "county": "Dublin",
    "rollNumber": "19314E",
    "schoolName": "Scoil Na Maighdine Mhuire Boy",
    "SETHours": "105",
    "spClassTeachingPosts": "2",
    "mainSNA": "5",
    "spSNA": "4",
    "totalSNA": "9",
    "eircode": "D16CX60",
    "addressOne": "Broadford Rise",
    "addressTwo": "Ballinteer",
    "addressThree": "Dublin 16",
    "addressFour": "",
    "lat": "53.2752359",
    "lng": "-6.2580114",
    "phone": "14946647",
    "email": "info@olbns.com"
  },
  {
    "i": "942",
    "county": "Dublin",
    "rollNumber": "19319O",
    "schoolName": "St Olaf's NS",
    "SETHours": "165",
    "spClassTeachingPosts": "0",
    "mainSNA": "8",
    "spSNA": "0",
    "totalSNA": "8",
    "eircode": "D16E067",
    "addressOne": "Balally Drive",
    "addressTwo": "Dundrum",
    "addressThree": "Dublin 16",
    "addressFour": "",
    "lat": "53.2825583",
    "lng": "-6.2264008",
    "phone": "12956513",
    "email": "olaf.info@gmail.com"
  },
  {
    "i": "943",
    "county": "Dublin",
    "rollNumber": "19320W",
    "schoolName": "Our Lady Of Good Counsel Boys NS",
    "SETHours": "142.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "9",
    "spSNA": "0",
    "totalSNA": "9",
    "eircode": "A96AF10",
    "addressOne": "Johnstown",
    "addressTwo": "Dún Laoghaire",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.2645998",
    "lng": "-6.1386454",
    "phone": "12851449",
    "email": "johnstownbns@olgc.ie"
  },
  {
    "i": "944",
    "county": "Dublin",
    "rollNumber": "19321B",
    "schoolName": "Our Lady Good Counsel GNS",
    "SETHours": "120",
    "spClassTeachingPosts": "3",
    "mainSNA": "8.83",
    "spSNA": "8.66",
    "totalSNA": "17.49",
    "eircode": "A96A033",
    "addressOne": "Woodley Road",
    "addressTwo": "Johnstown",
    "addressThree": "Dun Laoghaire",
    "addressFour": "Co. Dublin",
    "lat": "53.2638968",
    "lng": "-6.1389832",
    "phone": "12853775",
    "email": "office@johnstowngns.ie"
  },
  {
    "i": "945",
    "county": "Dublin",
    "rollNumber": "19335M",
    "schoolName": "Scoil Na Aingeal",
    "SETHours": "175",
    "spClassTeachingPosts": "0",
    "mainSNA": "7",
    "spSNA": "0",
    "totalSNA": "7",
    "eircode": "A94H395",
    "addressOne": "Newtownpark Avenue",
    "addressTwo": "Blackrock",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.2925065",
    "lng": "-6.1714628",
    "phone": "12833961",
    "email": "info@guardianangels.ie"
  },
  {
    "i": "947",
    "county": "Dublin",
    "rollNumber": "19374W",
    "schoolName": "Our Lady's Grove Primary School",
    "SETHours": "170",
    "spClassTeachingPosts": "0",
    "mainSNA": "8",
    "spSNA": "0",
    "totalSNA": "8",
    "eircode": "D14Y993",
    "addressOne": "Goatstown Road,",
    "addressTwo": "Dublin 14",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3007117",
    "lng": "-6.2340861",
    "phone": "12988694",
    "email": "annekernan@olgps.ie"
  },
  {
    "i": "948",
    "county": "Dublin",
    "rollNumber": "19390U",
    "schoolName": "St Marks Sn Ns",
    "SETHours": "350",
    "spClassTeachingPosts": "1",
    "mainSNA": "9.75",
    "spSNA": "0.25",
    "totalSNA": "10",
    "eircode": "D24FV07",
    "addressOne": "Springfield",
    "addressTwo": "Tallaght",
    "addressThree": "Dublin 24",
    "addressFour": "",
    "lat": "53.287088",
    "lng": "-6.3872912",
    "phone": "14513138",
    "email": "secretary@saintmarksns.ie"
  },
  {
    "i": "949",
    "county": "Dublin",
    "rollNumber": "19393D",
    "schoolName": "Mhuire Iosef Jn",
    "SETHours": "110",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.16",
    "spSNA": "0",
    "totalSNA": "5.16",
    "eircode": "D13CD56",
    "addressOne": "Verbena Avenue,",
    "addressTwo": "Sutton",
    "addressThree": "Dublin 13",
    "addressFour": "",
    "lat": "53.3892091",
    "lng": "-6.1473678",
    "phone": "18326524",
    "email": "notices@baysidejunior.ie"
  },
  {
    "i": "950",
    "county": "Dublin",
    "rollNumber": "19395H",
    "schoolName": "Scoil Mobhi",
    "SETHours": "90",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "D09A303",
    "addressOne": "Bóthar Mobhí­",
    "addressTwo": "Glasnaí­on",
    "addressThree": "Baile átha Cliath 9",
    "addressFour": "",
    "lat": "53.3734548",
    "lng": "-6.2632061",
    "phone": "18379591",
    "email": "oifig@scoilmobhi.ie"
  },
  {
    "i": "951",
    "county": "Dublin",
    "rollNumber": "19396J",
    "schoolName": "Na Maighdine Muire Girl",
    "SETHours": "77.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "D16C820",
    "addressOne": "Ballinteer",
    "addressTwo": "Dublin 16",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.2750241",
    "lng": "-6.2579912",
    "phone": "14930736",
    "email": "info@ourladysgns.ie"
  },
  {
    "i": "952",
    "county": "Dublin",
    "rollNumber": "19400U",
    "schoolName": "Sn Gleann Na Gcaorach Iní­on Léiní­n",
    "SETHours": "72.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "A96P585",
    "addressOne": "Wyvern",
    "addressTwo": "Killiney",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.2694314",
    "lng": "-6.115773",
    "phone": "12856011",
    "email": "info@gkns.ie"
  },
  {
    "i": "953",
    "county": "Dublin",
    "rollNumber": "19406J",
    "schoolName": "Holy Trinity Sn NS",
    "SETHours": "187.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "3",
    "spSNA": "6",
    "totalSNA": "9",
    "eircode": "D13WY00",
    "addressOne": "Grange Road",
    "addressTwo": "Donaghmede",
    "addressThree": "Dublin 13",
    "addressFour": "",
    "lat": "53.3965438",
    "lng": "-6.1612917",
    "phone": "18474695",
    "email": "htnsoffice@eircom.net"
  },
  {
    "i": "954",
    "county": "Dublin",
    "rollNumber": "19430G",
    "schoolName": "Scoil An Tseachtar Laoch",
    "SETHours": "97.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.66",
    "spSNA": "0",
    "totalSNA": "3.66",
    "eircode": "D11E306",
    "addressOne": "Bóthar Bhaile Munna",
    "addressTwo": "Baile átha Cliath 11",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3926628",
    "lng": "-6.2648043",
    "phone": "18425725",
    "email": "7laoch.ias@eircom.net"
  },
  {
    "i": "955",
    "county": "Dublin",
    "rollNumber": "19431I",
    "schoolName": "St Josephs Jnr",
    "SETHours": "127.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.83",
    "spSNA": "0",
    "totalSNA": "4.83",
    "eircode": "D11ND82",
    "addressOne": "St Joseph's Jn NS",
    "addressTwo": "Balbutcher Lane",
    "addressThree": "Ballymun",
    "addressFour": "Dublin 11",
    "lat": "53.4013335",
    "lng": "-6.2705818",
    "phone": "18421801",
    "email": "stjosjun@eircom.net"
  },
  {
    "i": "956",
    "county": "Dublin",
    "rollNumber": "19435Q",
    "schoolName": "St Francis Xavier J NS",
    "SETHours": "117.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "5.49",
    "spSNA": "2",
    "totalSNA": "7.49",
    "eircode": "D15CX84",
    "addressOne": "Roselawn Road",
    "addressTwo": "Castleknock",
    "addressThree": "Dublin 15",
    "addressFour": "",
    "lat": "53.3833773",
    "lng": "-6.383233",
    "phone": "18210892",
    "email": "sfxjns1@eircom.net"
  },
  {
    "i": "957",
    "county": "Dublin",
    "rollNumber": "19437U",
    "schoolName": "Scoil Naithi",
    "SETHours": "62.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "D16EK63",
    "addressOne": "Bóthar átha Leathan",
    "addressTwo": "Baile An Tsaoir",
    "addressThree": "Baile átha Cliath 16",
    "addressFour": "",
    "lat": "53.282278",
    "lng": "-6.2615337",
    "phone": "12981931",
    "email": "oifig@scoilnaithi.com"
  },
  {
    "i": "958",
    "county": "Dublin",
    "rollNumber": "19438W",
    "schoolName": "Scoil Colmcille Sn",
    "SETHours": "142.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "7",
    "spSNA": "0",
    "totalSNA": "7",
    "eircode": "A96TN32",
    "addressOne": "Coolevin",
    "addressTwo": "Ballybrack",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.2547166",
    "lng": "-6.1346006",
    "phone": "12855527",
    "email": "cholmsenior@gmail.com"
  },
  {
    "i": "959",
    "county": "Dublin",
    "rollNumber": "19446V",
    "schoolName": "Scoil Mhuire Boys",
    "SETHours": "150",
    "spClassTeachingPosts": "0",
    "mainSNA": "7.83",
    "spSNA": "0",
    "totalSNA": "7.83",
    "eircode": "D14P046",
    "addressOne": "Grange Road",
    "addressTwo": "Rathfarnham",
    "addressThree": "Dublin 14",
    "addressFour": "",
    "lat": "53.2948158",
    "lng": "-6.2838866",
    "phone": "14931477",
    "email": "secretary@marysbns.ie"
  },
  {
    "i": "960",
    "county": "Dublin",
    "rollNumber": "19454U",
    "schoolName": "Darndale NS Jn",
    "SETHours": "135",
    "spClassTeachingPosts": "0",
    "mainSNA": "7.82",
    "spSNA": "0",
    "totalSNA": "7.82",
    "eircode": "D17TR25",
    "addressOne": "Our Lady Immac Jun Ns",
    "addressTwo": "Darndale",
    "addressThree": "Malahide Road",
    "addressFour": "Dublin 17",
    "lat": "53.401339",
    "lng": "-6.193453",
    "phone": "18476643",
    "email": "ddalejnr@eircom.net"
  },
  {
    "i": "961",
    "county": "Dublin",
    "rollNumber": "19456B",
    "schoolName": "St Cronans Jn NS",
    "SETHours": "205",
    "spClassTeachingPosts": "2",
    "mainSNA": "6.32",
    "spSNA": "6.66",
    "totalSNA": "12.98",
    "eircode": "K67DP28",
    "addressOne": "Brackenstown",
    "addressTwo": "Swords",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.459094",
    "lng": "-6.2364494",
    "phone": "18402194",
    "email": "info@stcronansjns.ie"
  },
  {
    "i": "962",
    "county": "Dublin",
    "rollNumber": "19462T",
    "schoolName": "Scoil Maelruain Jn",
    "SETHours": "150",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.66",
    "spSNA": "0",
    "totalSNA": "4.66",
    "eircode": "D24T854",
    "addressOne": "Old Bawn",
    "addressTwo": "Tallaght",
    "addressThree": "Dublin 24",
    "addressFour": "",
    "lat": "53.2780311",
    "lng": "-6.3629769",
    "phone": "14513967",
    "email": "scoilmaelruainjunior@gmail.com"
  },
  {
    "i": "963",
    "county": "Dublin",
    "rollNumber": "19463V",
    "schoolName": "Scoil Maelruain Sn",
    "SETHours": "192.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "7",
    "spSNA": "0",
    "totalSNA": "7",
    "eircode": "D24EV18",
    "addressOne": "Old Bawn",
    "addressTwo": "Tallaght",
    "addressThree": "Dublin 24",
    "addressFour": "",
    "lat": "53.2778239",
    "lng": "-6.3625898",
    "phone": "14510706",
    "email": "smsinsear@yahoo.ie"
  },
  {
    "i": "964",
    "county": "Dublin",
    "rollNumber": "19465C",
    "schoolName": "St Kevins Boys",
    "SETHours": "155",
    "spClassTeachingPosts": "1",
    "mainSNA": "5.83",
    "spSNA": "1.83",
    "totalSNA": "7.66",
    "eircode": "D24A2XF",
    "addressOne": "Kilnamanagh",
    "addressTwo": "Tallaght",
    "addressThree": "Dublin 24",
    "addressFour": "",
    "lat": "53.3006067",
    "lng": "-6.357688",
    "phone": "14517925",
    "email": "marion@stkevinsboys.ie"
  },
  {
    "i": "965",
    "county": "Dublin",
    "rollNumber": "19466E",
    "schoolName": "St Kevins Girls",
    "SETHours": "102.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "4.83",
    "spSNA": "1.83",
    "totalSNA": "6.66",
    "eircode": "D24R6PT",
    "addressOne": "Kilnamanagh",
    "addressTwo": "Tallaght",
    "addressThree": "Dublin 24",
    "addressFour": "",
    "lat": "53.3013095",
    "lng": "-6.3586821",
    "phone": "14517981",
    "email": "info@stkevinsgns.com"
  },
  {
    "i": "966",
    "county": "Dublin",
    "rollNumber": "19470S",
    "schoolName": "St Francis Xavier Sn NS",
    "SETHours": "135",
    "spClassTeachingPosts": "1",
    "mainSNA": "6",
    "spSNA": "2",
    "totalSNA": "8",
    "eircode": "D15WY02",
    "addressOne": "Roselawn",
    "addressTwo": "Castleknock",
    "addressThree": "Dublin 15",
    "addressFour": "",
    "lat": "53.382631",
    "lng": "-6.3832419",
    "phone": "18211121",
    "email": "sfxseniorschool@eircom.net"
  },
  {
    "i": "967",
    "county": "Dublin",
    "rollNumber": "19471U",
    "schoolName": "St Paul's Jn NS",
    "SETHours": "82.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.33",
    "spSNA": "0",
    "totalSNA": "5.33",
    "eircode": "D13PK10",
    "addressOne": "Clonrosse Drive",
    "addressTwo": "Ard Na Gréine",
    "addressThree": "Dublin 13",
    "addressFour": "",
    "lat": "53.3949633",
    "lng": "-6.1836297",
    "phone": "18470479",
    "email": "ayrfieldjns@eircom.net"
  },
  {
    "i": "968",
    "county": "Dublin",
    "rollNumber": "19472W",
    "schoolName": "St Marks Jn Mixed",
    "SETHours": "315.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "12.32",
    "spSNA": "0.66",
    "totalSNA": "12.98",
    "eircode": "D24FT95",
    "addressOne": "Springfield",
    "addressTwo": "Tallaght",
    "addressThree": "Dublin 24",
    "addressFour": "",
    "lat": "53.2869427",
    "lng": "-6.3868527",
    "phone": "14512076",
    "email": "info@stmarksjs.ie"
  },
  {
    "i": "969",
    "county": "Dublin",
    "rollNumber": "19473B",
    "schoolName": "Scoil Bhride",
    "SETHours": "167.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "4.49",
    "spSNA": "4.66",
    "totalSNA": "9.15",
    "eircode": "D13NY53",
    "addressOne": "Grange Road",
    "addressTwo": "Donaghmede",
    "addressThree": "Dublin 13",
    "addressFour": "",
    "lat": "53.3971796",
    "lng": "-6.1611094",
    "phone": "18470014",
    "email": "office@scoilbhridejns.com"
  },
  {
    "i": "970",
    "county": "Dublin",
    "rollNumber": "19474D",
    "schoolName": "Scoil Colmcille Naofa",
    "SETHours": "0",
    "spClassTeachingPosts": "0",
    "mainSNA": "13",
    "spSNA": "0",
    "totalSNA": "13",
    "eircode": "D16H337",
    "addressOne": "Idrone Avenue",
    "addressTwo": "Knocklyon",
    "addressThree": "Dublin 16",
    "addressFour": "",
    "lat": "53.2840842",
    "lng": "-6.3160157",
    "phone": "14947422",
    "email": "office@ccjns.ie"
  },
  {
    "i": "971",
    "county": "Dublin",
    "rollNumber": "19480V",
    "schoolName": "St Patricks",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "D08WK19",
    "addressOne": "St Patrick's Close",
    "addressTwo": "Dublin 8",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3389817",
    "lng": "-6.2715879",
    "phone": "14540588",
    "email": "choirsch.ias@eircom.net"
  },
  {
    "i": "972",
    "county": "Dublin",
    "rollNumber": "19489Q",
    "schoolName": "Sn Naomh Finnin",
    "SETHours": "167.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "6.66",
    "spSNA": "0",
    "totalSNA": "6.66",
    "eircode": "D11WN70",
    "addressOne": "Glenties Park",
    "addressTwo": "Rivermount",
    "addressThree": "Finglas South",
    "addressFour": "Dublin 11",
    "lat": "53.3806108",
    "lng": "-6.3121104",
    "phone": "18341130",
    "email": "saintfinians@gmail.com"
  },
  {
    "i": "973",
    "county": "Dublin",
    "rollNumber": "19490B",
    "schoolName": "Scoil Mhuire",
    "SETHours": "145",
    "spClassTeachingPosts": "2",
    "mainSNA": "7",
    "spSNA": "3.32",
    "totalSNA": "10.32",
    "eircode": "D16V043",
    "addressOne": "Glenmore Court",
    "addressTwo": "Ballyboden",
    "addressThree": "Dublin 16",
    "addressFour": "",
    "lat": "53.2793709",
    "lng": "-6.2893403",
    "phone": "14931967",
    "email": "omcloughlin@hotmail.com"
  },
  {
    "i": "974",
    "county": "Dublin",
    "rollNumber": "19494J",
    "schoolName": "Bishop Galvin Ns",
    "SETHours": "167.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "9",
    "spSNA": "0",
    "totalSNA": "9",
    "eircode": "D6WY791",
    "addressOne": "Orwell Park",
    "addressTwo": "Templeogue",
    "addressThree": "Dublin 6w",
    "addressFour": "",
    "lat": "53.2980668",
    "lng": "-6.3186409",
    "phone": "14566652",
    "email": "secretary@bishopgalvin.ie"
  },
  {
    "i": "975",
    "county": "Dublin",
    "rollNumber": "19496N",
    "schoolName": "Scoil Fhiachra Soisir",
    "SETHours": "195",
    "spClassTeachingPosts": "0",
    "mainSNA": "7.49",
    "spSNA": "0",
    "totalSNA": "7.49",
    "eircode": "D05W248",
    "addressOne": "Montrose Park",
    "addressTwo": "Artane",
    "addressThree": "Dublin 5",
    "addressFour": "",
    "lat": "53.3877539",
    "lng": "-6.2262956",
    "phone": "18472367",
    "email": "fiachrajunior76@yahoo.com"
  },
  {
    "i": "976",
    "county": "Dublin",
    "rollNumber": "19497P",
    "schoolName": "Scoil Mhuire",
    "SETHours": "150",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "D18FT91",
    "addressOne": "Rathsallagh",
    "addressTwo": "Shankill",
    "addressThree": "Dublin 18",
    "addressFour": "",
    "lat": "53.2362038",
    "lng": "-6.1218925",
    "phone": "12823507",
    "email": "scoilmhuireshankill@gmail.com"
  },
  {
    "i": "977",
    "county": "Dublin",
    "rollNumber": "19502F",
    "schoolName": "Scoil Aenghusa Jun Ns",
    "SETHours": "115",
    "spClassTeachingPosts": "0",
    "mainSNA": "6.32",
    "spSNA": "0",
    "totalSNA": "6.32",
    "eircode": "D24YN34",
    "addressOne": "Balrothery",
    "addressTwo": "Tallaght",
    "addressThree": "Dublin 24",
    "addressFour": "",
    "lat": "53.2930486",
    "lng": "-6.345385",
    "phone": "14513912",
    "email": "aonghusajnr.ias@scoilaonghusajnr.com"
  },
  {
    "i": "978",
    "county": "Dublin",
    "rollNumber": "19503H",
    "schoolName": "Scoil Chronain",
    "SETHours": "137.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.66",
    "spSNA": "0",
    "totalSNA": "5.66",
    "eircode": "D24YW81",
    "addressOne": "An Tsráid Mhór",
    "addressTwo": "Ráth Cúil",
    "addressThree": "Co. átha Cliath",
    "addressFour": "",
    "lat": "53.281783",
    "lng": "-6.467742",
    "phone": "14588889",
    "email": "oifig@scoilchronain.ie"
  },
  {
    "i": "979",
    "county": "Dublin",
    "rollNumber": "19505L",
    "schoolName": "Sn Oilibheir",
    "SETHours": "75",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "D15PX99",
    "addressOne": "An Chúil Mhí­n",
    "addressTwo": "Cluain Saileach",
    "addressThree": "Baile átha Cliath 15",
    "addressFour": "",
    "lat": "53.3873745",
    "lng": "-6.3978016",
    "phone": "18215277",
    "email": "priomhoide.scoil.oilibheir@gmail.com"
  },
  {
    "i": "980",
    "county": "Dublin",
    "rollNumber": "19509T",
    "schoolName": "Scoil Nano Nagle",
    "SETHours": "147.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.66",
    "spSNA": "0",
    "totalSNA": "5.66",
    "eircode": "D22VF68",
    "addressOne": "Bawnogue Road",
    "addressTwo": "Clondalkin",
    "addressThree": "Dublin 22",
    "addressFour": "",
    "lat": "53.3261703",
    "lng": "-6.4134148",
    "phone": "14571306",
    "email": "nanonagleinfo2@gmail.com"
  },
  {
    "i": "981",
    "county": "Dublin",
    "rollNumber": "19510E",
    "schoolName": "Talbot Sn Ns",
    "SETHours": "187.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "8.5",
    "spSNA": "0",
    "totalSNA": "8.5",
    "eircode": "D22RT44",
    "addressOne": "Bawnoge",
    "addressTwo": "Clondalkin",
    "addressThree": "Dublin 22",
    "addressFour": "",
    "lat": "53.3260955",
    "lng": "-6.4131541",
    "phone": "14571226",
    "email": "talbotsns@hotmail.com"
  },
  {
    "i": "982",
    "county": "Dublin",
    "rollNumber": "19515O",
    "schoolName": "Sn Naomh Treasa",
    "SETHours": "175",
    "spClassTeachingPosts": "1",
    "mainSNA": "7.49",
    "spSNA": "1",
    "totalSNA": "8.49",
    "eircode": "K32E925",
    "addressOne": "Hampton",
    "addressTwo": "Balbriggan",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.6035536",
    "lng": "-6.174016",
    "phone": "18416270",
    "email": "adminstteresasps@gmail.com"
  },
  {
    "i": "983",
    "county": "Dublin",
    "rollNumber": "19524P",
    "schoolName": "Our Lady Immac Sn NS",
    "SETHours": "167.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "4",
    "spSNA": "2",
    "totalSNA": "6",
    "eircode": "D17CK81",
    "addressOne": "Our Lady Immac Sn Ns",
    "addressTwo": "Darndale",
    "addressThree": "Dublin 17",
    "addressFour": "",
    "lat": "53.4018005",
    "lng": "-6.1934086",
    "phone": "18470749",
    "email": "darndalesns@gmail.com"
  },
  {
    "i": "984",
    "county": "Dublin",
    "rollNumber": "19533Q",
    "schoolName": "SN Muire Agus Iosef",
    "SETHours": "152.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "D13EK83",
    "addressOne": "Verbena Ave",
    "addressTwo": "Bayside",
    "addressThree": "Sutton",
    "addressFour": "Dublin 13",
    "lat": "53.3895568",
    "lng": "-6.1471276",
    "phone": "18393682",
    "email": "baysidesns@gmail.com"
  },
  {
    "i": "985",
    "county": "Dublin",
    "rollNumber": "19535U",
    "schoolName": "Brackenstown Sn NS",
    "SETHours": "250",
    "spClassTeachingPosts": "3",
    "mainSNA": "5.5",
    "spSNA": "5.5",
    "totalSNA": "11",
    "eircode": "K67CH99",
    "addressOne": "Brackenstown Road",
    "addressTwo": "Swords",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.4588966",
    "lng": "-6.235489",
    "phone": "18403488",
    "email": "stcronanssns@eircom.net"
  },
  {
    "i": "986",
    "county": "Dublin",
    "rollNumber": "19537B",
    "schoolName": "St Attractas Jn NS",
    "SETHours": "120",
    "spClassTeachingPosts": "0",
    "mainSNA": "6.15",
    "spSNA": "0",
    "totalSNA": "6.15",
    "eircode": "D16P891",
    "addressOne": "Meadowbrook",
    "addressTwo": "Dundrum",
    "addressThree": "Dublin 16",
    "addressFour": "",
    "lat": "53.2809143",
    "lng": "-6.2563211",
    "phone": "12984352",
    "email": "stattractasjns@gmail.com"
  },
  {
    "i": "987",
    "county": "Dublin",
    "rollNumber": "19538D",
    "schoolName": "St Kevins Jn NS",
    "SETHours": "95",
    "spClassTeachingPosts": "1",
    "mainSNA": "4.99",
    "spSNA": "1.66",
    "totalSNA": "6.65",
    "eircode": "D13DK88",
    "addressOne": "Newbrook Avenue",
    "addressTwo": "Donaghmede",
    "addressThree": "Dublin 13",
    "addressFour": "",
    "lat": "53.3965638",
    "lng": "-6.1578348",
    "phone": "18475969",
    "email": "stkevinsjns@gmail.com"
  },
  {
    "i": "988",
    "county": "Dublin",
    "rollNumber": "19541P",
    "schoolName": "Belgard Heights NS",
    "SETHours": "187.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "6.34",
    "spSNA": "0.66",
    "totalSNA": "7",
    "eircode": "D24C621",
    "addressOne": "Cookstown Road",
    "addressTwo": "Tallaght",
    "addressThree": "Dublin 24",
    "addressFour": "",
    "lat": "53.298351",
    "lng": "-6.3857149",
    "phone": "14517134",
    "email": "solaschriost@gmail.com"
  },
  {
    "i": "989",
    "county": "Dublin",
    "rollNumber": "19542R",
    "schoolName": "St Thomas Jn NS",
    "SETHours": "160",
    "spClassTeachingPosts": "0",
    "mainSNA": "7.32",
    "spSNA": "0",
    "totalSNA": "7.32",
    "eircode": "K78PF57",
    "addressOne": "Newcastle Road",
    "addressTwo": "Lucan",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.3486632",
    "lng": "-6.4489917",
    "phone": "16282691",
    "email": "stns.ias@eircom.net"
  },
  {
    "i": "990",
    "county": "Dublin",
    "rollNumber": "19543T",
    "schoolName": "Scoil N An Croi Ro Naofa",
    "SETHours": "220",
    "spClassTeachingPosts": "0",
    "mainSNA": "6",
    "spSNA": "0",
    "totalSNA": "6",
    "eircode": "D24K528",
    "addressOne": "Killinarden",
    "addressTwo": "Tallaght",
    "addressThree": "Dublin 24",
    "addressFour": "",
    "lat": "53.2764729",
    "lng": "-6.3819672",
    "phone": "14524811",
    "email": "secretary@sacredheartsns.net"
  },
  {
    "i": "991",
    "county": "Dublin",
    "rollNumber": "19545A",
    "schoolName": "Corduff NS",
    "SETHours": "120",
    "spClassTeachingPosts": "1",
    "mainSNA": "3.16",
    "spSNA": "1.66",
    "totalSNA": "4.82",
    "eircode": "D15KD21",
    "addressOne": "Blackcourt Road",
    "addressTwo": "Corduff",
    "addressThree": "Blanchardstown",
    "addressFour": "Dublin 15",
    "lat": "53.3988289",
    "lng": "-6.3759083",
    "phone": "18211546",
    "email": "stpatricksj.ias@eircom.net"
  },
  {
    "i": "992",
    "county": "Dublin",
    "rollNumber": "19546C",
    "schoolName": "St Oliver Plunkett NS",
    "SETHours": "92.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "D11XA46",
    "addressOne": "St Helena's Drive",
    "addressTwo": "Finglas",
    "addressThree": "Dublin 11",
    "addressFour": "",
    "lat": "53.3818496",
    "lng": "-6.2997749",
    "phone": "18344678",
    "email": "info@stoliverplunkettsfinglas.ie"
  },
  {
    "i": "993",
    "county": "Dublin",
    "rollNumber": "19549I",
    "schoolName": "St Fintans Ns",
    "SETHours": "127.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "D13X528",
    "addressOne": "Carrickbrack Road",
    "addressTwo": "Sutton",
    "addressThree": "Dublin 13",
    "addressFour": "",
    "lat": "53.3803756",
    "lng": "-6.0951549",
    "phone": "18391067",
    "email": "info@stfintansns.ie"
  },
  {
    "i": "994",
    "county": "Dublin",
    "rollNumber": "19556F",
    "schoolName": "St Kilians Jn School",
    "SETHours": "100",
    "spClassTeachingPosts": "0",
    "mainSNA": "6.99",
    "spSNA": "0",
    "totalSNA": "6.99",
    "eircode": "D24H303",
    "addressOne": "Kingswood Heights",
    "addressTwo": "Castleview",
    "addressThree": "Tallaght",
    "addressFour": "Dublin 24",
    "lat": "53.3068879",
    "lng": "-6.3695086",
    "phone": "14521009",
    "email": "principal@stkiliansjns.ie"
  },
  {
    "i": "995",
    "county": "Dublin",
    "rollNumber": "19565G",
    "schoolName": "Scoil Treasa Firhouse",
    "SETHours": "190",
    "spClassTeachingPosts": "0",
    "mainSNA": "5",
    "spSNA": "0",
    "totalSNA": "5",
    "eircode": "D24E985",
    "addressOne": "Ballycullen Avenue",
    "addressTwo": "Firhouse",
    "addressThree": "Dublin 24",
    "addressFour": "",
    "lat": "53.2808006",
    "lng": "-6.3390175",
    "phone": "14513141",
    "email": "admin@scoiltreasa.ie"
  },
  {
    "i": "996",
    "county": "Dublin",
    "rollNumber": "19566I",
    "schoolName": "Our Lady Queen Of Apostles",
    "SETHours": "0",
    "spClassTeachingPosts": "1",
    "mainSNA": "13.41",
    "spSNA": "0.25",
    "totalSNA": "13.66",
    "eircode": "D22X729",
    "addressOne": "Dunawley Avenue",
    "addressTwo": "Clondalkin",
    "addressThree": "Dublin 22",
    "addressFour": "",
    "lat": "53.3266275",
    "lng": "-6.4012582",
    "phone": "14573636",
    "email": "handp1@eircom.net"
  },
  {
    "i": "997",
    "county": "Dublin",
    "rollNumber": "19569O",
    "schoolName": "Neillstown NS",
    "SETHours": "155",
    "spClassTeachingPosts": "3",
    "mainSNA": "10.49",
    "spSNA": "5.32",
    "totalSNA": "15.81",
    "eircode": "D22AK09",
    "addressOne": "Neillstown Road",
    "addressTwo": "Clondalkin",
    "addressThree": "Dublin 22",
    "addressFour": "",
    "lat": "53.3369094",
    "lng": "-6.4009192",
    "phone": "14572811",
    "email": "info@stpeterapostlejns.ie"
  },
  {
    "i": "998",
    "county": "Dublin",
    "rollNumber": "19574H",
    "schoolName": "Marley Grange Ns",
    "SETHours": "150",
    "spClassTeachingPosts": "0",
    "mainSNA": "8.49",
    "spSNA": "0",
    "totalSNA": "8.49",
    "eircode": "D16FF62",
    "addressOne": "Grange Manor Close",
    "addressTwo": "Marley Grange",
    "addressThree": "Rathfarnham",
    "addressFour": "Dublin 16",
    "lat": "53.2840789",
    "lng": "-6.2732555",
    "phone": "14945955",
    "email": "divinewordschool@gmail.com"
  },
  {
    "i": "999",
    "county": "Dublin",
    "rollNumber": "19575J",
    "schoolName": "St Marys Jn NS",
    "SETHours": "130",
    "spClassTeachingPosts": "2",
    "mainSNA": "4.66",
    "spSNA": "3.66",
    "totalSNA": "8.32",
    "eircode": "D22H504",
    "addressOne": "Rowlagh",
    "addressTwo": "Clondalkin",
    "addressThree": "Dublin 22",
    "addressFour": "",
    "lat": "53.3433686",
    "lng": "-6.3951504",
    "phone": "16263266",
    "email": "office@stmarysjunior.ie"
  },
  {
    "i": "1000",
    "county": "Dublin",
    "rollNumber": "19576L",
    "schoolName": "SN Aenghusa",
    "SETHours": "140",
    "spClassTeachingPosts": "0",
    "mainSNA": "8",
    "spSNA": "0",
    "totalSNA": "8",
    "eircode": "D24PXW8",
    "addressOne": "Scoil N Aenghusa Sin",
    "addressTwo": "Balrothery",
    "addressThree": "Tallaght",
    "addressFour": "Dublin 24",
    "lat": "53.2925558",
    "lng": "-6.3459582",
    "phone": "14518984",
    "email": "aengusa@hotmail.com"
  },
  {
    "i": "1001",
    "county": "Dublin",
    "rollNumber": "19577N",
    "schoolName": "Scoil Iosa",
    "SETHours": "80",
    "spClassTeachingPosts": "1",
    "mainSNA": "2.83",
    "spSNA": "2",
    "totalSNA": "4.83",
    "eircode": "D24ND34",
    "addressOne": "Tymon Road",
    "addressTwo": "Tallaght",
    "addressThree": "Dublin 24",
    "addressFour": "",
    "lat": "53.2952066",
    "lng": "-6.3405703",
    "phone": "14520800",
    "email": "scoiliosa@gmail.com"
  },
  {
    "i": "1002",
    "county": "Dublin",
    "rollNumber": "19578P",
    "schoolName": "St Helens Jn NS",
    "SETHours": "112.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "4.32",
    "spSNA": "7.66",
    "totalSNA": "11.98",
    "eircode": "D13KP93",
    "addressOne": "Martello",
    "addressTwo": "Portmarnock",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.4389942",
    "lng": "-6.1358076",
    "phone": "18461763",
    "email": "secretary@sthelensjunior.com"
  },
  {
    "i": "1003",
    "county": "Dublin",
    "rollNumber": "19582G",
    "schoolName": "St Maelruains NS",
    "SETHours": "67.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "2.83",
    "spSNA": "1",
    "totalSNA": "3.83",
    "eircode": "D24YD74",
    "addressOne": "Kilclare Avenue",
    "addressTwo": "Jobstown",
    "addressThree": "Tallaght",
    "addressFour": "Dublin 24",
    "lat": "53.2824701",
    "lng": "-6.3921419",
    "phone": "14527933",
    "email": "stmaelruainss@gmail.com"
  },
  {
    "i": "1004",
    "county": "Dublin",
    "rollNumber": "19583I",
    "schoolName": "St Josephs Sn NS",
    "SETHours": "125",
    "spClassTeachingPosts": "0",
    "mainSNA": "5",
    "spSNA": "0",
    "totalSNA": "5",
    "eircode": "D11HY03",
    "addressOne": "Balcurris Road",
    "addressTwo": "Ballymun",
    "addressThree": "Dublin 11",
    "addressFour": "",
    "lat": "53.4013646",
    "lng": "-6.2719084",
    "phone": "18422600",
    "email": "balcurrisns@gmail.com"
  },
  {
    "i": "1005",
    "county": "Dublin",
    "rollNumber": "19589U",
    "schoolName": "Gaelscoil Inse Chor",
    "SETHours": "72.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "D08NR26",
    "addressOne": "Droichead NS Hinse",
    "addressTwo": "Baile átha Cliath 8",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3440411",
    "lng": "-6.311834",
    "phone": "16796748",
    "email": "priomhoidegsic@gmail.com"
  },
  {
    "i": "1006",
    "county": "Dublin",
    "rollNumber": "19601H",
    "schoolName": "St Philip The Apostle Jn NS",
    "SETHours": "100",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.49",
    "spSNA": "0",
    "totalSNA": "3.49",
    "eircode": "D15V124",
    "addressOne": "Mountview",
    "addressTwo": "Clonsilla",
    "addressThree": "Dublin 15",
    "addressFour": "",
    "lat": "53.3898947",
    "lng": "-6.4067928",
    "phone": "18212992",
    "email": "philip.the.apostle.jns@gmail.com"
  },
  {
    "i": "1007",
    "county": "Dublin",
    "rollNumber": "19605P",
    "schoolName": "Scoil Nais Mhuire Sois",
    "SETHours": "122.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "2.83",
    "spSNA": "1.66",
    "totalSNA": "4.49",
    "eircode": "D15F293",
    "addressOne": "Blakestown",
    "addressTwo": "Mulhuddart",
    "addressThree": "Dublin 15",
    "addressFour": "",
    "lat": "53.3975378",
    "lng": "-6.4009764",
    "phone": "18216916",
    "email": "smjblakestown@gmail.com"
  },
  {
    "i": "1008",
    "county": "Dublin",
    "rollNumber": "19611K",
    "schoolName": "Scoil Naomh Colmcille",
    "SETHours": "92.5",
    "spClassTeachingPosts": "4",
    "mainSNA": "1.75",
    "spSNA": "6.66",
    "totalSNA": "8.41",
    "eircode": "D13XP49",
    "addressOne": "Newbrook Road",
    "addressTwo": "Donaghmede",
    "addressThree": "Dublin 13",
    "addressFour": "",
    "lat": "53.3967797",
    "lng": "-6.1591405",
    "phone": "18477300",
    "email": "principal@scholmcille.com"
  },
  {
    "i": "1009",
    "county": "Dublin",
    "rollNumber": "19612M",
    "schoolName": "Dalkey School Project",
    "SETHours": "92.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "6.66",
    "spSNA": "0",
    "totalSNA": "6.66",
    "eircode": "A96RX32",
    "addressOne": "Glenageary Lodge",
    "addressTwo": "Glenageary",
    "addressThree": "Co Dublin",
    "addressFour": "",
    "lat": "53.2747608",
    "lng": "-6.1330205",
    "phone": "12857199",
    "email": "info@dspns.ie"
  },
  {
    "i": "1010",
    "county": "Dublin",
    "rollNumber": "19613O",
    "schoolName": "Scoil Cnoc Mhuire Sin",
    "SETHours": "0",
    "spClassTeachingPosts": "1",
    "mainSNA": "5",
    "spSNA": "1",
    "totalSNA": "6",
    "eircode": "D24TF65",
    "addressOne": "Knockmore Avenue",
    "addressTwo": "Tallaght",
    "addressThree": "Dublin 24",
    "addressFour": "",
    "lat": "53.2758084",
    "lng": "-6.3918432",
    "phone": "14512347",
    "email": "mail@cmsenior.com"
  },
  {
    "i": "1011",
    "county": "Dublin",
    "rollNumber": "19617W",
    "schoolName": "St Martin De Porres NS",
    "SETHours": "197.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "10.49",
    "spSNA": "2",
    "totalSNA": "12.49",
    "eircode": "D24HF54",
    "addressOne": "Heatherview Lawn",
    "addressTwo": "Aylesbury",
    "addressThree": "Tallaght",
    "addressFour": "Dublin 24",
    "lat": "53.2750581",
    "lng": "-6.3715116",
    "phone": "14511319",
    "email": "smdpnsoffice@gmail.com"
  },
  {
    "i": "1012",
    "county": "Dublin",
    "rollNumber": "19618B",
    "schoolName": "St Paul's Sn Ns",
    "SETHours": "105",
    "spClassTeachingPosts": "0",
    "mainSNA": "6",
    "spSNA": "0",
    "totalSNA": "6",
    "eircode": "D13DD74",
    "addressOne": "Ayrfield",
    "addressTwo": "Malahide Rd",
    "addressThree": "Dublin 13",
    "addressFour": "",
    "lat": "53.3952276",
    "lng": "-6.1836699",
    "phone": "18472810",
    "email": "office@stpauls-sns.com"
  },
  {
    "i": "1013",
    "county": "Dublin",
    "rollNumber": "19619D",
    "schoolName": "St Malachys Ns",
    "SETHours": "90",
    "spClassTeachingPosts": "0",
    "mainSNA": "5",
    "spSNA": "0",
    "totalSNA": "5",
    "eircode": "D11Y880",
    "addressOne": "St. Helena's Road",
    "addressTwo": "Finglas",
    "addressThree": "Dublin 11",
    "addressFour": "",
    "lat": "53.3823876",
    "lng": "-6.2997998",
    "phone": "18345875",
    "email": "stmalachysmns@gmail.com"
  },
  {
    "i": "1014",
    "county": "Dublin",
    "rollNumber": "19624T",
    "schoolName": "Scoil Nais Caitriona",
    "SETHours": "162.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "5.83",
    "spSNA": "5",
    "totalSNA": "10.83",
    "eircode": "K56TY32",
    "addressOne": "The Avenue",
    "addressTwo": "Rush",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.5350471",
    "lng": "-6.099188",
    "phone": "18438266",
    "email": "secretary@stcatherinesns.ie"
  },
  {
    "i": "1015",
    "county": "Dublin",
    "rollNumber": "19625V",
    "schoolName": "Scoil Réalt Na Mara",
    "SETHours": "137.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.33",
    "spSNA": "0",
    "totalSNA": "3.33",
    "eircode": "K34VW10",
    "addressOne": "Balbriggan Road",
    "addressTwo": "Skerries",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.5803144",
    "lng": "-6.1206979",
    "phone": "18490049",
    "email": "eolas@realtnamara.ie"
  },
  {
    "i": "1016",
    "county": "Dublin",
    "rollNumber": "19627C",
    "schoolName": "John Paul Ii NS",
    "SETHours": "195",
    "spClassTeachingPosts": "0",
    "mainSNA": "8",
    "spSNA": "0",
    "totalSNA": "8",
    "eircode": "K36P796",
    "addressOne": "Sea Road",
    "addressTwo": "Malahide",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.454049",
    "lng": "-6.1691864",
    "phone": "18450736",
    "email": "info@pjp.ie"
  },
  {
    "i": "1017",
    "county": "Dublin",
    "rollNumber": "19628E",
    "schoolName": "St Fiachras Sn NS",
    "SETHours": "212.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "D05K3C3",
    "addressOne": "St. Fiachras Sns",
    "addressTwo": "Montrose Park",
    "addressThree": "Beaumont",
    "addressFour": "Dublin 5",
    "lat": "53.3876711",
    "lng": "-6.2244013",
    "phone": "18477762",
    "email": "secretary@fiachras.ie"
  },
  {
    "i": "1018",
    "county": "Dublin",
    "rollNumber": "19636D",
    "schoolName": "St Patricks Sn School",
    "SETHours": "122.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "5.5",
    "spSNA": "2.25",
    "totalSNA": "7.75",
    "eircode": "D15W261",
    "addressOne": "Corduff",
    "addressTwo": "Blanchardstown",
    "addressThree": "Dublin 15",
    "addressFour": "",
    "lat": "53.3989098",
    "lng": "-6.3769981",
    "phone": "18216563",
    "email": "patcord2019@gmail.com"
  },
  {
    "i": "1019",
    "county": "Dublin",
    "rollNumber": "19641T",
    "schoolName": "Scoil Cholmcille Jn Ns",
    "SETHours": "90",
    "spClassTeachingPosts": "0",
    "mainSNA": "6.49",
    "spSNA": "0",
    "totalSNA": "6.49",
    "eircode": "A96FA40",
    "addressOne": "Coolevin",
    "addressTwo": "Ballybrack",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.2542921",
    "lng": "-6.1347277",
    "phone": "12848899",
    "email": "cholmjnr@gmail.com"
  },
  {
    "i": "1020",
    "county": "Dublin",
    "rollNumber": "19642V",
    "schoolName": "St Peter Apostle Sn Ns",
    "SETHours": "172.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "7.5",
    "spSNA": "4",
    "totalSNA": "11.5",
    "eircode": "D22WR59",
    "addressOne": "Neilstown",
    "addressTwo": "Clondalkin",
    "addressThree": "Dublin 22",
    "addressFour": "",
    "lat": "53.3369119",
    "lng": "-6.4021014",
    "phone": "14572799",
    "email": "info@stpeterapostlesns.ie"
  },
  {
    "i": "1021",
    "county": "Dublin",
    "rollNumber": "19643A",
    "schoolName": "St Philips Sn NS",
    "SETHours": "115",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "D15RC56",
    "addressOne": "Mountview Road",
    "addressTwo": "Clonsilla",
    "addressThree": "Dublin 15",
    "addressFour": "",
    "lat": "53.3896639",
    "lng": "-6.4071222",
    "phone": "18216101",
    "email": "stphilipsenior@yahoo.ie"
  },
  {
    "i": "1022",
    "county": "Dublin",
    "rollNumber": "19644C",
    "schoolName": "St Ciarans NS",
    "SETHours": "232.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.49",
    "spSNA": "0",
    "totalSNA": "5.49",
    "eircode": "D15ED83",
    "addressOne": "Hartstown",
    "addressTwo": "Dublin 15",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3937754",
    "lng": "-6.4207611",
    "phone": "18212233",
    "email": "principal@stciarans.com"
  },
  {
    "i": "1023",
    "county": "Dublin",
    "rollNumber": "19646G",
    "schoolName": "Scoil Santain",
    "SETHours": "132.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.33",
    "spSNA": "0",
    "totalSNA": "5.33",
    "eircode": "D24TW35",
    "addressOne": "Bóthar Na Habhann Móire",
    "addressTwo": "Tamhlacht",
    "addressThree": "Baile átha Cliath 24",
    "addressFour": "",
    "lat": "53.284146",
    "lng": "-6.347512",
    "phone": "14597613",
    "email": "santain.ias@eircom.net"
  },
  {
    "i": "1024",
    "county": "Dublin",
    "rollNumber": "19647I",
    "schoolName": "St Marys Sn NS",
    "SETHours": "145",
    "spClassTeachingPosts": "1",
    "mainSNA": "3.75",
    "spSNA": "0.25",
    "totalSNA": "4",
    "eircode": "D22WN40",
    "addressOne": "Rowlagh",
    "addressTwo": "Clondalkin",
    "addressThree": "Dublin 22",
    "addressFour": "",
    "lat": "53.3428895",
    "lng": "-6.3963126",
    "phone": "16262563",
    "email": "stmarysrowlagh@gmail.com"
  },
  {
    "i": "1025",
    "county": "Dublin",
    "rollNumber": "19652B",
    "schoolName": "An Chroi Ro Naofa Sois",
    "SETHours": "132.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "5.83",
    "spSNA": "4",
    "totalSNA": "9.83",
    "eircode": "D24K528",
    "addressOne": "Killinarden",
    "addressTwo": "Tallaght",
    "addressThree": "Dublin 24",
    "addressFour": "",
    "lat": "53.2764729",
    "lng": "-6.3819672",
    "phone": "14524064",
    "email": "admin@shjkillinarden.ie"
  },
  {
    "i": "1026",
    "county": "Dublin",
    "rollNumber": "19658N",
    "schoolName": "Bishop Shanahan Ns",
    "SETHours": "152.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "12.15",
    "spSNA": "1",
    "totalSNA": "13.15",
    "eircode": "D6WX093",
    "addressOne": "Orwell Park",
    "addressTwo": "Templeogue",
    "addressThree": "Dublin 6w",
    "addressFour": "",
    "lat": "53.2984278",
    "lng": "-6.3184214",
    "phone": "14508449",
    "email": "secretary@bishopshanahan.ie"
  },
  {
    "i": "1027",
    "county": "Dublin",
    "rollNumber": "19660A",
    "schoolName": "Rush Ns",
    "SETHours": "275",
    "spClassTeachingPosts": "0",
    "mainSNA": "9.49",
    "spSNA": "0",
    "totalSNA": "9.49",
    "eircode": "K56VK88",
    "addressOne": "Channel Road",
    "addressTwo": "Rush",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.5206655",
    "lng": "-6.1043338",
    "phone": "18437095",
    "email": "office@rushnationalschool.ie"
  },
  {
    "i": "1028",
    "county": "Dublin",
    "rollNumber": "19661C",
    "schoolName": "St Gabriels Ns",
    "SETHours": "175",
    "spClassTeachingPosts": "0",
    "mainSNA": "8.5",
    "spSNA": "0",
    "totalSNA": "8.5",
    "eircode": "D10KD76",
    "addressOne": "Ballyfermot Road",
    "addressTwo": "Ballyfermot",
    "addressThree": "Dublin 10",
    "addressFour": "",
    "lat": "53.3429717",
    "lng": "-6.3473097",
    "phone": "16265958",
    "email": "office@stgabrielsprimary.ie"
  },
  {
    "i": "1029",
    "county": "Dublin",
    "rollNumber": "19662E",
    "schoolName": "St Michaels Ns",
    "SETHours": "235",
    "spClassTeachingPosts": "1",
    "mainSNA": "13.83",
    "spSNA": "2",
    "totalSNA": "15.83",
    "eircode": "D10YK84",
    "addressOne": "Kylemore Road",
    "addressTwo": "Ballyfermot",
    "addressThree": "Dublin 10",
    "addressFour": "",
    "lat": "53.3433768",
    "lng": "-6.3480633",
    "phone": "16263556",
    "email": "office@stmichaelsps.ie"
  },
  {
    "i": "1030",
    "county": "Dublin",
    "rollNumber": "19663G",
    "schoolName": "St Raphaels Ns",
    "SETHours": "267.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "18.32",
    "spSNA": "0",
    "totalSNA": "18.32",
    "eircode": "D10XW56",
    "addressOne": "Ballyfermot Road",
    "addressTwo": "Dublin 10",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3431876",
    "lng": "-6.3477234",
    "phone": "16265953",
    "email": "info@straphaels.ie"
  },
  {
    "i": "1031",
    "county": "Dublin",
    "rollNumber": "19668Q",
    "schoolName": "St Francis Sn NS",
    "SETHours": "160",
    "spClassTeachingPosts": "0",
    "mainSNA": "5",
    "spSNA": "0",
    "totalSNA": "5",
    "eircode": "D17F978",
    "addressOne": "Clonshaugh Drive",
    "addressTwo": "Priorswood,",
    "addressThree": "Dublin 17",
    "addressFour": "",
    "lat": "53.4038266",
    "lng": "-6.205909",
    "phone": "18470656",
    "email": "fransns.ias@eircom.net"
  },
  {
    "i": "1032",
    "county": "Dublin",
    "rollNumber": "19669S",
    "schoolName": "Lady Of Good Counsel Boys Sn Ns",
    "SETHours": "117.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "4",
    "spSNA": "3",
    "totalSNA": "7",
    "eircode": "D12H213",
    "addressOne": "Mourne Road",
    "addressTwo": "Drimnagh",
    "addressThree": "Dublin 12",
    "addressFour": "",
    "lat": "53.3303441",
    "lng": "-6.3170366",
    "phone": "14551672",
    "email": "principal@olgcbnsdrimnagh.com"
  },
  {
    "i": "1033",
    "county": "Dublin",
    "rollNumber": "19676P",
    "schoolName": "Scoil Aine Naofa",
    "SETHours": "247.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "6",
    "spSNA": "0",
    "totalSNA": "6",
    "eircode": "K78N8X6",
    "addressOne": "Esker",
    "addressTwo": "Lucan",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.3490936",
    "lng": "-6.4485997",
    "phone": "16281972",
    "email": "secretary@scaine.ie"
  },
  {
    "i": "1034",
    "county": "Dublin",
    "rollNumber": "19693P",
    "schoolName": "Mary Queen Of Ireland NS",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "K67E718",
    "addressOne": "Toberburr",
    "addressTwo": "Co Dublin",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.4525756",
    "lng": "-6.2925495",
    "phone": "18404629",
    "email": "toberburrns@eircom.net"
  },
  {
    "i": "1035",
    "county": "Dublin",
    "rollNumber": "19694R",
    "schoolName": "Scoil Mhuire Sin",
    "SETHours": "142.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "3.5",
    "spSNA": "2",
    "totalSNA": "5.5",
    "eircode": "D15YK58",
    "addressOne": "Blakestown",
    "addressTwo": "Mulhuddart",
    "addressThree": "Dublin 15",
    "addressFour": "",
    "lat": "53.3978679",
    "lng": "-6.3999446",
    "phone": "18212288",
    "email": "admin@scoilmhuiresenior.ie"
  },
  {
    "i": "1036",
    "county": "Dublin",
    "rollNumber": "19702N",
    "schoolName": "St Thomas Jn NS",
    "SETHours": "257.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "7.66",
    "spSNA": "0",
    "totalSNA": "7.66",
    "eircode": "D24X577",
    "addressOne": "Fortunestown Road",
    "addressTwo": "Tallaght",
    "addressThree": "Dublin 24",
    "addressFour": "",
    "lat": "53.278816",
    "lng": "-6.4044189",
    "phone": "14525855",
    "email": "info@stthomasjns.ie"
  },
  {
    "i": "1037",
    "county": "Dublin",
    "rollNumber": "19707A",
    "schoolName": "St Ronans NS",
    "SETHours": "257.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "6.66",
    "spSNA": "0",
    "totalSNA": "6.66",
    "eircode": "D22C861",
    "addressOne": "St Cuthbert's Road",
    "addressTwo": "Deansrath",
    "addressThree": "Dublin 22",
    "addressFour": "",
    "lat": "53.3232542",
    "lng": "-6.4262854",
    "phone": "14573653",
    "email": "stronans28@yahoo.ie"
  },
  {
    "i": "1038",
    "county": "Dublin",
    "rollNumber": "19716B",
    "schoolName": "St Attractas Sn NS",
    "SETHours": "150",
    "spClassTeachingPosts": "0",
    "mainSNA": "11",
    "spSNA": "0",
    "totalSNA": "11",
    "eircode": "D16HW66",
    "addressOne": "Meadowbrook",
    "addressTwo": "Dundrum",
    "addressThree": "Dublin 16",
    "addressFour": "",
    "lat": "53.281316",
    "lng": "-6.2557031",
    "phone": "12951627",
    "email": "oifigstattracta@gmail.com"
  },
  {
    "i": "1039",
    "county": "Dublin",
    "rollNumber": "19721R",
    "schoolName": "Holy Family Jn NS",
    "SETHours": "247.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "9.49",
    "spSNA": "0",
    "totalSNA": "9.49",
    "eircode": "K67PX92",
    "addressOne": "Forest Fields",
    "addressTwo": "Swords",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.4524004",
    "lng": "-6.2419378",
    "phone": "18404394",
    "email": "hfjns3.ias@eircom.net"
  },
  {
    "i": "1040",
    "county": "Dublin",
    "rollNumber": "19723V",
    "schoolName": "Queen Of Angels Primary School",
    "SETHours": "127.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "D16AX05",
    "addressOne": "Wedgewood",
    "addressTwo": "Sandyford",
    "addressThree": "Dublin 16",
    "addressFour": "",
    "lat": "53.2763237",
    "lng": "-6.2260491",
    "phone": "12955483",
    "email": "secretary@qoa.ie"
  },
  {
    "i": "1041",
    "county": "Dublin",
    "rollNumber": "19727G",
    "schoolName": "St Marys Central NS",
    "SETHours": "105",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "D04K025",
    "addressOne": "Belmont Avenue",
    "addressTwo": "Donnybrook",
    "addressThree": "Dublin 4",
    "addressFour": "",
    "lat": "53.3210652",
    "lng": "-6.2389255",
    "phone": "12195734",
    "email": "office@saintmarys.ie"
  },
  {
    "i": "1042",
    "county": "Dublin",
    "rollNumber": "19742C",
    "schoolName": "St Colmcille Sn NS",
    "SETHours": "320",
    "spClassTeachingPosts": "0",
    "mainSNA": "13",
    "spSNA": "0",
    "totalSNA": "13",
    "eircode": "D16W8K0",
    "addressOne": "Idrone Avenue",
    "addressTwo": "Knocklyon",
    "addressThree": "Dublin 16",
    "addressFour": "",
    "lat": "53.2846508",
    "lng": "-6.3165814",
    "phone": "14942527",
    "email": "colmcillessklsec@eircom.net"
  },
  {
    "i": "1043",
    "county": "Dublin",
    "rollNumber": "19743E",
    "schoolName": "St Bernadettes Jn NS",
    "SETHours": "157.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "5.66",
    "spSNA": "1.66",
    "totalSNA": "7.32",
    "eircode": "D22CD39",
    "addressOne": "Quarryvale",
    "addressTwo": "Clondalkin",
    "addressThree": "Dublin 22",
    "addressFour": "",
    "lat": "53.3496367",
    "lng": "-6.3978898",
    "phone": "16263188",
    "email": "stbjns@gmail.com"
  },
  {
    "i": "1044",
    "county": "Dublin",
    "rollNumber": "19755L",
    "schoolName": "Sacred Heart NS",
    "SETHours": "325",
    "spClassTeachingPosts": "3",
    "mainSNA": "10.49",
    "spSNA": "6",
    "totalSNA": "16.49",
    "eircode": "D15KF65",
    "addressOne": "Huntstown",
    "addressTwo": "Mulhuddart",
    "addressThree": "Dublin 15",
    "addressFour": "",
    "lat": "53.4025589",
    "lng": "-6.4100525",
    "phone": "18216400",
    "email": "sacredheartns@gmail.com"
  },
  {
    "i": "1045",
    "county": "Dublin",
    "rollNumber": "19762I",
    "schoolName": "St Helens Sn NS",
    "SETHours": "112.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "D13X326",
    "addressOne": "Limetree Ave",
    "addressTwo": "Portmarnock",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.4399255",
    "lng": "-6.1361242",
    "phone": "18461808",
    "email": "admin@helens.ie"
  },
  {
    "i": "1046",
    "county": "Dublin",
    "rollNumber": "19764M",
    "schoolName": "Our Lady Of Wayside NS",
    "SETHours": "107.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "5.83",
    "spSNA": "1.83",
    "totalSNA": "7.66",
    "eircode": "D12KC63",
    "addressOne": "Bluebell Road",
    "addressTwo": "Bluebell",
    "addressThree": "Dublin 12",
    "addressFour": "",
    "lat": "53.3312985",
    "lng": "-6.3378935",
    "phone": "14501030",
    "email": "school@olw.ie"
  },
  {
    "i": "1047",
    "county": "Dublin",
    "rollNumber": "19765O",
    "schoolName": "St Thomas Sn NS",
    "SETHours": "352.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "9.75",
    "spSNA": "0.75",
    "totalSNA": "10.5",
    "eircode": "D24YN90",
    "addressOne": "Jobstown",
    "addressTwo": "Tallaght",
    "addressThree": "Dublin 24",
    "addressFour": "",
    "lat": "53.2788759",
    "lng": "-6.403235",
    "phone": "14526555",
    "email": "info@stthomas.ie"
  },
  {
    "i": "1048",
    "county": "Dublin",
    "rollNumber": "19769W",
    "schoolName": "Scoil Thomais",
    "SETHours": "170",
    "spClassTeachingPosts": "0",
    "mainSNA": "7.32",
    "spSNA": "0",
    "totalSNA": "7.32",
    "eircode": "D15VW02",
    "addressOne": "Laurel Lodge",
    "addressTwo": "Castleknock",
    "addressThree": "Dublin 15",
    "addressFour": "",
    "lat": "53.3781924",
    "lng": "-6.3778063",
    "phone": "18201022",
    "email": "deputy@scoilthomais.ie"
  },
  {
    "i": "1049",
    "county": "Dublin",
    "rollNumber": "19774P",
    "schoolName": "St Josephs Mxd NS",
    "SETHours": "85",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "D03HF24",
    "addressOne": "East Wall Road",
    "addressTwo": "Dublin 3",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3544026",
    "lng": "-6.2287901",
    "phone": "18556284",
    "email": "stjosephscoedeastwall@gmail.com"
  },
  {
    "i": "1050",
    "county": "Dublin",
    "rollNumber": "19775R",
    "schoolName": "Scoil Cnoc Mhuire Jn",
    "SETHours": "107.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "3.83",
    "spSNA": "4",
    "totalSNA": "7.83",
    "eircode": "D24C921",
    "addressOne": "Knockmore Avenue",
    "addressTwo": "Killinarden",
    "addressThree": "Tallaght",
    "addressFour": "Dublin 24",
    "lat": "53.2761453",
    "lng": "-6.3932032",
    "phone": "14525266",
    "email": "office@knockmorejns.ie"
  },
  {
    "i": "1051",
    "county": "Dublin",
    "rollNumber": "19777V",
    "schoolName": "Gaelscoil Mide",
    "SETHours": "70",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "D05YN51",
    "addressOne": "Bóthar An Ghleanntáin Ghlais",
    "addressTwo": "Cill Bharróg",
    "addressThree": "Baile átha Cliath 5",
    "addressFour": "",
    "lat": "53.3855085",
    "lng": "-6.1529109",
    "phone": "18393968",
    "email": "gaelscoilmide@gmail.com"
  },
  {
    "i": "1052",
    "county": "Dublin",
    "rollNumber": "19782O",
    "schoolName": "St Brigids NS",
    "SETHours": "170",
    "spClassTeachingPosts": "2",
    "mainSNA": "3.49",
    "spSNA": "3",
    "totalSNA": "6.49",
    "eircode": "D24X343",
    "addressOne": "Brookfield",
    "addressTwo": "Tallaght",
    "addressThree": "Dublin 24",
    "addressFour": "",
    "lat": "53.2871527",
    "lng": "-6.4043031",
    "phone": "14514700",
    "email": "secretary@stbrigidsbrookfield.ie"
  },
  {
    "i": "1053",
    "county": "Dublin",
    "rollNumber": "19785U",
    "schoolName": "St Bernadettes Sn NS",
    "SETHours": "160",
    "spClassTeachingPosts": "0",
    "mainSNA": "6",
    "spSNA": "0",
    "totalSNA": "6",
    "eircode": "D22PW58",
    "addressOne": "Quarryvale",
    "addressTwo": "Clondalkin",
    "addressThree": "Dublin 22",
    "addressFour": "",
    "lat": "53.3503954",
    "lng": "-6.3973213",
    "phone": "16267116",
    "email": "office@bernadettes.ie"
  },
  {
    "i": "1054",
    "county": "Dublin",
    "rollNumber": "19799I",
    "schoolName": "Sacred Heart NS",
    "SETHours": "0",
    "spClassTeachingPosts": "3",
    "mainSNA": "7.66",
    "spSNA": "5.83",
    "totalSNA": "13.49",
    "eircode": "D22H224",
    "addressOne": "Sruleen",
    "addressTwo": "Clondalkin",
    "addressThree": "Dublin 22",
    "addressFour": "",
    "lat": "53.3145107",
    "lng": "-6.4021632",
    "phone": "14572988",
    "email": "info@sruleenns.com"
  },
  {
    "i": "1055",
    "county": "Dublin",
    "rollNumber": "19817H",
    "schoolName": "St Marys NS",
    "SETHours": "145",
    "spClassTeachingPosts": "2",
    "mainSNA": "5",
    "spSNA": "4",
    "totalSNA": "9",
    "eircode": "K78KP94",
    "addressOne": "Airlie Heights",
    "addressTwo": "Lucan",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.3509807",
    "lng": "-6.4672047",
    "phone": "16240203",
    "email": "office@scoilmhuire.ie"
  },
  {
    "i": "1056",
    "county": "Dublin",
    "rollNumber": "19831B",
    "schoolName": "Scoil Chaoimhin",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.33",
    "spSNA": "0",
    "totalSNA": "2.33",
    "eircode": "D01YT29",
    "addressOne": "Sráid Mhaoilbhrí­de",
    "addressTwo": "Baile átha Cliath 1",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3512957",
    "lng": "-6.2576946",
    "phone": "18788594",
    "email": "scoilchaoimhin@gmail.com"
  },
  {
    "i": "1057",
    "county": "Dublin",
    "rollNumber": "19834H",
    "schoolName": "St Aidans Ns",
    "SETHours": "230",
    "spClassTeachingPosts": "1",
    "mainSNA": "9.75",
    "spSNA": "0.25",
    "totalSNA": "10",
    "eircode": "D24XN24",
    "addressOne": "Brookfield",
    "addressTwo": "Tallaght",
    "addressThree": "Dublin 24",
    "addressFour": "",
    "lat": "53.2863904",
    "lng": "-6.4046425",
    "phone": "14596016",
    "email": "principal@staidanssns.ie"
  },
  {
    "i": "1058",
    "county": "Dublin",
    "rollNumber": "19837N",
    "schoolName": "Drimnagh Castle Cbs NS",
    "SETHours": "272.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "10",
    "spSNA": "0",
    "totalSNA": "10",
    "eircode": "D12C893",
    "addressOne": "Drimnagh Castle",
    "addressTwo": "Long Mile Road",
    "addressThree": "Dublin 12",
    "addressFour": "",
    "lat": "53.3243593",
    "lng": "-6.3309211",
    "phone": "14552066",
    "email": "drimnaghcastle.ias@gmail.com"
  },
  {
    "i": "1059",
    "county": "Dublin",
    "rollNumber": "19840C",
    "schoolName": "Holy Family School",
    "SETHours": "75",
    "spClassTeachingPosts": "2",
    "mainSNA": "5",
    "spSNA": "4",
    "totalSNA": "9",
    "eircode": "A96TW60",
    "addressOne": "Dunedin Park",
    "addressTwo": "Monkstown Farm",
    "addressThree": "Glenageary",
    "addressFour": "Co. Dublin",
    "lat": "53.2863276",
    "lng": "-6.1537674",
    "phone": "12809242",
    "email": "holyfamilydunedin@gmail.com"
  },
  {
    "i": "1060",
    "county": "Dublin",
    "rollNumber": "19845M",
    "schoolName": "North Dublin NS Project",
    "SETHours": "77.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "D09PE80",
    "addressOne": "Ballymun Road",
    "addressTwo": "Dublin 9",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3819302",
    "lng": "-6.2682924",
    "phone": "18371620",
    "email": "ruthdonald@ndnsp.ie"
  },
  {
    "i": "1061",
    "county": "Dublin",
    "rollNumber": "19850F",
    "schoolName": "Ladyswell NS",
    "SETHours": "240",
    "spClassTeachingPosts": "0",
    "mainSNA": "7.83",
    "spSNA": "0",
    "totalSNA": "7.83",
    "eircode": "D15DD40",
    "addressOne": "Dromheath Gardens",
    "addressTwo": "Mulhuddart",
    "addressThree": "Dublin 15",
    "addressFour": "",
    "lat": "53.4059808",
    "lng": "-6.3920372",
    "phone": "18204255",
    "email": "ladyswellns@gmail.com"
  },
  {
    "i": "1062",
    "county": "Dublin",
    "rollNumber": "19855P",
    "schoolName": "Gaelscoil Chluain Dolcain",
    "SETHours": "132.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "D22PE04",
    "addressOne": "Seanbhóthar Nangair",
    "addressTwo": "Cluain Dolcáin",
    "addressThree": "Baile átha Cliath 22",
    "addressFour": "",
    "lat": "53.3233459",
    "lng": "-6.402203",
    "phone": "14574970",
    "email": "oifig@gscd.ie"
  },
  {
    "i": "1063",
    "county": "Dublin",
    "rollNumber": "19865S",
    "schoolName": "Divine Mercy Jn NS",
    "SETHours": "165",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.33",
    "spSNA": "0",
    "totalSNA": "4.33",
    "eircode": "K78FW98",
    "addressOne": "Lynch's Lane",
    "addressTwo": "Lucan",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.3405678",
    "lng": "-6.4157761",
    "phone": "14573095",
    "email": "dmbalgaddyjns@gmail.com"
  },
  {
    "i": "1064",
    "county": "Dublin",
    "rollNumber": "19872P",
    "schoolName": "Scoil Chaitlin Maude",
    "SETHours": "180",
    "spClassTeachingPosts": "1",
    "mainSNA": "5.83",
    "spSNA": "2",
    "totalSNA": "7.83",
    "eircode": "D24C921",
    "addressOne": "Garrán An Choill",
    "addressTwo": "Tamhlacht",
    "addressThree": "Baile átha Cliath 24",
    "addressFour": "",
    "lat": "53.2761453",
    "lng": "-6.3932032",
    "phone": "14596141",
    "email": "oifig@scoilcm.ie"
  },
  {
    "i": "1065",
    "county": "Dublin",
    "rollNumber": "19877C",
    "schoolName": "Holy Family Sn NS",
    "SETHours": "260",
    "spClassTeachingPosts": "2",
    "mainSNA": "6.5",
    "spSNA": "0",
    "totalSNA": "6.5",
    "eircode": "K67V9V2",
    "addressOne": "Forest Fields",
    "addressTwo": "River Valley",
    "addressThree": "Swords",
    "addressFour": "Co. Dublin",
    "lat": "53.4518192",
    "lng": "-6.241495",
    "phone": "18406334",
    "email": "secretary@holyfamilysns.ie"
  },
  {
    "i": "1066",
    "county": "Dublin",
    "rollNumber": "19878E",
    "schoolName": "Holy Rosary Primary School",
    "SETHours": "267.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "10.49",
    "spSNA": "0",
    "totalSNA": "10.49",
    "eircode": "D24H022",
    "addressOne": "Old Court Avenue",
    "addressTwo": "Tallaght",
    "addressThree": "Dublin 24",
    "addressFour": "",
    "lat": "53.2728911",
    "lng": "-6.3486729",
    "phone": "14521369",
    "email": "holyrosaryps1@gmail.com"
  },
  {
    "i": "1067",
    "county": "Dublin",
    "rollNumber": "19888H",
    "schoolName": "St Annes Mxd NS",
    "SETHours": "167.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "6.83",
    "spSNA": "0",
    "totalSNA": "6.83",
    "eircode": "D18AV61",
    "addressOne": "Stonebridge Road",
    "addressTwo": "Shankill",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.234272",
    "lng": "-6.1289874",
    "phone": "12825565",
    "email": "stannesnsshankill@gmail.com"
  },
  {
    "i": "1068",
    "county": "Dublin",
    "rollNumber": "19893A",
    "schoolName": "St Kilians Sn NS",
    "SETHours": "102.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "7",
    "spSNA": "2",
    "totalSNA": "9",
    "eircode": "D24F797",
    "addressOne": "Kingswood Heights",
    "addressTwo": "Tallaght",
    "addressThree": "Dublin 24",
    "addressFour": "",
    "lat": "53.3062897",
    "lng": "-6.3703534",
    "phone": "14510100",
    "email": "stkilians@gmail.com"
  },
  {
    "i": "1069",
    "county": "Dublin",
    "rollNumber": "19896G",
    "schoolName": "Scoil Caitriona Na Mbraithre",
    "SETHours": "70",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.33",
    "spSNA": "0",
    "totalSNA": "4.33",
    "eircode": "D02H365",
    "addressOne": "59 Lower Baggot Street",
    "addressTwo": "Dublin 2",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3362025",
    "lng": "-6.2458237",
    "phone": "16766132",
    "email": "info@scoilchaitrionabaggotstreet.ie"
  },
  {
    "i": "1070",
    "county": "Dublin",
    "rollNumber": "19898K",
    "schoolName": "Gaelscoil An Duinninigh",
    "SETHours": "120",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.83",
    "spSNA": "0",
    "totalSNA": "4.83",
    "eircode": "K67V207",
    "addressOne": "Draighneán",
    "addressTwo": "Bóthar Fhaol Droma",
    "addressThree": "Sord",
    "addressFour": "Co. átha Cliath",
    "lat": "53.446612",
    "lng": "-6.2004429",
    "phone": "18409640",
    "email": "oifig@scoiland.ie"
  },
  {
    "i": "1071",
    "county": "Dublin",
    "rollNumber": "19901T",
    "schoolName": "Booterstown NS",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "A94E524",
    "addressOne": "Cross Ave",
    "addressTwo": "Blackrock",
    "addressThree": "Co Dublin",
    "addressFour": "",
    "lat": "53.3005433",
    "lng": "-6.1910044",
    "phone": "12885514",
    "email": "office@booterstownnationalschool.ie"
  },
  {
    "i": "1072",
    "county": "Dublin",
    "rollNumber": "19904C",
    "schoolName": "Holy Cross NS",
    "SETHours": "102.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "8",
    "spSNA": "0",
    "totalSNA": "8",
    "eircode": "D14AD66",
    "addressOne": "Kilmacud Road Upper",
    "addressTwo": "Dundrum",
    "addressThree": "Dublin 14",
    "addressFour": "",
    "lat": "53.2885144",
    "lng": "-6.2413717",
    "phone": "12985493",
    "email": "admin@holycrossschool.ie"
  },
  {
    "i": "1073",
    "county": "Dublin",
    "rollNumber": "19907I",
    "schoolName": "Gaelscoil Mologa",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "D6WEA22",
    "addressOne": "Bóthar Thigh Chláir,",
    "addressTwo": "Cros Araild",
    "addressThree": "Baile Atha Cliath 6w",
    "addressFour": "",
    "lat": "53.3173504",
    "lng": "-6.2853574",
    "phone": "14923888",
    "email": "runaiscoilmologa@gmail.com"
  },
  {
    "i": "1074",
    "county": "Dublin",
    "rollNumber": "19913D",
    "schoolName": "St Josephs Ns",
    "SETHours": "230",
    "spClassTeachingPosts": "1",
    "mainSNA": "6.83",
    "spSNA": "3",
    "totalSNA": "9.83",
    "eircode": "D17DY60",
    "addressOne": "Macroom Road",
    "addressTwo": "Bonnybrook",
    "addressThree": "Dublin 17",
    "addressFour": "",
    "lat": "53.3981164",
    "lng": "-6.2032168",
    "phone": "18475616",
    "email": "secretarystjosephsns@gmail.com"
  },
  {
    "i": "1075",
    "county": "Dublin",
    "rollNumber": "19919P",
    "schoolName": "St Davids NS",
    "SETHours": "175",
    "spClassTeachingPosts": "3",
    "mainSNA": "6.49",
    "spSNA": "7",
    "totalSNA": "13.49",
    "eircode": "D05E510",
    "addressOne": "Kilmore Road",
    "addressTwo": "Artane",
    "addressThree": "Dublin 5",
    "addressFour": "",
    "lat": "53.3858123",
    "lng": "-6.217246",
    "phone": "18487979",
    "email": "stdavidsbns@gmail.com"
  },
  {
    "i": "1076",
    "county": "Dublin",
    "rollNumber": "19920A",
    "schoolName": "St John Of God NS",
    "SETHours": "72.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "D05E265",
    "addressOne": "Kilmore Road",
    "addressTwo": "Artane",
    "addressThree": "Dublin 5",
    "addressFour": "",
    "lat": "53.3896502",
    "lng": "-6.2173226",
    "phone": "18477193",
    "email": "info@stjohnofgodartane.com"
  },
  {
    "i": "1077",
    "county": "Dublin",
    "rollNumber": "19922E",
    "schoolName": "Our Ladys NS",
    "SETHours": "105",
    "spClassTeachingPosts": "0",
    "mainSNA": "6",
    "spSNA": "0",
    "totalSNA": "6",
    "eircode": "D14N8H4",
    "addressOne": "St Columbanus",
    "addressTwo": "Milltown",
    "addressThree": "Dublin 14",
    "addressFour": "",
    "lat": "53.3016233",
    "lng": "-6.2499307",
    "phone": "12981989",
    "email": "olnsclonskeagh@gmail.com"
  },
  {
    "i": "1078",
    "county": "Dublin",
    "rollNumber": "19924I",
    "schoolName": "Harolds Cross NS",
    "SETHours": "180",
    "spClassTeachingPosts": "0",
    "mainSNA": "5",
    "spSNA": "0",
    "totalSNA": "5",
    "eircode": "D6WFR66",
    "addressOne": "Clareville Road",
    "addressTwo": "Harold's Cross",
    "addressThree": "Dublin 6w",
    "addressFour": "",
    "lat": "53.3173638",
    "lng": "-6.2857534",
    "phone": "14922321",
    "email": "office@haroldscrossns.ie"
  },
  {
    "i": "1079",
    "county": "Dublin",
    "rollNumber": "19926M",
    "schoolName": "Gaelscoil Cholaiste Mhuire",
    "SETHours": "105",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "D01WC99",
    "addressOne": "4 Cearnóg Parnell",
    "addressTwo": "Baile átha Cliath",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3535881",
    "lng": "-6.2620967",
    "phone": "18729131",
    "email": "GCMBAC1@GMAIL.COM"
  },
  {
    "i": "1080",
    "county": "Dublin",
    "rollNumber": "19928Q",
    "schoolName": "Ranelagh Multi Denom Ns",
    "SETHours": "70",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "D06Y658",
    "addressOne": "Ranelagh Road",
    "addressTwo": "Ranelagh",
    "addressThree": "Dublin 6",
    "addressFour": "",
    "lat": "53.3267982",
    "lng": "-6.2576866",
    "phone": "14961722",
    "email": "principal@rmds.ie"
  },
  {
    "i": "1081",
    "county": "Dublin",
    "rollNumber": "19929S",
    "schoolName": "St Brigids Sn Girls",
    "SETHours": "97.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "2",
    "spSNA": "5",
    "totalSNA": "7",
    "eircode": "D11X262",
    "addressOne": "Wellmount Avenue",
    "addressTwo": "Finglas West",
    "addressThree": "Dublin 11",
    "addressFour": "",
    "lat": "53.3862754",
    "lng": "-6.3102112",
    "phone": "18342416",
    "email": "info@stbrigidssgns.ie"
  },
  {
    "i": "1082",
    "county": "Dublin",
    "rollNumber": "19933J",
    "schoolName": "Scoil Treasa Naofa",
    "SETHours": "87.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "D08XP02",
    "addressOne": "Petrie Road",
    "addressTwo": "Donore Avenue",
    "addressThree": "Dublin 8",
    "addressFour": "",
    "lat": "53.3344596",
    "lng": "-6.2793638",
    "phone": "14541899",
    "email": "principal@scoiltreasanaofa.ie"
  },
  {
    "i": "1083",
    "county": "Dublin",
    "rollNumber": "19935N",
    "schoolName": "Scoil Eoin",
    "SETHours": "115",
    "spClassTeachingPosts": "0",
    "mainSNA": "7.83",
    "spSNA": "0",
    "totalSNA": "7.83",
    "eircode": "D05K5P2",
    "addressOne": "Greendale Road",
    "addressTwo": "Dublin 5",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3870066",
    "lng": "-6.1570723",
    "phone": "18323281",
    "email": "principalscoileoin@gmail.com"
  },
  {
    "i": "1084",
    "county": "Dublin",
    "rollNumber": "19938T",
    "schoolName": "St Josephs",
    "SETHours": "153",
    "spClassTeachingPosts": "1",
    "mainSNA": "6.83",
    "spSNA": "2",
    "totalSNA": "8.83",
    "eircode": "A96VF34",
    "addressOne": "Tivoli Road",
    "addressTwo": "Dun Laoghaire",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.2866843",
    "lng": "-6.1400087",
    "phone": "12803504",
    "email": "principal@dunlaoghairens.ie"
  },
  {
    "i": "1085",
    "county": "Dublin",
    "rollNumber": "19939V",
    "schoolName": "Scoil Naisiunta An Dea Aoire",
    "SETHours": "112.5",
    "spClassTeachingPosts": "4",
    "mainSNA": "4",
    "spSNA": "4.16",
    "totalSNA": "8.16",
    "eircode": "D14Y448",
    "addressOne": "Whitehall Road",
    "addressTwo": "Churchtown",
    "addressThree": "Dublin 14",
    "addressFour": "",
    "lat": "53.293642",
    "lng": "-6.2694794",
    "phone": "12989475",
    "email": "school@goodshepherd.ie"
  },
  {
    "i": "1086",
    "county": "Dublin",
    "rollNumber": "19940G",
    "schoolName": "Gaelscoil Naomh Padraig",
    "SETHours": "125",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "K78RK40",
    "addressOne": "Bóthar An Chaisleán",
    "addressTwo": "Leamhcán",
    "addressThree": "Co. átha Cliath",
    "addressFour": "",
    "lat": "53.3506269",
    "lng": "-6.4354832",
    "phone": "16241355",
    "email": "oifig.gsnp@gmail.com"
  },
  {
    "i": "1087",
    "county": "Dublin",
    "rollNumber": "19943M",
    "schoolName": "St Damiens Ns",
    "SETHours": "100",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.33",
    "spSNA": "0",
    "totalSNA": "3.33",
    "eircode": "D12FWV6",
    "addressOne": "Quarry Drive",
    "addressTwo": "Perrystown",
    "addressThree": "Dublin 12",
    "addressFour": "",
    "lat": "53.3142345",
    "lng": "-6.3212875",
    "phone": "14508932",
    "email": "stdamiansoffice@gmail.com"
  },
  {
    "i": "1088",
    "county": "Dublin",
    "rollNumber": "19945Q",
    "schoolName": "Rathfarnham Educate Together",
    "SETHours": "100",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.66",
    "spSNA": "0",
    "totalSNA": "5.66",
    "eircode": "D14V5W4",
    "addressOne": "Loreto Avenue",
    "addressTwo": "Rathfarnham",
    "addressThree": "Dublin 14",
    "addressFour": "",
    "lat": "53.2917566",
    "lng": "-6.2750885",
    "phone": "14938677",
    "email": "info@retns.ie"
  },
  {
    "i": "1089",
    "county": "Dublin",
    "rollNumber": "19946S",
    "schoolName": "Rutland NS",
    "SETHours": "105",
    "spClassTeachingPosts": "0",
    "mainSNA": "6",
    "spSNA": "0",
    "totalSNA": "6",
    "eircode": "D01AE73",
    "addressOne": "Lower Gloucester Place",
    "addressTwo": "Dublin 1",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3533709",
    "lng": "-6.2551024",
    "phone": "18747331",
    "email": "rutlandns@gmail.com"
  },
  {
    "i": "1090",
    "county": "Dublin",
    "rollNumber": "19949B",
    "schoolName": "Islamic NS",
    "SETHours": "170",
    "spClassTeachingPosts": "1",
    "mainSNA": "3",
    "spSNA": "2",
    "totalSNA": "5",
    "eircode": "D14V386",
    "addressOne": "19 Roebuck Road",
    "addressTwo": "Clonskeagh",
    "addressThree": "Dublin 14",
    "addressFour": "",
    "lat": "53.3039596",
    "lng": "-6.2342314",
    "phone": "12961340",
    "email": "mns0003@hotmail.com"
  },
  {
    "i": "1091",
    "county": "Dublin",
    "rollNumber": "19954R",
    "schoolName": "North Bay Educate Together Ns",
    "SETHours": "92.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "5",
    "spSNA": "0",
    "totalSNA": "5",
    "eircode": "D05K744",
    "addressOne": "Greendale Avenue",
    "addressTwo": "Kilbarrack",
    "addressThree": "Dublin 5",
    "addressFour": "",
    "lat": "53.3853245",
    "lng": "-6.152575",
    "phone": "18325536",
    "email": "principal@northbay.ie"
  },
  {
    "i": "1092",
    "county": "Dublin",
    "rollNumber": "19960M",
    "schoolName": "St Johns NS",
    "SETHours": "115",
    "spClassTeachingPosts": "3",
    "mainSNA": "6",
    "spSNA": "7",
    "totalSNA": "13",
    "eircode": "A96NW60",
    "addressOne": "Church Road",
    "addressTwo": "Ballybrack",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.2560838",
    "lng": "-6.1282737",
    "phone": "12855525",
    "email": "office@stjohnsns.ie"
  },
  {
    "i": "1093",
    "county": "Dublin",
    "rollNumber": "19979K",
    "schoolName": "St Kevins NS",
    "SETHours": "122.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.66",
    "spSNA": "0",
    "totalSNA": "3.66",
    "eircode": "A96W862",
    "addressOne": "Pearse Street",
    "addressTwo": "Sallynoggin",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.2764912",
    "lng": "-6.1383221",
    "phone": "12854309",
    "email": "stkevinsns@eircom.net"
  },
  {
    "i": "1094",
    "county": "Dublin",
    "rollNumber": "19981U",
    "schoolName": "St Marys NS",
    "SETHours": "90",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "D03AH64",
    "addressOne": "Windsor Avenue",
    "addressTwo": "Fairview",
    "addressThree": "Dublin 3",
    "addressFour": "",
    "lat": "53.3641737",
    "lng": "-6.2382837",
    "phone": "18377551",
    "email": "secretary@stmarysfairview.ie"
  },
  {
    "i": "1095",
    "county": "Dublin",
    "rollNumber": "19991A",
    "schoolName": "Gaelscoil Na Camoige",
    "SETHours": "85",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "D22X048",
    "addressOne": "Bóthar An úlloird",
    "addressTwo": "Cluain Dolcáin",
    "addressThree": "Baile átha Cliath 22",
    "addressFour": "",
    "lat": "53.3236498",
    "lng": "-6.3929228",
    "phone": "14576878",
    "email": "gncamoige@gmail.com"
  },
  {
    "i": "1096",
    "county": "Dublin",
    "rollNumber": "20012S",
    "schoolName": "Griffith Barracks Multi D School",
    "SETHours": "127.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.5",
    "spSNA": "0",
    "totalSNA": "5.5",
    "eircode": "D08KVY4",
    "addressOne": "The Old Guardhouse",
    "addressTwo": "South Circular Road",
    "addressThree": "Dublin 8",
    "addressFour": "",
    "lat": "53.3310938",
    "lng": "-6.2799479",
    "phone": "14547278",
    "email": "office@griffithbarracks.ie"
  },
  {
    "i": "1097",
    "county": "Dublin",
    "rollNumber": "20015B",
    "schoolName": "Gaelscoil Bhaile Munna",
    "SETHours": "112.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.58",
    "spSNA": "0",
    "totalSNA": "2.58",
    "eircode": "D09TY74",
    "addressOne": "Bóthar Choltraí­",
    "addressTwo": "Baile Munna",
    "addressThree": "Baile átha Cliath 9",
    "addressFour": "",
    "lat": "53.3980416",
    "lng": "-6.2558431",
    "phone": "18622275",
    "email": "eolas@gaelscoilbhailemunna.ie"
  },
  {
    "i": "1098",
    "county": "Dublin",
    "rollNumber": "20020R",
    "schoolName": "Gaelscoil Thaobh Na Coille",
    "SETHours": "112.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "D18TK40",
    "addressOne": "Beallairmí­n",
    "addressTwo": "An Chéim",
    "addressThree": "Baile átha Cliath 18",
    "addressFour": "",
    "lat": "53.2595561",
    "lng": "-6.2153485",
    "phone": "12950000",
    "email": "gaelscoil@taobhnacoille.ie"
  },
  {
    "i": "1099",
    "county": "Dublin",
    "rollNumber": "20029M",
    "schoolName": "St Brigids Infant NS",
    "SETHours": "107.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.15",
    "spSNA": "0",
    "totalSNA": "4.15",
    "eircode": "D11F992",
    "addressOne": "Wellmount Avenue",
    "addressTwo": "Finglas West",
    "addressThree": "Dublin 11",
    "addressFour": "",
    "lat": "53.3861926",
    "lng": "-6.308412",
    "phone": "18348770",
    "email": "stbrigidsinfantschool@eircom.net"
  },
  {
    "i": "1100",
    "county": "Dublin",
    "rollNumber": "20035H",
    "schoolName": "St Gabriels NS",
    "SETHours": "140",
    "spClassTeachingPosts": "1",
    "mainSNA": "3.83",
    "spSNA": "2",
    "totalSNA": "5.83",
    "eircode": "D07CX50",
    "addressOne": "Cowper Street",
    "addressTwo": "Dublin 7",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3538543",
    "lng": "-6.2906696",
    "phone": "18384853",
    "email": "principal@stgabrielsns.ie"
  },
  {
    "i": "1101",
    "county": "Dublin",
    "rollNumber": "20043G",
    "schoolName": "Gaelscoil Chnoc Liamhna",
    "SETHours": "62.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "D16HR26",
    "addressOne": "Sean Bhóthar Chnoc Liamhna",
    "addressTwo": "Bothar Cnoc Liamhna",
    "addressThree": "Baile átha Cliath 16",
    "addressFour": "",
    "lat": "53.2845038",
    "lng": "-6.3267558",
    "phone": "14939262",
    "email": "runai@gaelscoilcl.com"
  },
  {
    "i": "1102",
    "county": "Dublin",
    "rollNumber": "20047O",
    "schoolName": "Gaelscoil Bharra",
    "SETHours": "112.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "5",
    "spSNA": "0",
    "totalSNA": "5",
    "eircode": "D07CF72",
    "addressOne": "Naomh Fionbarra Clg",
    "addressTwo": "Ascal An Fhasaigh",
    "addressThree": "Cabrach",
    "addressFour": "Baile átha Cliath 7",
    "lat": "53.3646984",
    "lng": "-6.28945",
    "phone": "18684827",
    "email": "oifig@gaelscoilbharra.net"
  },
  {
    "i": "1103",
    "county": "Dublin",
    "rollNumber": "20048Q",
    "schoolName": "Gaelscoil Lios Na Nog",
    "SETHours": "70",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "D06WF43",
    "addressOne": "Teach Feadha Chuileann",
    "addressTwo": "Bóthar Oakley",
    "addressThree": "Raghnallach",
    "addressFour": "Baile átha Cliath 6",
    "lat": "53.3221546",
    "lng": "-6.2567926",
    "phone": "14975300",
    "email": "eolas@gsliosnanog.ie"
  },
  {
    "i": "1104",
    "county": "Dublin",
    "rollNumber": "20052H",
    "schoolName": "Gaelscoil Cholmcille",
    "SETHours": "70",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "D17W021",
    "addressOne": "Lána Na Cúlóige",
    "addressTwo": "Baile átha Cliath 17",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3960102",
    "lng": "-6.2305956",
    "phone": "18940440",
    "email": "eolas@gaelscoilcholmcille.ie"
  },
  {
    "i": "1105",
    "county": "Dublin",
    "rollNumber": "20056P",
    "schoolName": "Gaelscoil Phadraig",
    "SETHours": "77.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "A96KF64",
    "addressOne": "Ascaill Shí­leann",
    "addressTwo": "Baile Breac",
    "addressThree": "Co. átha Cliath",
    "addressFour": "",
    "lat": "53.2483738",
    "lng": "-6.1245869",
    "phone": "12827345",
    "email": "gaelscoilphadraig@gmail.com"
  },
  {
    "i": "1106",
    "county": "Dublin",
    "rollNumber": "20059V",
    "schoolName": "Mother Of Divine Grace",
    "SETHours": "262.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.66",
    "spSNA": "0",
    "totalSNA": "5.66",
    "eircode": "D11VW68",
    "addressOne": "Ferndale Avenue",
    "addressTwo": "Ballygall",
    "addressThree": "Dublin 11",
    "addressFour": "",
    "lat": "53.3863281",
    "lng": "-6.2874542",
    "phone": "18344000",
    "email": "school@mdgballygall.com"
  },
  {
    "i": "1107",
    "county": "Dublin",
    "rollNumber": "20060G",
    "schoolName": "Monkstown Educate Together Ns",
    "SETHours": "202.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "13",
    "spSNA": "0",
    "totalSNA": "13",
    "eircode": "A96R528",
    "addressOne": "Kill Avenue",
    "addressTwo": "Dun Laoghaire",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.2806513",
    "lng": "-6.1503437",
    "phone": "12303696",
    "email": "office@metns.ie"
  },
  {
    "i": "1108",
    "county": "Dublin",
    "rollNumber": "20064O",
    "schoolName": "Our Lady Of Consolation Ns",
    "SETHours": "132.5",
    "spClassTeachingPosts": "5",
    "mainSNA": "4.49",
    "spSNA": "12.32",
    "totalSNA": "16.81",
    "eircode": "D05RW80",
    "addressOne": "Collins Avenue East",
    "addressTwo": "Donnycarney",
    "addressThree": "Dublin 5",
    "addressFour": "",
    "lat": "53.3743785",
    "lng": "-6.21686",
    "phone": "18310721",
    "email": "office@olocschool.ie"
  },
  {
    "i": "1109",
    "county": "Dublin",
    "rollNumber": "20066S",
    "schoolName": "Lucan Educate Together Ns",
    "SETHours": "120",
    "spClassTeachingPosts": "2",
    "mainSNA": "4.5",
    "spSNA": "4",
    "totalSNA": "8.5",
    "eircode": "K78C922",
    "addressOne": "Mount Bellew Way",
    "addressTwo": "Willsbrook",
    "addressThree": "Lucan",
    "addressFour": "Co. Dublin",
    "lat": "53.3512046",
    "lng": "-6.4254417",
    "phone": "16281298",
    "email": "info@letns.org"
  },
  {
    "i": "1110",
    "county": "Dublin",
    "rollNumber": "20091R",
    "schoolName": "St Peters Ns",
    "SETHours": "125",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.33",
    "spSNA": "0",
    "totalSNA": "4.33",
    "eircode": "D07F75C",
    "addressOne": "Saint Peter's Road",
    "addressTwo": "Phibsborough",
    "addressThree": "Dublin 7",
    "addressFour": "",
    "lat": "53.3617557",
    "lng": "-6.2765544",
    "phone": "18680501",
    "email": "office@stpetersns.net"
  },
  {
    "i": "1111",
    "county": "Dublin",
    "rollNumber": "20092T",
    "schoolName": "St Ultans Ns",
    "SETHours": "280",
    "spClassTeachingPosts": "3",
    "mainSNA": "14.66",
    "spSNA": "9",
    "totalSNA": "23.66",
    "eircode": "D10NY53",
    "addressOne": "Cherry Orchard Avenue",
    "addressTwo": "Ballyfermot",
    "addressThree": "Dublin 10",
    "addressFour": "",
    "lat": "53.3367966",
    "lng": "-6.3738702",
    "phone": "16434599",
    "email": "office@stultans.ie"
  },
  {
    "i": "1112",
    "county": "Dublin",
    "rollNumber": "20095C",
    "schoolName": "Gaelscoil Bhrian Bóroimhe",
    "SETHours": "147.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "K67T3H2",
    "addressOne": "Coill Na Núll",
    "addressTwo": "Sord",
    "addressThree": "Co. átha Cliath",
    "addressFour": "",
    "lat": "53.4713461",
    "lng": "-6.246228",
    "phone": "18902799",
    "email": "oifig@gsbb.ie"
  },
  {
    "i": "1113",
    "county": "Dublin",
    "rollNumber": "20098I",
    "schoolName": "Castleknock Educate Together Ns",
    "SETHours": "160",
    "spClassTeachingPosts": "2",
    "mainSNA": "6.66",
    "spSNA": "6",
    "totalSNA": "12.66",
    "eircode": "D15X094",
    "addressOne": "Beechpark Avenue",
    "addressTwo": "Castleknock",
    "addressThree": "Dublin 15",
    "addressFour": "",
    "lat": "53.3799514",
    "lng": "-6.3628187",
    "phone": "18219331",
    "email": "secretary@cetns.ie"
  },
  {
    "i": "1114",
    "county": "Dublin",
    "rollNumber": "20103V",
    "schoolName": "John Scottus Ns",
    "SETHours": "75",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "D04R128",
    "addressOne": "47/49 Northumberland Road",
    "addressTwo": "Ballsbridge",
    "addressThree": "Dublin 4",
    "addressFour": "",
    "lat": "53.3344211",
    "lng": "-6.2373189",
    "phone": "16609309",
    "email": "primary@johnscottus.ie"
  },
  {
    "i": "1115",
    "county": "Dublin",
    "rollNumber": "20104A",
    "schoolName": "St Audoens Ns",
    "SETHours": "132.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "4",
    "spSNA": "4",
    "totalSNA": "8",
    "eircode": "D08XP83",
    "addressOne": "Cook Street",
    "addressTwo": "Merchant's Quay",
    "addressThree": "Dublin 8",
    "addressFour": "",
    "lat": "53.3443321",
    "lng": "-6.2743708",
    "phone": "16779856",
    "email": "info@staudoens.ie"
  },
  {
    "i": "1116",
    "county": "Dublin",
    "rollNumber": "20130B",
    "schoolName": "St Patricks Ns",
    "SETHours": "240",
    "spClassTeachingPosts": "0",
    "mainSNA": "11.81",
    "spSNA": "0",
    "totalSNA": "11.81",
    "eircode": "D15PH21",
    "addressOne": "St. Patrick's NS",
    "addressTwo": "Diswellstown Lawn",
    "addressThree": "Castleknock",
    "addressFour": "Dublin 15",
    "lat": "53.3689542",
    "lng": "-6.3873728",
    "phone": "18249930",
    "email": "info@stpatricksns.ie"
  },
  {
    "i": "1117",
    "county": "Dublin",
    "rollNumber": "20131D",
    "schoolName": "Educate Together Ns",
    "SETHours": "158",
    "spClassTeachingPosts": "1",
    "mainSNA": "6.66",
    "spSNA": "2",
    "totalSNA": "8.66",
    "eircode": "D07PY50",
    "addressOne": "Fitzwilliam Place North",
    "addressTwo": "Grangegorman Lower",
    "addressThree": "Dublin 7",
    "addressFour": "",
    "lat": "53.3520302",
    "lng": "-6.2782793",
    "phone": "18943111",
    "email": "Secretary@d7educatetogether.com"
  },
  {
    "i": "1118",
    "county": "Dublin",
    "rollNumber": "20137P",
    "schoolName": "Mary Mother Of Hope Sn Ns",
    "SETHours": "150",
    "spClassTeachingPosts": "0",
    "mainSNA": "10",
    "spSNA": "0",
    "totalSNA": "10",
    "eircode": "D15TA49",
    "addressOne": "Littlepace",
    "addressTwo": "Castaheany",
    "addressThree": "Dublin 15",
    "addressFour": "",
    "lat": "53.4047632",
    "lng": "-6.4238884",
    "phone": "18128693",
    "email": "hopens@eircom.net"
  },
  {
    "i": "1119",
    "county": "Dublin",
    "rollNumber": "20139T",
    "schoolName": "Inchicore Ns",
    "SETHours": "132.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "6.49",
    "spSNA": "0",
    "totalSNA": "6.49",
    "eircode": "D10V963",
    "addressOne": "Sarsfield Road",
    "addressTwo": "Inchicore",
    "addressThree": "Dublin 10",
    "addressFour": "",
    "lat": "53.3413932",
    "lng": "-6.3200961",
    "phone": "14536505",
    "email": "inchicorens@gmail.com"
  },
  {
    "i": "1120",
    "county": "Dublin",
    "rollNumber": "20141G",
    "schoolName": "The Harold School",
    "SETHours": "200",
    "spClassTeachingPosts": "0",
    "mainSNA": "6.83",
    "spSNA": "0",
    "totalSNA": "6.83",
    "eircode": "A96X043",
    "addressOne": "Eden Road",
    "addressTwo": "Glasthule",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.2860639",
    "lng": "-6.1256209",
    "phone": "12805708",
    "email": "admin@haroldschool.ie"
  },
  {
    "i": "1121",
    "county": "Dublin",
    "rollNumber": "20145O",
    "schoolName": "Swords Educate Together Ns",
    "SETHours": "170",
    "spClassTeachingPosts": "0",
    "mainSNA": "8.66",
    "spSNA": "0",
    "totalSNA": "8.66",
    "eircode": "K67H0F6",
    "addressOne": "Applewood",
    "addressTwo": "Swords",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.4713494",
    "lng": "-6.2470638",
    "phone": "18903899",
    "email": "info@swordseducatetogether.ie"
  },
  {
    "i": "1122",
    "county": "Dublin",
    "rollNumber": "20152L",
    "schoolName": "North Dublin Muslim NS Project",
    "SETHours": "150",
    "spClassTeachingPosts": "1",
    "mainSNA": "3.83",
    "spSNA": "3",
    "totalSNA": "6.83",
    "eircode": "D07P967",
    "addressOne": "Ratoath Road",
    "addressTwo": "Cabra",
    "addressThree": "Dublin 7",
    "addressFour": "",
    "lat": "53.3634993",
    "lng": "-6.2996924",
    "phone": "18689587",
    "email": "info@ndmns.com"
  },
  {
    "i": "1123",
    "county": "Dublin",
    "rollNumber": "20161M",
    "schoolName": "Donabate/portrane Educate Together",
    "SETHours": "260",
    "spClassTeachingPosts": "2",
    "mainSNA": "10.32",
    "spSNA": "5.83",
    "totalSNA": "16.15",
    "eircode": "K36HX03",
    "addressOne": "Ballisk Common",
    "addressTwo": "Beaverstown Road",
    "addressThree": "Donabate",
    "addressFour": "Co. Dublin",
    "lat": "53.491709",
    "lng": "-6.1457005",
    "phone": "18434573",
    "email": "info@dpetns.ie"
  },
  {
    "i": "1124",
    "county": "Dublin",
    "rollNumber": "20166W",
    "schoolName": "Griffeen Valley Educate Together Ns",
    "SETHours": "185",
    "spClassTeachingPosts": "0",
    "mainSNA": "7.66",
    "spSNA": "0",
    "totalSNA": "7.66",
    "eircode": "K78YA07",
    "addressOne": "Griffeen Glen Boulevard",
    "addressTwo": "Lucan",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.3413363",
    "lng": "-6.4337768",
    "phone": "16219819",
    "email": "info@gvet.ie"
  },
  {
    "i": "1125",
    "county": "Dublin",
    "rollNumber": "20168D",
    "schoolName": "Glasnevin Educate Together Ns",
    "SETHours": "122.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "5.49",
    "spSNA": "4",
    "totalSNA": "9.49",
    "eircode": "D11A2YT",
    "addressOne": "Griffith Avenue",
    "addressTwo": "Glasmevim",
    "addressThree": "Dublin 11",
    "addressFour": "",
    "lat": "53.3787261",
    "lng": "-6.2693792",
    "phone": "18572086",
    "email": "scoilgetns@gmail.com"
  },
  {
    "i": "1126",
    "county": "Dublin",
    "rollNumber": "20173T",
    "schoolName": "St Annes Primary School",
    "SETHours": "277.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "10",
    "spSNA": "0",
    "totalSNA": "10",
    "eircode": "D24DHY5",
    "addressOne": "Kilcarrig Avenue",
    "addressTwo": "Tallaght",
    "addressThree": "Dublin 24",
    "addressFour": "",
    "lat": "53.2906556",
    "lng": "-6.3919974",
    "phone": "14515850",
    "email": "stannesps@gmail.com"
  },
  {
    "i": "1127",
    "county": "Dublin",
    "rollNumber": "20176C",
    "schoolName": "Rush And Lusk Educate Together Ns",
    "SETHours": "185",
    "spClassTeachingPosts": "0",
    "mainSNA": "8.49",
    "spSNA": "0",
    "totalSNA": "8.49",
    "eircode": "K45WC62",
    "addressOne": "Raheny Lane",
    "addressTwo": "Rathmore Road",
    "addressThree": "Lusk",
    "addressFour": "Co. Dublin",
    "lat": "53.5289349",
    "lng": "-6.1569141",
    "phone": "18430525",
    "email": "office@ralet.ie"
  },
  {
    "i": "1128",
    "county": "Dublin",
    "rollNumber": "20186F",
    "schoolName": "Castaheany Educate Together Ns",
    "SETHours": "175",
    "spClassTeachingPosts": "0",
    "mainSNA": "5",
    "spSNA": "0",
    "totalSNA": "5",
    "eircode": "D15AE61",
    "addressOne": "Ongar Village",
    "addressTwo": "Dublin 15",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3933865",
    "lng": "-6.4426779",
    "phone": "16467484",
    "email": "castaheanyeducatetogether@gmail.com"
  },
  {
    "i": "1129",
    "county": "Dublin",
    "rollNumber": "20187H",
    "schoolName": "Divine Mercy Sn NS",
    "SETHours": "190",
    "spClassTeachingPosts": "0",
    "mainSNA": "8",
    "spSNA": "0",
    "totalSNA": "8",
    "eircode": "K78A393",
    "addressOne": "Balgaddy",
    "addressTwo": "Lucan",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.339867",
    "lng": "-6.4167652",
    "phone": "14670689",
    "email": "dmbalgaddysns@gmail.com"
  },
  {
    "i": "1130",
    "county": "Dublin",
    "rollNumber": "20190T",
    "schoolName": "Holy Trinity NS",
    "SETHours": "202.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "7",
    "spSNA": "0",
    "totalSNA": "7",
    "eircode": "D18YV91",
    "addressOne": "Glencairn",
    "addressTwo": "Leopardstown",
    "addressThree": "Dublin 18",
    "addressFour": "",
    "lat": "53.2618173",
    "lng": "-6.1964289",
    "phone": "12063664",
    "email": "office@holytrinity.ie"
  },
  {
    "i": "1131",
    "county": "Dublin",
    "rollNumber": "20194E",
    "schoolName": "St. John The Evangelist NS",
    "SETHours": "210",
    "spClassTeachingPosts": "0",
    "mainSNA": "10.83",
    "spSNA": "0",
    "totalSNA": "10.83",
    "eircode": "K78P212",
    "addressOne": "Station Road",
    "addressTwo": "Adamstown Castle",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.3363033",
    "lng": "-6.4608685",
    "phone": "16540358",
    "email": "office@stjohntheevangelistns.com"
  },
  {
    "i": "1132",
    "county": "Dublin",
    "rollNumber": "20201V",
    "schoolName": "Tyrrelstown Educate Together NS",
    "SETHours": "207.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "10.32",
    "spSNA": "5.83",
    "totalSNA": "16.15",
    "eircode": "D15X938",
    "addressOne": "Hollywood Road",
    "addressTwo": "Tyrellstown",
    "addressThree": "Dublin 15",
    "addressFour": "",
    "lat": "53.4231681",
    "lng": "-6.3824572",
    "phone": "18272172",
    "email": "info@tetns.ie"
  },
  {
    "i": "1133",
    "county": "Dublin",
    "rollNumber": "20202A",
    "schoolName": "Balbriggan Educate Together Ns",
    "SETHours": "185",
    "spClassTeachingPosts": "0",
    "mainSNA": "6.49",
    "spSNA": "0",
    "totalSNA": "6.49",
    "eircode": "K32NT02",
    "addressOne": "Hamlet Lane",
    "addressTwo": "Balbriggan",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.6113581",
    "lng": "-6.2067144",
    "phone": "16904635",
    "email": "balbrigganetns@eircom.net"
  },
  {
    "i": "1134",
    "county": "Dublin",
    "rollNumber": "20218P",
    "schoolName": "St Columbanus NS",
    "SETHours": "75.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "A96X0D1",
    "addressOne": "Loughlinstown Drive",
    "addressTwo": "Dun Laoghaire",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.2471029",
    "lng": "-6.1269705",
    "phone": "12821220",
    "email": "officestcolumbanusns@gmail.com"
  },
  {
    "i": "1135",
    "county": "Dublin",
    "rollNumber": "20220C",
    "schoolName": "Gaelscoil Ui Earcain",
    "SETHours": "130",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.83",
    "spSNA": "0",
    "totalSNA": "4.83",
    "eircode": "D11VP44",
    "addressOne": "Bóthar Ghlas An éin",
    "addressTwo": "Fionnghlas",
    "addressThree": "Baile átha Cliath 11",
    "addressFour": "",
    "lat": "53.3874063",
    "lng": "-6.2899421",
    "phone": "18643544",
    "email": "eolas@gsue.ie"
  },
  {
    "i": "1136",
    "county": "Dublin",
    "rollNumber": "20223I",
    "schoolName": "Gaelscoil Eiscir Riada",
    "SETHours": "145",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "K78YX77",
    "addressOne": "Bóthar An Ghrifí­n",
    "addressTwo": "Leamhcán",
    "addressThree": "Co. átha Cliath",
    "addressFour": "",
    "lat": "53.3481702",
    "lng": "-6.4367337",
    "phone": "16210342",
    "email": "gaelscoil_eiscirriada@yahoo.ie"
  },
  {
    "i": "1137",
    "county": "Dublin",
    "rollNumber": "20231H",
    "schoolName": "St Benedicts NS",
    "SETHours": "217.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "11.15",
    "spSNA": "0",
    "totalSNA": "11.15",
    "eircode": "D15PY61",
    "addressOne": "Ongar",
    "addressTwo": "Dublin 15",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3931773",
    "lng": "-6.4408506",
    "phone": "16403011",
    "email": "office.stbenedicts@gmail.com"
  },
  {
    "i": "1138",
    "county": "Dublin",
    "rollNumber": "20241K",
    "schoolName": "Scoil Choilm Community Ns",
    "SETHours": "337.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "12.49",
    "spSNA": "6",
    "totalSNA": "18.49",
    "eircode": "D15X582",
    "addressOne": "Porterstown Road",
    "addressTwo": "Clonsilla",
    "addressThree": "Dublin 15",
    "addressFour": "",
    "lat": "53.3760532",
    "lng": "-6.4088404",
    "phone": "18213352",
    "email": "scoilchoilm@sccns.ie"
  },
  {
    "i": "1139",
    "county": "Dublin",
    "rollNumber": "20247W",
    "schoolName": "Scoil Ghrainne Community NS",
    "SETHours": "255",
    "spClassTeachingPosts": "2",
    "mainSNA": "9.49",
    "spSNA": "5.5",
    "totalSNA": "14.99",
    "eircode": "D15Y5PR",
    "addressOne": "Phibblestown",
    "addressTwo": "Clonee",
    "addressThree": "Dublin 15",
    "addressFour": "",
    "lat": "53.3975244",
    "lng": "-6.4371064",
    "phone": "16402418",
    "email": "s.ghrainne@gmail.com"
  },
  {
    "i": "1140",
    "county": "Dublin",
    "rollNumber": "20252P",
    "schoolName": "Gaelscoil Bhaile Brigin",
    "SETHours": "187.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "5.66",
    "spSNA": "4",
    "totalSNA": "9.66",
    "eircode": "K32YT18",
    "addressOne": "Fearann An Chaisleáin",
    "addressTwo": "Baile Brigí­n",
    "addressThree": "Co. átha Cliath",
    "addressFour": "",
    "lat": "53.6005899",
    "lng": "-6.1791182",
    "phone": "18416036",
    "email": "oifig@gsbhailebrigin.ie"
  },
  {
    "i": "1141",
    "county": "Dublin",
    "rollNumber": "20268H",
    "schoolName": "Adamstown Castle Educate Together NS",
    "SETHours": "150",
    "spClassTeachingPosts": "2",
    "mainSNA": "5",
    "spSNA": "4",
    "totalSNA": "9",
    "eircode": "K78KT91",
    "addressOne": "Station Road",
    "addressTwo": "Adamstown",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.336254",
    "lng": "-6.459985",
    "phone": "16540088",
    "email": "office@acetns.ie"
  },
  {
    "i": "1142",
    "county": "Dublin",
    "rollNumber": "20269J",
    "schoolName": "Scoil Chormaic",
    "SETHours": "250",
    "spClassTeachingPosts": "2",
    "mainSNA": "7.83",
    "spSNA": "3.83",
    "totalSNA": "11.66",
    "eircode": "K32AX94",
    "addressOne": "Scoil Chormaic CNS",
    "addressTwo": "Stephenstown",
    "addressThree": "Balbriggan",
    "addressFour": "Co Dublin",
    "lat": "53.6047038",
    "lng": "-6.2017989",
    "phone": "18416948",
    "email": "scoilchormaiccns@ddletb.ie"
  },
  {
    "i": "1143",
    "county": "Dublin",
    "rollNumber": "20274C",
    "schoolName": "Esker Educate Together NS",
    "SETHours": "200",
    "spClassTeachingPosts": "1",
    "mainSNA": "9.66",
    "spSNA": "0.83",
    "totalSNA": "10.49",
    "eircode": "K78N239",
    "addressOne": "The Glebe",
    "addressTwo": "Esker Lane",
    "addressThree": "Lucan",
    "addressFour": "Co. Dublin",
    "lat": "53.3509407",
    "lng": "-6.4372387",
    "phone": "16241462",
    "email": "office@eskeretns.ie"
  },
  {
    "i": "1144",
    "county": "Dublin",
    "rollNumber": "20281W",
    "schoolName": "St Benedicts And St Marys NS",
    "SETHours": "102.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.83",
    "spSNA": "0",
    "totalSNA": "5.83",
    "eircode": "D05K4N2",
    "addressOne": "Grange Park",
    "addressTwo": "Raheny",
    "addressThree": "Dublin 5",
    "addressFour": "",
    "lat": "53.3884024",
    "lng": "-6.1642907",
    "phone": "18470202",
    "email": "stbenedictsandstmarys@live.ie"
  },
  {
    "i": "1145",
    "county": "Dublin",
    "rollNumber": "20282B",
    "schoolName": "Bracken Educate Together NS",
    "SETHours": "202.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "6.66",
    "spSNA": "6",
    "totalSNA": "12.66",
    "eircode": "K32YE94",
    "addressOne": "Castlelands",
    "addressTwo": "Balbriggan",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.6008425",
    "lng": "-6.1781798",
    "phone": "18496850",
    "email": "info@brackenetns.com"
  },
  {
    "i": "1146",
    "county": "Dublin",
    "rollNumber": "20302E",
    "schoolName": "Thornleigh Educate Together NS",
    "SETHours": "130",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.66",
    "spSNA": "0",
    "totalSNA": "3.66",
    "eircode": "K67PH68",
    "addressOne": "Thornleigh Green",
    "addressTwo": "Applewood Village",
    "addressThree": "Swords",
    "addressFour": "Co. Dublin",
    "lat": "53.4722718",
    "lng": "-6.2337284",
    "phone": "18074969",
    "email": "office@thornleighet.com"
  },
  {
    "i": "1147",
    "county": "Dublin",
    "rollNumber": "20303G",
    "schoolName": "Lucan East Etns",
    "SETHours": "187.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "7.32",
    "spSNA": "4",
    "totalSNA": "11.32",
    "eircode": "K78FA37",
    "addressOne": "Kishogue Cross",
    "addressTwo": "Off Griffeen Avenue",
    "addressThree": "Lucan",
    "addressFour": "County Dublin",
    "lat": "53.3383121",
    "lng": "-6.432513",
    "phone": "16212690",
    "email": "secretary@lucaneastet.ie"
  },
  {
    "i": "1148",
    "county": "Dublin",
    "rollNumber": "20304I",
    "schoolName": "St. Francis Of Assisi NS",
    "SETHours": "200",
    "spClassTeachingPosts": "0",
    "mainSNA": "7.33",
    "spSNA": "0",
    "totalSNA": "7.33",
    "eircode": "D13P5VY",
    "addressOne": "Belmayne Avenue",
    "addressTwo": "Balgriffin",
    "addressThree": "Dublin 13",
    "addressFour": "",
    "lat": "53.4047761",
    "lng": "-6.169895",
    "phone": "18296007",
    "email": "office@stfrancispsbelmayne.com"
  },
  {
    "i": "1149",
    "county": "Dublin",
    "rollNumber": "20307O",
    "schoolName": "Skerries Educate Together NS",
    "SETHours": "175",
    "spClassTeachingPosts": "2",
    "mainSNA": "9.49",
    "spSNA": "3.32",
    "totalSNA": "12.81",
    "eircode": "K34CX46",
    "addressOne": "Kellys Bay",
    "addressTwo": "Skerries",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.5833192",
    "lng": "-6.134496",
    "phone": "18494050",
    "email": "admin@skerrieseducatetogether.ie"
  },
  {
    "i": "1150",
    "county": "Dublin",
    "rollNumber": "20308Q",
    "schoolName": "Belmayne Educate Together NS",
    "SETHours": "152.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.99",
    "spSNA": "0",
    "totalSNA": "5.99",
    "eircode": "D13DA58",
    "addressOne": "Belmayne Avenue",
    "addressTwo": "Dublin 13",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.408322",
    "lng": "-6.1665024",
    "phone": "18296980",
    "email": "office@belmayne-etns.ie"
  },
  {
    "i": "1151",
    "county": "Dublin",
    "rollNumber": "20309S",
    "schoolName": "Mary Mother Of Hope Jn NS",
    "SETHours": "140",
    "spClassTeachingPosts": "1",
    "mainSNA": "4.83",
    "spSNA": "1.66",
    "totalSNA": "6.49",
    "eircode": "D15TA49",
    "addressOne": "St Charles Houben Building",
    "addressTwo": "Littlepace",
    "addressThree": "Clonee",
    "addressFour": "Dublin 15",
    "lat": "53.4047632",
    "lng": "-6.4238884",
    "phone": "16405655",
    "email": "info@hopejns.ie"
  },
  {
    "i": "1152",
    "county": "Dublin",
    "rollNumber": "20334R",
    "schoolName": "Gaelscoil Ros Eo",
    "SETHours": "75",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "K56C867",
    "addressOne": "Gaelscoil Ros Eo",
    "addressTwo": "Clg Naomh Maur",
    "addressThree": "Ros Eo",
    "addressFour": "Co. Bhaile átha Cliath",
    "lat": "53.5322123",
    "lng": "-6.1061353",
    "phone": "18949767",
    "email": "priomhoide@gaelscoilroseo.com"
  },
  {
    "i": "1153",
    "county": "Dublin",
    "rollNumber": "20338C",
    "schoolName": "Holy Child NS",
    "SETHours": "175",
    "spClassTeachingPosts": "2",
    "mainSNA": "4.66",
    "spSNA": "4.49",
    "totalSNA": "9.15",
    "eircode": "D09YR59",
    "addressOne": "Larkhill Road",
    "addressTwo": "Whitehall",
    "addressThree": "Dublin 9",
    "addressFour": "",
    "lat": "53.3859343",
    "lng": "-6.2451174",
    "phone": "18375870",
    "email": "office@holychildns.ie"
  },
  {
    "i": "1154",
    "county": "Dublin",
    "rollNumber": "20348F",
    "schoolName": "Holywell Educate Together NS",
    "SETHours": "287.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "15.98",
    "spSNA": "9",
    "totalSNA": "24.98",
    "eircode": "K67AP99",
    "addressOne": "Holywell Road",
    "addressTwo": "Nevinstown",
    "addressThree": "Swords",
    "addressFour": "Co. Dublin",
    "lat": "53.4446269",
    "lng": "-6.2085028",
    "phone": "14444386",
    "email": "principal@holywelletns.ie"
  },
  {
    "i": "1155",
    "county": "Dublin",
    "rollNumber": "20383H",
    "schoolName": "Hansfield Educate Together NS",
    "SETHours": "172.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "4.33",
    "spSNA": "4.5",
    "totalSNA": "8.83",
    "eircode": "D15H1FC",
    "addressOne": "Barnwell Road",
    "addressTwo": "Hansfield",
    "addressThree": "Dublin 15",
    "addressFour": "",
    "lat": "53.3916979",
    "lng": "-6.4450797",
    "phone": "18614720",
    "email": "fergalcollinsprincipal@gmail.com"
  },
  {
    "i": "1156",
    "county": "Dublin",
    "rollNumber": "20384J",
    "schoolName": "Powerstown Educate Together NS",
    "SETHours": "140",
    "spClassTeachingPosts": "3",
    "mainSNA": "6.66",
    "spSNA": "6.5",
    "totalSNA": "13.16",
    "eircode": "D15VR80",
    "addressOne": "Powerstown Road",
    "addressTwo": "Tyrrelstown",
    "addressThree": "Dublin 15",
    "addressFour": "",
    "lat": "53.4146934",
    "lng": "-6.3923284",
    "phone": "18272018",
    "email": "info@powerstownet.com"
  },
  {
    "i": "1157",
    "county": "Dublin",
    "rollNumber": "20392I",
    "schoolName": "Pelletstown Etns",
    "SETHours": "127.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.66",
    "spSNA": "0",
    "totalSNA": "3.66",
    "eircode": "D15W571",
    "addressOne": "Ashtown Road,",
    "addressTwo": "Rathborne",
    "addressThree": "Dublin 15",
    "addressFour": "",
    "lat": "53.3772931",
    "lng": "-6.3313729",
    "phone": "874483613",
    "email": "pelletstownetns@gmail.com"
  },
  {
    "i": "1158",
    "county": "Dublin",
    "rollNumber": "20394M",
    "schoolName": "Gaelscoil An Chuilinn",
    "SETHours": "125",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.33",
    "spSNA": "0",
    "totalSNA": "3.33",
    "eircode": "D15WR86",
    "addressOne": "Bóthar Bhaile An Phaoraigh",
    "addressTwo": "Baile An Tirialaigh",
    "addressThree": "Baile átha Cliath 15",
    "addressFour": "",
    "lat": "53.4146543",
    "lng": "-6.3902703",
    "phone": "18262022",
    "email": "runai@gsch.ie"
  },
  {
    "i": "1159",
    "county": "Dublin",
    "rollNumber": "20397S",
    "schoolName": "St Louise De Marillac Primary School",
    "SETHours": "187.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "7.83",
    "spSNA": "0",
    "totalSNA": "7.83",
    "eircode": "D10KT99",
    "addressOne": "Drumfinn Road",
    "addressTwo": "Ballyfermot",
    "addressThree": "Dublin 10",
    "addressFour": "",
    "lat": "53.3481891",
    "lng": "-6.3595592",
    "phone": "16234153",
    "email": "admin@stlouises.scoilnet.ie"
  },
  {
    "i": "1160",
    "county": "Dublin",
    "rollNumber": "20398U",
    "schoolName": "Citywest & Saggart Community NS",
    "SETHours": "192.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "5.66",
    "spSNA": "3.49",
    "totalSNA": "9.15",
    "eircode": "D24R920",
    "addressOne": "Fortunestown Lane",
    "addressTwo": "Citywest",
    "addressThree": "Dublin 24",
    "addressFour": "",
    "lat": "53.2836617",
    "lng": "-6.4381392",
    "phone": "14133080",
    "email": "cscns@ddletb.ie"
  },
  {
    "i": "1161",
    "county": "Dublin",
    "rollNumber": "20400E",
    "schoolName": "Ballinteer Educate Together NS",
    "SETHours": "107.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.83",
    "spSNA": "0",
    "totalSNA": "4.83",
    "eircode": "D14Y563",
    "addressOne": "Notre Dame Campus",
    "addressTwo": "Upper Churchtown Road",
    "addressThree": "Churchtown",
    "addressFour": "Dublin 14",
    "lat": "53.2936636",
    "lng": "-6.2513957",
    "phone": "12963017",
    "email": "info@ballinteeretns.ie"
  },
  {
    "i": "1162",
    "county": "Dublin",
    "rollNumber": "20401G",
    "schoolName": "Stepaside Educate Together NS",
    "SETHours": "147.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "3.66",
    "spSNA": "4.5",
    "totalSNA": "8.16",
    "eircode": "D18H7W6",
    "addressOne": "Belarmine Vale",
    "addressTwo": "Stepaside",
    "addressThree": "Dublin 18",
    "addressFour": "",
    "lat": "53.2599661",
    "lng": "-6.2169369",
    "phone": "12946753",
    "email": "info@stepasideetns.ie"
  },
  {
    "i": "1163",
    "county": "Dublin",
    "rollNumber": "20402I",
    "schoolName": "City West Educate Together NS",
    "SETHours": "175",
    "spClassTeachingPosts": "2",
    "mainSNA": "6.49",
    "spSNA": "4.16",
    "totalSNA": "10.65",
    "eircode": "D24TR94",
    "addressOne": "Fortunestown Lane",
    "addressTwo": "Citywest",
    "addressThree": "Dublin 24",
    "addressFour": "",
    "lat": "53.2836822",
    "lng": "-6.4374689",
    "phone": "14035906",
    "email": "Info@citywestetns.ie"
  },
  {
    "i": "1164",
    "county": "Dublin",
    "rollNumber": "20411J",
    "schoolName": "Firhouse Educate Together NS",
    "SETHours": "165",
    "spClassTeachingPosts": "2",
    "mainSNA": "6.32",
    "spSNA": "5",
    "totalSNA": "11.32",
    "eircode": "D24FW9Y",
    "addressOne": "Ballycullen Drive",
    "addressTwo": "Firhouse",
    "addressThree": "Dublin 24",
    "addressFour": "",
    "lat": "53.2765977",
    "lng": "-6.3380799",
    "phone": "14061010",
    "email": "info@firhouseetns.ie"
  },
  {
    "i": "1165",
    "county": "Dublin",
    "rollNumber": "20412L",
    "schoolName": "Gaelscoil Na Giúise",
    "SETHours": "85",
    "spClassTeachingPosts": "1",
    "mainSNA": "1",
    "spSNA": "1.66",
    "totalSNA": "2.66",
    "eircode": "D24W682",
    "addressOne": "Céide Bhaile Í­ Chuilinn",
    "addressTwo": "Teach Na Giúise",
    "addressThree": "Baile átha Cliath",
    "addressFour": "D24 W682",
    "lat": "53.2766039",
    "lng": "-6.3405072",
    "phone": "14954064",
    "email": "oifig@gaelscoilnagiuise.ie"
  },
  {
    "i": "1166",
    "county": "Dublin",
    "rollNumber": "20422O",
    "schoolName": "Scoil Aoife CNS",
    "SETHours": "197.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "3.66",
    "spSNA": "5",
    "totalSNA": "8.66",
    "eircode": "D24EE3V",
    "addressOne": "Citywest Drive",
    "addressTwo": "Citywest",
    "addressThree": "Dublin 24",
    "addressFour": "",
    "lat": "53.2849551",
    "lng": "-6.417928",
    "phone": "14215104",
    "email": "tinacurran@sacns.ie"
  },
  {
    "i": "1167",
    "county": "Dublin",
    "rollNumber": "20425U",
    "schoolName": "Gaelscoil Shliabh Rua",
    "SETHours": "115",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.66",
    "spSNA": "0",
    "totalSNA": "2.66",
    "eircode": "D18K0EN",
    "addressOne": "Bóthar Bhaile Í­ ógáin",
    "addressTwo": "Bác 18",
    "addressThree": "Baile átha Cliath 18",
    "addressFour": "",
    "lat": "53.2562931",
    "lng": "-6.1882033",
    "phone": "12958589",
    "email": "oifig@gsr.ie"
  },
  {
    "i": "1168",
    "county": "Dublin",
    "rollNumber": "20426W",
    "schoolName": "Lucan Community NS",
    "SETHours": "150",
    "spClassTeachingPosts": "2",
    "mainSNA": "2.66",
    "spSNA": "5",
    "totalSNA": "7.66",
    "eircode": "K78TF76",
    "addressOne": "Balgaddy Road",
    "addressTwo": "Lucan",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.340267",
    "lng": "-6.4201484",
    "phone": "14570432",
    "email": "info@lucancns.ie"
  },
  {
    "i": "1169",
    "county": "Dublin",
    "rollNumber": "20429F",
    "schoolName": "St. James's Primary School",
    "SETHours": "235",
    "spClassTeachingPosts": "1",
    "mainSNA": "8",
    "spSNA": "2",
    "totalSNA": "10",
    "eircode": "D08EC96",
    "addressOne": "Basin Lane",
    "addressTwo": "James' Street",
    "addressThree": "Dublin 8",
    "addressFour": "",
    "lat": "53.3403895",
    "lng": "-6.2901689",
    "phone": "14548461",
    "email": "saintjamessps@gmail.com"
  },
  {
    "i": "1170",
    "county": "Dublin",
    "rollNumber": "20430N",
    "schoolName": "Canal Way Educate Together NS",
    "SETHours": "115",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "D08K338",
    "addressOne": "Basin Street Upper",
    "addressTwo": "Dublin 8",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3403638",
    "lng": "-6.2894442",
    "phone": "14021418",
    "email": "office@canalwayetns.org"
  },
  {
    "i": "1171",
    "county": "Dublin",
    "rollNumber": "20436C",
    "schoolName": "St Mary's Primary School",
    "SETHours": "140",
    "spClassTeachingPosts": "1",
    "mainSNA": "4.83",
    "spSNA": "2",
    "totalSNA": "6.83",
    "eircode": "D07HF10",
    "addressOne": "Dorset Street Upper",
    "addressTwo": "Dublin 7",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3548071",
    "lng": "-6.2672886",
    "phone": "18300841",
    "email": "office@stmarysprimaryschool.ie"
  },
  {
    "i": "1172",
    "county": "Dublin",
    "rollNumber": "20437E",
    "schoolName": "St Laurence's NS",
    "SETHours": "157.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.24",
    "spSNA": "0",
    "totalSNA": "5.24",
    "eircode": "D13C924",
    "addressOne": "Brookstone Road",
    "addressTwo": "Baldoyle",
    "addressThree": "Dublin 13",
    "addressFour": "",
    "lat": "53.3964267",
    "lng": "-6.1328832",
    "phone": "18326782",
    "email": "info@stlaurencesbaldoyle.org"
  },
  {
    "i": "1173",
    "county": "Dublin",
    "rollNumber": "20441S",
    "schoolName": "Shellybanks Educate Together NS",
    "SETHours": "80",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "D04F8P5",
    "addressOne": "Roslyn Park",
    "addressTwo": "Seafort Avenue",
    "addressThree": "Sandymount",
    "addressFour": "Dublin 4",
    "lat": "53.3328982",
    "lng": "-6.213878",
    "phone": "879667892",
    "email": "info@shellybanksetns.ie"
  },
  {
    "i": "1174",
    "county": "Dublin",
    "rollNumber": "20445D",
    "schoolName": "Malahide / Portmarnock Educate Together NS",
    "SETHours": "132.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.83",
    "spSNA": "0",
    "totalSNA": "4.83",
    "eircode": "D17DR97",
    "addressOne": "Malahide Road",
    "addressTwo": "Dublin 17",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.4223683",
    "lng": "-6.175781",
    "phone": "18455956",
    "email": "info@mpetns.ie"
  },
  {
    "i": "1175",
    "county": "Dublin",
    "rollNumber": "20450T",
    "schoolName": "Assumption Jn School",
    "SETHours": "177.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "6.32",
    "spSNA": "4.66",
    "totalSNA": "10.98",
    "eircode": "D12EH70",
    "addressOne": "Sisters Of Charity",
    "addressTwo": "Walkinstown",
    "addressThree": "Dublin 12",
    "addressFour": "",
    "lat": "53.3228994",
    "lng": "-6.3321159",
    "phone": "14507613",
    "email": "principal@assumptionjns.com"
  },
  {
    "i": "1176",
    "county": "Dublin",
    "rollNumber": "20453C",
    "schoolName": "Broombridge Educate Together NS",
    "SETHours": "147.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "2.83",
    "spSNA": "2.66",
    "totalSNA": "5.49",
    "eircode": "D07TD93",
    "addressOne": "Bannow Road",
    "addressTwo": "Cabra",
    "addressThree": "Dublin 7",
    "addressFour": "",
    "lat": "53.3708109",
    "lng": "-6.2939088",
    "phone": "18682650",
    "email": "broombridgeetns@gmail.com"
  },
  {
    "i": "1177",
    "county": "Dublin",
    "rollNumber": "20463F",
    "schoolName": "Holy Spirit Jn Primary School",
    "SETHours": "127.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "6.99",
    "spSNA": "0",
    "totalSNA": "6.99",
    "eircode": "D12V880",
    "addressOne": "Limekiln Lane",
    "addressTwo": "Greenhills",
    "addressThree": "Dublin 12",
    "addressFour": "",
    "lat": "53.3088594",
    "lng": "-6.3283935",
    "phone": "14569173",
    "email": "holyspiritjps@gmail.com"
  },
  {
    "i": "1178",
    "county": "Dublin",
    "rollNumber": "20464H",
    "schoolName": "Holy Spirit Sn Primary School",
    "SETHours": "150",
    "spClassTeachingPosts": "2",
    "mainSNA": "8",
    "spSNA": "4",
    "totalSNA": "12",
    "eircode": "D12AY63",
    "addressOne": "Limekiln Lane",
    "addressTwo": "Greenhills",
    "addressThree": "Dublin 12",
    "addressFour": "",
    "lat": "53.3086004",
    "lng": "-6.3292991",
    "phone": "14506019",
    "email": "principalholyspiritgreenhills@gmail.com"
  },
  {
    "i": "1179",
    "county": "Dublin",
    "rollNumber": "20468P",
    "schoolName": "St Dominic's NS",
    "SETHours": "192.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "9.83",
    "spSNA": "0",
    "totalSNA": "9.83",
    "eircode": "D24P7XC",
    "addressOne": "Mountain Park",
    "addressTwo": "Tallaght",
    "addressThree": "Dublin 24",
    "addressFour": "",
    "lat": "53.2859462",
    "lng": "-6.357417",
    "phone": "14512443",
    "email": "secretary@stdominicsns.ie"
  },
  {
    "i": "1180",
    "county": "Dublin",
    "rollNumber": "20486R",
    "schoolName": "Grace Park Educate Together NS",
    "SETHours": "113.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.33",
    "spSNA": "0",
    "totalSNA": "3.33",
    "eircode": "D09KDW4",
    "addressOne": "Dcu All Hallows Campus",
    "addressTwo": "Grace Park Road",
    "addressThree": "Drumcondra",
    "addressFour": "Dublin 9",
    "lat": "53.3723499",
    "lng": "-6.2469282",
    "phone": "851368422",
    "email": "info@graceparketns.com"
  },
  {
    "i": "1181",
    "county": "Dublin",
    "rollNumber": "20487T",
    "schoolName": "Gaelscoil Na Fuinseoige",
    "SETHours": "93.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "1",
    "spSNA": "2.5",
    "totalSNA": "3.5",
    "eircode": "D14N960",
    "addressOne": "Páirc Finsbury",
    "addressTwo": "Baile An Teampaill",
    "addressThree": "Bác 14",
    "addressFour": "",
    "lat": "53.2933357",
    "lng": "-6.2523718",
    "phone": "12989851",
    "email": "oifig@gsnafuinseoige.ie"
  },
  {
    "i": "1182",
    "county": "Dublin",
    "rollNumber": "20488V",
    "schoolName": "Scoil úna Naofa",
    "SETHours": "235",
    "spClassTeachingPosts": "0",
    "mainSNA": "9",
    "spSNA": "0",
    "totalSNA": "9",
    "eircode": "D12W524",
    "addressOne": "Armagh Road",
    "addressTwo": "Crumlin",
    "addressThree": "Dublin 12",
    "addressFour": "",
    "lat": "53.3206231",
    "lng": "-6.3074649",
    "phone": "14555127",
    "email": "scoilunanaofa@gmail.com"
  },
  {
    "i": "1183",
    "county": "Dublin",
    "rollNumber": "20494Q",
    "schoolName": "Riverview Educate Together NS",
    "SETHours": "61",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.16",
    "spSNA": "0",
    "totalSNA": "4.16",
    "eircode": "D12VY8A",
    "addressOne": "Limekiln Road",
    "addressTwo": "Greenhills",
    "addressThree": "Dublin 12",
    "addressFour": "",
    "lat": "53.3050563",
    "lng": "-6.3283937",
    "phone": "14604468",
    "email": "rvetns@gmail.com"
  },
  {
    "i": "1184",
    "county": "Dublin",
    "rollNumber": "20501K",
    "schoolName": "Harcourt Terrace Educate Together NS",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.66",
    "spSNA": "0",
    "totalSNA": "1.66",
    "eircode": "D6WHP44",
    "addressOne": "151-153 Harold's Cross Road",
    "addressTwo": "Harold's Cross",
    "addressThree": "Dublin 6w",
    "addressFour": "",
    "lat": "53.3236468",
    "lng": "-6.2776649",
    "phone": "867768394",
    "email": "info@harcourtterrace.com"
  },
  {
    "i": "1185",
    "county": "Dublin",
    "rollNumber": "20507W",
    "schoolName": "St Laurence O'toole's NS",
    "SETHours": "135",
    "spClassTeachingPosts": "0",
    "mainSNA": "7.66",
    "spSNA": "0",
    "totalSNA": "7.66",
    "eircode": "",
    "addressOne": "St. Laurence Place East,",
    "addressTwo": "Seville Place,",
    "addressThree": "Dublin 1",
    "addressFour": "",
    "lat": "53.3520088",
    "lng": "-6.244662",
    "phone": "18364577",
    "email": "office@stlaurenceotoolesns.ie"
  },
  {
    "i": "1186",
    "county": "Dublin",
    "rollNumber": "20509D",
    "schoolName": "Lusk Jn NS St Maccullins",
    "SETHours": "155",
    "spClassTeachingPosts": "0",
    "mainSNA": "9.15",
    "spSNA": "0",
    "totalSNA": "9.15",
    "eircode": "",
    "addressOne": "Chapel Road",
    "addressTwo": "Lusk",
    "addressThree": "Co. Dublin",
    "addressFour": "",
    "lat": "53.5296801",
    "lng": "-6.1707035",
    "phone": "18709242",
    "email": "office@luskjns.ie"
  },
  {
    "i": "1187",
    "county": "Dublin",
    "rollNumber": "20517C",
    "schoolName": "Drumcondra Marino Dublin 1 Gaelscoil",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "D09XP65",
    "addressOne": "Bóthar Naomh Mobhí­,",
    "addressTwo": "Droim Conrach,",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3730795",
    "lng": "-6.2636596",
    "phone": "18377941",
    "email": "gaelscoilaine@gmail.com"
  },
  {
    "i": "1188",
    "county": "Dublin",
    "rollNumber": "20518E",
    "schoolName": "Gaelscoil Laighean",
    "SETHours": "23",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "A94FC44",
    "addressOne": "Lána Na Cille",
    "addressTwo": "Cill Na Gráinsí­",
    "addressThree": "An Charraig Dhubh",
    "addressFour": "Co. Bhaile átha Cliath",
    "lat": "53.2794868",
    "lng": "-6.1625079",
    "phone": "858036710",
    "email": "gslaighean@gmail.com"
  },
  {
    "i": "1189",
    "county": "Dublin",
    "rollNumber": "20519G",
    "schoolName": "Stapolin Educate Together NS",
    "SETHours": "110",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "D13NX25",
    "addressOne": "Grange Abbey Road",
    "addressTwo": "Donaghmede",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.4004797",
    "lng": "-6.1570583",
    "phone": "868374715",
    "email": "d13etns@gmail.com"
  },
  {
    "i": "1190",
    "county": "Dublin",
    "rollNumber": "20520O",
    "schoolName": "Dublin 6 Clonskeagh And Dublin 6w Primary School",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "D6WHP44",
    "addressOne": "151/153 Harold's Cross Road",
    "addressTwo": "Dublin 6w",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3236468",
    "lng": "-6.2776649",
    "phone": "863471806",
    "email": "principal.haroldscrossetns@gmail.com"
  },
  {
    "i": "1191",
    "county": "Dublin",
    "rollNumber": "20523U",
    "schoolName": "Goatstown Stillorgan Primary School",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "D18P274",
    "addressOne": "Grafton House",
    "addressTwo": "Ballymoss Road",
    "addressThree": "Sandyford Industrial Estate",
    "addressFour": "D. 18",
    "lat": "53.2784028",
    "lng": "-6.2113282",
    "phone": "873878592",
    "email": "info@goatstownstillorganetns.com"
  },
  {
    "i": "1192",
    "county": "Dublin",
    "rollNumber": "20525B",
    "schoolName": "Killester Raheny Clontarf Educate Together NS",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.66",
    "spSNA": "0",
    "totalSNA": "1.66",
    "eircode": "D13C3K8",
    "addressOne": "Killester Raheny Clontarf Etns",
    "addressTwo": "C/o Suttonians Rfc",
    "addressThree": "Station Road",
    "addressFour": "Dublin 13",
    "lat": "53.3908101",
    "lng": "-6.1131553",
    "phone": "868550965",
    "email": "info.krcetns@gmail.com"
  },
  {
    "i": "1193",
    "county": "Dublin",
    "rollNumber": "20528H",
    "schoolName": "River Valley CNS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "",
    "addressOne": "Swords South",
    "addressTwo": "Dublin",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.4551838",
    "lng": "-6.2221519",
    "phone": "858705523",
    "email": "info@rivervalleycns.ie"
  },
  {
    "i": "1194",
    "county": "Dublin",
    "rollNumber": "20530R",
    "schoolName": "Gaelscoil Na Mara (donabate)",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "",
    "addressOne": "",
    "addressTwo": "",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.4895301",
    "lng": "-6.1492025",
    "phone": "",
    "email": ""
  },
  {
    "i": "1195",
    "county": "Dublin",
    "rollNumber": "20531T",
    "schoolName": "Gaelscoil Lir (saggart)",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "",
    "addressOne": "",
    "addressTwo": "",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.2837299",
    "lng": "-6.4408063",
    "phone": "",
    "email": ""
  },
  {
    "i": "1196",
    "county": "Dublin",
    "rollNumber": "20535E",
    "schoolName": "Cherrywood Etns",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "",
    "addressOne": "",
    "addressTwo": "",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.2453092",
    "lng": "-6.1570383",
    "phone": "",
    "email": ""
  },
  {
    "i": "1197",
    "county": "Dublin",
    "rollNumber": "20545H",
    "schoolName": "St Christopher's Ns",
    "SETHours": "182.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "D04FP20",
    "addressOne": "Haddington Road",
    "addressTwo": "Ballsbridge",
    "addressThree": "Dublin 4",
    "addressFour": "",
    "lat": "53.3350796",
    "lng": "-6.2402099",
    "phone": "16681155",
    "email": "principal@scps.ie"
  },
  {
    "i": "1198",
    "county": "Dublin",
    "rollNumber": "20549P",
    "schoolName": "Rathcoole Etns",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "D24ER80",
    "addressOne": "Fortunestown",
    "addressTwo": "Co. Dublin",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.28427878751174",
    "lng": "-6.436767486517267",
    "phone": "",
    "email": ""
  },
  {
    "i": "1200",
    "county": "Dublin",
    "rollNumber": "20502M",
    "schoolName": "Scoil Sinead Ns",
    "SETHours": "35",
    "spClassTeachingPosts": "3",
    "mainSNA": "2",
    "spSNA": "6.32",
    "totalSNA": "8.32",
    "eircode": "D11HN88",
    "addressOne": "Scoil Sinead Pelletstown",
    "addressTwo": "Patrician College Campus,",
    "addressThree": "Deanstown,",
    "addressFour": "Finglas,",
    "lat": "53.3840963",
    "lng": "-6.3180084",
    "phone": "861453205",
    "email": "principal@scoilsinead.ie"
  },
  {
    "i": "1201",
    "county": "Dublin",
    "rollNumber": "20503O",
    "schoolName": "Dun Laoghaire Etns",
    "SETHours": "65",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "A94D3H7",
    "addressOne": "C/o The Red Door School",
    "addressTwo": "Monkstown Grove",
    "addressThree": "Monkstown Avenue",
    "addressFour": "Co. Dublin",
    "lat": "53.2872644",
    "lng": "-6.1549672",
    "phone": "864667017",
    "email": "principal.dunlaoghaireetns@gmail.com"
  },
  {
    "i": "1202",
    "county": "Galway",
    "rollNumber": "01000E",
    "schoolName": "Esker NS",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "H65HY10",
    "addressOne": "Esker",
    "addressTwo": "Athenry",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.2785333",
    "lng": "-8.6817025",
    "phone": "91848008",
    "email": "eskerschool@gmail.com"
  },
  {
    "i": "1203",
    "county": "Galway",
    "rollNumber": "01013N",
    "schoolName": "Scoil Croi Iosa",
    "SETHours": "100",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.5",
    "spSNA": "0",
    "totalSNA": "3.5",
    "eircode": "H91FV48",
    "addressOne": "Newcastle Road",
    "addressTwo": "Galway",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.2742056",
    "lng": "-9.0624895",
    "phone": "91525904",
    "email": "scoilchroiiosa@gmail.com"
  },
  {
    "i": "1204",
    "county": "Galway",
    "rollNumber": "01328P",
    "schoolName": "Kiltormer NS",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H53AH28",
    "addressOne": "Kiltormer",
    "addressTwo": "Ballinasloe",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.2356845",
    "lng": "-8.2742532",
    "phone": "909627109",
    "email": "kiltormernsgalway@gmail.com"
  },
  {
    "i": "1205",
    "county": "Galway",
    "rollNumber": "03607G",
    "schoolName": "SN Aindreis Naofa",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "H62KN83",
    "addressOne": "Leitrim",
    "addressTwo": "Kylebrack East",
    "addressThree": "Loughrea",
    "addressFour": "Co. Galway",
    "lat": "53.1598781",
    "lng": "-8.485628",
    "phone": "91847470",
    "email": "leitrimschool@gmail.com"
  },
  {
    "i": "1206",
    "county": "Galway",
    "rollNumber": "04506F",
    "schoolName": "Scoil Na Ngasur",
    "SETHours": "150",
    "spClassTeachingPosts": "2",
    "mainSNA": "3",
    "spSNA": "2.5",
    "totalSNA": "5.5",
    "eircode": "H91Y763",
    "addressOne": "Maree Road",
    "addressTwo": "Oranmore",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.2642299",
    "lng": "-8.9312734",
    "phone": "91790312",
    "email": "info@oranmoreboysns.ie"
  },
  {
    "i": "1207",
    "county": "Galway",
    "rollNumber": "04515G",
    "schoolName": "Scoil An Linbh Iosa",
    "SETHours": "142.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "6.74",
    "spSNA": "0",
    "totalSNA": "6.74",
    "eircode": "H91RX32",
    "addressOne": "St Francis Street",
    "addressTwo": "Galway",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.2757127",
    "lng": "-9.0537972",
    "phone": "91566452",
    "email": "info@mercyprimary.ie"
  },
  {
    "i": "1208",
    "county": "Galway",
    "rollNumber": "05754G",
    "schoolName": "SN Creachmhaoil",
    "SETHours": "152.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "7.83",
    "spSNA": "0",
    "totalSNA": "7.83",
    "eircode": "H91P218",
    "addressOne": "Crinnage",
    "addressTwo": "Craughwell",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.2364658",
    "lng": "-8.7503641",
    "phone": "91846246",
    "email": "office@craughwellns.ie"
  },
  {
    "i": "1209",
    "county": "Galway",
    "rollNumber": "06044D",
    "schoolName": "SN Cill Cuile",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H62YY62",
    "addressOne": "Kilcooley",
    "addressTwo": "Loughrea",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.2009746",
    "lng": "-8.4566564",
    "phone": "91843292",
    "email": "kilcooleyns.ias@eircom.net"
  },
  {
    "i": "1210",
    "county": "Galway",
    "rollNumber": "06489S",
    "schoolName": "SN An Tsaileain",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "H54DA29",
    "addressOne": "Sylane",
    "addressTwo": "Tuam",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.5249713",
    "lng": "-8.939374",
    "phone": "9355540",
    "email": "office@sylanens.ie"
  },
  {
    "i": "1211",
    "county": "Galway",
    "rollNumber": "07455G",
    "schoolName": "Scoil Mhuire Gan Smal",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "F42AD83",
    "addressOne": "Ballygar",
    "addressTwo": "Co. Roscommon",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.5217221",
    "lng": "-8.3270475",
    "phone": "906624951",
    "email": "ballygarns@gmail.com"
  },
  {
    "i": "1212",
    "county": "Galway",
    "rollNumber": "07551C",
    "schoolName": "Ballinderreen Mxd NS",
    "SETHours": "77.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.58",
    "spSNA": "0",
    "totalSNA": "1.58",
    "eircode": "H91F292",
    "addressOne": "Ballinderreen",
    "addressTwo": "Kilcolgan",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.1850334",
    "lng": "-8.9098939",
    "phone": "91796632",
    "email": "info@ballinderreenns.ie"
  },
  {
    "i": "1213",
    "county": "Galway",
    "rollNumber": "08379V",
    "schoolName": "Gortanumera NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "H53PW70",
    "addressOne": "Ballyshrule",
    "addressTwo": "Ballinasloe",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.1124732",
    "lng": "-8.2875077",
    "phone": "909741624",
    "email": "scoilmhuiregortanumera@gmail.com"
  },
  {
    "i": "1214",
    "county": "Galway",
    "rollNumber": "08446K",
    "schoolName": "Sn Tullach Ui Chadhain",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H91WD98",
    "addressOne": "Tulach Í­ Chadhain",
    "addressTwo": "Maigh Cuilinn",
    "addressThree": "Co. Na Gaillimhe",
    "addressFour": "",
    "lat": "53.3799786",
    "lng": "-9.1523655",
    "phone": "91555601",
    "email": "scoilnaomhbride@gmail.com"
  },
  {
    "i": "1215",
    "county": "Galway",
    "rollNumber": "08512U",
    "schoolName": "Iomair NS",
    "SETHours": "75",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H53DP95",
    "addressOne": "Killimor",
    "addressTwo": "Ballinasloe",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.1674958",
    "lng": "-8.296673",
    "phone": "909676428",
    "email": "killimorns@yahoo.ie"
  },
  {
    "i": "1216",
    "county": "Galway",
    "rollNumber": "09069L",
    "schoolName": "SN An Bhain Mhoir",
    "SETHours": "67.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "1.5",
    "spSNA": "2",
    "totalSNA": "3.5",
    "eircode": "H91WY22",
    "addressOne": "Cloghaun",
    "addressTwo": "Claregalway",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.3763789",
    "lng": "-8.942368",
    "phone": "91798600",
    "email": "info@bawnmorens.ie"
  },
  {
    "i": "1217",
    "county": "Galway",
    "rollNumber": "09833W",
    "schoolName": "SN Leitirgeis",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "H91K2H9",
    "addressOne": "Lettergesh West",
    "addressTwo": "Renvyle",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.598585",
    "lng": "-9.9127867",
    "phone": "9543900",
    "email": "office@lettergeshns.ie"
  },
  {
    "i": "1218",
    "county": "Galway",
    "rollNumber": "10095T",
    "schoolName": "SN Naomh Treasa",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H53DP11",
    "addressOne": "Killure",
    "addressTwo": "Ahascragh",
    "addressThree": "Ballinasloe",
    "addressFour": "Co. Galway",
    "lat": "53.361522",
    "lng": "-8.309771",
    "phone": "909688094",
    "email": "tobareolais@gmail.com"
  },
  {
    "i": "1219",
    "county": "Galway",
    "rollNumber": "10591I",
    "schoolName": "SN An Ard Mhoir",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "H91D8X3",
    "addressOne": "Aird Mhoir",
    "addressTwo": "Cill Chiarain",
    "addressThree": "Co. Na Gaillimhe",
    "addressFour": "",
    "lat": "53.3053423",
    "lng": "-9.7747036",
    "phone": "9533602",
    "email": "ardmor@gmail.com"
  },
  {
    "i": "1220",
    "county": "Galway",
    "rollNumber": "10675O",
    "schoolName": "Ballymana NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H91A3P1",
    "addressOne": "Ballymana",
    "addressTwo": "Craughwell",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.1987418",
    "lng": "-8.7108908",
    "phone": "91846361",
    "email": "info@ballymanans.ie"
  },
  {
    "i": "1221",
    "county": "Galway",
    "rollNumber": "10863P",
    "schoolName": "SN Na Coille Glaise",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "H53PC94",
    "addressOne": "Kilglass",
    "addressTwo": "Ahascragh",
    "addressThree": "Ballinasloe",
    "addressFour": "Co. Galway",
    "lat": "53.4138684",
    "lng": "-8.3492216",
    "phone": "909688881",
    "email": "kilglass@hotmail.com"
  },
  {
    "i": "1223",
    "county": "Galway",
    "rollNumber": "11290W",
    "schoolName": "SN Muire Gan Smal",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.25",
    "spSNA": "0",
    "totalSNA": "1.25",
    "eircode": "H91EH90",
    "addressOne": "Camus",
    "addressTwo": "Co. Na Gaillimhe",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3775567",
    "lng": "-9.5468621",
    "phone": "91574366",
    "email": "eala07@gmail.com"
  },
  {
    "i": "1224",
    "county": "Galway",
    "rollNumber": "11373D",
    "schoolName": "SN Mhuire",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H91YT26",
    "addressOne": "Turlach Beag",
    "addressTwo": "Rosmuc",
    "addressThree": "Co. Na Gaillimhe",
    "addressFour": "",
    "lat": "53.3477585",
    "lng": "-9.6194296",
    "phone": "91574312",
    "email": "snturlachbeag@gmail.com"
  },
  {
    "i": "1225",
    "county": "Galway",
    "rollNumber": "11669B",
    "schoolName": "SN Naomh Brid",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "H91R996",
    "addressOne": "Cloonluane",
    "addressTwo": "Renvyle",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.6037969",
    "lng": "-1087981",
    "phone": "9543642",
    "email": "eaglesnestns@gmail.com"
  },
  {
    "i": "1226",
    "county": "Galway",
    "rollNumber": "12095G",
    "schoolName": "SN Naomh Antoine",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "H71KF38",
    "addressOne": "Kill",
    "addressTwo": "Kingstown",
    "addressThree": "Clifden",
    "addressFour": "Co. Galway",
    "lat": "53.5100152",
    "lng": "-10.0926431",
    "phone": "9522124",
    "email": "kingstownns@gmail.com"
  },
  {
    "i": "1227",
    "county": "Galway",
    "rollNumber": "12106I",
    "schoolName": "SN Naomh Padraig",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F12W142",
    "addressOne": "An Chloc Breac",
    "addressTwo": "An Fhairche",
    "addressThree": "Co. Na Gaillimhe",
    "addressFour": "",
    "lat": "53.5592471",
    "lng": "-9.4422642",
    "phone": "949548278",
    "email": "clochbhreac@ymail.com"
  },
  {
    "i": "1228",
    "county": "Galway",
    "rollNumber": "12138V",
    "schoolName": "SN Ceathru Na Laithigh",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "H54KA44",
    "addressOne": "Brownsgrove",
    "addressTwo": "Tuam",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.5661312",
    "lng": "-8.7923745",
    "phone": "9324521",
    "email": "ceathrunalaithigh@gmail.com"
  },
  {
    "i": "1229",
    "county": "Galway",
    "rollNumber": "12339I",
    "schoolName": "SN Inis Meadhoin",
    "SETHours": "7.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H91P892",
    "addressOne": "Inis Meáin",
    "addressTwo": "Oileann árainn",
    "addressThree": "Co. Na Gaillimhe",
    "addressFour": "",
    "lat": "53.086835",
    "lng": "-9.5888147",
    "phone": "9973064",
    "email": "sninismeain1887@gmail.com"
  },
  {
    "i": "1230",
    "county": "Galway",
    "rollNumber": "12502Q",
    "schoolName": "SN Eanna",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H91N206",
    "addressOne": "Roundstone",
    "addressTwo": "Co. Galway",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.392755",
    "lng": "-9.9169824",
    "phone": "9535072",
    "email": "scoileannacloch1@gmail.com"
  },
  {
    "i": "1231",
    "county": "Galway",
    "rollNumber": "12574S",
    "schoolName": "Lurga NS",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H91A034",
    "addressOne": "Lurga",
    "addressTwo": "Gort",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.0123833",
    "lng": "-8.8671225",
    "phone": "91633118",
    "email": "lurgaschool@gmail.com"
  },
  {
    "i": "1232",
    "county": "Galway",
    "rollNumber": "12606F",
    "schoolName": "Crumlin NS",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H54VY03",
    "addressOne": "Crumlin",
    "addressTwo": "Ballyglunin",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.3968276",
    "lng": "-8.789544",
    "phone": "91797128",
    "email": "crumlinns@gmail.com"
  },
  {
    "i": "1233",
    "county": "Galway",
    "rollNumber": "12706J",
    "schoolName": "Sn Sailearna",
    "SETHours": "122.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "H91PW35",
    "addressOne": "Indreabhán",
    "addressTwo": "Co. Na Gaillimhe",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.24587",
    "lng": "-9.3823272",
    "phone": "91593321",
    "email": "eolas@scoilsailearna.ie"
  },
  {
    "i": "1234",
    "county": "Galway",
    "rollNumber": "12782C",
    "schoolName": "Bunscoil Naomh Chuana",
    "SETHours": "87.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "3",
    "spSNA": "5",
    "totalSNA": "8",
    "eircode": "H91FX95",
    "addressOne": "Kilcoona",
    "addressTwo": "Headford",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.4422564",
    "lng": "-9.0426606",
    "phone": "91791542",
    "email": "kilcoonans@gmail.com"
  },
  {
    "i": "1235",
    "county": "Galway",
    "rollNumber": "12946G",
    "schoolName": "SN Coilm Cille",
    "SETHours": "40",
    "spClassTeachingPosts": "1",
    "mainSNA": "1.25",
    "spSNA": "2.5",
    "totalSNA": "3.75",
    "eircode": "H91CD83",
    "addressOne": "Ros A'mhí­l",
    "addressTwo": "Baile Na Habhann",
    "addressThree": "Co. Na Gaillimhe",
    "addressFour": "",
    "lat": "53.2737695",
    "lng": "-9.5404523",
    "phone": "91572039",
    "email": "scoilcholmcille@gmail.com"
  },
  {
    "i": "1236",
    "county": "Galway",
    "rollNumber": "12954F",
    "schoolName": "SN Bhride",
    "SETHours": "90",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.5",
    "spSNA": "0",
    "totalSNA": "4.5",
    "eircode": "H65FE81",
    "addressOne": "Lackagh Beg",
    "addressTwo": "Turloughmore",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.3693635",
    "lng": "-8.8885906",
    "phone": "91797474",
    "email": "lackaghschool@gmail.com"
  },
  {
    "i": "1237",
    "county": "Galway",
    "rollNumber": "13365O",
    "schoolName": "Scoil Mhuire",
    "SETHours": "167.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "5.41",
    "spSNA": "2.83",
    "totalSNA": "8.24",
    "eircode": "H91F9T8",
    "addressOne": "Castle Road",
    "addressTwo": "Oranmore",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.2673354",
    "lng": "-8.9318261",
    "phone": "91794184",
    "email": "scoilmhuireoranmore@eircom.net"
  },
  {
    "i": "1238",
    "county": "Galway",
    "rollNumber": "13415D",
    "schoolName": "Sn Tuairini",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H91YR64",
    "addressOne": "Tuairí­ní­",
    "addressTwo": "Maigh Cuilinn",
    "addressThree": "Co. Na Gaillimhe",
    "addressFour": "",
    "lat": "53.3070015",
    "lng": "-9.1530514",
    "phone": "91555650",
    "email": "scoiltuairini@gmail.com"
  },
  {
    "i": "1239",
    "county": "Galway",
    "rollNumber": "13621G",
    "schoolName": "SN Muire",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "H91H603",
    "addressOne": "Letterfrack",
    "addressTwo": "Co. Galway",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.5548346",
    "lng": "-9.9496016",
    "phone": "9541034",
    "email": "letterfrackns@yahoo.ie"
  },
  {
    "i": "1240",
    "county": "Galway",
    "rollNumber": "13665D",
    "schoolName": "SN An Cillin",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "H53DP84",
    "addressOne": "Ballyshrule",
    "addressTwo": "Portumna",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.103992",
    "lng": "-8.3175975",
    "phone": "909741884",
    "email": "info@killeenschool.com"
  },
  {
    "i": "1241",
    "county": "Galway",
    "rollNumber": "13686L",
    "schoolName": "SN Naomh Iosef",
    "SETHours": "52.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "3.83",
    "spSNA": "1",
    "totalSNA": "4.83",
    "eircode": "F31XV80",
    "addressOne": "Nymphsfield",
    "addressTwo": "Cong",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.5430463",
    "lng": "-9.2806256",
    "phone": "949546725",
    "email": "congnsmartina@gmail.com"
  },
  {
    "i": "1242",
    "county": "Galway",
    "rollNumber": "13699U",
    "schoolName": "SN Colmcille",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H91NT25",
    "addressOne": "Leitir Móir",
    "addressTwo": "Co. Na Gaillimhe",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.2890618",
    "lng": "-9.6580282",
    "phone": "91551241",
    "email": "caoimhinof@hotmail.com"
  },
  {
    "i": "1243",
    "county": "Galway",
    "rollNumber": "13821O",
    "schoolName": "SN Na Naomh Uile",
    "SETHours": "7.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H71VY19",
    "addressOne": "Knockbrack",
    "addressTwo": "Cleggan",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.5553932",
    "lng": "-10.1084623",
    "phone": "9544808",
    "email": "snnaomhuile@gmail.com"
  },
  {
    "i": "1244",
    "county": "Galway",
    "rollNumber": "13856K",
    "schoolName": "Bushy Park NS",
    "SETHours": "160",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.5",
    "spSNA": "0",
    "totalSNA": "4.5",
    "eircode": "H91AF57",
    "addressOne": "Circular Road",
    "addressTwo": "Bushy Park",
    "addressThree": "Galway",
    "addressFour": "",
    "lat": "53.2898064",
    "lng": "-9.08322",
    "phone": "91524625",
    "email": "bushyparkns@gmail.com"
  },
  {
    "i": "1245",
    "county": "Galway",
    "rollNumber": "13914V",
    "schoolName": "Scoil Naomh Iosef",
    "SETHours": "110",
    "spClassTeachingPosts": "3",
    "mainSNA": "1.33",
    "spSNA": "6",
    "totalSNA": "7.33",
    "eircode": "H91WY28",
    "addressOne": "Ráthún",
    "addressTwo": "Bearna",
    "addressThree": "Co. Na Gaillimhe",
    "addressFour": "",
    "lat": "53.2810982",
    "lng": "-9.1293559",
    "phone": "91520933",
    "email": "buailebeagns@hotmail.com"
  },
  {
    "i": "1246",
    "county": "Galway",
    "rollNumber": "13927H",
    "schoolName": "Inishbofin NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "H91KV48",
    "addressOne": "Middlequarter",
    "addressTwo": "Inishbofin",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.6161454",
    "lng": "-10.2141379",
    "phone": "9545880",
    "email": "school@inishbofin.com"
  },
  {
    "i": "1248",
    "county": "Galway",
    "rollNumber": "14031N",
    "schoolName": "Carnain NS",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.75",
    "spSNA": "0",
    "totalSNA": "2.75",
    "eircode": "H65TX86",
    "addressOne": "Carnaun",
    "addressTwo": "Athenry",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.3324731",
    "lng": "-8.7898003",
    "phone": "91844668",
    "email": "admin@carnaunns.ie"
  },
  {
    "i": "1249",
    "county": "Galway",
    "rollNumber": "14273O",
    "schoolName": "SN Padraig Naofa",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F45CH74",
    "addressOne": "Lisheen",
    "addressTwo": "Williamstown",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.6272789",
    "lng": "-8.6318015",
    "phone": "949659533",
    "email": "lisheenns@eircom.net"
  },
  {
    "i": "1250",
    "county": "Galway",
    "rollNumber": "14278B",
    "schoolName": "Scoil Naomh Padraig",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.33",
    "spSNA": "0",
    "totalSNA": "1.33",
    "eircode": "H91Y3Y4",
    "addressOne": "Knockroon",
    "addressTwo": "Headford",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.4891318",
    "lng": "-9.0819494",
    "phone": "9335137",
    "email": "knockroonns@gmail.com"
  },
  {
    "i": "1251",
    "county": "Galway",
    "rollNumber": "14294W",
    "schoolName": "Brierfield N School",
    "SETHours": "62.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "2.5",
    "spSNA": "2",
    "totalSNA": "4.5",
    "eircode": "H54DY79",
    "addressOne": "Brierfield",
    "addressTwo": "Tuam",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.4659637",
    "lng": "-8.6636547",
    "phone": "9349376",
    "email": "brierfieldnationalschool@gmail.com"
  },
  {
    "i": "1252",
    "county": "Galway",
    "rollNumber": "14377D",
    "schoolName": "SN Cill Conaill",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "H53T205",
    "addressOne": "Corraneena",
    "addressTwo": "Kilconnell",
    "addressThree": "Ballinasloe",
    "addressFour": "Co. Galway",
    "lat": "53.3311072",
    "lng": "-8.4032489",
    "phone": "909686820",
    "email": "stgabriels.ias@eircom.net"
  },
  {
    "i": "1253",
    "county": "Galway",
    "rollNumber": "14383V",
    "schoolName": "SN Padraig Naofa",
    "SETHours": "60",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F42KC56",
    "addressOne": "Ballaghlea",
    "addressTwo": "Ballygar",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.5119965",
    "lng": "-8.3867971",
    "phone": "906660255",
    "email": "info@ballaghleans.ie"
  },
  {
    "i": "1254",
    "county": "Galway",
    "rollNumber": "14394D",
    "schoolName": "SN Cill Fheicin",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H91VE28",
    "addressOne": "Rakerin",
    "addressTwo": "Gort",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.0689707",
    "lng": "-8.7827573",
    "phone": "91632382",
    "email": "kilbeacantyns@gmail.com"
  },
  {
    "i": "1255",
    "county": "Galway",
    "rollNumber": "14420B",
    "schoolName": "SN Naomh Padraig",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "H91FT73",
    "addressOne": "Gorteennaglogh",
    "addressTwo": "Renvyle",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.5923745",
    "lng": "-9.9706723",
    "phone": "9543627",
    "email": "office@tullyschool.com"
  },
  {
    "i": "1256",
    "county": "Galway",
    "rollNumber": "14421D",
    "schoolName": "SN Ard",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "H91H9W9",
    "addressOne": "Aird Thiar",
    "addressTwo": "Carna",
    "addressThree": "Co. Na Gaillimhe",
    "addressFour": "",
    "lat": "53.3268117",
    "lng": "-9.8747179",
    "phone": "9532806",
    "email": "ardthiar.ias@eircom.net"
  },
  {
    "i": "1257",
    "county": "Galway",
    "rollNumber": "14448A",
    "schoolName": "Cloughanower NS",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H91K2X0",
    "addressOne": "Cloughanover",
    "addressTwo": "Headford",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.4456233",
    "lng": "-9.0952923",
    "phone": "9335315",
    "email": "clover.ias@eircom.net"
  },
  {
    "i": "1258",
    "county": "Galway",
    "rollNumber": "14590D",
    "schoolName": "Ainbhthin Naofa",
    "SETHours": "105",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "H91VK31",
    "addressOne": "Rosscahill East",
    "addressTwo": "Rosscahill",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.390684",
    "lng": "-9.2480329",
    "phone": "91550316",
    "email": "anninsns@gmail.com"
  },
  {
    "i": "1259",
    "county": "Galway",
    "rollNumber": "14642T",
    "schoolName": "SN Mhuire",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H91D263",
    "addressOne": "Fiddaun",
    "addressTwo": "Ardrahan",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.1690493",
    "lng": "-8.7577079",
    "phone": "91635424",
    "email": "ballyglassns@gmail.com"
  },
  {
    "i": "1260",
    "county": "Galway",
    "rollNumber": "14712O",
    "schoolName": "Sn An Fhairche",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F12DW65",
    "addressOne": "An Fháirche",
    "addressTwo": "Via Clár Chlainne Mhuiris",
    "addressThree": "Co. Na Gaillimhe",
    "addressFour": "",
    "lat": "53.5449496",
    "lng": "-9.364152",
    "phone": "949546654",
    "email": "snanfhairche@gmail.com"
  },
  {
    "i": "1261",
    "county": "Galway",
    "rollNumber": "14724V",
    "schoolName": "Scoil Ronain",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "H91E8Y0",
    "addressOne": "Oileán Trá Bhán",
    "addressTwo": "Leitir Móir",
    "addressThree": "Co. Na Gaillimhe",
    "addressFour": "",
    "lat": "53.2407635",
    "lng": "-9.6531046",
    "phone": "91551345",
    "email": "scoilronain2010@gmail.com"
  },
  {
    "i": "1262",
    "county": "Galway",
    "rollNumber": "15027E",
    "schoolName": "SN Na Heaglaise",
    "SETHours": "62.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H53TN20",
    "addressOne": "Ahascragh",
    "addressTwo": "Ballinasloe",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.3933103",
    "lng": "-8.287885",
    "phone": "909688874",
    "email": "eglishprimaryschool@gmail.com"
  },
  {
    "i": "1263",
    "county": "Galway",
    "rollNumber": "15071H",
    "schoolName": "SN Cillini Dioma",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "H62DK53",
    "addressOne": "Killeendeema East",
    "addressTwo": "Loughrea",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.1637265",
    "lng": "-8.5635817",
    "phone": "91842532",
    "email": "kilnadeemans.principal@gmail.com"
  },
  {
    "i": "1264",
    "county": "Galway",
    "rollNumber": "15331H",
    "schoolName": "SN Baile Nua",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "H91F6T7",
    "addressOne": "Baile Nua",
    "addressTwo": "Maigh Cuilinn",
    "addressThree": "Co. Na Gaillimhe",
    "addressFour": "",
    "lat": "53.3581723",
    "lng": "-9.2120933",
    "phone": "91555040",
    "email": "snbhailenua.ias@eircom.net"
  },
  {
    "i": "1265",
    "county": "Galway",
    "rollNumber": "15475I",
    "schoolName": "Kilconly NS",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "H54N529",
    "addressOne": "Kilconly",
    "addressTwo": "Tuam",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.5732006",
    "lng": "-8.9776112",
    "phone": "9347775",
    "email": "kilconns@gmail.com"
  },
  {
    "i": "1266",
    "county": "Galway",
    "rollNumber": "15523Q",
    "schoolName": "SN Naomh Iosef",
    "SETHours": "132.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "3.5",
    "spSNA": "3",
    "totalSNA": "6.5",
    "eircode": "H91X673",
    "addressOne": "Convent Road",
    "addressTwo": "Kinvara",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.1393128",
    "lng": "-8.9421853",
    "phone": "91638171",
    "email": "domgall@gmail.com"
  },
  {
    "i": "1267",
    "county": "Galway",
    "rollNumber": "15796F",
    "schoolName": "SN Cor An Droma",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "H91AD85",
    "addressOne": "Claregalway",
    "addressTwo": "Co. Galway",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.4103605",
    "lng": "-8.9108725",
    "phone": "91791715",
    "email": "corrandrum@gmail.com"
  },
  {
    "i": "1268",
    "county": "Galway",
    "rollNumber": "15835M",
    "schoolName": "St Brendan's NS",
    "SETHours": "145",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "H62YW57",
    "addressOne": "Mount Pleasant",
    "addressTwo": "Loughrea",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.1947414",
    "lng": "-8.5612393",
    "phone": "91841217",
    "email": "office@stbrendansbns.com"
  },
  {
    "i": "1269",
    "county": "Galway",
    "rollNumber": "15900U",
    "schoolName": "The Glebe NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H53P959",
    "addressOne": "Aughrim",
    "addressTwo": "Ballinasloe",
    "addressThree": "Co Galway",
    "addressFour": "",
    "lat": "53.303773",
    "lng": "-8.3150049",
    "phone": "909673650",
    "email": "lmckeigue@hotmail.com"
  },
  {
    "i": "1270",
    "county": "Galway",
    "rollNumber": "15958F",
    "schoolName": "St. Josephs NS",
    "SETHours": "37.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "0",
    "spSNA": "3",
    "totalSNA": "3",
    "eircode": "H62Y540",
    "addressOne": "Woodford",
    "addressTwo": "Loughrea",
    "addressThree": "County Galway",
    "addressFour": "",
    "lat": "53.0482826",
    "lng": "-8.3933476",
    "phone": "909749525",
    "email": "coill.ias@eircom.net"
  },
  {
    "i": "1271",
    "county": "Galway",
    "rollNumber": "15997P",
    "schoolName": "St Brendan's NS",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H53R772",
    "addressOne": "The Square",
    "addressTwo": "Eyrecourt",
    "addressThree": "Ballinasloe",
    "addressFour": "Co. Galway",
    "lat": "53.2014561",
    "lng": "-8.1295041",
    "phone": "909675362",
    "email": "office@eyrecourtns.ie"
  },
  {
    "i": "1272",
    "county": "Galway",
    "rollNumber": "16071M",
    "schoolName": "Scoil Chroi Naofa",
    "SETHours": "110",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "H65C860",
    "addressOne": "Tuam Road",
    "addressTwo": "Athenry",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.3005963",
    "lng": "-8.7469224",
    "phone": "91844510",
    "email": "scnathenry@eircom.net"
  },
  {
    "i": "1273",
    "county": "Galway",
    "rollNumber": "16121B",
    "schoolName": "Attymon NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H65PT02",
    "addressOne": "Attymon",
    "addressTwo": "Athenry",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.3227223",
    "lng": "-8.6080106",
    "phone": "91848454",
    "email": "attymonns@gmail.com"
  },
  {
    "i": "1274",
    "county": "Galway",
    "rollNumber": "16293H",
    "schoolName": "SN Cill Richill",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H62KC82",
    "addressOne": "Baile Locha Riabhach",
    "addressTwo": "Co Na Gaillimhe",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.2296803",
    "lng": "-8.4528823",
    "phone": "91843363",
    "email": "kilricklens@gmail.com"
  },
  {
    "i": "1275",
    "county": "Galway",
    "rollNumber": "16410I",
    "schoolName": "Ballinderry NS",
    "SETHours": "80",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "H54PX07",
    "addressOne": "Cummer",
    "addressTwo": "Tuam",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.4485697",
    "lng": "-8.8224258",
    "phone": "9341670",
    "email": "info@ballinderryns.ie"
  },
  {
    "i": "1276",
    "county": "Galway",
    "rollNumber": "16464I",
    "schoolName": "Castleblakeney NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "H53Y650",
    "addressOne": "Castleblakeney",
    "addressTwo": "Ballinasloe",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.4323147",
    "lng": "-8.4748335",
    "phone": "909678433",
    "email": "gallachns@hotmail.com"
  },
  {
    "i": "1277",
    "county": "Galway",
    "rollNumber": "16596C",
    "schoolName": "St Feichins N School",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H62FY64",
    "addressOne": "Abbey",
    "addressTwo": "Loughrea",
    "addressThree": "Co Galway",
    "addressFour": "",
    "lat": "53.1046156",
    "lng": "-8.390927",
    "phone": "909745609",
    "email": "stfeichins.ias@eircom.net"
  },
  {
    "i": "1278",
    "county": "Galway",
    "rollNumber": "16750J",
    "schoolName": "Parochial NS",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "H91W2V0",
    "addressOne": "Waterside",
    "addressTwo": "Woodquay",
    "addressThree": "Galway",
    "addressFour": "",
    "lat": "53.2764054",
    "lng": "-9.0543828",
    "phone": "91569233",
    "email": "galwayschool@gmail.com"
  },
  {
    "i": "1279",
    "county": "Galway",
    "rollNumber": "16762Q",
    "schoolName": "SN Ide Naofa",
    "SETHours": "145",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.99",
    "spSNA": "0",
    "totalSNA": "3.99",
    "eircode": "H62EE06",
    "addressOne": "Cross Street",
    "addressTwo": "Loughrea",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.1972307",
    "lng": "-8.564536",
    "phone": "91841605",
    "email": "italoughrea@hotmail.com"
  },
  {
    "i": "1280",
    "county": "Galway",
    "rollNumber": "16804G",
    "schoolName": "Sn Chlair Na Gaillimhe",
    "SETHours": "132.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.08",
    "spSNA": "0",
    "totalSNA": "3.08",
    "eircode": "H91C6D0",
    "addressOne": "Lakeview",
    "addressTwo": "Claregalway",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.3385969",
    "lng": "-8.9446081",
    "phone": "91798720",
    "email": "info@claregalwayns.ie"
  },
  {
    "i": "1281",
    "county": "Galway",
    "rollNumber": "16857E",
    "schoolName": "SN Naomh Uinseann",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "H65PK03",
    "addressOne": "Coolarne",
    "addressTwo": "Turloughmore",
    "addressThree": "Athenry",
    "addressFour": "Co. Galway",
    "lat": "53.3672833",
    "lng": "-8.8350928",
    "phone": "91797617",
    "email": "coolarnens1@gmail.com"
  },
  {
    "i": "1282",
    "county": "Galway",
    "rollNumber": "16936A",
    "schoolName": "SN Naomh Padraig",
    "SETHours": "97.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.66",
    "spSNA": "0",
    "totalSNA": "4.66",
    "eircode": "H91YD28",
    "addressOne": "Cregmore",
    "addressTwo": "Claregalway",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.3387266",
    "lng": "-8.8756291",
    "phone": "91799037",
    "email": "cregmorens@ymail.com"
  },
  {
    "i": "1283",
    "county": "Galway",
    "rollNumber": "16937C",
    "schoolName": "SN Fhursa",
    "SETHours": "92.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "H91P8X5",
    "addressOne": "Nile Lodge",
    "addressTwo": "Gaillimh",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.2690781",
    "lng": "-9.0663205",
    "phone": "91521840",
    "email": "runaiscoilfhursa@gmail.com"
  },
  {
    "i": "1284",
    "county": "Galway",
    "rollNumber": "16943U",
    "schoolName": "Niochlas NS",
    "SETHours": "305",
    "spClassTeachingPosts": "4",
    "mainSNA": "9.75",
    "spSNA": "8.66",
    "totalSNA": "18.41",
    "eircode": "H91DX57",
    "addressOne": "Saint Dominick's Road",
    "addressTwo": "The Claddagh",
    "addressThree": "Galway",
    "addressFour": "",
    "lat": "53.2674317",
    "lng": "-9.0577944",
    "phone": "91586173",
    "email": "claddaghns@gmail.com"
  },
  {
    "i": "1286",
    "county": "Galway",
    "rollNumber": "17007I",
    "schoolName": "SN Ard Raithin",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "H91CY67",
    "addressOne": "Ardrahan",
    "addressTwo": "Co. Galway",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.1415901",
    "lng": "-8.80507",
    "phone": "91635466",
    "email": "secretary@ardrahanns.ie"
  },
  {
    "i": "1287",
    "county": "Galway",
    "rollNumber": "17051L",
    "schoolName": "SN Na Fuar Coilleadh",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H91KN52",
    "addressOne": "Craughwell",
    "addressTwo": "Co Galway",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.2581",
    "lng": "-8.8062894",
    "phone": "91846373",
    "email": "admin@coldwood.ie"
  },
  {
    "i": "1288",
    "county": "Galway",
    "rollNumber": "17071R",
    "schoolName": "SN Baile A Mhoinin",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H53C1P3",
    "addressOne": "Castle Ffrench",
    "addressTwo": "Callinamore Bridge",
    "addressThree": "Ballinsloe",
    "addressFour": "Co. Galway",
    "lat": "53.4616391",
    "lng": "-8.3728853",
    "phone": "906622341",
    "email": "castlefrench.ias@eircom.net"
  },
  {
    "i": "1289",
    "county": "Galway",
    "rollNumber": "17095I",
    "schoolName": "SN Na Cealltraighe",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H53FR66",
    "addressOne": "Kilclare",
    "addressTwo": "Caltra",
    "addressThree": "Ballinasloe",
    "addressFour": "Co. Galway",
    "lat": "53.4341384",
    "lng": "-8.4458752",
    "phone": "909678416",
    "email": "caltraprimary@gmail.com"
  },
  {
    "i": "1290",
    "county": "Galway",
    "rollNumber": "17118R",
    "schoolName": "SN Naomh Fhursa",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H91Y443",
    "addressOne": "Claran",
    "addressTwo": "Headford",
    "addressThree": "Co Na Gaillimhe",
    "addressFour": "",
    "lat": "53.4599754",
    "lng": "-9.1644402",
    "phone": "9335922",
    "email": "claranfursa@hotmail.com"
  },
  {
    "i": "1291",
    "county": "Galway",
    "rollNumber": "17154V",
    "schoolName": "SN Breandain Naofa",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H62P447",
    "addressOne": "Mullagh More",
    "addressTwo": "Gurtymadden",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.2234994",
    "lng": "-8.3812566",
    "phone": "91843011",
    "email": "mullaghschool@eircom.net"
  },
  {
    "i": "1292",
    "county": "Galway",
    "rollNumber": "17170T",
    "schoolName": "Baile Mor Siol Anmcadha",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H53RH48",
    "addressOne": "Oghil More",
    "addressTwo": "Lawrencetown",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.2393124",
    "lng": "-8.1733098",
    "phone": "909685609",
    "email": "laurencetownns@hotmail.com"
  },
  {
    "i": "1293",
    "county": "Galway",
    "rollNumber": "17197Q",
    "schoolName": "SN An Leath Bhaile",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "H54YX29",
    "addressOne": "Tuam",
    "addressTwo": "Co. Galway",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.5313317",
    "lng": "-8.7138512",
    "phone": "858622031",
    "email": "lavallyns@gmail.com"
  },
  {
    "i": "1294",
    "county": "Galway",
    "rollNumber": "17198S",
    "schoolName": "SN Muire Gan Smal",
    "SETHours": "205",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.83",
    "spSNA": "0",
    "totalSNA": "5.83",
    "eircode": "H53PT32",
    "addressOne": "Shannonbridge",
    "addressTwo": "Ballinasloe",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.3280512",
    "lng": "-8.2011799",
    "phone": "909642634",
    "email": "principal.creaghns@gmail.com"
  },
  {
    "i": "1295",
    "county": "Galway",
    "rollNumber": "17207Q",
    "schoolName": "SN Domhnach Padraig",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "H91W3Y6",
    "addressOne": "Beagh Beg",
    "addressTwo": "Caherlistrane",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.4969872",
    "lng": "-9.0223469",
    "phone": "872445277",
    "email": "info@donaghpatrickns.ie"
  },
  {
    "i": "1296",
    "county": "Galway",
    "rollNumber": "17221K",
    "schoolName": "Sn Colmcille",
    "SETHours": "85",
    "spClassTeachingPosts": "1",
    "mainSNA": "2.25",
    "spSNA": "2.5",
    "totalSNA": "4.75",
    "eircode": "H91F9K6",
    "addressOne": "School Road",
    "addressTwo": "Castlegar",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.301518",
    "lng": "-9.0189412",
    "phone": "91757362",
    "email": "castlegarns@gmail.com"
  },
  {
    "i": "1297",
    "county": "Galway",
    "rollNumber": "17242S",
    "schoolName": "SN Pairc Na Slinne",
    "SETHours": "0",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H62FC62",
    "addressOne": "Magh Glas",
    "addressTwo": "Baile Locha Riach",
    "addressThree": "Co Na Gaillimhe",
    "addressFour": "",
    "lat": "53.0709604",
    "lng": "-8.4638109",
    "phone": "909749317",
    "email": "slatefieldns@yahoo.ie"
  },
  {
    "i": "1298",
    "county": "Galway",
    "rollNumber": "17273G",
    "schoolName": "SN Baile Na Cille",
    "SETHours": "7.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H62DK60",
    "addressOne": "Baile Locha Riach",
    "addressTwo": "Co Na Gaillimhe",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.0988451",
    "lng": "-8.4469446",
    "phone": "909745555",
    "email": "ballinakillns@hotmail.com"
  },
  {
    "i": "1299",
    "county": "Galway",
    "rollNumber": "17280D",
    "schoolName": "SN Baile Atha N Riogh",
    "SETHours": "65",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "H65R921",
    "addressOne": "Knockaunglass",
    "addressTwo": "Athenry",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.2982675",
    "lng": "-8.7420041",
    "phone": "91844029",
    "email": "bnsathenry.ias@eircom.net"
  },
  {
    "i": "1300",
    "county": "Galway",
    "rollNumber": "17289V",
    "schoolName": "SN Caomhain",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H91C967",
    "addressOne": "An Trá",
    "addressTwo": "Inis Oirr",
    "addressThree": "Co. Na Gaillimhe",
    "addressFour": "",
    "lat": "53.0651651",
    "lng": "-9.5158892",
    "phone": "9975102",
    "email": "snchaomhain@gmail.com"
  },
  {
    "i": "1301",
    "county": "Galway",
    "rollNumber": "17331R",
    "schoolName": "SN An Droma",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H62AK49",
    "addressOne": "Ballinakill",
    "addressTwo": "Loughrea",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.0996376",
    "lng": "-8.4826635",
    "phone": "866659033",
    "email": "drimnationalschool@gmail.com"
  },
  {
    "i": "1302",
    "county": "Galway",
    "rollNumber": "17368R",
    "schoolName": "Croi Ronaofa Meascaithe",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "F45K466",
    "addressOne": "Corralough",
    "addressTwo": "Williamstown",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.6762419",
    "lng": "-8.5783986",
    "phone": "949643124",
    "email": "williamstownns@eircom.net"
  },
  {
    "i": "1303",
    "county": "Galway",
    "rollNumber": "17444H",
    "schoolName": "SN Seosamh Naofa",
    "SETHours": "75",
    "spClassTeachingPosts": "2",
    "mainSNA": "1.75",
    "spSNA": "5",
    "totalSNA": "6.75",
    "eircode": "H65YK19",
    "addressOne": "Carrabane",
    "addressTwo": "Athenry",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.2297873",
    "lng": "-8.6384744",
    "phone": "91842458",
    "email": "carrabanens@gmail.com"
  },
  {
    "i": "1304",
    "county": "Galway",
    "rollNumber": "17456O",
    "schoolName": "SN Ronain",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H91ED89",
    "addressOne": "Cill Ronáin",
    "addressTwo": "Inis Mór",
    "addressThree": "Co. Na Gaillimhe",
    "addressFour": "",
    "lat": "53.1230087",
    "lng": "-9.6681201",
    "phone": "9961310",
    "email": "scoilronain@gmail.com"
  },
  {
    "i": "1305",
    "county": "Galway",
    "rollNumber": "17463L",
    "schoolName": "SN Briocain",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "H91V5X0",
    "addressOne": "An Gort Mor",
    "addressTwo": "Rosmuc",
    "addressThree": "Co Na Gaillimhe",
    "addressFour": "",
    "lat": "53.3861817",
    "lng": "-9.6089656",
    "phone": "91574303",
    "email": "snbhriocain1@gmail.com"
  },
  {
    "i": "1306",
    "county": "Galway",
    "rollNumber": "17475S",
    "schoolName": "SN Aine Naofa",
    "SETHours": "40",
    "spClassTeachingPosts": "1",
    "mainSNA": "2",
    "spSNA": "2",
    "totalSNA": "4",
    "eircode": "H91C6D6",
    "addressOne": "Loughcutra",
    "addressTwo": "Gort",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.0112705",
    "lng": "-8.8125954",
    "phone": "91633242",
    "email": "loughcutrans@gmail.com"
  },
  {
    "i": "1307",
    "county": "Galway",
    "rollNumber": "17485V",
    "schoolName": "SN Padraig Naofa",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "H53PN72",
    "addressOne": "Fohenagh",
    "addressTwo": "Ahascragh",
    "addressThree": "Ballinasloe",
    "addressFour": "Co. Galway",
    "lat": "53.386235",
    "lng": "-8.3870498",
    "phone": "909688148",
    "email": "stpatricksnsfoh@gmail.com"
  },
  {
    "i": "1308",
    "county": "Galway",
    "rollNumber": "17488E",
    "schoolName": "Sn An Aill Bhreach",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H71EP65",
    "addressOne": "Aillebrack",
    "addressTwo": "Ballyconneely",
    "addressThree": "Co Galway",
    "addressFour": "",
    "lat": "53.4177337",
    "lng": "-10.1190231",
    "phone": "9523988",
    "email": "aillebrackns.ias@eircom.net"
  },
  {
    "i": "1309",
    "county": "Galway",
    "rollNumber": "17490O",
    "schoolName": "SN Lorcain Naofa",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H62AW74",
    "addressOne": "Tynagh",
    "addressTwo": "Loughrea",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.1387685",
    "lng": "-8.3667283",
    "phone": "909745439",
    "email": "tynaghns@hotmail.com"
  },
  {
    "i": "1310",
    "county": "Galway",
    "rollNumber": "17502S",
    "schoolName": "SN Naomh Thomais",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "H91TP89",
    "addressOne": "Tobar Pheadar",
    "addressTwo": "Gaillimh",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.1143164",
    "lng": "-8.747222",
    "phone": "858747269",
    "email": "stthomasns.ias@eircom.net"
  },
  {
    "i": "1311",
    "county": "Galway",
    "rollNumber": "17506D",
    "schoolName": "SN Breandan Naofa",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H62VK28",
    "addressOne": "Duniry",
    "addressTwo": "Kylebrack East",
    "addressThree": "Loughrea",
    "addressFour": "Co. Galway",
    "lat": "53.1474423",
    "lng": "-8.4165639",
    "phone": "909745582",
    "email": "duniryns@hotmail.com"
  },
  {
    "i": "1312",
    "county": "Galway",
    "rollNumber": "17529P",
    "schoolName": "SN Iomair Naofa",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H65C670",
    "addressOne": "Brackloon",
    "addressTwo": "Kiltullagh",
    "addressThree": "Athenry",
    "addressFour": "Co. Galway",
    "lat": "53.2830599",
    "lng": "-8.58612",
    "phone": "91848376",
    "email": "brackloonns2011@gmail.com"
  },
  {
    "i": "1313",
    "county": "Galway",
    "rollNumber": "17539S",
    "schoolName": "SN Cill Cruain",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F45A099",
    "addressOne": "Scoil Chill Chruain",
    "addressTwo": "Williamstown",
    "addressThree": "Castlerea",
    "addressFour": "",
    "lat": "53.6689661",
    "lng": "-8.4999263",
    "phone": "949655367",
    "email": "kilcroanns@yahoo.com"
  },
  {
    "i": "1314",
    "county": "Galway",
    "rollNumber": "17547R",
    "schoolName": "SN Breandan Naofa",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H62NY53",
    "addressOne": "Derryoober East",
    "addressTwo": "Woodford",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.0063891",
    "lng": "-8.3647397",
    "phone": "860483344",
    "email": "derryoobernationalschool@yahoo.ie"
  },
  {
    "i": "1315",
    "county": "Galway",
    "rollNumber": "17574U",
    "schoolName": "SN Naomh Ciarain",
    "SETHours": "20",
    "spClassTeachingPosts": "1",
    "mainSNA": "0.75",
    "spSNA": "0.83",
    "totalSNA": "1.58",
    "eircode": "H91T650",
    "addressOne": "Cill Chiaráin",
    "addressTwo": "Conamara",
    "addressThree": "Co. Na Gaillimhe",
    "addressFour": "",
    "lat": "53.3269235",
    "lng": "-9.7342733",
    "phone": "9533613",
    "email": "scoilnaomhciaran@gmail.com"
  },
  {
    "i": "1316",
    "county": "Galway",
    "rollNumber": "17613E",
    "schoolName": "SN Caitriona Naofa",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H53X266",
    "addressOne": "Eachdruim",
    "addressTwo": "Ballinasloe",
    "addressThree": "Co Galway",
    "addressFour": "",
    "lat": "53.3050937",
    "lng": "-8.3194834",
    "phone": "909673635",
    "email": "aughrimprimary@gmail.com"
  },
  {
    "i": "1317",
    "county": "Galway",
    "rollNumber": "17631G",
    "schoolName": "Ceathru Na Ngarrdhanta",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "H54RW56",
    "addressOne": "Ballytrasna",
    "addressTwo": "Tuam",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.5465823",
    "lng": "-8.8498553",
    "phone": "9324081",
    "email": "gardenfieldoffice@gmail.com"
  },
  {
    "i": "1318",
    "county": "Galway",
    "rollNumber": "17645R",
    "schoolName": "SN Cronain",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "H91T2N2",
    "addressOne": "Kiltiernan",
    "addressTwo": "Kilcolgan",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.177623",
    "lng": "-8.8403076",
    "phone": "91635000",
    "email": "kiltiernanschool1@gmail.com"
  },
  {
    "i": "1319",
    "county": "Galway",
    "rollNumber": "17647V",
    "schoolName": "Muire Na Dea Comhairle",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "H91FD71",
    "addressOne": "Church Road",
    "addressTwo": "Headford",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.4691777",
    "lng": "-9.1104511",
    "phone": "9335377",
    "email": "headfordgirlsns@gmail.com"
  },
  {
    "i": "1320",
    "county": "Galway",
    "rollNumber": "17648A",
    "schoolName": "SN Breandain Naofa",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H91NV02",
    "addressOne": "Church Road",
    "addressTwo": "Headford",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.4692408",
    "lng": "-9.1109394",
    "phone": "9335378",
    "email": "hbns@eircom.net"
  },
  {
    "i": "1321",
    "county": "Galway",
    "rollNumber": "17655U",
    "schoolName": "SN Caladh Na Muc",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "H91XD57",
    "addressOne": "Carrowmoreknock",
    "addressTwo": "Rosscahill",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.4131215",
    "lng": "-9.1774314",
    "phone": "91550009",
    "email": "caladhnamuc.ns@gmail.com"
  },
  {
    "i": "1322",
    "county": "Galway",
    "rollNumber": "17660N",
    "schoolName": "SN Naomh Treasa",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H91A6C1",
    "addressOne": "Cashel",
    "addressTwo": "Co. Galway",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.4189047",
    "lng": "-9.8061616",
    "phone": "9531126",
    "email": "principal@cashelns.ie"
  },
  {
    "i": "1323",
    "county": "Galway",
    "rollNumber": "17668G",
    "schoolName": "SN Na Bhforbacha",
    "SETHours": "60",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.33",
    "spSNA": "0",
    "totalSNA": "2.33",
    "eircode": "H91RR60",
    "addressOne": "An Spideal",
    "addressTwo": "Co Na Gaillimhe",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.2488441",
    "lng": "-9.2055425",
    "phone": "91592244",
    "email": "forbachasc@gmail.com"
  },
  {
    "i": "1324",
    "county": "Galway",
    "rollNumber": "17689O",
    "schoolName": "SN Tir An Fhiaidh",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.75",
    "spSNA": "0",
    "totalSNA": "1.75",
    "eircode": "H91YF90",
    "addressOne": "Tí­r An Fhia",
    "addressTwo": "Leitir Móir,",
    "addressThree": "Co. Na Gaillimhe",
    "addressFour": "",
    "lat": "53.2690578",
    "lng": "-9.6626319",
    "phone": "91551415",
    "email": "scoilthiranfhia@gmail.com"
  },
  {
    "i": "1325",
    "county": "Galway",
    "rollNumber": "17759J",
    "schoolName": "SN Brighde",
    "SETHours": "90",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "H91YD63",
    "addressOne": "Mionlach",
    "addressTwo": "An Caisleán Gearr",
    "addressThree": "Co. Na Gaillimhe",
    "addressFour": "",
    "lat": "53.3013318",
    "lng": "-9.0687802",
    "phone": "91762323",
    "email": "scoilbhride2@hotmail.com"
  },
  {
    "i": "1326",
    "county": "Galway",
    "rollNumber": "17760R",
    "schoolName": "SN Baile An Leasa",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H54TP40",
    "addressOne": "Dunmore",
    "addressTwo": "Tuam",
    "addressThree": "Co Galway",
    "addressFour": "",
    "lat": "53.6065718",
    "lng": "-8.6997543",
    "phone": "9338002",
    "email": "nsballinlass@eircom.net"
  },
  {
    "i": "1327",
    "county": "Galway",
    "rollNumber": "17770U",
    "schoolName": "SN Naomh Colmain",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H91Y8K0",
    "addressOne": "Scoil Cholmain",
    "addressTwo": "Muigh-inis",
    "addressThree": "Cárna",
    "addressFour": "Co. Na Gaillimhe",
    "lat": "53.3016877",
    "lng": "-9.8472614",
    "phone": "9532818",
    "email": "scoilcholmain@yahoo.com"
  },
  {
    "i": "1328",
    "county": "Galway",
    "rollNumber": "17771W",
    "schoolName": "SN Mhuire",
    "SETHours": "262.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "9.5",
    "spSNA": "0",
    "totalSNA": "9.5",
    "eircode": "H91YR20",
    "addressOne": "Lisheenkyle",
    "addressTwo": "Oranmore",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.2920587",
    "lng": "-8.8445978",
    "phone": "91844901",
    "email": "lisheenkyle@gmail.com"
  },
  {
    "i": "1329",
    "county": "Galway",
    "rollNumber": "17772B",
    "schoolName": "SN Brighdhe Naofa",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "H91F2A4",
    "addressOne": "Cinn Mara",
    "addressTwo": "Co Na Gaillimhe",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.1273445",
    "lng": "-8.9043596",
    "phone": "91637519",
    "email": "smcd1970@hotmail.com"
  },
  {
    "i": "1330",
    "county": "Galway",
    "rollNumber": "17782E",
    "schoolName": "SN Bride Naofa",
    "SETHours": "280.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "7.75",
    "spSNA": "0",
    "totalSNA": "7.75",
    "eircode": "H91VW59",
    "addressOne": "Shantalla Road",
    "addressTwo": "Galway",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.2735027",
    "lng": "-9.0714566",
    "phone": "91525052",
    "email": "principal@scoilbhrideshantalla.ie"
  },
  {
    "i": "1331",
    "county": "Galway",
    "rollNumber": "17784I",
    "schoolName": "SN Padraic Naofa",
    "SETHours": "187.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "3.34",
    "spSNA": "3.32",
    "totalSNA": "6.66",
    "eircode": "H91K3C7",
    "addressOne": "Lombard Street",
    "addressTwo": "Galway",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.2722627",
    "lng": "-9.0553831",
    "phone": "91568707",
    "email": "saintpatricksgalway@gmail.com"
  },
  {
    "i": "1332",
    "county": "Galway",
    "rollNumber": "17789S",
    "schoolName": "SN Cill Tartain",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H91C6E8",
    "addressOne": "Gort Inse Guaire",
    "addressTwo": "Co Na Gaillimhe",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.0966752",
    "lng": "-8.8166753",
    "phone": "91631187",
    "email": "kiltartanschool@gmail.com"
  },
  {
    "i": "1333",
    "county": "Galway",
    "rollNumber": "17793J",
    "schoolName": "SN Padraig Naofa",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H91CK06",
    "addressOne": "Cloideach",
    "addressTwo": "Ath Cinn",
    "addressThree": "Co Na Gaillimhe",
    "addressFour": "",
    "lat": "53.4421859",
    "lng": "-9.1451386",
    "phone": "9335868",
    "email": "clydaghns@eircom.net"
  },
  {
    "i": "1334",
    "county": "Galway",
    "rollNumber": "17807R",
    "schoolName": "SN Cathair Geal",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.58",
    "spSNA": "0",
    "totalSNA": "2.58",
    "eircode": "H54C593",
    "addressOne": "Cahergal",
    "addressTwo": "Tuam",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.473306",
    "lng": "-8.777929",
    "phone": "9349364",
    "email": "cahergalns@gmail.com"
  },
  {
    "i": "1335",
    "county": "Galway",
    "rollNumber": "17845C",
    "schoolName": "Scoil Mhuire",
    "SETHours": "125",
    "spClassTeachingPosts": "2",
    "mainSNA": "3.83",
    "spSNA": "4.5",
    "totalSNA": "8.33",
    "eircode": "H91E5C9",
    "addressOne": "Brierhill School",
    "addressTwo": "Brierhill",
    "addressThree": "Galway",
    "addressFour": "",
    "lat": "53.2943874",
    "lng": "-8.9791442",
    "phone": "91751543",
    "email": "brierhillns1@gmail.com"
  },
  {
    "i": "1336",
    "county": "Galway",
    "rollNumber": "17863E",
    "schoolName": "Scoil Iarlatha Naofa",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "H53HW42",
    "addressOne": "Garbally",
    "addressTwo": "Ballinasloe",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.4068543",
    "lng": "-8.635099",
    "phone": "909684663",
    "email": "garballyns@eircom.net"
  },
  {
    "i": "1337",
    "county": "Galway",
    "rollNumber": "17869Q",
    "schoolName": "SN Ciarain Naofa",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "H91DFH7",
    "addressOne": "Cloonsh",
    "addressTwo": "Kinvara",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.1663248",
    "lng": "-9.0178004",
    "phone": "91638645",
    "email": "doorusns@gmail.com"
  },
  {
    "i": "1338",
    "county": "Galway",
    "rollNumber": "17870B",
    "schoolName": "Scoil Bhreandain Naofa",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H53EW70",
    "addressOne": "Cluain Fhearta",
    "addressTwo": "Beal Atha Na Sluaigh",
    "addressThree": "Co Na Gaillimhe",
    "addressFour": "",
    "lat": "53.2249687",
    "lng": "-8.0725276",
    "phone": "909675008",
    "email": "clonfertns17@gmail.com"
  },
  {
    "i": "1339",
    "county": "Galway",
    "rollNumber": "17877P",
    "schoolName": "Scoil Muire Naofa",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "H53A3E8",
    "addressOne": "Menlough",
    "addressTwo": "Ballinasloe",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.4210027",
    "lng": "-8.569264",
    "phone": "909684004",
    "email": "menloughns@gmail.com"
  },
  {
    "i": "1340",
    "county": "Galway",
    "rollNumber": "17919F",
    "schoolName": "Aibhistin Naofa",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H53X568",
    "addressOne": "Clontuskert",
    "addressTwo": "Ballinasloe",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.275966",
    "lng": "-8.2436915",
    "phone": "909643762",
    "email": "clontuskertns@gmail.com"
  },
  {
    "i": "1341",
    "county": "Galway",
    "rollNumber": "17934B",
    "schoolName": "Scoil Bhride",
    "SETHours": "52.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "1",
    "spSNA": "1.83",
    "totalSNA": "2.83",
    "eircode": "H53K188",
    "addressOne": "An Cnoc Bhreac",
    "addressTwo": "Beal Atha Na Sluaigh",
    "addressThree": "Co Na Gaillimhe",
    "addressFour": "",
    "lat": "53.3010902",
    "lng": "-8.4887923",
    "phone": "909675706",
    "email": "info@newinnns.com"
  },
  {
    "i": "1342",
    "county": "Galway",
    "rollNumber": "17980I",
    "schoolName": "Scoil Mhuire",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F45DX68",
    "addressOne": "Ardeevin",
    "addressTwo": "Williamstown",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.6378697",
    "lng": "-8.5496852",
    "phone": "949659333",
    "email": "ardeevinschool@outlook.ie"
  },
  {
    "i": "1343",
    "county": "Galway",
    "rollNumber": "18021H",
    "schoolName": "Sn An Croi Ro Naofa",
    "SETHours": "75",
    "spClassTeachingPosts": "1",
    "mainSNA": "3.58",
    "spSNA": "0.83",
    "totalSNA": "4.41",
    "eircode": "H54NY03",
    "addressOne": "Belclare",
    "addressTwo": "Tuam",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.4926516",
    "lng": "-8.939119",
    "phone": "9355569",
    "email": "belclarens@gmail.com"
  },
  {
    "i": "1344",
    "county": "Galway",
    "rollNumber": "18043R",
    "schoolName": "SN Muire Gan Smal",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H53TP86",
    "addressOne": "Tiernascragh",
    "addressTwo": "Ballycrissane",
    "addressThree": "Ballinasloe",
    "addressFour": "Co. Galway",
    "lat": "53.15128",
    "lng": "-8.190787",
    "phone": "909675431",
    "email": "office.tiernascraghns@gmail.com"
  },
  {
    "i": "1345",
    "county": "Galway",
    "rollNumber": "18089S",
    "schoolName": "Scoil Naomh Mhuire",
    "SETHours": "60",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "H91PK19",
    "addressOne": "Maree",
    "addressTwo": "Oranmore",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.2314677",
    "lng": "-8.9491506",
    "phone": "91790353",
    "email": "info@mareens.ie"
  },
  {
    "i": "1346",
    "county": "Galway",
    "rollNumber": "18097R",
    "schoolName": "Togala Mhuire",
    "SETHours": "60",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "H65Y309",
    "addressOne": "Kiltullagh",
    "addressTwo": "Co. Galway",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.2747782",
    "lng": "-8.6372871",
    "phone": "91848480",
    "email": "kiltullaghns@gmail.com"
  },
  {
    "i": "1347",
    "county": "Galway",
    "rollNumber": "18111I",
    "schoolName": "SN Gort Na Gaoithe",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "H53A242",
    "addressOne": "Gort Na Gaoithe",
    "addressTwo": "Newbridge",
    "addressThree": "Ballinasloe",
    "addressFour": "",
    "lat": "53.5167695",
    "lng": "-8.4693827",
    "phone": "906660203",
    "email": "info@windfieldns.ie"
  },
  {
    "i": "1348",
    "county": "Galway",
    "rollNumber": "18112K",
    "schoolName": "Scoil Naomh Eanna",
    "SETHours": "80",
    "spClassTeachingPosts": "1",
    "mainSNA": "1.83",
    "spSNA": "1.66",
    "totalSNA": "3.49",
    "eircode": "H62EY13",
    "addressOne": "Bullaun",
    "addressTwo": "Loughrea",
    "addressThree": "Co Galway",
    "addressFour": "",
    "lat": "53.249194",
    "lng": "-8.5543429",
    "phone": "91841556",
    "email": "bullaunns.ias@eircom.net"
  },
  {
    "i": "1350",
    "county": "Galway",
    "rollNumber": "18121L",
    "schoolName": "SN Mhuire",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "H91D2H5",
    "addressOne": "Carna",
    "addressTwo": "Co. Na Gaillimhe",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3230751",
    "lng": "-9.8162956",
    "phone": "9532820",
    "email": "scoilcarna@eircom.net"
  },
  {
    "i": "1351",
    "county": "Galway",
    "rollNumber": "18125T",
    "schoolName": "Scoil Naomh Mhuire",
    "SETHours": "65",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "H53DV74",
    "addressOne": "Mountbellew",
    "addressTwo": "Ballinasloe",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.4677568",
    "lng": "-8.492619",
    "phone": "909679396",
    "email": "mountbellewns.ias@eircom.net"
  },
  {
    "i": "1352",
    "county": "Galway",
    "rollNumber": "18163E",
    "schoolName": "Sn N Breandain",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.75",
    "spSNA": "0",
    "totalSNA": "1.75",
    "eircode": "H91C963",
    "addressOne": "Eanach Dhuin",
    "addressTwo": "Cor An Dola",
    "addressThree": "Co Na Gaillimhe",
    "addressFour": "",
    "lat": "53.3867142",
    "lng": "-9.0664183",
    "phone": "91791661",
    "email": "annaghdown.ias@eircom.net"
  },
  {
    "i": "1353",
    "county": "Galway",
    "rollNumber": "18252D",
    "schoolName": "Scoil Mhuire",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H91P6A0",
    "addressOne": "Doire Glinne",
    "addressTwo": "Sraith Salach",
    "addressThree": "Co. Na Gaillimhe",
    "addressFour": "",
    "lat": "53.4290342",
    "lng": "-9.4223264",
    "phone": "91552810",
    "email": "smdoire@hotmail.com"
  },
  {
    "i": "1354",
    "county": "Galway",
    "rollNumber": "18268S",
    "schoolName": "SN Cillinin",
    "SETHours": "70",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.58",
    "spSNA": "0",
    "totalSNA": "4.58",
    "eircode": "H91E293",
    "addressOne": "Killeeneen",
    "addressTwo": "Craughwell",
    "addressThree": "Galway",
    "addressFour": "",
    "lat": "53.2207965",
    "lng": "-8.8077373",
    "phone": "91796404",
    "email": "killeeneen2@gmail.com"
  },
  {
    "i": "1355",
    "county": "Galway",
    "rollNumber": "18289D",
    "schoolName": "Scoil Naomh Iosef",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "H54FY23",
    "addressOne": "Castlehackett",
    "addressTwo": "Belclare",
    "addressThree": "Tuam",
    "addressFour": "Co. Galway",
    "lat": "53.449536",
    "lng": "-8.9829409",
    "phone": "91791708",
    "email": "Info@castlehackettns.ie"
  },
  {
    "i": "1356",
    "county": "Galway",
    "rollNumber": "18309G",
    "schoolName": "Scoil Bride",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H53W642",
    "addressOne": "Cooloo",
    "addressTwo": "Moylough",
    "addressThree": "Ballinasloe",
    "addressFour": "",
    "lat": "53.4840011",
    "lng": "-8.6287447",
    "phone": "9349565",
    "email": "coolooschool@gmail.com"
  },
  {
    "i": "1357",
    "county": "Galway",
    "rollNumber": "18332B",
    "schoolName": "Scoil Naomh Padraig",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H53PF54",
    "addressOne": "Moylough",
    "addressTwo": "Ballinasloe",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.4874221",
    "lng": "-8.5627502",
    "phone": "909679578",
    "email": "moyloughprimary@gmail.com"
  },
  {
    "i": "1358",
    "county": "Galway",
    "rollNumber": "18441G",
    "schoolName": "Scoil Naomh Chuan",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H53YK58",
    "addressOne": "Killimor",
    "addressTwo": "Ballinasloe",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.1882563",
    "lng": "-8.2433313",
    "phone": "909676502",
    "email": "snc.ias@gmail.com"
  },
  {
    "i": "1359",
    "county": "Galway",
    "rollNumber": "18460K",
    "schoolName": "Sn Baile An Mhuilinn",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "H54RR60",
    "addressOne": "Milltown",
    "addressTwo": "Tuam",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.6028083",
    "lng": "-8.886035",
    "phone": "9351474",
    "email": "milltownns@eircom.net"
  },
  {
    "i": "1360",
    "county": "Galway",
    "rollNumber": "18490T",
    "schoolName": "Sn M An Croi Gan Smal",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H91C6H9",
    "addressOne": "Leenane",
    "addressTwo": "Co Galway",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.5986361",
    "lng": "-9.6928114",
    "phone": "9542366",
    "email": "info@leenanens.ie"
  },
  {
    "i": "1361",
    "county": "Galway",
    "rollNumber": "18514H",
    "schoolName": "SN Choilm Chille",
    "SETHours": "92.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "2",
    "spSNA": "1",
    "totalSNA": "3",
    "eircode": "H91T224",
    "addressOne": "An Tulach",
    "addressTwo": "Baile Na Habhann O.p.,",
    "addressThree": "Co Na Gaillimhe",
    "addressFour": "",
    "lat": "53.2373629",
    "lng": "-9.4925988",
    "phone": "91593613",
    "email": "colmcille2011@gmail.com"
  },
  {
    "i": "1362",
    "county": "Galway",
    "rollNumber": "18572V",
    "schoolName": "Glenamaddy Ns",
    "SETHours": "50",
    "spClassTeachingPosts": "1",
    "mainSNA": "1",
    "spSNA": "1.83",
    "totalSNA": "2.83",
    "eircode": "F45YP27",
    "addressOne": "Kilkerrin Road",
    "addressTwo": "Glenamaddy",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.6040101",
    "lng": "-8.5604846",
    "phone": "949659375",
    "email": "glenamaddyns@hotmail.com"
  },
  {
    "i": "1363",
    "county": "Galway",
    "rollNumber": "18581W",
    "schoolName": "Scoil Mhuire",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.33",
    "spSNA": "0",
    "totalSNA": "1.33",
    "eircode": "F12WV77",
    "addressOne": "Corr Na Móna",
    "addressTwo": "Co. Na Gaillimhe",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.5121488",
    "lng": "-9.4566491",
    "phone": "949548301",
    "email": "cnmscoilmhuire@gmail.com"
  },
  {
    "i": "1364",
    "county": "Galway",
    "rollNumber": "18608Q",
    "schoolName": "SN Muire Gan Smal",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.25",
    "spSNA": "0",
    "totalSNA": "1.25",
    "eircode": "H71YF76",
    "addressOne": "Claddaghduff",
    "addressTwo": "Co. Galway",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.5444561",
    "lng": "-10.1410901",
    "phone": "9544334",
    "email": "claddaghduffns@gmail.com"
  },
  {
    "i": "1365",
    "county": "Galway",
    "rollNumber": "18634R",
    "schoolName": "Scoil Ide",
    "SETHours": "107.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.33",
    "spSNA": "0",
    "totalSNA": "4.33",
    "eircode": "H91E4C2",
    "addressOne": "Ardnamara",
    "addressTwo": "Salthill",
    "addressThree": "Galway",
    "addressFour": "",
    "lat": "53.2628031",
    "lng": "-9.0812275",
    "phone": "91522716",
    "email": "secretary@scoilideschool.com"
  },
  {
    "i": "1366",
    "county": "Galway",
    "rollNumber": "18636V",
    "schoolName": "SN Bheanain",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "H54CC84",
    "addressOne": "Tuam",
    "addressTwo": "Co. Galway",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.5489059",
    "lng": "-8.897806",
    "phone": "9325175",
    "email": "stbenins@gmail.com"
  },
  {
    "i": "1367",
    "county": "Galway",
    "rollNumber": "18686N",
    "schoolName": "SN Gort Na Leime",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H54NY66",
    "addressOne": "Dunmore",
    "addressTwo": "Tuam",
    "addressThree": "Co Galway",
    "addressFour": "",
    "lat": "53.6375916",
    "lng": "-8.682377",
    "phone": "9338688",
    "email": "scoilgort@gmail.com"
  },
  {
    "i": "1368",
    "county": "Galway",
    "rollNumber": "18746F",
    "schoolName": "Sn Muine Mhea",
    "SETHours": "80",
    "spClassTeachingPosts": "1",
    "mainSNA": "4.66",
    "spSNA": "2.83",
    "totalSNA": "7.49",
    "eircode": "H65X993",
    "addressOne": "Monivea",
    "addressTwo": "Athenry",
    "addressThree": "Co Galway",
    "addressFour": "",
    "lat": "53.375152",
    "lng": "-8.7071442",
    "phone": "91849532",
    "email": "office@moniveans.ie"
  },
  {
    "i": "1369",
    "county": "Galway",
    "rollNumber": "18929N",
    "schoolName": "Scoil Naomh Einde",
    "SETHours": "97.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "H91Y725",
    "addressOne": "Dr Mannix Road",
    "addressTwo": "Salthill",
    "addressThree": "Galway",
    "addressFour": "",
    "lat": "53.2646465",
    "lng": "-9.0833844",
    "phone": "91521272",
    "email": "scoileindegalway@gmail.com"
  },
  {
    "i": "1372",
    "county": "Galway",
    "rollNumber": "19241D",
    "schoolName": "Scoil Náisiúnta Róis",
    "SETHours": "160",
    "spClassTeachingPosts": "0",
    "mainSNA": "6.32",
    "spSNA": "0",
    "totalSNA": "6.32",
    "eircode": "H91W2V9",
    "addressOne": "Rosary Lane",
    "addressTwo": "Taylor's Hill",
    "addressThree": "Galway",
    "addressFour": "",
    "lat": "53.268218",
    "lng": "-9.0760327",
    "phone": "91520908",
    "email": "scrois.ias@eircom.net"
  },
  {
    "i": "1373",
    "county": "Galway",
    "rollNumber": "19275U",
    "schoolName": "Barnaderg Central Sch",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "H54EW71",
    "addressOne": "Barnaderg",
    "addressTwo": "Tuam",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.4822794",
    "lng": "-8.7257182",
    "phone": "9349357",
    "email": "contact@barnadergns.com"
  },
  {
    "i": "1374",
    "county": "Galway",
    "rollNumber": "19276W",
    "schoolName": "St Colmans Mxd NS",
    "SETHours": "102.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "5",
    "spSNA": "0",
    "totalSNA": "5",
    "eircode": "H54KP40",
    "addressOne": "Cummer",
    "addressTwo": "Tuam",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.4497344",
    "lng": "-8.8720191",
    "phone": "9341649",
    "email": "stcolmansns@gmail.com"
  },
  {
    "i": "1375",
    "county": "Galway",
    "rollNumber": "19283T",
    "schoolName": "Ballymacward Central Sc",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H53NX21",
    "addressOne": "Ballymacward Central Sc",
    "addressTwo": "Ballinasloe",
    "addressThree": "Co Galway",
    "addressFour": "",
    "lat": "53.3892113",
    "lng": "-8.4819139",
    "phone": "909687696",
    "email": "ballymacwardns.ias@eircom.net"
  },
  {
    "i": "1376",
    "county": "Galway",
    "rollNumber": "19290Q",
    "schoolName": "Ballyconeely NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H71N291",
    "addressOne": "Clifden",
    "addressTwo": "Co. Galway",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.4307765",
    "lng": "-10.073282",
    "phone": "9523945",
    "email": "ballyconneelyns@gmail.com"
  },
  {
    "i": "1377",
    "county": "Galway",
    "rollNumber": "19357W",
    "schoolName": "Sn Tir Na Cille",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H91W635",
    "addressOne": "Tí­r Na Cille",
    "addressTwo": "An Mam",
    "addressThree": "Co. Na Gaillimhe",
    "addressFour": "",
    "lat": "53.5107491",
    "lng": "-9.5656416",
    "phone": "91571168",
    "email": "sntirnacille@gmail.com"
  },
  {
    "i": "1378",
    "county": "Galway",
    "rollNumber": "19371Q",
    "schoolName": "SN Iognaid",
    "SETHours": "195",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.5",
    "spSNA": "0",
    "totalSNA": "3.5",
    "eircode": "H91E364",
    "addressOne": "Bóithrí­n Na Sliogán",
    "addressTwo": "Gaillimh",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.270517",
    "lng": "-9.0624626",
    "phone": "91584491",
    "email": "oifigiognaid@gmail.com"
  },
  {
    "i": "1379",
    "county": "Galway",
    "rollNumber": "19377F",
    "schoolName": "Naomh Colman Mac Duaigh",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "H91F8D2",
    "addressOne": "Tierneevin",
    "addressTwo": "Gort",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.0632697",
    "lng": "-8.8826188",
    "phone": "91631832",
    "email": "tierneevinns@gmail.com"
  },
  {
    "i": "1380",
    "county": "Galway",
    "rollNumber": "19380R",
    "schoolName": "St Oliver Plunkett NS",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "H53DX30",
    "addressOne": "Kilkerrin",
    "addressTwo": "Ballinasloe",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.5561878",
    "lng": "-8.5698549",
    "phone": "949659316",
    "email": "kilkerrinns@gmail.com"
  },
  {
    "i": "1381",
    "county": "Galway",
    "rollNumber": "19388K",
    "schoolName": "Clonberne Central Sch",
    "SETHours": "72.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H53T291",
    "addressOne": "Clonberne",
    "addressTwo": "Ballinasloe",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.5626959",
    "lng": "-8.6477417",
    "phone": "9345936",
    "email": "office@clonbernens.com"
  },
  {
    "i": "1382",
    "county": "Galway",
    "rollNumber": "19391W",
    "schoolName": "Garrafrauns Central Sch",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "H54NY73",
    "addressOne": "Dunmore",
    "addressTwo": "Tuam",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.6327552",
    "lng": "-8.8253609",
    "phone": "9338708",
    "email": "garrafraunsns@gmail.com"
  },
  {
    "i": "1383",
    "county": "Galway",
    "rollNumber": "19401W",
    "schoolName": "SN Caitriona Sois",
    "SETHours": "197.5",
    "spClassTeachingPosts": "4",
    "mainSNA": "3.83",
    "spSNA": "3.66",
    "totalSNA": "7.49",
    "eircode": "H91N5H6",
    "addressOne": "Renmore Avenue",
    "addressTwo": "Renmore",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.2766246",
    "lng": "-9.0176153",
    "phone": "91753613",
    "email": "principal@renmorejuniorschool.com"
  },
  {
    "i": "1384",
    "county": "Galway",
    "rollNumber": "19449E",
    "schoolName": "St Oliver Plunketts Ns",
    "SETHours": "75",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.25",
    "spSNA": "0",
    "totalSNA": "4.25",
    "eircode": "H65T680",
    "addressOne": "Newcastle",
    "addressTwo": "Athenry",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.3430311",
    "lng": "-8.6836783",
    "phone": "91849178",
    "email": "newcastlens@yahoo.ie"
  },
  {
    "i": "1385",
    "county": "Galway",
    "rollNumber": "19468I",
    "schoolName": "Sn Caitriona Sinsear",
    "SETHours": "215",
    "spClassTeachingPosts": "3",
    "mainSNA": "4.67",
    "spSNA": "2.33",
    "totalSNA": "7",
    "eircode": "H91N5H6",
    "addressOne": "Renmore Avenue",
    "addressTwo": "Renmore",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.2766246",
    "lng": "-9.0176153",
    "phone": "91753613",
    "email": "info@renmoreschool.com"
  },
  {
    "i": "1386",
    "county": "Galway",
    "rollNumber": "19506N",
    "schoolName": "Cappatagle Central Sch",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H53D297",
    "addressOne": "Cappataggle",
    "addressTwo": "Ballinasloe",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.2695123",
    "lng": "-8.4103859",
    "phone": "91843124",
    "email": "cappyns@hotmail.com"
  },
  {
    "i": "1387",
    "county": "Galway",
    "rollNumber": "19529C",
    "schoolName": "Scoil Mhuire",
    "SETHours": "172.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.66",
    "spSNA": "0",
    "totalSNA": "5.66",
    "eircode": "H91HF10",
    "addressOne": "Maigh Cuilinn",
    "addressTwo": "Co. Na Gaillimhe",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3396764",
    "lng": "-9.17588",
    "phone": "91555454",
    "email": "moycullencentralschool@gmail.com"
  },
  {
    "i": "1388",
    "county": "Galway",
    "rollNumber": "19544V",
    "schoolName": "Kilchreest Central Sch",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "H62N766",
    "addressOne": "Lackabaun",
    "addressTwo": "Kilchreest",
    "addressThree": "Loughrea",
    "addressFour": "Co. Galway",
    "lat": "53.1660886",
    "lng": "-8.6748763",
    "phone": "91840112",
    "email": "kilchreestns1@gmail.com"
  },
  {
    "i": "1389",
    "county": "Galway",
    "rollNumber": "19744G",
    "schoolName": "Nioclas Naofa",
    "SETHours": "90",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "H54PD32",
    "addressOne": "Sion Hill",
    "addressTwo": "Dunmore",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.620161",
    "lng": "-8.7391403",
    "phone": "9338349",
    "email": "info@dunmorens.com"
  },
  {
    "i": "1390",
    "county": "Galway",
    "rollNumber": "19770H",
    "schoolName": "Gurteen Central Ns",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H53K634",
    "addressOne": "Gurteen",
    "addressTwo": "Ballinasloe",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3717532",
    "lng": "-8.5710366",
    "phone": "909677966",
    "email": "saintkerrills@hotmail.com"
  },
  {
    "i": "1391",
    "county": "Galway",
    "rollNumber": "19795A",
    "schoolName": "Tirellan Heights NS",
    "SETHours": "257.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "6.49",
    "spSNA": "0",
    "totalSNA": "6.49",
    "eircode": "H91X853",
    "addressOne": "Tirellan Heights",
    "addressTwo": "Headford Road",
    "addressThree": "Galway",
    "addressFour": "",
    "lat": "53.289757",
    "lng": "-9.0437733",
    "phone": "91763844",
    "email": "principaltirellan@gmail.com"
  },
  {
    "i": "1392",
    "county": "Galway",
    "rollNumber": "19803T",
    "schoolName": "Sn Seamus Naofa",
    "SETHours": "82.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.75",
    "spSNA": "0",
    "totalSNA": "3.75",
    "eircode": "H91X2X8",
    "addressOne": "Bearna",
    "addressTwo": "Co. Na Gaillimhe",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.2521573",
    "lng": "-9.1467771",
    "phone": "91592575",
    "email": "oifig@barnaprimaryschool.ie"
  },
  {
    "i": "1393",
    "county": "Galway",
    "rollNumber": "19818J",
    "schoolName": "Creggs Central NS",
    "SETHours": "35",
    "spClassTeachingPosts": "1",
    "mainSNA": "1",
    "spSNA": "4",
    "totalSNA": "5",
    "eircode": "F42D592",
    "addressOne": "Creegs",
    "addressTwo": "Via Roscommon",
    "addressThree": "Co Galway",
    "addressFour": "",
    "lat": "53.5920818",
    "lng": "-8.3597706",
    "phone": "906621303",
    "email": "creggsns@eircom.net"
  },
  {
    "i": "1394",
    "county": "Galway",
    "rollNumber": "19828M",
    "schoolName": "Sn Cearn Mor",
    "SETHours": "102.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.5",
    "spSNA": "0",
    "totalSNA": "3.5",
    "eircode": "H91PT80",
    "addressOne": "Bóthar Na Scoile",
    "addressTwo": "An Carn Mór",
    "addressThree": "órán Mór",
    "addressFour": "Co. Na Gaillimhe",
    "lat": "53.3166433",
    "lng": "-8.9007532",
    "phone": "91798718",
    "email": "carnmoreschool@gmail.com"
  },
  {
    "i": "1395",
    "county": "Galway",
    "rollNumber": "19841E",
    "schoolName": "Glinsk NS",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.25",
    "spSNA": "0",
    "totalSNA": "1.25",
    "eircode": "F45YW40",
    "addressOne": "Via Castlerea",
    "addressTwo": "Co Galway",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.6535219",
    "lng": "-8.4427955",
    "phone": "949655257",
    "email": "glinskschool@gmail.com"
  },
  {
    "i": "1396",
    "county": "Galway",
    "rollNumber": "19858V",
    "schoolName": "Gaelscoil Dara",
    "SETHours": "155",
    "spClassTeachingPosts": "0",
    "mainSNA": "5",
    "spSNA": "0",
    "totalSNA": "5",
    "eircode": "H91PN47",
    "addressOne": "Bóthar Bhaile An Locháin",
    "addressTwo": "An Rinn Mhór",
    "addressThree": "Gaillimh",
    "addressFour": "",
    "lat": "53.2755927",
    "lng": "-9.0119889",
    "phone": "91757145",
    "email": "eolas@gaelscoildara.ie"
  },
  {
    "i": "1397",
    "county": "Galway",
    "rollNumber": "19932H",
    "schoolName": "Sn Mhic Dara",
    "SETHours": "100",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.75",
    "spSNA": "0",
    "totalSNA": "2.75",
    "eircode": "H91T4C2",
    "addressOne": "An Ceathrú Rua",
    "addressTwo": "Co. Na Gaillimhe",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.264428",
    "lng": "-9.5972052",
    "phone": "91595395",
    "email": "scoilmhicdara@gmail.com"
  },
  {
    "i": "1398",
    "county": "Galway",
    "rollNumber": "19965W",
    "schoolName": "Scoil Mhuire",
    "SETHours": "97.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.75",
    "spSNA": "0",
    "totalSNA": "3.75",
    "eircode": "H91D7P3",
    "addressOne": "Clarinbridge",
    "addressTwo": "Co. Galway",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.2259228",
    "lng": "-8.8784188",
    "phone": "91796191",
    "email": "info@clarinbridgeschool.ie"
  },
  {
    "i": "1399",
    "county": "Galway",
    "rollNumber": "19969H",
    "schoolName": "Sn Ui Cheithearnaigh",
    "SETHours": "100",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H53W183",
    "addressOne": "Céide Ghearrbhaile",
    "addressTwo": "Béal átha Na Slua",
    "addressThree": "Co. Na Gaillimhe",
    "addressFour": "",
    "lat": "53.3276791",
    "lng": "-8.2406406",
    "phone": "909644347",
    "email": "scoiluich@eircom.net"
  },
  {
    "i": "1400",
    "county": "Galway",
    "rollNumber": "19973V",
    "schoolName": "Scoil Mhuire",
    "SETHours": "112.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "3.42",
    "spSNA": "2.83",
    "totalSNA": "6.25",
    "eircode": "H71HY04",
    "addressOne": "Racecourse Road",
    "addressTwo": "Clifden",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.4907804",
    "lng": "-10.0180235",
    "phone": "9521353",
    "email": "secretary.scoilmhuire@gmail.com"
  },
  {
    "i": "1401",
    "county": "Galway",
    "rollNumber": "19994G",
    "schoolName": "Gaelscoil Mhic Amhlaigh",
    "SETHours": "155",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.5",
    "spSNA": "0",
    "totalSNA": "4.5",
    "eircode": "H91FV4D",
    "addressOne": "Lána An Mhuillearoa",
    "addressTwo": "Cnoc Na Cathrach",
    "addressThree": "Gaillimh",
    "addressFour": "",
    "lat": "53.2732088",
    "lng": "-9.0959628",
    "phone": "91590152",
    "email": "scoilma.ias@gmail.com"
  },
  {
    "i": "1402",
    "county": "Galway",
    "rollNumber": "19996K",
    "schoolName": "St Brendans Ns",
    "SETHours": "115",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.5",
    "spSNA": "0",
    "totalSNA": "4.5",
    "eircode": "H53C792",
    "addressOne": "St Brigid's Road",
    "addressTwo": "Portumna",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.0952359",
    "lng": "-8.2203238",
    "phone": "909741465",
    "email": "portumnans@gmail.com"
  },
  {
    "i": "1403",
    "county": "Galway",
    "rollNumber": "19997M",
    "schoolName": "Scoil Bhrige Agus Bhreandain Naofa",
    "SETHours": "120",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "H91AT10",
    "addressOne": "Corrandulla",
    "addressTwo": "Co. Galway",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3971993",
    "lng": "-8.9941844",
    "phone": "91791093",
    "email": "corrandullans.ias@eircom.net"
  },
  {
    "i": "1404",
    "county": "Galway",
    "rollNumber": "19998O",
    "schoolName": "Gaelscoil De Hide",
    "SETHours": "117.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.75",
    "spSNA": "0",
    "totalSNA": "3.75",
    "eircode": "H91R2RV",
    "addressOne": "Ard Na Mara",
    "addressTwo": "Uarán Mór",
    "addressThree": "Co Na Gaillimhe",
    "addressFour": "",
    "lat": "53.2655797",
    "lng": "-8.9348658",
    "phone": "91790737",
    "email": "gsdehideoifig@gmail.com"
  },
  {
    "i": "1405",
    "county": "Galway",
    "rollNumber": "20000L",
    "schoolName": "Galway Educate Together NS",
    "SETHours": "190",
    "spClassTeachingPosts": "3",
    "mainSNA": "8.5",
    "spSNA": "5.83",
    "totalSNA": "14.33",
    "eircode": "H91HV07",
    "addressOne": "Thomas Hynes Road",
    "addressTwo": "Newcastle",
    "addressThree": "Galway",
    "addressFour": "",
    "lat": "53.2839847",
    "lng": "-9.0708234",
    "phone": "91527887",
    "email": "admin@getns.ie"
  },
  {
    "i": "1406",
    "county": "Galway",
    "rollNumber": "20040A",
    "schoolName": "St Brendans NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H54HY75",
    "addressOne": "Belmont",
    "addressTwo": "Cloghans Hill",
    "addressThree": "Tuam",
    "addressFour": "Co Galway",
    "lat": "53.6072319",
    "lng": "-8.9641633",
    "phone": "9351528",
    "email": "belmontns@eircom.net"
  },
  {
    "i": "1407",
    "county": "Galway",
    "rollNumber": "20042E",
    "schoolName": "Scoil An Chroi Naofa",
    "SETHours": "280",
    "spClassTeachingPosts": "3",
    "mainSNA": "4.83",
    "spSNA": "2",
    "totalSNA": "6.83",
    "eircode": "H53W603",
    "addressOne": "Society Street",
    "addressTwo": "Ballinasloe",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.3315977",
    "lng": "-8.227082",
    "phone": "909644975",
    "email": "info@ballinasloens.ie"
  },
  {
    "i": "1408",
    "county": "Galway",
    "rollNumber": "20061I",
    "schoolName": "Gaelscoil Iarfhlatha",
    "SETHours": "82.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.75",
    "spSNA": "0",
    "totalSNA": "2.75",
    "eircode": "H54CC80",
    "addressOne": "Tí­r An Chóir",
    "addressTwo": "Tuaim",
    "addressThree": "Co. Na Gaillimhe",
    "addressFour": "",
    "lat": "53.5071605",
    "lng": "-8.8529917",
    "phone": "9326525",
    "email": "oifig@gaelscoiliarfhlatha.com"
  },
  {
    "i": "1409",
    "county": "Galway",
    "rollNumber": "20108I",
    "schoolName": "St. John The Apostle, Knocknacarra Ns",
    "SETHours": "202.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "6",
    "spSNA": "0",
    "totalSNA": "6",
    "eircode": "H91R3N1",
    "addressOne": "Western Distributor Road",
    "addressTwo": "Galway",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.2676386",
    "lng": "-9.1040921",
    "phone": "91573027",
    "email": "principal@knocknacarrans.ie"
  },
  {
    "i": "1410",
    "county": "Galway",
    "rollNumber": "20115F",
    "schoolName": "Scoil Einne",
    "SETHours": "72.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.33",
    "spSNA": "0",
    "totalSNA": "4.33",
    "eircode": "H91N9C9",
    "addressOne": "An Spidéal",
    "addressTwo": "Co. Na Gaillimhe",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.2446837",
    "lng": "-9.3028733",
    "phone": "91504970",
    "email": "scoileinnespideal@gmail.com"
  },
  {
    "i": "1411",
    "county": "Galway",
    "rollNumber": "20123E",
    "schoolName": "Gaelscoil Riabhach",
    "SETHours": "92.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "H62TK22",
    "addressOne": "Cois Móna",
    "addressTwo": "Baile Locha Riach",
    "addressThree": "Co. Na Gaillimhe",
    "addressFour": "",
    "lat": "53.2053721",
    "lng": "-8.5854445",
    "phone": "91847865",
    "email": "oifig@gaelscoilriabhach.ie"
  },
  {
    "i": "1412",
    "county": "Galway",
    "rollNumber": "20199O",
    "schoolName": "Scoil Chuimí­n & Caitrí­ona",
    "SETHours": "135",
    "spClassTeachingPosts": "1",
    "mainSNA": "4.66",
    "spSNA": "2",
    "totalSNA": "6.66",
    "eircode": "H91PN35",
    "addressOne": "Carrowmanagh",
    "addressTwo": "Oughterard",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.4299351",
    "lng": "-9.3263783",
    "phone": "91552074",
    "email": "modomhnaill@gmail.com"
  },
  {
    "i": "1413",
    "county": "Galway",
    "rollNumber": "20210W",
    "schoolName": "SN Eoin Pol Ii",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "H91W727",
    "addressOne": "Eoghanacht",
    "addressTwo": "Inis Mor",
    "addressThree": "Oileain Arann",
    "addressFour": "Co Na Gaillimhe",
    "lat": "53.1461829",
    "lng": "-9.7848392",
    "phone": "9961266",
    "email": "scoileoinpol11@eircom.net"
  },
  {
    "i": "1414",
    "county": "Galway",
    "rollNumber": "20211B",
    "schoolName": "Claregalway Educate Together NS",
    "SETHours": "75",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "H91F5EH",
    "addressOne": "Lakeview",
    "addressTwo": "Claregalway",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.3367226",
    "lng": "-8.9383874",
    "phone": "91798356",
    "email": "info@claregalwayet.ie"
  },
  {
    "i": "1415",
    "county": "Galway",
    "rollNumber": "20237T",
    "schoolName": "Gaelscoil Riada",
    "SETHours": "90",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "H65WD54",
    "addressOne": "Bóthar Ráithin",
    "addressTwo": "Baile átha An Rí­",
    "addressThree": "Co. Na Gaillimhe",
    "addressFour": "",
    "lat": "53.3013431",
    "lng": "-8.7473393",
    "phone": "91850638",
    "email": "riada06@gmail.com"
  },
  {
    "i": "1416",
    "county": "Galway",
    "rollNumber": "20264W",
    "schoolName": "Gaelscoil Na Bhfili",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H91E0Y3",
    "addressOne": "Gort Inse Guaire",
    "addressTwo": "Co. Na Gaillimhe",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.062838",
    "lng": "-8.8119511",
    "phone": "91630494",
    "email": "gaelscoilnabhfili123@gmail.com"
  },
  {
    "i": "1417",
    "county": "Galway",
    "rollNumber": "20280U",
    "schoolName": "Newtown Ns",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H54P489",
    "addressOne": "Newtown",
    "addressTwo": "Abbeyknockmoy",
    "addressThree": "Tuam",
    "addressFour": "Co. Galway",
    "lat": "53.4397121",
    "lng": "-8.7289348",
    "phone": "9343722",
    "email": "principal@newtown-ns.ie"
  },
  {
    "i": "1418",
    "county": "Galway",
    "rollNumber": "20326S",
    "schoolName": "Kilcolgan Educate Together Ns",
    "SETHours": "110",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.58",
    "spSNA": "0",
    "totalSNA": "5.58",
    "eircode": "H91Y7HR",
    "addressOne": "Kilcornan",
    "addressTwo": "Clarinbridge",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.2306479",
    "lng": "-8.8608453",
    "phone": "91776595",
    "email": "info@kilcolganetns.com"
  },
  {
    "i": "1419",
    "county": "Galway",
    "rollNumber": "20345W",
    "schoolName": "SN Leitir Meallain",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "H91RX45",
    "addressOne": "Leitir Meallain",
    "addressTwo": "Co Na Gaillimhe",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.2423199",
    "lng": "-9.7322787",
    "phone": "91551374",
    "email": "snleitirm@gmail.com"
  },
  {
    "i": "1420",
    "county": "Galway",
    "rollNumber": "20350P",
    "schoolName": "Merlin Woods Primary School",
    "SETHours": "162.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "4",
    "spSNA": "4",
    "totalSNA": "8",
    "eircode": "H91D7VH",
    "addressOne": "Doughiska Road",
    "addressTwo": "Doughiska",
    "addressThree": "Galway",
    "addressFour": "",
    "lat": "53.2830299",
    "lng": "-8.983643",
    "phone": "91761676",
    "email": "merlinwoodsprimaryschool@gmail.com"
  },
  {
    "i": "1421",
    "county": "Galway",
    "rollNumber": "20410H",
    "schoolName": "Knocknacarra Educate Together Ns",
    "SETHours": "75",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "H91Y38E",
    "addressOne": "An Coimí­n Mór",
    "addressTwo": "Cappagh Road",
    "addressThree": "Knocknacarra",
    "addressFour": "Co. Galway",
    "lat": "53.2649372",
    "lng": "-9.1256044",
    "phone": "91573023",
    "email": "matt@ketns.ie"
  },
  {
    "i": "1422",
    "county": "Galway",
    "rollNumber": "20448J",
    "schoolName": "Annagh Hill Ns",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "H54F104",
    "addressOne": "Ballyglunin",
    "addressTwo": "Tuam",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.4097421",
    "lng": "-8.8160005",
    "phone": "9341590",
    "email": "annaghillns@eircom.net"
  },
  {
    "i": "1423",
    "county": "Galway",
    "rollNumber": "20456I",
    "schoolName": "Tuam Educate Together NS",
    "SETHours": "80",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "H54N237",
    "addressOne": "Dublin Road",
    "addressTwo": "Tuam",
    "addressThree": "Co. Galway",
    "addressFour": "",
    "lat": "53.51215",
    "lng": "-8.8447039",
    "phone": "9326278",
    "email": "office.tuametns@yahoo.com"
  },
  {
    "i": "1424",
    "county": "Galway",
    "rollNumber": "20462D",
    "schoolName": "Cuan Na Gaillimhe Community NS",
    "SETHours": "40.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H91Y38E",
    "addressOne": "An Cimin Mor",
    "addressTwo": "Cappagh Road",
    "addressThree": "Knocknacarra",
    "addressFour": "",
    "lat": "53.2649372",
    "lng": "-9.1256044",
    "phone": "91867387",
    "email": "info@galwaysteinerschool.com"
  },
  {
    "i": "1425",
    "county": "Galway",
    "rollNumber": "20465J",
    "schoolName": "Gort NS",
    "SETHours": "177.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.5",
    "spSNA": "0",
    "totalSNA": "3.5",
    "eircode": "H91AD93",
    "addressOne": "Tubber Road",
    "addressTwo": "Gort",
    "addressThree": "Co Galway",
    "addressFour": "",
    "lat": "53.0628766",
    "lng": "-8.8249836",
    "phone": "91631627",
    "email": "gortnationalschool@gmail.com"
  },
  {
    "i": "1426",
    "county": "Galway",
    "rollNumber": "20547L",
    "schoolName": "Trinity Primary School",
    "SETHours": "492.5",
    "spClassTeachingPosts": "7",
    "mainSNA": "15.56",
    "spSNA": "11.07",
    "totalSNA": "26.63",
    "eircode": "",
    "addressOne": "Tuam",
    "addressTwo": "Co Galway",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.5130146",
    "lng": "-8.8506487",
    "phone": "9328349",
    "email": "sec.campus3@tpstuam.ie"
  },
  {
    "i": "1427",
    "county": "Galway",
    "rollNumber": "20491K",
    "schoolName": "St Columba's NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "H91W8Y8",
    "addressOne": "Ballyturn",
    "addressTwo": "Gort",
    "addressThree": "Co Galway",
    "addressFour": "",
    "lat": "53.0523448",
    "lng": "-8.7523277",
    "phone": "91632064",
    "email": "stcolumbas1ns@gmail.com"
  },
  {
    "i": "1428",
    "county": "Kerry",
    "rollNumber": "00538V",
    "schoolName": "Clochar Daingean",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "V92AD76",
    "addressOne": "An Phrí­omhsráid Uachtarach",
    "addressTwo": "Daingean Í­ Chúis",
    "addressThree": "Co. Chiarraí­",
    "addressFour": "",
    "lat": "52.142211",
    "lng": "-10.2703837",
    "phone": "669151154",
    "email": "bscd01@gmail.com"
  },
  {
    "i": "1429",
    "county": "Kerry",
    "rollNumber": "01396J",
    "schoolName": "Tulloha NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "V93DW99",
    "addressOne": "Bonane",
    "addressTwo": "Kenmare",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "51.8266644",
    "lng": "-9.5260903",
    "phone": "646641977",
    "email": "tullohans@gmail.com"
  },
  {
    "i": "1430",
    "county": "Kerry",
    "rollNumber": "01583I",
    "schoolName": "Glounaguillagh NS",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "V93HX07",
    "addressOne": "Glannagilliagh",
    "addressTwo": "Caragh Lake",
    "addressThree": "Killorglin",
    "addressFour": "Co. Kerry",
    "lat": "52.0720128",
    "lng": "-9.8325591",
    "phone": "669769402",
    "email": "glounaguillaghns@gmail.com"
  },
  {
    "i": "1431",
    "county": "Kerry",
    "rollNumber": "02418V",
    "schoolName": "Knockaderry Farranfore NS",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "V93NF44",
    "addressOne": "Farranfore",
    "addressTwo": "Killarney",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.1715146",
    "lng": "-9.5477539",
    "phone": "669764729",
    "email": "knockaderryfarranforens@gmail.com"
  },
  {
    "i": "1432",
    "county": "Kerry",
    "rollNumber": "03132I",
    "schoolName": "SN Sliabh A Mhadra",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "V92WF40",
    "addressOne": "Ballyduff",
    "addressTwo": "Tralee",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.4605726",
    "lng": "-9.7163791",
    "phone": "667131742",
    "email": "slmhadrans@gmail.com"
  },
  {
    "i": "1433",
    "county": "Kerry",
    "rollNumber": "04062S",
    "schoolName": "Listowel Presentation Primary",
    "SETHours": "97.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "V31CX52",
    "addressOne": "Ballybunion Road",
    "addressTwo": "Listowel",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.4483479",
    "lng": "-9.4960541",
    "phone": "6822294",
    "email": "office@ppslistowel.ie"
  },
  {
    "i": "1434",
    "county": "Kerry",
    "rollNumber": "05348S",
    "schoolName": "Tahilla Community NS",
    "SETHours": "0",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "V93D735",
    "addressOne": "Tahilla",
    "addressTwo": "Sneem",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "51.8337222",
    "lng": "-9.8223946",
    "phone": "646645561",
    "email": "info@tahillacns.ie"
  },
  {
    "i": "1435",
    "county": "Kerry",
    "rollNumber": "05970M",
    "schoolName": "Scoil Barr Dubh",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.75",
    "spSNA": "0",
    "totalSNA": "3.75",
    "eircode": "V93H330",
    "addressOne": "Barraduff",
    "addressTwo": "Headford",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.0592993",
    "lng": "-9.335746",
    "phone": "647754478",
    "email": "barraduff.ias@gmail.com"
  },
  {
    "i": "1436",
    "county": "Kerry",
    "rollNumber": "06227L",
    "schoolName": "Sn Mhaolcheadair",
    "SETHours": "30",
    "spClassTeachingPosts": "1",
    "mainSNA": "0",
    "spSNA": "2",
    "totalSNA": "2",
    "eircode": "V92A313",
    "addressOne": "An Charraig",
    "addressTwo": "Baile Na Ngall",
    "addressThree": "Co. Chiarraí­",
    "addressFour": "",
    "lat": "52.1861576",
    "lng": "-10.3578851",
    "phone": "669155341",
    "email": "scoilmch@gmail.com"
  },
  {
    "i": "1437",
    "county": "Kerry",
    "rollNumber": "07841L",
    "schoolName": "Kilgobnet NS",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "V93DW26",
    "addressOne": "Beaufort",
    "addressTwo": "Killarney",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.0654337",
    "lng": "-9.7293648",
    "phone": "646644622",
    "email": "kilgobnetnationalschool@gmail.com"
  },
  {
    "i": "1438",
    "county": "Kerry",
    "rollNumber": "07990F",
    "schoolName": "Scoil Naomh Carthach",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "V93NP26",
    "addressOne": "Ballyfinane",
    "addressTwo": "Firies",
    "addressThree": "Killarney",
    "addressFour": "Co Kerry",
    "lat": "52.1946423",
    "lng": "-9.6373052",
    "phone": "669764044",
    "email": "ballyfinanens@hotmail.com"
  },
  {
    "i": "1439",
    "county": "Kerry",
    "rollNumber": "08147A",
    "schoolName": "Scoil An Ghleanna Pobal Scoil Náisi",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "V23KV63",
    "addressOne": "Aghort The Glen",
    "addressTwo": "Baile An Sceilg",
    "addressThree": "Co. Chiarraí­",
    "addressFour": "",
    "lat": "51.8434727",
    "lng": "-10.3273002",
    "phone": "669479330",
    "email": "priomhoide@scoilanghleannapsn.ie"
  },
  {
    "i": "1440",
    "county": "Kerry",
    "rollNumber": "08251S",
    "schoolName": "Scoil Naomh Micheal",
    "SETHours": "40",
    "spClassTeachingPosts": "1",
    "mainSNA": "3",
    "spSNA": "1",
    "totalSNA": "4",
    "eircode": "V93X243",
    "addressOne": "West End",
    "addressTwo": "Sneem",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "51.8384501",
    "lng": "-9.9049054",
    "phone": "646645000",
    "email": "sneemns@gmail.com"
  },
  {
    "i": "1441",
    "county": "Kerry",
    "rollNumber": "08530W",
    "schoolName": "Lauragh NS",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "V93HC84",
    "addressOne": "Lauragh Lower",
    "addressTwo": "Co. Kerry",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.7640119",
    "lng": "-9.7773495",
    "phone": "646683578",
    "email": "lauraghns@gmail.com"
  },
  {
    "i": "1442",
    "county": "Kerry",
    "rollNumber": "08687J",
    "schoolName": "SN Muire Gan Smal",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "V23Y597",
    "addressOne": "Coars",
    "addressTwo": "Mastergeehy",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "51.9462826",
    "lng": "-10.1215569",
    "phone": "669472647",
    "email": "coars@eircom.net"
  },
  {
    "i": "1443",
    "county": "Kerry",
    "rollNumber": "08791E",
    "schoolName": "Lissivigeen Mxd NS",
    "SETHours": "82.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.75",
    "spSNA": "0",
    "totalSNA": "2.75",
    "eircode": "V93AH63",
    "addressOne": "Lissivigeen",
    "addressTwo": "Killarney",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.0513289",
    "lng": "-9.4590039",
    "phone": "646632579",
    "email": "lissivigeenscoil@gmail.com"
  },
  {
    "i": "1444",
    "county": "Kerry",
    "rollNumber": "09209B",
    "schoolName": "Castledrum NS",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "V93DF79",
    "addressOne": "Castledrum",
    "addressTwo": "Castlemain",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.1742539",
    "lng": "-9.7718518",
    "phone": "669766256",
    "email": "castledrumns69@gmail.com"
  },
  {
    "i": "1445",
    "county": "Kerry",
    "rollNumber": "09260B",
    "schoolName": "SN Lios Teilic",
    "SETHours": "75",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.75",
    "spSNA": "0",
    "totalSNA": "3.75",
    "eircode": "V92AE92",
    "addressOne": "Listellick",
    "addressTwo": "Tralee",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.2982233",
    "lng": "-9.694381",
    "phone": "667124144",
    "email": "info@listellickprimary.com"
  },
  {
    "i": "1446",
    "county": "Kerry",
    "rollNumber": "09302O",
    "schoolName": "Glenflesk NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "V93PX30",
    "addressOne": "Glenflesk",
    "addressTwo": "Killarney",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.018966",
    "lng": "-9.3823711",
    "phone": "647754624",
    "email": "glenfleskns@gmail.com"
  },
  {
    "i": "1447",
    "county": "Kerry",
    "rollNumber": "09304S",
    "schoolName": "Raheen NS",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "V93HR40",
    "addressOne": "Raheen",
    "addressTwo": "Headford",
    "addressThree": "Killarney",
    "addressFour": "Co. Kerry",
    "lat": "52.0874337",
    "lng": "-9.3661305",
    "phone": "647754447",
    "email": "raheenns1@gmail.com"
  },
  {
    "i": "1448",
    "county": "Kerry",
    "rollNumber": "09708T",
    "schoolName": "Knocknagoshel NS",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.75",
    "spSNA": "0",
    "totalSNA": "1.75",
    "eircode": "V92HD00",
    "addressOne": "Knocknagoshel",
    "addressTwo": "Tralee",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.3311169",
    "lng": "-9.3816245",
    "phone": "6846011",
    "email": "knocknagoshelns@gmail.com"
  },
  {
    "i": "1449",
    "county": "Kerry",
    "rollNumber": "09782I",
    "schoolName": "Ballymacelligott 1 NS",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "V92V243",
    "addressOne": "Flemby",
    "addressTwo": "Ballymacelligott",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.2385586",
    "lng": "-9.6143443",
    "phone": "667137075",
    "email": "flemby.ias@eircom.net"
  },
  {
    "i": "1451",
    "county": "Kerry",
    "rollNumber": "09841V",
    "schoolName": "SN Bhaile An Chrosaigh",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V92AP80",
    "addressOne": "Ballyduff",
    "addressTwo": "Tralee",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.4151097",
    "lng": "-9.6875958",
    "phone": "667131700",
    "email": "ballincrossigns@eircom.net"
  },
  {
    "i": "1452",
    "county": "Kerry",
    "rollNumber": "09878V",
    "schoolName": "Aghatubrid NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "V23KC04",
    "addressOne": "Direen",
    "addressTwo": "Caherciveen",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "51.8914463",
    "lng": "-10.2281235",
    "phone": "669472736",
    "email": "aghatubridnationalschool@gmail.com"
  },
  {
    "i": "1453",
    "county": "Kerry",
    "rollNumber": "09938N",
    "schoolName": "Curranes NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V92KW97",
    "addressOne": "Scoil Ide",
    "addressTwo": "Curranes",
    "addressThree": "Castleisland",
    "addressFour": "Co.kerry",
    "lat": "52.2635134",
    "lng": "-9.490653",
    "phone": "667142021",
    "email": "principal@curranesns.ie"
  },
  {
    "i": "1454",
    "county": "Kerry",
    "rollNumber": "10014Q",
    "schoolName": "Coolick NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V93DW65",
    "addressOne": "Coolick",
    "addressTwo": "Kilcummin",
    "addressThree": "Killarney",
    "addressFour": "Co. Kerry",
    "lat": "52.1248964",
    "lng": "-9.5055338",
    "phone": "669764549",
    "email": "coolickns@gmail.com"
  },
  {
    "i": "1455",
    "county": "Kerry",
    "rollNumber": "10049M",
    "schoolName": "Loughguitane NS",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "V93RF96",
    "addressOne": "Dromickbane",
    "addressTwo": "Muckross",
    "addressThree": "Killarney",
    "addressFour": "Co. Kerry",
    "lat": "52.0253654",
    "lng": "-9.4559396",
    "phone": "646634765",
    "email": "loughquittanens@gmail.com"
  },
  {
    "i": "1456",
    "county": "Kerry",
    "rollNumber": "10050U",
    "schoolName": "Scoil Bhrí­de",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "V93AY90",
    "addressOne": "Scartlea",
    "addressTwo": "Muckross",
    "addressThree": "Killarney",
    "addressFour": "Co Kerry",
    "lat": "52.0392089",
    "lng": "-9.4741289",
    "phone": "646632484",
    "email": "office@loretonskillarney.com"
  },
  {
    "i": "1457",
    "county": "Kerry",
    "rollNumber": "10239R",
    "schoolName": "Crochan Naofa NS",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.75",
    "spSNA": "0",
    "totalSNA": "1.75",
    "eircode": "V93FK88",
    "addressOne": "Caherdaniel",
    "addressTwo": "Killarney",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "51.7705446",
    "lng": "-10.1017352",
    "phone": "669475433",
    "email": "mcmaunsell@yahoo.co.uk"
  },
  {
    "i": "1458",
    "county": "Kerry",
    "rollNumber": "10326M",
    "schoolName": "Scoil Nuachabhail",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.58",
    "spSNA": "0",
    "totalSNA": "2.58",
    "eircode": "V92KX44",
    "addressOne": "Gortatlea",
    "addressTwo": "Tralee",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.234029",
    "lng": "-9.5545326",
    "phone": "667137516",
    "email": "snuachabhail@gmail.com"
  },
  {
    "i": "1459",
    "county": "Kerry",
    "rollNumber": "10394G",
    "schoolName": "Scoil Mhuire B&c",
    "SETHours": "35",
    "spClassTeachingPosts": "1",
    "mainSNA": "4",
    "spSNA": "0.25",
    "totalSNA": "4.25",
    "eircode": "V92X015",
    "addressOne": "Cordal",
    "addressTwo": "Castleisland",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.2288793",
    "lng": "-9.3850251",
    "phone": "667142356",
    "email": "kilmurryschool@gmail.com"
  },
  {
    "i": "1460",
    "county": "Kerry",
    "rollNumber": "10501E",
    "schoolName": "Scoil Easa Dhuibhe",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V31C997",
    "addressOne": "Asdee",
    "addressTwo": "Co. Kerry",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.552212",
    "lng": "-9.5601816",
    "phone": "6841337",
    "email": "asdeens2@gmail.com"
  },
  {
    "i": "1461",
    "county": "Kerry",
    "rollNumber": "10755M",
    "schoolName": "Scoil An Fhirtearaigh",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "V92X795",
    "addressOne": "Baile An Fheirtéaraigh",
    "addressTwo": "Co. Chiarraí­",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.1655087",
    "lng": "-10.408175",
    "phone": "669156135",
    "email": "snfhirtearaigh.ias@eircom.net"
  },
  {
    "i": "1462",
    "county": "Kerry",
    "rollNumber": "10775S",
    "schoolName": "Scoil Chorp Chrí­ost",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "V31YA25",
    "addressOne": "Knockanure",
    "addressTwo": "Moyvane",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.463",
    "lng": "-9.3714353",
    "phone": "6849130",
    "email": "scoilchorpchriost@gmail.com"
  },
  {
    "i": "1463",
    "county": "Kerry",
    "rollNumber": "10957B",
    "schoolName": "SN Mhuire De Lourdes",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V92Y430",
    "addressOne": "The Village",
    "addressTwo": "Lixnaw",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.4059583",
    "lng": "-9.6173562",
    "phone": "667132639",
    "email": "lixnawboys@gmail.com"
  },
  {
    "i": "1464",
    "county": "Kerry",
    "rollNumber": "11067T",
    "schoolName": "SN Naomh Brid",
    "SETHours": "95",
    "spClassTeachingPosts": "0",
    "mainSNA": "7.83",
    "spSNA": "0",
    "totalSNA": "7.83",
    "eircode": "V31CD90",
    "addressOne": "Duagh",
    "addressTwo": "Listowel",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.4132873",
    "lng": "-9.3881153",
    "phone": "6845366",
    "email": "info@duaghns.ie"
  },
  {
    "i": "1465",
    "county": "Kerry",
    "rollNumber": "11248A",
    "schoolName": "Sn An Ghleanna",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "V92DX85",
    "addressOne": "Glin South",
    "addressTwo": "Dingle",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.1691287",
    "lng": "-10.289438",
    "phone": "669152766",
    "email": "scoilanghleanna1877@eircom.net"
  },
  {
    "i": "1466",
    "county": "Kerry",
    "rollNumber": "11363A",
    "schoolName": "Scoil Atha Na Mblath",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "V93KN60",
    "addressOne": "Kilcummin",
    "addressTwo": "Killarney",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.1235207",
    "lng": "-9.3774983",
    "phone": "646643233",
    "email": "scoilanabla@gmail.com"
  },
  {
    "i": "1467",
    "county": "Kerry",
    "rollNumber": "11405N",
    "schoolName": "Faha NS",
    "SETHours": "95",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "V93XH79",
    "addressOne": "Faha",
    "addressTwo": "Killarney",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.1059921",
    "lng": "-9.6424133",
    "phone": "646644619",
    "email": "info@fahans.com"
  },
  {
    "i": "1468",
    "county": "Kerry",
    "rollNumber": "11419B",
    "schoolName": "Scoil Bhreanainn",
    "SETHours": "32.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "2",
    "spSNA": "1",
    "totalSNA": "3",
    "eircode": "V23RX48",
    "addressOne": "Portmagee",
    "addressTwo": "Killarney",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "51.8847539",
    "lng": "-10.3686821",
    "phone": "669477211",
    "email": "portmageens@gmail.com"
  },
  {
    "i": "1469",
    "county": "Kerry",
    "rollNumber": "11746Q",
    "schoolName": "Castlegregory Mxd NS",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.25",
    "spSNA": "0",
    "totalSNA": "2.25",
    "eircode": "V92P962",
    "addressOne": "Strand Road",
    "addressTwo": "Castlegregory",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.2587545",
    "lng": "-10.0164501",
    "phone": "667139419",
    "email": "gregns.ias@eircom.net"
  },
  {
    "i": "1470",
    "county": "Kerry",
    "rollNumber": "12354E",
    "schoolName": "Clogher Mxd NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "V92AH70",
    "addressOne": "Ballydwyer East",
    "addressTwo": "Ballymecelligott",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.2596899",
    "lng": "-9.5693432",
    "phone": "667137166",
    "email": "info@clogherns.ie"
  },
  {
    "i": "1471",
    "county": "Kerry",
    "rollNumber": "12587E",
    "schoolName": "Coolard Mxd NS",
    "SETHours": "70",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "V31TR74",
    "addressOne": "Shronowen",
    "addressTwo": "Coolard",
    "addressThree": "Listowel",
    "addressFour": "",
    "lat": "52.486359",
    "lng": "-9.5185881",
    "phone": "6822300",
    "email": "coolardns@gmail.com"
  },
  {
    "i": "1472",
    "county": "Kerry",
    "rollNumber": "12701W",
    "schoolName": "Scoil An Fhaill Mor",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V23Y510",
    "addressOne": "Foilduff",
    "addressTwo": "Caherciveen",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "51.9798578",
    "lng": "-10.1533599",
    "phone": "669473310",
    "email": "filemorens@gmail.com"
  },
  {
    "i": "1473",
    "county": "Kerry",
    "rollNumber": "12820H",
    "schoolName": "Scoil Realt Na Mara",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "V93A5D6",
    "addressOne": "Cromane",
    "addressTwo": "Killorglin",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.1180965",
    "lng": "-9.9000464",
    "phone": "669769331",
    "email": "info@cromanens.com"
  },
  {
    "i": "1474",
    "county": "Kerry",
    "rollNumber": "12832O",
    "schoolName": "Scoil Mhuire B",
    "SETHours": "150",
    "spClassTeachingPosts": "0",
    "mainSNA": "8.83",
    "spSNA": "0",
    "totalSNA": "8.83",
    "eircode": "V93HK80",
    "addressOne": "Killorglin",
    "addressTwo": "Co. Kerry",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.1083219",
    "lng": "-9.7878254",
    "phone": "669761779",
    "email": "office@scoilmhuirekillorglin.com"
  },
  {
    "i": "1475",
    "county": "Kerry",
    "rollNumber": "12875J",
    "schoolName": "Douglas NS",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.75",
    "spSNA": "0",
    "totalSNA": "1.75",
    "eircode": "V93PH28",
    "addressOne": "Douglas",
    "addressTwo": "Killorglin",
    "addressThree": "Kerry",
    "addressFour": "",
    "lat": "52.1141839",
    "lng": "-9.8355028",
    "phone": "669762524",
    "email": "douglaskillorglin@gmail.com"
  },
  {
    "i": "1476",
    "county": "Kerry",
    "rollNumber": "13150Q",
    "schoolName": "Knockanes Mxd NS",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "V93HX80",
    "addressOne": "Knockanes",
    "addressTwo": "Headford",
    "addressThree": "Killarney",
    "addressFour": "Co. Kerry",
    "lat": "52.0334827",
    "lng": "-9.3777519",
    "phone": "647754038",
    "email": "knockanesnationalschool@gmail.com"
  },
  {
    "i": "1477",
    "county": "Kerry",
    "rollNumber": "13530D",
    "schoolName": "Scoil Mhuire",
    "SETHours": "240",
    "spClassTeachingPosts": "2",
    "mainSNA": "7.5",
    "spSNA": "2",
    "totalSNA": "9.5",
    "eircode": "V92AE70",
    "addressOne": "Moyderwell",
    "addressTwo": "Tralee",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.2680735",
    "lng": "-9.699744",
    "phone": "667124403",
    "email": "admin@moyderwellmercy.ie"
  },
  {
    "i": "1478",
    "county": "Kerry",
    "rollNumber": "13540G",
    "schoolName": "Murhur NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V31T227",
    "addressOne": "Listowel Road",
    "addressTwo": "Moyvane",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.5009104",
    "lng": "-9.3721081",
    "phone": "6849522",
    "email": "info@murhurns.com"
  },
  {
    "i": "1479",
    "county": "Kerry",
    "rollNumber": "13615L",
    "schoolName": "Scoil Eoin",
    "SETHours": "270",
    "spClassTeachingPosts": "2",
    "mainSNA": "7.75",
    "spSNA": "4.5",
    "totalSNA": "12.25",
    "eircode": "V92Y653",
    "addressOne": "Balloonagh",
    "addressTwo": "Tralee",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.2731835",
    "lng": "-9.7110575",
    "phone": "667121375",
    "email": "balluamhnach@gmail.com"
  },
  {
    "i": "1480",
    "county": "Kerry",
    "rollNumber": "14366V",
    "schoolName": "Loughfouder NS",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "V92NR44",
    "addressOne": "Knocknagoshel",
    "addressTwo": "Tralee",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.2860135",
    "lng": "-9.3598261",
    "phone": "6846500",
    "email": "loughfouderns1@gmail.com"
  },
  {
    "i": "1481",
    "county": "Kerry",
    "rollNumber": "14767Q",
    "schoolName": "Aghacasla NS",
    "SETHours": "43",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "V92Y312",
    "addressOne": "Aughacasla",
    "addressTwo": "Camp",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.2341616",
    "lng": "-9.9746152",
    "phone": "667139456",
    "email": "camp.ias@eircom.net"
  },
  {
    "i": "1482",
    "county": "Kerry",
    "rollNumber": "14952L",
    "schoolName": "Muire Gan Smal",
    "SETHours": "92.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "2.83",
    "spSNA": "6.66",
    "totalSNA": "9.49",
    "eircode": "V92P803",
    "addressOne": "Old Chapel Lane",
    "addressTwo": "Castleisland",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.229514",
    "lng": "-9.459415",
    "phone": "667141147",
    "email": "info@muiregansmal.ie"
  },
  {
    "i": "1483",
    "county": "Kerry",
    "rollNumber": "14987H",
    "schoolName": "SN An Chlochan",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "V92YP27",
    "addressOne": "An Clochán",
    "addressTwo": "Co. Chiarraí­",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.237191",
    "lng": "-10.1809073",
    "phone": "667138292",
    "email": "snchlochain@gmail.com"
  },
  {
    "i": "1484",
    "county": "Kerry",
    "rollNumber": "14998M",
    "schoolName": "Lyre A Crompane NS",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V31P996",
    "addressOne": "Glashanacree",
    "addressTwo": "Lyracrompane",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.3546956",
    "lng": "-9.4858293",
    "phone": "6848233",
    "email": "lyrens@eircom.net"
  },
  {
    "i": "1485",
    "county": "Kerry",
    "rollNumber": "15033W",
    "schoolName": "SN Treasa Naofa Mxd",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "V92X735",
    "addressOne": "Castletown",
    "addressTwo": "Kilflynn",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.3537463",
    "lng": "-9.6272661",
    "phone": "667135633",
    "email": "knschool@gmail.com"
  },
  {
    "i": "1486",
    "county": "Kerry",
    "rollNumber": "15592M",
    "schoolName": "Sn Ceann Tra Meascaithe",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V92YK09",
    "addressOne": "Ceann Trá",
    "addressTwo": "Trá Lí­",
    "addressThree": "Co. Chiarraí­",
    "addressFour": "",
    "lat": "52.1325174",
    "lng": "-10.358339",
    "phone": "669159868",
    "email": "scoilcheanntra@gmail.com"
  },
  {
    "i": "1487",
    "county": "Kerry",
    "rollNumber": "15644F",
    "schoolName": "Tiernaboul NS",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "V93D362",
    "addressOne": "Killarney",
    "addressTwo": "Co Kerry",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.0741876",
    "lng": "-9.4436511",
    "phone": "646634767",
    "email": "tiernaboul1ns@gmail.com"
  },
  {
    "i": "1488",
    "county": "Kerry",
    "rollNumber": "15878H",
    "schoolName": "Derryquay Mxd NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "V92EK49",
    "addressOne": "Derrymore",
    "addressTwo": "Tralee",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.2394194",
    "lng": "-9.8227867",
    "phone": "667130269",
    "email": "info@derryquayns.ie"
  },
  {
    "i": "1489",
    "county": "Kerry",
    "rollNumber": "15945T",
    "schoolName": "Firies Mxd NS",
    "SETHours": "120",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.5",
    "spSNA": "0",
    "totalSNA": "4.5",
    "eircode": "V93D932",
    "addressOne": "Church Road",
    "addressTwo": "Firies Village",
    "addressThree": "Killarney",
    "addressFour": "Co. Kerry",
    "lat": "52.17074",
    "lng": "-9.5939708",
    "phone": "669764496",
    "email": "info@firiesnationalschool.ie"
  },
  {
    "i": "1490",
    "county": "Kerry",
    "rollNumber": "15978L",
    "schoolName": "Curraheen Mxd NS",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.5",
    "spSNA": "0",
    "totalSNA": "3.5",
    "eircode": "V93XD43",
    "addressOne": "Glenbeigh",
    "addressTwo": "Co Kerry",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.0652279",
    "lng": "-9.9104424",
    "phone": "669768033",
    "email": "curraheen1ns@gmail.com"
  },
  {
    "i": "1491",
    "county": "Kerry",
    "rollNumber": "16014A",
    "schoolName": "St Finians",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.25",
    "spSNA": "0",
    "totalSNA": "3.25",
    "eircode": "V23AX51",
    "addressOne": "Spunkane",
    "addressTwo": "Waterville",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "51.8354957",
    "lng": "-10.171788",
    "phone": "669474685",
    "email": "watervillens@hotmail.com"
  },
  {
    "i": "1492",
    "county": "Kerry",
    "rollNumber": "16217O",
    "schoolName": "An Bhreac Chluain B",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "V92T9P1",
    "addressOne": "Annascaul",
    "addressTwo": "Tralee",
    "addressThree": "Co Kerry",
    "addressFour": "",
    "lat": "52.1536382",
    "lng": "-10.0479267",
    "phone": "669157436",
    "email": "breacchluainias@eircom.net"
  },
  {
    "i": "1493",
    "county": "Kerry",
    "rollNumber": "16281A",
    "schoolName": "Sn Naomh Gobnait",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "V92NY00",
    "addressOne": "Baile An Fheirtéaraigh",
    "addressTwo": "Trá Lí­",
    "addressThree": "Co Chiarrai",
    "addressFour": "",
    "lat": "52.1300187",
    "lng": "-10.4506079",
    "phone": "669156411",
    "email": "scoildhunchaoin.ias@gmail.com"
  },
  {
    "i": "1494",
    "county": "Kerry",
    "rollNumber": "16456J",
    "schoolName": "Scoil Naisiunta Eirc",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V92W592",
    "addressOne": "Baile An Mhóraigh",
    "addressTwo": "Trá Lí­",
    "addressThree": "Co. Chiarraí­",
    "addressFour": "",
    "lat": "52.2153149",
    "lng": "-10.3433225",
    "phone": "669155274",
    "email": "scoilnaomheirc2@gmail.com"
  },
  {
    "i": "1495",
    "county": "Kerry",
    "rollNumber": "16703A",
    "schoolName": "Scoil Na Mbraithre",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V92E062",
    "addressOne": "An Daingean",
    "addressTwo": "Co. Chiarraí­",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.1392676",
    "lng": "-10.2681798",
    "phone": "669152157",
    "email": "scoiliognaidris@gmail.com"
  },
  {
    "i": "1496",
    "county": "Kerry",
    "rollNumber": "16744O",
    "schoolName": "Boheshill Mxd",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "V93EC56",
    "addressOne": "Boheshil",
    "addressTwo": "Glencar",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "51.9753335",
    "lng": "-9.8639875",
    "phone": "669760996",
    "email": "boheshill@hotmail.com"
  },
  {
    "i": "1497",
    "county": "Kerry",
    "rollNumber": "16779K",
    "schoolName": "Scoil Caitlin Naofa",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "V92XD92",
    "addressOne": "Cill Mhic An Domhnaigh,",
    "addressTwo": "Ceann Trá,",
    "addressThree": "Trá Lí­,",
    "addressFour": "Co. Chiarraí­.",
    "lat": "52.1121157",
    "lng": "-10.3941954",
    "phone": "876699901",
    "email": "scoilchaitlin.ias@gmail.com"
  },
  {
    "i": "1498",
    "county": "Kerry",
    "rollNumber": "16871V",
    "schoolName": "SN An Chroi Naofa",
    "SETHours": "132.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "V92X093",
    "addressOne": "Castle Street Upper",
    "addressTwo": "Tralee",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.2683239",
    "lng": "-9.7013555",
    "phone": "667123314",
    "email": "presprimarytralee@gmail.com"
  },
  {
    "i": "1499",
    "county": "Kerry",
    "rollNumber": "16898S",
    "schoolName": "SN Breandan Naofa",
    "SETHours": "100",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.5",
    "spSNA": "0",
    "totalSNA": "4.5",
    "eircode": "V92VF10",
    "addressOne": "Cathar Ui Mhodhrain",
    "addressTwo": "Traighli",
    "addressThree": "Co Chiarrai",
    "addressFour": "",
    "lat": "52.2545641",
    "lng": "-9.7384947",
    "phone": "667120207",
    "email": "info@blennervillens.ie"
  },
  {
    "i": "1500",
    "county": "Kerry",
    "rollNumber": "16917T",
    "schoolName": "Naomh Padraig Measc",
    "SETHours": "97.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "5",
    "spSNA": "0",
    "totalSNA": "5",
    "eircode": "V92W248",
    "addressOne": "Cathair Leithin",
    "addressTwo": "Traighli",
    "addressThree": "Co Chiarrai",
    "addressFour": "",
    "lat": "52.242941",
    "lng": "-9.6755279",
    "phone": "667121919",
    "email": "caherleaheen@hotmail.com"
  },
  {
    "i": "1501",
    "county": "Kerry",
    "rollNumber": "17012B",
    "schoolName": "SN An Fhossa",
    "SETHours": "92.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "5.83",
    "spSNA": "4",
    "totalSNA": "9.83",
    "eircode": "V93FY59",
    "addressOne": "Fossa",
    "addressTwo": "Killarney",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.0709992",
    "lng": "-9.5831539",
    "phone": "646634863",
    "email": "fossaschool@gmail.com"
  },
  {
    "i": "1502",
    "county": "Kerry",
    "rollNumber": "17072T",
    "schoolName": "SN Cill Cruinn",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "V31HE92",
    "addressOne": "Listowel",
    "addressTwo": "Co. Kerry",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.4326859",
    "lng": "-9.549059",
    "phone": "6840419",
    "email": "killocrimns@eircom.net"
  },
  {
    "i": "1503",
    "county": "Kerry",
    "rollNumber": "17161S",
    "schoolName": "Kiltallagh NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V93KV76",
    "addressOne": "Kiltallagh",
    "addressTwo": "Castlemaine",
    "addressThree": "Co Kerry",
    "addressFour": "",
    "lat": "52.1705577",
    "lng": "-9.7006575",
    "phone": "669767718",
    "email": "info@kiltallaghns.ie"
  },
  {
    "i": "1504",
    "county": "Kerry",
    "rollNumber": "17231N",
    "schoolName": "SN Cill Cuimin",
    "SETHours": "82.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "V93HF82",
    "addressOne": "Clashnagarrane",
    "addressTwo": "Kilcummin",
    "addressThree": "Killarney",
    "addressFour": "Co. Kerry",
    "lat": "52.097473",
    "lng": "-9.4712777",
    "phone": "646643163",
    "email": "kill43163@gmail.com"
  },
  {
    "i": "1505",
    "county": "Kerry",
    "rollNumber": "17349N",
    "schoolName": "SN An Leana Mhoir",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V31F702",
    "addressOne": "Lenamore",
    "addressTwo": "Ballylongford",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.5237609",
    "lng": "-9.4146712",
    "phone": "6843941",
    "email": "lenamoreps.ias@eircom.net"
  },
  {
    "i": "1506",
    "county": "Kerry",
    "rollNumber": "17358O",
    "schoolName": "SN Naomh Eirc",
    "SETHours": "62.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V92W942",
    "addressOne": "Cill Mhaoile",
    "addressTwo": "Ard Fhearta",
    "addressThree": "Co. Chiarrai",
    "addressFour": "",
    "lat": "52.3692498",
    "lng": "-9.7606254",
    "phone": "667133376",
    "email": "sterc@eircom.net"
  },
  {
    "i": "1507",
    "county": "Kerry",
    "rollNumber": "17365L",
    "schoolName": "Two Mile Community NS",
    "SETHours": "18",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V93WD82",
    "addressOne": "Aughaleemore",
    "addressTwo": "Killarney",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.095689",
    "lng": "-9.539628",
    "phone": "646633018",
    "email": "principal@twomilecns.ie"
  },
  {
    "i": "1508",
    "county": "Kerry",
    "rollNumber": "17646T",
    "schoolName": "SN Uaimh Bhreanainn",
    "SETHours": "90",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.5",
    "spSNA": "0",
    "totalSNA": "4.5",
    "eircode": "V92AE73",
    "addressOne": "Cill Dubh",
    "addressTwo": "Tra Li",
    "addressThree": "Co Chiarrai",
    "addressFour": "V92 Ae73",
    "lat": "52.2732119",
    "lng": "-9.615203",
    "phone": "667137448",
    "email": "obrennanns@gmail.com"
  },
  {
    "i": "1509",
    "county": "Kerry",
    "rollNumber": "17710C",
    "schoolName": "SN An Chuilleanaig",
    "SETHours": "107.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "6",
    "spSNA": "4",
    "totalSNA": "10",
    "eircode": "V93RC81",
    "addressOne": "Beaufort",
    "addressTwo": "Killarney",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.0618844",
    "lng": "-9.6585114",
    "phone": "646644788",
    "email": "cullinaschool@yahoo.com"
  },
  {
    "i": "1510",
    "county": "Kerry",
    "rollNumber": "17744T",
    "schoolName": "SN Gniomh Go Leith B",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "P51X450",
    "addressOne": "Rathmore",
    "addressTwo": "Co Kerry",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.1188213",
    "lng": "-9.2734596",
    "phone": "647756368",
    "email": "gneeveguillans.ias@eircom.net"
  },
  {
    "i": "1511",
    "county": "Kerry",
    "rollNumber": "17747C",
    "schoolName": "SN Na Srona",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "P51ET85",
    "addressOne": "Rathmore",
    "addressTwo": "Co. Kerry",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.0453708",
    "lng": "-9.262138",
    "phone": "647758687",
    "email": "shronens@gmail.com"
  },
  {
    "i": "1512",
    "county": "Kerry",
    "rollNumber": "17915U",
    "schoolName": "Freastogail Mhuire Mxd",
    "SETHours": "27.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "1",
    "spSNA": "3.49",
    "totalSNA": "4.49",
    "eircode": "V92XH31",
    "addressOne": "Killahan",
    "addressTwo": "Abbeydorney",
    "addressThree": "Tralee",
    "addressFour": "Co. Kerry",
    "lat": "52.373166",
    "lng": "-9.7204824",
    "phone": "667135925",
    "email": "killahanprimary@gmail.com"
  },
  {
    "i": "1513",
    "county": "Kerry",
    "rollNumber": "18039D",
    "schoolName": "Na Minteoga NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "V93PF30",
    "addressOne": "Meentogues",
    "addressTwo": "Headford",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.0884741",
    "lng": "-9.3047061",
    "phone": "647754500",
    "email": "meentoguesns@gmail.com"
  },
  {
    "i": "1514",
    "county": "Kerry",
    "rollNumber": "18049G",
    "schoolName": "Muire Na Mainistreach",
    "SETHours": "110",
    "spClassTeachingPosts": "2",
    "mainSNA": "3",
    "spSNA": "1",
    "totalSNA": "4",
    "eircode": "V93T271",
    "addressOne": "New Road",
    "addressTwo": "Killarney",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.0622565",
    "lng": "-9.5174354",
    "phone": "646633687",
    "email": "monkillarney@gmail.com"
  },
  {
    "i": "1515",
    "county": "Kerry",
    "rollNumber": "18084I",
    "schoolName": "Scoil Mhuire Gan Smal",
    "SETHours": "23",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V92YK84",
    "addressOne": "Ballinageragh",
    "addressTwo": "Lixnaw",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.4000785",
    "lng": "-9.6168561",
    "phone": "667132600",
    "email": "smgslixnaw@yahoo.ie"
  },
  {
    "i": "1516",
    "county": "Kerry",
    "rollNumber": "18184M",
    "schoolName": "SN Cill Lúraigh",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.33",
    "spSNA": "0",
    "totalSNA": "2.33",
    "eircode": "V92EY40",
    "addressOne": "Causeway",
    "addressTwo": "Tralee",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.420419",
    "lng": "-9.7399939",
    "phone": "667131088",
    "email": "killuryns1@gmail.com"
  },
  {
    "i": "1517",
    "county": "Kerry",
    "rollNumber": "18214S",
    "schoolName": "Sn Cill Conla",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "V31YC04",
    "addressOne": "Cill Conla",
    "addressTwo": "Ballybunion",
    "addressThree": "Co Kerry",
    "addressFour": "",
    "lat": "52.5492337",
    "lng": "-9.6515686",
    "phone": "6827833",
    "email": "cillconla@gmail.com"
  },
  {
    "i": "1518",
    "county": "Kerry",
    "rollNumber": "18233W",
    "schoolName": "St Johns Parochial School",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "V92EV50",
    "addressOne": "Ashe Street",
    "addressTwo": "Tralee",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.2713521",
    "lng": "-9.7038454",
    "phone": "667128142",
    "email": "jschooltralee@gmail.com"
  },
  {
    "i": "1519",
    "county": "Kerry",
    "rollNumber": "18247K",
    "schoolName": "SN Mhuire Na Mbraithre",
    "SETHours": "347.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "9",
    "spSNA": "2.75",
    "totalSNA": "11.75",
    "eircode": "V92FD62",
    "addressOne": "Clounalour",
    "addressTwo": "Tralee",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.2726904",
    "lng": "-9.6987713",
    "phone": "667124029",
    "email": "secretary@cbsprimarytralee.com"
  },
  {
    "i": "1520",
    "county": "Kerry",
    "rollNumber": "18283O",
    "schoolName": "Scoil Mhuire",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V92E982",
    "addressOne": "Knockognoe",
    "addressTwo": "Brosna",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.3126332",
    "lng": "-9.2765471",
    "phone": "6844577",
    "email": "scoilmhuirebrosna@gmail.com"
  },
  {
    "i": "1521",
    "county": "Kerry",
    "rollNumber": "18325E",
    "schoolName": "Naomh Charthaigh",
    "SETHours": "42.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "2",
    "spSNA": "1",
    "totalSNA": "3",
    "eircode": "V92DY26",
    "addressOne": "College Road",
    "addressTwo": "Castleisland",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.2353819",
    "lng": "-9.4558434",
    "phone": "667142420",
    "email": "naomhcharthaigh@gmail.com"
  },
  {
    "i": "1522",
    "county": "Kerry",
    "rollNumber": "18414D",
    "schoolName": "SN Gleann Beithe",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "V93KD50",
    "addressOne": "Glenbeigh",
    "addressTwo": "Co. Kerry",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.0387501",
    "lng": "-9.965801",
    "phone": "669768468",
    "email": "glenbeighns@eircom.net"
  },
  {
    "i": "1523",
    "county": "Kerry",
    "rollNumber": "18573A",
    "schoolName": "Scoil Chriost Ri",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "V92TD45",
    "addressOne": "Drumnacurra",
    "addressTwo": "Causeway",
    "addressThree": "Tralee",
    "addressFour": "",
    "lat": "52.4354042",
    "lng": "-9.7655212",
    "phone": "667131911",
    "email": "info@scoilchriostri.ie"
  },
  {
    "i": "1524",
    "county": "Kerry",
    "rollNumber": "18590A",
    "schoolName": "Scoil Naomh Erc",
    "SETHours": "62.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.66",
    "spSNA": "0",
    "totalSNA": "4.66",
    "eircode": "V92TP94",
    "addressOne": "Glenderry",
    "addressTwo": "Ballyheigue",
    "addressThree": "Tralee",
    "addressFour": "Co. Kerry",
    "lat": "52.3996558",
    "lng": "-9.8883072",
    "phone": "667133827",
    "email": "scoilerc@gmail.com"
  },
  {
    "i": "1525",
    "county": "Kerry",
    "rollNumber": "18665F",
    "schoolName": "SN Mainistir O Dtorna",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.5",
    "spSNA": "0",
    "totalSNA": "3.5",
    "eircode": "V92KC59",
    "addressOne": "Abbeydorney",
    "addressTwo": "Tralee",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.3456102",
    "lng": "-9.6913819",
    "phone": "667135747",
    "email": "odorney.ns@gmail.com"
  },
  {
    "i": "1526",
    "county": "Kerry",
    "rollNumber": "18702I",
    "schoolName": "Spa NS",
    "SETHours": "87.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "V92CY93",
    "addressOne": "Ballygarron",
    "addressTwo": "Spa",
    "addressThree": "Tralee",
    "addressFour": "Co. Kerry",
    "lat": "52.2750624",
    "lng": "-9.785997",
    "phone": "667136618",
    "email": "info@spanationalschool.ie"
  },
  {
    "i": "1527",
    "county": "Kerry",
    "rollNumber": "18705O",
    "schoolName": "Tarbert NS",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "V31TW13",
    "addressOne": "Chapel Street",
    "addressTwo": "Tarbert",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.5707586",
    "lng": "-9.3746809",
    "phone": "6836282",
    "email": "tarbertns@gmail.com"
  },
  {
    "i": "1528",
    "county": "Kerry",
    "rollNumber": "18756I",
    "schoolName": "Fibough NS",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "V93RW24",
    "addressOne": "Caislean Na Mainge",
    "addressTwo": "Co Chiarrai",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.1648996",
    "lng": "-9.8283087",
    "phone": "669766301",
    "email": "fyboughns1964@gmail.com"
  },
  {
    "i": "1529",
    "county": "Kerry",
    "rollNumber": "18759O",
    "schoolName": "Cahir NS",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "V93TD4V",
    "addressOne": "Caher West",
    "addressTwo": "Kenmare",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "51.8937784",
    "lng": "-9.5269329",
    "phone": "646642244",
    "email": "cahirschool@gmail.com"
  },
  {
    "i": "1530",
    "county": "Kerry",
    "rollNumber": "18832V",
    "schoolName": "Castlemaine NS",
    "SETHours": "62.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "3.66",
    "spSNA": "5",
    "totalSNA": "8.66",
    "eircode": "V93F864",
    "addressOne": "Castlemaine",
    "addressTwo": "Co. Kerry",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.168528",
    "lng": "-9.7028248",
    "phone": "669767819",
    "email": "stjosephscastlemaine@gmail.com"
  },
  {
    "i": "1531",
    "county": "Kerry",
    "rollNumber": "18856M",
    "schoolName": "Scoil Naomh Iosef",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V92DR72",
    "addressOne": "Ballyheigue",
    "addressTwo": "Tralee",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.4037092",
    "lng": "-9.8144563",
    "phone": "667133080",
    "email": "stjosephsns@live.ie"
  },
  {
    "i": "1532",
    "county": "Kerry",
    "rollNumber": "19304B",
    "schoolName": "SN Cillin Liath",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "V23Y540",
    "addressOne": "Máistir Gaoithe",
    "addressTwo": "Cill Airne",
    "addressThree": "Co. Chiarraí­",
    "addressFour": "",
    "lat": "51.9049445",
    "lng": "-10.0638027",
    "phone": "669474474",
    "email": "cillinliathns@gmail.com"
  },
  {
    "i": "1533",
    "county": "Kerry",
    "rollNumber": "19384C",
    "schoolName": "Ardfert Central NS",
    "SETHours": "85",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "V92CD63",
    "addressOne": "Station Road",
    "addressTwo": "Ardfert",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.3234146",
    "lng": "-9.7759861",
    "phone": "667134289",
    "email": "ardfertns.ias@eircom.net"
  },
  {
    "i": "1534",
    "county": "Kerry",
    "rollNumber": "19436S",
    "schoolName": "Sn Naomh Mhichil",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V23PN30",
    "addressOne": "Dungeagáin",
    "addressTwo": "Baile 'n Sceilg",
    "addressThree": "Co Chiarrai",
    "addressFour": "",
    "lat": "51.8330048",
    "lng": "-10.2657215",
    "phone": "669479271",
    "email": "scoilmhichil78@gmail.com"
  },
  {
    "i": "1535",
    "county": "Kerry",
    "rollNumber": "19448C",
    "schoolName": "SN Realt Na Mara",
    "SETHours": "22.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "1",
    "spSNA": "1",
    "totalSNA": "2",
    "eircode": "V93K593",
    "addressOne": "Tuath O Siosta",
    "addressTwo": "Cill Airne",
    "addressThree": "Co Chiarrai",
    "addressFour": "",
    "lat": "51.8066061",
    "lng": "-9.7503735",
    "phone": "646684504",
    "email": "info@tuosistns.ie"
  },
  {
    "i": "1536",
    "county": "Kerry",
    "rollNumber": "19458F",
    "schoolName": "Kilgarvan Central Schl",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "V93HP79",
    "addressOne": "Kilgarvan",
    "addressTwo": "Co. Kerry",
    "addressThree": "",
    "addressFour": "",
    "lat": "51.9061915",
    "lng": "-9.442083",
    "phone": "646685428",
    "email": "kilgarvanschool@gmail.com"
  },
  {
    "i": "1537",
    "county": "Kerry",
    "rollNumber": "19461R",
    "schoolName": "Eiltin Naofa",
    "SETHours": "75",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.5",
    "spSNA": "0",
    "totalSNA": "3.5",
    "eircode": "V31Y266",
    "addressOne": "Lios Eiltin",
    "addressTwo": "Co. Chiarrai",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.487799",
    "lng": "-9.5780626",
    "phone": "6847240",
    "email": "scoileiltinnaofa@gmail.com"
  },
  {
    "i": "1538",
    "county": "Kerry",
    "rollNumber": "19483E",
    "schoolName": "SN Dar Earca",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V23R928",
    "addressOne": "Ballyhearny",
    "addressTwo": "Valentia",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "51.9088017",
    "lng": "-10.3333396",
    "phone": "669476239",
    "email": "valentians@gmail.com"
  },
  {
    "i": "1539",
    "county": "Kerry",
    "rollNumber": "19487M",
    "schoolName": "Holy Cross Primary School",
    "SETHours": "200",
    "spClassTeachingPosts": "3",
    "mainSNA": "8",
    "spSNA": "5.32",
    "totalSNA": "13.32",
    "eircode": "V93A096",
    "addressOne": "New Road",
    "addressTwo": "Killarney",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.0626842",
    "lng": "-9.5139043",
    "phone": "646631241",
    "email": "holycrossmercy.ias@eircom.net"
  },
  {
    "i": "1540",
    "county": "Kerry",
    "rollNumber": "19492F",
    "schoolName": "Sn Oilibhear Naofa",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "V31KD88",
    "addressOne": "Ballylongford",
    "addressTwo": "Co. Kerry",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.5451193",
    "lng": "-9.4791514",
    "phone": "6843477",
    "email": "ballyns.ias@eircom.net"
  },
  {
    "i": "1541",
    "county": "Kerry",
    "rollNumber": "19512I",
    "schoolName": "St Olivers Ns",
    "SETHours": "413",
    "spClassTeachingPosts": "6",
    "mainSNA": "15.75",
    "spSNA": "8.25",
    "totalSNA": "24",
    "eircode": "V93W594",
    "addressOne": "Ballycasheen",
    "addressTwo": "Killarney",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.055667",
    "lng": "-9.4928232",
    "phone": "646632047",
    "email": "info@stolivers.ie"
  },
  {
    "i": "1542",
    "county": "Kerry",
    "rollNumber": "19536W",
    "schoolName": "Holy Family",
    "SETHours": "145",
    "spClassTeachingPosts": "0",
    "mainSNA": "6",
    "spSNA": "0",
    "totalSNA": "6",
    "eircode": "V92R239",
    "addressOne": "Balloonagh",
    "addressTwo": "Tralee",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.2712878",
    "lng": "-9.712518",
    "phone": "667124161",
    "email": "info@hfstralee.com"
  },
  {
    "i": "1543",
    "county": "Kerry",
    "rollNumber": "19631Q",
    "schoolName": "Gaelscoil Mhic Easmainn",
    "SETHours": "127.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "6.5",
    "spSNA": "0",
    "totalSNA": "6.5",
    "eircode": "V92Y973",
    "addressOne": "Ráth Rónáin",
    "addressTwo": "Trá Lí­",
    "addressThree": "Co. Chiarraí­",
    "addressFour": "",
    "lat": "52.2836681",
    "lng": "-9.6931171",
    "phone": "667121394",
    "email": "caituichonchuir@hotmail.com"
  },
  {
    "i": "1544",
    "county": "Kerry",
    "rollNumber": "19659P",
    "schoolName": "St Brendans NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "V92YW52",
    "addressOne": "Fenit",
    "addressTwo": "Tralee",
    "addressThree": "Co Kerry",
    "addressFour": "",
    "lat": "52.2791143",
    "lng": "-9.8632358",
    "phone": "667136374",
    "email": "stbrendansfenit@gmail.com"
  },
  {
    "i": "1545",
    "county": "Kerry",
    "rollNumber": "19745I",
    "schoolName": "Scartaglin New Cent Sc",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "V93Y443",
    "addressOne": "Scairteach A Ghlinne",
    "addressTwo": "Cill Airne",
    "addressThree": "Co Chiarraí­",
    "addressFour": "",
    "lat": "52.1784809",
    "lng": "-9.4073037",
    "phone": "667147104",
    "email": "principal@scartaglenns.ie"
  },
  {
    "i": "1546",
    "county": "Kerry",
    "rollNumber": "19846O",
    "schoolName": "Realt Na Maidne",
    "SETHours": "112.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "3.83",
    "spSNA": "3",
    "totalSNA": "6.83",
    "eircode": "V31R297",
    "addressOne": "Listowel",
    "addressTwo": "Co. Kerry",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.4473822",
    "lng": "-9.4807339",
    "phone": "6821994",
    "email": "info@scoilrealta.ie"
  },
  {
    "i": "1547",
    "county": "Kerry",
    "rollNumber": "19917L",
    "schoolName": "Gaelscoil Naomh Aogain",
    "SETHours": "77.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "V92HD27",
    "addressOne": "Bóthar An Choláiste",
    "addressTwo": "Oileán Ciarraí­",
    "addressThree": "Co. Chiarraí­",
    "addressFour": "",
    "lat": "52.2336102",
    "lng": "-9.4582725",
    "phone": "667142022",
    "email": "gaelscoilaogain87@gmail.com"
  },
  {
    "i": "1548",
    "county": "Kerry",
    "rollNumber": "19941I",
    "schoolName": "Gaelscoil Faithleann",
    "SETHours": "85",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V93WP62",
    "addressOne": "An Pháirc",
    "addressTwo": "Cill Airne",
    "addressThree": "Co. Chiarraí­",
    "addressFour": "",
    "lat": "52.063536",
    "lng": "-9.4897028",
    "phone": "646634930",
    "email": "gsfaithleann.ias@eircom.net"
  },
  {
    "i": "1549",
    "county": "Kerry",
    "rollNumber": "19957A",
    "schoolName": "Dromclough NS",
    "SETHours": "100",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.5",
    "spSNA": "0",
    "totalSNA": "5.5",
    "eircode": "V31W640",
    "addressOne": "Listowell",
    "addressTwo": "Co. Kerry",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.4075302",
    "lng": "-9.5254476",
    "phone": "6840293",
    "email": "dromc@eircom.net"
  },
  {
    "i": "1550",
    "county": "Kerry",
    "rollNumber": "19986H",
    "schoolName": "SN Eoin Baiste",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "V92CX51",
    "addressOne": "Garraí­ Na Dtor",
    "addressTwo": "Liopoil",
    "addressThree": "Co. Chiarraí­",
    "addressFour": "",
    "lat": "52.1430165",
    "lng": "-10.1425815",
    "phone": "669157408",
    "email": "scoilnaomheoinbaiste@gmail.com"
  },
  {
    "i": "1551",
    "county": "Kerry",
    "rollNumber": "20013U",
    "schoolName": "Gaelscoil Lios Tuathail",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V31E981",
    "addressOne": "Lios Tuathail",
    "addressTwo": "Co Chiarrai",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.448596",
    "lng": "-9.4786888",
    "phone": "6823081",
    "email": "oifig@liostuathail.com"
  },
  {
    "i": "1552",
    "county": "Kerry",
    "rollNumber": "20111U",
    "schoolName": "Holy Family NS",
    "SETHours": "75",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "P51N290",
    "addressOne": "Rathmore",
    "addressTwo": "Co Kerry",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.0763573",
    "lng": "-9.2492667",
    "phone": "647758492",
    "email": "hfnsrathmorekerry@gmail.com"
  },
  {
    "i": "1553",
    "county": "Kerry",
    "rollNumber": "20112W",
    "schoolName": "Caherciveen NS",
    "SETHours": "85",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "V23TW26",
    "addressOne": "O'connell Street",
    "addressTwo": "Cahirciveen",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "51.9474714",
    "lng": "-10.2268809",
    "phone": "669472294",
    "email": "scoilsaidhbhin@gmail.com"
  },
  {
    "i": "1554",
    "county": "Kerry",
    "rollNumber": "20147S",
    "schoolName": "Scoil Mhuire Agus N.treasa",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "V93E981",
    "addressOne": "Currow",
    "addressTwo": "Killarney",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.1858376",
    "lng": "-9.4949954",
    "phone": "669764616",
    "email": "currownationalschool@gmail.com"
  },
  {
    "i": "1555",
    "county": "Kerry",
    "rollNumber": "20158A",
    "schoolName": "Tralee Educate Together Ns",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "V92Y5VC",
    "addressOne": "Collis Sandes House",
    "addressTwo": "Kileen",
    "addressThree": "Oakpark",
    "addressFour": "Tralee",
    "lat": "52.2870462",
    "lng": "-9.690588",
    "phone": "667180506",
    "email": "info@tralee-educate-together.com"
  },
  {
    "i": "1556",
    "county": "Kerry",
    "rollNumber": "20196I",
    "schoolName": "Scoil í­osagáin",
    "SETHours": "105",
    "spClassTeachingPosts": "2",
    "mainSNA": "4.83",
    "spSNA": "5",
    "totalSNA": "9.83",
    "eircode": "V31F208",
    "addressOne": "Church Road",
    "addressTwo": "Ballybunion",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.5132707",
    "lng": "-9.6693935",
    "phone": "6827272",
    "email": "scoiliosagain11@gmail.com"
  },
  {
    "i": "1557",
    "county": "Kerry",
    "rollNumber": "20197K",
    "schoolName": "St Johns Ns",
    "SETHours": "160",
    "spClassTeachingPosts": "1",
    "mainSNA": "5",
    "spSNA": "2",
    "totalSNA": "7",
    "eircode": "V93DX76",
    "addressOne": "Railway Road",
    "addressTwo": "Kenmare",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "51.8847688",
    "lng": "-9.5819588",
    "phone": "646642598",
    "email": "info@stjohnskenmare.ie"
  },
  {
    "i": "1558",
    "county": "Kerry",
    "rollNumber": "20229U",
    "schoolName": "Nagle Rice Primary School",
    "SETHours": "145",
    "spClassTeachingPosts": "0",
    "mainSNA": "6.83",
    "spSNA": "0",
    "totalSNA": "6.83",
    "eircode": "V93EV97",
    "addressOne": "Milltown",
    "addressTwo": "Killarney",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.1427526",
    "lng": "-9.7131509",
    "phone": "669767625",
    "email": "office@naglericens.com"
  },
  {
    "i": "1559",
    "county": "Kerry",
    "rollNumber": "20478S",
    "schoolName": "Ballyduff NS",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.5",
    "spSNA": "0",
    "totalSNA": "4.5",
    "eircode": "V92E796",
    "addressOne": "Ballyduff",
    "addressTwo": "Tralee",
    "addressThree": "Co. Kerry",
    "addressFour": "",
    "lat": "52.4529082",
    "lng": "-9.6664512",
    "phone": "667131496",
    "email": "bduffns.ias@eircom.net"
  },
  {
    "i": "1560",
    "county": "Kildare",
    "rollNumber": "00779U",
    "schoolName": "Presentation Girls Primary School",
    "SETHours": "165",
    "spClassTeachingPosts": "1",
    "mainSNA": "7",
    "spSNA": "1.66",
    "totalSNA": "8.66",
    "eircode": "W23X0C6",
    "addressOne": "Main Street",
    "addressTwo": "Maynooth",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.3831686",
    "lng": "-6.5877499",
    "phone": "16286034",
    "email": "info@presgirlsmaynooth.ie"
  },
  {
    "i": "1561",
    "county": "Kildare",
    "rollNumber": "01821V",
    "schoolName": "SN Rath Mor",
    "SETHours": "105",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "W91VK46",
    "addressOne": "Rathmore",
    "addressTwo": "Naas",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.2061501",
    "lng": "-6.5698168",
    "phone": "45862145",
    "email": "office.rathmorens@gmail.com"
  },
  {
    "i": "1562",
    "county": "Kildare",
    "rollNumber": "06209J",
    "schoolName": "Athy Model School",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.75",
    "spSNA": "0",
    "totalSNA": "1.75",
    "eircode": "R14Y478",
    "addressOne": "Tomard",
    "addressTwo": "Athy",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.0029355",
    "lng": "-6.9854291",
    "phone": "598638545",
    "email": "office@athymodelschool.ie"
  },
  {
    "i": "1563",
    "county": "Kildare",
    "rollNumber": "07790U",
    "schoolName": "Churchtown NS",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "R14VE89",
    "addressOne": "Churchtown",
    "addressTwo": "Athy",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.0095634",
    "lng": "-7.0514737",
    "phone": "598632178",
    "email": "churchathy@gmail.com"
  },
  {
    "i": "1564",
    "county": "Kildare",
    "rollNumber": "08099P",
    "schoolName": "St Laurences NS",
    "SETHours": "220",
    "spClassTeachingPosts": "0",
    "mainSNA": "7",
    "spSNA": "0",
    "totalSNA": "7",
    "eircode": "W91AD80",
    "addressOne": "Sallins",
    "addressTwo": "Co. Kildare",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.2483675",
    "lng": "-6.661504",
    "phone": "45879119",
    "email": "info@sallinsns.ie"
  },
  {
    "i": "1565",
    "county": "Kildare",
    "rollNumber": "09414C",
    "schoolName": "St Laurences NS",
    "SETHours": "102.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "R14P758",
    "addressOne": "Crookstown",
    "addressTwo": "Ballytore",
    "addressThree": "Athy",
    "addressFour": "Co. Kildare",
    "lat": "53.0209578",
    "lng": "-6.8046669",
    "phone": "598623333",
    "email": "officestlaurences@gmail.com"
  },
  {
    "i": "1566",
    "county": "Kildare",
    "rollNumber": "11893G",
    "schoolName": "St Davids Ns",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "W91AE26",
    "addressOne": "Pipers Hill Educational Campus",
    "addressTwo": "Kilcullen Road",
    "addressThree": "Naas",
    "addressFour": "Co. Kildare",
    "lat": "53.1949947",
    "lng": "-6.6737799",
    "phone": "45874087",
    "email": "stdavidsnationalschool@gmail.com"
  },
  {
    "i": "1567",
    "county": "Kildare",
    "rollNumber": "11976K",
    "schoolName": "Scoil Chóca Naofa",
    "SETHours": "142.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "5",
    "spSNA": "2.5",
    "totalSNA": "7.5",
    "eircode": "W23KD79",
    "addressOne": "Church Street",
    "addressTwo": "Kilcock",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.4022159",
    "lng": "-6.6679532",
    "phone": "16287967",
    "email": "office@scoilchoca.ie"
  },
  {
    "i": "1568",
    "county": "Kildare",
    "rollNumber": "12182B",
    "schoolName": "St. John's NS",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "W34K585",
    "addressOne": "Drogheda Street",
    "addressTwo": "Monasterevin",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.1405722",
    "lng": "-7.0630631",
    "phone": "45525953",
    "email": "stjohns_monasterevan@yahoo.com"
  },
  {
    "i": "1569",
    "county": "Kildare",
    "rollNumber": "12998C",
    "schoolName": "SN Cianog Naofa",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.75",
    "spSNA": "0",
    "totalSNA": "1.75",
    "eircode": "W91H260",
    "addressOne": "Timahoe",
    "addressTwo": "Coill Dubh",
    "addressThree": "Naas",
    "addressFour": "Co. Kildare",
    "lat": "53.3296993",
    "lng": "-6.8414519",
    "phone": "45863563",
    "email": "secretary@timahoens.ie"
  },
  {
    "i": "1570",
    "county": "Kildare",
    "rollNumber": "13165G",
    "schoolName": "Kilberry NS",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "R14EY05",
    "addressOne": "Kilberry",
    "addressTwo": "Athy",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.0504556",
    "lng": "-7.0223533",
    "phone": "598638448",
    "email": "kilberry.ias@eircom.net"
  },
  {
    "i": "1571",
    "county": "Kildare",
    "rollNumber": "13328I",
    "schoolName": "St Patricks NS",
    "SETHours": "122.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "4.83",
    "spSNA": "2",
    "totalSNA": "6.83",
    "eircode": "W12FH94",
    "addressOne": "Morristown",
    "addressTwo": "Newbridge",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.177777",
    "lng": "-6.8140046",
    "phone": "45432446",
    "email": "scopadnua.ias@gmail.com"
  },
  {
    "i": "1572",
    "county": "Kildare",
    "rollNumber": "13350B",
    "schoolName": "Scoil Bride",
    "SETHours": "80",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "R56A436",
    "addressOne": "Athgarvan",
    "addressTwo": "The Curragh",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.1491707",
    "lng": "-6.7995435",
    "phone": "45441645",
    "email": "athgarvansecretary@gmail.com"
  },
  {
    "i": "1573",
    "county": "Kildare",
    "rollNumber": "13819E",
    "schoolName": "Primrose Hill Ns",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "W23YE97",
    "addressOne": "Hazelhatch Road",
    "addressTwo": "Celbridge",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.3367026",
    "lng": "-6.5371115",
    "phone": "16273168",
    "email": "phns1814@gmail.com"
  },
  {
    "i": "1574",
    "county": "Kildare",
    "rollNumber": "13902O",
    "schoolName": "Hewetsons NS",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "W91CA34",
    "addressOne": "Millicent",
    "addressTwo": "Clane",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.2797308",
    "lng": "-6.69303",
    "phone": "45868233",
    "email": "info@hewetson.ie"
  },
  {
    "i": "1575",
    "county": "Kildare",
    "rollNumber": "14643V",
    "schoolName": "SN Na Cloiche Moire",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "R93KP89",
    "addressOne": "Ballyraggan",
    "addressTwo": "Rathvilly",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "52.9059564",
    "lng": "-6.7508971",
    "phone": "599161171",
    "email": "bigstonens1@gmail.com"
  },
  {
    "i": "1576",
    "county": "Kildare",
    "rollNumber": "15040T",
    "schoolName": "Mercy Convent Primary School",
    "SETHours": "150",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "W91XC94",
    "addressOne": "Sallins Road",
    "addressTwo": "Naas",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.2212597",
    "lng": "-6.6639482",
    "phone": "45876410",
    "email": "hilarygrant@eircom.net"
  },
  {
    "i": "1577",
    "county": "Kildare",
    "rollNumber": "15456E",
    "schoolName": "Ballyshannon NS",
    "SETHours": "60",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "R56FF60",
    "addressOne": "Ballyshannon",
    "addressTwo": "Kilcullen",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.0873608",
    "lng": "-6.8149281",
    "phone": "45485309",
    "email": "ballyshannonprimary@gmail.com"
  },
  {
    "i": "1578",
    "county": "Kildare",
    "rollNumber": "15769C",
    "schoolName": "Monasterevan Convent",
    "SETHours": "82.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "W34P308",
    "addressOne": "Drogheda Street",
    "addressTwo": "Monasterevin",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.14032",
    "lng": "-7.0614456",
    "phone": "45525561",
    "email": "saintevin@gmail.com"
  },
  {
    "i": "1579",
    "county": "Kildare",
    "rollNumber": "15870O",
    "schoolName": "Scoil Chonnla Phadraig",
    "SETHours": "175",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.5",
    "spSNA": "0",
    "totalSNA": "5.5",
    "eircode": "W12Y198",
    "addressOne": "Chapel Lane",
    "addressTwo": "Newbridge",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.1823853",
    "lng": "-6.7918453",
    "phone": "45432174",
    "email": "info@patricianprimary.ie"
  },
  {
    "i": "1580",
    "county": "Kildare",
    "rollNumber": "15957D",
    "schoolName": "Rathangan BNS",
    "SETHours": "80",
    "spClassTeachingPosts": "1",
    "mainSNA": "3.75",
    "spSNA": "1.66",
    "totalSNA": "5.41",
    "eircode": "R51VP23",
    "addressOne": "Rathangan",
    "addressTwo": "Co. Kildare",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.2222971",
    "lng": "-7.0031045",
    "phone": "45528496",
    "email": "rathanganbns@gmail.com"
  },
  {
    "i": "1581",
    "county": "Kildare",
    "rollNumber": "16302F",
    "schoolName": "St Brigids NS",
    "SETHours": "70",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "R56E782",
    "addressOne": "Ballysax Little",
    "addressTwo": "Curragh",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.1221013",
    "lng": "-6.8306275",
    "phone": "45441829",
    "email": "ballysaxns@gmail.com"
  },
  {
    "i": "1582",
    "county": "Kildare",
    "rollNumber": "16345A",
    "schoolName": "Scoil Bhrí­de",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "R51YC66",
    "addressOne": "Nurney",
    "addressTwo": "Co. Kildare",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.0949081",
    "lng": "-6.9490025",
    "phone": "45526767",
    "email": "sbnurney@gmail.com"
  },
  {
    "i": "1583",
    "county": "Kildare",
    "rollNumber": "16566Q",
    "schoolName": "Scoil Naomh Brid",
    "SETHours": "112.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "W23R8Y9",
    "addressOne": "Main Street",
    "addressTwo": "Celbridge",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.3397701",
    "lng": "-6.5408502",
    "phone": "16272922",
    "email": "oifig@scoilnaomhbrid.com"
  },
  {
    "i": "1586",
    "county": "Kildare",
    "rollNumber": "16654N",
    "schoolName": "SN Brighde",
    "SETHours": "62.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "W12PF82",
    "addressOne": "Milltown",
    "addressTwo": "Newbridge",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.2050899",
    "lng": "-6.8618644",
    "phone": "45433230",
    "email": "scoilbhridemilltown@gmail.com"
  },
  {
    "i": "1587",
    "county": "Kildare",
    "rollNumber": "16705E",
    "schoolName": "Scoil Phadraig Naofa",
    "SETHours": "285",
    "spClassTeachingPosts": "3",
    "mainSNA": "2.33",
    "spSNA": "5.66",
    "totalSNA": "7.99",
    "eircode": "R14D773",
    "addressOne": "An Tom Ard",
    "addressTwo": "Baile átha í­",
    "addressThree": "Co. Chill Dara",
    "addressFour": "",
    "lat": "53.0033623",
    "lng": "-6.9827944",
    "phone": "598634811",
    "email": "info@spnathy.ie"
  },
  {
    "i": "1588",
    "county": "Kildare",
    "rollNumber": "16706G",
    "schoolName": "St Josephs Ns",
    "SETHours": "167.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "5.5",
    "spSNA": "4",
    "totalSNA": "9.5",
    "eircode": "W23RX07",
    "addressOne": "Highfield Park",
    "addressTwo": "Kilcock",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.3988826",
    "lng": "-6.6720711",
    "phone": "16287628",
    "email": "office@stjosephskilcock.com"
  },
  {
    "i": "1589",
    "county": "Kildare",
    "rollNumber": "16707I",
    "schoolName": "Scoil Naisiunta Naomh Pheadar",
    "SETHours": "110",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "W34K449",
    "addressOne": "Monasterevin",
    "addressTwo": "Co. Kildare",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.1426291",
    "lng": "-7.0653373",
    "phone": "45525037",
    "email": "info@stpetersmonasterevin.ie"
  },
  {
    "i": "1590",
    "county": "Kildare",
    "rollNumber": "16777G",
    "schoolName": "SN Nmh Mhuire",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "W91X336",
    "addressOne": "Staplestown",
    "addressTwo": "Donadea",
    "addressThree": "Naas",
    "addressFour": "Co Kildare",
    "lat": "53.3298771",
    "lng": "-6.7670068",
    "phone": "45869229",
    "email": "staplestownns@gmail.com"
  },
  {
    "i": "1591",
    "county": "Kildare",
    "rollNumber": "16817P",
    "schoolName": "Brannoxtown Community NS",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "W91NY67",
    "addressOne": "Brannockstown",
    "addressTwo": "Naas",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.1225504",
    "lng": "-6.697315",
    "phone": "871124310",
    "email": "brannoxtowncns@kwetb.ie"
  },
  {
    "i": "1592",
    "county": "Kildare",
    "rollNumber": "16845U",
    "schoolName": "Rathcoffey NS",
    "SETHours": "72.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.5",
    "spSNA": "0",
    "totalSNA": "4.5",
    "eircode": "W91W012",
    "addressOne": "School Road",
    "addressTwo": "Rathcoffey South",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.3327886",
    "lng": "-6.6757113",
    "phone": "45868721",
    "email": "rathcoffeyschool@yahoo.ie"
  },
  {
    "i": "1593",
    "county": "Kildare",
    "rollNumber": "17254C",
    "schoolName": "Scoil Chorbain",
    "SETHours": "172.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "8",
    "spSNA": "0",
    "totalSNA": "8",
    "eircode": "W91E635",
    "addressOne": "Fairgreen",
    "addressTwo": "Naas",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.2149901",
    "lng": "-6.6630788",
    "phone": "45875508",
    "email": "stcorbans@eircom.net"
  },
  {
    "i": "1594",
    "county": "Kildare",
    "rollNumber": "17341U",
    "schoolName": "Maynooth BNS",
    "SETHours": "235",
    "spClassTeachingPosts": "0",
    "mainSNA": "7.5",
    "spSNA": "0",
    "totalSNA": "7.5",
    "eircode": "W23Y598",
    "addressOne": "Moyglare Road",
    "addressTwo": "Maynooth",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.3836877",
    "lng": "-6.595347",
    "phone": "16293021",
    "email": "maynoothbns@yahoo.ie"
  },
  {
    "i": "1595",
    "county": "Kildare",
    "rollNumber": "17567A",
    "schoolName": "Almhaine NS",
    "SETHours": "107.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "W91AX99",
    "addressOne": "Kilmeague",
    "addressTwo": "Naas",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.2411051",
    "lng": "-6.8525538",
    "phone": "45860043",
    "email": "allen.nationalschool@gmail.com"
  },
  {
    "i": "1596",
    "county": "Kildare",
    "rollNumber": "17650K",
    "schoolName": "SN Ide",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "R14EV65",
    "addressOne": "Kilmead",
    "addressTwo": "Athy",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.0338678",
    "lng": "-6.9016966",
    "phone": "598626100",
    "email": "principal@kilmeadns.ie"
  },
  {
    "i": "1597",
    "county": "Kildare",
    "rollNumber": "17662R",
    "schoolName": "SN Brighde",
    "SETHours": "217.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "4.83",
    "spSNA": "4",
    "totalSNA": "8.83",
    "eircode": "W91PF85",
    "addressOne": "Kill",
    "addressTwo": "Co. Kildare",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.2503981",
    "lng": "-6.58202",
    "phone": "45877592",
    "email": "info@killschool.ie"
  },
  {
    "i": "1598",
    "county": "Kildare",
    "rollNumber": "17674B",
    "schoolName": "St Annes NS",
    "SETHours": "102.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "4",
    "spSNA": "3",
    "totalSNA": "7",
    "eircode": "W23H330",
    "addressOne": "Tipperstown",
    "addressTwo": "Straffan",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.2979873",
    "lng": "-6.5744121",
    "phone": "16273367",
    "email": "office@stannesardclough.ie"
  },
  {
    "i": "1599",
    "county": "Kildare",
    "rollNumber": "17714K",
    "schoolName": "SN Cill Cae",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "R14KC97",
    "addressOne": "Castledermot",
    "addressTwo": "Athy",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "52.9483374",
    "lng": "-6.8928771",
    "phone": "599145289",
    "email": "secretary@kilkeans.com"
  },
  {
    "i": "1600",
    "county": "Kildare",
    "rollNumber": "17787O",
    "schoolName": "SN Colmcill Naofa",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "R14AY61",
    "addressOne": "Moone",
    "addressTwo": "Athy",
    "addressThree": "Co Kildare",
    "addressFour": "",
    "lat": "52.9730419",
    "lng": "-6.8160483",
    "phone": "598624313",
    "email": "mooneschool@hotmail.com"
  },
  {
    "i": "1601",
    "county": "Kildare",
    "rollNumber": "17872F",
    "schoolName": "St Conleths And Marys NS",
    "SETHours": "147.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "4",
    "spSNA": "2",
    "totalSNA": "6",
    "eircode": "W12VN26",
    "addressOne": "Newbridge",
    "addressTwo": "Co. Kildare",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.1836861",
    "lng": "-6.7923626",
    "phone": "45431179",
    "email": "scoilcm@hotmail.com"
  },
  {
    "i": "1602",
    "county": "Kildare",
    "rollNumber": "17873H",
    "schoolName": "SN Connlaodh Naofa N",
    "SETHours": "140",
    "spClassTeachingPosts": "2",
    "mainSNA": "4.15",
    "spSNA": "3.32",
    "totalSNA": "7.47",
    "eircode": "W12WV88",
    "addressOne": "Naas Road",
    "addressTwo": "Newbridge",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.1837766",
    "lng": "-6.7911284",
    "phone": "45431050",
    "email": "office@stconlethinfantschool.ie"
  },
  {
    "i": "1603",
    "county": "Kildare",
    "rollNumber": "17931S",
    "schoolName": "SN Brighde",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "W91P868",
    "addressOne": "Ticknevin",
    "addressTwo": "Carbury",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.3140513",
    "lng": "-6.9529356",
    "phone": "469553521",
    "email": "ticknevin@hotmail.com"
  },
  {
    "i": "1604",
    "county": "Kildare",
    "rollNumber": "17968S",
    "schoolName": "Ursaille Naofa",
    "SETHours": "102.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "W91YY75",
    "addressOne": "Stephenstown South",
    "addressTwo": "Two Mile House",
    "addressThree": "Naas",
    "addressFour": "Co. Kildare",
    "lat": "53.1703518",
    "lng": "-6.6993153",
    "phone": "45871200",
    "email": "office@twomilehouseschool.ie"
  },
  {
    "i": "1605",
    "county": "Kildare",
    "rollNumber": "17995V",
    "schoolName": "SN Oilibhear Plunglead",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "W91XC62",
    "addressOne": "Killina",
    "addressTwo": "Carbury",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.3061727",
    "lng": "-6.9162157",
    "phone": "469553522",
    "email": "office@killinans.com"
  },
  {
    "i": "1606",
    "county": "Kildare",
    "rollNumber": "18018S",
    "schoolName": "Scoil Bhride NS",
    "SETHours": "107.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "2.75",
    "spSNA": "0.83",
    "totalSNA": "3.58",
    "eircode": "R51FP93",
    "addressOne": "Rathangan",
    "addressTwo": "Co. Kildare",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.2228956",
    "lng": "-6.9889944",
    "phone": "45524540",
    "email": "bunscoilbhride9@hotmail.com"
  },
  {
    "i": "1607",
    "county": "Kildare",
    "rollNumber": "18031K",
    "schoolName": "SN Bride",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "R56NR27",
    "addressOne": "Suncroft",
    "addressTwo": "Curragh",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.1093194",
    "lng": "-6.8588934",
    "phone": "45441041",
    "email": "suncroftns@gmail.com"
  },
  {
    "i": "1608",
    "county": "Kildare",
    "rollNumber": "18055B",
    "schoolName": "SN Mhuire",
    "SETHours": "75",
    "spClassTeachingPosts": "1",
    "mainSNA": "2.5",
    "spSNA": "1.66",
    "totalSNA": "4.16",
    "eircode": "W91PF86",
    "addressOne": "Ballymore Eustace",
    "addressTwo": "Naas",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.1347216",
    "lng": "-6.6169115",
    "phone": "45864085",
    "email": "office@bmesch.ie"
  },
  {
    "i": "1609",
    "county": "Kildare",
    "rollNumber": "18063A",
    "schoolName": "SN Naomh Lorcain",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "R93KX24",
    "addressOne": "Levitstown",
    "addressTwo": "Maganey",
    "addressThree": "Athy",
    "addressFour": "Co. Kildare",
    "lat": "52.9106349",
    "lng": "-6.913229",
    "phone": "599145217",
    "email": "snlorcain@yahoo.com"
  },
  {
    "i": "1610",
    "county": "Kildare",
    "rollNumber": "18092H",
    "schoolName": "SN Baile Mhic Adaim",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "W91YX81",
    "addressOne": "Baile Mhic Adaim",
    "addressTwo": "Magh Bhealaigh",
    "addressThree": "Co Cill Dara",
    "addressFour": "",
    "lat": "53.4001131",
    "lng": "-6.9217004",
    "phone": "469551308",
    "email": "cadamstown@gmail.com"
  },
  {
    "i": "1611",
    "county": "Kildare",
    "rollNumber": "18093J",
    "schoolName": "SN Cloch Rinnce",
    "SETHours": "67.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "1",
    "spSNA": "4",
    "totalSNA": "5",
    "eircode": "W91NN8F",
    "addressOne": "Broadford",
    "addressTwo": "Co. Kildare",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3978064",
    "lng": "-7.01498",
    "phone": "469553428",
    "email": "principal@clocharince.ie"
  },
  {
    "i": "1612",
    "county": "Kildare",
    "rollNumber": "18096P",
    "schoolName": "SN Coill Dubh",
    "SETHours": "97.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "3.83",
    "spSNA": "4",
    "totalSNA": "7.83",
    "eircode": "W91D854",
    "addressOne": "Coill Dubh",
    "addressTwo": "Naas",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.2938126",
    "lng": "-6.8209496",
    "phone": "45860023",
    "email": "office@coilldubhns.ie"
  },
  {
    "i": "1613",
    "county": "Kildare",
    "rollNumber": "18130M",
    "schoolName": "St Patricks Ns",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "A83KD59",
    "addressOne": "Johnstown Bridge",
    "addressTwo": "Enfield",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.4024692",
    "lng": "-6.8543859",
    "phone": "469541907",
    "email": "stpatsjtb@yahoo.ie"
  },
  {
    "i": "1614",
    "county": "Kildare",
    "rollNumber": "18179T",
    "schoolName": "SN Bride",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "W34VW50",
    "addressOne": "Lackagh",
    "addressTwo": "Monasterevin",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.1660852",
    "lng": "-7.0080337",
    "phone": "45529134",
    "email": "info@scoilbhridelackagh.ie"
  },
  {
    "i": "1615",
    "county": "Kildare",
    "rollNumber": "18287W",
    "schoolName": "SN Na Maighdine Mhuire",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "W91Y512",
    "addressOne": "Garrisker",
    "addressTwo": "Broadford",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.4204656",
    "lng": "-6.9634625",
    "phone": "469551323",
    "email": "broadfordns@gmail.com"
  },
  {
    "i": "1616",
    "county": "Kildare",
    "rollNumber": "18288B",
    "schoolName": "Scoil Mhichil Naofa",
    "SETHours": "285",
    "spClassTeachingPosts": "8",
    "mainSNA": "3",
    "spSNA": "15.07",
    "totalSNA": "18.07",
    "eircode": "R14XD86",
    "addressOne": "Mount Hawkins",
    "addressTwo": "Athy",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "52.9939358",
    "lng": "-6.9807817",
    "phone": "598631794",
    "email": "schmhna@gmail.com"
  },
  {
    "i": "1617",
    "county": "Kildare",
    "rollNumber": "18378C",
    "schoolName": "SN Naomh Ioseph",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "R56W950",
    "addressOne": "Halverstown",
    "addressTwo": "Kilcullen",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.0897587",
    "lng": "-6.7621092",
    "phone": "45485374",
    "email": "halverstownschool@gmail.com"
  },
  {
    "i": "1618",
    "county": "Kildare",
    "rollNumber": "18430B",
    "schoolName": "SN Baile Roibeaird",
    "SETHours": "90",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "W91D403",
    "addressOne": "Robertstown",
    "addressTwo": "Co. Kildare",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.2671989",
    "lng": "-6.8101494",
    "phone": "45860021",
    "email": "robertstownns@gmail.com"
  },
  {
    "i": "1619",
    "county": "Kildare",
    "rollNumber": "18445O",
    "schoolName": "SN Scoil Treasa",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "A83PC95",
    "addressOne": "Kilshanroe",
    "addressTwo": "Enfield",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.3831861",
    "lng": "-6.8895202",
    "phone": "469541612",
    "email": "kilshanroens@gmail.com"
  },
  {
    "i": "1620",
    "county": "Kildare",
    "rollNumber": "18449W",
    "schoolName": "St Conleths NS",
    "SETHours": "115",
    "spClassTeachingPosts": "2",
    "mainSNA": "3.5",
    "spSNA": "3.66",
    "totalSNA": "7.16",
    "eircode": "W91KC79",
    "addressOne": "Derrinturn",
    "addressTwo": "Carbury",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.3407694",
    "lng": "-6.9383484",
    "phone": "469553490",
    "email": "theprincipal@stconlethsns.ie"
  },
  {
    "i": "1621",
    "county": "Kildare",
    "rollNumber": "18515J",
    "schoolName": "Prosperous NS",
    "SETHours": "175",
    "spClassTeachingPosts": "3",
    "mainSNA": "5.5",
    "spSNA": "7",
    "totalSNA": "12.5",
    "eircode": "W91DT10",
    "addressOne": "Prosperous",
    "addressTwo": "Naas",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.2873594",
    "lng": "-6.7510663",
    "phone": "45868660",
    "email": "enquiries@prosperousns.ie"
  },
  {
    "i": "1622",
    "county": "Kildare",
    "rollNumber": "18551N",
    "schoolName": "Scoil Na Mainistreach",
    "SETHours": "243",
    "spClassTeachingPosts": "2",
    "mainSNA": "6.58",
    "spSNA": "4",
    "totalSNA": "10.58",
    "eircode": "W23VR98",
    "addressOne": "Oldtown Road",
    "addressTwo": "Celbridge",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.3402447",
    "lng": "-6.5544063",
    "phone": "16271149",
    "email": "mainistreach@eircom.net"
  },
  {
    "i": "1623",
    "county": "Kildare",
    "rollNumber": "18644U",
    "schoolName": "Straffan NS",
    "SETHours": "112.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.58",
    "spSNA": "0",
    "totalSNA": "3.58",
    "eircode": "W23CD77",
    "addressOne": "The Glebe",
    "addressTwo": "Newtown",
    "addressThree": "Rathangan",
    "addressFour": "Co. Kildare",
    "lat": "53.3149243",
    "lng": "-6.6122456",
    "phone": "16272255",
    "email": "principal@straffanschool.com"
  },
  {
    "i": "1624",
    "county": "Kildare",
    "rollNumber": "18650P",
    "schoolName": "Newtown Ns",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.25",
    "spSNA": "0",
    "totalSNA": "2.25",
    "eircode": "A83HW74",
    "addressOne": "Newtown",
    "addressTwo": "Enfield",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.394573",
    "lng": "-6.7569275",
    "phone": "469541122",
    "email": "scoilbailenua.ias@eircom.net"
  },
  {
    "i": "1625",
    "county": "Kildare",
    "rollNumber": "18654A",
    "schoolName": "Caragh NS",
    "SETHours": "205",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.5",
    "spSNA": "0",
    "totalSNA": "5.5",
    "eircode": "W91YE97",
    "addressOne": "Caragh",
    "addressTwo": "Naas",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.2371095",
    "lng": "-6.7297958",
    "phone": "45903091",
    "email": "principal@caraghns.ie"
  },
  {
    "i": "1626",
    "county": "Kildare",
    "rollNumber": "18666H",
    "schoolName": "SN Tir Mochain",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "W91HX78",
    "addressOne": "Donadea",
    "addressTwo": "Naas",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.3708558",
    "lng": "-6.7338775",
    "phone": "45869442",
    "email": "office@tiermohanns.ie"
  },
  {
    "i": "1627",
    "county": "Kildare",
    "rollNumber": "18675I",
    "schoolName": "SN Cill Daingin",
    "SETHours": "92.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "W34DR40",
    "addressOne": "Kildangan",
    "addressTwo": "Monasterevan",
    "addressThree": "Co Kildare",
    "addressFour": "",
    "lat": "53.1058476",
    "lng": "-7.0069506",
    "phone": "45523536",
    "email": "kildanganns@hotmail.com"
  },
  {
    "i": "1628",
    "county": "Kildare",
    "rollNumber": "19407L",
    "schoolName": "Scoil Bhride",
    "SETHours": "107.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.25",
    "spSNA": "0",
    "totalSNA": "5.25",
    "eircode": "W23R9Y6",
    "addressOne": "Green Lane",
    "addressTwo": "Leixlip",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.3657666",
    "lng": "-6.5007652",
    "phone": "16244850",
    "email": "oifig.scoilbhrideleixlip@gmail.com"
  },
  {
    "i": "1629",
    "county": "Kildare",
    "rollNumber": "19425N",
    "schoolName": "Ballyroe Central NS",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "R14DX61",
    "addressOne": "Athy",
    "addressTwo": "Co Kildare",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.9618789",
    "lng": "-6.9335486",
    "phone": "598632522",
    "email": "scntreasa@gmail.com"
  },
  {
    "i": "1630",
    "county": "Kildare",
    "rollNumber": "19452Q",
    "schoolName": "Scoil Mhuire",
    "SETHours": "227.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "5",
    "spSNA": "2",
    "totalSNA": "7",
    "eircode": "W12HD29",
    "addressOne": "Ballymany",
    "addressTwo": "Newbridge",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.1732773",
    "lng": "-6.8155826",
    "phone": "45431077",
    "email": "office@scoilmhuire.net"
  },
  {
    "i": "1631",
    "county": "Kildare",
    "rollNumber": "19459H",
    "schoolName": "Scoil Mhuire",
    "SETHours": "107.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "3.75",
    "spSNA": "4",
    "totalSNA": "7.75",
    "eircode": "W23TX49",
    "addressOne": "Green Lane",
    "addressTwo": "Leixlip",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.3658206",
    "lng": "-6.5005578",
    "phone": "16244851",
    "email": "scmhuireleixlip.ias@eircom.net"
  },
  {
    "i": "1632",
    "county": "Kildare",
    "rollNumber": "19550Q",
    "schoolName": "Ballymany Jn Ns",
    "SETHours": "190",
    "spClassTeachingPosts": "1",
    "mainSNA": "7.66",
    "spSNA": "2",
    "totalSNA": "9.66",
    "eircode": "W12ED88",
    "addressOne": "Standhouse Rd.",
    "addressTwo": "Newbridge",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.1732944",
    "lng": "-6.8168763",
    "phone": "45432400",
    "email": "office@scmj.ie"
  },
  {
    "i": "1633",
    "county": "Kildare",
    "rollNumber": "19597T",
    "schoolName": "An Linbh Iosa",
    "SETHours": "180",
    "spClassTeachingPosts": "1",
    "mainSNA": "5.32",
    "spSNA": "1.66",
    "totalSNA": "6.98",
    "eircode": "W91Y266",
    "addressOne": "Ballycane",
    "addressTwo": "Naas",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.2125303",
    "lng": "-6.6540231",
    "phone": "45866964",
    "email": "holychildoffice@eircom.net"
  },
  {
    "i": "1634",
    "county": "Kildare",
    "rollNumber": "19653D",
    "schoolName": "San Carlo Jn Ns",
    "SETHours": "102.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "3.66",
    "spSNA": "2.33",
    "totalSNA": "5.99",
    "eircode": "W23E9D0",
    "addressOne": "Confey",
    "addressTwo": "Leixlip",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3705527",
    "lng": "-6.487352",
    "phone": "16243155",
    "email": "sancarlojns@gmail.com"
  },
  {
    "i": "1635",
    "county": "Kildare",
    "rollNumber": "19675N",
    "schoolName": "St Brigids NS",
    "SETHours": "240",
    "spClassTeachingPosts": "3",
    "mainSNA": "6.66",
    "spSNA": "7.66",
    "totalSNA": "14.32",
    "eircode": "R56RK83",
    "addressOne": "Kilcullen",
    "addressTwo": "Co. Kildare",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.1301467",
    "lng": "-6.750789",
    "phone": "45481428",
    "email": "info@kilcullenns.org"
  },
  {
    "i": "1636",
    "county": "Kildare",
    "rollNumber": "19680G",
    "schoolName": "Scoil C.ui Dhalaigh",
    "SETHours": "105",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "W23PF67",
    "addressOne": "Léim An Bhradáin",
    "addressTwo": "Co. Chill Dara",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3654439",
    "lng": "-6.4949093",
    "phone": "16242061",
    "email": "oifigsud@gmail.com"
  },
  {
    "i": "1637",
    "county": "Kildare",
    "rollNumber": "19684O",
    "schoolName": "Scoil Eoin Phoil",
    "SETHours": "95",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "W23FY81",
    "addressOne": "Green Lane",
    "addressTwo": "Leixlip",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.3656572",
    "lng": "-6.502108",
    "phone": "16243130",
    "email": "scoileoinphoilleixlip@gmail.com"
  },
  {
    "i": "1638",
    "county": "Kildare",
    "rollNumber": "19786W",
    "schoolName": "Castledermot NS Mxd",
    "SETHours": "132.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "R14FX46",
    "addressOne": "Athy Road",
    "addressTwo": "Castledermot",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "52.9135135",
    "lng": "-6.8423399",
    "phone": "599144355",
    "email": "schooloffice@scoildiarmada.com"
  },
  {
    "i": "1639",
    "county": "Kildare",
    "rollNumber": "19794V",
    "schoolName": "Aghards NS",
    "SETHours": "175",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "W23YY00",
    "addressOne": "Scoil Mochua",
    "addressTwo": "Aghards Road",
    "addressThree": "Celbridge",
    "addressFour": "Co. Kildare",
    "lat": "53.3487985",
    "lng": "-6.5494085",
    "phone": "16272963",
    "email": "info@scoilmochua.com"
  },
  {
    "i": "1640",
    "county": "Kildare",
    "rollNumber": "19796C",
    "schoolName": "St Patricks BNS",
    "SETHours": "202.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "7",
    "spSNA": "2",
    "totalSNA": "9",
    "eircode": "W91FC97",
    "addressOne": "Clane",
    "addressTwo": "Co. Kildare",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.2907379",
    "lng": "-6.6957335",
    "phone": "45868620",
    "email": "office@clanebns.ie"
  },
  {
    "i": "1641",
    "county": "Kildare",
    "rollNumber": "19797E",
    "schoolName": "Scoil Naisiunta Bhride",
    "SETHours": "137.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "3",
    "spSNA": "3",
    "totalSNA": "6",
    "eircode": "W91PF77",
    "addressOne": "Prosperous Road",
    "addressTwo": "Clane",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.2908349",
    "lng": "-6.6934862",
    "phone": "45868614",
    "email": "info@scoilbhrideclane.ie"
  },
  {
    "i": "1642",
    "county": "Kildare",
    "rollNumber": "19875V",
    "schoolName": "San Carlo Sn NS",
    "SETHours": "107.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.5",
    "spSNA": "0",
    "totalSNA": "3.5",
    "eircode": "W23E9D0",
    "addressOne": "Captain's Hill",
    "addressTwo": "Leixlip",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.3705527",
    "lng": "-6.487352",
    "phone": "16245002",
    "email": "office@scoilsancarlo.ie"
  },
  {
    "i": "1643",
    "county": "Kildare",
    "rollNumber": "19897I",
    "schoolName": "Scoil Í­ Riada",
    "SETHours": "180",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.5",
    "spSNA": "0",
    "totalSNA": "5.5",
    "eircode": "W23KNW8",
    "addressOne": "An Bhanóg",
    "addressTwo": "Cill Choca",
    "addressThree": "Co Chill Dara",
    "addressFour": "",
    "lat": "53.3998919",
    "lng": "-6.6769866",
    "phone": "16287906",
    "email": "eolas@scoiluiriada.ie"
  },
  {
    "i": "1644",
    "county": "Kildare",
    "rollNumber": "19995I",
    "schoolName": "North Kildare Educate Together Sch",
    "SETHours": "127.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "4.75",
    "spSNA": "4.83",
    "totalSNA": "9.58",
    "eircode": "W23HFX0",
    "addressOne": "Clane Road",
    "addressTwo": "Celbridge",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.3333269",
    "lng": "-6.5574716",
    "phone": "16274388",
    "email": "office@nketns.ie"
  },
  {
    "i": "1645",
    "county": "Kildare",
    "rollNumber": "20023A",
    "schoolName": "Gaelscoil Chill Dara",
    "SETHours": "140",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "R56PR22",
    "addressOne": "Green Road",
    "addressTwo": "Newbridge",
    "addressThree": "Co. Chill Dara",
    "addressFour": "",
    "lat": "53.1587835",
    "lng": "-6.8083775",
    "phone": "45442300",
    "email": "gscoilchilldara@eircom.net"
  },
  {
    "i": "1646",
    "county": "Kildare",
    "rollNumber": "20058T",
    "schoolName": "Scoil Ui Fhiaich",
    "SETHours": "140",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "W23T207",
    "addressOne": "Bóthar Chill Droichid",
    "addressTwo": "Maigh Nuad",
    "addressThree": "Co. Chill Dara",
    "addressFour": "",
    "lat": "53.3696652",
    "lng": "-6.5821061",
    "phone": "16290667",
    "email": "oifig@gaelscoiluifhiaich.ie"
  },
  {
    "i": "1647",
    "county": "Kildare",
    "rollNumber": "20087D",
    "schoolName": "Killashee Multi-denominational Ns",
    "SETHours": "70",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "W91YV60",
    "addressOne": "Kilcullen Road",
    "addressTwo": "Naas",
    "addressThree": "Co Kildare",
    "addressFour": "",
    "lat": "53.1913813",
    "lng": "-6.6780393",
    "phone": "45881636",
    "email": "killasheemdns@gmail.com"
  },
  {
    "i": "1648",
    "county": "Kildare",
    "rollNumber": "20114D",
    "schoolName": "Scoil Brí­d",
    "SETHours": "190",
    "spClassTeachingPosts": "3",
    "mainSNA": "4.83",
    "spSNA": "6.5",
    "totalSNA": "11.33",
    "eircode": "W91YA62",
    "addressOne": "Oldtown",
    "addressTwo": "Naas",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.2313676",
    "lng": "-6.6625938",
    "phone": "45889562",
    "email": "office@scoilbhridenaas.com"
  },
  {
    "i": "1649",
    "county": "Kildare",
    "rollNumber": "20159C",
    "schoolName": "Gaelscoil Nas Na Riogh",
    "SETHours": "115",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "W91WD98",
    "addressOne": "Cnoc An Phí­obaire",
    "addressTwo": "An Nás",
    "addressThree": "Co. Chill Dara",
    "addressFour": "",
    "lat": "53.1967515",
    "lng": "-6.6705454",
    "phone": "45898766",
    "email": "gaelscoilnas@yahoo.ie"
  },
  {
    "i": "1650",
    "county": "Kildare",
    "rollNumber": "20177E",
    "schoolName": "Newbridge Educate Together",
    "SETHours": "147.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.24",
    "spSNA": "0",
    "totalSNA": "5.24",
    "eircode": "R56YC60",
    "addressOne": "Green Road",
    "addressTwo": "The Curragh",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.1587745",
    "lng": "-6.8099068",
    "phone": "45445710",
    "email": "admin@netns.ie"
  },
  {
    "i": "1651",
    "county": "Kildare",
    "rollNumber": "20192A",
    "schoolName": "Gaelscoil átha í­",
    "SETHours": "0",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "R14DP92",
    "addressOne": "An Tom Ard",
    "addressTwo": "Baile átha í­",
    "addressThree": "Co. Chill Dara",
    "addressFour": "",
    "lat": "53.0033436",
    "lng": "-6.9869166",
    "phone": "598634200",
    "email": "gaelscoil_athai@yahoo.ie"
  },
  {
    "i": "1652",
    "county": "Kildare",
    "rollNumber": "20257C",
    "schoolName": "Scoil Naomh Padraig",
    "SETHours": "157.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.33",
    "spSNA": "0",
    "totalSNA": "2.33",
    "eircode": "W23Y300",
    "addressOne": "Hazelhatch",
    "addressTwo": "Celbridge",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.3325505",
    "lng": "-6.5286671",
    "phone": "851069985",
    "email": "stpatricksnscelbridge@gmail.com"
  },
  {
    "i": "1653",
    "county": "Kildare",
    "rollNumber": "20271T",
    "schoolName": "Scoil Na Naomh Uilig",
    "SETHours": "255",
    "spClassTeachingPosts": "5",
    "mainSNA": "9.31",
    "spSNA": "13.5",
    "totalSNA": "22.81",
    "eircode": "W12FK10",
    "addressOne": "Rickardstown",
    "addressTwo": "Newbridge",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.1904836",
    "lng": "-6.8083196",
    "phone": "45434853",
    "email": "office@snu.ie"
  },
  {
    "i": "1654",
    "county": "Kildare",
    "rollNumber": "20292E",
    "schoolName": "Maynooth Educate Together NS",
    "SETHours": "130",
    "spClassTeachingPosts": "2",
    "mainSNA": "2.33",
    "spSNA": "5",
    "totalSNA": "7.33",
    "eircode": "W23P466",
    "addressOne": "Celbridge Road",
    "addressTwo": "Maynooth",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.3703728",
    "lng": "-6.5803649",
    "phone": "16106823",
    "email": "principal@maynoothet.ie"
  },
  {
    "i": "1655",
    "county": "Kildare",
    "rollNumber": "20351R",
    "schoolName": "Naas Community NS",
    "SETHours": "167.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "6.66",
    "spSNA": "0",
    "totalSNA": "6.66",
    "eircode": "W91HF68",
    "addressOne": "Craddockstown Road",
    "addressTwo": "Naas",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.2071575",
    "lng": "-6.6499178",
    "phone": "45875311",
    "email": "admin@naascns.ie"
  },
  {
    "i": "1656",
    "county": "Kildare",
    "rollNumber": "20403K",
    "schoolName": "Kildare Town Educate Together",
    "SETHours": "170",
    "spClassTeachingPosts": "3",
    "mainSNA": "3",
    "spSNA": "6",
    "totalSNA": "9",
    "eircode": "R51RX38",
    "addressOne": "Melitta Road",
    "addressTwo": "Kildare Town",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.1594802",
    "lng": "-6.9021846",
    "phone": "45530530",
    "email": "Gerry.Breslin@kildaretownet.ie"
  },
  {
    "i": "1657",
    "county": "Kildare",
    "rollNumber": "20427B",
    "schoolName": "St Brigid's Kildare Town Primary School",
    "SETHours": "425.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "6.83",
    "spSNA": "3.5",
    "totalSNA": "10.33",
    "eircode": "R51XY30",
    "addressOne": "Grey Abbey Road",
    "addressTwo": "Kildare Town",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.154604",
    "lng": "-6.9134674",
    "phone": "45521799",
    "email": "office@sbps.ie"
  },
  {
    "i": "1658",
    "county": "Kildare",
    "rollNumber": "20428D",
    "schoolName": "Gaelscoil Mhic Aodha",
    "SETHours": "75",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "R51CX64",
    "addressOne": "Bóthar Mhelitta",
    "addressTwo": "Baile Chill Dara",
    "addressThree": "Co Chill Dara",
    "addressFour": "",
    "lat": "53.1587962",
    "lng": "-6.9004541",
    "phone": "45535588",
    "email": "gaelscoilmhicaodha@gmail.com"
  },
  {
    "i": "1659",
    "county": "Kildare",
    "rollNumber": "20505S",
    "schoolName": "Scoil Mhuire Allenwood NS",
    "SETHours": "85",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "W91FX21",
    "addressOne": "Allenwood",
    "addressTwo": "Robertstown",
    "addressThree": "Naas",
    "addressFour": "Co Kildare",
    "lat": "53.2840301",
    "lng": "-6.8635046",
    "phone": "45860826",
    "email": "scoilmaw@gmail.com"
  },
  {
    "i": "1660",
    "county": "Kildare",
    "rollNumber": "20526D",
    "schoolName": "Leixlip Primary School",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "W23R942",
    "addressOne": "Leixlip Etns",
    "addressTwo": "Leixlip Amenities",
    "addressThree": "Station Road, Leixlip,",
    "addressFour": "Leixlip",
    "lat": "53.3705724",
    "lng": "-6.513869",
    "phone": "868368959",
    "email": "leixlipetnsoffice@gmail.com"
  },
  {
    "i": "1661",
    "county": "Kildare",
    "rollNumber": "20527F",
    "schoolName": "Gaelscoil Ruairí­",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "",
    "addressOne": "F/ch Gaelscoil Í­ Fhiaich",
    "addressTwo": "Bóthar Chill Droichid",
    "addressThree": "Maigh Nuad",
    "addressFour": "",
    "lat": "53.3936029",
    "lng": "-6.6036181",
    "phone": "868226872",
    "email": "gaelscoilruairi@gmail.com"
  },
  {
    "i": "1662",
    "county": "Kilkenny",
    "rollNumber": "00788V",
    "schoolName": "Lisdowney NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "0",
    "spSNA": "2",
    "totalSNA": "2",
    "eircode": "R95XD45",
    "addressOne": "Lisdowney",
    "addressTwo": "Ballyragget",
    "addressThree": "Co. Kilkenny",
    "addressFour": "",
    "lat": "52.7889181",
    "lng": "-7.3883723",
    "phone": "568833495",
    "email": "lisdowneyns@gmail.com"
  },
  {
    "i": "1663",
    "county": "Kilkenny",
    "rollNumber": "00796U",
    "schoolName": "Scoil Lachtain",
    "SETHours": "70",
    "spClassTeachingPosts": "2",
    "mainSNA": "2.5",
    "spSNA": "3.32",
    "totalSNA": "5.82",
    "eircode": "R95RP20",
    "addressOne": "Freshford",
    "addressTwo": "Co. Kilkenny",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.7311023",
    "lng": "-7.3965585",
    "phone": "568832400",
    "email": "stlachtainns@gmail.com"
  },
  {
    "i": "1664",
    "county": "Kilkenny",
    "rollNumber": "01300Q",
    "schoolName": "St Michaels NS",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.33",
    "spSNA": "0",
    "totalSNA": "1.33",
    "eircode": "R95X527",
    "addressOne": "Danesfort",
    "addressTwo": "Co. Kilkenny",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.5831067",
    "lng": "-7.2420047",
    "phone": "567727588",
    "email": "danesfortns@gmail.com"
  },
  {
    "i": "1665",
    "county": "Kilkenny",
    "rollNumber": "05927L",
    "schoolName": "Church Hill Mixed NS",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "R95T253",
    "addressOne": "Church Hill",
    "addressTwo": "Cuffesgrange",
    "addressThree": "Co. Kilkenny",
    "addressFour": "",
    "lat": "52.5999806",
    "lng": "-7.3082586",
    "phone": "567729144",
    "email": "churchhillns1828@gmail.com"
  },
  {
    "i": "1666",
    "county": "Kilkenny",
    "rollNumber": "06621P",
    "schoolName": "Ringville NS",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "X91XN29",
    "addressOne": "Ballinlaw",
    "addressTwo": "Slieverue",
    "addressThree": "Co Kilkenny",
    "addressFour": "Via Waterford",
    "lat": "52.2987636",
    "lng": "-7.0340648",
    "phone": "51832635",
    "email": "ringvillens@gmail.com"
  },
  {
    "i": "1667",
    "county": "Kilkenny",
    "rollNumber": "07481H",
    "schoolName": "Kilmoganny Mixed NS",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "R95TK70",
    "addressOne": "Cottresllstown",
    "addressTwo": "Kilmoganny",
    "addressThree": "Co. Kilkenny",
    "addressFour": "",
    "lat": "52.4618418",
    "lng": "-7.3258709",
    "phone": "51648349",
    "email": "kilmoganny75@gmail.com"
  },
  {
    "i": "1668",
    "county": "Kilkenny",
    "rollNumber": "10835K",
    "schoolName": "Presentation Convent NS",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "R95C795",
    "addressOne": "Kilkenny Street",
    "addressTwo": "Castlecomer",
    "addressThree": "Co. Kilkenny",
    "addressFour": "",
    "lat": "52.8028487",
    "lng": "-7.2099458",
    "phone": "564441426",
    "email": "prescomer@gmail.com"
  },
  {
    "i": "1669",
    "county": "Kilkenny",
    "rollNumber": "12476S",
    "schoolName": "Slieverue Mixed NS",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.75",
    "spSNA": "0",
    "totalSNA": "1.75",
    "eircode": "X91YA26",
    "addressOne": "Slieverue",
    "addressTwo": "Co. Kilkenny",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.2833114",
    "lng": "-7.0664935",
    "phone": "51832339",
    "email": "slieveruensoffice@gmail.com"
  },
  {
    "i": "1670",
    "county": "Kilkenny",
    "rollNumber": "14476F",
    "schoolName": "Wandesforde Mixed NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "R95HT21",
    "addressOne": "Castlecomer",
    "addressTwo": "Co. Kilkenny",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.8051092",
    "lng": "-7.2079224",
    "phone": "564441517",
    "email": "info@wandesforde.ie"
  },
  {
    "i": "1671",
    "county": "Kilkenny",
    "rollNumber": "15160G",
    "schoolName": "The Rower Mixed NS",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "R95T623",
    "addressOne": "The Rower",
    "addressTwo": "Thomastown",
    "addressThree": "Co. Kilkenny",
    "addressFour": "",
    "lat": "52.4528197",
    "lng": "-6.9615536",
    "phone": "51423838",
    "email": "therower.ias@eircom.net"
  },
  {
    "i": "1672",
    "county": "Kilkenny",
    "rollNumber": "15340I",
    "schoolName": "Carigeen NS",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "X91F656",
    "addressOne": "Carrigeen",
    "addressTwo": "Co. Kilkenny",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.2703066",
    "lng": "-7.2154973",
    "phone": "51895423",
    "email": "carrigeen.scoil@gmail.com"
  },
  {
    "i": "1673",
    "county": "Kilkenny",
    "rollNumber": "16116I",
    "schoolName": "SN Naomh Colmain",
    "SETHours": "50",
    "spClassTeachingPosts": "1",
    "mainSNA": "0",
    "spSNA": "1.66",
    "totalSNA": "1.66",
    "eircode": "R95YW73",
    "addressOne": "Clarabricken",
    "addressTwo": "Clara",
    "addressThree": "Co. Kilkenny",
    "addressFour": "",
    "lat": "52.6577722",
    "lng": "-7.1540996",
    "phone": "567759736",
    "email": "claraprimary@eircom.net"
  },
  {
    "i": "1674",
    "county": "Kilkenny",
    "rollNumber": "16140F",
    "schoolName": "Skeaghvastheen NS",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "R95D529",
    "addressOne": "Gorteen",
    "addressTwo": "Skeaghvasteen",
    "addressThree": "Co. Kilkenny",
    "addressFour": "",
    "lat": "52.5903769",
    "lng": "-6.9949317",
    "phone": "599775444",
    "email": "skeoughvosteenps@gmail.com"
  },
  {
    "i": "1675",
    "county": "Kilkenny",
    "rollNumber": "16204F",
    "schoolName": "SN An Moinin Rua",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "R95F8WP",
    "addressOne": "The Glen",
    "addressTwo": "Moneenroe",
    "addressThree": "Castlecomer",
    "addressFour": "Co. Kilkenny",
    "lat": "52.839339",
    "lng": "-7.1544255",
    "phone": "564442288",
    "email": "gaz.ias@eircom.net"
  },
  {
    "i": "1676",
    "county": "Kilkenny",
    "rollNumber": "16230G",
    "schoolName": "SN Lisnafunchin",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "R95TKD2",
    "addressOne": "Castlecomer",
    "addressTwo": "Co. Kilkenny",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.7601257",
    "lng": "-7.2409409",
    "phone": "867930484",
    "email": "lisnafunchinschool@gmail.com"
  },
  {
    "i": "1677",
    "county": "Kilkenny",
    "rollNumber": "16311G",
    "schoolName": "Graig Na Manach Buac",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "R95Y971",
    "addressOne": "Graignamanagh",
    "addressTwo": "Co Kilkenny",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.5415744",
    "lng": "-6.9513347",
    "phone": "599724454",
    "email": "graigboysschool@gmail.com"
  },
  {
    "i": "1678",
    "county": "Kilkenny",
    "rollNumber": "16406R",
    "schoolName": "Bennettsbridge NS",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "R95R280",
    "addressOne": "Bennettsbridge",
    "addressTwo": "Kilkenny",
    "addressThree": "Co Kilkenny",
    "addressFour": "",
    "lat": "52.5921957",
    "lng": "-7.1824419",
    "phone": "567727553",
    "email": "bennettsbridgens@gmail.com"
  },
  {
    "i": "1679",
    "county": "Kilkenny",
    "rollNumber": "16430O",
    "schoolName": "Owning NS",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.33",
    "spSNA": "0",
    "totalSNA": "2.33",
    "eircode": "E32DX43",
    "addressOne": "Piltown",
    "addressTwo": "Co Kilkenny",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.3872134",
    "lng": "-7.3437382",
    "phone": "51643628",
    "email": "owningns1@eircom.net"
  },
  {
    "i": "1680",
    "county": "Kilkenny",
    "rollNumber": "16445E",
    "schoolName": "St Patricks Ns",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "R95YP5W",
    "addressOne": "Boneyarrow",
    "addressTwo": "Clogh",
    "addressThree": "Castlecomer",
    "addressFour": "Co. Kilkenny",
    "lat": "52.8564023",
    "lng": "-7.1561437",
    "phone": "564442374",
    "email": "cloghschool@gmail.com"
  },
  {
    "i": "1681",
    "county": "Kilkenny",
    "rollNumber": "16485Q",
    "schoolName": "St Brendans Mixed NS",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.33",
    "spSNA": "0",
    "totalSNA": "1.33",
    "eircode": "R95A394",
    "addressOne": "Huggsintown",
    "addressTwo": "Co. Kilkenny",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.470103",
    "lng": "-7.2622781",
    "phone": "567768919",
    "email": "18sbns@gmail.com"
  },
  {
    "i": "1682",
    "county": "Kilkenny",
    "rollNumber": "16827S",
    "schoolName": "Scoil San Lionard",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "R95E299",
    "addressOne": "Dunnamaggin",
    "addressTwo": "Co. Kilkenny",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.5040504",
    "lng": "-7.2998149",
    "phone": "567728386",
    "email": "dunnamagginschool@gmail.com"
  },
  {
    "i": "1683",
    "county": "Kilkenny",
    "rollNumber": "16865D",
    "schoolName": "Clontubrid Mixed NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "R95TX40",
    "addressOne": "Clontubrid",
    "addressTwo": "Freshford",
    "addressThree": "Co. Kilkenny",
    "addressFour": "",
    "lat": "52.7573498",
    "lng": "-7.4042375",
    "phone": "568832417",
    "email": "clontubridns@gmail.com"
  },
  {
    "i": "1684",
    "county": "Kilkenny",
    "rollNumber": "16875G",
    "schoolName": "SN Naomh Padraigh",
    "SETHours": "77.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "X91KP57",
    "addressOne": "Strangsmills",
    "addressTwo": "Kilmacow",
    "addressThree": "Co. Kilkenny",
    "addressFour": "Via Waterford",
    "lat": "52.2932735",
    "lng": "-7.1359906",
    "phone": "51874474",
    "email": "schooloffice@strangsmillsns.ie"
  },
  {
    "i": "1685",
    "county": "Kilkenny",
    "rollNumber": "17073V",
    "schoolName": "SN Cholmcille",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "R95W529",
    "addressOne": "Inistioge",
    "addressTwo": "Co. Kilkenny",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.490464",
    "lng": "-7.0648738",
    "phone": "567758660",
    "email": "stcolinistiogens@gmail.com"
  },
  {
    "i": "1686",
    "county": "Kilkenny",
    "rollNumber": "17093E",
    "schoolName": "SN Bhreandain Naofa",
    "SETHours": "62.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "R95YN60",
    "addressOne": "Clorinka",
    "addressTwo": "Ballyfoyle",
    "addressThree": "Co. Kilkenny",
    "addressFour": "",
    "lat": "52.7566174",
    "lng": "-7.1754443",
    "phone": "564441422",
    "email": "officemuckaleens@gmail.com"
  },
  {
    "i": "1687",
    "county": "Kilkenny",
    "rollNumber": "17108O",
    "schoolName": "St Johns Infants NS",
    "SETHours": "135",
    "spClassTeachingPosts": "1",
    "mainSNA": "0.5",
    "spSNA": "1",
    "totalSNA": "1.5",
    "eircode": "R95HC03",
    "addressOne": "Michael Street",
    "addressTwo": "Kilkenny",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.654299",
    "lng": "-7.2498623",
    "phone": "567762888",
    "email": "info@stjohnsthelake.ie"
  },
  {
    "i": "1688",
    "county": "Kilkenny",
    "rollNumber": "17174E",
    "schoolName": "SN Bhrighde",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "R93KC63",
    "addressOne": "Coon West",
    "addressTwo": "Carlow",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.7887212",
    "lng": "-7.1203881",
    "phone": "564443235",
    "email": "coonns1@eircom.net"
  },
  {
    "i": "1689",
    "county": "Kilkenny",
    "rollNumber": "17200C",
    "schoolName": "SN Colmain",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "R95YR15",
    "addressOne": "Conahy",
    "addressTwo": "Jenkinstown",
    "addressThree": "Co Kilkenny",
    "addressFour": "",
    "lat": "52.7600939",
    "lng": "-7.2874823",
    "phone": "567767100",
    "email": "colmanconahy@gmail.com"
  },
  {
    "i": "1690",
    "county": "Kilkenny",
    "rollNumber": "17218V",
    "schoolName": "Kilkenny Mixed NS",
    "SETHours": "75",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "R95XA66",
    "addressOne": "Castlecomer Road",
    "addressTwo": "Kilkenny",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6677515",
    "lng": "-7.2503991",
    "phone": "567722082",
    "email": "modelschoolkilkenny@gmail.com"
  },
  {
    "i": "1691",
    "county": "Kilkenny",
    "rollNumber": "17222M",
    "schoolName": "SN Mhichil Naofa",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "E41TD34",
    "addressOne": "Galmoy Parochial School",
    "addressTwo": "Moneynamuck",
    "addressThree": "Stopford",
    "addressFour": "Galmoy (via Thurles)",
    "lat": "52.7921741",
    "lng": "-7.5708831",
    "phone": "568831481",
    "email": "galmoyns.ias@eircom.net"
  },
  {
    "i": "1692",
    "county": "Kilkenny",
    "rollNumber": "17224Q",
    "schoolName": "SN Muire Gan Smal",
    "SETHours": "60",
    "spClassTeachingPosts": "2",
    "mainSNA": "2",
    "spSNA": "4",
    "totalSNA": "6",
    "eircode": "R95D793",
    "addressOne": "Graigenamanagh",
    "addressTwo": "Co. Kilkenny",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.5434001",
    "lng": "-6.953656",
    "phone": "599724490",
    "email": "principal@scoilmhuiregraig.com"
  },
  {
    "i": "1693",
    "county": "Kilkenny",
    "rollNumber": "17253A",
    "schoolName": "SN Caislean An Cumair",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "R95PHH4",
    "addressOne": "Donaguile",
    "addressTwo": "Castlecomer",
    "addressThree": "Co. Kilkenny",
    "addressFour": "",
    "lat": "52.8005412",
    "lng": "-7.2133437",
    "phone": "564441774",
    "email": "comerboysns@gmail.com"
  },
  {
    "i": "1694",
    "county": "Kilkenny",
    "rollNumber": "17314R",
    "schoolName": "Scoil Naomh Eoin Dea",
    "SETHours": "113",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "R95E221",
    "addressOne": "Upper New Street",
    "addressTwo": "Kilkenny",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6464854",
    "lng": "-7.2521582",
    "phone": "567721290",
    "email": "stjohnofgod.ias@eircom.net"
  },
  {
    "i": "1695",
    "county": "Kilkenny",
    "rollNumber": "17339K",
    "schoolName": "SN Naomh Chiarain",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "E41N820",
    "addressOne": "Rathdowney Road",
    "addressTwo": "Johnstown",
    "addressThree": "Co. Kilkenny",
    "addressFour": "",
    "lat": "52.7509158",
    "lng": "-7.5607042",
    "phone": "568831611",
    "email": "johnstownns@gmail.com"
  },
  {
    "i": "1696",
    "county": "Kilkenny",
    "rollNumber": "17357M",
    "schoolName": "SN Baile An Phiull",
    "SETHours": "85",
    "spClassTeachingPosts": "2",
    "mainSNA": "1.5",
    "spSNA": "3.66",
    "totalSNA": "5.16",
    "eircode": "E32DE27",
    "addressOne": "Kildalton",
    "addressTwo": "Piltown",
    "addressThree": "Co. Kilkenny",
    "addressFour": "",
    "lat": "52.3528267",
    "lng": "-7.3248208",
    "phone": "51643498",
    "email": "piltownns.ias@eircom.net"
  },
  {
    "i": "1697",
    "county": "Kilkenny",
    "rollNumber": "17374M",
    "schoolName": "SN Chrion Choill",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "E41WD59",
    "addressOne": "Gathabawn",
    "addressTwo": "Via Thurles",
    "addressThree": "Co. Kilkenny",
    "addressFour": "",
    "lat": "52.7693492",
    "lng": "-7.4770521",
    "phone": "568832111",
    "email": "info@gathabawnns.ie"
  },
  {
    "i": "1698",
    "county": "Kilkenny",
    "rollNumber": "17566V",
    "schoolName": "SN Bhridhe",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "R95WK84",
    "addressOne": "Kells",
    "addressTwo": "Co. Kilkenny",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.538758",
    "lng": "-7.2716807",
    "phone": "567728476",
    "email": "stbrigidsns2@gmail.com"
  },
  {
    "i": "1699",
    "county": "Kilkenny",
    "rollNumber": "17589K",
    "schoolName": "SN Chiaran Naofa",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "R95XR65",
    "addressOne": "Stoneyford",
    "addressTwo": "Co Kilkenny",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.5339175",
    "lng": "-7.2221722",
    "phone": "567728393",
    "email": "snathastuin@eircom.net"
  },
  {
    "i": "1700",
    "county": "Kilkenny",
    "rollNumber": "17590S",
    "schoolName": "SN Moin Ruadh Mixed",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "R95FY06",
    "addressOne": "Knocktopher",
    "addressTwo": "Co Kilkenny",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.4292926",
    "lng": "-7.2428679",
    "phone": "567768931",
    "email": "snmoinruadh.ias@eircom.net"
  },
  {
    "i": "1701",
    "county": "Kilkenny",
    "rollNumber": "17628R",
    "schoolName": "SN Naomh Padraig Mxd",
    "SETHours": "65",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "R95EK00",
    "addressOne": "Baile Haol",
    "addressTwo": "Co Kilkenny",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.4649191",
    "lng": "-7.1996561",
    "phone": "567768915",
    "email": "scoil@ballyhale.com"
  },
  {
    "i": "1702",
    "county": "Kilkenny",
    "rollNumber": "17675D",
    "schoolName": "SN Teampall Loiscithe",
    "SETHours": "40",
    "spClassTeachingPosts": "1",
    "mainSNA": "1",
    "spSNA": "2",
    "totalSNA": "3",
    "eircode": "R95RT02",
    "addressOne": "Burnchurch",
    "addressTwo": "Cuffesgrange Kilkenny",
    "addressThree": "Co Kilkenny",
    "addressFour": "",
    "lat": "52.5750438",
    "lng": "-7.2968135",
    "phone": "567729138",
    "email": "burnchurchns@eircom.net"
  },
  {
    "i": "1703",
    "county": "Kilkenny",
    "rollNumber": "17758H",
    "schoolName": "Scoil Mhichil Naofa",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "E41EK57",
    "addressOne": "Crosspatrick",
    "addressTwo": "Co Kilkenny (via Thurles)",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.7721018",
    "lng": "-7.5986277",
    "phone": "568831753",
    "email": "office@crosspatrickns.com"
  },
  {
    "i": "1704",
    "county": "Kilkenny",
    "rollNumber": "17854D",
    "schoolName": "SN Padraig Naofa",
    "SETHours": "212.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "4",
    "spSNA": "5.83",
    "totalSNA": "9.83",
    "eircode": "R95DX80",
    "addressOne": "St. Patrick's B.n.s.",
    "addressTwo": "Coote's Lane",
    "addressThree": "Kilkenny",
    "addressFour": "",
    "lat": "52.6450686",
    "lng": "-7.2537445",
    "phone": "567761081",
    "email": "stpats.ias@eircom.net"
  },
  {
    "i": "1705",
    "county": "Kilkenny",
    "rollNumber": "17867M",
    "schoolName": "Scoil Iognaid De Ris",
    "SETHours": "95.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "R95EC93",
    "addressOne": "Stephen Street",
    "addressTwo": "Kilkenny",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6508674",
    "lng": "-7.2607706",
    "phone": "567761739",
    "email": "principal.cbsprimarykk@gmail.com"
  },
  {
    "i": "1706",
    "county": "Kilkenny",
    "rollNumber": "17905R",
    "schoolName": "SN Tobair Eoin Baisde",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "R95YY10",
    "addressOne": "Johnswell",
    "addressTwo": "Co Kilkenny",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.7023766",
    "lng": "-7.1701797",
    "phone": "567759895",
    "email": "johnswellns@gmail.com"
  },
  {
    "i": "1707",
    "county": "Kilkenny",
    "rollNumber": "17911M",
    "schoolName": "Colmcille Mixed NS",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "X91YA49",
    "addressOne": "Bigwood",
    "addressTwo": "Mullinavat",
    "addressThree": "Co. Waterford",
    "addressFour": "",
    "lat": "52.335293",
    "lng": "-7.1150298",
    "phone": "51885525",
    "email": "stcolmcillesschool@gmail.com"
  },
  {
    "i": "1708",
    "county": "Kilkenny",
    "rollNumber": "18064C",
    "schoolName": "SN Muire",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "R95ND27",
    "addressOne": "Gowran",
    "addressTwo": "Co. Kilkenny",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6282287",
    "lng": "-7.0777426",
    "phone": "567726221",
    "email": "gowranns@live.ie"
  },
  {
    "i": "1709",
    "county": "Kilkenny",
    "rollNumber": "18078N",
    "schoolName": "Scoil Bhride B7c",
    "SETHours": "87.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "R95E170",
    "addressOne": "Paul'stown",
    "addressTwo": "Kilkenny",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6820411",
    "lng": "-7.0236245",
    "phone": "599726149",
    "email": "admin@paulstownns.ie"
  },
  {
    "i": "1710",
    "county": "Kilkenny",
    "rollNumber": "18158L",
    "schoolName": "SN Seamus Naofa",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "Y34C527",
    "addressOne": "Robinstown",
    "addressTwo": "Glenmore",
    "addressThree": "Co. Kilkenny",
    "addressFour": "",
    "lat": "52.3523262",
    "lng": "-7.0337856",
    "phone": "51880269",
    "email": "glenmorens@gmail.com"
  },
  {
    "i": "1711",
    "county": "Kilkenny",
    "rollNumber": "18257N",
    "schoolName": "SN Baile An Fhasaigh",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "X91C439",
    "addressOne": "Ballyfacey",
    "addressTwo": "Glenmore",
    "addressThree": "Via New Ross",
    "addressFour": "Co. Kilkenny",
    "lat": "52.3710441",
    "lng": "-7.0698201",
    "phone": "51880388",
    "email": "ballyfaceyns@gmail.com"
  },
  {
    "i": "1712",
    "county": "Kilkenny",
    "rollNumber": "18607O",
    "schoolName": "Scoil Naomh Ioseph",
    "SETHours": "47.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "2",
    "spSNA": "2",
    "totalSNA": "4",
    "eircode": "R95XA00",
    "addressOne": "Clinstown",
    "addressTwo": "Jenkinstown",
    "addressThree": "Co. Kilkenny",
    "addressFour": "",
    "lat": "52.7381834",
    "lng": "-7.3200812",
    "phone": "567767490",
    "email": "clinstownns@gmail.com"
  },
  {
    "i": "1713",
    "county": "Kilkenny",
    "rollNumber": "18643S",
    "schoolName": "Holycross NS",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "R95E22N",
    "addressOne": "Firoda",
    "addressTwo": "Castlecomer",
    "addressThree": "Co Kilkenny",
    "addressFour": "",
    "lat": "52.8398474",
    "lng": "-7.2503614",
    "phone": "564441384",
    "email": "info@firodaschool.ie"
  },
  {
    "i": "1714",
    "county": "Kilkenny",
    "rollNumber": "18660S",
    "schoolName": "SN Shan Nioclas",
    "SETHours": "32.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "0",
    "spSNA": "1.83",
    "totalSNA": "1.83",
    "eircode": "R95XA36",
    "addressOne": "Windgap",
    "addressTwo": "Co Kilkenny",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.4616678",
    "lng": "-7.3959403",
    "phone": "51648321",
    "email": "windgapns@eircom.net"
  },
  {
    "i": "1715",
    "county": "Kilkenny",
    "rollNumber": "18670V",
    "schoolName": "SN Tulach Ruain",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "R95YA46",
    "addressOne": "Tullarone",
    "addressTwo": "Co. Kilkenny",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6642284",
    "lng": "-7.4391988",
    "phone": "567769469",
    "email": "scoilruadhain@gmail.com"
  },
  {
    "i": "1716",
    "county": "Kilkenny",
    "rollNumber": "18748J",
    "schoolName": "Scoil Mholainge Listerlin",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "X91EA09",
    "addressOne": "Listerlin",
    "addressTwo": "Mullinavat",
    "addressThree": "Via Waterford",
    "addressFour": "Co. Kilkenny",
    "lat": "52.4094051",
    "lng": "-7.0734432",
    "phone": "51427305",
    "email": "listerlinns@eircom.net"
  },
  {
    "i": "1717",
    "county": "Kilkenny",
    "rollNumber": "19267V",
    "schoolName": "Templeorum NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "E32CY24",
    "addressOne": "Templeorum",
    "addressTwo": "Piltown",
    "addressThree": "Via Carrick-on-suir",
    "addressFour": "Co. Kilkenny",
    "lat": "52.3835279",
    "lng": "-7.2979002",
    "phone": "51643602",
    "email": "templeorum@gmail.com"
  },
  {
    "i": "1718",
    "county": "Kilkenny",
    "rollNumber": "19344N",
    "schoolName": "St Aidans NS",
    "SETHours": "60",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "R95XN76",
    "addressOne": "Kilmanagh",
    "addressTwo": "Co Kilkenny",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.619793",
    "lng": "-7.4227845",
    "phone": "567769340",
    "email": "staidansnskilmanagh@gmail.com"
  },
  {
    "i": "1719",
    "county": "Kilkenny",
    "rollNumber": "19626A",
    "schoolName": "St Canices Central NS",
    "SETHours": "237.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "4.83",
    "spSNA": "5.66",
    "totalSNA": "10.49",
    "eircode": "R95PK80",
    "addressOne": "Granges Road",
    "addressTwo": "Kilkenny",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6602895",
    "lng": "-7.2619942",
    "phone": "567762150",
    "email": "principal@stcanicesschool.ie"
  },
  {
    "i": "1720",
    "county": "Kilkenny",
    "rollNumber": "19856R",
    "schoolName": "Gaelscoil Osrai",
    "SETHours": "135",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "R95AT85",
    "addressOne": "Loch BÍ­",
    "addressTwo": "Cill Chainnigh",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6394077",
    "lng": "-7.2462204",
    "phone": "567765697",
    "email": "eolas@osrai.com"
  },
  {
    "i": "1721",
    "county": "Kilkenny",
    "rollNumber": "19905E",
    "schoolName": "Kilkenny School Project",
    "SETHours": "75",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.33",
    "spSNA": "0",
    "totalSNA": "3.33",
    "eircode": "R95VX31",
    "addressOne": "Springfields",
    "addressTwo": "Waterford Road",
    "addressThree": "Kilkenny",
    "addressFour": "",
    "lat": "52.6381043",
    "lng": "-7.2518904",
    "phone": "567751407",
    "email": "office@kilkennyschoolproject.ie"
  },
  {
    "i": "1722",
    "county": "Kilkenny",
    "rollNumber": "19925K",
    "schoolName": "Scoil Mhuire",
    "SETHours": "177.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "2.33",
    "spSNA": "0.66",
    "totalSNA": "2.99",
    "eircode": "R95YT68",
    "addressOne": "Parnell Street",
    "addressTwo": "Kilkenny",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6511961",
    "lng": "-7.2559655",
    "phone": "567761659",
    "email": "smuirekk2@eircom.net"
  },
  {
    "i": "1723",
    "county": "Kilkenny",
    "rollNumber": "19930D",
    "schoolName": "Scoil An Chroí­ Ró-naofa",
    "SETHours": "72.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "E41A567",
    "addressOne": "Urlingford",
    "addressTwo": "Co Kilkenny",
    "addressThree": "Via Thurles",
    "addressFour": "",
    "lat": "52.7192561",
    "lng": "-7.5796071",
    "phone": "568831512",
    "email": "urlingfordns2020@gmail.com"
  },
  {
    "i": "1724",
    "county": "Kilkenny",
    "rollNumber": "19944O",
    "schoolName": "Goresbridge NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "R95VX26",
    "addressOne": "Goresbridge",
    "addressTwo": "Co Kilkenny",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6306697",
    "lng": "-6.9971087",
    "phone": "599775168",
    "email": "goresbridgeschool@gmail.com"
  },
  {
    "i": "1725",
    "county": "Kilkenny",
    "rollNumber": "19976E",
    "schoolName": "St Beacons NS",
    "SETHours": "60",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "X91DY67",
    "addressOne": "Mullinavat",
    "addressTwo": "Co Kilkenny",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.36848",
    "lng": "-7.1728663",
    "phone": "51898442",
    "email": "stbeaconsns@gmail.com"
  },
  {
    "i": "1726",
    "county": "Kilkenny",
    "rollNumber": "20011Q",
    "schoolName": "St Johns Sn Ns",
    "SETHours": "87.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "1",
    "spSNA": "1",
    "totalSNA": "2",
    "eircode": "R95NH66",
    "addressOne": "Ballybought Street",
    "addressTwo": "Kilkenny",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6583398",
    "lng": "-7.2433075",
    "phone": "567763528",
    "email": "johnsseniorkk@gmail.com"
  },
  {
    "i": "1727",
    "county": "Kilkenny",
    "rollNumber": "20255V",
    "schoolName": "Bunscoil Mcauley Rice",
    "SETHours": "145",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "R95E840",
    "addressOne": "Kilkenny Road",
    "addressTwo": "Callan",
    "addressThree": "Co. Kilkenny",
    "addressFour": "",
    "lat": "52.5484209",
    "lng": "-7.3870667",
    "phone": "567725674",
    "email": "mcauleyrice@gmail.com"
  },
  {
    "i": "1728",
    "county": "Kilkenny",
    "rollNumber": "20272V",
    "schoolName": "St Mary's NS",
    "SETHours": "132.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "R95FP30",
    "addressOne": "Thomastown",
    "addressTwo": "Co. Kilkenny",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.5286847",
    "lng": "-7.1361054",
    "phone": "567724290",
    "email": "reception@stmarysttown.com"
  },
  {
    "i": "1729",
    "county": "Kilkenny",
    "rollNumber": "20443W",
    "schoolName": "St. Senan's NS",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "X91D894",
    "addressOne": "Kilmacow",
    "addressTwo": "Co. Kilkenny",
    "addressThree": "Via Waterford",
    "addressFour": "",
    "lat": "52.3185828",
    "lng": "-7.174561",
    "phone": "51885361",
    "email": "info@stsenansns.ie"
  },
  {
    "i": "1730",
    "county": "Kilkenny",
    "rollNumber": "20492M",
    "schoolName": "Scoil Mhuire",
    "SETHours": "112.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "2.83",
    "spSNA": "0.83",
    "totalSNA": "3.66",
    "eircode": "X91KC92",
    "addressOne": "Mooncoin",
    "addressTwo": "Co. Kilkenny",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.2908288",
    "lng": "-7.2499264",
    "phone": "51895503",
    "email": "scoilmhuiremooncoin@gmail.com"
  },
  {
    "i": "1731",
    "county": "Kilkenny",
    "rollNumber": "20506U",
    "schoolName": "Ballyragget NS",
    "SETHours": "72.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.33",
    "spSNA": "0",
    "totalSNA": "1.33",
    "eircode": "R95KR86",
    "addressOne": "Kilkenny Road",
    "addressTwo": "Ballyragget",
    "addressThree": "Co. Kilkenny",
    "addressFour": "",
    "lat": "52.7860977",
    "lng": "-7.3362267",
    "phone": "568833606",
    "email": "ballyraggetns@gmail.com"
  },
  {
    "i": "1732",
    "county": "Laois",
    "rollNumber": "00892Q",
    "schoolName": "Shanganamore NS",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "R14K659",
    "addressOne": "Shanganamore",
    "addressTwo": "Athy",
    "addressThree": "Co. Laois",
    "addressFour": "",
    "lat": "52.9534459",
    "lng": "-6.9935885",
    "phone": "598632315",
    "email": "shanganamorens87@gmail.com"
  },
  {
    "i": "1733",
    "county": "Laois",
    "rollNumber": "00895W",
    "schoolName": "Ballinakill Mixed NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "R32TX38",
    "addressOne": "Ballinakill",
    "addressTwo": "Portlaoise",
    "addressThree": "Co. Laois",
    "addressFour": "",
    "lat": "52.8759472",
    "lng": "-7.3081052",
    "phone": "578733393",
    "email": "ballinakillps@gmail.com"
  },
  {
    "i": "1734",
    "county": "Laois",
    "rollNumber": "07183W",
    "schoolName": "St Josephs Girls NS",
    "SETHours": "115",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "R32EC56",
    "addressOne": "Davitt Road",
    "addressTwo": "Mountmellick",
    "addressThree": "Co. Laois",
    "addressFour": "",
    "lat": "53.1130719",
    "lng": "-7.3189159",
    "phone": "578624540",
    "email": "stjosephsgns.ias@eircom.net"
  },
  {
    "i": "1735",
    "county": "Laois",
    "rollNumber": "07442U",
    "schoolName": "St Josephs NS",
    "SETHours": "65",
    "spClassTeachingPosts": "2",
    "mainSNA": "0.5",
    "spSNA": "4",
    "totalSNA": "4.5",
    "eircode": "R32FP79",
    "addressOne": "Borrin-in-ossory",
    "addressTwo": "Portlaoise",
    "addressThree": "Co. Laois",
    "addressFour": "",
    "lat": "52.9382365",
    "lng": "-7.6341543",
    "phone": "50541331",
    "email": "borrisinossoryns@gmail.com"
  },
  {
    "i": "1736",
    "county": "Laois",
    "rollNumber": "07636K",
    "schoolName": "St Fintans NS",
    "SETHours": "62.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "2.5",
    "spSNA": "2.83",
    "totalSNA": "5.33",
    "eircode": "R32ET78",
    "addressOne": "New Line Road",
    "addressTwo": "Mountrath",
    "addressThree": "Co. Laois",
    "addressFour": "",
    "lat": "52.9985204",
    "lng": "-7.4797871",
    "phone": "578732372",
    "email": "saintfintansbns@gmail.com"
  },
  {
    "i": "1737",
    "county": "Laois",
    "rollNumber": "10544W",
    "schoolName": "Cosby NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "R32VP9F",
    "addressOne": "Main Street",
    "addressTwo": "Stradbally",
    "addressThree": "Co. Laois",
    "addressFour": "",
    "lat": "53.0134405",
    "lng": "-7.1454198",
    "phone": "578625555",
    "email": "cosbyns01@gmail.com"
  },
  {
    "i": "1738",
    "county": "Laois",
    "rollNumber": "12231L",
    "schoolName": "Rush Hall Mixed NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "R32CK15",
    "addressOne": "Pike-of-rushall",
    "addressTwo": "Portloaise",
    "addressThree": "Co. Laois",
    "addressFour": "",
    "lat": "52.9552592",
    "lng": "-7.5545127",
    "phone": "578735055",
    "email": "nsrushall@gmail.com"
  },
  {
    "i": "1739",
    "county": "Laois",
    "rollNumber": "12692B",
    "schoolName": "Kiladooley Mixed NS",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "R32A726",
    "addressOne": "Killadooley",
    "addressTwo": "Borris-in-ossory",
    "addressThree": "Co. Laois",
    "addressFour": "",
    "lat": "52.892768",
    "lng": "-7.6455441",
    "phone": "50544236",
    "email": "killadooleyns1@gmail.com"
  },
  {
    "i": "1740",
    "county": "Laois",
    "rollNumber": "13173F",
    "schoolName": "Paddock NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "R32EV80",
    "addressOne": "Paddock",
    "addressTwo": "Mountrath",
    "addressThree": "Co. Laois",
    "addressFour": "",
    "lat": "53.0229789",
    "lng": "-7.4985012",
    "phone": "578732160",
    "email": "paddocknationalschool@gmail.com"
  },
  {
    "i": "1741",
    "county": "Laois",
    "rollNumber": "13343E",
    "schoolName": "Scoil Bhride",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "R32F802",
    "addressOne": "Stillbrook",
    "addressTwo": "Mountrath",
    "addressThree": "Co. Laois",
    "addressFour": "",
    "lat": "53.00017",
    "lng": "-7.4769772",
    "phone": "578732423",
    "email": "bridnaofamountrath@gmail.com"
  },
  {
    "i": "1742",
    "county": "Laois",
    "rollNumber": "13643Q",
    "schoolName": "Emo Mixed NS",
    "SETHours": "100",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.16",
    "spSNA": "0",
    "totalSNA": "5.16",
    "eircode": "R32DX52",
    "addressOne": "Emo",
    "addressTwo": "Portlaoise",
    "addressThree": "Co. Laois",
    "addressFour": "",
    "lat": "53.1002754",
    "lng": "-7.2087934",
    "phone": "578646868",
    "email": "principal@emons.ie"
  },
  {
    "i": "1743",
    "county": "Laois",
    "rollNumber": "13741Q",
    "schoolName": "Rath Mixed NS",
    "SETHours": "92.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "5.83",
    "spSNA": "4",
    "totalSNA": "9.83",
    "eircode": "R32Y510",
    "addressOne": "Rath",
    "addressTwo": "Ballybrittas",
    "addressThree": "Portlaoise",
    "addressFour": "Co. Laois",
    "lat": "53.0946614",
    "lng": "-7.0921842",
    "phone": "578626270",
    "email": "rathns1@gmail.com"
  },
  {
    "i": "1744",
    "county": "Laois",
    "rollNumber": "14260F",
    "schoolName": "Abbeyleix Sth NS",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.5",
    "spSNA": "0",
    "totalSNA": "3.5",
    "eircode": "R32PP79",
    "addressOne": "Ballacolla Road",
    "addressTwo": "Abbeyleix",
    "addressThree": "Co. Laois",
    "addressFour": "",
    "lat": "52.9108451",
    "lng": "-7.3552886",
    "phone": "578731920",
    "email": "abbeyleixsouthns@gmail.com"
  },
  {
    "i": "1745",
    "county": "Laois",
    "rollNumber": "14838N",
    "schoolName": "Maryboro NS",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "R32HY24",
    "addressOne": "Summerhill",
    "addressTwo": "The Downs",
    "addressThree": "Portlaoise",
    "addressFour": "Co. Laois",
    "lat": "53.030697",
    "lng": "-7.2842392",
    "phone": "578632019",
    "email": "maryboroughns@hotmail.com"
  },
  {
    "i": "1746",
    "county": "Laois",
    "rollNumber": "15446B",
    "schoolName": "Trummera NS",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "R32YY23",
    "addressOne": "Tromaire",
    "addressTwo": "Maighean Rátha",
    "addressThree": "Co. Laoise",
    "addressFour": "",
    "lat": "52.9845974",
    "lng": "-7.4236912",
    "phone": "578756306",
    "email": "gaelscoilthromaire00@gmail.com"
  },
  {
    "i": "1747",
    "county": "Laois",
    "rollNumber": "15537E",
    "schoolName": "SN Baile Finn",
    "SETHours": "85",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "R32N920",
    "addressOne": "Ballyfin",
    "addressTwo": "Portlaoise",
    "addressThree": "Co. Laois",
    "addressFour": "",
    "lat": "53.0561069",
    "lng": "-7.4070585",
    "phone": "578755225",
    "email": "nsballyfin@gmail.com"
  },
  {
    "i": "1748",
    "county": "Laois",
    "rollNumber": "15556I",
    "schoolName": "Presentation Primary School",
    "SETHours": "242.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "4.33",
    "spSNA": "3.32",
    "totalSNA": "7.65",
    "eircode": "R32HF43",
    "addressOne": "Station Road",
    "addressTwo": "Portarlington",
    "addressThree": "Co. Laois",
    "addressFour": "",
    "lat": "53.1532664",
    "lng": "-7.1816218",
    "phone": "578623007",
    "email": "info@presprimary.ie"
  },
  {
    "i": "1749",
    "county": "Laois",
    "rollNumber": "15562D",
    "schoolName": "Cloch An Tsionnaigh NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "R32XH26",
    "addressOne": "Foxrock",
    "addressTwo": "Ballacolla",
    "addressThree": "Abbeyleix",
    "addressFour": "Co. Laois",
    "lat": "52.8864346",
    "lng": "-7.5089479",
    "phone": "578738546",
    "email": "cloughns@gmail.com"
  },
  {
    "i": "1750",
    "county": "Laois",
    "rollNumber": "15933M",
    "schoolName": "Camross NS",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "R32YEF6",
    "addressOne": "Camross",
    "addressTwo": "Portlaoise",
    "addressThree": "Co Laoise",
    "addressFour": "",
    "lat": "53.0049822",
    "lng": "-7.5920594",
    "phone": "578735230",
    "email": "camrossns@eircom.net"
  },
  {
    "i": "1751",
    "county": "Laois",
    "rollNumber": "16070K",
    "schoolName": "Mountmellick Boys NS",
    "SETHours": "155",
    "spClassTeachingPosts": "2",
    "mainSNA": "3.5",
    "spSNA": "3.83",
    "totalSNA": "7.33",
    "eircode": "R32DY73",
    "addressOne": "Davitt Road",
    "addressTwo": "Mountmellick",
    "addressThree": "Co. Laois",
    "addressFour": "",
    "lat": "53.1131589",
    "lng": "-7.3190839",
    "phone": "578624760",
    "email": "scoilpn2.ias@eircom.net"
  },
  {
    "i": "1752",
    "county": "Laois",
    "rollNumber": "16617H",
    "schoolName": "Ballyadams NS",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "R14E225",
    "addressOne": "Ballyadams",
    "addressTwo": "Via Athy",
    "addressThree": "Co Laois",
    "addressFour": "",
    "lat": "52.9673819",
    "lng": "-7.079419",
    "phone": "598627226",
    "email": "principal.ballyadams@gmail.com"
  },
  {
    "i": "1753",
    "county": "Laois",
    "rollNumber": "16667W",
    "schoolName": "Tobar An Leinn",
    "SETHours": "47.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "1.5",
    "spSNA": "1.66",
    "totalSNA": "3.16",
    "eircode": "R32R296",
    "addressOne": "Raheen",
    "addressTwo": "Abbeyleix",
    "addressThree": "Co. Laois",
    "addressFour": "",
    "lat": "52.9655688",
    "lng": "-7.3699942",
    "phone": "578731767",
    "email": "toblr@eircom.net"
  },
  {
    "i": "1754",
    "county": "Laois",
    "rollNumber": "17064U",
    "schoolName": "Scoil Padraig",
    "SETHours": "110",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "R14HK31",
    "addressOne": "Ballylinan",
    "addressTwo": "Co. Laois",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.9470983",
    "lng": "-7.04644",
    "phone": "598625195",
    "email": "ballylinan1@yahoo.ie"
  },
  {
    "i": "1755",
    "county": "Laois",
    "rollNumber": "17084D",
    "schoolName": "Cill An Iubhair NS",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "R32V276",
    "addressOne": "Killanure",
    "addressTwo": "Mountrath",
    "addressThree": "Co Laois",
    "addressFour": "",
    "lat": "53.0473865",
    "lng": "-7.5538275",
    "phone": "578732944",
    "email": "killanurens@eircom.net"
  },
  {
    "i": "1756",
    "county": "Laois",
    "rollNumber": "17271C",
    "schoolName": "Scoil Mhuire Muigheo",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "R93H799",
    "addressOne": "Mayo",
    "addressTwo": "Crettyard",
    "addressThree": "Carlow",
    "addressFour": "Co. Laois",
    "lat": "52.8463572",
    "lng": "-7.0875547",
    "phone": "564442555",
    "email": "mayonsovs@gmail.com"
  },
  {
    "i": "1757",
    "county": "Laois",
    "rollNumber": "17441B",
    "schoolName": "Scoil Mhuire",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "R14C521",
    "addressOne": "Wolfhill",
    "addressTwo": "Athy",
    "addressThree": "Co Kildare",
    "addressFour": "",
    "lat": "52.9003094",
    "lng": "-7.1314653",
    "phone": "598635718",
    "email": "wolfhillns@gmail.com"
  },
  {
    "i": "1758",
    "county": "Laois",
    "rollNumber": "17489G",
    "schoolName": "SN Fionntan Naofa",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "R32F899",
    "addressOne": "Abbeyleix",
    "addressTwo": "Portlaoise",
    "addressThree": "Co. Laois",
    "addressFour": "",
    "lat": "52.9282593",
    "lng": "-7.4264609",
    "phone": "578739715",
    "email": "shanahoens@gmail.com"
  },
  {
    "i": "1759",
    "county": "Laois",
    "rollNumber": "17493U",
    "schoolName": "Rosenallis NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "R32Y674",
    "addressOne": "Rosenallis",
    "addressTwo": "Co Laois",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.1355255",
    "lng": "-7.4116533",
    "phone": "578628663",
    "email": "rosenallisns@eircom.net"
  },
  {
    "i": "1760",
    "county": "Laois",
    "rollNumber": "17555Q",
    "schoolName": "Scoil Naomh Abban",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "R93DY27",
    "addressOne": "Newtown",
    "addressTwo": "Crettyard",
    "addressThree": "Co. Laois.",
    "addressFour": "",
    "lat": "52.8642081",
    "lng": "-7.1123514",
    "phone": "564442494",
    "email": "principal@newtownns.net"
  },
  {
    "i": "1761",
    "county": "Laois",
    "rollNumber": "17557U",
    "schoolName": "Scoil Abbain Cillin",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "R93N244",
    "addressOne": "Killeen",
    "addressTwo": "Maganey",
    "addressThree": "Co Laois",
    "addressFour": "",
    "lat": "52.9060424",
    "lng": "-6.9693315",
    "phone": "599145399",
    "email": "stabbansnskilleen@gmail.com"
  },
  {
    "i": "1762",
    "county": "Laois",
    "rollNumber": "17604D",
    "schoolName": "Raithin An Uisce NS",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "R32HW50",
    "addressOne": "Ratheniska",
    "addressTwo": "Stradbally",
    "addressThree": "Co. Laois",
    "addressFour": "",
    "lat": "53.0069724",
    "lng": "-7.2158874",
    "phone": "578625148",
    "email": "ratheniskans@eircom.net"
  },
  {
    "i": "1763",
    "county": "Laois",
    "rollNumber": "17617M",
    "schoolName": "Scoil Chomhgain Naofa",
    "SETHours": "132.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "R93XF53",
    "addressOne": "Killeshin",
    "addressTwo": "Carlow",
    "addressThree": "Co. Laois",
    "addressFour": "",
    "lat": "52.851477",
    "lng": "-6.9934357",
    "phone": "599147852",
    "email": "killeshinns@eircom.net"
  },
  {
    "i": "1764",
    "county": "Laois",
    "rollNumber": "17695J",
    "schoolName": "SN Molaise",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "R32PT62",
    "addressOne": "Spink",
    "addressTwo": "Abbeyleix",
    "addressThree": "Co. Laois",
    "addressFour": "",
    "lat": "52.9024483",
    "lng": "-7.2372436",
    "phone": "578731770",
    "email": "knockns.sec@gmail.com"
  },
  {
    "i": "1765",
    "county": "Laois",
    "rollNumber": "17883K",
    "schoolName": "Muire Naofa Castlecuffe",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "R32CR74",
    "addressOne": "Castlecuffe Ns",
    "addressTwo": "Clonaslee",
    "addressThree": "Co Laois",
    "addressFour": "",
    "lat": "53.1514802",
    "lng": "-7.587417",
    "phone": "578648238",
    "email": "castlecuffens@gmail.com"
  },
  {
    "i": "1766",
    "county": "Laois",
    "rollNumber": "18014K",
    "schoolName": "Scoil An Chroi Ro Naofa",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "R14PF79",
    "addressOne": "The Swan",
    "addressTwo": "Via Athy",
    "addressThree": "Co. Laois",
    "addressFour": "",
    "lat": "52.8842163",
    "lng": "-7.1535517",
    "phone": "598635764",
    "email": "theswanns1@eircom.net"
  },
  {
    "i": "1768",
    "county": "Laois",
    "rollNumber": "18150S",
    "schoolName": "Fraoch Mor NS",
    "SETHours": "110",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.33",
    "spSNA": "0",
    "totalSNA": "4.33",
    "eircode": "R32XW40",
    "addressOne": "Scoil An Fhraoich Mhóir",
    "addressTwo": "The Heath",
    "addressThree": "Portlaoise",
    "addressFour": "Laois",
    "lat": "53.0554818",
    "lng": "-7.2239515",
    "phone": "578646658",
    "email": "office@theheathns.com"
  },
  {
    "i": "1769",
    "county": "Laois",
    "rollNumber": "18166K",
    "schoolName": "Cluain Eidhneach NS",
    "SETHours": "30",
    "spClassTeachingPosts": "1",
    "mainSNA": "1",
    "spSNA": "2",
    "totalSNA": "3",
    "eircode": "R32CP84",
    "addressOne": "Cluain Eidhneach",
    "addressTwo": "Mountrath",
    "addressThree": "Co Laois",
    "addressFour": "",
    "lat": "53.0029972",
    "lng": "-7.4728262",
    "phone": "578732516",
    "email": "clonenaghns@gmail.com"
  },
  {
    "i": "1770",
    "county": "Laois",
    "rollNumber": "18203N",
    "schoolName": "Scoil Náisiúnta Cúil An Tsúdaire 2",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "R32Y195",
    "addressOne": "Sandy Lane",
    "addressTwo": "Portarlington",
    "addressThree": "Co. Laois",
    "addressFour": "",
    "lat": "53.157234",
    "lng": "-7.1911343",
    "phone": "578643281",
    "email": "sandylanensoffice@gmail.com"
  },
  {
    "i": "1771",
    "county": "Laois",
    "rollNumber": "18206T",
    "schoolName": "Na Carraige NS",
    "SETHours": "107.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.66",
    "spSNA": "0",
    "totalSNA": "3.66",
    "eircode": "R32AP98",
    "addressOne": "Rock",
    "addressTwo": "Mountmellick",
    "addressThree": "Co. Laois",
    "addressFour": "",
    "lat": "53.1152234",
    "lng": "-7.2873384",
    "phone": "578624490",
    "email": "therockns20@gmail.com"
  },
  {
    "i": "1772",
    "county": "Laois",
    "rollNumber": "18265M",
    "schoolName": "Bhride NS",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "R93T611",
    "addressOne": "Ardough",
    "addressTwo": "Bilboa",
    "addressThree": "Carlow",
    "addressFour": "Co. Laois",
    "lat": "52.796963",
    "lng": "-7.0473458",
    "phone": "599140611",
    "email": "ardoughns@gmail.com"
  },
  {
    "i": "1773",
    "county": "Laois",
    "rollNumber": "18294T",
    "schoolName": "Barr Na Sruthan NS",
    "SETHours": "35",
    "spClassTeachingPosts": "2",
    "mainSNA": "2",
    "spSNA": "3.66",
    "totalSNA": "5.66",
    "eircode": "R32AX96",
    "addressOne": "Barr Na Sruthan",
    "addressTwo": "Mountmellick",
    "addressThree": "Co Laois",
    "addressFour": "",
    "lat": "53.0851473",
    "lng": "-7.3659294",
    "phone": "578644020",
    "email": "barnashronens@yahoo.ie"
  },
  {
    "i": "1774",
    "county": "Laois",
    "rollNumber": "18368W",
    "schoolName": "Mhuire Fatima NS",
    "SETHours": "85",
    "spClassTeachingPosts": "2",
    "mainSNA": "3.83",
    "spSNA": "3.32",
    "totalSNA": "7.15",
    "eircode": "R32YN52",
    "addressOne": "Timahoe",
    "addressTwo": "Portlaoise",
    "addressThree": "Co. Laois",
    "addressFour": "",
    "lat": "52.9627228",
    "lng": "-7.1989479",
    "phone": "578627051",
    "email": "timahoelaoisns@gmail.com"
  },
  {
    "i": "1775",
    "county": "Laois",
    "rollNumber": "18433H",
    "schoolName": "Naomh Pius X NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "R32H211",
    "addressOne": "Ballacolla",
    "addressTwo": "Portlaoise",
    "addressThree": "Co. Laois",
    "addressFour": "",
    "lat": "52.8817997",
    "lng": "-7.4499687",
    "phone": "578734140",
    "email": "stpiusxballacolla@gmail.com"
  },
  {
    "i": "1776",
    "county": "Laois",
    "rollNumber": "18513F",
    "schoolName": "Naomh Padraig NS",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.75",
    "spSNA": "0",
    "totalSNA": "1.75",
    "eircode": "R32YD81",
    "addressOne": "Doire Liaim Oig",
    "addressTwo": "Rosenallis",
    "addressThree": "Co Laois",
    "addressFour": "",
    "lat": "53.1173848",
    "lng": "-7.39283",
    "phone": "578628702",
    "email": "derrylamogue.ias@eircom.net"
  },
  {
    "i": "1777",
    "county": "Laois",
    "rollNumber": "18532J",
    "schoolName": "Ardlios NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "R93HY62",
    "addressOne": "Arles",
    "addressTwo": "Ballickmoyler",
    "addressThree": "Co. Laois",
    "addressFour": "",
    "lat": "52.8917575",
    "lng": "-7.0190277",
    "phone": "599147731",
    "email": "principal@arlesnationalschool.ie"
  },
  {
    "i": "1778",
    "county": "Laois",
    "rollNumber": "18641O",
    "schoolName": "SN Naomh Eoin",
    "SETHours": "132.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.66",
    "spSNA": "0",
    "totalSNA": "5.66",
    "eircode": "R32F782",
    "addressOne": "Killenard",
    "addressTwo": "Co. Laois",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.1310021",
    "lng": "-7.1480309",
    "phone": "578626217",
    "email": "office@naomheoin.ie"
  },
  {
    "i": "1779",
    "county": "Laois",
    "rollNumber": "18780F",
    "schoolName": "SN Naomh Colmcille",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "R32CK26",
    "addressOne": "Errill",
    "addressTwo": "Portlaoise",
    "addressThree": "Co. Laois",
    "addressFour": "",
    "lat": "52.8518106",
    "lng": "-7.6737559",
    "phone": "50544228",
    "email": "errillns@gmail.com"
  },
  {
    "i": "1780",
    "county": "Laois",
    "rollNumber": "19369G",
    "schoolName": "St Paul's NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "R32WK79",
    "addressOne": "Irishtown",
    "addressTwo": "Mountmellick",
    "addressThree": "Co. Laois",
    "addressFour": "",
    "lat": "53.1157156",
    "lng": "-7.326449",
    "phone": "578624781",
    "email": "stpauls1ns@gmail.com"
  },
  {
    "i": "1781",
    "county": "Laois",
    "rollNumber": "19747M",
    "schoolName": "Scoil Bhride Ns",
    "SETHours": "412.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "8.66",
    "spSNA": "4",
    "totalSNA": "12.66",
    "eircode": "R32EV18",
    "addressOne": "Knockmay",
    "addressTwo": "Portlaoise",
    "addressThree": "Co. Laois",
    "addressFour": "",
    "lat": "53.0373329",
    "lng": "-7.3139445",
    "phone": "578620287",
    "email": "mail@scoil-bhride.com"
  },
  {
    "i": "1782",
    "county": "Laois",
    "rollNumber": "19750B",
    "schoolName": "Scoil Mhuire",
    "SETHours": "122.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "3.33",
    "spSNA": "6",
    "totalSNA": "9.33",
    "eircode": "R32A566",
    "addressOne": "Ballyroan Road",
    "addressTwo": "Abbeyleix",
    "addressThree": "Co. Laois",
    "addressFour": "",
    "lat": "52.9186645",
    "lng": "-7.3427446",
    "phone": "578731051",
    "email": "scoilmhuireabbeyleix@gmail.com"
  },
  {
    "i": "1783",
    "county": "Laois",
    "rollNumber": "19791P",
    "schoolName": "Scoil Tí­ghearnach Naofa",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "R32WV79",
    "addressOne": "Cullohill",
    "addressTwo": "Rathdowney",
    "addressThree": "Co. Laois",
    "addressFour": "",
    "lat": "52.8210212",
    "lng": "-7.4775671",
    "phone": "578737281",
    "email": "scoiltnaofa@gmail.com"
  },
  {
    "i": "1784",
    "county": "Laois",
    "rollNumber": "20065Q",
    "schoolName": "Our Ladys Meadow National Schoo",
    "SETHours": "75",
    "spClassTeachingPosts": "1",
    "mainSNA": "3.66",
    "spSNA": "1.66",
    "totalSNA": "5.32",
    "eircode": "R32FW18",
    "addressOne": "Durrow",
    "addressTwo": "Co. Laois",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.8454332",
    "lng": "-7.3979326",
    "phone": "578736329",
    "email": "ourladysmeadowschool@gmail.com"
  },
  {
    "i": "1785",
    "county": "Laois",
    "rollNumber": "20071L",
    "schoolName": "Scoil Bhride",
    "SETHours": "105.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.75",
    "spSNA": "0",
    "totalSNA": "2.75",
    "eircode": "R32H773",
    "addressOne": "Rathdowney",
    "addressTwo": "Co. Laois",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.8565581",
    "lng": "-7.5973416",
    "phone": "50546546",
    "email": "scoilbhrideoffice@gmail.com"
  },
  {
    "i": "1786",
    "county": "Laois",
    "rollNumber": "20081O",
    "schoolName": "Gaelscoil Phort Laoise",
    "SETHours": "150",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "R32YA66",
    "addressOne": "Cnoc An Tsamhraidh",
    "addressTwo": "Portlaoise",
    "addressThree": "Co. Laoise",
    "addressFour": "",
    "lat": "53.0295687",
    "lng": "-7.2845978",
    "phone": "578688293",
    "email": "gaelscoilphortlaoise@hotmail.com"
  },
  {
    "i": "1787",
    "county": "Laois",
    "rollNumber": "20118L",
    "schoolName": "Scoil Bhride",
    "SETHours": "62.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "R32WE51",
    "addressOne": "Chapel St",
    "addressTwo": "Clonaslee",
    "addressThree": "Co. Laois",
    "addressFour": "",
    "lat": "53.1500177",
    "lng": "-7.525662",
    "phone": "578648334",
    "email": "clonasleens@gmail.com"
  },
  {
    "i": "1788",
    "county": "Laois",
    "rollNumber": "20169F",
    "schoolName": "Castletown N.s",
    "SETHours": "0",
    "spClassTeachingPosts": "1",
    "mainSNA": "2",
    "spSNA": "1.83",
    "totalSNA": "3.83",
    "eircode": "R32VX78",
    "addressOne": "Elderfield Building",
    "addressTwo": "Castletown",
    "addressThree": "Co. Laois",
    "addressFour": "",
    "lat": "52.9762771",
    "lng": "-7.4918697",
    "phone": "578732307",
    "email": "castletownprimary@gmail.com"
  },
  {
    "i": "1789",
    "county": "Laois",
    "rollNumber": "20224K",
    "schoolName": "Gaelscoil An Tsli Dala",
    "SETHours": "30",
    "spClassTeachingPosts": "2",
    "mainSNA": "0.83",
    "spSNA": "3.32",
    "totalSNA": "4.15",
    "eircode": "R32TN62",
    "addressOne": "An Bealach Mór",
    "addressTwo": "Co. Laoise",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.9599785",
    "lng": "-7.6939567",
    "phone": "50541810",
    "email": "gaelscoilshlidala@gmail.com"
  },
  {
    "i": "1790",
    "county": "Laois",
    "rollNumber": "20270R",
    "schoolName": "Holy Family Jn School",
    "SETHours": "282.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "5.66",
    "spSNA": "3.34",
    "totalSNA": "9",
    "eircode": "R32CY05",
    "addressOne": "Aughnaharna",
    "addressTwo": "Summerhill",
    "addressThree": "Portlaoise",
    "addressFour": "",
    "lat": "53.0294559",
    "lng": "-7.2768321",
    "phone": "578688224",
    "email": "info@holyfamilyjs.ie"
  },
  {
    "i": "1791",
    "county": "Laois",
    "rollNumber": "20347D",
    "schoolName": "Portlaoise Educate Together Ns",
    "SETHours": "237.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "5.5",
    "spSNA": "5.5",
    "totalSNA": "11",
    "eircode": "R32HX45",
    "addressOne": "Summerhill Downs",
    "addressTwo": "Stradbally Road",
    "addressThree": "Portlaoise",
    "addressFour": "Co. Laois",
    "lat": "53.0288377",
    "lng": "-7.2840644",
    "phone": "578664823",
    "email": "office@petns.ie"
  },
  {
    "i": "1792",
    "county": "Laois",
    "rollNumber": "20353V",
    "schoolName": "St Coleman's NS",
    "SETHours": "150",
    "spClassTeachingPosts": "2",
    "mainSNA": "2.5",
    "spSNA": "4",
    "totalSNA": "6.5",
    "eircode": "R32VR84",
    "addressOne": "Stradbally",
    "addressTwo": "Co. Laois",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.0141263",
    "lng": "-7.1446206",
    "phone": "578625348",
    "email": "stradballyschool@gmail.com"
  },
  {
    "i": "1793",
    "county": "Laois",
    "rollNumber": "20485P",
    "schoolName": "Ballyroan Primary School",
    "SETHours": "65",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "R32V4H0",
    "addressOne": "Ballyroan",
    "addressTwo": "Co. Laois",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.2863548",
    "lng": "-6.2969717",
    "phone": "578731865",
    "email": "scoilepn@eircom.net"
  },
  {
    "i": "1794",
    "county": "Laois",
    "rollNumber": "20480F",
    "schoolName": "Holy Family Sn School",
    "SETHours": "300",
    "spClassTeachingPosts": "2",
    "mainSNA": "8",
    "spSNA": "4",
    "totalSNA": "12",
    "eircode": "R32N8C2",
    "addressOne": "Aughnaharna",
    "addressTwo": "Portlaoise",
    "addressThree": "Co. Laois",
    "addressFour": "",
    "lat": "53.0289176",
    "lng": "-7.276011",
    "phone": "578671564",
    "email": "hfssportlaoise@gmail.com"
  },
  {
    "i": "1795",
    "county": "Leitrim",
    "rollNumber": "01125B",
    "schoolName": "Leitrim Mxd NS",
    "SETHours": "62.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "N41EC81",
    "addressOne": "Leitrim Village",
    "addressTwo": "Carrick-on-shannon",
    "addressThree": "Co. Leitrim",
    "addressFour": "",
    "lat": "53.9927192",
    "lng": "-8.0669673",
    "phone": "719621205",
    "email": "leitrimns@gmail.com"
  },
  {
    "i": "1796",
    "county": "Leitrim",
    "rollNumber": "08390J",
    "schoolName": "Mastersons NS",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "F91YD86",
    "addressOne": "Church Lane",
    "addressTwo": "Manorhamilton",
    "addressThree": "Co. Leitrim",
    "addressFour": "",
    "lat": "54.3050233",
    "lng": "-8.1726239",
    "phone": "719855540",
    "email": "mastersonns@gmail.com"
  },
  {
    "i": "1797",
    "county": "Leitrim",
    "rollNumber": "08673V",
    "schoolName": "The Hunt NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "N41XW81",
    "addressOne": "Castle Street",
    "addressTwo": "Mohill",
    "addressThree": "Co. Leitrim",
    "addressFour": "",
    "lat": "53.9225957",
    "lng": "-7.8651529",
    "phone": "719631326",
    "email": "huntnsmohill@gmail.com"
  },
  {
    "i": "1798",
    "county": "Leitrim",
    "rollNumber": "09353I",
    "schoolName": "Newtowngore NS 1",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "N41RY65",
    "addressOne": "Mullyaster",
    "addressTwo": "Newtowngore",
    "addressThree": "Co. Leitrim",
    "addressFour": "",
    "lat": "54.0367769",
    "lng": "-7.6811857",
    "phone": "494333955",
    "email": "newtowngorenatschool@gmail.com"
  },
  {
    "i": "1799",
    "county": "Leitrim",
    "rollNumber": "13656C",
    "schoolName": "Annaduff Mxd NS",
    "SETHours": "60",
    "spClassTeachingPosts": "1",
    "mainSNA": "2.5",
    "spSNA": "1",
    "totalSNA": "3.5",
    "eircode": "N41K309",
    "addressOne": "Antfield",
    "addressTwo": "Aughamore",
    "addressThree": "Carrick On Shannon",
    "addressFour": "Co. Leitrim",
    "lat": "53.9022558",
    "lng": "-7.9541607",
    "phone": "719624416",
    "email": "annaduff.ias@eircom.net"
  },
  {
    "i": "1800",
    "county": "Leitrim",
    "rollNumber": "13908D",
    "schoolName": "Ballaghameehan NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F91HH90",
    "addressOne": "Conray",
    "addressTwo": "Rossinver",
    "addressThree": "Co. Leitrim",
    "addressFour": "",
    "lat": "54.3816947",
    "lng": "-8.1091187",
    "phone": "719854073",
    "email": "bmeehannsirl@hotmail.com"
  },
  {
    "i": "1801",
    "county": "Leitrim",
    "rollNumber": "14339S",
    "schoolName": "Aughavas Ns",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.75",
    "spSNA": "0",
    "totalSNA": "1.75",
    "eircode": "H12YY74",
    "addressOne": "Aughavas",
    "addressTwo": "Carrigallen",
    "addressThree": "Co.leitrim",
    "addressFour": "",
    "lat": "53.9544775",
    "lng": "-7.7182759",
    "phone": "719636326",
    "email": "aughavasns@gmail.com"
  },
  {
    "i": "1802",
    "county": "Leitrim",
    "rollNumber": "14898I",
    "schoolName": "Drumeela NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H12XA02",
    "addressOne": "Drumeela",
    "addressTwo": "Carrigallen Po",
    "addressThree": "Co. Leitrim",
    "addressFour": "",
    "lat": "54.0144218",
    "lng": "-7.6481621",
    "phone": "494333305",
    "email": "drumeelans@gmail.com"
  },
  {
    "i": "1803",
    "county": "Leitrim",
    "rollNumber": "15116D",
    "schoolName": "Ardvarney Mxd NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F91K103",
    "addressOne": "Cashel",
    "addressTwo": "Dromahair",
    "addressThree": "Co. Leitrim",
    "addressFour": "",
    "lat": "54.221201",
    "lng": "-8.2381917",
    "phone": "719164757",
    "email": "ardvarneyns@gmail.com"
  },
  {
    "i": "1804",
    "county": "Leitrim",
    "rollNumber": "15194A",
    "schoolName": "Naomh Caillin",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "N41TK60",
    "addressOne": "Commons",
    "addressTwo": "Fenagh",
    "addressThree": "Co. Leitrim",
    "addressFour": "",
    "lat": "54.0188717",
    "lng": "-7.8350284",
    "phone": "719645244",
    "email": "fenaghns@gmail.com"
  },
  {
    "i": "1805",
    "county": "Leitrim",
    "rollNumber": "15382B",
    "schoolName": "Drumlease NS",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "F91T946",
    "addressOne": "Drumlease",
    "addressTwo": "Dromahair",
    "addressThree": "Co. Leitrim",
    "addressFour": "",
    "lat": "54.2285872",
    "lng": "-8.2932189",
    "phone": "719164586",
    "email": "drumleasens.ias@gmail.com"
  },
  {
    "i": "1806",
    "county": "Leitrim",
    "rollNumber": "15960P",
    "schoolName": "Gortletteragh Central",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "N41NY29",
    "addressOne": "Fornocht",
    "addressTwo": "Cara Droma Ruisc",
    "addressThree": "Co Leitrim",
    "addressFour": "",
    "lat": "53.878877",
    "lng": "-7.8166947",
    "phone": "719631926",
    "email": "gortletteraghs@gmail.com"
  },
  {
    "i": "1807",
    "county": "Leitrim",
    "rollNumber": "16130C",
    "schoolName": "St Josephs NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "F91RT98",
    "addressOne": "Killenummery",
    "addressTwo": "Dromahair",
    "addressThree": "Co. Leitrim",
    "addressFour": "",
    "lat": "54.194259",
    "lng": "-8.3058664",
    "phone": "719164860",
    "email": "killenummeryns@gmail.com"
  },
  {
    "i": "1808",
    "county": "Leitrim",
    "rollNumber": "16474L",
    "schoolName": "Carrigallen NS",
    "SETHours": "72.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "1",
    "spSNA": "2",
    "totalSNA": "3",
    "eircode": "H12HK79",
    "addressOne": "Longford Road",
    "addressTwo": "Carrigallen",
    "addressThree": "Co. Leitrim",
    "addressFour": "",
    "lat": "53.9740482",
    "lng": "-7.6468241",
    "phone": "494339929",
    "email": "carrigallenns@gmail.com"
  },
  {
    "i": "1809",
    "county": "Leitrim",
    "rollNumber": "16932P",
    "schoolName": "Aughawillan Ns",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "N41E082",
    "addressOne": "Lisgrudy",
    "addressTwo": "Garadice",
    "addressThree": "Co. Leitrim",
    "addressFour": "",
    "lat": "54.0749695",
    "lng": "-7.7378331",
    "phone": "719644246",
    "email": "aughawillanns@gmail.com"
  },
  {
    "i": "1810",
    "county": "Leitrim",
    "rollNumber": "17125O",
    "schoolName": "Differeen NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F91E044",
    "addressOne": "Diffreen",
    "addressTwo": "Manorhamilton",
    "addressThree": "Co. Leitrim",
    "addressFour": "",
    "lat": "54.3236664",
    "lng": "-8.3203463",
    "phone": "719855944",
    "email": "diffreen.ias@eircom.net"
  },
  {
    "i": "1811",
    "county": "Leitrim",
    "rollNumber": "17206O",
    "schoolName": "Glebe NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "F91P043",
    "addressOne": "Kinlough",
    "addressTwo": "Co. Leitrim",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.346029",
    "lng": "-8.2479245",
    "phone": "719856138",
    "email": "largyns@hotmail.com"
  },
  {
    "i": "1812",
    "county": "Leitrim",
    "rollNumber": "17233R",
    "schoolName": "St Clare's NS",
    "SETHours": "77.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "F91NP08",
    "addressOne": "Enniskillen Road",
    "addressTwo": "Manorhamilton",
    "addressThree": "Co. Leitrim",
    "addressFour": "",
    "lat": "54.3024971",
    "lng": "-8.1699162",
    "phone": "719855703",
    "email": "stclarespsmanorhamilton@gmail.com"
  },
  {
    "i": "1813",
    "county": "Leitrim",
    "rollNumber": "18139H",
    "schoolName": "SN Naomh Padraig",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "N41V344",
    "addressOne": "Tearmon",
    "addressTwo": "Spencer Harbour",
    "addressThree": "Drumkeerin",
    "addressFour": "",
    "lat": "54.1278809",
    "lng": "-8.0919929",
    "phone": "719648306",
    "email": "stpatsnstarmon@gmail.com"
  },
  {
    "i": "1814",
    "county": "Leitrim",
    "rollNumber": "18181G",
    "schoolName": "St. Hugh's NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "N41TC66",
    "addressOne": "Dowra",
    "addressTwo": "Via Carrick-on-shannon",
    "addressThree": "Co. Leitrim",
    "addressFour": "",
    "lat": "54.1859261",
    "lng": "-8.0096231",
    "phone": "719643444",
    "email": "info@sainthughs.com"
  },
  {
    "i": "1815",
    "county": "Leitrim",
    "rollNumber": "18329M",
    "schoolName": "SN Naomh Mhuire",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "F91N923",
    "addressOne": "Leckaun",
    "addressTwo": "Via Sligo",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.2753166",
    "lng": "-8.2926418",
    "phone": "719164569",
    "email": "info@leckaunns.ie"
  },
  {
    "i": "1816",
    "county": "Leitrim",
    "rollNumber": "18492A",
    "schoolName": "SN Naomh Brighid",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "N41VK83",
    "addressOne": "Coill Na Gcros",
    "addressTwo": "Carrick On Shannon",
    "addressThree": "Co Leitrim",
    "addressFour": "",
    "lat": "53.9861731",
    "lng": "-7.9554463",
    "phone": "719642412",
    "email": "kilnagrossns@gmail.com"
  },
  {
    "i": "1817",
    "county": "Leitrim",
    "rollNumber": "18589P",
    "schoolName": "SN Mhic Diarmada",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F91NF72",
    "addressOne": "Bóthar Ghleann Fearna",
    "addressTwo": "Coillte Clochair",
    "addressThree": "Co. Liatroma",
    "addressFour": "",
    "lat": "54.3557454",
    "lng": "-8.0361434",
    "phone": "719854061",
    "email": "scoilmhicdiarmada@gmail.com"
  },
  {
    "i": "1818",
    "county": "Leitrim",
    "rollNumber": "18741S",
    "schoolName": "Faitima NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "N41HN73",
    "addressOne": "Cloone",
    "addressTwo": "Carrick On Shannon",
    "addressThree": "Co Leitrim",
    "addressFour": "",
    "lat": "53.9452007",
    "lng": "-7.7861044",
    "phone": "719636522",
    "email": "fatimanscloone@gmail.com"
  },
  {
    "i": "1819",
    "county": "Leitrim",
    "rollNumber": "19255O",
    "schoolName": "St Michaels Ns",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "F91YW25",
    "addressOne": "West Barrs",
    "addressTwo": "Glenfarne",
    "addressThree": "Co. Leitrim",
    "addressFour": "",
    "lat": "54.2983494",
    "lng": "-8.0677201",
    "phone": "719856057",
    "email": "glenfarnestmichaels@gmail.com"
  },
  {
    "i": "1820",
    "county": "Leitrim",
    "rollNumber": "19360L",
    "schoolName": "Drumkeerin Central Ns",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "N41DK12",
    "addressOne": "Drumkeerin",
    "addressTwo": "Co. Leitrim",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.1653595",
    "lng": "-8.1403187",
    "phone": "719648314",
    "email": "drumkeerinns@gmail.com"
  },
  {
    "i": "1821",
    "county": "Leitrim",
    "rollNumber": "19365V",
    "schoolName": "Achadh Na Sileann",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "N41NX92",
    "addressOne": "Aughnasheelin",
    "addressTwo": "Ballinamore",
    "addressThree": "Co. Leitrim",
    "addressFour": "",
    "lat": "54.0681329",
    "lng": "-7.8643297",
    "phone": "719644868",
    "email": "info@stmarysnsaughnasheelin.ie"
  },
  {
    "i": "1822",
    "county": "Leitrim",
    "rollNumber": "19423J",
    "schoolName": "St Patricks Ns",
    "SETHours": "80",
    "spClassTeachingPosts": "2",
    "mainSNA": "1.83",
    "spSNA": "5",
    "totalSNA": "6.83",
    "eircode": "N41PY61",
    "addressOne": "Drumshanbo",
    "addressTwo": "Co Leitrim",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.0472667",
    "lng": "-8.0345017",
    "phone": "719641755",
    "email": "stpatricksnsdrumshanbo@gmail.com"
  },
  {
    "i": "1823",
    "county": "Leitrim",
    "rollNumber": "19519W",
    "schoolName": "St Brids",
    "SETHours": "62.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "N41VK20",
    "addressOne": "Drumcong",
    "addressTwo": "Carrick-on-shannon",
    "addressThree": "Co. Leitrim",
    "addressFour": "",
    "lat": "54.0293549",
    "lng": "-7.9739052",
    "phone": "719642315",
    "email": "drumcongns1978@gmail.com"
  },
  {
    "i": "1824",
    "county": "Leitrim",
    "rollNumber": "19554B",
    "schoolName": "Scoil Mhuire",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "N41YH05",
    "addressOne": "Bornacoola",
    "addressTwo": "Carrick On Shannon",
    "addressThree": "Co Leitrim",
    "addressFour": "",
    "lat": "53.8604916",
    "lng": "-7.8789595",
    "phone": "719638441",
    "email": "scoilmhuirensbornacoola@gmail.com"
  },
  {
    "i": "1825",
    "county": "Leitrim",
    "rollNumber": "19600F",
    "schoolName": "SN Naomh Mhuire",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "H12P596",
    "addressOne": "Drumlea",
    "addressTwo": "Carrigallen",
    "addressThree": "Via Cavan",
    "addressFour": "Co. Leitrim",
    "lat": "54.0183699",
    "lng": "-7.7287234",
    "phone": "494333125",
    "email": "drumleans@gmail.com"
  },
  {
    "i": "1826",
    "county": "Leitrim",
    "rollNumber": "20079E",
    "schoolName": "Four Masters Ns",
    "SETHours": "105",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "F91P086",
    "addressOne": "Kinlough",
    "addressTwo": "Co. Leitrim",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.4459966",
    "lng": "-8.2889705",
    "phone": "719841123",
    "email": "fmastersns@gmail.com"
  },
  {
    "i": "1827",
    "county": "Leitrim",
    "rollNumber": "20203C",
    "schoolName": "Mohill NS",
    "SETHours": "80",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "N41X762",
    "addressOne": "Mohill",
    "addressTwo": "Co. Leitrim",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.920837",
    "lng": "-7.8710055",
    "phone": "719631774",
    "email": "mohillns@gmail.com"
  },
  {
    "i": "1828",
    "county": "Leitrim",
    "rollNumber": "20212D",
    "schoolName": "Gaelscoil Liatroma",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "N41V2H5",
    "addressOne": "Cora Droma Rúisc",
    "addressTwo": "Co. Liatroma",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.9528213",
    "lng": "-8.0689051",
    "phone": "719671464",
    "email": "gaelscoilliatroma@gmail.com"
  },
  {
    "i": "1829",
    "county": "Leitrim",
    "rollNumber": "20260O",
    "schoolName": "Gaelscoil Chluainí­n",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F91PP62",
    "addressOne": "Sráid An Chaisleáin",
    "addressTwo": "Cluainí­n Í­ Ruairc",
    "addressThree": "Co. Liatroma",
    "addressFour": "",
    "lat": "54.3061048",
    "lng": "-8.1797802",
    "phone": "719856046",
    "email": "gaelscoilchluainin@eircom.net"
  },
  {
    "i": "1830",
    "county": "Leitrim",
    "rollNumber": "20432R",
    "schoolName": "Scoil Mhuire",
    "SETHours": "170",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.66",
    "spSNA": "0",
    "totalSNA": "4.66",
    "eircode": "N41Y186",
    "addressOne": "Carrick-on-shannon",
    "addressTwo": "Co. Leitrim",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.9476796",
    "lng": "-8.0899761",
    "phone": "719620285",
    "email": "maristckns1@gmail.com"
  },
  {
    "i": "1831",
    "county": "Leitrim",
    "rollNumber": "20483L",
    "schoolName": "Scoil Chlann Naofa",
    "SETHours": "105",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "N41KD98",
    "addressOne": "Ballinamore",
    "addressTwo": "Co Leitrim",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.0522322",
    "lng": "-7.8104815",
    "phone": "719645001",
    "email": "ballinamorebns1@gmail.com"
  },
  {
    "i": "1832",
    "county": "Limerick",
    "rollNumber": "02007A",
    "schoolName": "Croagh NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V94R7R2",
    "addressOne": "Croagh",
    "addressTwo": "Rathkeale",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.5344067",
    "lng": "-8.8733674",
    "phone": "6964750",
    "email": "croaghns@outlook.com"
  },
  {
    "i": "1833",
    "county": "Limerick",
    "rollNumber": "02358G",
    "schoolName": "Templeglantine NS",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.25",
    "spSNA": "0",
    "totalSNA": "1.25",
    "eircode": "V94KC56",
    "addressOne": "Templeglantine East",
    "addressTwo": "Co. Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.3948518",
    "lng": "-9.1797416",
    "phone": "6984300",
    "email": "glantine.ias@eircom.net"
  },
  {
    "i": "1834",
    "county": "Limerick",
    "rollNumber": "02813E",
    "schoolName": "SN Sheanain",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "V94NX50",
    "addressOne": "Corgrigg",
    "addressTwo": "Foynes",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.6087343",
    "lng": "-9.1051789",
    "phone": "6965117",
    "email": "stsenans@yahoo.ie"
  },
  {
    "i": "1835",
    "county": "Limerick",
    "rollNumber": "04466T",
    "schoolName": "Ballymartin NS",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V35EK54",
    "addressOne": "Manister",
    "addressTwo": "Croom",
    "addressThree": "Co Limerick",
    "addressFour": "",
    "lat": "52.5320515",
    "lng": "-8.6539083",
    "phone": "61397220",
    "email": "manister.ns@hotmail.com"
  },
  {
    "i": "1836",
    "county": "Limerick",
    "rollNumber": "04469C",
    "schoolName": "SN Fiodhnach",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "V35FN44",
    "addressOne": "Feenagh",
    "addressTwo": "Kilmallock",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.3872823",
    "lng": "-8.8738823",
    "phone": "6385225",
    "email": "feenaghns@eircom.net"
  },
  {
    "i": "1837",
    "county": "Limerick",
    "rollNumber": "06516S",
    "schoolName": "Kildimo NS",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "V94KW80",
    "addressOne": "Kildimo",
    "addressTwo": "Co. Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6212128",
    "lng": "-8.8116078",
    "phone": "61394500",
    "email": "info@kildimons.ie"
  },
  {
    "i": "1838",
    "county": "Limerick",
    "rollNumber": "06539H",
    "schoolName": "Knockea NS",
    "SETHours": "115",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.66",
    "spSNA": "0",
    "totalSNA": "5.66",
    "eircode": "V94FX90",
    "addressOne": "Knockea",
    "addressTwo": "Ballyneety",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.6061263",
    "lng": "-8.5722944",
    "phone": "61351414",
    "email": "principal@knockeans.ie"
  },
  {
    "i": "1839",
    "county": "Limerick",
    "rollNumber": "06936R",
    "schoolName": "St Johns Convent",
    "SETHours": "180",
    "spClassTeachingPosts": "1",
    "mainSNA": "5.42",
    "spSNA": "0.33",
    "totalSNA": "5.75",
    "eircode": "V94T223",
    "addressOne": "Cathedral Place",
    "addressTwo": "Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6619269",
    "lng": "-8.6164391",
    "phone": "61416752",
    "email": "johnsns@eircom.net"
  },
  {
    "i": "1840",
    "county": "Limerick",
    "rollNumber": "07117J",
    "schoolName": "SN Loch Guir",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V35XE27",
    "addressOne": "Patrickswell",
    "addressTwo": "Bruff",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.5052703",
    "lng": "-8.5076439",
    "phone": "61385004",
    "email": "loughgurns@gmail.com"
  },
  {
    "i": "1841",
    "county": "Limerick",
    "rollNumber": "07222G",
    "schoolName": "Banogue NS",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "V35HY63",
    "addressOne": "Dohora",
    "addressTwo": "Banogue",
    "addressThree": "Croom",
    "addressFour": "Co. Limerick",
    "lat": "52.4808357",
    "lng": "-8.7079568",
    "phone": "61397188",
    "email": "banoguenationalschool@gmail.com"
  },
  {
    "i": "1842",
    "county": "Limerick",
    "rollNumber": "07317R",
    "schoolName": "Glengurt NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "V42TD93",
    "addressOne": "Tournafulla",
    "addressTwo": "Ballagh",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.3627213",
    "lng": "-9.1635004",
    "phone": "6981120",
    "email": "glengurtns.bdalton@gmail.com"
  },
  {
    "i": "1843",
    "county": "Limerick",
    "rollNumber": "07857D",
    "schoolName": "SN Ailbhe",
    "SETHours": "80",
    "spClassTeachingPosts": "2",
    "mainSNA": "2.75",
    "spSNA": "3.83",
    "totalSNA": "6.58",
    "eircode": "V94T184",
    "addressOne": "Killinure",
    "addressTwo": "Brittas",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.6138043",
    "lng": "-8.4369437",
    "phone": "61351377",
    "email": "snailbhe@gmail.com"
  },
  {
    "i": "1844",
    "county": "Limerick",
    "rollNumber": "07900B",
    "schoolName": "Ballysteen NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "V94Y078",
    "addressOne": "Ballysteen",
    "addressTwo": "Askeaton",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.6467839",
    "lng": "-8.9518549",
    "phone": "61398383",
    "email": "ballysteenns@gmail.com"
  },
  {
    "i": "1845",
    "county": "Limerick",
    "rollNumber": "08342V",
    "schoolName": "Bohermore NS",
    "SETHours": "30",
    "spClassTeachingPosts": "1",
    "mainSNA": "2",
    "spSNA": "2",
    "totalSNA": "4",
    "eircode": "V94EF60",
    "addressOne": "Srahane",
    "addressTwo": "Ballysimon",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.6110353",
    "lng": "-8.5252138",
    "phone": "61351020",
    "email": "bohermorens.ias@eircom.net"
  },
  {
    "i": "1846",
    "county": "Limerick",
    "rollNumber": "08419H",
    "schoolName": "Ardpatrick NS",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "V35CC64",
    "addressOne": "Ardpatrick",
    "addressTwo": "Kilmallock",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.3434065",
    "lng": "-8.5190283",
    "phone": "6391411",
    "email": "ardpatrickns@gmail.com"
  },
  {
    "i": "1847",
    "county": "Limerick",
    "rollNumber": "08572P",
    "schoolName": "Bruree NS",
    "SETHours": "75",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "V35EK64",
    "addressOne": "Bruree",
    "addressTwo": "Co. Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.4229735",
    "lng": "-8.6495508",
    "phone": "6390896",
    "email": "office@brureens.ie"
  },
  {
    "i": "1848",
    "county": "Limerick",
    "rollNumber": "08926B",
    "schoolName": "St Nicholas Church Of Ireland Schoo",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.75",
    "spSNA": "0",
    "totalSNA": "2.75",
    "eircode": "V94E622",
    "addressOne": "Blackabbey",
    "addressTwo": "Adare",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.5676444",
    "lng": "-8.784963",
    "phone": "61396683",
    "email": "stnicholasadare.ias@eircom.net"
  },
  {
    "i": "1849",
    "county": "Limerick",
    "rollNumber": "09132P",
    "schoolName": "Carnane Mxd NS",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "V35V520",
    "addressOne": "Carnane",
    "addressTwo": "Fedamore",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.57123",
    "lng": "-8.5812428",
    "phone": "61390343",
    "email": "carnane.ias@eircom.net"
  },
  {
    "i": "1850",
    "county": "Limerick",
    "rollNumber": "09296W",
    "schoolName": "Our Ladys Abbey",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.25",
    "spSNA": "0",
    "totalSNA": "1.25",
    "eircode": "V94C437",
    "addressOne": "Blackabbey",
    "addressTwo": "Adare",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.5653655",
    "lng": "-8.7885379",
    "phone": "61396753",
    "email": "ourladysabbeyadare@gmail.com"
  },
  {
    "i": "1851",
    "county": "Limerick",
    "rollNumber": "09306W",
    "schoolName": "Croom NS",
    "SETHours": "117.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "4",
    "spSNA": "3",
    "totalSNA": "7",
    "eircode": "V35WD60",
    "addressOne": "High Street",
    "addressTwo": "Croom",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.5209419",
    "lng": "-8.7133006",
    "phone": "61397416",
    "email": "principal@croomns.ie"
  },
  {
    "i": "1852",
    "county": "Limerick",
    "rollNumber": "09401Q",
    "schoolName": "Monogay NS",
    "SETHours": "90",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.08",
    "spSNA": "0",
    "totalSNA": "3.08",
    "eircode": "V42VW74",
    "addressOne": "Monagea",
    "addressTwo": "Newcastle West",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.4177681",
    "lng": "-9.088059",
    "phone": "6962805",
    "email": "office@monageans.net"
  },
  {
    "i": "1853",
    "county": "Limerick",
    "rollNumber": "09702H",
    "schoolName": "St James NS",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "V94X661",
    "addressOne": "Cappagh",
    "addressTwo": "Askeaton",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.5540234",
    "lng": "-8.9289241",
    "phone": "6964780",
    "email": "cappaghns1@yahoo.ie"
  },
  {
    "i": "1854",
    "county": "Limerick",
    "rollNumber": "09915B",
    "schoolName": "Martinstown NS",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.25",
    "spSNA": "0",
    "totalSNA": "2.25",
    "eircode": "V35YK74",
    "addressOne": "Martinstown",
    "addressTwo": "Kilmallock",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.3972996",
    "lng": "-8.4789886",
    "phone": "6388146",
    "email": "martinstownns@gmail.com"
  },
  {
    "i": "1855",
    "county": "Limerick",
    "rollNumber": "09927I",
    "schoolName": "Granagh NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "V35FN27",
    "addressOne": "Granagh",
    "addressTwo": "Kilmallock",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.4592633",
    "lng": "-8.7635876",
    "phone": "61399081",
    "email": "office@granaghns.ie"
  },
  {
    "i": "1856",
    "county": "Limerick",
    "rollNumber": "10929T",
    "schoolName": "Rathkeale NS 2",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "V94P588",
    "addressOne": "Church Street",
    "addressTwo": "Rathkeale",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.5187783",
    "lng": "-8.9447922",
    "phone": "6964571",
    "email": "info@rathkealens.ie"
  },
  {
    "i": "1857",
    "county": "Limerick",
    "rollNumber": "10991B",
    "schoolName": "Garrydoolis NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "V94K5A4",
    "addressOne": "Garrydoolis",
    "addressTwo": "Pallasgreen",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.5081766",
    "lng": "-8.3359309",
    "phone": "6257343",
    "email": "garrydoolisns@gmail.com"
  },
  {
    "i": "1858",
    "county": "Limerick",
    "rollNumber": "11280T",
    "schoolName": "Carrickerry NS",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "V94N592",
    "addressOne": "Carrickerry",
    "addressTwo": "Athea",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.4924925",
    "lng": "-9.1488312",
    "phone": "6976229",
    "email": "office@carrickerryns.ie"
  },
  {
    "i": "1859",
    "county": "Limerick",
    "rollNumber": "11307N",
    "schoolName": "Ballyguiltenane NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "V94T2W9",
    "addressOne": "Ballyguiltenane Upper",
    "addressTwo": "Glin",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.524211",
    "lng": "-9.2909296",
    "phone": "6834545",
    "email": "office@ballyguiltenanens.ie"
  },
  {
    "i": "1860",
    "county": "Limerick",
    "rollNumber": "11422N",
    "schoolName": "Mahoonagh NS",
    "SETHours": "102.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "4",
    "spSNA": "2",
    "totalSNA": "6",
    "eircode": "V42Y362",
    "addressOne": "Main Street",
    "addressTwo": "Castlemahon",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.4309315",
    "lng": "-9.009582",
    "phone": "6972332",
    "email": "mahoonaghns.ias@gmail.com"
  },
  {
    "i": "1861",
    "county": "Limerick",
    "rollNumber": "11809O",
    "schoolName": "SN Cnoch A Deaga",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V35DW73",
    "addressOne": "Knockadea",
    "addressTwo": "Ballylanders",
    "addressThree": "Kilmallock",
    "addressFour": "Co. Limerick",
    "lat": "52.3287777",
    "lng": "-8.3425592",
    "phone": "6246113",
    "email": "knockadeaschool@gmail.com"
  },
  {
    "i": "1862",
    "county": "Limerick",
    "rollNumber": "11955C",
    "schoolName": "Coolcappa NS",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V42NT35",
    "addressOne": "Ardagh",
    "addressTwo": "Co. Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.525965",
    "lng": "-9.0182708",
    "phone": "6976493",
    "email": "coolcappans@gmail.com"
  },
  {
    "i": "1863",
    "county": "Limerick",
    "rollNumber": "12368P",
    "schoolName": "SN Naomh Padraig",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "V94W263",
    "addressOne": "Knocknasnaa",
    "addressTwo": "Abbeyfeale",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.4165666",
    "lng": "-9.3007132",
    "phone": "6832121",
    "email": "knocknasnanationalschool@gmail.com"
  },
  {
    "i": "1864",
    "county": "Limerick",
    "rollNumber": "12613C",
    "schoolName": "Glenbrohane NS",
    "SETHours": "0",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V35P220",
    "addressOne": "Glenbrohane",
    "addressTwo": "Garryspillane",
    "addressThree": "Kilmallock",
    "addressFour": "Co. Limerick",
    "lat": "52.3870919",
    "lng": "-8.3877518",
    "phone": "6246009",
    "email": "glenbrohaneschool@gmail.com"
  },
  {
    "i": "1865",
    "county": "Limerick",
    "rollNumber": "12631E",
    "schoolName": "Pallaskenry NS",
    "SETHours": "92.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "3.5",
    "spSNA": "1",
    "totalSNA": "4.5",
    "eircode": "V94DN24",
    "addressOne": "Pallas",
    "addressTwo": "Pallaskenry",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.6395981",
    "lng": "-8.8677422",
    "phone": "61393096",
    "email": "info@pallaskenryns.ie"
  },
  {
    "i": "1866",
    "county": "Limerick",
    "rollNumber": "12834S",
    "schoolName": "St Michaels",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "V94A0K7",
    "addressOne": "11 Barrington Street",
    "addressTwo": "Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6575752",
    "lng": "-8.6297288",
    "phone": "61315927",
    "email": "info@smnslimerick.ie"
  },
  {
    "i": "1867",
    "county": "Limerick",
    "rollNumber": "12975N",
    "schoolName": "St Josephs Convent",
    "SETHours": "87.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "2.33",
    "spSNA": "1.66",
    "totalSNA": "3.99",
    "eircode": "V42T180",
    "addressOne": "Lower Knockane Road",
    "addressTwo": "Newcastle West",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.447904",
    "lng": "-9.0594851",
    "phone": "6962778",
    "email": "scoiliosaf.ias@eircom.net"
  },
  {
    "i": "1868",
    "county": "Limerick",
    "rollNumber": "13026P",
    "schoolName": "Kilfinane Convent Primary School",
    "SETHours": "65",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "V35EY95",
    "addressOne": "Castle Street",
    "addressTwo": "Kilfinane",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.3613431",
    "lng": "-8.4687828",
    "phone": "6391326",
    "email": "kilfinanens@gmail.com"
  },
  {
    "i": "1869",
    "county": "Limerick",
    "rollNumber": "13459A",
    "schoolName": "SN Gallbhaile",
    "SETHours": "55",
    "spClassTeachingPosts": "1",
    "mainSNA": "2",
    "spSNA": "2",
    "totalSNA": "4",
    "eircode": "E34XN57",
    "addressOne": "Galbally",
    "addressTwo": "Co. Tipperary",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.3995872",
    "lng": "-8.2951006",
    "phone": "6237933",
    "email": "galballyns@gmail.com"
  },
  {
    "i": "1870",
    "county": "Limerick",
    "rollNumber": "13790G",
    "schoolName": "Bulgaden NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V35F589",
    "addressOne": "Bulgaden",
    "addressTwo": "Kilmallock",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.4226179",
    "lng": "-8.5268126",
    "phone": "6398882",
    "email": "bulgadennnationalschool@gmail.com"
  },
  {
    "i": "1871",
    "county": "Limerick",
    "rollNumber": "14005M",
    "schoolName": "Kilteely NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "0",
    "spSNA": "2",
    "totalSNA": "2",
    "eircode": "V94HC62",
    "addressOne": "Kilteely",
    "addressTwo": "Co. Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.5212066",
    "lng": "-8.3990035",
    "phone": "61384568",
    "email": "kilteelyns@outlook.com"
  },
  {
    "i": "1872",
    "county": "Limerick",
    "rollNumber": "14067L",
    "schoolName": "Fedamore NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V35KT54",
    "addressOne": "Ballyea",
    "addressTwo": "Fedamore",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.5452973",
    "lng": "-8.6051784",
    "phone": "61390337",
    "email": "fedamorens@yahoo.ie"
  },
  {
    "i": "1873",
    "county": "Limerick",
    "rollNumber": "14075K",
    "schoolName": "SN Molua B",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V42XH94",
    "addressOne": "Cross",
    "addressTwo": "Ardagh",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.4979596",
    "lng": "-9.0609808",
    "phone": "6976353",
    "email": "office@stmoluasns.scoilnet.ie"
  },
  {
    "i": "1874",
    "county": "Limerick",
    "rollNumber": "14231V",
    "schoolName": "Nicker NS",
    "SETHours": "72.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "V94XF84",
    "addressOne": "Nicker",
    "addressTwo": "Pallasgreen",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.561035",
    "lng": "-8.3458804",
    "phone": "61384761",
    "email": "nickerprimaryschool@gmail.com"
  },
  {
    "i": "1875",
    "county": "Limerick",
    "rollNumber": "14305B",
    "schoolName": "Ballylanders NS",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.75",
    "spSNA": "0",
    "totalSNA": "2.75",
    "eircode": "V35R9X8",
    "addressOne": "Main Street",
    "addressTwo": "Ballylanders",
    "addressThree": "Kilmallock",
    "addressFour": "Co. Limerick",
    "lat": "52.3708691",
    "lng": "-8.3465021",
    "phone": "6246889",
    "email": "ballylandersns@live.ie"
  },
  {
    "i": "1876",
    "county": "Limerick",
    "rollNumber": "14409N",
    "schoolName": "Scoil Neassain",
    "SETHours": "287.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "7",
    "spSNA": "0",
    "totalSNA": "7",
    "eircode": "V94FY29",
    "addressOne": "Mungret",
    "addressTwo": "Co. Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6309384",
    "lng": "-8.6683743",
    "phone": "61229911",
    "email": "office@stnessans.ie"
  },
  {
    "i": "1877",
    "county": "Limerick",
    "rollNumber": "14625T",
    "schoolName": "Doon Convent NS",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "V94CV48",
    "addressOne": "Doon",
    "addressTwo": "Co. Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6029366",
    "lng": "-8.2452348",
    "phone": "61380149",
    "email": "conventns@gmail.com"
  },
  {
    "i": "1878",
    "county": "Limerick",
    "rollNumber": "15226K",
    "schoolName": "Caherline NS",
    "SETHours": "75",
    "spClassTeachingPosts": "2",
    "mainSNA": "2",
    "spSNA": "4",
    "totalSNA": "6",
    "eircode": "V94KX74",
    "addressOne": "Caherline",
    "addressTwo": "Caherconlish",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.5687292",
    "lng": "-8.4542163",
    "phone": "61351657",
    "email": "caherlinenationalschool@gmail.com"
  },
  {
    "i": "1879",
    "county": "Limerick",
    "rollNumber": "15320C",
    "schoolName": "St Michaels Ns",
    "SETHours": "132.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "4.66",
    "spSNA": "3.32",
    "totalSNA": "7.98",
    "eircode": "V94HX23",
    "addressOne": "Sexton Street",
    "addressTwo": "Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6588527",
    "lng": "-8.6223052",
    "phone": "61317672",
    "email": "stmichaelsinfantschool@gmail.com"
  },
  {
    "i": "1880",
    "county": "Limerick",
    "rollNumber": "15680J",
    "schoolName": "Scoil An Spioraid Naomh",
    "SETHours": "85",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "V94WA29",
    "addressOne": "Roxborough",
    "addressTwo": "Ballysheedy",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.6081157",
    "lng": "-8.6250408",
    "phone": "61228041",
    "email": "donatleahy@eircom.net"
  },
  {
    "i": "1881",
    "county": "Limerick",
    "rollNumber": "15685T",
    "schoolName": "Athea N School",
    "SETHours": "87.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "2.5",
    "spSNA": "4.83",
    "totalSNA": "7.33",
    "eircode": "V94F226",
    "addressOne": "Athea",
    "addressTwo": "Co. Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.4606659",
    "lng": "-9.2849386",
    "phone": "6842333",
    "email": "atheans.ias@eircom.net"
  },
  {
    "i": "1882",
    "county": "Limerick",
    "rollNumber": "15692Q",
    "schoolName": "Bilboa N School",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "V94KN61",
    "addressOne": "Bilaboa",
    "addressTwo": "Cappaghmore",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.6344543",
    "lng": "-8.2909533",
    "phone": "61381652",
    "email": "info@bilboans.ie"
  },
  {
    "i": "1883",
    "county": "Limerick",
    "rollNumber": "15700M",
    "schoolName": "Cloverfield NS",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "V94DW42",
    "addressOne": "Cloverfield",
    "addressTwo": "Dromchaoin",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.5568687",
    "lng": "-8.4058522",
    "phone": "61384566",
    "email": "cloverfieldns2013@gmail.com"
  },
  {
    "i": "1884",
    "county": "Limerick",
    "rollNumber": "16118M",
    "schoolName": "Donoughmore NS",
    "SETHours": "115",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.83",
    "spSNA": "0",
    "totalSNA": "4.83",
    "eircode": "V94X051",
    "addressOne": "Donoughmore",
    "addressTwo": "Co. Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6341345",
    "lng": "-8.5893112",
    "phone": "61418173",
    "email": "donoughmorenslimk@gmail.com"
  },
  {
    "i": "1885",
    "county": "Limerick",
    "rollNumber": "16237U",
    "schoolName": "Dromtrasna NS",
    "SETHours": "47.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "0.75",
    "spSNA": "2",
    "totalSNA": "2.75",
    "eircode": "V94W5RC",
    "addressOne": "Dromtrasna NS",
    "addressTwo": "Dromtrasna North",
    "addressThree": "Abbeyfeale",
    "addressFour": "",
    "lat": "52.3663855",
    "lng": "-9.2496059",
    "phone": "6831822",
    "email": "dromtrasnans@gmail.com"
  },
  {
    "i": "1886",
    "county": "Limerick",
    "rollNumber": "16239B",
    "schoolName": "Meenkilly NS",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V94CXH1",
    "addressOne": "Abbeyfeale",
    "addressTwo": "Co Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.3399232",
    "lng": "-9.2632162",
    "phone": "6831631",
    "email": "marymeenkilly@gmail.com"
  },
  {
    "i": "1887",
    "county": "Limerick",
    "rollNumber": "16264A",
    "schoolName": "Abbeyfeale BNS 1",
    "SETHours": "62.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "V94DH96",
    "addressOne": "Church Street",
    "addressTwo": "Abbeyfeale",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.3860229",
    "lng": "-9.3019445",
    "phone": "6831699",
    "email": "stmarysboys.ias@eircom.net"
  },
  {
    "i": "1888",
    "county": "Limerick",
    "rollNumber": "16439J",
    "schoolName": "Scoil Na Mbearnan",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "V94P6Y6",
    "addressOne": "Pallasagreen",
    "addressTwo": "Co Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.5369418",
    "lng": "-8.3299475",
    "phone": "61384481",
    "email": "barnaschoolpallasgreen@gmail.com"
  },
  {
    "i": "1889",
    "county": "Limerick",
    "rollNumber": "16443A",
    "schoolName": "Scoil Padraig Naofa B",
    "SETHours": "135",
    "spClassTeachingPosts": "0",
    "mainSNA": "5",
    "spSNA": "0",
    "totalSNA": "5",
    "eircode": "V94NX84",
    "addressOne": "Dublin Road",
    "addressTwo": "Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6639665",
    "lng": "-8.6065119",
    "phone": "61412913",
    "email": "principal@stpatricksboysns.com"
  },
  {
    "i": "1890",
    "county": "Limerick",
    "rollNumber": "16444C",
    "schoolName": "Scoil Padraig Naofa C",
    "SETHours": "110",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "V94X3W6",
    "addressOne": "Dublin Road",
    "addressTwo": "Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6649403",
    "lng": "-8.6072242",
    "phone": "61417119",
    "email": "stpatricksgnslk@gmail.com"
  },
  {
    "i": "1891",
    "county": "Limerick",
    "rollNumber": "16508C",
    "schoolName": "Scoil Athain",
    "SETHours": "82.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.25",
    "spSNA": "0",
    "totalSNA": "4.25",
    "eircode": "V94EY11",
    "addressOne": "Laught",
    "addressTwo": "Lisnagry",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.6684951",
    "lng": "-8.4821838",
    "phone": "61335101",
    "email": "office@ahanenationalschool.ie"
  },
  {
    "i": "1892",
    "county": "Limerick",
    "rollNumber": "16712B",
    "schoolName": "Scoil Naomh Iosaf",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "V94FK30",
    "addressOne": "Rathkeale Road",
    "addressTwo": "Adare",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.5603951",
    "lng": "-8.7932684",
    "phone": "61396101",
    "email": "sniadare.ias@eircom.net"
  },
  {
    "i": "1893",
    "county": "Limerick",
    "rollNumber": "16713D",
    "schoolName": "Scoil Na Mbraithre",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "V94C3V5",
    "addressOne": "Doon",
    "addressTwo": "Co Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.60612",
    "lng": "-8.2435102",
    "phone": "61380239",
    "email": "dunbleiscecbs@gmail.com"
  },
  {
    "i": "1894",
    "county": "Limerick",
    "rollNumber": "16715H",
    "schoolName": "St John The Baptist Boys NS",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.5",
    "spSNA": "0",
    "totalSNA": "3.5",
    "eircode": "V94FA44",
    "addressOne": "Downey Street",
    "addressTwo": "Pennywell",
    "addressThree": "Limerick",
    "addressFour": "",
    "lat": "52.6632948",
    "lng": "-8.6146239",
    "phone": "61312411",
    "email": "principal@sjtbb.ie"
  },
  {
    "i": "1895",
    "county": "Limerick",
    "rollNumber": "16764U",
    "schoolName": "Kilmeedy NS",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "V42DX30",
    "addressOne": "Kilmeedy",
    "addressTwo": "Co Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.4153441",
    "lng": "-8.9175809",
    "phone": "6387128",
    "email": "kilmeedyprimary@gmail.com"
  },
  {
    "i": "1896",
    "county": "Limerick",
    "rollNumber": "16896O",
    "schoolName": "Scoil Naomh Ide",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "V42XE16",
    "addressOne": "Ashford",
    "addressTwo": "Ballagh",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.3606785",
    "lng": "-9.0596535",
    "phone": "6985292",
    "email": "ashfordns@gmail.com"
  },
  {
    "i": "1897",
    "county": "Limerick",
    "rollNumber": "16910F",
    "schoolName": "Scoil Iosagain",
    "SETHours": "182.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "3",
    "spSNA": "3",
    "totalSNA": "6",
    "eircode": "V94HX23",
    "addressOne": "Sexton Street",
    "addressTwo": "Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6588527",
    "lng": "-8.6223052",
    "phone": "61413950",
    "email": "reception@cbslk.ie"
  },
  {
    "i": "1899",
    "county": "Limerick",
    "rollNumber": "17060M",
    "schoolName": "Convent Of Mercy NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.58",
    "spSNA": "0",
    "totalSNA": "3.58",
    "eircode": "V94XY93",
    "addressOne": "Convent Road",
    "addressTwo": "Abbeyfeale",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.3872142",
    "lng": "-9.2958202",
    "phone": "6831701",
    "email": "mhathairde.ias@eircom.net"
  },
  {
    "i": "1900",
    "county": "Limerick",
    "rollNumber": "17068F",
    "schoolName": "Scoil Sean Tsraide",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "V94HC65",
    "addressOne": "Tuogh",
    "addressTwo": "Adare",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.5716748",
    "lng": "-8.8368617",
    "phone": "61396765",
    "email": "shountradens@gmail.com"
  },
  {
    "i": "1901",
    "county": "Limerick",
    "rollNumber": "17101A",
    "schoolName": "Scoil Cre Cumhra",
    "SETHours": "97.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "V94P5C0",
    "addressOne": "Crecora",
    "addressTwo": "Patrickswell",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.576946",
    "lng": "-8.6699766",
    "phone": "61355228",
    "email": "principalcrecoranationalschool@gmail.com"
  },
  {
    "i": "1902",
    "county": "Limerick",
    "rollNumber": "17138A",
    "schoolName": "Scoil Cill Colmain",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.25",
    "spSNA": "0",
    "totalSNA": "3.25",
    "eircode": "V42T320",
    "addressOne": "Ard Achadh",
    "addressTwo": "Co Luimnigh",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.5330563",
    "lng": "-9.0853116",
    "phone": "6960005",
    "email": "kilschool1@eircom.net"
  },
  {
    "i": "1903",
    "county": "Limerick",
    "rollNumber": "17155A",
    "schoolName": "Athlacca NS",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "V35AN83",
    "addressOne": "Athlacca",
    "addressTwo": "Kilmallock",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.4570188",
    "lng": "-8.6466603",
    "phone": "6390978",
    "email": "athlaccans@gmail.com"
  },
  {
    "i": "1904",
    "county": "Limerick",
    "rollNumber": "17184H",
    "schoolName": "Oola NS",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "E34P389",
    "addressOne": "Oola",
    "addressTwo": "Tipperary",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.5319884",
    "lng": "-8.2617167",
    "phone": "6247906",
    "email": "oolaprincipal@eircom.net"
  },
  {
    "i": "1905",
    "county": "Limerick",
    "rollNumber": "17212J",
    "schoolName": "Scoil Nais Cnoc Aine",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.66",
    "spSNA": "0",
    "totalSNA": "5.66",
    "eircode": "V35AH66",
    "addressOne": "Knockainey",
    "addressTwo": "Hospital",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.4721897",
    "lng": "-8.4735494",
    "phone": "61383529",
    "email": "cnocaine@gmail.com"
  },
  {
    "i": "1906",
    "county": "Limerick",
    "rollNumber": "17298W",
    "schoolName": "Kilbehenny NS",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "P67HR64",
    "addressOne": "Kilbehenny",
    "addressTwo": "Mitchelstown",
    "addressThree": "Co Cork",
    "addressFour": "",
    "lat": "52.3000925",
    "lng": "-8.217406",
    "phone": "2584337",
    "email": "kilbehennyns2015@gmail.com"
  },
  {
    "i": "1907",
    "county": "Limerick",
    "rollNumber": "17299B",
    "schoolName": "Scoil Mhuire",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "V35RH51",
    "addressOne": "Effin",
    "addressTwo": "Kilmallock",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.3480289",
    "lng": "-8.6082042",
    "phone": "6371541",
    "email": "effinns@gmail.com"
  },
  {
    "i": "1908",
    "county": "Limerick",
    "rollNumber": "17364J",
    "schoolName": "Scoil Baile An Aird",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "V35KX63",
    "addressOne": "Ballinard",
    "addressTwo": "Herbertstown",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.5166462",
    "lng": "-8.4688728",
    "phone": "61385340",
    "email": "herbertstownns@gmail.com"
  },
  {
    "i": "1909",
    "county": "Limerick",
    "rollNumber": "17438M",
    "schoolName": "Shanagolden NS",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "V94H642",
    "addressOne": "Shanagolden",
    "addressTwo": "Co. Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.5675787",
    "lng": "-9.0942104",
    "phone": "6960215",
    "email": "shanagoldenns.ias@gmail.com"
  },
  {
    "i": "1910",
    "county": "Limerick",
    "rollNumber": "17487C",
    "schoolName": "Scoil Nais Cathair Chinn Lis",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.58",
    "spSNA": "0",
    "totalSNA": "1.58",
    "eircode": "V94X4A8",
    "addressOne": "Caherconlish",
    "addressTwo": "Co. Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.5941427",
    "lng": "-8.4766649",
    "phone": "61351844",
    "email": "office@caherconlishns.ie"
  },
  {
    "i": "1911",
    "county": "Limerick",
    "rollNumber": "17593B",
    "schoolName": "Scoil Naomh Mhuire",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V94K036",
    "addressOne": "Caherlevoy",
    "addressTwo": "Mountcollins",
    "addressThree": "Abbeyfeale",
    "addressFour": "Co. Limerick",
    "lat": "52.3218899",
    "lng": "-9.2079353",
    "phone": "6844470",
    "email": "mountcollinsnationalschool@gmail.com"
  },
  {
    "i": "1912",
    "county": "Limerick",
    "rollNumber": "17737W",
    "schoolName": "Our Lady Queen Of Peace School",
    "SETHours": "395",
    "spClassTeachingPosts": "1",
    "mainSNA": "9.75",
    "spSNA": "1.83",
    "totalSNA": "11.58",
    "eircode": "V94T9C8",
    "addressOne": "Janesboro",
    "addressTwo": "Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6489634",
    "lng": "-8.622021",
    "phone": "61311285",
    "email": "ourladyqueenofpeace@hotmail.com"
  },
  {
    "i": "1913",
    "county": "Limerick",
    "rollNumber": "17738B",
    "schoolName": "Scoil Tobar Padraig",
    "SETHours": "82.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "V94YF44",
    "addressOne": "Patrickswell",
    "addressTwo": "Co. Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6006851",
    "lng": "-8.7138705",
    "phone": "61355057",
    "email": "pwell.ias@eircom.net"
  },
  {
    "i": "1914",
    "county": "Limerick",
    "rollNumber": "17814O",
    "schoolName": "Gearoid Ui Ghriobhtha",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "V94EK19",
    "addressOne": "Loughill",
    "addressTwo": "County Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.595459",
    "lng": "-9.188479",
    "phone": "6965450",
    "email": "geraldgriffinnsloughill@gmail.com"
  },
  {
    "i": "1915",
    "county": "Limerick",
    "rollNumber": "17871D",
    "schoolName": "Scoil Cill Churnain",
    "SETHours": "60",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.66",
    "spSNA": "0",
    "totalSNA": "4.66",
    "eircode": "V94XF95",
    "addressOne": "Kilcornan",
    "addressTwo": "Co. Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6154856",
    "lng": "-8.8835165",
    "phone": "61393304",
    "email": "secretary@kilcornanns.ie"
  },
  {
    "i": "1916",
    "county": "Limerick",
    "rollNumber": "17937H",
    "schoolName": "Scoil Moin A Lin",
    "SETHours": "290",
    "spClassTeachingPosts": "0",
    "mainSNA": "10.33",
    "spSNA": "0",
    "totalSNA": "10.33",
    "eircode": "V94T9P1",
    "addressOne": "Castletroy",
    "addressTwo": "Co. Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6583476",
    "lng": "-8.5494942",
    "phone": "61336048",
    "email": "monaleenns.ias@eircom.net"
  },
  {
    "i": "1917",
    "county": "Limerick",
    "rollNumber": "17951B",
    "schoolName": "Scoil O Curain B",
    "SETHours": "170",
    "spClassTeachingPosts": "4",
    "mainSNA": "4.67",
    "spSNA": "4.99",
    "totalSNA": "9.66",
    "eircode": "V42X343",
    "addressOne": "Gortboy",
    "addressTwo": "Newcastle West",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.4537982",
    "lng": "-9.0569657",
    "phone": "6962638",
    "email": "s.kelly@courtenayschool.ie"
  },
  {
    "i": "1918",
    "county": "Limerick",
    "rollNumber": "17981K",
    "schoolName": "SN Gleann Na Gcreabhar",
    "SETHours": "22.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "0",
    "spSNA": "2",
    "totalSNA": "2",
    "eircode": "V35TX00",
    "addressOne": "Gleann Na Gcreabhar",
    "addressTwo": "Cill Mocheallog",
    "addressThree": "Co Luimni",
    "addressFour": "",
    "lat": "52.3385551",
    "lng": "-8.2882743",
    "phone": "6246697",
    "email": "anglesboro.ias@eircom.net"
  },
  {
    "i": "1919",
    "county": "Limerick",
    "rollNumber": "18030I",
    "schoolName": "Scoil Ailbhe",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "V35T283",
    "addressOne": "Caherelly",
    "addressTwo": "Grange",
    "addressThree": "Kilmallock",
    "addressFour": "Co. Limerick",
    "lat": "52.5506783",
    "lng": "-8.5007031",
    "phone": "61351812",
    "email": "office@caherellyns.com"
  },
  {
    "i": "1920",
    "county": "Limerick",
    "rollNumber": "18142T",
    "schoolName": "Scoil Cnoc Loinge B",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "V35A627",
    "addressOne": "Knocklong",
    "addressTwo": "Co Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.4266785",
    "lng": "-8.4146911",
    "phone": "6253452",
    "email": "knocklongns@live.ie"
  },
  {
    "i": "1921",
    "county": "Limerick",
    "rollNumber": "18161A",
    "schoolName": "Castleconnell NS",
    "SETHours": "90",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "V94XA43",
    "addressOne": "Castleconnell",
    "addressTwo": "Co. Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.7140809",
    "lng": "-8.4953234",
    "phone": "61377594",
    "email": "secretary@castleconnellns.ie"
  },
  {
    "i": "1922",
    "county": "Limerick",
    "rollNumber": "18177P",
    "schoolName": "Scoil Aine Naofa",
    "SETHours": "183",
    "spClassTeachingPosts": "0",
    "mainSNA": "5",
    "spSNA": "0",
    "totalSNA": "5",
    "eircode": "V94YY15",
    "addressOne": "Rathkeale",
    "addressTwo": "Co. Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.5247616",
    "lng": "-8.939842",
    "phone": "6964779",
    "email": "info@stannesps.ie"
  },
  {
    "i": "1923",
    "county": "Limerick",
    "rollNumber": "18236F",
    "schoolName": "Scoil Naomh Mhuire NS",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V94VK23",
    "addressOne": "Beal Atha Da Thuille",
    "addressTwo": "Co Luimni",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.5578476",
    "lng": "-9.1990095",
    "phone": "6982217",
    "email": "ballyhahillns@yahoo.ie"
  },
  {
    "i": "1924",
    "county": "Limerick",
    "rollNumber": "18260C",
    "schoolName": "Scoil Mhuire",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.5",
    "spSNA": "0",
    "totalSNA": "4.5",
    "eircode": "P56VW31",
    "addressOne": "Broadford",
    "addressTwo": "Charleville",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.3459307",
    "lng": "-8.9693545",
    "phone": "6384214",
    "email": "scoilmhuire@broadford.iol.ie"
  },
  {
    "i": "1925",
    "county": "Limerick",
    "rollNumber": "18367U",
    "schoolName": "SN Toinn An Tairbh",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "V94E670",
    "addressOne": "Cappamore",
    "addressTwo": "Co Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.5940138",
    "lng": "-8.3750607",
    "phone": "61384055",
    "email": "toinnatairbh.ias@gmail.com"
  },
  {
    "i": "1926",
    "county": "Limerick",
    "rollNumber": "18426K",
    "schoolName": "Scoil Ide Naofa",
    "SETHours": "67.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "0",
    "spSNA": "3",
    "totalSNA": "3",
    "eircode": "V42P288",
    "addressOne": "Raheenagh",
    "addressTwo": "Ballagh",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.3758741",
    "lng": "-9.0432768",
    "phone": "6985276",
    "email": "raheenaghns@eircom.net"
  },
  {
    "i": "1927",
    "county": "Limerick",
    "rollNumber": "18516L",
    "schoolName": "SN Lios Na Groi",
    "SETHours": "115",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "V94K599",
    "addressOne": "Lisnagry",
    "addressTwo": "Co. Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6801853",
    "lng": "-8.5124866",
    "phone": "61331011",
    "email": "info@lisnagryns.ie"
  },
  {
    "i": "1929",
    "county": "Limerick",
    "rollNumber": "18600A",
    "schoolName": "SN Ma Rua",
    "SETHours": "77.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "V94X6T7",
    "addressOne": "Liscreagh",
    "addressTwo": "Murroe",
    "addressThree": "Limerick",
    "addressFour": "",
    "lat": "52.6497045",
    "lng": "-8.3978253",
    "phone": "61386116",
    "email": "murroestaff@gmail.com"
  },
  {
    "i": "1930",
    "county": "Limerick",
    "rollNumber": "18612H",
    "schoolName": "Scoil Mhuire",
    "SETHours": "60",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "V94PC85",
    "addressOne": "Achadh Lin",
    "addressTwo": "Ahalin",
    "addressThree": "Ballingarry",
    "addressFour": "Co. Limerick",
    "lat": "52.4649209",
    "lng": "-8.9387851",
    "phone": "6983122",
    "email": "ahalinns@gmail.com"
  },
  {
    "i": "1931",
    "county": "Limerick",
    "rollNumber": "18653V",
    "schoolName": "Scoil Naomh Iosef",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "V94EH60",
    "addressOne": "Thomas Street",
    "addressTwo": "Rathkeale",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.5254922",
    "lng": "-8.9392239",
    "phone": "876054162",
    "email": "rathkealebns@gmail.com"
  },
  {
    "i": "1932",
    "county": "Limerick",
    "rollNumber": "18677M",
    "schoolName": "Scoil Mathair De",
    "SETHours": "192.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "3.34",
    "spSNA": "0.66",
    "totalSNA": "4",
    "eircode": "V94VR64",
    "addressOne": "South Circular Road",
    "addressTwo": "Limerick City",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6524137",
    "lng": "-8.6384264",
    "phone": "61317630",
    "email": "principal@scoilmhathairde.ie"
  },
  {
    "i": "1933",
    "county": "Limerick",
    "rollNumber": "18708U",
    "schoolName": "SN Cill Lachtain",
    "SETHours": "92.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "2.5",
    "spSNA": "2",
    "totalSNA": "4.5",
    "eircode": "V42XE17",
    "addressOne": "Newcastle West",
    "addressTwo": "Co. Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.4428525",
    "lng": "-9.1136363",
    "phone": "6961195",
    "email": "killoughteennationalschool@eircom.net"
  },
  {
    "i": "1934",
    "county": "Limerick",
    "rollNumber": "18717V",
    "schoolName": "SN Ciarain",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "V94A8P6",
    "addressOne": "Kilfinny",
    "addressTwo": "Adare",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.5134269",
    "lng": "-8.8052512",
    "phone": "61396518",
    "email": "kilfinnyns.ias@eircom.net"
  },
  {
    "i": "1935",
    "county": "Limerick",
    "rollNumber": "18872K",
    "schoolName": "Scoil Ide",
    "SETHours": "307.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "8",
    "spSNA": "0",
    "totalSNA": "8",
    "eircode": "V94X659",
    "addressOne": "Corbally Road",
    "addressTwo": "Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6780183",
    "lng": "-8.6146672",
    "phone": "61345495",
    "email": "principal@scoilide.ie"
  },
  {
    "i": "1936",
    "county": "Limerick",
    "rollNumber": "18991S",
    "schoolName": "J F K Memorial School",
    "SETHours": "137.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "V94P9E8",
    "addressOne": "Ennis Road",
    "addressTwo": "Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6666564",
    "lng": "-8.6446194",
    "phone": "61452090",
    "email": "info@jfkmemorialschool.com"
  },
  {
    "i": "1937",
    "county": "Limerick",
    "rollNumber": "19272O",
    "schoolName": "Sn Naomh Iosef",
    "SETHours": "97.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "V94C586",
    "addressOne": "Ballybrown",
    "addressTwo": "Clarina",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.643153",
    "lng": "-8.7309925",
    "phone": "61353276",
    "email": "principal@ballybrownns.ie"
  },
  {
    "i": "1938",
    "county": "Limerick",
    "rollNumber": "19323F",
    "schoolName": "SN Beal Atha Grean",
    "SETHours": "65",
    "spClassTeachingPosts": "2",
    "mainSNA": "1.5",
    "spSNA": "5",
    "totalSNA": "6.5",
    "eircode": "V35W220",
    "addressOne": "Ballyagran",
    "addressTwo": "Kilmallock",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.4049248",
    "lng": "-8.7842189",
    "phone": "6382015",
    "email": "info@ballyagrannationalschool.com"
  },
  {
    "i": "1939",
    "county": "Limerick",
    "rollNumber": "19331E",
    "schoolName": "Scoil Chriost Ri B",
    "SETHours": "255",
    "spClassTeachingPosts": "2",
    "mainSNA": "3.75",
    "spSNA": "5",
    "totalSNA": "8.75",
    "eircode": "V94N229",
    "addressOne": "Caherdavin",
    "addressTwo": "Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6744888",
    "lng": "-8.6572891",
    "phone": "61453484",
    "email": "info@scoilchriostribns.com"
  },
  {
    "i": "1940",
    "county": "Limerick",
    "rollNumber": "19332G",
    "schoolName": "SN Muire Na Heireann",
    "SETHours": "140",
    "spClassTeachingPosts": "0",
    "mainSNA": "5",
    "spSNA": "0",
    "totalSNA": "5",
    "eircode": "V94A5N7",
    "addressOne": "Caherdavin",
    "addressTwo": "Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.674533",
    "lng": "-8.6589171",
    "phone": "61454149",
    "email": "info@mqoi.ie"
  },
  {
    "i": "1941",
    "county": "Limerick",
    "rollNumber": "19336O",
    "schoolName": "Scoil Phoil Naofa",
    "SETHours": "260",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.83",
    "spSNA": "0",
    "totalSNA": "4.83",
    "eircode": "",
    "addressOne": "Dooradoyle",
    "addressTwo": "Co. Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6342845",
    "lng": "-8.6650347",
    "phone": "61306645",
    "email": "jtuohy5@gmail.com"
  },
  {
    "i": "1942",
    "county": "Limerick",
    "rollNumber": "19475F",
    "schoolName": "St Brigids Ns",
    "SETHours": "283",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.5",
    "spSNA": "0",
    "totalSNA": "5.5",
    "eircode": "V94FN12",
    "addressOne": "Singland",
    "addressTwo": "Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6563977",
    "lng": "-8.5983999",
    "phone": "61414319",
    "email": "stbrigidslimerick@gmail.com"
  },
  {
    "i": "1943",
    "county": "Limerick",
    "rollNumber": "19667O",
    "schoolName": "Our Lady Of Lourdes NS",
    "SETHours": "207.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.75",
    "spSNA": "0",
    "totalSNA": "2.75",
    "eircode": "V94Y6N9",
    "addressOne": "Rosbrien",
    "addressTwo": "Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6472145",
    "lng": "-8.6310604",
    "phone": "61227991",
    "email": "ourladyoflourdesrb@gmail.com"
  },
  {
    "i": "1944",
    "county": "Limerick",
    "rollNumber": "19800N",
    "schoolName": "Milford Grange N School",
    "SETHours": "195",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.83",
    "spSNA": "0",
    "totalSNA": "5.83",
    "eircode": "V94W3W4",
    "addressOne": "Plassey Park Road",
    "addressTwo": "Castletroy",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.6724656",
    "lng": "-8.5669305",
    "phone": "61339123",
    "email": "office@milfordns.ie"
  },
  {
    "i": "1945",
    "county": "Limerick",
    "rollNumber": "19830W",
    "schoolName": "Corpus Christi NS",
    "SETHours": "450",
    "spClassTeachingPosts": "3",
    "mainSNA": "2.74",
    "spSNA": "4.25",
    "totalSNA": "6.99",
    "eircode": "V94Y4CY",
    "addressOne": "Moyross",
    "addressTwo": "Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6815234",
    "lng": "-8.6447556",
    "phone": "61455166",
    "email": "oneilltiernan@gmail.com"
  },
  {
    "i": "1946",
    "county": "Limerick",
    "rollNumber": "19883U",
    "schoolName": "Gaelscoil O Doghair",
    "SETHours": "75",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.75",
    "spSNA": "0",
    "totalSNA": "1.75",
    "eircode": "V42PD71",
    "addressOne": "Bóthar An Stáisiúin",
    "addressTwo": "An Caisleán Nua",
    "addressThree": "Co. Luimnigh",
    "addressFour": "",
    "lat": "52.4573904",
    "lng": "-9.0595239",
    "phone": "6961087",
    "email": "muinteoircaitlin@gmail.com"
  },
  {
    "i": "1947",
    "county": "Limerick",
    "rollNumber": "19894C",
    "schoolName": "An Mhodh Scoil",
    "SETHours": "207.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.75",
    "spSNA": "0",
    "totalSNA": "3.75",
    "eircode": "V94W891",
    "addressOne": "Ascaill Í­ Chonaill",
    "addressTwo": "Luimneach",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6551822",
    "lng": "-8.63383",
    "phone": "61315827",
    "email": "info@modelschool.ie"
  },
  {
    "i": "1948",
    "county": "Limerick",
    "rollNumber": "19931F",
    "schoolName": "Gaelscoil Sheoirse",
    "SETHours": "97.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V94VYH1",
    "addressOne": "Bóthar Bhaile An Róistigh",
    "addressTwo": "Luimneach",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6507165",
    "lng": "-8.6138464",
    "phone": "61603293",
    "email": "gaelscoilsheoirseclancy@gmail.com"
  },
  {
    "i": "1949",
    "county": "Limerick",
    "rollNumber": "19934L",
    "schoolName": "Limerick School Project",
    "SETHours": "95",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.75",
    "spSNA": "0",
    "totalSNA": "3.75",
    "eircode": "V94WDV2",
    "addressOne": "O'connell Avenue",
    "addressTwo": "Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6572332",
    "lng": "-8.6336939",
    "phone": "61412994",
    "email": "louiselspns@eircom.net"
  },
  {
    "i": "1950",
    "county": "Limerick",
    "rollNumber": "19952N",
    "schoolName": "Hospital Ns",
    "SETHours": "122.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.08",
    "spSNA": "0",
    "totalSNA": "3.08",
    "eircode": "V35PX34",
    "addressOne": "Castlefarm",
    "addressTwo": "Hospital",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.4797345",
    "lng": "-8.4329005",
    "phone": "61383197",
    "email": "hospitalns@eircom.net"
  },
  {
    "i": "1951",
    "county": "Limerick",
    "rollNumber": "19956V",
    "schoolName": "Gaelscoil Sairseal",
    "SETHours": "122.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "V94YX97",
    "addressOne": "Bóthar Shí­ol Bhroin",
    "addressTwo": "Luimneach",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6675528",
    "lng": "-8.6230483",
    "phone": "61322502",
    "email": "oifig@gaelscoilsairseal.com"
  },
  {
    "i": "1952",
    "county": "Limerick",
    "rollNumber": "19966B",
    "schoolName": "St Josephs",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.25",
    "spSNA": "0",
    "totalSNA": "1.25",
    "eircode": "P56P409",
    "addressOne": "Drumcollogher",
    "addressTwo": "Charleville",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.3378213",
    "lng": "-8.9018216",
    "phone": "6383229",
    "email": "dromcollogherprimary@gmail.com"
  },
  {
    "i": "1953",
    "county": "Limerick",
    "rollNumber": "20018H",
    "schoolName": "Presentation Primary School",
    "SETHours": "225",
    "spClassTeachingPosts": "0",
    "mainSNA": "5",
    "spSNA": "0",
    "totalSNA": "5",
    "eircode": "V94P028",
    "addressOne": "Sexton Street",
    "addressTwo": "Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6592955",
    "lng": "-8.6223124",
    "phone": "61412494",
    "email": "info@preslimerick.ie"
  },
  {
    "i": "1954",
    "county": "Limerick",
    "rollNumber": "20094A",
    "schoolName": "Scoil Chriost An Slanaitheoir",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.25",
    "spSNA": "0",
    "totalSNA": "1.25",
    "eircode": "V94W1X4",
    "addressOne": "Ballingarry",
    "addressTwo": "Co. Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.4718698",
    "lng": "-8.8612612",
    "phone": "6968402",
    "email": "ballingarryns@yahoo.ie"
  },
  {
    "i": "1955",
    "county": "Limerick",
    "rollNumber": "20102T",
    "schoolName": "St Fergus Primary School",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.75",
    "spSNA": "0",
    "totalSNA": "1.75",
    "eircode": "V94PT68",
    "addressOne": "South Mall",
    "addressTwo": "Glin",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.5672238",
    "lng": "-9.2826423",
    "phone": "6834344",
    "email": "office@stfergusns.ie"
  },
  {
    "i": "1956",
    "county": "Limerick",
    "rollNumber": "20133H",
    "schoolName": "Scoil Dean Cussen",
    "SETHours": "120",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "V35FT99",
    "addressOne": "Kilmallock Road",
    "addressTwo": "Bruff",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.4736462",
    "lng": "-8.5508025",
    "phone": "61382568",
    "email": "scoildeancussen@gmail.com"
  },
  {
    "i": "1957",
    "county": "Limerick",
    "rollNumber": "20148U",
    "schoolName": "Gaelscoil Chaladh An Treoigh",
    "SETHours": "125",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "V947N32",
    "addressOne": "Caisleán Nua",
    "addressTwo": "Bóthar Bhaile átha Cliath",
    "addressThree": "Caladh An Treoigh",
    "addressFour": "Co. Luimnigh",
    "lat": "52.6668662",
    "lng": "-8.5462518",
    "phone": "61502214",
    "email": "oifig@gaelcat.com"
  },
  {
    "i": "1958",
    "county": "Limerick",
    "rollNumber": "20175A",
    "schoolName": "Limerick City East Educate Together",
    "SETHours": "167.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "3.75",
    "spSNA": "5.66",
    "totalSNA": "9.41",
    "eircode": "V94ND77",
    "addressOne": "Dromdarrig",
    "addressTwo": "Mungret",
    "addressThree": "County Limerick",
    "addressFour": "",
    "lat": "52.6309913",
    "lng": "-8.6810998",
    "phone": "61300889",
    "email": "letsnationalschool@gmail.com"
  },
  {
    "i": "1959",
    "county": "Limerick",
    "rollNumber": "20181S",
    "schoolName": "Gaelscoil An Raithin",
    "SETHours": "128",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "V941X59",
    "addressOne": "An Drom Dearg",
    "addressTwo": "Mungairit",
    "addressThree": "Luimneach",
    "addressFour": "",
    "lat": "52.6348752",
    "lng": "-8.6838942",
    "phone": "6130882",
    "email": "gaelscoilanraithin@gmail.com"
  },
  {
    "i": "1960",
    "county": "Limerick",
    "rollNumber": "20193C",
    "schoolName": "Scoil Mocheallóg",
    "SETHours": "205",
    "spClassTeachingPosts": "3",
    "mainSNA": "3.68",
    "spSNA": "5.32",
    "totalSNA": "9",
    "eircode": "V35H324",
    "addressOne": "Glenfield Road",
    "addressTwo": "Kilmallock",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.402193",
    "lng": "-8.5799369",
    "phone": "6398319",
    "email": "info@kns.ie"
  },
  {
    "i": "1961",
    "county": "Limerick",
    "rollNumber": "20233L",
    "schoolName": "Scoil Chaitrí­ona",
    "SETHours": "55",
    "spClassTeachingPosts": "1",
    "mainSNA": "2",
    "spSNA": "2",
    "totalSNA": "4",
    "eircode": "V94HH98",
    "addressOne": "Main Street",
    "addressTwo": "Cappamore",
    "addressThree": "Co. Limerick",
    "addressFour": "",
    "lat": "52.6133617",
    "lng": "-8.3409486",
    "phone": "61381774",
    "email": "secretarysch1@gmail.com"
  },
  {
    "i": "1962",
    "county": "Limerick",
    "rollNumber": "20405O",
    "schoolName": "St Mary's NS",
    "SETHours": "97.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.25",
    "spSNA": "0",
    "totalSNA": "4.25",
    "eircode": "V94P0A9",
    "addressOne": "Bishop St,",
    "addressTwo": "Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6698555",
    "lng": "-8.6211322",
    "phone": "61419264",
    "email": "muirec.ias@eircom.net"
  },
  {
    "i": "1963",
    "county": "Limerick",
    "rollNumber": "20459O",
    "schoolName": "Le Chéile NS",
    "SETHours": "207.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "2.25",
    "spSNA": "5.25",
    "totalSNA": "7.5",
    "eircode": "V94X2TR",
    "addressOne": "Roxboro Road",
    "addressTwo": "Limerick",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6499052",
    "lng": "-8.6139812",
    "phone": "61310744",
    "email": "lecheilens@gmail.com"
  },
  {
    "i": "1964",
    "county": "Limerick",
    "rollNumber": "20460W",
    "schoolName": "Thomond Primary School",
    "SETHours": "247.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.83",
    "spSNA": "0",
    "totalSNA": "5.83",
    "eircode": "V94C2R7",
    "addressOne": "Moylish Road",
    "addressTwo": "Ballynanty",
    "addressThree": "Limerick",
    "addressFour": "",
    "lat": "52.6775396",
    "lng": "-8.6418938",
    "phone": "61452755",
    "email": "thomondps@gmail.com"
  },
  {
    "i": "1965",
    "county": "Limerick",
    "rollNumber": "20496U",
    "schoolName": "Salesian Primary School",
    "SETHours": "205",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.41",
    "spSNA": "0",
    "totalSNA": "3.41",
    "eircode": "V94RR99",
    "addressOne": "Fernbank",
    "addressTwo": "North Circular Road",
    "addressThree": "Limerick",
    "addressFour": "",
    "lat": "52.6649712",
    "lng": "-8.639503",
    "phone": "61455442",
    "email": "admin@salesianprimary.ie"
  },
  {
    "i": "1966",
    "county": "Longford",
    "rollNumber": "00856M",
    "schoolName": "Scoil Naomh Micheal",
    "SETHours": "135",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "N39AX75",
    "addressOne": "St. Mel's Road",
    "addressTwo": "Longford",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.7294959",
    "lng": "-7.7952221",
    "phone": "433345536",
    "email": "stmichaelsbns@gmail.com"
  },
  {
    "i": "1967",
    "county": "Longford",
    "rollNumber": "00860D",
    "schoolName": "Forgney NS",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "N39TW52",
    "addressOne": "Cloncallow",
    "addressTwo": "Ballymahon",
    "addressThree": "Co. Longford",
    "addressFour": "",
    "lat": "53.5574165",
    "lng": "-7.7221738",
    "phone": "906452659",
    "email": "forgneyschool@gmail.com"
  },
  {
    "i": "1968",
    "county": "Longford",
    "rollNumber": "05115S",
    "schoolName": "SN An Leana Mor",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "N39NN60",
    "addressOne": "Lenamore",
    "addressTwo": "Co. Longford",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.6223089",
    "lng": "-7.6330744",
    "phone": "449357867",
    "email": "lenamore.ns@hotmail.com"
  },
  {
    "i": "1969",
    "county": "Longford",
    "rollNumber": "07518E",
    "schoolName": "SN Cnoc An Mharcaigh",
    "SETHours": "115",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "N39XW13",
    "addressOne": "Melview",
    "addressTwo": "Longford",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.7620238",
    "lng": "-7.7847989",
    "phone": "433346197",
    "email": "melviewschool@gmail.com"
  },
  {
    "i": "1970",
    "county": "Longford",
    "rollNumber": "10223C",
    "schoolName": "Tashinny NS",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "N39W8C5",
    "addressOne": "Tashinny",
    "addressTwo": "Ballymahon",
    "addressThree": "Co. Longford",
    "addressFour": "",
    "lat": "53.5920407",
    "lng": "-7.6967067",
    "phone": "449357610",
    "email": "tashinnyschool@gmail.com"
  },
  {
    "i": "1971",
    "county": "Longford",
    "rollNumber": "12136R",
    "schoolName": "Scoil Bhrí­de",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "N39TD42",
    "addressOne": "Glen",
    "addressTwo": "Edgeworthstown",
    "addressThree": "Co. Longford",
    "addressFour": "",
    "lat": "53.6691226",
    "lng": "-7.6191711",
    "phone": "436671778",
    "email": "sbgleann@gmail.com"
  },
  {
    "i": "1972",
    "county": "Longford",
    "rollNumber": "12683A",
    "schoolName": "St. Johns NS",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "N39VK22",
    "addressOne": "Battery Road",
    "addressTwo": "Longford",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.7326325",
    "lng": "-7.8003167",
    "phone": "433341316",
    "email": "longfordschool@hotmail.com"
  },
  {
    "i": "1973",
    "county": "Longford",
    "rollNumber": "12736S",
    "schoolName": "Naomh Guasachta NS",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "N39KN92",
    "addressOne": "Bunlahy",
    "addressTwo": "Ballinalee",
    "addressThree": "Co. Longford",
    "addressFour": "",
    "lat": "53.7927663",
    "lng": "-7.584618",
    "phone": "433323600",
    "email": "stguasachtsns@gmail.com"
  },
  {
    "i": "1974",
    "county": "Longford",
    "rollNumber": "12813K",
    "schoolName": "St Columbas Mxd NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "N39XD90",
    "addressOne": "Cloonagh",
    "addressTwo": "Dring",
    "addressThree": "Co. Longford",
    "addressFour": "",
    "lat": "53.8397097",
    "lng": "-7.5197168",
    "phone": "436683020",
    "email": "cloonaghns1@eircom.net"
  },
  {
    "i": "1975",
    "county": "Longford",
    "rollNumber": "13313S",
    "schoolName": "St. John's NS,",
    "SETHours": "7.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "N39F211",
    "addressOne": "Ballinalee Road",
    "addressTwo": "Edgeworthstown",
    "addressThree": "Co. Longford",
    "addressFour": "",
    "lat": "53.6975598",
    "lng": "-7.6082152",
    "phone": "436671620",
    "email": "stjohnsnsedge@gmail.com"
  },
  {
    "i": "1976",
    "county": "Longford",
    "rollNumber": "13320P",
    "schoolName": "Fermoyle Mixed NS",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "N39E899",
    "addressOne": "Fermoyle",
    "addressTwo": "Lanesboro",
    "addressThree": "Co. Longford",
    "addressFour": "",
    "lat": "53.6246596",
    "lng": "-7.9933585",
    "phone": "433321959",
    "email": "fermoylens@gmail.com"
  },
  {
    "i": "1977",
    "county": "Longford",
    "rollNumber": "13752V",
    "schoolName": "Naomh Padraig NS",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "N39K304",
    "addressOne": "Muckerstaff",
    "addressTwo": "Coolarty",
    "addressThree": "Co. Longford",
    "addressFour": "",
    "lat": "53.7596133",
    "lng": "-7.5565186",
    "phone": "436686652",
    "email": "killeen.ns@gmail.com"
  },
  {
    "i": "1978",
    "county": "Longford",
    "rollNumber": "14300O",
    "schoolName": "Killasonna Mixed NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "N39NA43",
    "addressOne": "Killasonna",
    "addressTwo": "Granard",
    "addressThree": "Co. Longford",
    "addressFour": "",
    "lat": "53.7467536",
    "lng": "-7.4770829",
    "phone": "436685280",
    "email": "killasonnans@gmail.com"
  },
  {
    "i": "1979",
    "county": "Longford",
    "rollNumber": "14386E",
    "schoolName": "Stonepark NS",
    "SETHours": "125",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "N39T925",
    "addressOne": "Stonepark",
    "addressTwo": "Co. Longford",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.6945106",
    "lng": "-7.8203748",
    "phone": "433346036",
    "email": "info@stoneparkns.ie"
  },
  {
    "i": "1980",
    "county": "Longford",
    "rollNumber": "14650S",
    "schoolName": "Cloontagh Mixed NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "N39RF60",
    "addressOne": "Cloontagh",
    "addressTwo": "Killashee",
    "addressThree": "Co. Longford",
    "addressFour": "",
    "lat": "53.6368436",
    "lng": "-7.8942711",
    "phone": "433325450",
    "email": "principal@cloontaghns.ie"
  },
  {
    "i": "1981",
    "county": "Longford",
    "rollNumber": "14672F",
    "schoolName": "Colehill Mixed NS",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "N39HK27",
    "addressOne": "Colehill",
    "addressTwo": "Co. Longford",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.5974927",
    "lng": "-7.6785023",
    "phone": "449357466",
    "email": "scoilsinneach@gmail.com"
  },
  {
    "i": "1982",
    "county": "Longford",
    "rollNumber": "15122V",
    "schoolName": "St Bernards Mixed NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "N39K773",
    "addressOne": "Abbeylara",
    "addressTwo": "Co. Longford",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.765869",
    "lng": "-7.4482429",
    "phone": "436686806",
    "email": "stbernardsns@gmail.com"
  },
  {
    "i": "1983",
    "county": "Longford",
    "rollNumber": "15154L",
    "schoolName": "Naomh Dominic NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "N39NC80",
    "addressOne": "Kenagh",
    "addressTwo": "Co. Longford",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.6249195",
    "lng": "-7.8187255",
    "phone": "433322456",
    "email": "naomhdominicns@gmail.com"
  },
  {
    "i": "1984",
    "county": "Longford",
    "rollNumber": "16665S",
    "schoolName": "St Marys Mixed NS",
    "SETHours": "97.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "N39AF54",
    "addressOne": "Hill Street",
    "addressTwo": "Drumlish",
    "addressThree": "Co. Longford",
    "addressFour": "",
    "lat": "53.8181539",
    "lng": "-7.7672886",
    "phone": "433324065",
    "email": "drumprincipal@gmail.com"
  },
  {
    "i": "1985",
    "county": "Longford",
    "rollNumber": "17561L",
    "schoolName": "Samhthann NS",
    "SETHours": "62.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "N39HY57",
    "addressOne": "Ballinalee",
    "addressTwo": "Co. Longford",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.775535",
    "lng": "-7.6478611",
    "phone": "433323333",
    "email": "scoilsamhthannballinalee@gmail.com"
  },
  {
    "i": "1986",
    "county": "Longford",
    "rollNumber": "17644P",
    "schoolName": "Scoil Mhuire",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "N39KX77",
    "addressOne": "Aughnagarron",
    "addressTwo": "Granard",
    "addressThree": "Co Longford",
    "addressFour": "",
    "lat": "53.79854",
    "lng": "-7.4711376",
    "phone": "436686805",
    "email": "aughnagarron@gmail.com"
  },
  {
    "i": "1987",
    "county": "Longford",
    "rollNumber": "18178R",
    "schoolName": "St Josephs Convent",
    "SETHours": "267.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "2.83",
    "spSNA": "3.83",
    "totalSNA": "6.66",
    "eircode": "N39DY23",
    "addressOne": "Dublin Road",
    "addressTwo": "Longford Town",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.7259178",
    "lng": "-7.7943857",
    "phone": "433345700",
    "email": "stjosephsnslongford@gmail.com"
  },
  {
    "i": "1988",
    "county": "Longford",
    "rollNumber": "18258P",
    "schoolName": "Naomh Earnain NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "N39CK85",
    "addressOne": "Killashee",
    "addressTwo": "Longford",
    "addressThree": "Co Longford",
    "addressFour": "",
    "lat": "53.6793484",
    "lng": "-7.8790214",
    "phone": "433348676",
    "email": "killasheens@gmail.com"
  },
  {
    "i": "1989",
    "county": "Longford",
    "rollNumber": "18259R",
    "schoolName": "Lanesborough Primary School",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "N39EH04",
    "addressOne": "Lanesborough",
    "addressTwo": "Co. Longford",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.6737049",
    "lng": "-7.9876718",
    "phone": "433321545",
    "email": "smgslb2020@gmail.com"
  },
  {
    "i": "1990",
    "county": "Longford",
    "rollNumber": "18733T",
    "schoolName": "SN Mhuire",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "N39KD36",
    "addressOne": "Cloondara",
    "addressTwo": "Co. Longford",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.7302552",
    "lng": "-7.9054512",
    "phone": "436626417",
    "email": "clondrans.ias@eircom.net"
  },
  {
    "i": "1991",
    "county": "Longford",
    "rollNumber": "19171I",
    "schoolName": "SN Naomh Mhuire",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "N39PC82",
    "addressOne": "Baile Nua An Chaisil",
    "addressTwo": "Co Longphort",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.583111",
    "lng": "-7.9402745",
    "phone": "433325433",
    "email": "newtownc1@gmail.com"
  },
  {
    "i": "1992",
    "county": "Longford",
    "rollNumber": "19279F",
    "schoolName": "SN Naomh Treasa",
    "SETHours": "132.5",
    "spClassTeachingPosts": "4",
    "mainSNA": "4.83",
    "spSNA": "9.49",
    "totalSNA": "14.32",
    "eircode": "N39EW95",
    "addressOne": "Clontumpher",
    "addressTwo": "Ballinalee",
    "addressThree": "Co. Longford",
    "addressFour": "",
    "lat": "53.7792062",
    "lng": "-7.7111091",
    "phone": "433323352",
    "email": "snnaomhtreasa.ias@eircom.net"
  },
  {
    "i": "1993",
    "county": "Longford",
    "rollNumber": "19296F",
    "schoolName": "SN Naomh Colmcille",
    "SETHours": "43",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "N39CD60",
    "addressOne": "Aughnacliffe",
    "addressTwo": "Co Longford",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.8455587",
    "lng": "-7.6059338",
    "phone": "436684408",
    "email": "aughnacliffens@eircom.net"
  },
  {
    "i": "1994",
    "county": "Longford",
    "rollNumber": "19353O",
    "schoolName": "St Patricks NS Longford",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "N39X827",
    "addressOne": "Dromard",
    "addressTwo": "Moyne",
    "addressThree": "Co. Longford",
    "addressFour": "",
    "lat": "53.9062635",
    "lng": "-7.6481197",
    "phone": "494335781",
    "email": "dromardps@hotmail.com"
  },
  {
    "i": "1995",
    "county": "Longford",
    "rollNumber": "19467G",
    "schoolName": "Saint Mels",
    "SETHours": "97.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "5",
    "spSNA": "0",
    "totalSNA": "5",
    "eircode": "N39CD85",
    "addressOne": "Ardagh Village",
    "addressTwo": "Co. Longford",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.6672846",
    "lng": "-7.6906626",
    "phone": "436675269",
    "email": "stmelsns@gmail.com"
  },
  {
    "i": "1996",
    "county": "Longford",
    "rollNumber": "19753H",
    "schoolName": "St Emer's NS",
    "SETHours": "115",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "N39ND29",
    "addressOne": "St Emers",
    "addressTwo": "Templemichael",
    "addressThree": "Co Longford",
    "addressFour": "",
    "lat": "53.7311242",
    "lng": "-7.7802101",
    "phone": "433341188",
    "email": "scoileimear1987@gmail.com"
  },
  {
    "i": "1997",
    "county": "Longford",
    "rollNumber": "19975C",
    "schoolName": "St Patricks",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "N39P276",
    "addressOne": "Ballinamuck",
    "addressTwo": "Co Longford",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.855388",
    "lng": "-7.7091917",
    "phone": "433324063",
    "email": "ballinamuckns@eircom.net"
  },
  {
    "i": "1998",
    "county": "Longford",
    "rollNumber": "19987J",
    "schoolName": "Scoil Mhuire NS",
    "SETHours": "130",
    "spClassTeachingPosts": "0",
    "mainSNA": "6.66",
    "spSNA": "0",
    "totalSNA": "6.66",
    "eircode": "N39K263",
    "addressOne": "Newtownforbes",
    "addressTwo": "Co. Longford",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.7624974",
    "lng": "-7.8333294",
    "phone": "433345220",
    "email": "scoilmhuirenewtown@gmail.com"
  },
  {
    "i": "1999",
    "county": "Longford",
    "rollNumber": "20083S",
    "schoolName": "Gaelscoil An Longfoirt",
    "SETHours": "105",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "N39TW62",
    "addressOne": "Fearann Í­ Dhugáin",
    "addressTwo": "An Longfort",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.7154238",
    "lng": "-7.8006359",
    "phone": "433341360",
    "email": "gaelscoillongfoirt1998@gmail.com"
  },
  {
    "i": "2000",
    "county": "Longford",
    "rollNumber": "20101R",
    "schoolName": "The Sacred Heart Primary NS",
    "SETHours": "117.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.66",
    "spSNA": "0",
    "totalSNA": "3.66",
    "eircode": "N39RY67",
    "addressOne": "Granard",
    "addressTwo": "Co. Longford",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.7801683",
    "lng": "-7.490911",
    "phone": "436686894",
    "email": "sacredheartpsgranard@gmail.com"
  },
  {
    "i": "2001",
    "county": "Longford",
    "rollNumber": "20124G",
    "schoolName": "St Marys NS",
    "SETHours": "170",
    "spClassTeachingPosts": "6",
    "mainSNA": "1",
    "spSNA": "12.49",
    "totalSNA": "13.49",
    "eircode": "N39PX32",
    "addressOne": "Edgeworthstown",
    "addressTwo": "Co. Longford",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.698259",
    "lng": "-7.6025475",
    "phone": "436671750",
    "email": "stmarysetown@eircom.net"
  },
  {
    "i": "2002",
    "county": "Longford",
    "rollNumber": "20128O",
    "schoolName": "St Matthews Mixed N.s",
    "SETHours": "215",
    "spClassTeachingPosts": "2",
    "mainSNA": "4.83",
    "spSNA": "4.16",
    "totalSNA": "8.99",
    "eircode": "N39KA06",
    "addressOne": "Drinan",
    "addressTwo": "Ballymahon",
    "addressThree": "Co. Longford",
    "addressFour": "",
    "lat": "53.566811",
    "lng": "-7.7682514",
    "phone": "906432578",
    "email": "stmatthewsns@gmail.com"
  },
  {
    "i": "2003",
    "county": "Louth",
    "rollNumber": "00851C",
    "schoolName": "Presentation Convent",
    "SETHours": "150",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "A92E296",
    "addressOne": "Ballymakenny Road",
    "addressTwo": "Drogheda",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "53.7298697",
    "lng": "-6.3436042",
    "phone": "419837119",
    "email": "presentationprimary@yahoo.com"
  },
  {
    "i": "2004",
    "county": "Louth",
    "rollNumber": "01434O",
    "schoolName": "SN Columcille",
    "SETHours": "77.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "1",
    "spSNA": "4.98",
    "totalSNA": "5.98",
    "eircode": "A92TW50",
    "addressOne": "Tullydonnell",
    "addressTwo": "Togher",
    "addressThree": "Drogheda",
    "addressFour": "Co. Louth",
    "lat": "53.8374868",
    "lng": "-6.336249",
    "phone": "416852301",
    "email": "st.colmcilles1@gmail.com"
  },
  {
    "i": "2005",
    "county": "Louth",
    "rollNumber": "01553W",
    "schoolName": "St. Mochta's NS",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "A91AE79",
    "addressOne": "Louth Village",
    "addressTwo": "Co. Louth",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.9501057",
    "lng": "-6.5441319",
    "phone": "429374840",
    "email": "louthschool@gmail.com"
  },
  {
    "i": "2006",
    "county": "Louth",
    "rollNumber": "01554B",
    "schoolName": "Baile An Phusta NS",
    "SETHours": "62.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "A92XD53",
    "addressOne": "Ballapousta",
    "addressTwo": "Ardee",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "53.8218251",
    "lng": "-6.5575326",
    "phone": "416853966",
    "email": "secretary.ballapousta.ns@gmail.com"
  },
  {
    "i": "2007",
    "county": "Louth",
    "rollNumber": "02322I",
    "schoolName": "St Olivers Ns",
    "SETHours": "72.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "A91NW92",
    "addressOne": "Dundalk Street",
    "addressTwo": "Carlingford",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "54.0374986",
    "lng": "-6.1833868",
    "phone": "429373405",
    "email": "info@stoliversns.ie"
  },
  {
    "i": "2008",
    "county": "Louth",
    "rollNumber": "02745N",
    "schoolName": "Tallonstown NS",
    "SETHours": "112.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "A91YX04",
    "addressOne": "Tallanstown",
    "addressTwo": "Dundalk",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "53.9194486",
    "lng": "-6.5497084",
    "phone": "429374419",
    "email": "tallanstownns@gmail.com"
  },
  {
    "i": "2009",
    "county": "Louth",
    "rollNumber": "02793B",
    "schoolName": "SN Mullach Bui",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "A91H319",
    "addressOne": "Castletowncooley",
    "addressTwo": "Riverstown",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "54.0199231",
    "lng": "-6.2201623",
    "phone": "429376202",
    "email": "mullaghbuoyns@gmail.com"
  },
  {
    "i": "2010",
    "county": "Louth",
    "rollNumber": "03787L",
    "schoolName": "Walshestown NS",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "A92CD53",
    "addressOne": "Walshestown",
    "addressTwo": "Clogherhead",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "53.8070813",
    "lng": "-6.3002017",
    "phone": "416852285",
    "email": "walshestownschool@gmail.com"
  },
  {
    "i": "2011",
    "county": "Louth",
    "rollNumber": "06576N",
    "schoolName": "Dromin NS",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "A92VP44",
    "addressOne": "Dromin",
    "addressTwo": "Dunleer",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "53.8443329",
    "lng": "-6.4446372",
    "phone": "416851564",
    "email": "secretary@drominns.ie"
  },
  {
    "i": "2012",
    "county": "Louth",
    "rollNumber": "11072M",
    "schoolName": "SN Naomh Peadar",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "A92H425",
    "addressOne": "Bolton Street",
    "addressTwo": "Drogheda",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "53.7171622",
    "lng": "-6.3553493",
    "phone": "419839573",
    "email": "stpetersnsdrogheda@gmail.com"
  },
  {
    "i": "2013",
    "county": "Louth",
    "rollNumber": "13670T",
    "schoolName": "Dulargy Mixed NS",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "A91P297",
    "addressOne": "Dulargy",
    "addressTwo": "Ravensdale",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "54.0427127",
    "lng": "-6.3312106",
    "phone": "429371536",
    "email": "dulargyns@gmail.com"
  },
  {
    "i": "2014",
    "county": "Louth",
    "rollNumber": "14069P",
    "schoolName": "Dun Dealgan NS",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "A91PH27",
    "addressOne": "Jocelyn Street",
    "addressTwo": "Dundalk",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "54.004136",
    "lng": "-6.3952877",
    "phone": "429335902",
    "email": "dundealganns@gmail.com"
  },
  {
    "i": "2015",
    "county": "Louth",
    "rollNumber": "14207B",
    "schoolName": "Sn Chill Sarain",
    "SETHours": "80",
    "spClassTeachingPosts": "4",
    "mainSNA": "2.5",
    "spSNA": "8.66",
    "totalSNA": "11.16",
    "eircode": "A91RY82",
    "addressOne": "Kilsaran",
    "addressTwo": "Castlebellingham",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "53.8866939",
    "lng": "-6.3899841",
    "phone": "429372333",
    "email": "office@kilsaranschool.com"
  },
  {
    "i": "2016",
    "county": "Louth",
    "rollNumber": "14252G",
    "schoolName": "Callystown Mixed NS",
    "SETHours": "102.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.83",
    "spSNA": "0",
    "totalSNA": "4.83",
    "eircode": "A92P981",
    "addressOne": "Callystown",
    "addressTwo": "Clogherhead",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "53.7916634",
    "lng": "-6.243557",
    "phone": "419822873",
    "email": "callystown14@gmail.com"
  },
  {
    "i": "2017",
    "county": "Louth",
    "rollNumber": "14578N",
    "schoolName": "Scoil Naomh Fainche",
    "SETHours": "65",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "A92WV96",
    "addressOne": "School Lane",
    "addressTwo": "Collon",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "53.7767842",
    "lng": "-6.4830488",
    "phone": "419826594",
    "email": "collonnationalschool@gmail.com"
  },
  {
    "i": "2018",
    "county": "Louth",
    "rollNumber": "14651U",
    "schoolName": "Castletown Rd Convent",
    "SETHours": "97.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "A91P957",
    "addressOne": "Castletown Road",
    "addressTwo": "Dundalk",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "54.0107652",
    "lng": "-6.4051389",
    "phone": "429334574",
    "email": "castletowngs@gmail.com"
  },
  {
    "i": "2019",
    "county": "Louth",
    "rollNumber": "15101N",
    "schoolName": "Knockbridge Mixed NS",
    "SETHours": "102.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "A91X330",
    "addressOne": "Knockbridge",
    "addressTwo": "Dundalk",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "53.9729537",
    "lng": "-6.4856454",
    "phone": "429374443",
    "email": "knockbridgens.ias@eircom.net"
  },
  {
    "i": "2020",
    "county": "Louth",
    "rollNumber": "15259C",
    "schoolName": "SN N Maolmhaodhagh C",
    "SETHours": "82.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "A91N286",
    "addressOne": "Anne Stret",
    "addressTwo": "Dundalk",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "54.0013472",
    "lng": "-6.4079105",
    "phone": "429338156",
    "email": "bridgalligan@eircom.net"
  },
  {
    "i": "2021",
    "county": "Louth",
    "rollNumber": "15260K",
    "schoolName": "SN N Maolmhaodhagh N",
    "SETHours": "85",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.66",
    "spSNA": "0",
    "totalSNA": "2.66",
    "eircode": "A91N286",
    "addressOne": "Anne Street",
    "addressTwo": "Dundalk",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "54.0013472",
    "lng": "-6.4079105",
    "phone": "429338130",
    "email": "stmalachysinfants@eircom.net"
  },
  {
    "i": "2022",
    "county": "Louth",
    "rollNumber": "15285D",
    "schoolName": "Sc Na Gcreagacha Dubha",
    "SETHours": "122.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "A91AK57",
    "addressOne": "Sandy Lane",
    "addressTwo": "Blackrock",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "53.9641802",
    "lng": "-6.3682168",
    "phone": "429321598",
    "email": "blackrockschool@gmail.com"
  },
  {
    "i": "2023",
    "county": "Louth",
    "rollNumber": "16208N",
    "schoolName": "Scoil Náisí­unta Naomh Feichí­n",
    "SETHours": "90",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "A92YN15",
    "addressOne": "Termonfeckin",
    "addressTwo": "Drogheda",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "53.7580147",
    "lng": "-6.2709238",
    "phone": "419822589",
    "email": "office@scoilnaomhfeichin.ie"
  },
  {
    "i": "2024",
    "county": "Louth",
    "rollNumber": "16249E",
    "schoolName": "Bellurgan NS",
    "SETHours": "47.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "1",
    "spSNA": "2.66",
    "totalSNA": "3.66",
    "eircode": "A91N288",
    "addressOne": "New Road",
    "addressTwo": "Bellurgan",
    "addressThree": "Dundalk",
    "addressFour": "",
    "lat": "54.0163225",
    "lng": "-6.3222418",
    "phone": "429371479",
    "email": "principal@bellurganns.ie"
  },
  {
    "i": "2025",
    "county": "Louth",
    "rollNumber": "16431Q",
    "schoolName": "SN Oilibear Beannaithe",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "A91X923",
    "addressOne": "Stonetown",
    "addressTwo": "Dundalk",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "53.9648063",
    "lng": "-6.5975388",
    "phone": "429374883",
    "email": "stown.ias@gmail.com"
  },
  {
    "i": "2026",
    "county": "Louth",
    "rollNumber": "16469S",
    "schoolName": "St Nicholas Monastery Ns",
    "SETHours": "95",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.75",
    "spSNA": "0",
    "totalSNA": "4.75",
    "eircode": "A91X223",
    "addressOne": "Philip Street",
    "addressTwo": "Dundalk",
    "addressThree": "Co Louth",
    "addressFour": "",
    "lat": "54.0102215",
    "lng": "-6.4055237",
    "phone": "429334920",
    "email": "stnicholasmonasteryns@gmail.com"
  },
  {
    "i": "2027",
    "county": "Louth",
    "rollNumber": "16749B",
    "schoolName": "Scoil Mhuire Gan Smál",
    "SETHours": "82.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.75",
    "spSNA": "0",
    "totalSNA": "1.75",
    "eircode": "A91A596",
    "addressOne": "Kilkerley",
    "addressTwo": "Dundalk",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "54.0074583",
    "lng": "-6.469616",
    "phone": "429337187",
    "email": "office@kilkerleyns.ie"
  },
  {
    "i": "2028",
    "county": "Louth",
    "rollNumber": "16760M",
    "schoolName": "Dromiskin Mixed NS",
    "SETHours": "80",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.49",
    "spSNA": "0",
    "totalSNA": "4.49",
    "eircode": "A91E398",
    "addressOne": "Dromiskin",
    "addressTwo": "Dundalk",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "53.9210066",
    "lng": "-6.4054343",
    "phone": "429372906",
    "email": "principal@dromiskinns.ie"
  },
  {
    "i": "2029",
    "county": "Louth",
    "rollNumber": "17059E",
    "schoolName": "Scoil Na Mbraithre Sn",
    "SETHours": "165",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "A92Y927",
    "addressOne": "Sunday's Gate",
    "addressTwo": "Drogheda",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "53.7180691",
    "lng": "-6.349869",
    "phone": "419833620",
    "email": "principal.sungate@gmail.com"
  },
  {
    "i": "2030",
    "county": "Louth",
    "rollNumber": "17124M",
    "schoolName": "Ardee Monastery",
    "SETHours": "142.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.66",
    "spSNA": "0",
    "totalSNA": "4.66",
    "eircode": "A92X788",
    "addressOne": "Drogheda Road",
    "addressTwo": "Ardee",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "53.8520964",
    "lng": "-6.537541",
    "phone": "416853641",
    "email": "officeardeemns@gmail.com"
  },
  {
    "i": "2031",
    "county": "Louth",
    "rollNumber": "17195M",
    "schoolName": "C.b.s. Primary",
    "SETHours": "0",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.83",
    "spSNA": "0",
    "totalSNA": "5.83",
    "eircode": "A91YF82",
    "addressOne": "Chapel Street",
    "addressTwo": "Dundalk",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "54.0064423",
    "lng": "-6.3997987",
    "phone": "429327861",
    "email": "office@cbsprimarydundalk.ie"
  },
  {
    "i": "2032",
    "county": "Louth",
    "rollNumber": "17315T",
    "schoolName": "Scoil Dairbhre Mixed",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "A91DR12",
    "addressOne": "Readypenny",
    "addressTwo": "Dundalk",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "53.9274417",
    "lng": "-6.4583989",
    "phone": "429379280",
    "email": "schdarver.ias@eircom.net"
  },
  {
    "i": "2033",
    "county": "Louth",
    "rollNumber": "17550G",
    "schoolName": "Scoil Fhursa",
    "SETHours": "80",
    "spClassTeachingPosts": "1",
    "mainSNA": "3",
    "spSNA": "2.66",
    "totalSNA": "5.66",
    "eircode": "A91AP98",
    "addressOne": "Marlbog Road",
    "addressTwo": "Haggardstown",
    "addressThree": "Dundalk",
    "addressFour": "Co. Louth",
    "lat": "53.964487",
    "lng": "-6.4051398",
    "phone": "429321214",
    "email": "stfurseysschool@gmail.com"
  },
  {
    "i": "2034",
    "county": "Louth",
    "rollNumber": "17726R",
    "schoolName": "SN Tulach Aluinn",
    "SETHours": "130",
    "spClassTeachingPosts": "1",
    "mainSNA": "5.66",
    "spSNA": "1.66",
    "totalSNA": "7.32",
    "eircode": "A92AE81",
    "addressOne": "Tullyallen",
    "addressTwo": "Co. Louth",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.7368614",
    "lng": "-6.42399",
    "phone": "419833478",
    "email": "tullyns.ias@gmail.com"
  },
  {
    "i": "2035",
    "county": "Louth",
    "rollNumber": "17952D",
    "schoolName": "SN Naomh Fhionain",
    "SETHours": "47.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "0",
    "spSNA": "2",
    "totalSNA": "2",
    "eircode": "A92CX60",
    "addressOne": "Adamstown",
    "addressTwo": "Dunleer",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "53.862882",
    "lng": "-6.3475904",
    "phone": "416851725",
    "email": "scnfhionnain@gmail.com"
  },
  {
    "i": "2036",
    "county": "Louth",
    "rollNumber": "17965M",
    "schoolName": "SN Bhride",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "A91DA37",
    "addressOne": "Ard Achaidh",
    "addressTwo": "Omeath",
    "addressThree": "Dundalk",
    "addressFour": "Co. Louth",
    "lat": "54.0800076",
    "lng": "-6.2721991",
    "phone": "429375232",
    "email": "snbridardaghy@gmail.com"
  },
  {
    "i": "2037",
    "county": "Louth",
    "rollNumber": "18001B",
    "schoolName": "SN Naomh Lorcan",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.75",
    "spSNA": "0",
    "totalSNA": "2.75",
    "eircode": "A91E265",
    "addressOne": "Omeath",
    "addressTwo": "Dundalk",
    "addressThree": "Co Louth",
    "addressFour": "",
    "lat": "54.0823964",
    "lng": "-6.2521733",
    "phone": "429375362",
    "email": "scoilnaomhlorcan@gmail.com"
  },
  {
    "i": "2038",
    "county": "Louth",
    "rollNumber": "18019U",
    "schoolName": "SN Chaoimhin Naofa",
    "SETHours": "60",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "A92D761",
    "addressOne": "Philipstown",
    "addressTwo": "Dunleer",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "53.8223327",
    "lng": "-6.4702135",
    "phone": "416851902",
    "email": "stkevinsnsprincipal@gmail.com"
  },
  {
    "i": "2039",
    "county": "Louth",
    "rollNumber": "18034Q",
    "schoolName": "SN Mhuire",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "A91DK09",
    "addressOne": "Muchgrange",
    "addressTwo": "Greenore",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "54.0121997",
    "lng": "-6.1386918",
    "phone": "429373604",
    "email": "muchgrangens@gmail.com"
  },
  {
    "i": "2040",
    "county": "Louth",
    "rollNumber": "18045V",
    "schoolName": "SN Muire Gan Smal",
    "SETHours": "97.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "4",
    "spSNA": "2",
    "totalSNA": "6",
    "eircode": "A92A567",
    "addressOne": "Cartown",
    "addressTwo": "Termonfeckin",
    "addressThree": "Drogheda",
    "addressFour": "Co. Louth",
    "lat": "53.7700945",
    "lng": "-6.3094427",
    "phone": "419822126",
    "email": "principal@scoilmhuirec.ie"
  },
  {
    "i": "2041",
    "county": "Louth",
    "rollNumber": "18069M",
    "schoolName": "Naomh Seosamh",
    "SETHours": "97.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "A92W951",
    "addressOne": "Mell",
    "addressTwo": "Drogheda",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "53.720085",
    "lng": "-6.3718952",
    "phone": "419833990",
    "email": "office@mellns.ie"
  },
  {
    "i": "2042",
    "county": "Louth",
    "rollNumber": "18099V",
    "schoolName": "SN Muire Na Trocaire",
    "SETHours": "0",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "A92FR58",
    "addressOne": "Hale Street",
    "addressTwo": "Ardee",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "53.8529056",
    "lng": "-6.5337805",
    "phone": "416853152",
    "email": "smntadmin@eircom.net"
  },
  {
    "i": "2043",
    "county": "Louth",
    "rollNumber": "18101F",
    "schoolName": "SN Muire",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "A91VP64",
    "addressOne": "Rampark",
    "addressTwo": "Jenkinstown",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "53.9999584",
    "lng": "-6.2631101",
    "phone": "429376296",
    "email": "s.n.rampark@gmail.com"
  },
  {
    "i": "2044",
    "county": "Louth",
    "rollNumber": "18126V",
    "schoolName": "SN San Nioclas",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "A91KD91",
    "addressOne": "Tigh Banan",
    "addressTwo": "Castlebellingham",
    "addressThree": "Co Louth",
    "addressFour": "",
    "lat": "53.8665136",
    "lng": "-6.4408154",
    "phone": "416851772",
    "email": "stabannonschool@gmail.com"
  },
  {
    "i": "2045",
    "county": "Louth",
    "rollNumber": "18148I",
    "schoolName": "Scoil Bhride Mixed NS",
    "SETHours": "110",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "A92YW92",
    "addressOne": "Lann Léire",
    "addressTwo": "Ardee Road",
    "addressThree": "Dunleer",
    "addressFour": "Co. Louth",
    "lat": "53.8313888",
    "lng": "-6.4004975",
    "phone": "416851324",
    "email": "dunleerns@gmail.com"
  },
  {
    "i": "2046",
    "county": "Louth",
    "rollNumber": "18186Q",
    "schoolName": "Scoil Phadraig Naofa",
    "SETHours": "72.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "A91D302",
    "addressOne": "Carrickedmond",
    "addressTwo": "Kilcurry",
    "addressThree": "Dundalk",
    "addressFour": "Co. Louth",
    "lat": "54.044353",
    "lng": "-6.4254751",
    "phone": "429339310",
    "email": "sclphadr@gmail.com"
  },
  {
    "i": "2047",
    "county": "Louth",
    "rollNumber": "18312S",
    "schoolName": "SN Talamh Na Manach",
    "SETHours": "70",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "A91PW81",
    "addressOne": "Talamh Na Manach",
    "addressTwo": "Carlingford",
    "addressThree": "Co Louth",
    "addressFour": "",
    "lat": "54.0025497",
    "lng": "-6.1733286",
    "phone": "429376431",
    "email": "monkslandschool@gmail.com"
  },
  {
    "i": "2048",
    "county": "Louth",
    "rollNumber": "18347O",
    "schoolName": "SN San Nioclas",
    "SETHours": "70",
    "spClassTeachingPosts": "2",
    "mainSNA": "2",
    "spSNA": "4.83",
    "totalSNA": "6.83",
    "eircode": "A91CR24",
    "addressOne": "Nicholas St",
    "addressTwo": "Dundalk",
    "addressThree": "Co Louth",
    "addressFour": "",
    "lat": "54.0100592",
    "lng": "-6.3996964",
    "phone": "429330860",
    "email": "sannioclas.ns@hotmail.com"
  },
  {
    "i": "2049",
    "county": "Louth",
    "rollNumber": "18382Q",
    "schoolName": "Scoil Bhride",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "A91Y744",
    "addressOne": "Shelagh",
    "addressTwo": "Hackballscross",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "54.0389687",
    "lng": "-6.5582496",
    "phone": "429377510",
    "email": "snsoffice62@gmail.com"
  },
  {
    "i": "2050",
    "county": "Louth",
    "rollNumber": "18391R",
    "schoolName": "Faughart Community NS",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "A91D897",
    "addressOne": "Faughart",
    "addressTwo": "Dundalk",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.0444318",
    "lng": "-6.3890647",
    "phone": "429371931",
    "email": "jmccusker.fns@lmetb.ie"
  },
  {
    "i": "2051",
    "county": "Louth",
    "rollNumber": "18471P",
    "schoolName": "SN Rath Corr",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "A91X098",
    "addressOne": "Rathcor",
    "addressTwo": "Riverstown",
    "addressThree": "Dundalk",
    "addressFour": "",
    "lat": "53.9860754",
    "lng": "-6.1896137",
    "phone": "429376543",
    "email": "rathcorr@gmail.com"
  },
  {
    "i": "2052",
    "county": "Louth",
    "rollNumber": "18504E",
    "schoolName": "SN N Maolmhaodhagh B",
    "SETHours": "82.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "A91N286",
    "addressOne": "Anne Street",
    "addressTwo": "Dundalk",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "54.0013472",
    "lng": "-6.4079105",
    "phone": "429338145",
    "email": "office@stmalachysbns.ie"
  },
  {
    "i": "2053",
    "county": "Louth",
    "rollNumber": "18635T",
    "schoolName": "SN Tigh An Iubhair",
    "SETHours": "85",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.58",
    "spSNA": "0",
    "totalSNA": "5.58",
    "eircode": "A92PD26",
    "addressOne": "Tenure",
    "addressTwo": "Dunleer",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "53.7912094",
    "lng": "-6.4180949",
    "phone": "416851503",
    "email": "office@tenurens.ie"
  },
  {
    "i": "2054",
    "county": "Louth",
    "rollNumber": "19215C",
    "schoolName": "SN Ard Mhuire C",
    "SETHours": "115",
    "spClassTeachingPosts": "1",
    "mainSNA": "1.5",
    "spSNA": "1.83",
    "totalSNA": "3.33",
    "eircode": "A92FD60",
    "addressOne": "Donore Avenue",
    "addressTwo": "Drogheda",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "53.7111881",
    "lng": "-6.359935",
    "phone": "419837150",
    "email": "office@marymountgns.ie"
  },
  {
    "i": "2055",
    "county": "Louth",
    "rollNumber": "19223B",
    "schoolName": "SN Padraig",
    "SETHours": "65",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "A92VH02",
    "addressOne": "Harestown",
    "addressTwo": "Monasterboice",
    "addressThree": "Drogheda",
    "addressFour": "Co. Louth",
    "lat": "53.7758317",
    "lng": "-6.3533006",
    "phone": "419822112",
    "email": "stpatsharestown@eircom.net"
  },
  {
    "i": "2056",
    "county": "Louth",
    "rollNumber": "19246N",
    "schoolName": "SN An Tslanaitheora B",
    "SETHours": "110.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "3",
    "spSNA": "5",
    "totalSNA": "8",
    "eircode": "A91DN76",
    "addressOne": "Ard Easmuinn",
    "addressTwo": "Dundalk",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "54.006367",
    "lng": "-6.4153384",
    "phone": "429332053",
    "email": "redeemerboysschool@yahoo.com"
  },
  {
    "i": "2057",
    "county": "Louth",
    "rollNumber": "19247P",
    "schoolName": "SN An Tslanaitheora C",
    "SETHours": "77.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "0.83",
    "spSNA": "3",
    "totalSNA": "3.83",
    "eircode": "A91EC82",
    "addressOne": "Ard Easmuinn Road",
    "addressTwo": "Dundalk",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "54.006367",
    "lng": "-6.4153384",
    "phone": "864041057",
    "email": "redeemerprincipal@gmail.com"
  },
  {
    "i": "2058",
    "county": "Louth",
    "rollNumber": "19479N",
    "schoolName": "Rathmullan NS",
    "SETHours": "252.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "7.65",
    "spSNA": "0.33",
    "totalSNA": "7.98",
    "eircode": "A92DD39",
    "addressOne": "Marley's Lane",
    "addressTwo": "Drogheda",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "53.7109847",
    "lng": "-6.3744795",
    "phone": "419831488",
    "email": "stjohnsnsprincipal@gmail.com"
  },
  {
    "i": "2059",
    "county": "Louth",
    "rollNumber": "19598V",
    "schoolName": "Muire Na Ngael Ns",
    "SETHours": "197.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "8.83",
    "spSNA": "0",
    "totalSNA": "8.83",
    "eircode": "A91C953",
    "addressOne": "Bay Estate",
    "addressTwo": "Dundalik",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "53.9952493",
    "lng": "-6.3740891",
    "phone": "429336158",
    "email": "smgdundalk@gmail.com"
  },
  {
    "i": "2060",
    "county": "Louth",
    "rollNumber": "19673J",
    "schoolName": "St Josephs NS",
    "SETHours": "327.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "10.5",
    "spSNA": "1",
    "totalSNA": "11.5",
    "eircode": "A91D786",
    "addressOne": "Tom Bellew Avenue",
    "addressTwo": "Dundalk",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "53.9921341",
    "lng": "-6.3873319",
    "phone": "429337170",
    "email": "stjosephsnsdundalk@gmail.com"
  },
  {
    "i": "2061",
    "county": "Louth",
    "rollNumber": "19678T",
    "schoolName": "St Paul's Sn Ns",
    "SETHours": "290",
    "spClassTeachingPosts": "2",
    "mainSNA": "2.75",
    "spSNA": "0.25",
    "totalSNA": "3",
    "eircode": "A92D232",
    "addressOne": "Marley's Lane",
    "addressTwo": "Drogheda",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "53.7108455",
    "lng": "-6.3734563",
    "phone": "419833681",
    "email": "office@stpaulssns.com"
  },
  {
    "i": "2062",
    "county": "Louth",
    "rollNumber": "19740V",
    "schoolName": "SN Aonghusa",
    "SETHours": "60",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "A92PY18",
    "addressOne": "Geata An Domhnaigh",
    "addressTwo": "Droichead Atha",
    "addressThree": "Co Lu",
    "addressFour": "",
    "lat": "53.7181626",
    "lng": "-6.3490853",
    "phone": "419832531",
    "email": "oifig.scoilaonghusa@gmail.com"
  },
  {
    "i": "2063",
    "county": "Louth",
    "rollNumber": "19892V",
    "schoolName": "Gaelscoil Dhun Dealgan",
    "SETHours": "75",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "A91D797",
    "addressOne": "Muirtheimhne Mór",
    "addressTwo": "Dún Dealgan",
    "addressThree": "Co. Lú",
    "addressFour": "",
    "lat": "53.9881258",
    "lng": "-6.3817693",
    "phone": "429339389",
    "email": "gaelscdd@eircom.net"
  },
  {
    "i": "2064",
    "county": "Louth",
    "rollNumber": "20146Q",
    "schoolName": "Le Cheile Educate Together",
    "SETHours": "135",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.66",
    "spSNA": "0",
    "totalSNA": "4.66",
    "eircode": "A92KX84",
    "addressOne": "Mornington Road",
    "addressTwo": "Drogheda",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "53.7179924",
    "lng": "-6.3053806",
    "phone": "419847427",
    "email": "lecheile.etns@gmail.com"
  },
  {
    "i": "2065",
    "county": "Louth",
    "rollNumber": "20163Q",
    "schoolName": "S.n Eoin Baiste",
    "SETHours": "115",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "A91XN28",
    "addressOne": "Fatima",
    "addressTwo": "Castletown",
    "addressThree": "Dundalk",
    "addressFour": "Co. Louth",
    "lat": "54.0184523",
    "lng": "-6.4262885",
    "phone": "429331575",
    "email": "scoileoinbaiste@gmail.com"
  },
  {
    "i": "2066",
    "county": "Louth",
    "rollNumber": "20171P",
    "schoolName": "Ardee Educate Together N.s",
    "SETHours": "97.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "2.83",
    "spSNA": "6.66",
    "totalSNA": "9.49",
    "eircode": "A92TW80",
    "addressOne": "Dundalk Road",
    "addressTwo": "Ardee",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "53.8629196",
    "lng": "-6.5415298",
    "phone": "416853774",
    "email": "ardeeetns@gmail.com"
  },
  {
    "i": "2067",
    "county": "Louth",
    "rollNumber": "20205G",
    "schoolName": "St Marys Parish Primary School",
    "SETHours": "372.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "9.49",
    "spSNA": "0",
    "totalSNA": "9.49",
    "eircode": "A92XD80",
    "addressOne": "Dublin Road",
    "addressTwo": "Drogheda",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "53.7077741",
    "lng": "-6.3392592",
    "phone": "419845374",
    "email": "office@smpps.ie"
  },
  {
    "i": "2068",
    "county": "Louth",
    "rollNumber": "20259G",
    "schoolName": "St. Francis NS",
    "SETHours": "112.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.58",
    "spSNA": "0",
    "totalSNA": "3.58",
    "eircode": "A91NH0V",
    "addressOne": "Rock Road",
    "addressTwo": "Blackrock",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.9644736",
    "lng": "-6.378863",
    "phone": "429366993",
    "email": "admin@stfrancisns.ie"
  },
  {
    "i": "2069",
    "county": "Louth",
    "rollNumber": "20294I",
    "schoolName": "Aston Village Educate Together NS",
    "SETHours": "185",
    "spClassTeachingPosts": "5",
    "mainSNA": "5.83",
    "spSNA": "10",
    "totalSNA": "15.83",
    "eircode": "A92DR44",
    "addressOne": "Dunlin Street",
    "addressTwo": "Aston Village",
    "addressThree": "Drogheda",
    "addressFour": "Co. Louth",
    "lat": "53.7312044",
    "lng": "-6.3293506",
    "phone": "419849001",
    "email": "office@astonvillageetns.com"
  },
  {
    "i": "2070",
    "county": "Louth",
    "rollNumber": "20339E",
    "schoolName": "Réalt Na Mara School",
    "SETHours": "157.5",
    "spClassTeachingPosts": "5",
    "mainSNA": "8.66",
    "spSNA": "9.66",
    "totalSNA": "18.32",
    "eircode": "A91TD3H",
    "addressOne": "Mill Street",
    "addressTwo": "Dundalk",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "54.0067718",
    "lng": "-6.3905917",
    "phone": "429327230",
    "email": "realtnamarass@eircom.net"
  },
  {
    "i": "2071",
    "county": "Louth",
    "rollNumber": "20349H",
    "schoolName": "Scoil Oilibhéir Naofa",
    "SETHours": "152.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "A92NV26",
    "addressOne": "Ballymakenny Road",
    "addressTwo": "Drogheda",
    "addressThree": "Co. Louth",
    "addressFour": "",
    "lat": "53.7321869",
    "lng": "-6.3448528",
    "phone": "419804578",
    "email": "office@stoliversprimary.ie"
  },
  {
    "i": "2072",
    "county": "Louth",
    "rollNumber": "20508B",
    "schoolName": "St Brigid's And St Patrick's NS",
    "SETHours": "272.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "6.83",
    "spSNA": "0",
    "totalSNA": "6.83",
    "eircode": "",
    "addressOne": "Bothar Brugha",
    "addressTwo": "Drogheda",
    "addressThree": "Co Louth",
    "addressFour": "",
    "lat": "53.7211729",
    "lng": "-6.3561542",
    "phone": "419837133",
    "email": "stpatricksbotharbrugha@gmail.com"
  },
  {
    "i": "2073",
    "county": "Mayo",
    "rollNumber": "01676P",
    "schoolName": "Ballindine BNS",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.58",
    "spSNA": "0",
    "totalSNA": "2.58",
    "eircode": "F12CY64",
    "addressOne": "Ballindine",
    "addressTwo": "Claremorris",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.672562",
    "lng": "-8.9571203",
    "phone": "949364204",
    "email": "ballindineinfo@gmail.com"
  },
  {
    "i": "2074",
    "county": "Mayo",
    "rollNumber": "02912G",
    "schoolName": "Scoil Na Gcoillini",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "F12TW53",
    "addressOne": "Meelick",
    "addressTwo": "Swinford",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.9297562",
    "lng": "-9.0214293",
    "phone": "949384214",
    "email": "meelickns1@gmail.com"
  },
  {
    "i": "2075",
    "county": "Mayo",
    "rollNumber": "04796R",
    "schoolName": "Brackloon NS",
    "SETHours": "60",
    "spClassTeachingPosts": "1",
    "mainSNA": "3.83",
    "spSNA": "1",
    "totalSNA": "4.83",
    "eircode": "F28E8Y9",
    "addressOne": "Brackloon",
    "addressTwo": "Westport",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.7547499",
    "lng": "-9.5642115",
    "phone": "9821902",
    "email": "brackloonnationalschool@gmail.com"
  },
  {
    "i": "2076",
    "county": "Mayo",
    "rollNumber": "05120L",
    "schoolName": "Lehinch NS",
    "SETHours": "7.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F12FT92",
    "addressOne": "Lissatava",
    "addressTwo": "Hollymount",
    "addressThree": "Claremorris",
    "addressFour": "Co. Mayo",
    "lat": "53.6595962",
    "lng": "-9.0749359",
    "phone": "949540444",
    "email": "Lehinchprimary@gmail.com"
  },
  {
    "i": "2077",
    "county": "Mayo",
    "rollNumber": "05756K",
    "schoolName": "Burriscarra NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F12YD72",
    "addressOne": "Carrownacon",
    "addressTwo": "Ballyglass",
    "addressThree": "Claremorris",
    "addressFour": "Co. Mayo",
    "lat": "53.7290072",
    "lng": "-9.220588",
    "phone": "949360184",
    "email": "carnaconschool@eircom.net"
  },
  {
    "i": "2078",
    "county": "Mayo",
    "rollNumber": "06852L",
    "schoolName": "Garracloon NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "F26W266",
    "addressOne": "Garracloon",
    "addressTwo": "Cloghans",
    "addressThree": "Ballina",
    "addressFour": "Co. Mayo",
    "lat": "54.0920428",
    "lng": "-9.2353223",
    "phone": "9673208",
    "email": "garracloon.ns@gmail.com"
  },
  {
    "i": "2079",
    "county": "Mayo",
    "rollNumber": "07054L",
    "schoolName": "Cullens NS",
    "SETHours": "122.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "3.25",
    "spSNA": "1.66",
    "totalSNA": "4.91",
    "eircode": "F26TF97",
    "addressOne": "Faranoo",
    "addressTwo": "Ballina",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "54.1380224",
    "lng": "-9.1638052",
    "phone": "9622084",
    "email": "info@culleensballina.ie"
  },
  {
    "i": "2080",
    "county": "Mayo",
    "rollNumber": "07075T",
    "schoolName": "SN Naomh Feichin",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.75",
    "spSNA": "0",
    "totalSNA": "1.75",
    "eircode": "F12RD90",
    "addressOne": "Cross",
    "addressTwo": "Claremorris",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.5402543",
    "lng": "-9.2152857",
    "phone": "949546321",
    "email": "crossns1854@gmail.com"
  },
  {
    "i": "2081",
    "county": "Mayo",
    "rollNumber": "07374G",
    "schoolName": "Ballintubber NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "F12KW18",
    "addressOne": "Ballintubber",
    "addressTwo": "Claremorris",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.7584215",
    "lng": "-9.3044116",
    "phone": "949030969",
    "email": "ballintubber07374G@gmail.com"
  },
  {
    "i": "2082",
    "county": "Mayo",
    "rollNumber": "08302J",
    "schoolName": "Holy Trinity NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "F28FP64",
    "addressOne": "Newport Road",
    "addressTwo": "Westport",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.8015602",
    "lng": "-9.5213505",
    "phone": "9827216",
    "email": "school@holytrinityns.com"
  },
  {
    "i": "2083",
    "county": "Mayo",
    "rollNumber": "09040K",
    "schoolName": "Newtownwhite Educate Together Ns",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.75",
    "spSNA": "0",
    "totalSNA": "1.75",
    "eircode": "F26TP63",
    "addressOne": "Ballysakeery",
    "addressTwo": "Ballina",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "54.187006",
    "lng": "-9.179445",
    "phone": "9632728",
    "email": "newtownwhite@gmail.com"
  },
  {
    "i": "2084",
    "county": "Mayo",
    "rollNumber": "11725I",
    "schoolName": "Beheymore NS",
    "SETHours": "92.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "2.5",
    "spSNA": "2",
    "totalSNA": "4.5",
    "eircode": "F26RT66",
    "addressOne": "Behymore",
    "addressTwo": "Ballina",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "54.116258",
    "lng": "-9.0957681",
    "phone": "9670469",
    "email": "behyschool@hotmail.com"
  },
  {
    "i": "2085",
    "county": "Mayo",
    "rollNumber": "11834N",
    "schoolName": "Cloondaff NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F28Y261",
    "addressOne": "Cloondaff",
    "addressTwo": "Glenhest",
    "addressThree": "Newport",
    "addressFour": "Co. Mayo",
    "lat": "53.9395065",
    "lng": "-9.4407443",
    "phone": "9841917",
    "email": "neifinn.ias@eircom.net"
  },
  {
    "i": "2086",
    "county": "Mayo",
    "rollNumber": "12173A",
    "schoolName": "Meelickmore NS",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "F12EK20",
    "addressOne": "Meelick More",
    "addressTwo": "Claremorris",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.7033475",
    "lng": "-8.9461581",
    "phone": "949362424",
    "email": "meelickmorens@gmail.com"
  },
  {
    "i": "2087",
    "county": "Mayo",
    "rollNumber": "12206M",
    "schoolName": "SN Naomh Padraig",
    "SETHours": "80",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.75",
    "spSNA": "0",
    "totalSNA": "1.75",
    "eircode": "F26VW24",
    "addressOne": "Currabaggan West",
    "addressTwo": "Knockmore",
    "addressThree": "Ballina",
    "addressFour": "Co. Mayo",
    "lat": "54.0433706",
    "lng": "-9.179671",
    "phone": "949258169",
    "email": "secretary@currabagganschool.ie"
  },
  {
    "i": "2088",
    "county": "Mayo",
    "rollNumber": "12350T",
    "schoolName": "SN Na Haille",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F31YV57",
    "addressOne": "The Neale",
    "addressTwo": "Ballinrobe",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.5732469",
    "lng": "-9.2243222",
    "phone": "949546301",
    "email": "thenealens@gmail.com"
  },
  {
    "i": "2089",
    "county": "Mayo",
    "rollNumber": "12373I",
    "schoolName": "SN Eachleime",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F26P704",
    "addressOne": "Eachléim",
    "addressTwo": "Fód Dubh",
    "addressThree": "Béal An átha",
    "addressFour": "Co. Mhaigh Eo",
    "lat": "54.117948",
    "lng": "-10.1036446",
    "phone": "9785800",
    "email": "eolas@eachleim.com"
  },
  {
    "i": "2090",
    "county": "Mayo",
    "rollNumber": "12467R",
    "schoolName": "Craggagh NS",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "F23A590",
    "addressOne": "Craggagh",
    "addressTwo": "Balla",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.817914",
    "lng": "-9.0776007",
    "phone": "949365177",
    "email": "principal@craggaghns.ie"
  },
  {
    "i": "2091",
    "county": "Mayo",
    "rollNumber": "12568A",
    "schoolName": "Sn Inbhear",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F26A316",
    "addressOne": "Inver",
    "addressTwo": "Barnatra",
    "addressThree": "Ballina",
    "addressFour": "Co. Mayo",
    "lat": "54.251198",
    "lng": "-9.8649474",
    "phone": "9784532",
    "email": "inverns@outlook.ie"
  },
  {
    "i": "2092",
    "county": "Mayo",
    "rollNumber": "12569C",
    "schoolName": "SN Ros Dumhach",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F26KN50",
    "addressOne": "Ross Dumhach",
    "addressTwo": "Béal An átha",
    "addressThree": "Co. Mhaigh Eo",
    "addressFour": "",
    "lat": "54.2842767",
    "lng": "-9.7944824",
    "phone": "9788919",
    "email": "anitahealy@ymail.com"
  },
  {
    "i": "2093",
    "county": "Mayo",
    "rollNumber": "12792F",
    "schoolName": "Saint Michaels NS",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F26D6F8",
    "addressOne": "Church Road",
    "addressTwo": "Ballina",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "54.10787",
    "lng": "-9.153289",
    "phone": "9670279",
    "email": "stmichaelsnschurchrd@gmail.com"
  },
  {
    "i": "2095",
    "county": "Mayo",
    "rollNumber": "12816Q",
    "schoolName": "SN Ceathru An Chlochar",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F31EV96",
    "addressOne": "Cloonee",
    "addressTwo": "Ballinrobe",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.6640601",
    "lng": "-9.2250864",
    "phone": "949541715",
    "email": "roxboroballinrobe@eircom.net"
  },
  {
    "i": "2096",
    "county": "Mayo",
    "rollNumber": "12936D",
    "schoolName": "Cloonlyon NS",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "F12CH96",
    "addressOne": "Cloonlyon",
    "addressTwo": "Charlestown",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.9308427",
    "lng": "-8.8381591",
    "phone": "949254932",
    "email": "cloonlyon@eircom.net"
  },
  {
    "i": "2097",
    "county": "Mayo",
    "rollNumber": "12938H",
    "schoolName": "SN Tamhnighan Fheadha",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F12R232",
    "addressOne": "Tavneena",
    "addressTwo": "Charlestown",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.9178867",
    "lng": "-8.7766133",
    "phone": "949254910",
    "email": "tavneenans@gmail.com"
  },
  {
    "i": "2098",
    "county": "Mayo",
    "rollNumber": "13080V",
    "schoolName": "Kilmovee In S",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F45R650",
    "addressOne": "Ballyglass",
    "addressTwo": "Kilmovee",
    "addressThree": "Ballaghadereen",
    "addressFour": "Co. Mayo",
    "lat": "53.8903931",
    "lng": "-8.65807",
    "phone": "949861282",
    "email": "kilmoveens@eircom.net"
  },
  {
    "i": "2099",
    "county": "Mayo",
    "rollNumber": "13145A",
    "schoolName": "SN Naomh Colm Cille",
    "SETHours": "70",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F28W267",
    "addressOne": "The Quay",
    "addressTwo": "Westport",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.7976075",
    "lng": "-9.5496478",
    "phone": "9826829",
    "email": "quayschool1@eircom.net"
  },
  {
    "i": "2100",
    "county": "Mayo",
    "rollNumber": "13152U",
    "schoolName": "St Josephs NS",
    "SETHours": "50",
    "spClassTeachingPosts": "1",
    "mainSNA": "2",
    "spSNA": "1.83",
    "totalSNA": "3.83",
    "eircode": "F23T659",
    "addressOne": "Derrydorragh",
    "addressTwo": "Clonken",
    "addressThree": "Castlebar",
    "addressFour": "Co. Mayo",
    "lat": "53.8216203",
    "lng": "-9.3347803",
    "phone": "949023819",
    "email": "derrywashns@gmail.com"
  },
  {
    "i": "2101",
    "county": "Mayo",
    "rollNumber": "13174H",
    "schoolName": "St Columbas NS",
    "SETHours": "5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H91YNP3",
    "addressOne": "Ballyvaum",
    "addressTwo": "Inishturk",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.6988574",
    "lng": "-10.0970346",
    "phone": "877792096",
    "email": "stcolumbasns@gmail.com"
  },
  {
    "i": "2102",
    "county": "Mayo",
    "rollNumber": "13222P",
    "schoolName": "Sn Gleann A Chaisil",
    "SETHours": "37.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "1",
    "spSNA": "5.66",
    "totalSNA": "6.66",
    "eircode": "F26NP79",
    "addressOne": "Bunnahowen",
    "addressTwo": "Ballina",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "54.1952815",
    "lng": "-9.908431",
    "phone": "9782283",
    "email": "gleannachaisil@gmail.com"
  },
  {
    "i": "2103",
    "county": "Mayo",
    "rollNumber": "13225V",
    "schoolName": "Cormaic Nfa",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "F26KW35",
    "addressOne": "Killeennashask",
    "addressTwo": "Garranard",
    "addressThree": "Ballina",
    "addressFour": "Co. Mayo",
    "lat": "54.1657371",
    "lng": "-9.3446957",
    "phone": "9631832",
    "email": "carnns@gmail.com"
  },
  {
    "i": "2104",
    "county": "Mayo",
    "rollNumber": "13311O",
    "schoolName": "St Patricks Ns",
    "SETHours": "7.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F28F516",
    "addressOne": "Clare Island",
    "addressTwo": "Westport",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.7931829",
    "lng": "-9.9901451",
    "phone": "871675632",
    "email": "clareislandprimary@gmail.com"
  },
  {
    "i": "2105",
    "county": "Mayo",
    "rollNumber": "13383Q",
    "schoolName": "SN An Tsraith",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F26C672",
    "addressOne": "Bunnahowen",
    "addressTwo": "Ballina",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "54.1659993",
    "lng": "-9.9351861",
    "phone": "9781636",
    "email": "shraighns@gmail.com"
  },
  {
    "i": "2106",
    "county": "Mayo",
    "rollNumber": "13389F",
    "schoolName": "Sn An Trian Lair",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "F12C429",
    "addressOne": "Midfield",
    "addressTwo": "Swinford",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.8973158",
    "lng": "-8.9246942",
    "phone": "949252037",
    "email": "midfieldns@gmail.com"
  },
  {
    "i": "2107",
    "county": "Mayo",
    "rollNumber": "13444K",
    "schoolName": "SN Beal Atha Na Hein",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F23V124",
    "addressOne": "Ballyhean",
    "addressTwo": "Castlebar",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.7944214",
    "lng": "-9.3161946",
    "phone": "949030803",
    "email": "ballyheanens@gmail.com"
  },
  {
    "i": "2108",
    "county": "Mayo",
    "rollNumber": "13500R",
    "schoolName": "Mount Pleasant NS",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F12YX45",
    "addressOne": "Ballyglass",
    "addressTwo": "Claremorris",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.7461052",
    "lng": "-9.1771175",
    "phone": "949360125",
    "email": "mountpleasantns@gmail.com"
  },
  {
    "i": "2109",
    "county": "Mayo",
    "rollNumber": "13555T",
    "schoolName": "SN Faitche",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F28R9C9",
    "addressOne": "Toorgarve",
    "addressTwo": "Fahy",
    "addressThree": "Westport",
    "addressFour": "Co. Mayo",
    "lat": "53.8505878",
    "lng": "-9.4902715",
    "phone": "9841531",
    "email": "fahyns@yahoo.ie"
  },
  {
    "i": "2110",
    "county": "Mayo",
    "rollNumber": "13659I",
    "schoolName": "Beacan Mixed NS",
    "SETHours": "62.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "F12RP44",
    "addressOne": "Bekan",
    "addressTwo": "Claremorris",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.7586013",
    "lng": "-8.8497239",
    "phone": "949380311",
    "email": "bekanschool@gmail.com"
  },
  {
    "i": "2111",
    "county": "Mayo",
    "rollNumber": "13667H",
    "schoolName": "Sn Muine Chonallain",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "F26PK26",
    "addressOne": "Bonniconlon",
    "addressTwo": "Ballina",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "54.1098413",
    "lng": "-9.0271615",
    "phone": "9645356",
    "email": "bonniconlonns@gmail.com"
  },
  {
    "i": "2112",
    "county": "Mayo",
    "rollNumber": "13684H",
    "schoolName": "Scoil Chroí­ Ró Naofa Beannchor Iorrais",
    "SETHours": "33",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "F26WD59",
    "addressOne": "Srahanarry",
    "addressTwo": "Bangor Erris",
    "addressThree": "Ballina",
    "addressFour": "Co. Mayo",
    "lat": "54.1432789",
    "lng": "-9.7405606",
    "phone": "9783422",
    "email": "bangorerrisns1@gmail.com"
  },
  {
    "i": "2113",
    "county": "Mayo",
    "rollNumber": "13758K",
    "schoolName": "Templemary NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F26R838",
    "addressOne": "Carbad Beg",
    "addressTwo": "Killala",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "54.2335337",
    "lng": "-9.2576886",
    "phone": "9634760",
    "email": "templemaryns@gmail.com"
  },
  {
    "i": "2114",
    "county": "Mayo",
    "rollNumber": "13773G",
    "schoolName": "SN Gort An Eadain",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "F12TX37",
    "addressOne": "Facefield",
    "addressTwo": "Claremorris",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.7838739",
    "lng": "-9.0610492",
    "phone": "949365635",
    "email": "noelcommons@gmail.com"
  },
  {
    "i": "2115",
    "county": "Mayo",
    "rollNumber": "13781F",
    "schoolName": "Breaffy NS",
    "SETHours": "162.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "F23WF99",
    "addressOne": "Breaffy",
    "addressTwo": "Castlebar",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.8476963",
    "lng": "-9.2382453",
    "phone": "949024699",
    "email": "breaffynationalschool@eircom.net"
  },
  {
    "i": "2116",
    "county": "Mayo",
    "rollNumber": "13797U",
    "schoolName": "Lecanvey NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F28DW72",
    "addressOne": "Lecanvey",
    "addressTwo": "Westport",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.7790169",
    "lng": "-9.6884951",
    "phone": "9864957",
    "email": "lecanveyns.ias@eircom.net"
  },
  {
    "i": "2117",
    "county": "Mayo",
    "rollNumber": "13882L",
    "schoolName": "SN Gleann Na Muaidhe",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "F26NY57",
    "addressOne": "Béal An átha",
    "addressTwo": "Co. Mhaigh Eo",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.2426379",
    "lng": "-9.650143",
    "phone": "9787966",
    "email": "glenamoyns@gmail.com"
  },
  {
    "i": "2118",
    "county": "Mayo",
    "rollNumber": "14064F",
    "schoolName": "SN Coill An Bhaile",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "F28TR64",
    "addressOne": "Killawalla East",
    "addressTwo": "Westport",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.7606708",
    "lng": "-9.3637678",
    "phone": "9835206",
    "email": "killawallaschool@gmail.com"
  },
  {
    "i": "2119",
    "county": "Mayo",
    "rollNumber": "14188A",
    "schoolName": "Barnatra NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F26VP27",
    "addressOne": "Barnatra",
    "addressTwo": "Ballina",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.2226764",
    "lng": "-9.8515299",
    "phone": "9784008",
    "email": "barnatrans20@gmail.com"
  },
  {
    "i": "2120",
    "county": "Mayo",
    "rollNumber": "14193Q",
    "schoolName": "SN Dhumha Thuama",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "F26HD23",
    "addressOne": "Dumha Thuama",
    "addressTwo": "Béal An átha",
    "addressThree": "Co. Mhaigh Eo",
    "addressFour": "",
    "lat": "54.074985",
    "lng": "-9.9287235",
    "phone": "9786605",
    "email": "sndhumhathuama@gmail.com"
  },
  {
    "i": "2121",
    "county": "Mayo",
    "rollNumber": "14205U",
    "schoolName": "SN Mainistir Muigheo",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "F12T256",
    "addressOne": "Lehanagh",
    "addressTwo": "Mayo Abbey",
    "addressThree": "Claremorris",
    "addressFour": "Co. Mayo",
    "lat": "53.7622344",
    "lng": "-9.1175045",
    "phone": "949365644",
    "email": "mayoabbeyns@yahoo.com"
  },
  {
    "i": "2122",
    "county": "Mayo",
    "rollNumber": "14258S",
    "schoolName": "Cill Mhor Iorrais",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F26TX06",
    "addressOne": "Binghamstown",
    "addressTwo": "Belmullet",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "54.2041549",
    "lng": "-10.0382415",
    "phone": "9782223",
    "email": "binghamstownps@gmail.com"
  },
  {
    "i": "2123",
    "county": "Mayo",
    "rollNumber": "14290O",
    "schoolName": "Scoil Naomh Brid",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F26DP20",
    "addressOne": "Ballycastle",
    "addressTwo": "Co. Mayo",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.2786042",
    "lng": "-9.3716405",
    "phone": "9643267",
    "email": "saintbridgetsbc@gmail.com"
  },
  {
    "i": "2124",
    "county": "Mayo",
    "rollNumber": "14497N",
    "schoolName": "SN B Curnanool",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "F23W820",
    "addressOne": "Cornanool",
    "addressTwo": "Castlebar",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.852247",
    "lng": "-9.3572491",
    "phone": "949026569",
    "email": "eolas@cornanoolns.ie"
  },
  {
    "i": "2125",
    "county": "Mayo",
    "rollNumber": "14534Q",
    "schoolName": "Gortjordan NS",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "F31YV48",
    "addressOne": "Kilmaine",
    "addressTwo": "Claremorris",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.5492214",
    "lng": "-9.1538689",
    "phone": "9333470",
    "email": "gortjordanns@gmail.com"
  },
  {
    "i": "2126",
    "county": "Mayo",
    "rollNumber": "14808E",
    "schoolName": "Irishtown NS",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "F12XV30",
    "addressOne": "Claremorris",
    "addressTwo": "Co. Mayo",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.6625733",
    "lng": "-8.8902597",
    "phone": "949364559",
    "email": "irishtownnsmayo@gmail.com"
  },
  {
    "i": "2127",
    "county": "Mayo",
    "rollNumber": "14863M",
    "schoolName": "Achill Sound Convent Ns",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F28ER26",
    "addressOne": "The Points",
    "addressTwo": "Achill Sound",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.9288696",
    "lng": "-9.9285915",
    "phone": "9845705",
    "email": "principalasns@gmail.com"
  },
  {
    "i": "2128",
    "county": "Mayo",
    "rollNumber": "14873P",
    "schoolName": "Dookinella NS",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "F28RF79",
    "addressOne": "Low River",
    "addressTwo": "Dookinella",
    "addressThree": "Keel",
    "addressFour": "Co. Mayo",
    "lat": "53.9748584",
    "lng": "-10.04472",
    "phone": "9843322",
    "email": "riverns@eircom.net"
  },
  {
    "i": "2129",
    "county": "Mayo",
    "rollNumber": "15014S",
    "schoolName": "Corclough Ns",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F26RW94",
    "addressOne": "Corclogh West",
    "addressTwo": "Belmullet",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "54.2543703",
    "lng": "-10.0399952",
    "phone": "9782381",
    "email": "corcloughns2@eircom.net"
  },
  {
    "i": "2130",
    "county": "Mayo",
    "rollNumber": "15030Q",
    "schoolName": "St Marys NS",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.33",
    "spSNA": "0",
    "totalSNA": "2.33",
    "eircode": "F35X728",
    "addressOne": "Aghamore",
    "addressTwo": "Ballyhaunis",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.825906",
    "lng": "-8.8202698",
    "phone": "949367597",
    "email": "aghamorens.ias@gmail.com"
  },
  {
    "i": "2131",
    "county": "Mayo",
    "rollNumber": "15032U",
    "schoolName": "SN Muire Gan Smal",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F26HP11",
    "addressOne": "Ceathrú Thaidhg",
    "addressTwo": "Béal átha An Fheadha",
    "addressThree": "Co. Mhaigh Eo",
    "addressFour": "",
    "lat": "54.3115616",
    "lng": "-9.8185642",
    "phone": "9788953",
    "email": "sncheathruthaidhg@gmail.com"
  },
  {
    "i": "2132",
    "county": "Mayo",
    "rollNumber": "15113U",
    "schoolName": "SN Sheamais",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F12VF88",
    "addressOne": "Barnacogue",
    "addressTwo": "Swinford",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.9182695",
    "lng": "-8.8670968",
    "phone": "949367440",
    "email": "barnacoguens@gmail.com"
  },
  {
    "i": "2133",
    "county": "Mayo",
    "rollNumber": "15257V",
    "schoolName": "Quignamanger NS",
    "SETHours": "122.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.83",
    "spSNA": "0",
    "totalSNA": "4.83",
    "eircode": "F26YX95",
    "addressOne": "Creggs Road",
    "addressTwo": "Ballina",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "54.1317029",
    "lng": "-9.1305153",
    "phone": "9622842",
    "email": "quaynationalschool@gmail.com"
  },
  {
    "i": "2134",
    "county": "Mayo",
    "rollNumber": "15539I",
    "schoolName": "St Johns Ns",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F12FH94",
    "addressOne": "Logboy",
    "addressTwo": "Tulrahan",
    "addressThree": "Claremorris",
    "addressFour": "Co. Mayo",
    "lat": "53.7125003",
    "lng": "-8.7904948",
    "phone": "949646270",
    "email": "logboyschool.ias@eircom.net"
  },
  {
    "i": "2135",
    "county": "Mayo",
    "rollNumber": "15555G",
    "schoolName": "Scoil Cholmcille",
    "SETHours": "80",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F26RW32",
    "addressOne": "Breaffy",
    "addressTwo": "Ballina",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "54.0854301",
    "lng": "-9.1054032",
    "phone": "9622271",
    "email": "principal@breaffyns.com"
  },
  {
    "i": "2136",
    "county": "Mayo",
    "rollNumber": "15866A",
    "schoolName": "Carrakennedy NS",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "F28RF74",
    "addressOne": "Liscarney",
    "addressTwo": "Westport",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.7048049",
    "lng": "-9.5656603",
    "phone": "9821442",
    "email": "admin@carrakennedyns.com"
  },
  {
    "i": "2137",
    "county": "Mayo",
    "rollNumber": "15967G",
    "schoolName": "Crimlin NS",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F23V008",
    "addressOne": "Crimlin",
    "addressTwo": "Ross",
    "addressThree": "Castlebar",
    "addressFour": "",
    "lat": "53.9205089",
    "lng": "-9.2570527",
    "phone": "949025432",
    "email": "crimlinschool@gmail.com"
  },
  {
    "i": "2138",
    "county": "Mayo",
    "rollNumber": "15996N",
    "schoolName": "Rathbane NS",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "F26PC82",
    "addressOne": "Curraghmore",
    "addressTwo": "Ballina",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.984071",
    "lng": "-9.3239475",
    "phone": "9651182",
    "email": "principal@rathbanens.ie"
  },
  {
    "i": "2140",
    "county": "Mayo",
    "rollNumber": "16052I",
    "schoolName": "SN Naomh Padraig Saile",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F28Y229",
    "addressOne": "Sáile",
    "addressTwo": "Gob A Choire",
    "addressThree": "Acaill",
    "addressFour": "Co. Mhaigh Eo",
    "lat": "53.9502096",
    "lng": "-9.9431996",
    "phone": "9845767",
    "email": "scoilnaomhpadraigs@gmail.com"
  },
  {
    "i": "2141",
    "county": "Mayo",
    "rollNumber": "16113C",
    "schoolName": "Sn Toin Na Gaoithe",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.75",
    "spSNA": "0",
    "totalSNA": "1.75",
    "eircode": "F28R239",
    "addressOne": "Toin Ré Gaoith, Acaill,",
    "addressTwo": "Cathair Na Mart",
    "addressThree": "Co Mhaigh Eo",
    "addressFour": "",
    "lat": "53.9526834",
    "lng": "-9.8539994",
    "phone": "9845247",
    "email": "snthoinregaoith.ias@eircom.net"
  },
  {
    "i": "2142",
    "county": "Mayo",
    "rollNumber": "16122D",
    "schoolName": "Knock NS",
    "SETHours": "57.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "3",
    "spSNA": "4.66",
    "totalSNA": "7.66",
    "eircode": "F12KF89",
    "addressOne": "Knock",
    "addressTwo": "Claremorris",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.7925061",
    "lng": "-8.9244109",
    "phone": "949388435",
    "email": "admin@knockns.ie"
  },
  {
    "i": "2143",
    "county": "Mayo",
    "rollNumber": "16170O",
    "schoolName": "Cloghans NS",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F26A403",
    "addressOne": "Cloghans",
    "addressTwo": "Knockmore",
    "addressThree": "Ballina",
    "addressFour": "",
    "lat": "54.0570223",
    "lng": "-9.2138631",
    "phone": "949258245",
    "email": "cloghansnationalschool@gmail.com"
  },
  {
    "i": "2144",
    "county": "Mayo",
    "rollNumber": "16173U",
    "schoolName": "Kinaffe NS",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "F12FW71",
    "addressOne": "Kinaffe",
    "addressTwo": "Swinford",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.8980659",
    "lng": "-8.9767763",
    "phone": "949251031",
    "email": "kinaffe1915@gmail.com"
  },
  {
    "i": "2145",
    "county": "Mayo",
    "rollNumber": "16269K",
    "schoolName": "Killasser Ns",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F12AH68",
    "addressOne": "Killasser",
    "addressTwo": "Swinford",
    "addressThree": "Co Mayo",
    "addressFour": "",
    "lat": "53.9826647",
    "lng": "-8.958206",
    "phone": "949251489",
    "email": "killasserschool@gmail.com"
  },
  {
    "i": "2146",
    "county": "Mayo",
    "rollNumber": "16283E",
    "schoolName": "SN Pol A Tsomais",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F26WD26",
    "addressOne": "Pol A Tsomais",
    "addressTwo": "Béal An átha",
    "addressThree": "Co. Mhaigh Eo",
    "addressFour": "",
    "lat": "54.2651082",
    "lng": "-9.7977768",
    "phone": "9784573",
    "email": "pullathomasns@gmail.com"
  },
  {
    "i": "2147",
    "county": "Mayo",
    "rollNumber": "16289Q",
    "schoolName": "St Johns NS",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.25",
    "spSNA": "0",
    "totalSNA": "1.25",
    "eircode": "F12CX29",
    "addressOne": "Carrowmore",
    "addressTwo": "Swinford",
    "addressThree": "Co Mayo",
    "addressFour": "",
    "lat": "54.0000467",
    "lng": "-8.9798599",
    "phone": "719181435",
    "email": "carramorens.ias@eircom.net"
  },
  {
    "i": "2148",
    "county": "Mayo",
    "rollNumber": "16379R",
    "schoolName": "Valley NS",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "F28HY27",
    "addressOne": "Dugort",
    "addressTwo": "Achill",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "54.0079897",
    "lng": "-9.9766634",
    "phone": "9847303",
    "email": "valleysecretary18@gmail.com"
  },
  {
    "i": "2149",
    "county": "Mayo",
    "rollNumber": "16562I",
    "schoolName": "Knockanillo NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F26F867",
    "addressOne": "Ballina",
    "addressTwo": "Co Mayo",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.1327438",
    "lng": "-9.1950982",
    "phone": "9672128",
    "email": "knockanillons1918@gmail.com"
  },
  {
    "i": "2150",
    "county": "Mayo",
    "rollNumber": "16618J",
    "schoolName": "Myna NS",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F28R598",
    "addressOne": "Kilmeena",
    "addressTwo": "Westport",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.8421489",
    "lng": "-9.5731232",
    "phone": "9841361",
    "email": "officemynans@gmail.com"
  },
  {
    "i": "2151",
    "county": "Mayo",
    "rollNumber": "16756V",
    "schoolName": "SN Brighde",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F35PR29",
    "addressOne": "Tooreen",
    "addressTwo": "Ballyhaunis",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.8272694",
    "lng": "-8.7637521",
    "phone": "949649497",
    "email": "tooreenns@gmail.com"
  },
  {
    "i": "2152",
    "county": "Mayo",
    "rollNumber": "16780S",
    "schoolName": "Culmore NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F12YA37",
    "addressOne": "Swinford",
    "addressTwo": "Co Mayo",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.9531315",
    "lng": "-8.8925182",
    "phone": "949252038",
    "email": "culmorens@gmail.com"
  },
  {
    "i": "2153",
    "county": "Mayo",
    "rollNumber": "16811D",
    "schoolName": "Killala NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F26YX51",
    "addressOne": "Killala",
    "addressTwo": "Co. Mayo",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.2139116",
    "lng": "-9.2255815",
    "phone": "9632421",
    "email": "admin@stjosephsns.com"
  },
  {
    "i": "2154",
    "county": "Mayo",
    "rollNumber": "16832L",
    "schoolName": "Muirisc Ns",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "F28KD50",
    "addressOne": "Murrisk",
    "addressTwo": "Westport",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.7799232",
    "lng": "-9.6406053",
    "phone": "9864878",
    "email": "murriskns@gmail.com"
  },
  {
    "i": "2155",
    "county": "Mayo",
    "rollNumber": "16904K",
    "schoolName": "SN Lainn Cille",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F28V127",
    "addressOne": "Cathair Na Mart",
    "addressTwo": "Co Mayo",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.7566918",
    "lng": "-9.5111889",
    "phone": "9821272",
    "email": "ciaranhynes@lankillns.ie"
  },
  {
    "i": "2156",
    "county": "Mayo",
    "rollNumber": "16911H",
    "schoolName": "SN Leath Ardan",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.33",
    "spSNA": "0",
    "totalSNA": "1.33",
    "eircode": "F26XV34",
    "addressOne": "Beal Atha Na Fheadha",
    "addressTwo": "Co Mayo",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.0317041",
    "lng": "-9.3185063",
    "phone": "9651250",
    "email": "lahardanens@gmail.com"
  },
  {
    "i": "2157",
    "county": "Mayo",
    "rollNumber": "16984L",
    "schoolName": "SN Naomh Sheosamh",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.58",
    "spSNA": "0",
    "totalSNA": "2.58",
    "eircode": "H91D7DA",
    "addressOne": "Shrule",
    "addressTwo": "Co. Mayo",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.5244865",
    "lng": "-9.0913867",
    "phone": "9331221",
    "email": "theprincipal247@gmail.com"
  },
  {
    "i": "2158",
    "county": "Mayo",
    "rollNumber": "17039V",
    "schoolName": "SN Coill Mor",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F28NY07",
    "addressOne": "Drummin",
    "addressTwo": "Westport",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.6876967",
    "lng": "-9.6116681",
    "phone": "9821446",
    "email": "info@drumminns.ie"
  },
  {
    "i": "2159",
    "county": "Mayo",
    "rollNumber": "17082W",
    "schoolName": "Scoil Chomain Naofa",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F12TX04",
    "addressOne": "Roundfort",
    "addressTwo": "Hollymount",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.6387685",
    "lng": "-9.1056337",
    "phone": "949540177",
    "email": "roundfortns@gmail.com"
  },
  {
    "i": "2161",
    "county": "Mayo",
    "rollNumber": "17119T",
    "schoolName": "Scoil Naisiunta Balla Aluinn",
    "SETHours": "95",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.66",
    "spSNA": "0",
    "totalSNA": "3.66",
    "eircode": "F23W272",
    "addressOne": "Station Road",
    "addressTwo": "Balla",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.7990549",
    "lng": "-9.1295631",
    "phone": "949365280",
    "email": "ballanationalschool@gmail.com"
  },
  {
    "i": "2163",
    "county": "Mayo",
    "rollNumber": "17176I",
    "schoolName": "SN Realt Na Mara",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "F28F3F6",
    "addressOne": "Mulranny",
    "addressTwo": "Co Mayo",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.9056064",
    "lng": "-9.7889693",
    "phone": "9836283",
    "email": "realt.ias@eircom.net"
  },
  {
    "i": "2164",
    "county": "Mayo",
    "rollNumber": "17209U",
    "schoolName": "Cooneal NS",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "F26T659",
    "addressOne": "Cooneal",
    "addressTwo": "Ballina",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "54.1668798",
    "lng": "-9.2118153",
    "phone": "9632251",
    "email": "scoilcuanneal@gmail.com"
  },
  {
    "i": "2165",
    "county": "Mayo",
    "rollNumber": "17301I",
    "schoolName": "SN Teach Caoin",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F12H2V5",
    "addressOne": "Clar Cloinne Mhuiris",
    "addressTwo": "Co Mayo",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.7011661",
    "lng": "-9.0790206",
    "phone": "949362420",
    "email": "taugheenns@gmail.com"
  },
  {
    "i": "2166",
    "county": "Mayo",
    "rollNumber": "17321O",
    "schoolName": "SN An Coill Mhor",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "F28VF68",
    "addressOne": "Newport",
    "addressTwo": "Co. Mayo",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.8839557",
    "lng": "-9.4978578",
    "phone": "9841890",
    "email": "tracyhnl94@gmail.com"
  },
  {
    "i": "2167",
    "county": "Mayo",
    "rollNumber": "17482P",
    "schoolName": "Clogher Ns",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F12RC95",
    "addressOne": "Clogher",
    "addressTwo": "Claremorris",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.7602195",
    "lng": "-9.2274027",
    "phone": "949360316",
    "email": "principal@holyangelsns.ie"
  },
  {
    "i": "2168",
    "county": "Mayo",
    "rollNumber": "17483R",
    "schoolName": "Carraholly NS",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F28VX94",
    "addressOne": "Rusheen",
    "addressTwo": "Carrowholly",
    "addressThree": "Westport",
    "addressFour": "Co. Mayo",
    "lat": "53.8147011",
    "lng": "-9.5911961",
    "phone": "9839213",
    "email": "hollyns@eircom.net"
  },
  {
    "i": "2169",
    "county": "Mayo",
    "rollNumber": "17532E",
    "schoolName": "SN Druim Slaod",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.17",
    "spSNA": "0",
    "totalSNA": "1.17",
    "eircode": "F28PD70",
    "addressOne": "Cross Hill",
    "addressTwo": "Ballycroy",
    "addressThree": "Westport",
    "addressFour": "Co. Mayo",
    "lat": "54.0291298",
    "lng": "-9.8278798",
    "phone": "9849201",
    "email": "scoilnaomhbhride4@hotmail.com"
  },
  {
    "i": "2170",
    "county": "Mayo",
    "rollNumber": "17562N",
    "schoolName": "St Paul's NS",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "F23HX85",
    "addressOne": "Islandeady",
    "addressTwo": "Castlebar",
    "addressThree": "Co Mayo",
    "addressFour": "",
    "lat": "53.8186007",
    "lng": "-9.3866785",
    "phone": "949024630",
    "email": "stpaulsns@hotmail.com"
  },
  {
    "i": "2171",
    "county": "Mayo",
    "rollNumber": "17585C",
    "schoolName": "SN Beal Caradh",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F23ET38",
    "addressOne": "Belcarra",
    "addressTwo": "Castlebar",
    "addressThree": "Co Mayo",
    "addressFour": "",
    "lat": "53.805575",
    "lng": "-9.2179805",
    "phone": "949032210",
    "email": "belcarrans@outlook.com"
  },
  {
    "i": "2172",
    "county": "Mayo",
    "rollNumber": "17615I",
    "schoolName": "Sn Naomh Proinnsias",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "H91F6D8",
    "addressOne": "Kilroe",
    "addressTwo": "Ower",
    "addressThree": "Headford",
    "addressFour": "Co. Mayo",
    "lat": "53.4832325",
    "lng": "-9.176898",
    "phone": "9335231",
    "email": "kilroeschool@gmail.com"
  },
  {
    "i": "2173",
    "county": "Mayo",
    "rollNumber": "17678J",
    "schoolName": "SN Fiondalbha",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F23RY77",
    "addressOne": "Manulla",
    "addressTwo": "Castlebar",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.8329811",
    "lng": "-9.1840779",
    "phone": "949032010",
    "email": "info@manullans.ie"
  },
  {
    "i": "2174",
    "county": "Mayo",
    "rollNumber": "17682A",
    "schoolName": "SN Colm Naofa",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F28RR68",
    "addressOne": "Coggale",
    "addressTwo": "Westport",
    "addressThree": "Co Mayo",
    "addressFour": "",
    "lat": "53.8204266",
    "lng": "-9.4588293",
    "phone": "9826109",
    "email": "cogaulawestport.ias@eircom.net"
  },
  {
    "i": "2175",
    "county": "Mayo",
    "rollNumber": "17727T",
    "schoolName": "Sn Croi Muire",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F26H285",
    "addressOne": "Belmullet",
    "addressTwo": "Co. Mayo",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.2249154",
    "lng": "-9.9914051",
    "phone": "9782045",
    "email": "belmulletsnrns@gmail.com"
  },
  {
    "i": "2176",
    "county": "Mayo",
    "rollNumber": "17874J",
    "schoolName": "Glencorrib NS",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "H91NAV2",
    "addressOne": "Ballisnahyny",
    "addressTwo": "Shrule",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.5094043",
    "lng": "-9.1690813",
    "phone": "9331415",
    "email": "glencorribns@gmail.com"
  },
  {
    "i": "2178",
    "county": "Mayo",
    "rollNumber": "17923T",
    "schoolName": "SN Beal An Mhuirthead",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F26H285",
    "addressOne": "Pearse Street",
    "addressTwo": "Belmullet",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "54.2249154",
    "lng": "-9.9914051",
    "phone": "9782045",
    "email": "belmulletjns@gmail.com"
  },
  {
    "i": "2179",
    "county": "Mayo",
    "rollNumber": "18002D",
    "schoolName": "Drumgallagh NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "F28PP27",
    "addressOne": "Ballycroy",
    "addressTwo": "Westport",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.9838936",
    "lng": "-9.8209913",
    "phone": "9849147",
    "email": "snpdrumgallagh@gmail.com"
  },
  {
    "i": "2180",
    "county": "Mayo",
    "rollNumber": "18003F",
    "schoolName": "SN Athracht Nfa",
    "SETHours": "72.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "3.83",
    "spSNA": "6.32",
    "totalSNA": "10.15",
    "eircode": "F12T440",
    "addressOne": "Charlestown",
    "addressTwo": "Co. Mayo",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.9611679",
    "lng": "-8.7994497",
    "phone": "949254905",
    "email": "office@stattractasns.ie"
  },
  {
    "i": "2181",
    "county": "Mayo",
    "rollNumber": "18070U",
    "schoolName": "Scoil Mhuire Gan Smál",
    "SETHours": "122.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "F12XY16",
    "addressOne": "Claremount",
    "addressTwo": "Claremorris",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.7296917",
    "lng": "-9.0029185",
    "phone": "949371496",
    "email": "claremorrisscoil@eircom.net"
  },
  {
    "i": "2182",
    "county": "Mayo",
    "rollNumber": "18082E",
    "schoolName": "SN Dumhach",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F28AK54",
    "addressOne": "Dooagh",
    "addressTwo": "Achill",
    "addressThree": "Westport",
    "addressFour": "Co. Mayo",
    "lat": "53.9728648",
    "lng": "-10.1159013",
    "phone": "9843303",
    "email": "principal@dooaghns.ie"
  },
  {
    "i": "2183",
    "county": "Mayo",
    "rollNumber": "18145C",
    "schoolName": "Sn Nmh Treasa",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F35P650",
    "addressOne": "Swinford Road",
    "addressTwo": "Kilkelly",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.8740581",
    "lng": "-8.8544369",
    "phone": "949367371",
    "email": "kilkellyns.ias@eircom.net"
  },
  {
    "i": "2184",
    "county": "Mayo",
    "rollNumber": "18503C",
    "schoolName": "SN Naomh Brid C",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F23P903",
    "addressOne": "Oirreamh",
    "addressTwo": "Castlebar",
    "addressThree": "Co Mayo",
    "addressFour": "",
    "lat": "53.7961665",
    "lng": "-9.2641574",
    "phone": "949030615",
    "email": "principal.errew@gmail.com"
  },
  {
    "i": "2186",
    "county": "Mayo",
    "rollNumber": "18561Q",
    "schoolName": "St Joseph's Ns",
    "SETHours": "117.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "1",
    "spSNA": "6.49",
    "totalSNA": "7.49",
    "eircode": "F26XY33",
    "addressOne": "Rehins",
    "addressTwo": "Ballina",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "54.0876015",
    "lng": "-9.1672568",
    "phone": "9670093",
    "email": "principalrehins@gmail.com"
  },
  {
    "i": "2187",
    "county": "Mayo",
    "rollNumber": "18562S",
    "schoolName": "SN An Teaghlaigh",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "F23H322",
    "addressOne": "An Phairc",
    "addressTwo": "Turloch",
    "addressThree": "Caislean An Bharraigh",
    "addressFour": "Co Mayo",
    "lat": "53.9088013",
    "lng": "-9.1983681",
    "phone": "949031310",
    "email": "nsparke@gmail.com"
  },
  {
    "i": "2188",
    "county": "Mayo",
    "rollNumber": "18594I",
    "schoolName": "SN Achaidh An Ghlaisin",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F26X763",
    "addressOne": "Beal An Mhuirthead",
    "addressTwo": "Co Mhaigh Eo",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.2469061",
    "lng": "-9.9497519",
    "phone": "9782340",
    "email": "achaidhanghlaisin@gmail.com"
  },
  {
    "i": "2190",
    "county": "Mayo",
    "rollNumber": "18712L",
    "schoolName": "SN Cnoc Ruscaighe",
    "SETHours": "92.5",
    "spClassTeachingPosts": "4",
    "mainSNA": "2.34",
    "spSNA": "7.32",
    "totalSNA": "9.66",
    "eircode": "F28E129",
    "addressOne": "Knockrooskey",
    "addressTwo": "Westport",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.7824578",
    "lng": "-9.4438346",
    "phone": "9835276",
    "email": "knockrooskeyns@eircom.net"
  },
  {
    "i": "2192",
    "county": "Mayo",
    "rollNumber": "18848N",
    "schoolName": "SN Peadar Agus Pol",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F26E927",
    "addressOne": "Knockafall",
    "addressTwo": "Straide",
    "addressThree": "Foxford",
    "addressFour": "Co. Mayo",
    "lat": "53.929662",
    "lng": "-9.1262062",
    "phone": "949031267",
    "email": "info@straidens.ie"
  },
  {
    "i": "2193",
    "county": "Mayo",
    "rollNumber": "18876S",
    "schoolName": "Sn Baile Cuisin",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H54RK03",
    "addressOne": "Ballycushion",
    "addressTwo": "Kilconly",
    "addressThree": "Tuam",
    "addressFour": "Co. Galway",
    "lat": "53.5578288",
    "lng": "-9.0697585",
    "phone": "9333614",
    "email": "ballycushionns@gmail.com"
  },
  {
    "i": "2194",
    "county": "Mayo",
    "rollNumber": "18880J",
    "schoolName": "SN Gort Sceiche",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F12TF38",
    "addressOne": "Gortskehy",
    "addressTwo": "Hollymount",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.6313516",
    "lng": "-9.0283391",
    "phone": "949364301",
    "email": "eolas@gortskehy.com"
  },
  {
    "i": "2195",
    "county": "Mayo",
    "rollNumber": "18922W",
    "schoolName": "SN Chluain Luifin",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F31P206",
    "addressOne": "Cloonliffen",
    "addressTwo": "Ballinrobe",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.6135872",
    "lng": "-9.2738389",
    "phone": "949541539",
    "email": "eolas@cloonliffen.com"
  },
  {
    "i": "2196",
    "county": "Mayo",
    "rollNumber": "19324H",
    "schoolName": "SN Teaghlaigh Naofa",
    "SETHours": "30",
    "spClassTeachingPosts": "1",
    "mainSNA": "2.83",
    "spSNA": "2",
    "totalSNA": "4.83",
    "eircode": "F28X2D6",
    "addressOne": "Sn Teaghlaigh Naofa",
    "addressTwo": "Killeen",
    "addressThree": "Louisburgh Co Mayo",
    "addressFour": "",
    "lat": "53.7166489",
    "lng": "-9.87395",
    "phone": "9868651",
    "email": "killeenns2@gmail.com"
  },
  {
    "i": "2197",
    "county": "Mayo",
    "rollNumber": "19394F",
    "schoolName": "Robeen Central NS",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.25",
    "spSNA": "0",
    "totalSNA": "1.25",
    "eircode": "F12HP22",
    "addressOne": "Robeen",
    "addressTwo": "Hollymount",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.6811878",
    "lng": "-9.1493641",
    "phone": "949540262",
    "email": "robeenns01@gmail.com"
  },
  {
    "i": "2198",
    "county": "Mayo",
    "rollNumber": "19402B",
    "schoolName": "Ballyvary Central NS",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.33",
    "spSNA": "0",
    "totalSNA": "2.33",
    "eircode": "F23TP65",
    "addressOne": "Ballyvary Central NS",
    "addressTwo": "Castlebar",
    "addressThree": "Co Mayo",
    "addressFour": "",
    "lat": "53.8873465",
    "lng": "-9.1543442",
    "phone": "949031007",
    "email": "ballyvaryns@gmail.com"
  },
  {
    "i": "2199",
    "county": "Mayo",
    "rollNumber": "19451O",
    "schoolName": "Newport Central",
    "SETHours": "105",
    "spClassTeachingPosts": "3",
    "mainSNA": "3.34",
    "spSNA": "5.66",
    "totalSNA": "9",
    "eircode": "F28ED89",
    "addressOne": "Baile Ui Bhfiachain",
    "addressTwo": "Co Mhaigh Eo",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.887071",
    "lng": "-9.5432552",
    "phone": "9841442",
    "email": "office@newportns.ie"
  },
  {
    "i": "2200",
    "county": "Mayo",
    "rollNumber": "19488O",
    "schoolName": "Scoil Naomh Feichin",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "F26HH36",
    "addressOne": "Kilgellia",
    "addressTwo": "Attymass",
    "addressThree": "Ballina",
    "addressFour": "Co. Mayo",
    "lat": "54.050272",
    "lng": "-9.0828093",
    "phone": "9645076",
    "email": "office@attymassns.ie"
  },
  {
    "i": "2201",
    "county": "Mayo",
    "rollNumber": "19651W",
    "schoolName": "Carracastle Central Ns",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F45VK23",
    "addressOne": "Carracatsle",
    "addressTwo": "Ballaghadereen",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.9562689",
    "lng": "-8.7031024",
    "phone": "949255035",
    "email": "carracastlens@eircom.net"
  },
  {
    "i": "2202",
    "county": "Mayo",
    "rollNumber": "19710M",
    "schoolName": "Barnacarroll Central Ns",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.75",
    "spSNA": "0",
    "totalSNA": "1.75",
    "eircode": "F12D406",
    "addressOne": "Barnacarroll",
    "addressTwo": "Claremorris",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.7671017",
    "lng": "-8.9721133",
    "phone": "949388629",
    "email": "barnacarrollns@gmail.com"
  },
  {
    "i": "2203",
    "county": "Mayo",
    "rollNumber": "19776T",
    "schoolName": "Geesala Central School",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F26V677",
    "addressOne": "Geesala",
    "addressTwo": "Ballina",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "54.1140872",
    "lng": "-9.9026781",
    "phone": "9786625",
    "email": "geesalans.ias@eircom.net"
  },
  {
    "i": "2204",
    "county": "Mayo",
    "rollNumber": "19808G",
    "schoolName": "Tavrane Central Ns",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F35A461",
    "addressOne": "Kilkelly",
    "addressTwo": "Ballyhaunis",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.8782786",
    "lng": "-8.7764483",
    "phone": "858065834",
    "email": "tavranens@gmail.com"
  },
  {
    "i": "2205",
    "county": "Mayo",
    "rollNumber": "19812U",
    "schoolName": "Foxford Central Ns",
    "SETHours": "85",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "F26PX63",
    "addressOne": "Foxford",
    "addressTwo": "Co. Mayo",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.9800739",
    "lng": "-9.1096022",
    "phone": "949256391",
    "email": "foxfordns@gmail.com"
  },
  {
    "i": "2206",
    "county": "Mayo",
    "rollNumber": "19832D",
    "schoolName": "Scoil Raifteiri",
    "SETHours": "70",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "F23RC84",
    "addressOne": "Faiche An Aonaigh",
    "addressTwo": "Castlebar",
    "addressThree": "Caislean An Bharraigh",
    "addressFour": "Co Mhaigh Eo",
    "lat": "53.8584196",
    "lng": "-9.2905354",
    "phone": "949024700",
    "email": "raifteiri@gmail.com"
  },
  {
    "i": "2207",
    "county": "Mayo",
    "rollNumber": "19903A",
    "schoolName": "Kiltimagh Central",
    "SETHours": "107.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.83",
    "spSNA": "0",
    "totalSNA": "4.83",
    "eircode": "F12XY86",
    "addressOne": "Kiltimagh",
    "addressTwo": "Co Mayo",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.8457167",
    "lng": "-8.9967738",
    "phone": "949381679",
    "email": "scoilaodain@gmail.com"
  },
  {
    "i": "2208",
    "county": "Mayo",
    "rollNumber": "19911W",
    "schoolName": "St Patricks Central Ns",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "F31E199",
    "addressOne": "Kilmaine",
    "addressTwo": "Claremorris",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.582632",
    "lng": "-9.1224462",
    "phone": "9333535",
    "email": "kilmainens@gmail.com"
  },
  {
    "i": "2209",
    "county": "Mayo",
    "rollNumber": "19914F",
    "schoolName": "Scoil Naisiunta Thola",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "F12PR53",
    "addressOne": "Bohola",
    "addressTwo": "Claremorris",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.8999558",
    "lng": "-9.0590903",
    "phone": "949384271",
    "email": "boholaschool@gmail.com"
  },
  {
    "i": "2210",
    "county": "Mayo",
    "rollNumber": "19915H",
    "schoolName": "Claremorris Boys Ns",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F12Y996",
    "addressOne": "Kilcolman Road",
    "addressTwo": "Claremorris",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.7236203",
    "lng": "-8.9999159",
    "phone": "949371928",
    "email": "claremorrisbns@gmail.com"
  },
  {
    "i": "2211",
    "county": "Mayo",
    "rollNumber": "19916J",
    "schoolName": "St Peters Ns",
    "SETHours": "125",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.66",
    "spSNA": "0",
    "totalSNA": "5.66",
    "eircode": "F23XY33",
    "addressOne": "Snugboro",
    "addressTwo": "Castlebar",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.865093",
    "lng": "-9.329856",
    "phone": "949023079",
    "email": "snugboroschool@gmail.com"
  },
  {
    "i": "2212",
    "county": "Mayo",
    "rollNumber": "19951L",
    "schoolName": "Swinford Ns",
    "SETHours": "85",
    "spClassTeachingPosts": "1",
    "mainSNA": "2",
    "spSNA": "2",
    "totalSNA": "4",
    "eircode": "F12V050",
    "addressOne": "Station Road",
    "addressTwo": "Swinford",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.9434814",
    "lng": "-8.9529733",
    "phone": "949252055",
    "email": "swinfordps@gmail.com"
  },
  {
    "i": "2213",
    "county": "Mayo",
    "rollNumber": "19972T",
    "schoolName": "SN Uileog De Burca",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F12E201",
    "addressOne": "Lochán Na Mban",
    "addressTwo": "Clár Chlainne Mhuiris",
    "addressThree": "Co Maigh Eo",
    "addressFour": "",
    "lat": "53.7479612",
    "lng": "-8.9367209",
    "phone": "949362000",
    "email": "oifig@gaelscoildeburca.ie"
  },
  {
    "i": "2214",
    "county": "Mayo",
    "rollNumber": "20037L",
    "schoolName": "SN Padraig Naofa",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F28T189",
    "addressOne": "Louisburgh",
    "addressTwo": "Co. Mayo",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.7634087",
    "lng": "-9.8001972",
    "phone": "9866300",
    "email": "louisburghns.ias@eircom.net"
  },
  {
    "i": "2215",
    "county": "Mayo",
    "rollNumber": "20046M",
    "schoolName": "Gaelscoil Na Cruaiche",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F28R243",
    "addressOne": "Bóthar An Chúrsa Gailf",
    "addressTwo": "Cathair Na Mart",
    "addressThree": "Co. Mhaigh Eo",
    "addressFour": "",
    "lat": "53.8047915",
    "lng": "-9.5325449",
    "phone": "9828121",
    "email": "oifig@cruaiche.com"
  },
  {
    "i": "2216",
    "county": "Mayo",
    "rollNumber": "20084U",
    "schoolName": "Gaelscoil Na Gceithre Maol",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "F26N82Y",
    "addressOne": "Cearnóg An Mhargaidh",
    "addressTwo": "Béal An átha",
    "addressThree": "Co. Mhaigh Eo",
    "addressFour": "",
    "lat": "54.1161533",
    "lng": "-9.1563254",
    "phone": "9673828",
    "email": "scoilnagceithremaol@yahoo.ie"
  },
  {
    "i": "2217",
    "county": "Mayo",
    "rollNumber": "20089H",
    "schoolName": "St. Josephs N. S.",
    "SETHours": "167.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "4.83",
    "spSNA": "2.5",
    "totalSNA": "7.33",
    "eircode": "F31E406",
    "addressOne": "Convent Road",
    "addressTwo": "Ballinrobe",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.6227507",
    "lng": "-9.2160526",
    "phone": "949541464",
    "email": "ballinrobens@gmail.com"
  },
  {
    "i": "2218",
    "county": "Mayo",
    "rollNumber": "20125I",
    "schoolName": "Crossmolina NS",
    "SETHours": "85",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.75",
    "spSNA": "0",
    "totalSNA": "2.75",
    "eircode": "F26T224",
    "addressOne": "Crossmolina",
    "addressTwo": "Co. Mayo",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.0979487",
    "lng": "-9.318481",
    "phone": "9631768",
    "email": "cnsprincipal16@yahoo.com"
  },
  {
    "i": "2219",
    "county": "Mayo",
    "rollNumber": "20142I",
    "schoolName": "Scoil Iosa",
    "SETHours": "192.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "F35PX94",
    "addressOne": "Abbeyquarter",
    "addressTwo": "Ballyhaunis",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.7593557",
    "lng": "-8.7626283",
    "phone": "949630310",
    "email": "iosaballyhaunis@gmail.com"
  },
  {
    "i": "2220",
    "county": "Mayo",
    "rollNumber": "20217N",
    "schoolName": "Mount Palmer NS",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F26VW89",
    "addressOne": "Kincon",
    "addressTwo": "Kilfian",
    "addressThree": "Ballina",
    "addressFour": "Co. Mayo",
    "lat": "54.2045499",
    "lng": "-9.3060834",
    "phone": "9632225",
    "email": "mountpalmernats@gmail.com"
  },
  {
    "i": "2221",
    "county": "Mayo",
    "rollNumber": "20230F",
    "schoolName": "Scoil Phadraig",
    "SETHours": "188.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "8",
    "spSNA": "0",
    "totalSNA": "8",
    "eircode": "F28V023",
    "addressOne": "Newport Road",
    "addressTwo": "Westport",
    "addressThree": "Co Mayo",
    "addressFour": "",
    "lat": "53.8025621",
    "lng": "-9.522069",
    "phone": "9826027",
    "email": "info@spw.ie"
  },
  {
    "i": "2222",
    "county": "Mayo",
    "rollNumber": "20256A",
    "schoolName": "Scoil Náisiúnta Thuar Mhic éadaigh",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F12CD93",
    "addressOne": "Trianláir",
    "addressTwo": "Tuarmhicéadaigh",
    "addressThree": "Co. Mhaigh Eo",
    "addressFour": "",
    "lat": "53.6625378",
    "lng": "-9.354931",
    "phone": "949544088",
    "email": "snthuarmhiceadaigh@gmail.com"
  },
  {
    "i": "2223",
    "county": "Mayo",
    "rollNumber": "20275E",
    "schoolName": "Scoil í­osa",
    "SETHours": "213",
    "spClassTeachingPosts": "1",
    "mainSNA": "4.67",
    "spSNA": "0.33",
    "totalSNA": "5",
    "eircode": "F26F293",
    "addressOne": "Convent Hill",
    "addressTwo": "Ballina",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "54.1161861",
    "lng": "-9.1640655",
    "phone": "9670532",
    "email": "info@scoiliosaballina.ie"
  },
  {
    "i": "2224",
    "county": "Mayo",
    "rollNumber": "20431P",
    "schoolName": "Scoil Néifinn",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F26XR04",
    "addressOne": "Keenagh",
    "addressTwo": "Ballina",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "54.0444105",
    "lng": "-9.4701633",
    "phone": "9653160",
    "email": "scoilneifinn@outlook.com"
  },
  {
    "i": "2225",
    "county": "Mayo",
    "rollNumber": "20457K",
    "schoolName": "Castlebar Educate Together NS",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "F23FV59",
    "addressOne": "Marsh House",
    "addressTwo": "Newtown",
    "addressThree": "Castlebar",
    "addressFour": "Co. Mayo",
    "lat": "53.8569482",
    "lng": "-9.3019111",
    "phone": "949044726",
    "email": "secretary@castlebaretns.ie"
  },
  {
    "i": "2226",
    "county": "Mayo",
    "rollNumber": "20499D",
    "schoolName": "St Mary's NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F12X032",
    "addressOne": "Partry",
    "addressTwo": "Claremorris",
    "addressThree": "Co. Mayo",
    "addressFour": "",
    "lat": "53.6946392",
    "lng": "-9.2774654",
    "phone": "949543060",
    "email": "partryns@yahoo.ie"
  },
  {
    "i": "2227",
    "county": "Mayo",
    "rollNumber": "20510L",
    "schoolName": "Westport Educate Together NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F28CD82",
    "addressOne": "C/o Sharkey Hill Community Centre",
    "addressTwo": "Páirc Na Coille",
    "addressThree": "Westport",
    "addressFour": "Co. Mayo",
    "lat": "53.8036981",
    "lng": "-9.5307773",
    "phone": "861422822",
    "email": "westport.etns@gmail.com"
  },
  {
    "i": "2228",
    "county": "Mayo",
    "rollNumber": "20512P",
    "schoolName": "Lacken NS",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F26A240",
    "addressOne": "Carrowomre-lacken",
    "addressTwo": "Ballina",
    "addressThree": "Co Mayo",
    "addressFour": "",
    "lat": "54.2643293",
    "lng": "-9.2266013",
    "phone": "9634589",
    "email": "lackenns2018@gmail.com"
  },
  {
    "i": "2229",
    "county": "Mayo",
    "rollNumber": "20513R",
    "schoolName": "Kilmurry Ns",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "F26V489",
    "addressOne": "Crossmolina",
    "addressTwo": "Co. Mayo",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.0782239",
    "lng": "-9.3734207",
    "phone": "9631812",
    "email": "kilmurryns2018@gmail.com"
  },
  {
    "i": "2230",
    "county": "Meath",
    "rollNumber": "00883P",
    "schoolName": "Aine Naofa NS",
    "SETHours": "105",
    "spClassTeachingPosts": "1",
    "mainSNA": "2",
    "spSNA": "0.33",
    "totalSNA": "2.33",
    "eircode": "C15E208",
    "addressOne": "Fairgreen",
    "addressTwo": "Navan",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.6511151",
    "lng": "-6.685878",
    "phone": "469023039",
    "email": "office@stannesnavan.ie"
  },
  {
    "i": "2231",
    "county": "Meath",
    "rollNumber": "00885T",
    "schoolName": "Ratoath Jn NS",
    "SETHours": "115",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "A85P296",
    "addressOne": "Fairyhouse Road",
    "addressTwo": "Ratoath",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.5031013",
    "lng": "-6.4663906",
    "phone": "18256639",
    "email": "office@ratoathjuniorns.ie"
  },
  {
    "i": "2232",
    "county": "Meath",
    "rollNumber": "01309L",
    "schoolName": "Stackallen NS",
    "SETHours": "65",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "C15Y104",
    "addressOne": "Stackallen",
    "addressTwo": "Navan",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.7106377",
    "lng": "-6.6211168",
    "phone": "469024207",
    "email": "info@stackallenschool.com"
  },
  {
    "i": "2233",
    "county": "Meath",
    "rollNumber": "01421F",
    "schoolName": "Kilskyre Mixed NS",
    "SETHours": "0",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "A82DH22",
    "addressOne": "Kilskyre",
    "addressTwo": "Kells",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.6939282",
    "lng": "-6.9960512",
    "phone": "469243947",
    "email": "kilskyrens@gmail.com"
  },
  {
    "i": "2234",
    "county": "Meath",
    "rollNumber": "02905J",
    "schoolName": "SN Naomh Padraig",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "A83F863",
    "addressOne": "Baconstown",
    "addressTwo": "Enfield",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.4442083",
    "lng": "-6.803181",
    "phone": "469541115",
    "email": "baconstownns@gmail.com"
  },
  {
    "i": "2235",
    "county": "Meath",
    "rollNumber": "03275H",
    "schoolName": "Newtown NS",
    "SETHours": "32.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "1",
    "spSNA": "1.83",
    "totalSNA": "2.83",
    "eircode": "A92PW80",
    "addressOne": "Newtown",
    "addressTwo": "Ardee",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.8203007",
    "lng": "-6.6079892",
    "phone": "469053322",
    "email": "newtownnsardee92@gmail.com"
  },
  {
    "i": "2236",
    "county": "Meath",
    "rollNumber": "04210H",
    "schoolName": "Kilmessan Mxd NS",
    "SETHours": "90",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "C15TE28",
    "addressOne": "Kilmessan",
    "addressTwo": "Co. Meath",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.560613",
    "lng": "-6.6633277",
    "phone": "469025532",
    "email": "info@kilmessanns.ie"
  },
  {
    "i": "2237",
    "county": "Meath",
    "rollNumber": "05062A",
    "schoolName": "Kells Parochial NS",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "A82RK49",
    "addressOne": "Navan Road",
    "addressTwo": "Kells",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.7246742",
    "lng": "-6.8671921",
    "phone": "469241308",
    "email": "kellsparochialns@gmail.com"
  },
  {
    "i": "2238",
    "county": "Meath",
    "rollNumber": "05630L",
    "schoolName": "Scoil Mhichil Na Buachailli",
    "SETHours": "135",
    "spClassTeachingPosts": "6",
    "mainSNA": "3",
    "spSNA": "17.32",
    "totalSNA": "20.32",
    "eircode": "C15FK19",
    "addressOne": "Patrick Street",
    "addressTwo": "Trim",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.5513002",
    "lng": "-6.7918515",
    "phone": "469431813",
    "email": "scoilmhichil@gmail.com"
  },
  {
    "i": "2239",
    "county": "Meath",
    "rollNumber": "07120V",
    "schoolName": "Killyon NS",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "A83XW44",
    "addressOne": "Hill Of Down",
    "addressTwo": "Co. Meath",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.4860244",
    "lng": "-7.0024334",
    "phone": "469546532",
    "email": "school@killyonns.com"
  },
  {
    "i": "2240",
    "county": "Meath",
    "rollNumber": "09238I",
    "schoolName": "Ballinlough NS",
    "SETHours": "0",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "A82PX57",
    "addressOne": "Ballinlough",
    "addressTwo": "Kells",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.7320179",
    "lng": "-7.0285504",
    "phone": "469243965",
    "email": "nsballinlough@gmail.com"
  },
  {
    "i": "2241",
    "county": "Meath",
    "rollNumber": "10801Q",
    "schoolName": "Drumbarragh NS",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "A82NP98",
    "addressOne": "Drumbaragh",
    "addressTwo": "Kells",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.7261408",
    "lng": "-6.9407214",
    "phone": "469249605",
    "email": "drumbaraghns1@gmail.com"
  },
  {
    "i": "2242",
    "county": "Meath",
    "rollNumber": "11039O",
    "schoolName": "Kilbeg NS",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "A82T657",
    "addressOne": "Kilbeg",
    "addressTwo": "Thomastown",
    "addressThree": "Carlanstown",
    "addressFour": "Co. Meath",
    "lat": "53.7910711",
    "lng": "-6.8030444",
    "phone": "469246603",
    "email": "kilbegschool@gmail.com"
  },
  {
    "i": "2243",
    "county": "Meath",
    "rollNumber": "11978O",
    "schoolName": "Scoil Mhuire Ns",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "A82YF90",
    "addressOne": "Moylagh",
    "addressTwo": "Oldcastle",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.7189532",
    "lng": "-7.1722349",
    "phone": "498541738",
    "email": "office@moylaghns.com"
  },
  {
    "i": "2244",
    "county": "Meath",
    "rollNumber": "12068D",
    "schoolName": "Our Lady Of Mercy Ns",
    "SETHours": "127.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.66",
    "spSNA": "0",
    "totalSNA": "2.66",
    "eircode": "A82X571",
    "addressOne": "Jim Brunnock Road",
    "addressTwo": "Kells",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.7248824",
    "lng": "-6.8693453",
    "phone": "469240446",
    "email": "office@mercypskells.scoilnet.ie"
  },
  {
    "i": "2245",
    "county": "Meath",
    "rollNumber": "12488C",
    "schoolName": "Gilson NS",
    "SETHours": "87.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "A82E400",
    "addressOne": "Chapel Street",
    "addressTwo": "Oldcastle",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.7691096",
    "lng": "-7.1581037",
    "phone": "498541327",
    "email": "gilsonprimary@gmail.com"
  },
  {
    "i": "2246",
    "county": "Meath",
    "rollNumber": "12788O",
    "schoolName": "Flowerfield NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "C15XV20",
    "addressOne": "Trim Road",
    "addressTwo": "Navan",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.6460299",
    "lng": "-6.6860176",
    "phone": "469021239",
    "email": "oebarn@gmail.com"
  },
  {
    "i": "2247",
    "county": "Meath",
    "rollNumber": "12897T",
    "schoolName": "Ughtyneill NS",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "A82VW95",
    "addressOne": "Ughtyneill",
    "addressTwo": "Moynalty",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.8259903",
    "lng": "-6.8791287",
    "phone": "469244704",
    "email": "secretary@ughtyneillns.com"
  },
  {
    "i": "2248",
    "county": "Meath",
    "rollNumber": "13775K",
    "schoolName": "St Patricks NS",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "C15X285",
    "addressOne": "St Loman's Street",
    "addressTwo": "Trim",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.5589491",
    "lng": "-6.7920331",
    "phone": "469431892",
    "email": "stpatricksnstrim@hotmail.com"
  },
  {
    "i": "2249",
    "county": "Meath",
    "rollNumber": "14348T",
    "schoolName": "Carrickleck NS",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "A82XK71",
    "addressOne": "Carrickleck",
    "addressTwo": "Kingscourt",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.8745329",
    "lng": "-6.7643913",
    "phone": "429667746",
    "email": "jackieward1602@gmail.com"
  },
  {
    "i": "2250",
    "county": "Meath",
    "rollNumber": "15104T",
    "schoolName": "Scoil Bhrí­de",
    "SETHours": "142.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "C15CX61",
    "addressOne": "Cannistown",
    "addressTwo": "Navan",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.6216509",
    "lng": "-6.6659399",
    "phone": "469029779",
    "email": "principal.cannistown@gmail.com"
  },
  {
    "i": "2251",
    "county": "Meath",
    "rollNumber": "15483H",
    "schoolName": "St Louis NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "C15PH60",
    "addressOne": "Rathkenny",
    "addressTwo": "Navan",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.7416531",
    "lng": "-6.6541448",
    "phone": "469054417",
    "email": "rathkennyschool@gmail.com"
  },
  {
    "i": "2252",
    "county": "Meath",
    "rollNumber": "16067V",
    "schoolName": "Scoil Nais Finin Naofa",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "A83TY71",
    "addressOne": "Clonard",
    "addressTwo": "Enfield",
    "addressThree": "Co Meath",
    "addressFour": "",
    "lat": "53.4519925",
    "lng": "-7.0242501",
    "phone": "449375551",
    "email": "stfiniansns@yahoo.ie"
  },
  {
    "i": "2253",
    "county": "Meath",
    "rollNumber": "16100Q",
    "schoolName": "Mercy Convent NS",
    "SETHours": "175",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.66",
    "spSNA": "0",
    "totalSNA": "1.66",
    "eircode": "C15EA40",
    "addressOne": "Railway Street",
    "addressTwo": "Navan",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.6503292",
    "lng": "-6.6876632",
    "phone": "469021989",
    "email": "jomerps@iol.ie"
  },
  {
    "i": "2254",
    "county": "Meath",
    "rollNumber": "16143L",
    "schoolName": "SN Pheadair Agus Phoil",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "C15TX05",
    "addressOne": "Drumconrath",
    "addressTwo": "Navan",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.853037",
    "lng": "-6.6593469",
    "phone": "416854178",
    "email": "drumconrathns@yahoo.ie"
  },
  {
    "i": "2255",
    "county": "Meath",
    "rollNumber": "16549Q",
    "schoolName": "Scoil Naoimh Pio",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "C15X959",
    "addressOne": "Knockcommon",
    "addressTwo": "Beauparc",
    "addressThree": "Co Meath",
    "addressFour": "",
    "lat": "53.668213",
    "lng": "-6.4994319",
    "phone": "419825123",
    "email": "snpnsmail@gmail.com"
  },
  {
    "i": "2256",
    "county": "Meath",
    "rollNumber": "16646O",
    "schoolName": "St Marys Convent NS",
    "SETHours": "200",
    "spClassTeachingPosts": "3",
    "mainSNA": "4.5",
    "spSNA": "1.66",
    "totalSNA": "6.16",
    "eircode": "C15WF98",
    "addressOne": "Patrick Street",
    "addressTwo": "Trim",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.5512148",
    "lng": "-6.7925806",
    "phone": "469431919",
    "email": "office@stmarystrim.ie"
  },
  {
    "i": "2257",
    "county": "Meath",
    "rollNumber": "16655P",
    "schoolName": "St. Nicholas Primary School",
    "SETHours": "130",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.5",
    "spSNA": "0",
    "totalSNA": "4.5",
    "eircode": "A83K889",
    "addressOne": "Longwood",
    "addressTwo": "Co. Meath",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.4529224",
    "lng": "-6.919875",
    "phone": "469555384",
    "email": "info@stnicholasprimaryschool.com"
  },
  {
    "i": "2258",
    "county": "Meath",
    "rollNumber": "16722E",
    "schoolName": "Scoil Cholmcille",
    "SETHours": "167.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "A82FF86",
    "addressOne": "Jim Brunnock Road",
    "addressTwo": "Kells",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.724079",
    "lng": "-6.8698091",
    "phone": "469240498",
    "email": "colmcille.ias@eircom.net"
  },
  {
    "i": "2259",
    "county": "Meath",
    "rollNumber": "16774A",
    "schoolName": "Scoil Eoin Báiste",
    "SETHours": "0",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "A82YD58",
    "addressOne": "Nobber",
    "addressTwo": "Kells",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.8226016",
    "lng": "-6.7466534",
    "phone": "469052000",
    "email": "nobberns@gmail.com"
  },
  {
    "i": "2260",
    "county": "Meath",
    "rollNumber": "16790V",
    "schoolName": "SN Naomh Seosamh",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "C15P304",
    "addressOne": "St. Joseph's NS",
    "addressTwo": "Dunsany",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.5440453",
    "lng": "-6.6174645",
    "phone": "469025058",
    "email": "dunsanyns@gmail.com"
  },
  {
    "i": "2261",
    "county": "Meath",
    "rollNumber": "16825O",
    "schoolName": "Kilbride NS",
    "SETHours": "150",
    "spClassTeachingPosts": "2",
    "mainSNA": "2.5",
    "spSNA": "6",
    "totalSNA": "8.5",
    "eircode": "D15XA32",
    "addressOne": "Kilbride",
    "addressTwo": "Clonee",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.4503014",
    "lng": "-6.3941049",
    "phone": "18216359",
    "email": "info@scoilbhridens.ie"
  },
  {
    "i": "2262",
    "county": "Meath",
    "rollNumber": "16991I",
    "schoolName": "Carnaross NS",
    "SETHours": "62.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "A82H316",
    "addressOne": "Carnaross",
    "addressTwo": "Co. Meath",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.7506753",
    "lng": "-6.9545508",
    "phone": "469245598",
    "email": "office@carnarossns.ie"
  },
  {
    "i": "2263",
    "county": "Meath",
    "rollNumber": "17029S",
    "schoolName": "SN Naomh Cianain",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "A84RY80",
    "addressOne": "Cushenstown",
    "addressTwo": "Ashbourne",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.5743309",
    "lng": "-6.4454961",
    "phone": "18354215",
    "email": "snbailechuisin.ias@eircom.net"
  },
  {
    "i": "2264",
    "county": "Meath",
    "rollNumber": "17088L",
    "schoolName": "Scoil Í­ Ghramhnaigh",
    "SETHours": "80",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "C15WT18",
    "addressOne": "Ráth Chairn",
    "addressTwo": "áth BÍ­",
    "addressThree": "Co.na Mí­",
    "addressFour": "",
    "lat": "53.6146122",
    "lng": "-6.8607754",
    "phone": "469432837",
    "email": "bunscoilrathchairn@gmail.com"
  },
  {
    "i": "2265",
    "county": "Meath",
    "rollNumber": "17123K",
    "schoolName": "Kilmainham Wood NS",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "A82TY77",
    "addressOne": "Kilmainham Wood",
    "addressTwo": "Kells",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.8474658",
    "lng": "-6.8053601",
    "phone": "469052666",
    "email": "kwoodns.ias@hotmail.com"
  },
  {
    "i": "2266",
    "county": "Meath",
    "rollNumber": "17162U",
    "schoolName": "SN Bhrighde",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.66",
    "spSNA": "0",
    "totalSNA": "1.66",
    "eircode": "A82VX38",
    "addressOne": "Cortown",
    "addressTwo": "Kells",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.684813",
    "lng": "-6.8544158",
    "phone": "469249700",
    "email": "info@cortownns.ie"
  },
  {
    "i": "2267",
    "county": "Meath",
    "rollNumber": "17175G",
    "schoolName": "Bohermeen NS",
    "SETHours": "0",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "C15XF70",
    "addressOne": "Bohermeen Ns",
    "addressTwo": "Navan",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.6536544",
    "lng": "-6.789544",
    "phone": "469029037",
    "email": "ultansns@gmail.com"
  },
  {
    "i": "2268",
    "county": "Meath",
    "rollNumber": "17203I",
    "schoolName": "SN Ultain Naofa",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "C15PD95",
    "addressOne": "Baile Ghib",
    "addressTwo": "An Uaimh",
    "addressThree": "Co. Na Mí­",
    "addressFour": "",
    "lat": "53.7085822",
    "lng": "-6.7494219",
    "phone": "469054499",
    "email": "scoilultain.ias@eircom.net"
  },
  {
    "i": "2269",
    "county": "Meath",
    "rollNumber": "17213L",
    "schoolName": "SN Mhuire",
    "SETHours": "42.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "1",
    "spSNA": "2.66",
    "totalSNA": "3.66",
    "eircode": "A82YV20",
    "addressOne": "Ma Nealta",
    "addressTwo": "Ceannanus Mor",
    "addressThree": "Co Na Midhe",
    "addressFour": "",
    "lat": "53.7936724",
    "lng": "-6.8973728",
    "phone": "469244702",
    "email": "info@moynaltyns.ie"
  },
  {
    "i": "2270",
    "county": "Meath",
    "rollNumber": "17220I",
    "schoolName": "SN Bhrighde",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "C15H274",
    "addressOne": "Meath Hill",
    "addressTwo": "Drumconrath",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.8858604",
    "lng": "-6.7259106",
    "phone": "429667819",
    "email": "meathhillns7@gmail.com"
  },
  {
    "i": "2271",
    "county": "Meath",
    "rollNumber": "17312N",
    "schoolName": "SN Cul An Mhuilinn",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "A85D212",
    "addressOne": "Culmullen",
    "addressTwo": "Drumree",
    "addressThree": "Co Meath",
    "addressFour": "",
    "lat": "53.4897039",
    "lng": "-6.6063604",
    "phone": "18259883",
    "email": "culmullenschool@gmail.com"
  },
  {
    "i": "2272",
    "county": "Meath",
    "rollNumber": "17480L",
    "schoolName": "SN Baile Cheant",
    "SETHours": "75",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "C15YK73",
    "addressOne": "Kentstown",
    "addressTwo": "Navan",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.6330972",
    "lng": "-6.5240726",
    "phone": "419825458",
    "email": "kentstownschool@gmail.com"
  },
  {
    "i": "2273",
    "county": "Meath",
    "rollNumber": "17494W",
    "schoolName": "SN An Rath Mhor",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "C15X525",
    "addressOne": "Rathmore",
    "addressTwo": "Athboy",
    "addressThree": "Co Meath",
    "addressFour": "",
    "lat": "53.6461451",
    "lng": "-6.8621283",
    "phone": "469432359",
    "email": "nsrathmore@gmail.com"
  },
  {
    "i": "2274",
    "county": "Meath",
    "rollNumber": "17513A",
    "schoolName": "SN Cill Bhrighde",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "C15EK88",
    "addressOne": "Kilbride",
    "addressTwo": "Trim",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.5930735",
    "lng": "-6.820367",
    "phone": "469431945",
    "email": "info@kilbridenstrim.ie"
  },
  {
    "i": "2275",
    "county": "Meath",
    "rollNumber": "17520U",
    "schoolName": "SN Mhuire",
    "SETHours": "62.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "C15YK66",
    "addressOne": "Robinstown",
    "addressTwo": "Navan",
    "addressThree": "Co Meath",
    "addressFour": "",
    "lat": "53.5936686",
    "lng": "-6.7285589",
    "phone": "469029583",
    "email": "office@robinstownns.com"
  },
  {
    "i": "2276",
    "county": "Meath",
    "rollNumber": "17521W",
    "schoolName": "SN Colmcille",
    "SETHours": "62.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "C15NV99",
    "addressOne": "Skryne",
    "addressTwo": "Tara",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.5751087",
    "lng": "-6.5569149",
    "phone": "469025003",
    "email": "skryne.n.s@gmail.com"
  },
  {
    "i": "2277",
    "county": "Meath",
    "rollNumber": "17560J",
    "schoolName": "SN Seosamh Naomtha",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "C15HH63",
    "addressOne": "Dunderry",
    "addressTwo": "Navan",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.607713",
    "lng": "-6.7740484",
    "phone": "469431976",
    "email": "dunderryns@gmail.com"
  },
  {
    "i": "2278",
    "county": "Meath",
    "rollNumber": "17623H",
    "schoolName": "O'growney NS",
    "SETHours": "140",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "C15W2VN",
    "addressOne": "Town Parks",
    "addressTwo": "Athboy",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.620449",
    "lng": "-6.92456",
    "phone": "469432291",
    "email": "office@ogrowneyns.ie"
  },
  {
    "i": "2279",
    "county": "Meath",
    "rollNumber": "17629T",
    "schoolName": "SN Padraig Naofa",
    "SETHours": "32.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "0",
    "spSNA": "5",
    "totalSNA": "5",
    "eircode": "A42WR12",
    "addressOne": "Ardcath",
    "addressTwo": "Garristown",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.6066619",
    "lng": "-6.3904336",
    "phone": "18354043",
    "email": "info@ardcathns.ie"
  },
  {
    "i": "2280",
    "county": "Meath",
    "rollNumber": "17652O",
    "schoolName": "Scoil Oilibheir Naofa",
    "SETHours": "82.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "A85NH30",
    "addressOne": "Kilcloon",
    "addressTwo": "Co. Meath",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.4260118",
    "lng": "-6.5803662",
    "phone": "16285816",
    "email": "principal.kilcloon@gmail.com"
  },
  {
    "i": "2281",
    "county": "Meath",
    "rollNumber": "17705J",
    "schoolName": "SN Cros Ban",
    "SETHours": "125",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "A92W291",
    "addressOne": "Whitecross",
    "addressTwo": "Julianstown",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.6680901",
    "lng": "-6.2778736",
    "phone": "419829229",
    "email": "whitecrossns@gmail.com"
  },
  {
    "i": "2282",
    "county": "Meath",
    "rollNumber": "17741N",
    "schoolName": "Scoil Nais Aitinn Bhui",
    "SETHours": "75",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "C15X535",
    "addressOne": "Beauparc",
    "addressTwo": "Navan",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.671662",
    "lng": "-6.5705172",
    "phone": "469024434",
    "email": "principal@yellowfurzens.ie"
  },
  {
    "i": "2283",
    "county": "Meath",
    "rollNumber": "17742P",
    "schoolName": "Scoil Nais Mhuire Naofa",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "C15XF86",
    "addressOne": "Kiltale",
    "addressTwo": "Dunsany",
    "addressThree": "Co Meath",
    "addressFour": "",
    "lat": "53.5243771",
    "lng": "-6.6728621",
    "phone": "469025619",
    "email": "kiltalens@gmail.com"
  },
  {
    "i": "2284",
    "county": "Meath",
    "rollNumber": "17821L",
    "schoolName": "St. Mary's Primary School",
    "SETHours": "210",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "A83X316",
    "addressOne": "Johnstown Road",
    "addressTwo": "Enfield",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.4135407",
    "lng": "-6.8322243",
    "phone": "469541949",
    "email": "enda.flynn@eircom.net"
  },
  {
    "i": "2285",
    "county": "Meath",
    "rollNumber": "17839H",
    "schoolName": "SN Bheinn Naofa B",
    "SETHours": "197.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "3.83",
    "spSNA": "4",
    "totalSNA": "7.83",
    "eircode": "A92C903",
    "addressOne": "Duleek",
    "addressTwo": "Co. Meath",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.6467254",
    "lng": "-6.4240355",
    "phone": "419823539",
    "email": "duleekboysns@gmail.com"
  },
  {
    "i": "2286",
    "county": "Meath",
    "rollNumber": "17840P",
    "schoolName": "SN Bheinin Naofa C",
    "SETHours": "108",
    "spClassTeachingPosts": "2",
    "mainSNA": "1",
    "spSNA": "4",
    "totalSNA": "5",
    "eircode": "A92W722",
    "addressOne": "Duleek",
    "addressTwo": "Co. Meath",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.6467254",
    "lng": "-6.4240355",
    "phone": "419823632",
    "email": "duleekgirls2009@gmail.com"
  },
  {
    "i": "2287",
    "county": "Meath",
    "rollNumber": "17856H",
    "schoolName": "SN Dun Uabhair",
    "SETHours": "62.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "A92A568",
    "addressOne": "Donore",
    "addressTwo": "Drogheda",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.6913406",
    "lng": "-6.4175393",
    "phone": "419880118",
    "email": "donorenat.sch@gmail.com"
  },
  {
    "i": "2288",
    "county": "Meath",
    "rollNumber": "17857J",
    "schoolName": "SN Aindreis Naofa",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "A84DF89",
    "addressOne": "Curragha",
    "addressTwo": "Ashbourne",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.5377568",
    "lng": "-6.4431314",
    "phone": "18351528",
    "email": "office@standrewscurragha.com"
  },
  {
    "i": "2289",
    "county": "Meath",
    "rollNumber": "17930Q",
    "schoolName": "SN Seachnaill Naofa",
    "SETHours": "202.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.16",
    "spSNA": "0",
    "totalSNA": "4.16",
    "eircode": "A85R262",
    "addressOne": "Main Street",
    "addressTwo": "Dunshaughlin",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.5090163",
    "lng": "-6.540441",
    "phone": "18259679",
    "email": "info@stseachnalls.ie"
  },
  {
    "i": "2290",
    "county": "Meath",
    "rollNumber": "17946I",
    "schoolName": "Scoil Nais Naomh Aine",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "A82AP80",
    "addressOne": "Maio",
    "addressTwo": "Tierworker",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.8510661",
    "lng": "-6.9144793",
    "phone": "469242325",
    "email": "maio.ias@eircom.net"
  },
  {
    "i": "2291",
    "county": "Meath",
    "rollNumber": "17947K",
    "schoolName": "Scoil Naomh Bride",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "C15TP62",
    "addressOne": "Batterstown",
    "addressTwo": "Trim",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.5123894",
    "lng": "-6.8761866",
    "phone": "469546358",
    "email": "boardsmillns@gmail.com"
  },
  {
    "i": "2292",
    "county": "Meath",
    "rollNumber": "17964K",
    "schoolName": "SN Mhuire Naofa",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "C15F220",
    "addressOne": "Rathfeigh",
    "addressTwo": "Tara",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.5899862",
    "lng": "-6.5017038",
    "phone": "419825156",
    "email": "snrathfaiche1@eircom.net"
  },
  {
    "i": "2293",
    "county": "Meath",
    "rollNumber": "17969U",
    "schoolName": "SN Mhuire",
    "SETHours": "95",
    "spClassTeachingPosts": "2",
    "mainSNA": "1.83",
    "spSNA": "4",
    "totalSNA": "5.83",
    "eircode": "C15DA09",
    "addressOne": "Abbey Road",
    "addressTwo": "Navan",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.6541461",
    "lng": "-6.6911133",
    "phone": "469021483",
    "email": "scoilmhuirenavan@gmail.com"
  },
  {
    "i": "2294",
    "county": "Meath",
    "rollNumber": "17986U",
    "schoolName": "SN Nmh Sheosamh",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "C15WT26",
    "addressOne": "Boyerstown",
    "addressTwo": "Navan",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.6344699",
    "lng": "-6.7513358",
    "phone": "469027252",
    "email": "boyerstownns@gmail.com"
  },
  {
    "i": "2295",
    "county": "Meath",
    "rollNumber": "18016O",
    "schoolName": "SN Columbain",
    "SETHours": "132.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "1.83",
    "spSNA": "2",
    "totalSNA": "3.83",
    "eircode": "C15AE33",
    "addressOne": "Mullingar Road",
    "addressTwo": "Ballivor",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.5336863",
    "lng": "-6.9720671",
    "phone": "469546213",
    "email": "baileiomhair.ias@eircom.net"
  },
  {
    "i": "2296",
    "county": "Meath",
    "rollNumber": "18037W",
    "schoolName": "SN Mhuire",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "C15CF59",
    "addressOne": "Heronstown",
    "addressTwo": "Lobinstown",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.7820211",
    "lng": "-6.6228691",
    "phone": "469053297",
    "email": "scoilmhuireheronstown@gmail.com"
  },
  {
    "i": "2297",
    "county": "Meath",
    "rollNumber": "18040L",
    "schoolName": "SN Naomh Padraig",
    "SETHours": "87.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "C15NX78",
    "addressOne": "Collon Road",
    "addressTwo": "Slane",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.7130717",
    "lng": "-6.5378244",
    "phone": "419824229",
    "email": "office@slanens.ie"
  },
  {
    "i": "2298",
    "county": "Meath",
    "rollNumber": "18044T",
    "schoolName": "SN Naomh Padraig",
    "SETHours": "182.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "K32KR96",
    "addressOne": "Cockhill Road",
    "addressTwo": "Stamullen",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.6318307",
    "lng": "-6.2642901",
    "phone": "18411804",
    "email": "info@stamullenns.ie"
  },
  {
    "i": "2299",
    "county": "Meath",
    "rollNumber": "18051Q",
    "schoolName": "Coole N.s,",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "W23AXK8",
    "addressOne": "Garradice,",
    "addressTwo": "Kilcock,",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.4523036",
    "lng": "-6.7273555",
    "phone": "9557538",
    "email": "cooleschool@gmail.com"
  },
  {
    "i": "2300",
    "county": "Meath",
    "rollNumber": "18106P",
    "schoolName": "SN Na Trionoide Naofa",
    "SETHours": "102.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "C15NH68",
    "addressOne": "Lismullen",
    "addressTwo": "Garlow Cross",
    "addressThree": "Navan",
    "addressFour": "Co. Meath",
    "lat": "53.6043896",
    "lng": "-6.5988417",
    "phone": "469025533",
    "email": "lismullenns@gmail.com"
  },
  {
    "i": "2301",
    "county": "Meath",
    "rollNumber": "18132Q",
    "schoolName": "SN Muire",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "A82AH22",
    "addressOne": "Carlanstown",
    "addressTwo": "Kells",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.7613631",
    "lng": "-6.840979",
    "phone": "469246803",
    "email": "carlanstownns@gmail.com"
  },
  {
    "i": "2302",
    "county": "Meath",
    "rollNumber": "18169Q",
    "schoolName": "SN Rath Riagain",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "A86T665",
    "addressOne": "Rathregan",
    "addressTwo": "Batterstown",
    "addressThree": "Dunboyne",
    "addressFour": "Co. Meath",
    "lat": "53.4683811",
    "lng": "-6.5346788",
    "phone": "18259208",
    "email": "office@rathreganns.ie"
  },
  {
    "i": "2303",
    "county": "Meath",
    "rollNumber": "18174J",
    "schoolName": "SN Caitriona Naofa",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "A82DP71",
    "addressOne": "Oristown",
    "addressTwo": "Kells",
    "addressThree": "Co. Meath.",
    "addressFour": "",
    "lat": "53.7203321",
    "lng": "-6.789701",
    "phone": "469241425",
    "email": "oristownns@gmail.com"
  },
  {
    "i": "2304",
    "county": "Meath",
    "rollNumber": "18344I",
    "schoolName": "SN Mhuire",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "A83KD81",
    "addressOne": "Moynalvey",
    "addressTwo": "Summerhill",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.474805",
    "lng": "-6.6817478",
    "phone": "469557416",
    "email": "office@moynalveyns.ie"
  },
  {
    "i": "2305",
    "county": "Meath",
    "rollNumber": "18358T",
    "schoolName": "SN Fiach",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "A82X448",
    "addressOne": "Ballinacree",
    "addressTwo": "Oldcastle",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.7653411",
    "lng": "-7.2302011",
    "phone": "498541913",
    "email": "stfiachsoffice@gmail.com"
  },
  {
    "i": "2306",
    "county": "Meath",
    "rollNumber": "18413B",
    "schoolName": "SN Naomh Treasa",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "A92AX28",
    "addressOne": "Bellewstown",
    "addressTwo": "Drogheda",
    "addressThree": "Co Meath",
    "addressFour": "",
    "lat": "53.6432564",
    "lng": "-6.3526683",
    "phone": "419823629",
    "email": "scoilnaomhtreasa@gmail.com"
  },
  {
    "i": "2307",
    "county": "Meath",
    "rollNumber": "18429Q",
    "schoolName": "SN Mhuire",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "C15HP57",
    "addressOne": "Cul Ronain",
    "addressTwo": "Baile Iomhair",
    "addressThree": "Co Meath",
    "addressFour": "",
    "lat": "53.5599259",
    "lng": "-6.9830128",
    "phone": "469546416",
    "email": "scoilmhuire_ns@eircom.net"
  },
  {
    "i": "2308",
    "county": "Meath",
    "rollNumber": "18448U",
    "schoolName": "SN Rath Beagain",
    "SETHours": "117.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "A85AE84",
    "addressOne": "Rathbeggan",
    "addressTwo": "Dunshaughlin",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.4765273",
    "lng": "-6.5034678",
    "phone": "18259891",
    "email": "office@rathbegganns.ie"
  },
  {
    "i": "2309",
    "county": "Meath",
    "rollNumber": "18453N",
    "schoolName": "SN Mhichil Naofa",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "A83WV07",
    "addressOne": "Cill",
    "addressTwo": "Rath Molladhain",
    "addressThree": "Co Na Mi",
    "addressFour": "",
    "lat": "53.4855584",
    "lng": "-6.8265135",
    "phone": "469555300",
    "email": "killmolyon.ias@eircom.net"
  },
  {
    "i": "2310",
    "county": "Meath",
    "rollNumber": "18500T",
    "schoolName": "SN Naomh Colmcille",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "A92TC99",
    "addressOne": "Mount Hanover",
    "addressTwo": "Duleek",
    "addressThree": "Co Meath",
    "addressFour": "",
    "lat": "53.6747474",
    "lng": "-6.3732924",
    "phone": "419839405",
    "email": "mounthanoverns@gmail.com"
  },
  {
    "i": "2311",
    "county": "Meath",
    "rollNumber": "18762D",
    "schoolName": "SN Realt Na Mara (b)",
    "SETHours": "172.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "4",
    "spSNA": "4",
    "totalSNA": "8",
    "eircode": "A92WC52",
    "addressOne": "Donacarney",
    "addressTwo": "Mornington",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.7076106",
    "lng": "-6.2753915",
    "phone": "419827045",
    "email": "office@donacarneyschool.ie"
  },
  {
    "i": "2312",
    "county": "Meath",
    "rollNumber": "18767N",
    "schoolName": "SN Realt Na Mara (c)",
    "SETHours": "102.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "3.5",
    "spSNA": "4",
    "totalSNA": "7.5",
    "eircode": "A92T382",
    "addressOne": "Donacarney",
    "addressTwo": "Co. Meath",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.7082302",
    "lng": "-6.2762115",
    "phone": "419887684",
    "email": "office@realtnamaradonacarney.ie"
  },
  {
    "i": "2313",
    "county": "Meath",
    "rollNumber": "18887A",
    "schoolName": "St. Joseph's NS",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "W23T8YC",
    "addressOne": "Mulhussey",
    "addressTwo": "Kilcock",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.4379452",
    "lng": "-6.622088",
    "phone": "16285513",
    "email": "maolhosae@gmail.com"
  },
  {
    "i": "2314",
    "county": "Meath",
    "rollNumber": "19018A",
    "schoolName": "Dangan Mixed NS",
    "SETHours": "62.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "A83HN83",
    "addressOne": "Dangan",
    "addressTwo": "Summerhill",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.4899804",
    "lng": "-6.7432816",
    "phone": "469557332",
    "email": "dangan.school@yahoo.ie"
  },
  {
    "i": "2315",
    "county": "Meath",
    "rollNumber": "19253K",
    "schoolName": "Scoil Naomh Barra",
    "SETHours": "62.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "1.83",
    "spSNA": "2",
    "totalSNA": "3.83",
    "eircode": "C15VW32",
    "addressOne": "Wilkinstown",
    "addressTwo": "Navan",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.7319238",
    "lng": "-6.7099211",
    "phone": "469054329",
    "email": "office@wilkinstownns.ie"
  },
  {
    "i": "2316",
    "county": "Meath",
    "rollNumber": "19292U",
    "schoolName": "Castletown NS",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "C15K225",
    "addressOne": "Navan",
    "addressTwo": "Co Meath",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.7781136",
    "lng": "-6.7160334",
    "phone": "469054571",
    "email": "castletownkpns@gmail.com"
  },
  {
    "i": "2317",
    "county": "Offaly",
    "rollNumber": "19300Q",
    "schoolName": "Castlejordan Central Ns",
    "SETHours": "0",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "R35NX94",
    "addressOne": "Castlejordan",
    "addressTwo": "Tullamore",
    "addressThree": "Co. Offaly",
    "addressFour": "",
    "lat": "53.3971582",
    "lng": "-7.1218223",
    "phone": "469739036",
    "email": "castlejordan.school@gmail.com"
  },
  {
    "i": "2318",
    "county": "Meath",
    "rollNumber": "19476H",
    "schoolName": "St Oliver Plunkett Ns",
    "SETHours": "162.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "C15R642",
    "addressOne": "Blackcastle",
    "addressTwo": "Navan",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.662581",
    "lng": "-6.6782701",
    "phone": "469023347",
    "email": "stoliverns2@gmail.com"
  },
  {
    "i": "2319",
    "county": "Meath",
    "rollNumber": "19486K",
    "schoolName": "Scoil Nais Deaglain",
    "SETHours": "245",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.83",
    "spSNA": "0",
    "totalSNA": "4.83",
    "eircode": "A84KT02",
    "addressOne": "Ashbourne",
    "addressTwo": "Co. Meath",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.5058163",
    "lng": "-6.4008383",
    "phone": "18350594",
    "email": "principal@decsash.ie"
  },
  {
    "i": "2320",
    "county": "Meath",
    "rollNumber": "19671F",
    "schoolName": "St Paul's NS",
    "SETHours": "207.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "C15V067",
    "addressOne": "Abbeylands",
    "addressTwo": "Navan",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.6593785",
    "lng": "-6.6849142",
    "phone": "469028754",
    "email": "info@stpaulsschool.ie"
  },
  {
    "i": "2321",
    "county": "Meath",
    "rollNumber": "19725C",
    "schoolName": "Gaelscoil Eanna",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "C15WF67",
    "addressOne": "Bóthar áth Troim",
    "addressTwo": "An Uaimh",
    "addressThree": "Co. Na Mí­",
    "addressFour": "",
    "lat": "53.6441584",
    "lng": "-6.6820771",
    "phone": "469029739",
    "email": "gaelscoileanna@eircom.net"
  },
  {
    "i": "2322",
    "county": "Meath",
    "rollNumber": "19768U",
    "schoolName": "Scoil Mhuire",
    "SETHours": "155",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.83",
    "spSNA": "0",
    "totalSNA": "4.83",
    "eircode": "A84X762",
    "addressOne": "Tudor Grove",
    "addressTwo": "Ashbourne",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.5159947",
    "lng": "-6.3987342",
    "phone": "18351299",
    "email": "stmarysns1@gmail.com"
  },
  {
    "i": "2323",
    "county": "Meath",
    "rollNumber": "19779C",
    "schoolName": "Gaelscoil Na Cille",
    "SETHours": "87.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "A84TX36",
    "addressOne": "Cill Dheaglain",
    "addressTwo": "Ashbourne",
    "addressThree": "Co Meath",
    "addressFour": "",
    "lat": "53.5048728",
    "lng": "-6.386879",
    "phone": "18351600",
    "email": "info@gaelscoilnacille.ie"
  },
  {
    "i": "2324",
    "county": "Meath",
    "rollNumber": "19813W",
    "schoolName": "St. Dympna's NS",
    "SETHours": "92.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "3.33",
    "spSNA": "1.66",
    "totalSNA": "4.99",
    "eircode": "C15YN67",
    "addressOne": "Kildalkey",
    "addressTwo": "Navan",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.571801",
    "lng": "-6.9051394",
    "phone": "469435286",
    "email": "kildalkeyns@live.ie"
  },
  {
    "i": "2325",
    "county": "Meath",
    "rollNumber": "19867W",
    "schoolName": "Scoil Na Rithe",
    "SETHours": "70",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "A85D266",
    "addressOne": "Dún Seachlainn",
    "addressTwo": "Co. Na Mí­",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.5139317",
    "lng": "-6.5432795",
    "phone": "18259933",
    "email": "gsnarithe@gmail.com"
  },
  {
    "i": "2326",
    "county": "Meath",
    "rollNumber": "20017F",
    "schoolName": "Scoil An Spioraid Naoimh",
    "SETHours": "155",
    "spClassTeachingPosts": "2",
    "mainSNA": "3",
    "spSNA": "4",
    "totalSNA": "7",
    "eircode": "A92E273",
    "addressOne": "Laytown",
    "addressTwo": "Co. Meath",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.6891842",
    "lng": "-6.2420629",
    "phone": "419828091",
    "email": "secretary@ssnlaytown.ie"
  },
  {
    "i": "2327",
    "county": "Meath",
    "rollNumber": "20032B",
    "schoolName": "Dunboyne Jn NS",
    "SETHours": "155",
    "spClassTeachingPosts": "1",
    "mainSNA": "3.99",
    "spSNA": "2",
    "totalSNA": "5.99",
    "eircode": "A86HW57",
    "addressOne": "Station Road",
    "addressTwo": "Dunboyne",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.4196091",
    "lng": "-6.4703963",
    "phone": "18252807",
    "email": "office@dunboynejps.ie"
  },
  {
    "i": "2328",
    "county": "Meath",
    "rollNumber": "20033D",
    "schoolName": "Dunboyne Sn NS",
    "SETHours": "182.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "3",
    "spSNA": "2",
    "totalSNA": "5",
    "eircode": "A86X857",
    "addressOne": "Station Road",
    "addressTwo": "Dunboyne",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.4188664",
    "lng": "-6.4712009",
    "phone": "18252803",
    "email": "office@dunboynesps.ie"
  },
  {
    "i": "2329",
    "county": "Meath",
    "rollNumber": "20051F",
    "schoolName": "Gaelscoil Na Boinne",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "C15YF64",
    "addressOne": "Dublin Road",
    "addressTwo": "Trim",
    "addressThree": "Co. Meath.",
    "addressFour": "",
    "lat": "53.5531418",
    "lng": "-6.7696819",
    "phone": "469437872",
    "email": "gaelscoilnaboinne@eircom.net"
  },
  {
    "i": "2330",
    "county": "Meath",
    "rollNumber": "20082Q",
    "schoolName": "Gaelscoil Thulach Na Nóg",
    "SETHours": "105",
    "spClassTeachingPosts": "2",
    "mainSNA": "3.83",
    "spSNA": "4.66",
    "totalSNA": "8.49",
    "eircode": "A86EP04",
    "addressOne": "Bóthar Rúisc",
    "addressTwo": "Dún Búinne",
    "addressThree": "Co. Na Mí­",
    "addressFour": "",
    "lat": "53.4150699",
    "lng": "-6.4736153",
    "phone": "18252858",
    "email": "tulach@eircom.net"
  },
  {
    "i": "2331",
    "county": "Meath",
    "rollNumber": "20164S",
    "schoolName": "Navan Educate Together Ns",
    "SETHours": "102.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "1.83",
    "spSNA": "5.32",
    "totalSNA": "7.15",
    "eircode": "C15KV84",
    "addressOne": "Commons Road",
    "addressTwo": "Navan",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.6451061",
    "lng": "-6.6971897",
    "phone": "469060305",
    "email": "etnavan@hotmail.com"
  },
  {
    "i": "2332",
    "county": "Meath",
    "rollNumber": "20179I",
    "schoolName": "St Stephens Ns",
    "SETHours": "287.5",
    "spClassTeachingPosts": "4",
    "mainSNA": "3.66",
    "spSNA": "7.83",
    "totalSNA": "11.49",
    "eircode": "C15AE03",
    "addressOne": "Johnstown",
    "addressTwo": "Navan",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.6425593",
    "lng": "-6.647752",
    "phone": "469020080",
    "email": "ststephens2@eircom.net"
  },
  {
    "i": "2333",
    "county": "Meath",
    "rollNumber": "20180Q",
    "schoolName": "Scoil Naomh Eoin",
    "SETHours": "175",
    "spClassTeachingPosts": "1",
    "mainSNA": "3.33",
    "spSNA": "1.83",
    "totalSNA": "5.16",
    "eircode": "C15HK75",
    "addressOne": "Clonmagadden Valley",
    "addressTwo": "Windtown",
    "addressThree": "Navan",
    "addressFour": "Co. Meath",
    "lat": "53.6691828",
    "lng": "-6.6952061",
    "phone": "469075803",
    "email": "scoilnaomheoin@eircom.net"
  },
  {
    "i": "2334",
    "county": "Meath",
    "rollNumber": "20191V",
    "schoolName": "St Peters NS",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.33",
    "spSNA": "0",
    "totalSNA": "2.33",
    "eircode": "A86RX96",
    "addressOne": "St Peters Ns, Coi",
    "addressTwo": "Maynooth Rd",
    "addressThree": "Dunboyne",
    "addressFour": "Meath",
    "lat": "53.4185457",
    "lng": "-6.4780671",
    "phone": "18026741",
    "email": "stpetersnsdunboyne@gmail.com"
  },
  {
    "i": "2335",
    "county": "Meath",
    "rollNumber": "20200T",
    "schoolName": "Ratoath Sn Ns",
    "SETHours": "137.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "A85ET29",
    "addressOne": "Fairyhouse Road",
    "addressTwo": "Ratoath",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.5023754",
    "lng": "-6.4650335",
    "phone": "18254470",
    "email": "admin@ratoathsns.ie"
  },
  {
    "i": "2336",
    "county": "Meath",
    "rollNumber": "20215J",
    "schoolName": "St Paul's Ns",
    "SETHours": "225",
    "spClassTeachingPosts": "2",
    "mainSNA": "12.83",
    "spSNA": "4",
    "totalSNA": "16.83",
    "eircode": "A85DX54",
    "addressOne": "Jamestown",
    "addressTwo": "Ratoath",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.5025882",
    "lng": "-6.4523682",
    "phone": "18257246",
    "email": "office@stpaulsratoath.ie"
  },
  {
    "i": "2337",
    "county": "Meath",
    "rollNumber": "20216L",
    "schoolName": "Scoil Oilibheir Naofa",
    "SETHours": "160",
    "spClassTeachingPosts": "2",
    "mainSNA": "4.49",
    "spSNA": "5.66",
    "totalSNA": "10.15",
    "eircode": "A92H762",
    "addressOne": "Coast Road",
    "addressTwo": "Bettystown",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.6914661",
    "lng": "-6.2437893",
    "phone": "419887431",
    "email": "office@bettystownschool.ie"
  },
  {
    "i": "2338",
    "county": "Meath",
    "rollNumber": "20258E",
    "schoolName": "Gaelscoil An Bhradáin Feasa",
    "SETHours": "157.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "4",
    "spSNA": "2",
    "totalSNA": "6",
    "eircode": "A92WY45",
    "addressOne": "Bóthar An Mhuilinn",
    "addressTwo": "Droichead átha",
    "addressThree": "Co. Na Mí­",
    "addressFour": "",
    "lat": "53.7110252",
    "lng": "-6.2983678",
    "phone": "419848667",
    "email": "siobhan@gaelscoilanbhradainfeasa.com"
  },
  {
    "i": "2339",
    "county": "Meath",
    "rollNumber": "20352T",
    "schoolName": "Ard Rí­ Community NS",
    "SETHours": "88.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.33",
    "spSNA": "0",
    "totalSNA": "5.33",
    "eircode": "C15D340",
    "addressOne": "Balreask Old",
    "addressTwo": "Navan",
    "addressThree": "Co. Meath",
    "addressFour": "",
    "lat": "53.6382521",
    "lng": "-6.6712824",
    "phone": "871341007",
    "email": "Droe@lmetb.ie"
  },
  {
    "i": "2340",
    "county": "Meath",
    "rollNumber": "20382F",
    "schoolName": "Gaelscoil Na Mí­",
    "SETHours": "95",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "A84R667",
    "addressOne": "Campas Oideachais Chill Dhéagláin",
    "addressTwo": "Cill Dhéagláin",
    "addressThree": "Co. Na Mí­",
    "addressFour": "",
    "lat": "53.5109429",
    "lng": "-6.4133978",
    "phone": "18353480",
    "email": "gaelscoilnami@gmail.com"
  },
  {
    "i": "2341",
    "county": "Meath",
    "rollNumber": "20396Q",
    "schoolName": "Ashbourne Educate Together NS",
    "SETHours": "222.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "3.83",
    "spSNA": "4",
    "totalSNA": "7.83",
    "eircode": "A84TW90",
    "addressOne": "Ashbourne Educate Together",
    "addressTwo": "Killegland",
    "addressThree": "Ashbourne",
    "addressFour": "Co. Meath",
    "lat": "53.5119455",
    "lng": "-6.4160427",
    "phone": "18357493",
    "email": "office@ashbourneetns.ie"
  },
  {
    "i": "2342",
    "county": "Meath",
    "rollNumber": "20444B",
    "schoolName": "Trim Educate Together NS",
    "SETHours": "60",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "C15KA9P",
    "addressOne": "The Maudlins",
    "addressTwo": "Trim",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.5502187",
    "lng": "-6.7850753",
    "phone": "469009106",
    "email": "info@trimeducatetogether.com"
  },
  {
    "i": "2343",
    "county": "Meath",
    "rollNumber": "20521Q",
    "schoolName": "Dunshaughlin Community NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "",
    "addressOne": "",
    "addressTwo": "",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.5160197",
    "lng": "-6.5544837",
    "phone": "",
    "email": ""
  },
  {
    "i": "2344",
    "county": "Meath",
    "rollNumber": "20546J",
    "schoolName": "Ashbourne Community NS",
    "SETHours": "140",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "",
    "addressOne": "Ashbourne",
    "addressTwo": "Co Meath",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.5103375",
    "lng": "-6.4187928",
    "phone": "868522068",
    "email": "jbyrne.ans@lmetb.ie"
  },
  {
    "i": "2345",
    "county": "Monaghan",
    "rollNumber": "00359V",
    "schoolName": "St. Louis GNS",
    "SETHours": "112.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H18HK31",
    "addressOne": "Park Road",
    "addressTwo": "Monaghan",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.2456074",
    "lng": "-6.9766257",
    "phone": "4781305",
    "email": "principal@stlouisgns.com"
  },
  {
    "i": "2346",
    "county": "Monaghan",
    "rollNumber": "00373P",
    "schoolName": "Deravoy NS",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H18PY11",
    "addressOne": "Deravoy",
    "addressTwo": "Emyvale",
    "addressThree": "Co. Monaghan",
    "addressFour": "",
    "lat": "54.356397",
    "lng": "-7.0243139",
    "phone": "4787755",
    "email": "deravoyns@gmail.com"
  },
  {
    "i": "2347",
    "county": "Monaghan",
    "rollNumber": "05501A",
    "schoolName": "Scoil Naoimh Eanna",
    "SETHours": "62.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "A81E267",
    "addressOne": "Killanny",
    "addressTwo": "Carrickmacross",
    "addressThree": "Co. Monaghan",
    "addressFour": "",
    "lat": "53.9592703",
    "lng": "-6.6492555",
    "phone": "429662175",
    "email": "killannyns@gmail.com"
  },
  {
    "i": "2348",
    "county": "Monaghan",
    "rollNumber": "06028F",
    "schoolName": "Rockcorry NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H18C425",
    "addressOne": "Rockcorry",
    "addressTwo": "Co. Monaghan",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.1171544",
    "lng": "-7.0149102",
    "phone": "429742554",
    "email": "rockcorryns@gmail.com"
  },
  {
    "i": "2349",
    "county": "Monaghan",
    "rollNumber": "06117E",
    "schoolName": "Doohamlet NS",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "A75YV07",
    "addressOne": "Doohamlet",
    "addressTwo": "Castleblayney",
    "addressThree": "Co. Monaghan",
    "addressFour": "",
    "lat": "54.1291439",
    "lng": "-6.830666",
    "phone": "429741498",
    "email": "doohamletns@eircom.net"
  },
  {
    "i": "2350",
    "county": "Monaghan",
    "rollNumber": "07751K",
    "schoolName": "Monaghan Model School",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "H18EC56",
    "addressOne": "North Road",
    "addressTwo": "Monaghan",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.2510222",
    "lng": "-6.9722964",
    "phone": "4783070",
    "email": "modelsch.ias@gmail.com"
  },
  {
    "i": "2351",
    "county": "Monaghan",
    "rollNumber": "09186P",
    "schoolName": "Scoil Mhuire",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "H18RX50",
    "addressOne": "Magherarney",
    "addressTwo": "Smithborough",
    "addressThree": "Co. Monaghan",
    "addressFour": "",
    "lat": "54.2163457",
    "lng": "-7.1115922",
    "phone": "4757203",
    "email": "info@magherarneyns.com"
  },
  {
    "i": "2352",
    "county": "Monaghan",
    "rollNumber": "10282S",
    "schoolName": "Drumacruttin NS",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H18YD83",
    "addressOne": "Drumacrutten",
    "addressTwo": "Dunraymond",
    "addressThree": "Co. Monaghan",
    "addressFour": "",
    "lat": "54.1958406",
    "lng": "-6.9405181",
    "phone": "4771186",
    "email": "drumacruttinns@mail.com"
  },
  {
    "i": "2353",
    "county": "Monaghan",
    "rollNumber": "10429W",
    "schoolName": "Scoil Mhuire",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H18NY50",
    "addressOne": "Boyher",
    "addressTwo": "Rockcorry",
    "addressThree": "Co. Monaghan",
    "addressFour": "",
    "lat": "54.1154913",
    "lng": "-7.0129329",
    "phone": "429742366",
    "email": "scoilmhuirerock@gmail.com"
  },
  {
    "i": "2354",
    "county": "Monaghan",
    "rollNumber": "10751E",
    "schoolName": "Clontibret NS",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "H18F671",
    "addressOne": "Aghnameal",
    "addressTwo": "Clontibret",
    "addressThree": "Co. Monaghan",
    "addressFour": "",
    "lat": "54.1945132",
    "lng": "-6.8502433",
    "phone": "4780865",
    "email": "clontibretns@gmail.com"
  },
  {
    "i": "2355",
    "county": "Monaghan",
    "rollNumber": "13632L",
    "schoolName": "Annalitten NS",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "A75YX46",
    "addressOne": "Annalitten",
    "addressTwo": "Castleblayeny",
    "addressThree": "Co. Monaghan",
    "addressFour": "",
    "lat": "54.0830894",
    "lng": "-6.7031194",
    "phone": "429743054",
    "email": "annalittenns@gmail.com"
  },
  {
    "i": "2356",
    "county": "Monaghan",
    "rollNumber": "13811L",
    "schoolName": "Corcreagh NS",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "A81YR59",
    "addressOne": "Corcreagh",
    "addressTwo": "Shercock",
    "addressThree": "Co. Cavan",
    "addressFour": "",
    "lat": "53.9913909",
    "lng": "-6.8580444",
    "phone": "429669404",
    "email": "corcreaghns123@gmail.com"
  },
  {
    "i": "2357",
    "county": "Monaghan",
    "rollNumber": "14071C",
    "schoolName": "Drumgossett NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "A81X827",
    "addressOne": "Drumgossett",
    "addressTwo": "Carrickmacross",
    "addressThree": "Co. Monaghan",
    "addressFour": "",
    "lat": "53.9518763",
    "lng": "-6.7774528",
    "phone": "429662340",
    "email": "office@drumgossatt.com"
  },
  {
    "i": "2358",
    "county": "Monaghan",
    "rollNumber": "15142E",
    "schoolName": "Naomh Micheal",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "A81EA37",
    "addressOne": "Donaghmoyne",
    "addressTwo": "Carrickmacross",
    "addressThree": "Co Monaghan",
    "addressFour": "",
    "lat": "54.0128673",
    "lng": "-6.6888448",
    "phone": "429662284",
    "email": "donaghmoynens@eircom.net"
  },
  {
    "i": "2359",
    "county": "Monaghan",
    "rollNumber": "15143G",
    "schoolName": "Lisdoonan NS",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "A81WR65",
    "addressOne": "Lisdonnan",
    "addressTwo": "Carrickmacross",
    "addressThree": "Co. Monaghan",
    "addressFour": "",
    "lat": "54.0290928",
    "lng": "-6.7524875",
    "phone": "429662375",
    "email": "lisdoonanns@hotmail.com"
  },
  {
    "i": "2360",
    "county": "Monaghan",
    "rollNumber": "15329U",
    "schoolName": "Bun Scoil Louis Naofa",
    "SETHours": "85",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "A81DT82",
    "addressOne": "Cloughvalley",
    "addressTwo": "Carrickmacross",
    "addressThree": "Co. Monaghan",
    "addressFour": "",
    "lat": "53.9776661",
    "lng": "-6.7148347",
    "phone": "429661808",
    "email": "bunscoilln@gmail.com"
  },
  {
    "i": "2361",
    "county": "Monaghan",
    "rollNumber": "15654I",
    "schoolName": "Knockconnon NS",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "H18DY07",
    "addressOne": "Knockconan",
    "addressTwo": "Emyvale",
    "addressThree": "Co. Monaghan",
    "addressFour": "",
    "lat": "54.3679012",
    "lng": "-6.9650271",
    "phone": "4787244",
    "email": "knockconanns5@eircom.net"
  },
  {
    "i": "2362",
    "county": "Monaghan",
    "rollNumber": "16129R",
    "schoolName": "Corcaghan NS",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H18E284",
    "addressOne": "Corcaghan",
    "addressTwo": "Stranooden",
    "addressThree": "Co. Monaghan",
    "addressFour": "",
    "lat": "54.1912268",
    "lng": "-6.9899986",
    "phone": "429744026",
    "email": "corcaghanns.ias@eircom.net"
  },
  {
    "i": "2363",
    "county": "Monaghan",
    "rollNumber": "16202B",
    "schoolName": "Castleblayney Convent NS",
    "SETHours": "57.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "1",
    "spSNA": "1",
    "totalSNA": "2",
    "eircode": "A75XT66",
    "addressOne": "Laurel Hill",
    "addressTwo": "Castleblayney",
    "addressThree": "Co. Monaghan",
    "addressFour": "",
    "lat": "54.1182735",
    "lng": "-6.7415098",
    "phone": "429746090",
    "email": "scoilnagcailini@gmail.com"
  },
  {
    "i": "2364",
    "county": "Monaghan",
    "rollNumber": "16319W",
    "schoolName": "Castleblayney Convent Infants NS",
    "SETHours": "70",
    "spClassTeachingPosts": "1",
    "mainSNA": "1.83",
    "spSNA": "1",
    "totalSNA": "2.83",
    "eircode": "A75KC57",
    "addressOne": "Laurel Hill",
    "addressTwo": "Castleblayney",
    "addressThree": "Co. Monaghan",
    "addressFour": "",
    "lat": "54.1191529",
    "lng": "-6.7405375",
    "phone": "429740517",
    "email": "secretary@conventjuniorschool.ie"
  },
  {
    "i": "2365",
    "county": "Monaghan",
    "rollNumber": "16769H",
    "schoolName": "Latnamard NS",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H18VK88",
    "addressOne": "Latnambard",
    "addressTwo": "Smithboro",
    "addressThree": "Co. Monaghan",
    "addressFour": "",
    "lat": "54.1722418",
    "lng": "-7.0580047",
    "phone": "429744143",
    "email": "principal@latnamardns.com"
  },
  {
    "i": "2366",
    "county": "Monaghan",
    "rollNumber": "16842O",
    "schoolName": "Annyalla NS",
    "SETHours": "65",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "A75AY80",
    "addressOne": "Annyalla",
    "addressTwo": "Co. Monaghan",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.1598865",
    "lng": "-6.7861952",
    "phone": "429740973",
    "email": "secretary@annyallans.com"
  },
  {
    "i": "2367",
    "county": "Monaghan",
    "rollNumber": "16923O",
    "schoolName": "Urbleshanny NS",
    "SETHours": "117.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "H18R960",
    "addressOne": "Urbleshanny",
    "addressTwo": "Scotstown",
    "addressThree": "Co. Monaghan",
    "addressFour": "",
    "lat": "54.2805532",
    "lng": "-7.0633977",
    "phone": "4789594",
    "email": "admin@urbleshannyns.com"
  },
  {
    "i": "2368",
    "county": "Monaghan",
    "rollNumber": "16954C",
    "schoolName": "Scoil Mhichil",
    "SETHours": "0",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H18XY66",
    "addressOne": "Rackwallace",
    "addressTwo": "Castleshane",
    "addressThree": "Co. Monaghan",
    "addressFour": "",
    "lat": "54.2168931",
    "lng": "-6.8950855",
    "phone": "4785282",
    "email": "secretary@stmichaelsns.com"
  },
  {
    "i": "2369",
    "county": "Monaghan",
    "rollNumber": "16968N",
    "schoolName": "SN Blaithin Iosa",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "A81F892",
    "addressOne": "Ballaghnagearn",
    "addressTwo": "Magheracloone",
    "addressThree": "Carrickmacross",
    "addressFour": "Co. Monaghan",
    "lat": "53.9546011",
    "lng": "-6.8234472",
    "phone": "429667881",
    "email": "blaithin.ias@eircom.net"
  },
  {
    "i": "2370",
    "county": "Monaghan",
    "rollNumber": "17099Q",
    "schoolName": "St Joseph's NS",
    "SETHours": "117.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "5",
    "spSNA": "0",
    "totalSNA": "5",
    "eircode": "A81KX96",
    "addressOne": "Farney Street",
    "addressTwo": "Carrickmacross",
    "addressThree": "Co Monaghan",
    "addressFour": "",
    "lat": "53.9750494",
    "lng": "-6.7138308",
    "phone": "429661134",
    "email": "stjcmx@gmail.com"
  },
  {
    "i": "2371",
    "county": "Monaghan",
    "rollNumber": "17126Q",
    "schoolName": "Scoil Enda",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H23H678",
    "addressOne": "Scotshouse",
    "addressTwo": "Clones",
    "addressThree": "Co. Monaghan",
    "addressFour": "",
    "lat": "54.1240946",
    "lng": "-7.248567",
    "phone": "4756204",
    "email": "saintendasns@gmail.com"
  },
  {
    "i": "2372",
    "county": "Monaghan",
    "rollNumber": "17150N",
    "schoolName": "St Marys BNS",
    "SETHours": "177.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "1.34",
    "spSNA": "0.66",
    "totalSNA": "2",
    "eircode": "H18A215",
    "addressOne": "St Mary's Hill",
    "addressTwo": "Monaghan",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.2468197",
    "lng": "-6.976028",
    "phone": "4782361",
    "email": "office@1867.ie"
  },
  {
    "i": "2373",
    "county": "Monaghan",
    "rollNumber": "17686I",
    "schoolName": "Scoil Mhuire BNS",
    "SETHours": "72.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "2",
    "spSNA": "1",
    "totalSNA": "3",
    "eircode": "A75PC94",
    "addressOne": "Castleblayney",
    "addressTwo": "Co. Monaghan",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.1153271",
    "lng": "-6.7341456",
    "phone": "429740246",
    "email": "blbns2@gmail.com"
  },
  {
    "i": "2374",
    "county": "Monaghan",
    "rollNumber": "17735S",
    "schoolName": "St Patricks Ns",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.66",
    "spSNA": "0",
    "totalSNA": "1.66",
    "eircode": "A75TK84",
    "addressOne": "Broomfield",
    "addressTwo": "Castleblayney",
    "addressThree": "Co. Monaghan",
    "addressFour": "",
    "lat": "54.0584216",
    "lng": "-6.7000113",
    "phone": "429743640",
    "email": "office@broomfieldns.com"
  },
  {
    "i": "2375",
    "county": "Monaghan",
    "rollNumber": "17776J",
    "schoolName": "SN Comhghall",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "H23EH04",
    "addressOne": "Drumsloe",
    "addressTwo": "Drummully",
    "addressThree": "Clones",
    "addressFour": "Co. Monaghan",
    "lat": "54.1377973",
    "lng": "-7.312035",
    "phone": "4755329",
    "email": "stcomgallsns@gmail.com"
  },
  {
    "i": "2376",
    "county": "Monaghan",
    "rollNumber": "18023L",
    "schoolName": "Aughnafarcon NS",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "A75Y934",
    "addressOne": "Aughnafarcon",
    "addressTwo": "Broomfield",
    "addressThree": "Castleblayney",
    "addressFour": "Co. Monaghan",
    "lat": "54.0651981",
    "lng": "-6.7480199",
    "phone": "429743639",
    "email": "aughnafarcon.n.s@hotmail.com"
  },
  {
    "i": "2377",
    "county": "Monaghan",
    "rollNumber": "18028V",
    "schoolName": "Corr A Chrainn NS",
    "SETHours": "95",
    "spClassTeachingPosts": "1",
    "mainSNA": "2",
    "spSNA": "1",
    "totalSNA": "3",
    "eircode": "H18XH29",
    "addressOne": "Corracrin",
    "addressTwo": "Emyvale",
    "addressThree": "Co. Monaghan",
    "addressFour": "",
    "lat": "54.3173324",
    "lng": "-6.9629533",
    "phone": "4787551",
    "email": "corracrinns2019@gmail.com"
  },
  {
    "i": "2378",
    "county": "Monaghan",
    "rollNumber": "18234B",
    "schoolName": "Scoil Naomh Padraig",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "A75XN97",
    "addressOne": "Oram",
    "addressTwo": "Castleblayney",
    "addressThree": "Co. Monaghan",
    "addressFour": "",
    "lat": "54.1448659",
    "lng": "-6.6957419",
    "phone": "429746076",
    "email": "oramns@eircom.net"
  },
  {
    "i": "2379",
    "county": "Monaghan",
    "rollNumber": "18256L",
    "schoolName": "Scoil Bhrighde",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "H18YK29",
    "addressOne": "Tyholland",
    "addressTwo": "Co. Monaghan",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.277627",
    "lng": "-6.9057703",
    "phone": "4784977",
    "email": "scoilbhridesilverstream@gmail.com"
  },
  {
    "i": "2380",
    "county": "Monaghan",
    "rollNumber": "18401R",
    "schoolName": "Scoil Mhuire",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H18HC79",
    "addressOne": "Glaslough",
    "addressTwo": "Co. Monaghan",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.3077524",
    "lng": "-6.8988993",
    "phone": "4788356",
    "email": "glasloughschool@gmail.com"
  },
  {
    "i": "2381",
    "county": "Monaghan",
    "rollNumber": "18482U",
    "schoolName": "Mhuire Gransla",
    "SETHours": "0",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H23EY86",
    "addressOne": "Latgallan",
    "addressTwo": "Clones",
    "addressThree": "Co. Monaghan",
    "addressFour": "",
    "lat": "54.2024828",
    "lng": "-7.1650728",
    "phone": "4751235",
    "email": "granshans@hotmail.com"
  },
  {
    "i": "2382",
    "county": "Monaghan",
    "rollNumber": "18494E",
    "schoolName": "St Louis Infant School",
    "SETHours": "120",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.49",
    "spSNA": "0",
    "totalSNA": "2.49",
    "eircode": "H18P950",
    "addressOne": "Park Road",
    "addressTwo": "Monaghan",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.2456074",
    "lng": "-6.9766257",
    "phone": "4782913",
    "email": "office@stlouisinfants.ie"
  },
  {
    "i": "2383",
    "county": "Monaghan",
    "rollNumber": "18539A",
    "schoolName": "Scoil Naomh Mhuire",
    "SETHours": "57.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "2.25",
    "spSNA": "5.66",
    "totalSNA": "7.91",
    "eircode": "H18XN29",
    "addressOne": "Tullybuck",
    "addressTwo": "Clontibret",
    "addressThree": "Co. Monaghan",
    "addressFour": "",
    "lat": "54.2161495",
    "lng": "-6.8510139",
    "phone": "4780729",
    "email": "scoilmhuireclontibret@gmail.com"
  },
  {
    "i": "2384",
    "county": "Monaghan",
    "rollNumber": "18820O",
    "schoolName": "SN Cholmcille",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.75",
    "spSNA": "0",
    "totalSNA": "1.75",
    "eircode": "A81CR24",
    "addressOne": "Blackstaff",
    "addressTwo": "Carraig Mhachaire Rois",
    "addressThree": "Co Mhuineachain",
    "addressFour": "",
    "lat": "54.0273722",
    "lng": "-6.6174535",
    "phone": "429378337",
    "email": "blackstaffns@gmail.com"
  },
  {
    "i": "2385",
    "county": "Monaghan",
    "rollNumber": "19036C",
    "schoolName": "Scoil Phadraig",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "H18Y586",
    "addressOne": "Garron",
    "addressTwo": "Tyholland",
    "addressThree": "Co Monaghan",
    "addressFour": "",
    "lat": "54.2621484",
    "lng": "-6.8760646",
    "phone": "4785378",
    "email": "garron.ias@eircom.net"
  },
  {
    "i": "2386",
    "county": "Monaghan",
    "rollNumber": "19162H",
    "schoolName": "Threemilehouse NS",
    "SETHours": "60",
    "spClassTeachingPosts": "3",
    "mainSNA": "3",
    "spSNA": "6",
    "totalSNA": "9",
    "eircode": "H18R924",
    "addressOne": "Threemilehouse",
    "addressTwo": "Co. Monaghan",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.2177678",
    "lng": "-7.0411295",
    "phone": "4757492",
    "email": "office@threemilehousens.com"
  },
  {
    "i": "2387",
    "county": "Monaghan",
    "rollNumber": "19251G",
    "schoolName": "Scoil Naomh Deagha",
    "SETHours": "102.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "A91DW66",
    "addressOne": "The Glebe",
    "addressTwo": "Inniskeen",
    "addressThree": "Dundalk",
    "addressFour": "Co Louth",
    "lat": "54.0032824",
    "lng": "-6.578864",
    "phone": "429378256",
    "email": "stdaigs@hotmail.com"
  },
  {
    "i": "2388",
    "county": "Monaghan",
    "rollNumber": "19362P",
    "schoolName": "St Patricks NS",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "H18E365",
    "addressOne": "Clara",
    "addressTwo": "Killybrone",
    "addressThree": "Co. Monaghan",
    "addressFour": "",
    "lat": "54.3992714",
    "lng": "-7.024113",
    "phone": "4787569",
    "email": "secretary@stpatricksclara.com"
  },
  {
    "i": "2389",
    "county": "Monaghan",
    "rollNumber": "19364T",
    "schoolName": "Killeevan Central NS",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H18H735",
    "addressOne": "Newbliss",
    "addressTwo": "Co. Monaghan",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.1640546",
    "lng": "-7.141709",
    "phone": "4754023",
    "email": "killeevanoffice@yahoo.ie"
  },
  {
    "i": "2390",
    "county": "Monaghan",
    "rollNumber": "19434O",
    "schoolName": "Latton",
    "SETHours": "70",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.58",
    "spSNA": "0",
    "totalSNA": "2.58",
    "eircode": "A75P033",
    "addressOne": "Latton",
    "addressTwo": "Castleblayney",
    "addressThree": "Co. Monaghan",
    "addressFour": "",
    "lat": "54.0716917",
    "lng": "-6.9483992",
    "phone": "429742276",
    "email": "info@scoilmhuirelatton.ie"
  },
  {
    "i": "2391",
    "county": "Monaghan",
    "rollNumber": "19469K",
    "schoolName": "Naomh Oliver Plunkett",
    "SETHours": "85",
    "spClassTeachingPosts": "5",
    "mainSNA": "3.33",
    "spSNA": "9.66",
    "totalSNA": "12.99",
    "eircode": "A75PY66",
    "addressOne": "Tossey",
    "addressTwo": "Loughmourne",
    "addressThree": "Co. Monaghan",
    "addressFour": "",
    "lat": "54.0785627",
    "lng": "-6.8458386",
    "phone": "429745055",
    "email": "stoliverplunkettns@live.com"
  },
  {
    "i": "2392",
    "county": "Monaghan",
    "rollNumber": "19703P",
    "schoolName": "Drumcorrin NS",
    "SETHours": "0",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H16AK79",
    "addressOne": "Cortober",
    "addressTwo": "Drum",
    "addressThree": "Co. Monaghan",
    "addressFour": "",
    "lat": "54.1041182",
    "lng": "-7.1367723",
    "phone": "495552541",
    "email": "principal@drumcorrinns.ie"
  },
  {
    "i": "2393",
    "county": "Monaghan",
    "rollNumber": "19736H",
    "schoolName": "Scoil Phadraig",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "A81PP78",
    "addressOne": "Corduff",
    "addressTwo": "Carrickmacross",
    "addressThree": "Co. Monaghan",
    "addressFour": "",
    "lat": "54.0110951",
    "lng": "-6.8209995",
    "phone": "429669437",
    "email": "scoilphadraigns@gmail.com"
  },
  {
    "i": "2394",
    "county": "Monaghan",
    "rollNumber": "19737J",
    "schoolName": "Castleblayney Cent NS",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "A75E653",
    "addressOne": "Drumalish",
    "addressTwo": "Castleblayney",
    "addressThree": "Co Monaghan",
    "addressFour": "",
    "lat": "54.1333182",
    "lng": "-6.732122",
    "phone": "429740817",
    "email": "thecentralns.ias@eircom.net"
  },
  {
    "i": "2395",
    "county": "Monaghan",
    "rollNumber": "19738L",
    "schoolName": "St Dympnas Ns",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H18FK12",
    "addressOne": "Tedavnet",
    "addressTwo": "Co. Monaghan",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.2978659",
    "lng": "-7.0161456",
    "phone": "4789441",
    "email": "office@stdympnasns.com"
  },
  {
    "i": "2396",
    "county": "Monaghan",
    "rollNumber": "19780K",
    "schoolName": "Scoil Bride",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "A81NX62",
    "addressOne": "Mullaghrafferty",
    "addressTwo": "Carrickmacross",
    "addressThree": "Co. Monaghan",
    "addressFour": "",
    "lat": "53.9215237",
    "lng": "-6.7117318",
    "phone": "429662230",
    "email": "scoilbhridemr@gmail.com"
  },
  {
    "i": "2397",
    "county": "Monaghan",
    "rollNumber": "19857T",
    "schoolName": "Scoil Rois",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "A81H663",
    "addressOne": "Carraig Mhachaire Rois",
    "addressTwo": "Co. Mhuineacháin",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.9786544",
    "lng": "-6.7155413",
    "phone": "429662267",
    "email": "scoilrois.ias@eircom.net"
  },
  {
    "i": "2398",
    "county": "Monaghan",
    "rollNumber": "19884W",
    "schoolName": "Ballybay Central Ns",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "A75A382",
    "addressOne": "Ballybay",
    "addressTwo": "Co. Monaghan",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.1302777",
    "lng": "-6.8975035",
    "phone": "429741365",
    "email": "ballybaycentralns@gmail.com"
  },
  {
    "i": "2399",
    "county": "Monaghan",
    "rollNumber": "19936P",
    "schoolName": "Gaelscoil Ultain",
    "SETHours": "100",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "H18H263",
    "addressOne": "Cnoc An Chonnaidh",
    "addressTwo": "Muineacháin",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.2623644",
    "lng": "-6.949617",
    "phone": "4739711",
    "email": "eolas@ultain.ie"
  },
  {
    "i": "2400",
    "county": "Monaghan",
    "rollNumber": "20055N",
    "schoolName": "Gaelscoil éois",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H23RW28",
    "addressOne": "Bóthar Ros Liath",
    "addressTwo": "Cluain éois",
    "addressThree": "Co. Mhuineacháin",
    "addressFour": "",
    "lat": "54.1843972",
    "lng": "-7.2299971",
    "phone": "4752162",
    "email": "eois.ias@eircom.net"
  },
  {
    "i": "2401",
    "county": "Monaghan",
    "rollNumber": "20067U",
    "schoolName": "St Josephs NS",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H18VY49",
    "addressOne": "Knockatallon",
    "addressTwo": "Scotstown",
    "addressThree": "Co Monaghan",
    "addressFour": "",
    "lat": "54.2957848",
    "lng": "-7.1513019",
    "phone": "4789768",
    "email": "stjosephsnationalschool@gmail.com"
  },
  {
    "i": "2402",
    "county": "Monaghan",
    "rollNumber": "20120V",
    "schoolName": "St Tiarnach's Primary School",
    "SETHours": "190",
    "spClassTeachingPosts": "3",
    "mainSNA": "2",
    "spSNA": "5.66",
    "totalSNA": "7.66",
    "eircode": "H23KC59",
    "addressOne": "Roslea",
    "addressTwo": "Clones",
    "addressThree": "Co. Monaghan",
    "addressFour": "",
    "lat": "54.1841007",
    "lng": "-7.2285114",
    "phone": "4751398",
    "email": "info@sttiarnachs.ie"
  },
  {
    "i": "2403",
    "county": "Monaghan",
    "rollNumber": "20174V",
    "schoolName": "Scoil éanna",
    "SETHours": "117.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "A75XD83",
    "addressOne": "Ballybay",
    "addressTwo": "Co. Monaghan",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.1305174",
    "lng": "-6.8989304",
    "phone": "429741172",
    "email": "oifig@scoileanna.ie"
  },
  {
    "i": "2404",
    "county": "Monaghan",
    "rollNumber": "20246U",
    "schoolName": "The Billis NS",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H18RR22",
    "addressOne": "Billis",
    "addressTwo": "Glaslough",
    "addressThree": "Co. Monaghan",
    "addressFour": "",
    "lat": "54.2948958",
    "lng": "-6.9347696",
    "phone": "4788245",
    "email": "billisns@gmail.com"
  },
  {
    "i": "2405",
    "county": "Monaghan",
    "rollNumber": "20327U",
    "schoolName": "Gaelscoil Lorgan",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "A75Y278",
    "addressOne": "Baile Na Lorgan",
    "addressTwo": "Co. Mhuineacháin",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.1236239",
    "lng": "-6.7438114",
    "phone": "429795638",
    "email": "gaelscoillorgan@eircom.net"
  },
  {
    "i": "2406",
    "county": "Monaghan",
    "rollNumber": "20337A",
    "schoolName": "Edenmore NS",
    "SETHours": "67.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "1.5",
    "spSNA": "2",
    "totalSNA": "3.5",
    "eircode": "H18WY26",
    "addressOne": "Emyvale",
    "addressTwo": "Co Monaghan",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.3308616",
    "lng": "-6.9942044",
    "phone": "4787618",
    "email": "principal@edenmoreschool.com"
  },
  {
    "i": "2407",
    "county": "Offaly",
    "rollNumber": "02413L",
    "schoolName": "SN Naomh Eoin",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "R42HN30",
    "addressOne": "Rath",
    "addressTwo": "Fivealley",
    "addressThree": "Birr",
    "addressFour": "Co. Offaly",
    "lat": "53.1379218",
    "lng": "-7.8072948",
    "phone": "579133011",
    "email": "sneoinrath@eircom.net"
  },
  {
    "i": "2408",
    "county": "Offaly",
    "rollNumber": "03220F",
    "schoolName": "Mercy Primary School",
    "SETHours": "82.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "0",
    "spSNA": "2",
    "totalSNA": "2",
    "eircode": "R42TX89",
    "addressOne": "Chapel Lane",
    "addressTwo": "Birr",
    "addressThree": "Co. Offaly",
    "addressFour": "",
    "lat": "53.0930263",
    "lng": "-7.9097523",
    "phone": "579120259",
    "email": "principalmercyps@gmail.com"
  },
  {
    "i": "2409",
    "county": "Offaly",
    "rollNumber": "07191V",
    "schoolName": "SN Seosamh",
    "SETHours": "60",
    "spClassTeachingPosts": "1",
    "mainSNA": "2.83",
    "spSNA": "2.5",
    "totalSNA": "5.33",
    "eircode": "R35FN20",
    "addressOne": "Blueball",
    "addressTwo": "Tullamore",
    "addressThree": "Co. Offaly",
    "addressFour": "",
    "lat": "53.2216918",
    "lng": "-7.5806179",
    "phone": "579354960",
    "email": "gortnamonans@gmail.com"
  },
  {
    "i": "2410",
    "county": "Offaly",
    "rollNumber": "07949I",
    "schoolName": "SN Osmann",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "R42T271",
    "addressOne": "Model School Road",
    "addressTwo": "Birr",
    "addressThree": "Co. Offaly",
    "addressFour": "",
    "lat": "53.1003753",
    "lng": "-7.9143724",
    "phone": "579120706",
    "email": "oxmantownns@eircom.net"
  },
  {
    "i": "2411",
    "county": "Offaly",
    "rollNumber": "09191I",
    "schoolName": "Geashill 1 NS",
    "SETHours": "67.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "2.5",
    "spSNA": "2",
    "totalSNA": "4.5",
    "eircode": "R35W253",
    "addressOne": "Geashill",
    "addressTwo": "Co. Offaly",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.2344123",
    "lng": "-7.3224665",
    "phone": "579343754",
    "email": "geashillnsoffice@gmail.com"
  },
  {
    "i": "2412",
    "county": "Offaly",
    "rollNumber": "10353P",
    "schoolName": "Charleville NS",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.58",
    "spSNA": "0",
    "totalSNA": "1.58",
    "eircode": "R35CX20",
    "addressOne": "Church View",
    "addressTwo": "Tullamore",
    "addressThree": "Co Offaly",
    "addressFour": "",
    "lat": "53.2732675",
    "lng": "-7.4815155",
    "phone": "579341581",
    "email": "charlevillens@eircom.net"
  },
  {
    "i": "2413",
    "county": "Offaly",
    "rollNumber": "11203B",
    "schoolName": "Seir Kierans NS",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "R42KA97",
    "addressOne": "Clareen",
    "addressTwo": "Birr",
    "addressThree": "Co. Offaly",
    "addressFour": "",
    "lat": "53.0696668",
    "lng": "-7.7858691",
    "phone": "579131158",
    "email": "seirkieransns@gmail.com"
  },
  {
    "i": "2414",
    "county": "Offaly",
    "rollNumber": "12294M",
    "schoolName": "St Cronans Mixed NS",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "R42KC99",
    "addressOne": "Lusmagh",
    "addressTwo": "Banagher",
    "addressThree": "Birr",
    "addressFour": "Co. Offaly",
    "lat": "53.1727136",
    "lng": "-8.0195552",
    "phone": "579151834",
    "email": "cronanoffice@gmail.com"
  },
  {
    "i": "2415",
    "county": "Offaly",
    "rollNumber": "12343W",
    "schoolName": "Shinrone Mixed NS",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.33",
    "spSNA": "0",
    "totalSNA": "2.33",
    "eircode": "R42XE30",
    "addressOne": "Shinrone",
    "addressTwo": "Birr",
    "addressThree": "Co. Offaly",
    "addressFour": "",
    "lat": "52.985072",
    "lng": "-7.9231999",
    "phone": "50547223",
    "email": "shinronens@gmail.com"
  },
  {
    "i": "2416",
    "county": "Offaly",
    "rollNumber": "12370C",
    "schoolName": "St Brendans Monastery",
    "SETHours": "135",
    "spClassTeachingPosts": "3",
    "mainSNA": "3",
    "spSNA": "4.66",
    "totalSNA": "7.66",
    "eircode": "R42NW22",
    "addressOne": "Moorpark Street",
    "addressTwo": "Birr",
    "addressThree": "Co. Offaly",
    "addressFour": "",
    "lat": "53.0905887",
    "lng": "-7.9123847",
    "phone": "579121033",
    "email": "principal@stbrendansps.ie"
  },
  {
    "i": "2417",
    "county": "Offaly",
    "rollNumber": "13118U",
    "schoolName": "Clara Convent NS",
    "SETHours": "150",
    "spClassTeachingPosts": "2",
    "mainSNA": "2.83",
    "spSNA": "5",
    "totalSNA": "7.83",
    "eircode": "R35WP04",
    "addressOne": "Kilbeggan Road",
    "addressTwo": "Clara",
    "addressThree": "Co. Offaly",
    "addressFour": "",
    "lat": "53.342233",
    "lng": "-7.6040517",
    "phone": "579331483",
    "email": "office@sbclara.ie"
  },
  {
    "i": "2418",
    "county": "Offaly",
    "rollNumber": "13191H",
    "schoolName": "High St Mixed NS",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "R42YW42",
    "addressOne": "Highstreet",
    "addressTwo": "Belmont",
    "addressThree": "Co. Offaly",
    "addressFour": "",
    "lat": "53.2522528",
    "lng": "-7.9173217",
    "phone": "906457246",
    "email": "highstreetns@gmail.com"
  },
  {
    "i": "2419",
    "county": "Offaly",
    "rollNumber": "15325M",
    "schoolName": "Clonbullogue NS",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "R45DD79",
    "addressOne": "Clonbullogue",
    "addressTwo": "Co. Offaly",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.2626476",
    "lng": "-7.0862571",
    "phone": "469730123",
    "email": "stpatricksnsclonbullogue@gmail.com"
  },
  {
    "i": "2420",
    "county": "Offaly",
    "rollNumber": "15395K",
    "schoolName": "Mount Bolus NS",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "R35VH39",
    "addressOne": "Mount Bolus",
    "addressTwo": "Tullamore",
    "addressThree": "Co. Offaly",
    "addressFour": "",
    "lat": "53.1933286",
    "lng": "-7.6258826",
    "phone": "579354946",
    "email": "mountbolusns@gmail.com"
  },
  {
    "i": "2421",
    "county": "Offaly",
    "rollNumber": "15638K",
    "schoolName": "Edenderry 2 NS",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "R45HD23",
    "addressOne": "Edenderry",
    "addressTwo": "Co Offaly",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3409075",
    "lng": "-7.0714159",
    "phone": "469732231",
    "email": "info@monasterorisns.com"
  },
  {
    "i": "2422",
    "county": "Offaly",
    "rollNumber": "15656M",
    "schoolName": "Ballykilmurry NS",
    "SETHours": "80",
    "spClassTeachingPosts": "3",
    "mainSNA": "2.83",
    "spSNA": "7",
    "totalSNA": "9.83",
    "eircode": "R35AW83",
    "addressOne": "Ballinamere",
    "addressTwo": "Tullamore",
    "addressThree": "Co. Offaly",
    "addressFour": "",
    "lat": "53.2877581",
    "lng": "-7.5626381",
    "phone": "579341687",
    "email": "ballinamerens@gmail.com"
  },
  {
    "i": "2423",
    "county": "Offaly",
    "rollNumber": "15923J",
    "schoolName": "Cloneyhurke NS",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "R32FT51",
    "addressOne": "Cloneyhurke",
    "addressTwo": "Portarlington",
    "addressThree": "Co. Offaly",
    "addressFour": "",
    "lat": "53.1565981",
    "lng": "-7.2733646",
    "phone": "578623271",
    "email": "cloneyhurkens@gmail.com"
  },
  {
    "i": "2424",
    "county": "Offaly",
    "rollNumber": "15983E",
    "schoolName": "SN Naomh Brogain",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "R51E243",
    "addressOne": "Bracknagh",
    "addressTwo": "Rathanagan",
    "addressThree": "Co. Kildare",
    "addressFour": "",
    "lat": "53.2082687",
    "lng": "-7.0946511",
    "phone": "578629047",
    "email": "stbroghans@gmail.com"
  },
  {
    "i": "2425",
    "county": "Offaly",
    "rollNumber": "16013V",
    "schoolName": "Edenderry Convent NS",
    "SETHours": "150",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "R45DA33",
    "addressOne": "School Lane",
    "addressTwo": "Edenderry",
    "addressThree": "Co. Offaly",
    "addressFour": "",
    "lat": "53.338607",
    "lng": "-7.0595341",
    "phone": "469731424",
    "email": "info@stmaryspsedenderry.ie"
  },
  {
    "i": "2426",
    "county": "Offaly",
    "rollNumber": "16160L",
    "schoolName": "Clonaghadoo NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "2",
    "spSNA": "1.66",
    "totalSNA": "3.66",
    "eircode": "R35W427",
    "addressOne": "Clonaghdoo",
    "addressTwo": "Geashill",
    "addressThree": "Co. Offaly",
    "addressFour": "",
    "lat": "53.1798671",
    "lng": "-7.3730361",
    "phone": "578628757",
    "email": "clonaghadoons@eircom.net"
  },
  {
    "i": "2427",
    "county": "Offaly",
    "rollNumber": "16435B",
    "schoolName": "St Ciarans Mixed NS",
    "SETHours": "65",
    "spClassTeachingPosts": "2",
    "mainSNA": "2.83",
    "spSNA": "3",
    "totalSNA": "5.83",
    "eircode": "R35P448",
    "addressOne": "Boher",
    "addressTwo": "Ballycumber",
    "addressThree": "Co. Offaly",
    "addressFour": "",
    "lat": "53.3252695",
    "lng": "-7.7265893",
    "phone": "579336351",
    "email": "stciaransboher@outlook.ie"
  },
  {
    "i": "2428",
    "county": "Offaly",
    "rollNumber": "16620T",
    "schoolName": "Daingean NS",
    "SETHours": "125",
    "spClassTeachingPosts": "2",
    "mainSNA": "4.66",
    "spSNA": "5",
    "totalSNA": "9.66",
    "eircode": "R35AH95",
    "addressOne": "Church Road",
    "addressTwo": "Daingean",
    "addressThree": "Co. Offaly",
    "addressFour": "",
    "lat": "53.2930569",
    "lng": "-7.2892684",
    "phone": "579353337",
    "email": "office@daingeanns.ie"
  },
  {
    "i": "2429",
    "county": "Offaly",
    "rollNumber": "16802C",
    "schoolName": "Ceann Eitigh NS",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.75",
    "spSNA": "0",
    "totalSNA": "1.75",
    "eircode": "R42KD78",
    "addressOne": "Kinnitty",
    "addressTwo": "Birr",
    "addressThree": "Co. Offaly",
    "addressFour": "",
    "lat": "53.0986863",
    "lng": "-7.7160573",
    "phone": "579137052",
    "email": "info@kinnittyns.ie"
  },
  {
    "i": "2430",
    "county": "Offaly",
    "rollNumber": "16928B",
    "schoolName": "SN Naomh Philomena",
    "SETHours": "72.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "1",
    "spSNA": "1",
    "totalSNA": "2",
    "eircode": "R35VK61",
    "addressOne": "Convent Road",
    "addressTwo": "Tullamore",
    "addressThree": "Co. Offaly",
    "addressFour": "",
    "lat": "53.2776772",
    "lng": "-7.4899838",
    "phone": "579321983",
    "email": "info@stphilomenasns.com"
  },
  {
    "i": "2431",
    "county": "Offaly",
    "rollNumber": "16990G",
    "schoolName": "SN Naomh Callin",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.25",
    "spSNA": "0",
    "totalSNA": "1.25",
    "eircode": "N37DD59",
    "addressOne": "Rashinagh",
    "addressTwo": "Ballinahowen",
    "addressThree": "Co. Offaly",
    "addressFour": "",
    "lat": "53.3117053",
    "lng": "-7.8087197",
    "phone": "906454336",
    "email": "rashinans@hotmail.com"
  },
  {
    "i": "2432",
    "county": "Offaly",
    "rollNumber": "17003A",
    "schoolName": "SN Seosamh",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "E53EF68",
    "addressOne": "Moneygall",
    "addressTwo": "Co. Offaly",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.8797412",
    "lng": "-7.9530529",
    "phone": "50545286",
    "email": "moneygallns@gmail.com"
  },
  {
    "i": "2433",
    "county": "Offaly",
    "rollNumber": "17031F",
    "schoolName": "Shinchill NS",
    "SETHours": "127.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "5.99",
    "spSNA": "2",
    "totalSNA": "7.99",
    "eircode": "R35FF20",
    "addressOne": "Shinchill",
    "addressTwo": "Killeigh",
    "addressThree": "Co. Offaly",
    "addressFour": "",
    "lat": "53.2161849",
    "lng": "-7.4493794",
    "phone": "579344349",
    "email": "killeighns.ias@eircom.net"
  },
  {
    "i": "2434",
    "county": "Offaly",
    "rollNumber": "17069H",
    "schoolName": "SN Muire Naofa",
    "SETHours": "60",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "R35K521",
    "addressOne": "Pullough",
    "addressTwo": "Co. Offaly",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.2773784",
    "lng": "-7.7126194",
    "phone": "579355642",
    "email": "pulloughns@gmail.com"
  },
  {
    "i": "2435",
    "county": "Offaly",
    "rollNumber": "17188P",
    "schoolName": "SN Chiarain Naofa",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "N37E227",
    "addressOne": "Clonmacnoise",
    "addressTwo": "Co. Offaly",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3244336",
    "lng": "-7.9879144",
    "phone": "909674150",
    "email": "clonmacnoisns.ias@eircom.net"
  },
  {
    "i": "2436",
    "county": "Offaly",
    "rollNumber": "17336E",
    "schoolName": "SN Mhuire Bainrioghan",
    "SETHours": "32.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "0.75",
    "spSNA": "1.83",
    "totalSNA": "2.58",
    "eircode": "E53ED76",
    "addressOne": "Frankfort",
    "addressTwo": "Dunkerrin",
    "addressThree": "Birr",
    "addressFour": "Co. Offaly",
    "lat": "52.9152584",
    "lng": "-7.9118627",
    "phone": "50545252",
    "email": "office@dunkerrinns.net"
  },
  {
    "i": "2437",
    "county": "Offaly",
    "rollNumber": "17508H",
    "schoolName": "SN Naomh Cholumchille",
    "SETHours": "92.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "R35XY40",
    "addressOne": "Durrow",
    "addressTwo": "Tullamore",
    "addressThree": "Co Offaly",
    "addressFour": "",
    "lat": "53.3307985",
    "lng": "-7.5090904",
    "phone": "579332433",
    "email": "info@durrowns.com"
  },
  {
    "i": "2438",
    "county": "Offaly",
    "rollNumber": "17523D",
    "schoolName": "SN Cronain Naofa",
    "SETHours": "92.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "1.5",
    "spSNA": "5.33",
    "totalSNA": "6.83",
    "eircode": "E53PK37",
    "addressOne": "Drum Ui Cianain",
    "addressTwo": "Roscrea",
    "addressThree": "Co Tipperary",
    "addressFour": "",
    "lat": "52.9755229",
    "lng": "-7.8307662",
    "phone": "50521863",
    "email": "dromakeenan.ias@eircom.net"
  },
  {
    "i": "2439",
    "county": "Offaly",
    "rollNumber": "17540D",
    "schoolName": "SN Mhanachain",
    "SETHours": "97.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "N37T8Y0",
    "addressOne": "Tubber",
    "addressTwo": "Moate",
    "addressThree": "Co. Offaly",
    "addressFour": "",
    "lat": "53.37912",
    "lng": "-7.6616579",
    "phone": "906481501",
    "email": "tubberns@eircom.net"
  },
  {
    "i": "2440",
    "county": "Offaly",
    "rollNumber": "17616K",
    "schoolName": "Naomh Mhuire NS",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "R35T653",
    "addressOne": "Walsh Island",
    "addressTwo": "Geashill",
    "addressThree": "Co Offaly",
    "addressFour": "",
    "lat": "53.2327097",
    "lng": "-7.2215305",
    "phone": "578649686",
    "email": "wislandns.ias@eircom.net"
  },
  {
    "i": "2441",
    "county": "Offaly",
    "rollNumber": "17637S",
    "schoolName": "SN Sheosaimh Naofa",
    "SETHours": "60",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "R35RW26",
    "addressOne": "Ballinagar",
    "addressTwo": "Tullamore",
    "addressThree": "Co. Offaly",
    "addressFour": "",
    "lat": "53.2656774",
    "lng": "-7.3400315",
    "phone": "579343615",
    "email": "ballinagarns@gmail.com"
  },
  {
    "i": "2442",
    "county": "Offaly",
    "rollNumber": "17746A",
    "schoolName": "Scoil Colmain Naofa",
    "SETHours": "142.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "9.49",
    "spSNA": "8",
    "totalSNA": "17.49",
    "eircode": "R35HR63",
    "addressOne": "Mucklagh",
    "addressTwo": "Tullamore",
    "addressThree": "Co. Offaly",
    "addressFour": "",
    "lat": "53.2530145",
    "lng": "-7.5419831",
    "phone": "579341244",
    "email": "principal@mucklaghns.ie"
  },
  {
    "i": "2443",
    "county": "Offaly",
    "rollNumber": "17753U",
    "schoolName": "SN Chiarain Naofa",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "R42P766",
    "addressOne": "Broughall",
    "addressTwo": "Kilcormac",
    "addressThree": "Birr",
    "addressFour": "Co. Offaly",
    "lat": "53.1907875",
    "lng": "-7.7741925",
    "phone": "579135072",
    "email": "broughallns@gmail.com"
  },
  {
    "i": "2444",
    "county": "Laois",
    "rollNumber": "17827A",
    "schoolName": "Scoil Phadraig",
    "SETHours": "227.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "5.5",
    "spSNA": "4",
    "totalSNA": "9.5",
    "eircode": "R32Y6K7",
    "addressOne": "Canal Road",
    "addressTwo": "Portarlington",
    "addressThree": "Co. Laois",
    "addressFour": "",
    "lat": "53.1498506",
    "lng": "-7.1769438",
    "phone": "578623394",
    "email": "info@stpatricksbns.ie"
  },
  {
    "i": "2445",
    "county": "Offaly",
    "rollNumber": "18057F",
    "schoolName": "Scoil Mhuire",
    "SETHours": "182.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "3.08",
    "spSNA": "4.75",
    "totalSNA": "7.83",
    "eircode": "R35K250",
    "addressOne": "Kilcruttin",
    "addressTwo": "Tullamore",
    "addressThree": "Co. Offaly",
    "addressFour": "",
    "lat": "53.271717",
    "lng": "-7.4999389",
    "phone": "579321222",
    "email": "secretary@scoilmhuiretullamore.ie"
  },
  {
    "i": "2446",
    "county": "Offaly",
    "rollNumber": "18068K",
    "schoolName": "SN Peadar Agus Pol",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "N37E335",
    "addressOne": "Ath An Urchair",
    "addressTwo": "Moate",
    "addressThree": "Co Offaly",
    "addressFour": "",
    "lat": "53.3932837",
    "lng": "-7.5827399",
    "phone": "579335282",
    "email": "sspeterandpaulsns@gmail.com"
  },
  {
    "i": "2447",
    "county": "Offaly",
    "rollNumber": "18115Q",
    "schoolName": "SN Mhuire",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "R35NP58",
    "addressOne": "Cloneygowan",
    "addressTwo": "Tullamore",
    "addressThree": "Co. Offaly",
    "addressFour": "",
    "lat": "53.1867747",
    "lng": "-7.2821296",
    "phone": "579343594",
    "email": "cloneygowan.ias@eircom.net"
  },
  {
    "i": "2448",
    "county": "Offaly",
    "rollNumber": "18157J",
    "schoolName": "St Rynaghs NS",
    "SETHours": "115",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.33",
    "spSNA": "0",
    "totalSNA": "2.33",
    "eircode": "R42H221",
    "addressOne": "Banagher",
    "addressTwo": "Birr",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.1871696",
    "lng": "-7.9841908",
    "phone": "579151419",
    "email": "strynaghsns.ias@eircom.net"
  },
  {
    "i": "2449",
    "county": "Offaly",
    "rollNumber": "18267Q",
    "schoolName": "Croinchoill NS",
    "SETHours": "125",
    "spClassTeachingPosts": "2",
    "mainSNA": "3.83",
    "spSNA": "3.49",
    "totalSNA": "7.32",
    "eircode": "R42P585",
    "addressOne": "Crinkill",
    "addressTwo": "Birr",
    "addressThree": "Co Offaly",
    "addressFour": "",
    "lat": "53.0801651",
    "lng": "-7.8960703",
    "phone": "579120803",
    "email": "crinkillns@eircom.net"
  },
  {
    "i": "2450",
    "county": "Offaly",
    "rollNumber": "18328K",
    "schoolName": "SN Phadraig",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.33",
    "spSNA": "0",
    "totalSNA": "3.33",
    "eircode": "R35X670",
    "addressOne": "Ballybryan",
    "addressTwo": "Fahy",
    "addressThree": "Co. Offaly",
    "addressFour": "",
    "lat": "53.3560905",
    "lng": "-7.1496785",
    "phone": "469737365",
    "email": "ballybryan.ias@eircom.net"
  },
  {
    "i": "2451",
    "county": "Offaly",
    "rollNumber": "18331W",
    "schoolName": "SN Caoimhin Naofa",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "R42K702",
    "addressOne": "Clonlisk NS",
    "addressTwo": "Shinrone",
    "addressThree": "Birr",
    "addressFour": "",
    "lat": "52.9477674",
    "lng": "-7.9097961",
    "phone": "50547421",
    "email": "clonlisk@gmail.com"
  },
  {
    "i": "2452",
    "county": "Offaly",
    "rollNumber": "18335H",
    "schoolName": "SN Mhuire Naofa",
    "SETHours": "80",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "R35KD66",
    "addressOne": "Rathcobican",
    "addressTwo": "Rhode",
    "addressThree": "Co. Offaly",
    "addressFour": "",
    "lat": "53.3395366",
    "lng": "-7.1977344",
    "phone": "469737456",
    "email": "rhodens.ias@eircom.net"
  },
  {
    "i": "2453",
    "county": "Offaly",
    "rollNumber": "18364O",
    "schoolName": "St Patrick's NS",
    "SETHours": "90",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "R45XV22",
    "addressOne": "Gilroy Avenue",
    "addressTwo": "Edenderry",
    "addressThree": "Co.offaly",
    "addressFour": "",
    "lat": "53.339774",
    "lng": "-7.0628159",
    "phone": "469731478",
    "email": "bnsedenderry@gmail.com"
  },
  {
    "i": "2454",
    "county": "Offaly",
    "rollNumber": "18399K",
    "schoolName": "SN Bhride",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "R42Y840",
    "addressOne": "Ballyboy",
    "addressTwo": "Kilcormac",
    "addressThree": "Co. Offaly",
    "addressFour": "",
    "lat": "53.1742189",
    "lng": "-7.6961149",
    "phone": "579135055",
    "email": "ballyboyns@gmail.com"
  },
  {
    "i": "2455",
    "county": "Offaly",
    "rollNumber": "18406E",
    "schoolName": "SN Phroinsiais Naofa",
    "SETHours": "155",
    "spClassTeachingPosts": "3",
    "mainSNA": "5.66",
    "spSNA": "7.5",
    "totalSNA": "13.16",
    "eircode": "R35TP08",
    "addressOne": "Kilbeggan Road",
    "addressTwo": "Clara",
    "addressThree": "Co. Offaly",
    "addressFour": "",
    "lat": "53.3416297",
    "lng": "-7.6090079",
    "phone": "579331383",
    "email": "office@stfrancisbns.ie"
  },
  {
    "i": "2456",
    "county": "Offaly",
    "rollNumber": "18524K",
    "schoolName": "SN Naomh Brighde Buach",
    "SETHours": "97.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "4",
    "spSNA": "2",
    "totalSNA": "6",
    "eircode": "R35N406",
    "addressOne": "Kilcruttin",
    "addressTwo": "Tullamore",
    "addressThree": "Co. Offaly",
    "addressFour": "",
    "lat": "53.2723415",
    "lng": "-7.5006038",
    "phone": "579321194",
    "email": "scoilbhridepo@eircom.net"
  },
  {
    "i": "2457",
    "county": "Offaly",
    "rollNumber": "18537T",
    "schoolName": "SN Ros Com Rua",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "E53TY38",
    "addressOne": "Roscomroe",
    "addressTwo": "Roscrea",
    "addressThree": "Co. Offaly",
    "addressFour": "",
    "lat": "53.020259",
    "lng": "-7.7575834",
    "phone": "579131060",
    "email": "roscomroens@eircom.net"
  },
  {
    "i": "2458",
    "county": "Offaly",
    "rollNumber": "18690E",
    "schoolName": "Scoil Bhride",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.33",
    "spSNA": "0",
    "totalSNA": "1.33",
    "eircode": "R35T974",
    "addressOne": "An Cruachán",
    "addressTwo": "An Tulach Mhór",
    "addressThree": "Co. Í­bh Fhailí­",
    "addressFour": "",
    "lat": "53.3406682",
    "lng": "-7.2777638",
    "phone": "469737465",
    "email": "croghanschool@eircom.net"
  },
  {
    "i": "2459",
    "county": "Offaly",
    "rollNumber": "18777Q",
    "schoolName": "SN Lomchluana",
    "SETHours": "25",
    "spClassTeachingPosts": "2",
    "mainSNA": "1.5",
    "spSNA": "4",
    "totalSNA": "5.5",
    "eircode": "R42Y744",
    "addressOne": "Lumcloon",
    "addressTwo": "Cloghan",
    "addressThree": "Birr",
    "addressFour": "Co. Offaly",
    "lat": "53.2198313",
    "lng": "-7.7971989",
    "phone": "579345224",
    "email": "school@lumcloon.net"
  },
  {
    "i": "2460",
    "county": "Offaly",
    "rollNumber": "18795S",
    "schoolName": "SN Mhuire",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "R35K201",
    "addressOne": "Coolanarney",
    "addressTwo": "Blueball",
    "addressThree": "Co. Offaly",
    "addressFour": "",
    "lat": "53.234479",
    "lng": "-7.6423501",
    "phone": "579354934",
    "email": "coolanarney.ias@gmail.com"
  },
  {
    "i": "2461",
    "county": "Offaly",
    "rollNumber": "18797W",
    "schoolName": "St. Joseph's NS",
    "SETHours": "245",
    "spClassTeachingPosts": "3",
    "mainSNA": "7.32",
    "spSNA": "4.83",
    "totalSNA": "12.15",
    "eircode": "R35PH94",
    "addressOne": "Ardan View",
    "addressTwo": "Tullamore",
    "addressThree": "Co. Offaly",
    "addressFour": "",
    "lat": "53.281544",
    "lng": "-7.4948507",
    "phone": "579341121",
    "email": "info@stjosephstullamore.ie"
  },
  {
    "i": "2462",
    "county": "Offaly",
    "rollNumber": "19354Q",
    "schoolName": "St Colmans NS",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "R35Y635",
    "addressOne": "Cappagh",
    "addressTwo": "Croghan",
    "addressThree": "Tullamore",
    "addressFour": "Co. Offaly",
    "lat": "53.3255297",
    "lng": "-7.3675377",
    "phone": "449223452",
    "email": "stcolmansns1@gmail.com"
  },
  {
    "i": "2463",
    "county": "Offaly",
    "rollNumber": "19638H",
    "schoolName": "Coolderry Central Ns",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "R42ER23",
    "addressOne": "Brosna",
    "addressTwo": "Birr",
    "addressThree": "Co Offaly",
    "addressFour": "",
    "lat": "53.0121592",
    "lng": "-7.841616",
    "phone": "579131152",
    "email": "infocoolderryns@gmail.com"
  },
  {
    "i": "2464",
    "county": "Offaly",
    "rollNumber": "19713S",
    "schoolName": "Arden Boys Ns",
    "SETHours": "90",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "R35HN70",
    "addressOne": "Arden View",
    "addressTwo": "Tullamore",
    "addressThree": "Co. Offaly",
    "addressFour": "",
    "lat": "53.2812639",
    "lng": "-7.4959016",
    "phone": "579351894",
    "email": "eoinphoil@eircom.net"
  },
  {
    "i": "2465",
    "county": "Offaly",
    "rollNumber": "19990V",
    "schoolName": "Gaelscoil An Eiscir Riada",
    "SETHours": "70",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "R35YP90",
    "addressOne": "Cluain Calga",
    "addressTwo": "An Tulach Mhor",
    "addressThree": "Co. Uibh Fhaili",
    "addressFour": "",
    "lat": "53.2692691",
    "lng": "-7.4766659",
    "phone": "579352058",
    "email": "oifig@eriada.ie"
  },
  {
    "i": "2466",
    "county": "Offaly",
    "rollNumber": "20068W",
    "schoolName": "St Marys NS",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "R42E521",
    "addressOne": "Cloghan",
    "addressTwo": "Birr",
    "addressThree": "Co Offaly",
    "addressFour": "",
    "lat": "53.2249847",
    "lng": "-7.8859845",
    "phone": "906457421",
    "email": "stmarysnscloghan@gmail.com"
  },
  {
    "i": "2467",
    "county": "Offaly",
    "rollNumber": "20189L",
    "schoolName": "Tullamore Educate Together Ns",
    "SETHours": "85",
    "spClassTeachingPosts": "2",
    "mainSNA": "0.83",
    "spSNA": "4",
    "totalSNA": "4.83",
    "eircode": "R35AX22",
    "addressOne": "Collins Lane",
    "addressTwo": "Tullamore",
    "addressThree": "Co. Offaly",
    "addressFour": "",
    "lat": "53.2917637",
    "lng": "-7.5036909",
    "phone": "579361190",
    "email": "cathylyons2@gmail.com"
  },
  {
    "i": "2468",
    "county": "Offaly",
    "rollNumber": "20267F",
    "schoolName": "Scoil Bhrí­de Primary School",
    "SETHours": "330",
    "spClassTeachingPosts": "6",
    "mainSNA": "4.33",
    "spSNA": "13.15",
    "totalSNA": "17.48",
    "eircode": "R45X951",
    "addressOne": "Killane",
    "addressTwo": "Edenderry",
    "addressThree": "Co. Offaly",
    "addressFour": "",
    "lat": "53.337649",
    "lng": "-7.0718494",
    "phone": "469773451",
    "email": "info@scoilbhrideps.com"
  },
  {
    "i": "2469",
    "county": "Offaly",
    "rollNumber": "20273A",
    "schoolName": "SN Chartaigh Naofa",
    "SETHours": "87.5",
    "spClassTeachingPosts": "5",
    "mainSNA": "2.5",
    "spSNA": "8.3",
    "totalSNA": "10.8",
    "eircode": "R35P263",
    "addressOne": "Rahan",
    "addressTwo": "Tullamore",
    "addressThree": "Co. Offaly",
    "addressFour": "",
    "lat": "53.2821101",
    "lng": "-7.6228601",
    "phone": "579355393",
    "email": "rahannationalschool@gmail.com"
  },
  {
    "i": "2470",
    "county": "Offaly",
    "rollNumber": "20289P",
    "schoolName": "St. Cynoc's NS",
    "SETHours": "77.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "R42P803",
    "addressOne": "Ferbane",
    "addressTwo": "Co. Offaly",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.272188",
    "lng": "-7.830795",
    "phone": "906454249",
    "email": "stcynocsns@gmail.com"
  },
  {
    "i": "2471",
    "county": "Offaly",
    "rollNumber": "20332N",
    "schoolName": "Gaelscoil éadan Doire",
    "SETHours": "65",
    "spClassTeachingPosts": "1",
    "mainSNA": "1.5",
    "spSNA": "1",
    "totalSNA": "2.5",
    "eircode": "R45ED89",
    "addressOne": "Cill Anna",
    "addressTwo": "éadan Doire",
    "addressThree": "Co Í­bh Fhailí­",
    "addressFour": "",
    "lat": "53.3389929",
    "lng": "-7.0715275",
    "phone": "469773322",
    "email": "gaelscoileadandoire@gmail.com"
  },
  {
    "i": "2472",
    "county": "Offaly",
    "rollNumber": "20387P",
    "schoolName": "Scoil Mhuire Agus Chormaic",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "R42RC92",
    "addressOne": "Kilcormac",
    "addressTwo": "Co. Offaly",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.1746013",
    "lng": "-7.7247755",
    "phone": "579135181",
    "email": "kilcormacgns@gmail.com"
  },
  {
    "i": "2473",
    "county": "Offaly",
    "rollNumber": "20461B",
    "schoolName": "Gaelscoil Na Laochra",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "R42P821",
    "addressOne": "Sandymount Haven",
    "addressTwo": "Birr",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.097821",
    "lng": "-7.9012832",
    "phone": "874394549",
    "email": "gaelscoilnalaochra@outlook.com"
  },
  {
    "i": "2474",
    "county": "Roscommon",
    "rollNumber": "01086R",
    "schoolName": "SN Pol Naofa",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F45FK09",
    "addressOne": "Church Road",
    "addressTwo": "Castlerea",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.7651327",
    "lng": "-8.4837294",
    "phone": "949620566",
    "email": "boysnscastlerea.ias@gmail.com"
  },
  {
    "i": "2475",
    "county": "Roscommon",
    "rollNumber": "01607T",
    "schoolName": "SN Cor Na Fola B",
    "SETHours": "130",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "N37FW74",
    "addressOne": "Cornafulla",
    "addressTwo": "Athlone",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.3753227",
    "lng": "-8.005243",
    "phone": "906437177",
    "email": "principal@cornafullans.ie"
  },
  {
    "i": "2476",
    "county": "Roscommon",
    "rollNumber": "01866U",
    "schoolName": "Ballyforan Mixed NS",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H53WN36",
    "addressOne": "Ballyforan",
    "addressTwo": "Ballinasloe",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.4698407",
    "lng": "-8.2738339",
    "phone": "906622300",
    "email": "ballyforanns@gmail.com"
  },
  {
    "i": "2477",
    "county": "Roscommon",
    "rollNumber": "04800F",
    "schoolName": "Rooskey NS",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "N41DH36",
    "addressOne": "Rooskey",
    "addressTwo": "Carrick-on-shannon",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.8326376",
    "lng": "-7.9275006",
    "phone": "719638774",
    "email": "rooskeyns@gmail.com"
  },
  {
    "i": "2478",
    "county": "Roscommon",
    "rollNumber": "05220P",
    "schoolName": "SN Michil Naofa",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "N41XD40",
    "addressOne": "Woodbrook",
    "addressTwo": "Carrick-on-shannon",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.9410463",
    "lng": "-8.1660365",
    "phone": "719621771",
    "email": "woodbrookns@gmail.com"
  },
  {
    "i": "2479",
    "county": "Roscommon",
    "rollNumber": "06100K",
    "schoolName": "SN Cill Ronain",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F52P602",
    "addressOne": "Keadue West",
    "addressTwo": "Boyle",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "54.0501643",
    "lng": "-8.1365105",
    "phone": "719647503",
    "email": "scoilcillronain@gmail.com"
  },
  {
    "i": "2480",
    "county": "Roscommon",
    "rollNumber": "10967E",
    "schoolName": "Threen NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F45FP60",
    "addressOne": "Trien",
    "addressTwo": "Castlerea",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.7323928",
    "lng": "-8.552698",
    "phone": "949621330",
    "email": "thrnns56@gmail.com"
  },
  {
    "i": "2481",
    "county": "Roscommon",
    "rollNumber": "11201U",
    "schoolName": "SN Naomh Padraig",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "N41N276",
    "addressOne": "Scrabbagh",
    "addressTwo": "Kilmore",
    "addressThree": "Carrick-on-shannon",
    "addressFour": "Co. Roscommon",
    "lat": "53.8709843",
    "lng": "-8.0288231",
    "phone": "719637245",
    "email": "scrabbaghns@gmail.com"
  },
  {
    "i": "2482",
    "county": "Roscommon",
    "rollNumber": "11242L",
    "schoolName": "Cloonbonnif NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "F45FX92",
    "addressOne": "Cloonbonniffe",
    "addressTwo": "Castlerea",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.7810705",
    "lng": "-8.5821555",
    "phone": "949640388",
    "email": "cbns1875@gmail.com"
  },
  {
    "i": "2483",
    "county": "Roscommon",
    "rollNumber": "11466K",
    "schoolName": "Lismoil NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "N37W291",
    "addressOne": "Ballyline",
    "addressTwo": "Curraghboy",
    "addressThree": "Athlone",
    "addressFour": "Co. Roscommon",
    "lat": "53.4999839",
    "lng": "-8.160211",
    "phone": "906623373",
    "email": "aidanns.ias@eircom.net"
  },
  {
    "i": "2484",
    "county": "Roscommon",
    "rollNumber": "11943S",
    "schoolName": "Ballinlough NS",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F45RY86",
    "addressOne": "Ballinlough",
    "addressTwo": "Co. Roscommon",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.7412503",
    "lng": "-8.6355799",
    "phone": "949640477",
    "email": "ballinloughschool@yahoo.com"
  },
  {
    "i": "2485",
    "county": "Roscommon",
    "rollNumber": "12003V",
    "schoolName": "SN Ronain",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "N37XP77",
    "addressOne": "Castlesampson",
    "addressTwo": "Bealnamulla",
    "addressThree": "Athlone",
    "addressFour": "Co. Roscommon",
    "lat": "53.412708",
    "lng": "-8.0970735",
    "phone": "909683840",
    "email": "castlesampsonns@gmail.com"
  },
  {
    "i": "2486",
    "county": "Roscommon",
    "rollNumber": "12754U",
    "schoolName": "SN Cnoc An Samhraidh",
    "SETHours": "145",
    "spClassTeachingPosts": "3",
    "mainSNA": "6",
    "spSNA": "6",
    "totalSNA": "12",
    "eircode": "N37NY98",
    "addressOne": "Crannagh",
    "addressTwo": "Summerhill",
    "addressThree": "Athlone",
    "addressFour": "Co. Roscommon",
    "lat": "53.4110685",
    "lng": "-7.9875988",
    "phone": "906492037",
    "email": "summerhillns2018@gmail.com"
  },
  {
    "i": "2487",
    "county": "Roscommon",
    "rollNumber": "12964I",
    "schoolName": "SN Naomh Seosamh",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F42PW52",
    "addressOne": "Corroy",
    "addressTwo": "Ballymurray",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.5884573",
    "lng": "-8.1215799",
    "phone": "906661217",
    "email": "ballymurrayns@gmail.com"
  },
  {
    "i": "2488",
    "county": "Roscommon",
    "rollNumber": "13047A",
    "schoolName": "SN Lios A Cuill M",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "F45CX86",
    "addressOne": "Corracoggil North",
    "addressTwo": "Lisacul",
    "addressThree": "Castlerea",
    "addressFour": "Co. Roscommon",
    "lat": "53.8539906",
    "lng": "-8.6309804",
    "phone": "949880383",
    "email": "lisaculns@hotmail.com"
  },
  {
    "i": "2489",
    "county": "Roscommon",
    "rollNumber": "13198V",
    "schoolName": "St Annes Con NS",
    "SETHours": "62.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "F45WN59",
    "addressOne": "The Square",
    "addressTwo": "Castlerea",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.766325",
    "lng": "-8.4864534",
    "phone": "949620482",
    "email": "anneschool@eircom.net"
  },
  {
    "i": "2490",
    "county": "Roscommon",
    "rollNumber": "13262E",
    "schoolName": "Clover Hill NS",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "F42KH29",
    "addressOne": "Lisagallan",
    "addressTwo": "Cloverhill",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.6529185",
    "lng": "-8.2520551",
    "phone": "906625854",
    "email": "cloverhillns@campus.ie"
  },
  {
    "i": "2491",
    "county": "Roscommon",
    "rollNumber": "13498K",
    "schoolName": "Cloonfour NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "N41CH63",
    "addressOne": "Cloonfour",
    "addressTwo": "Rooskey",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.78341",
    "lng": "-7.9207749",
    "phone": "719638177",
    "email": "cloonfourns@hotmail.com"
  },
  {
    "i": "2492",
    "county": "Roscommon",
    "rollNumber": "13757I",
    "schoolName": "Tarmon NS",
    "SETHours": "95",
    "spClassTeachingPosts": "5",
    "mainSNA": "2.83",
    "spSNA": "9.98",
    "totalSNA": "12.81",
    "eircode": "F45K298",
    "addressOne": "Tarmon",
    "addressTwo": "Castlerea",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.7708548",
    "lng": "-8.438523",
    "phone": "949621143",
    "email": "office@tarmonns.ie"
  },
  {
    "i": "2493",
    "county": "Roscommon",
    "rollNumber": "13839K",
    "schoolName": "Carrick NS",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "N37EK20",
    "addressOne": "Carrick",
    "addressTwo": "Curraghboy",
    "addressThree": "Athlone",
    "addressFour": "Co. Westmeath",
    "lat": "53.4826321",
    "lng": "-8.1072219",
    "phone": "906488293",
    "email": "curraghboyns@yahoo.co.uk"
  },
  {
    "i": "2494",
    "county": "Roscommon",
    "rollNumber": "13879W",
    "schoolName": "Slatta NS",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "F42R796",
    "addressOne": "Moher",
    "addressTwo": "Kilglass",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.7964715",
    "lng": "-7.9798197",
    "phone": "719638818",
    "email": "slattans@gmail.com"
  },
  {
    "i": "2495",
    "county": "Roscommon",
    "rollNumber": "13978B",
    "schoolName": "SN Naomh Padraig",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F52CX60",
    "addressOne": "Ballyfarnon",
    "addressTwo": "Boyle",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "54.0680274",
    "lng": "-8.1994952",
    "phone": "719647232",
    "email": "ballyfarnonns@gmail.com"
  },
  {
    "i": "2496",
    "county": "Roscommon",
    "rollNumber": "14049J",
    "schoolName": "Whitehall NS",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "N39P226",
    "addressOne": "Whitehall",
    "addressTwo": "Tarmonbarry",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.7579802",
    "lng": "-7.9351162",
    "phone": "433326399",
    "email": "whitehall.ns@hotmail.com"
  },
  {
    "i": "2497",
    "county": "Roscommon",
    "rollNumber": "14056G",
    "schoolName": "Mount Talbot NS",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "F42P767",
    "addressOne": "Mount Talbot",
    "addressTwo": "Co. Roscommon",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.5302541",
    "lng": "-8.2821966",
    "phone": "906624014",
    "email": "mounttalbotns@gmail.com"
  },
  {
    "i": "2498",
    "county": "Roscommon",
    "rollNumber": "14356S",
    "schoolName": "Lisaniskey NS",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F42K226",
    "addressOne": "Ballymacfarrane",
    "addressTwo": "Donamon",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.6587916",
    "lng": "-8.3391692",
    "phone": "906662730",
    "email": "info@lisaniskeyns.com"
  },
  {
    "i": "2499",
    "county": "Roscommon",
    "rollNumber": "14684M",
    "schoolName": "Aughrim NS",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "N41EY63",
    "addressOne": "Hillstreet",
    "addressTwo": "Carrick-on-shannon",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.8717867",
    "lng": "-8.1224238",
    "phone": "719635596",
    "email": "jfaughnan81@hotmail.com"
  },
  {
    "i": "2500",
    "county": "Roscommon",
    "rollNumber": "14925I",
    "schoolName": "SN Naomh Eoin",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F52W662",
    "addressOne": "Ballinameen",
    "addressTwo": "Boyle",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.9018592",
    "lng": "-8.3077021",
    "phone": "719668344",
    "email": "ballinameenschool@gmail.com"
  },
  {
    "i": "2501",
    "county": "Roscommon",
    "rollNumber": "14966W",
    "schoolName": "Kilteevan NS",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F42YY76",
    "addressOne": "Kilteevan",
    "addressTwo": "Co. Roscommon",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.6355277",
    "lng": "-8.1149078",
    "phone": "906625936",
    "email": "kilteevannsoffice@gmail.com"
  },
  {
    "i": "2503",
    "county": "Roscommon",
    "rollNumber": "15045G",
    "schoolName": "SN Naomh Padraig",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F42DK16",
    "addressOne": "Elphin Street",
    "addressTwo": "Strokestown",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.7811358",
    "lng": "-8.1043943",
    "phone": "719633409",
    "email": "stpatricksbns@gmail.com"
  },
  {
    "i": "2504",
    "county": "Roscommon",
    "rollNumber": "15255R",
    "schoolName": "Don NS",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "F45XV82",
    "addressOne": "Ballaghadereen",
    "addressTwo": "Co. Roscommon",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.8624213",
    "lng": "-8.5437845",
    "phone": "949880478",
    "email": "donns.ias@eircom.net"
  },
  {
    "i": "2505",
    "county": "Roscommon",
    "rollNumber": "15308M",
    "schoolName": "Athleague NS",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "F42VF95",
    "addressOne": "Athleague",
    "addressTwo": "Co. Roscommon",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.5677643",
    "lng": "-8.2490723",
    "phone": "906663420",
    "email": "athleaguens@gmail.com"
  },
  {
    "i": "2506",
    "county": "Roscommon",
    "rollNumber": "15413J",
    "schoolName": "Brideswell NS",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "N37P838",
    "addressOne": "Brideswell",
    "addressTwo": "Athlone",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.4528906",
    "lng": "-8.0887108",
    "phone": "906488272",
    "email": "brideswellns@gmail.com"
  },
  {
    "i": "2507",
    "county": "Roscommon",
    "rollNumber": "15425Q",
    "schoolName": "Fairymount NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F45AK07",
    "addressOne": "Fairymount",
    "addressTwo": "Castlerea",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.8466775",
    "lng": "-8.4847923",
    "phone": "949870655",
    "email": "fairymountns@gmail.com"
  },
  {
    "i": "2508",
    "county": "Roscommon",
    "rollNumber": "15531P",
    "schoolName": "Scoil Mhuire,",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "H53V270",
    "addressOne": "Newtown",
    "addressTwo": "Ballinasloe",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.3586413",
    "lng": "-8.2132763",
    "phone": "909643043",
    "email": "newtownnatschool@eircom.net"
  },
  {
    "i": "2509",
    "county": "Roscommon",
    "rollNumber": "15543W",
    "schoolName": "Tibohine NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F45A892",
    "addressOne": "Teevnacreeva",
    "addressTwo": "Tibohine",
    "addressThree": "Castlerea",
    "addressFour": "Co. Roscommon",
    "lat": "53.8858535",
    "lng": "-8.5037434",
    "phone": "949870729",
    "email": "tibohinens@gmail.com"
  },
  {
    "i": "2510",
    "county": "Roscommon",
    "rollNumber": "15545D",
    "schoolName": "Castleplunkett NS",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F45YA40",
    "addressOne": "Castleplunkett",
    "addressTwo": "Castlerea",
    "addressThree": "Co Roscommon",
    "addressFour": "",
    "lat": "53.7513436",
    "lng": "-8.3471129",
    "phone": "949651260",
    "email": "castleplunkettns1@gmail.com"
  },
  {
    "i": "2511",
    "county": "Roscommon",
    "rollNumber": "15557K",
    "schoolName": "Cloonfad NS",
    "SETHours": "70",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "F35W407",
    "addressOne": "Cloonfad",
    "addressTwo": "Ballyhaunis",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.686176",
    "lng": "-8.7523864",
    "phone": "949646259",
    "email": "cloonfadns@eircom.net"
  },
  {
    "i": "2512",
    "county": "Roscommon",
    "rollNumber": "15584N",
    "schoolName": "Grange NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F52CX43",
    "addressOne": "Boyle",
    "addressTwo": "Co. Roscommon",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.9361419",
    "lng": "-8.3151169",
    "phone": "719663424",
    "email": "grangensboyle@gmail.com"
  },
  {
    "i": "2513",
    "county": "Roscommon",
    "rollNumber": "15614T",
    "schoolName": "Taughmaconnell NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "H53DX66",
    "addressOne": "Taughmaconnell",
    "addressTwo": "Ballinasloe",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.4011639",
    "lng": "-8.1461556",
    "phone": "894497540",
    "email": "taughmaconnellns@gmail.com"
  },
  {
    "i": "2515",
    "county": "Roscommon",
    "rollNumber": "15664L",
    "schoolName": "Granlahan GNS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F45FN12",
    "addressOne": "Granlahan",
    "addressTwo": "Ballinlough",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.71516",
    "lng": "-8.6751546",
    "phone": "949640366",
    "email": "granlahan_ns@yahoo.ie"
  },
  {
    "i": "2516",
    "county": "Roscommon",
    "rollNumber": "15980V",
    "schoolName": "Camcloon NS",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "N37YN56",
    "addressOne": "Ballydangan",
    "addressTwo": "Athlone",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.3507264",
    "lng": "-8.0612523",
    "phone": "909673437",
    "email": "camcloonns@gmail.com"
  },
  {
    "i": "2517",
    "county": "Roscommon",
    "rollNumber": "16009H",
    "schoolName": "Carrick Mixed NS",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F45PV27",
    "addressOne": "Ballinlough",
    "addressTwo": "Co. Roscommon",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.7485886",
    "lng": "-8.6523832",
    "phone": "949640411",
    "email": "carrickns@outlook.com"
  },
  {
    "i": "2518",
    "county": "Roscommon",
    "rollNumber": "16034G",
    "schoolName": "Tulsk NS",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F45VE84",
    "addressOne": "Tulsk",
    "addressTwo": "Castlerea",
    "addressThree": "Co Roscommon",
    "addressFour": "",
    "lat": "53.7755821",
    "lng": "-8.2429161",
    "phone": "719639287",
    "email": "tulsknationalschool@gmail.com"
  },
  {
    "i": "2519",
    "county": "Roscommon",
    "rollNumber": "16127N",
    "schoolName": "Gorthaganny NS",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.25",
    "spSNA": "0",
    "totalSNA": "1.25",
    "eircode": "F45C951",
    "addressOne": "Gortaganny",
    "addressTwo": "Loughglynn",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.8079861",
    "lng": "-8.6758431",
    "phone": "949649323",
    "email": "gorthaganny@hotmail.com"
  },
  {
    "i": "2520",
    "county": "Roscommon",
    "rollNumber": "16291D",
    "schoolName": "Clooncagh NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F42V580",
    "addressOne": "Clooncagh",
    "addressTwo": "Stokestown",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.7159508",
    "lng": "-8.1035311",
    "phone": "719633253",
    "email": "clooncaghschool@gmail.com"
  },
  {
    "i": "2521",
    "county": "Roscommon",
    "rollNumber": "16334S",
    "schoolName": "St. Bride's NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F45RR67",
    "addressOne": "Ballintubber",
    "addressTwo": "Castlerea",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.7187121",
    "lng": "-8.4102486",
    "phone": "949655276",
    "email": "stbridesns@gmail.com"
  },
  {
    "i": "2522",
    "county": "Roscommon",
    "rollNumber": "16427C",
    "schoolName": "Clonown NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "N37E0W0",
    "addressOne": "Athlone",
    "addressTwo": "Co. Roscommon",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.366258",
    "lng": "-7.9332658",
    "phone": "906437448",
    "email": "clonownns@gmail.com"
  },
  {
    "i": "2523",
    "county": "Roscommon",
    "rollNumber": "16815L",
    "schoolName": "SN Naomh Ceitheach",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F42Y260",
    "addressOne": "Runnamoat",
    "addressTwo": "Ballymacurley",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.689698",
    "lng": "-8.3008359",
    "phone": "906662686",
    "email": "naomhceitheach@gmail.com"
  },
  {
    "i": "2524",
    "county": "Roscommon",
    "rollNumber": "17054R",
    "schoolName": "SN Ard Cianain",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "N37HW25",
    "addressOne": "Drum",
    "addressTwo": "Athlone",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.3889902",
    "lng": "-8.0535364",
    "phone": "906437244",
    "email": "ardkeenanns@gmail.com"
  },
  {
    "i": "2525",
    "county": "Roscommon",
    "rollNumber": "17100V",
    "schoolName": "SN Rath Aradh",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F42XR20",
    "addressOne": "Athleague Road",
    "addressTwo": "Rahara",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.5251599",
    "lng": "-8.1450832",
    "phone": "906623393",
    "email": "raharans@gmail.com"
  },
  {
    "i": "2526",
    "county": "Roscommon",
    "rollNumber": "17266J",
    "schoolName": "Ballanagare NS",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F45W288",
    "addressOne": "Ballinagare",
    "addressTwo": "Castlerea",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.8346906",
    "lng": "-8.3755538",
    "phone": "949870564",
    "email": "ballinagarens@eircom.net"
  },
  {
    "i": "2527",
    "county": "Roscommon",
    "rollNumber": "17329H",
    "schoolName": "SN Paroisteach",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F52H280",
    "addressOne": "Boyle",
    "addressTwo": "Co. Roscommon",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.9740115",
    "lng": "-8.2993376",
    "phone": "719663555",
    "email": "pnsboyle@gmail.com"
  },
  {
    "i": "2528",
    "county": "Roscommon",
    "rollNumber": "17353E",
    "schoolName": "SN Cill Trostain",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F42K250",
    "addressOne": "Strokestown",
    "addressTwo": "Co Roscommon",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.8157831",
    "lng": "-8.1029436",
    "phone": "719633965",
    "email": "kiltrustannationalschool@gmail.com"
  },
  {
    "i": "2530",
    "county": "Roscommon",
    "rollNumber": "17571O",
    "schoolName": "Dangan Ns",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "N41RC79",
    "addressOne": "Dangan",
    "addressTwo": "Kilmore",
    "addressThree": "Carrick-on-shannon",
    "addressFour": "Co. Roscommon",
    "lat": "53.894742",
    "lng": "-8.0294964",
    "phone": "719637003",
    "email": "dangankilmore48@gmail.com"
  },
  {
    "i": "2531",
    "county": "Roscommon",
    "rollNumber": "17622F",
    "schoolName": "SN Lasair Naofa",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "N41FX64",
    "addressOne": "Greaghnafarna",
    "addressTwo": "Arigna",
    "addressThree": "Carrick On Shannon",
    "addressFour": "Co. Roscommon",
    "lat": "54.092826",
    "lng": "-8.1153876",
    "phone": "719646227",
    "email": "greaghnafarna@gmail.com"
  },
  {
    "i": "2532",
    "county": "Roscommon",
    "rollNumber": "17709R",
    "schoolName": "SN Naomh Mhuire",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "N41X677",
    "addressOne": "Drumboylan",
    "addressTwo": "Leitrim P.o.",
    "addressThree": "Carrick-on-shannon",
    "addressFour": "Co. Roscommon",
    "lat": "54.0166997",
    "lng": "-8.1075369",
    "phone": "719621724",
    "email": "drumboylanns@gmail.com"
  },
  {
    "i": "2533",
    "county": "Roscommon",
    "rollNumber": "17748E",
    "schoolName": "SN Padraig Naofa",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "F45FD34",
    "addressOne": "Dúngar (frenchpark)",
    "addressTwo": "An Caisleáin Riabhach",
    "addressThree": "Co. Ros Comáin",
    "addressFour": "",
    "lat": "53.8698182",
    "lng": "-8.4097275",
    "phone": "949870337",
    "email": "frenchparkns.ias@gmail.com"
  },
  {
    "i": "2534",
    "county": "Roscommon",
    "rollNumber": "17808T",
    "schoolName": "St Mary's Primary",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F42XD34",
    "addressOne": "Lisroyne",
    "addressTwo": "Strokestown",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.7768976",
    "lng": "-8.1123421",
    "phone": "868038968",
    "email": "smstrokestown20@gmail.com"
  },
  {
    "i": "2535",
    "county": "Roscommon",
    "rollNumber": "17849K",
    "schoolName": "SN O Dubhlain",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F42CF90",
    "addressOne": "Ballagh",
    "addressTwo": "Kilrooskey",
    "addressThree": "Co Roscommon",
    "addressFour": "",
    "lat": "53.6844994",
    "lng": "-8.0819144",
    "phone": "906625884",
    "email": "ballaghns1.ias@eircom.net"
  },
  {
    "i": "2536",
    "county": "Roscommon",
    "rollNumber": "17904P",
    "schoolName": "SN Brusna",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F45AR29",
    "addressOne": "Brosna",
    "addressTwo": "Ballaghadereen",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.9161676",
    "lng": "-8.6455393",
    "phone": "949860009",
    "email": "brusnans@gmail.com"
  },
  {
    "i": "2537",
    "county": "Roscommon",
    "rollNumber": "18005J",
    "schoolName": "Scoil Mhuire Gan Smal",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "H53NX71",
    "addressOne": "Feevagh",
    "addressTwo": "Dysart",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.4326638",
    "lng": "-8.2237669",
    "phone": "906622200",
    "email": "feevaghns@gmail.com"
  },
  {
    "i": "2538",
    "county": "Roscommon",
    "rollNumber": "18012G",
    "schoolName": "SN Cruachain",
    "SETHours": "70",
    "spClassTeachingPosts": "5",
    "mainSNA": "3",
    "spSNA": "9.32",
    "totalSNA": "12.32",
    "eircode": "F52NH72",
    "addressOne": "Carrowmore",
    "addressTwo": "Croghan",
    "addressThree": "Via Boyle",
    "addressFour": "Co. Roscommon",
    "lat": "53.9070065",
    "lng": "-8.2178247",
    "phone": "719668366",
    "email": "croghanns2@gmail.com"
  },
  {
    "i": "2539",
    "county": "Roscommon",
    "rollNumber": "18027T",
    "schoolName": "Clooniquin NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "F45Y045",
    "addressOne": "Clooneyquinn",
    "addressTwo": "Elphin",
    "addressThree": "Co Roscommon",
    "addressFour": "",
    "lat": "53.8056313",
    "lng": "-8.2305977",
    "phone": "719635341",
    "email": "clooneyquinn.ns@gmail.com"
  },
  {
    "i": "2540",
    "county": "Roscommon",
    "rollNumber": "18061T",
    "schoolName": "Scoil Mhuire",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "N39PX49",
    "addressOne": "Ballyleague",
    "addressTwo": "Lanesborough",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.676055",
    "lng": "-7.9999228",
    "phone": "433321906",
    "email": "ballyleaguens@gmail.com"
  },
  {
    "i": "2541",
    "county": "Roscommon",
    "rollNumber": "18116S",
    "schoolName": "Cloontuskert NS",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "N39AT80",
    "addressOne": "Lanesboro",
    "addressTwo": "Co. Longford",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.7005119",
    "lng": "-8.0120903",
    "phone": "433321817",
    "email": "cloontuskertns63@gmail.com"
  },
  {
    "i": "2542",
    "county": "Roscommon",
    "rollNumber": "18165I",
    "schoolName": "Tisrara NS",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F42T295",
    "addressOne": "Tisrara",
    "addressTwo": "Four Roads",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.5093138",
    "lng": "-8.224513",
    "phone": "906623367",
    "email": "tisrara.primaryschool@gmail.com"
  },
  {
    "i": "2543",
    "county": "Roscommon",
    "rollNumber": "18182I",
    "schoolName": "Naomh Atrachta",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F52PH39",
    "addressOne": "Kingsland",
    "addressTwo": "Mainistir Na Buille",
    "addressThree": "Co Roscommon",
    "addressFour": "",
    "lat": "53.914856",
    "lng": "-8.3788966",
    "phone": "949870608",
    "email": "murphydaithi@hotmail.com"
  },
  {
    "i": "2544",
    "county": "Roscommon",
    "rollNumber": "18194P",
    "schoolName": "Ciaran Naofa",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F42YK22",
    "addressOne": "Cooly",
    "addressTwo": "Fuerty",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.6136245",
    "lng": "-8.2876593",
    "phone": "906663433",
    "email": "fuertyns@gmail.com"
  },
  {
    "i": "2545",
    "county": "Roscommon",
    "rollNumber": "18272J",
    "schoolName": "Lecarrow Community NS",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F42HC83",
    "addressOne": "Lecarrow",
    "addressTwo": "Co. Roscommon",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.5425326",
    "lng": "-8.0414434",
    "phone": "906661242",
    "email": "naomheoinstjohn@yahoo.ie"
  },
  {
    "i": "2546",
    "county": "Roscommon",
    "rollNumber": "18395C",
    "schoolName": "SN Cluain Na Cille",
    "SETHours": "145",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.66",
    "spSNA": "0",
    "totalSNA": "5.66",
    "eircode": "N37E523",
    "addressOne": "Cloonakille",
    "addressTwo": "Bealnamulla",
    "addressThree": "Athlone",
    "addressFour": "Co. Roscommon",
    "lat": "53.4261862",
    "lng": "-8.0215065",
    "phone": "906492569",
    "email": "cloonakillaschool@gmail.com"
  },
  {
    "i": "2547",
    "county": "Roscommon",
    "rollNumber": "18432F",
    "schoolName": "SN Baile Ui Fhidhne",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "F42WV63",
    "addressOne": "Scramogue",
    "addressTwo": "Co Roscommon",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.7847634",
    "lng": "-8.0405948",
    "phone": "719633855",
    "email": "ballyfeeneyns@gmail.com"
  },
  {
    "i": "2548",
    "county": "Roscommon",
    "rollNumber": "18454P",
    "schoolName": "SN Naomh Treasa",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F52KD43",
    "addressOne": "Carraigin Rua",
    "addressTwo": "Mainistir Na Buille",
    "addressThree": "Co Roscommon",
    "addressFour": "",
    "lat": "54.0287599",
    "lng": "-8.2778338",
    "phone": "719666162",
    "email": "principal@corrigeenroens.ie"
  },
  {
    "i": "2549",
    "county": "Roscommon",
    "rollNumber": "18536R",
    "schoolName": "SN Mhuire Lourdes",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F45K751",
    "addressOne": "Loughglynn",
    "addressTwo": "Castlerea",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.8214592",
    "lng": "-8.5561674",
    "phone": "949880165",
    "email": "loughglynnns@gmail.com"
  },
  {
    "i": "2550",
    "county": "Roscommon",
    "rollNumber": "18571T",
    "schoolName": "SN Cnoc An Chrocaire",
    "SETHours": "85",
    "spClassTeachingPosts": "3",
    "mainSNA": "2.83",
    "spSNA": "7",
    "totalSNA": "9.83",
    "eircode": "F42YF38",
    "addressOne": "Knockcroghery",
    "addressTwo": "Co. Roscommon",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.574343",
    "lng": "-8.0915544",
    "phone": "906661963",
    "email": "knockcroghery.ias@eircom.net"
  },
  {
    "i": "2551",
    "county": "Roscommon",
    "rollNumber": "18626S",
    "schoolName": "SN An Gleann Duibh",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "N37YV82",
    "addressOne": "Kiltoom",
    "addressTwo": "Athlone",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.5184974",
    "lng": "-8.0343186",
    "phone": "906489317",
    "email": "glanduffnsroscommon@gmail.com"
  },
  {
    "i": "2552",
    "county": "Roscommon",
    "rollNumber": "18729F",
    "schoolName": "Ballintleva NS",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "N37VN23",
    "addressOne": "Curraghboy",
    "addressTwo": "Athlone",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.4715449",
    "lng": "-8.1757376",
    "phone": "906622491",
    "email": "ballintlevans@gmail.com"
  },
  {
    "i": "2553",
    "county": "Roscommon",
    "rollNumber": "18742U",
    "schoolName": "Roxboro NS",
    "SETHours": "100",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.66",
    "spSNA": "0",
    "totalSNA": "4.66",
    "eircode": "F42NY75",
    "addressOne": "Derrane",
    "addressTwo": "Co. Roscommon",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.6610248",
    "lng": "-8.15397",
    "phone": "906625703",
    "email": "officeroxborons@gmail.com"
  },
  {
    "i": "2554",
    "county": "Roscommon",
    "rollNumber": "19257S",
    "schoolName": "Strabaggan NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "N41VW08",
    "addressOne": "Loch Aillinne",
    "addressTwo": "Cara Droma Ruisg",
    "addressThree": "Co Roscommon",
    "addressFour": "",
    "lat": "54.078689",
    "lng": "-8.0794573",
    "phone": "719646140",
    "email": "strabragganns@yahoo.co.uk"
  },
  {
    "i": "2555",
    "county": "Roscommon",
    "rollNumber": "19368E",
    "schoolName": "SN Naomh Ciaran",
    "SETHours": "65",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "N37R521",
    "addressOne": "Scoil Naomh Ciaran",
    "addressTwo": "Rooty Cross Oldtown",
    "addressThree": "Athlone",
    "addressFour": "Co Roscommon",
    "lat": "53.3261565",
    "lng": "-8.1013825",
    "phone": "909673436",
    "email": "stciaransns@gmail.com"
  },
  {
    "i": "2556",
    "county": "Roscommon",
    "rollNumber": "19534S",
    "schoolName": "Ballybay NS",
    "SETHours": "80",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "N37RC82",
    "addressOne": "Kiltoom",
    "addressTwo": "Athlone",
    "addressThree": "Co Roscommon",
    "addressFour": "",
    "lat": "53.4644926",
    "lng": "-8.0077913",
    "phone": "906489220",
    "email": "ballybayoffice@gmail.com"
  },
  {
    "i": "2557",
    "county": "Roscommon",
    "rollNumber": "19720P",
    "schoolName": "N Micheal Agus Padraig",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F52TV26",
    "addressOne": "Clegna",
    "addressTwo": "Cootehall",
    "addressThree": "Boyle",
    "addressFour": "Co. Roscommon",
    "lat": "53.9898369",
    "lng": "-8.1647669",
    "phone": "719667264",
    "email": "cootehallns@gmail.com"
  },
  {
    "i": "2558",
    "county": "Roscommon",
    "rollNumber": "19809I",
    "schoolName": "Abbeycarton Ns",
    "SETHours": "82.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F45V302",
    "addressOne": "Bishop Street",
    "addressTwo": "Elphin",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "53.8465509",
    "lng": "-8.1904778",
    "phone": "719635385",
    "email": "abbeycartron.ias@eircom.net"
  },
  {
    "i": "2559",
    "county": "Roscommon",
    "rollNumber": "19815D",
    "schoolName": "Scoil Bhrí­de",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "F42WF25",
    "addressOne": "Four Mile House",
    "addressTwo": "Roscommon",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.7029866",
    "lng": "-8.2056867",
    "phone": "906629570",
    "email": "scoilbhridefmh@gmail.com"
  },
  {
    "i": "2560",
    "county": "Roscommon",
    "rollNumber": "19980S",
    "schoolName": "St Attractas NS",
    "SETHours": "132.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "F45H367",
    "addressOne": "Ballaghaderreen",
    "addressTwo": "Co. Roscommon",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.8996172",
    "lng": "-8.5897926",
    "phone": "949860646",
    "email": "secretary@stattractasns.com"
  },
  {
    "i": "2561",
    "county": "Roscommon",
    "rollNumber": "20126K",
    "schoolName": "Gaelscoil De Hide",
    "SETHours": "62.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "F42TD83",
    "addressOne": "Cnoc Na Crúibe",
    "addressTwo": "Bóthar Na Gaillimhe",
    "addressThree": "Co. Ros Comáin",
    "addressFour": "",
    "lat": "53.6210905",
    "lng": "-8.201974",
    "phone": "906628860",
    "email": "eolasgaelscoildehide@gmail.com"
  },
  {
    "i": "2562",
    "county": "Roscommon",
    "rollNumber": "20498B",
    "schoolName": "St Cóman's Wood Primary School",
    "SETHours": "310",
    "spClassTeachingPosts": "2",
    "mainSNA": "11.49",
    "spSNA": "1",
    "totalSNA": "12.49",
    "eircode": "F42YH60",
    "addressOne": "Roscommon Town",
    "addressTwo": "Roscommon",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.6280148",
    "lng": "-8.1966849",
    "phone": "906626872",
    "email": "ufeeley@comanswoodprimary.ie"
  },
  {
    "i": "2563",
    "county": "Sligo",
    "rollNumber": "02013S",
    "schoolName": "Ballintogher NS",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F91DR72",
    "addressOne": "Kingsfort",
    "addressTwo": "Ballintogher",
    "addressThree": "Co. Sligo",
    "addressFour": "",
    "lat": "54.1994629",
    "lng": "-8.3671409",
    "phone": "719164939",
    "email": "sntreasa@gmail.com"
  },
  {
    "i": "2564",
    "county": "Sligo",
    "rollNumber": "03924S",
    "schoolName": "Owenbeg NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "0",
    "spSNA": "1",
    "totalSNA": "1",
    "eircode": "F26VK13",
    "addressOne": "Owenbeg",
    "addressTwo": "Culleens",
    "addressThree": "Co. Sligo",
    "addressFour": "",
    "lat": "54.2529693",
    "lng": "-8.9592776",
    "phone": "9649253",
    "email": "owenbegns@gmail.com"
  },
  {
    "i": "2565",
    "county": "Sligo",
    "rollNumber": "04487E",
    "schoolName": "SN Naithi Naofa",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "F91WF65",
    "addressOne": "Achonry",
    "addressTwo": "Tubbercurry",
    "addressThree": "Co. Sligo",
    "addressFour": "",
    "lat": "54.07886",
    "lng": "-8.6601288",
    "phone": "719184395",
    "email": "achonryns.ias@eircom.net"
  },
  {
    "i": "2566",
    "county": "Sligo",
    "rollNumber": "04802J",
    "schoolName": "Cloonacool NS",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F91TV07",
    "addressOne": "Cloonacool",
    "addressTwo": "Tubbercurry",
    "addressThree": "Co. Sligo",
    "addressFour": "",
    "lat": "54.0990338",
    "lng": "-8.7814413",
    "phone": "719185709",
    "email": "stmichaelsns9@gmail.com"
  },
  {
    "i": "2567",
    "county": "Sligo",
    "rollNumber": "09691F",
    "schoolName": "Killeenduff NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F26KX78",
    "addressOne": "Killeenduff",
    "addressTwo": "Easkey",
    "addressThree": "Co. Sligo",
    "addressFour": "",
    "lat": "54.2747402",
    "lng": "-8.9236936",
    "phone": "9649228",
    "email": "killeenduff.ns@hotmail.com"
  },
  {
    "i": "2569",
    "county": "Sligo",
    "rollNumber": "12171T",
    "schoolName": "Corballa NS",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F26F582",
    "addressOne": "Corballa",
    "addressTwo": "Via Ballina",
    "addressThree": "Co. Sligo",
    "addressFour": "",
    "lat": "54.1647676",
    "lng": "-9.0764368",
    "phone": "9636287",
    "email": "corballans@gmail.com"
  },
  {
    "i": "2570",
    "county": "Sligo",
    "rollNumber": "12537M",
    "schoolName": "Carn NS",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "F56DE40",
    "addressOne": "Gurteen",
    "addressTwo": "Ballymote",
    "addressThree": "Co. Sligo",
    "addressFour": "",
    "lat": "53.9945318",
    "lng": "-8.5161612",
    "phone": "719182825",
    "email": "secretary@carnns.ie"
  },
  {
    "i": "2571",
    "county": "Sligo",
    "rollNumber": "12767G",
    "schoolName": "SN Ronain Naofa",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F52E288",
    "addressOne": "Cloonloo",
    "addressTwo": "Via Boyle",
    "addressThree": "Co. Sligo",
    "addressFour": "",
    "lat": "53.9715585",
    "lng": "-8.4122543",
    "phone": "719663684",
    "email": "info@cloonlooschool.ie"
  },
  {
    "i": "2572",
    "county": "Sligo",
    "rollNumber": "13196R",
    "schoolName": "Taunagh NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F52HE92",
    "addressOne": "Riverstown",
    "addressTwo": "Co. Sligo",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.1299752",
    "lng": "-8.398008",
    "phone": "719165605",
    "email": "taunaghns@gmail.com"
  },
  {
    "i": "2573",
    "county": "Sligo",
    "rollNumber": "13242V",
    "schoolName": "Castlerock NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F91DV27",
    "addressOne": "Drummartin",
    "addressTwo": "Aclare",
    "addressThree": "Co. Sligo",
    "addressFour": "",
    "lat": "54.0629433",
    "lng": "-8.8674295",
    "phone": "719181234",
    "email": "castlerockns@gmail.com"
  },
  {
    "i": "2574",
    "county": "Sligo",
    "rollNumber": "13831R",
    "schoolName": "Moylough NS",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "F91T880",
    "addressOne": "Moylough",
    "addressTwo": "Tubbercurry",
    "addressThree": "Co. Sligo",
    "addressFour": "",
    "lat": "54.0273353",
    "lng": "-8.7046991",
    "phone": "719186090",
    "email": "moyloughns1990@gmail.com"
  },
  {
    "i": "2575",
    "county": "Sligo",
    "rollNumber": "13940W",
    "schoolName": "Enniscrone NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.66",
    "spSNA": "0",
    "totalSNA": "2.66",
    "eircode": "F26EW67",
    "addressOne": "Enniscrone",
    "addressTwo": "Co. Sligo",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.2131263",
    "lng": "-9.0875784",
    "phone": "9636299",
    "email": "screnniscrone@gmail.com"
  },
  {
    "i": "2576",
    "county": "Sligo",
    "rollNumber": "14051T",
    "schoolName": "Stokane Ns",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F26C970",
    "addressOne": "Stokane",
    "addressTwo": "Enniscrone",
    "addressThree": "Co. Sligo",
    "addressFour": "",
    "lat": "54.177716",
    "lng": "-9.0272949",
    "phone": "9636673",
    "email": "stokanens@gmail.com"
  },
  {
    "i": "2577",
    "county": "Sligo",
    "rollNumber": "14636B",
    "schoolName": "Carraroe NS",
    "SETHours": "130",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "F91DC67",
    "addressOne": "Tonafortes",
    "addressTwo": "Carraroe",
    "addressThree": "Co. Sligo",
    "addressFour": "",
    "lat": "54.2447177",
    "lng": "-8.4748815",
    "phone": "719161843",
    "email": "carraroens@gmail.com"
  },
  {
    "i": "2578",
    "county": "Sligo",
    "rollNumber": "15004P",
    "schoolName": "Scoil Asicus",
    "SETHours": "85",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "F91V003",
    "addressOne": "Golf Course Road",
    "addressTwo": "Strandhill",
    "addressThree": "Co. Sligo",
    "addressFour": "",
    "lat": "54.2672039",
    "lng": "-8.6018965",
    "phone": "719168154",
    "email": "asicus81@gmail.com"
  },
  {
    "i": "2579",
    "county": "Sligo",
    "rollNumber": "15217J",
    "schoolName": "Ardkeerin NS",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "F52E244",
    "addressOne": "Ardeeran",
    "addressTwo": "Riverstown",
    "addressThree": "Co. Sligo",
    "addressFour": "",
    "lat": "54.1287212",
    "lng": "-8.3958666",
    "phone": "719165411",
    "email": "admin@ardkeeran.com"
  },
  {
    "i": "2580",
    "county": "Sligo",
    "rollNumber": "15337T",
    "schoolName": "SN Mhuire",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F91DA00",
    "addressOne": "Castlegal",
    "addressTwo": "Cliffoney",
    "addressThree": "Co. Sligo",
    "addressFour": "",
    "lat": "54.4553239",
    "lng": "-8.3970348",
    "phone": "719166758",
    "email": "castlegalns@yahoo.ie"
  },
  {
    "i": "2581",
    "county": "Sligo",
    "rollNumber": "15342M",
    "schoolName": "SN Naomh Mhuire",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F56NT66",
    "addressOne": "Knockconor",
    "addressTwo": "Keash",
    "addressThree": "Ballymote",
    "addressFour": "Co. Sligo",
    "lat": "54.0482343",
    "lng": "-8.4482249",
    "phone": "719189166",
    "email": "keashns@gmail.com"
  },
  {
    "i": "2582",
    "county": "Sligo",
    "rollNumber": "15378K",
    "schoolName": "Rockfield NS",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.66",
    "spSNA": "0",
    "totalSNA": "2.66",
    "eircode": "F56FW32",
    "addressOne": "Coolney",
    "addressTwo": "Co. Sligo",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.1668162",
    "lng": "-8.619878",
    "phone": "719130539",
    "email": "scoilchriostri@gmail.com"
  },
  {
    "i": "2583",
    "county": "Sligo",
    "rollNumber": "15431L",
    "schoolName": "Killaville NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F56HX72",
    "addressOne": "Killavil",
    "addressTwo": "Ballymote",
    "addressThree": "Co. Sligo",
    "addressFour": "",
    "lat": "54.0385974",
    "lng": "-8.5535562",
    "phone": "719182795",
    "email": "killavilns@gmail.com"
  },
  {
    "i": "2584",
    "county": "Sligo",
    "rollNumber": "15496Q",
    "schoolName": "Leaffoney NS",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F26XD61",
    "addressOne": "Leaffoney",
    "addressTwo": "Kilglass",
    "addressThree": "Co. Sligo",
    "addressFour": "",
    "lat": "54.2565373",
    "lng": "-9.0300915",
    "phone": "9649291",
    "email": "leaffoneyns@gmail.com"
  },
  {
    "i": "2585",
    "county": "Sligo",
    "rollNumber": "15571E",
    "schoolName": "Kilglass NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F26E682",
    "addressOne": "Ballyglass",
    "addressTwo": "Enniscrone",
    "addressThree": "Co. Sligo",
    "addressFour": "",
    "lat": "54.2282993",
    "lng": "-9.0291427",
    "phone": "9636688",
    "email": "kilglassns@gmail.com"
  },
  {
    "i": "2586",
    "county": "Sligo",
    "rollNumber": "16044J",
    "schoolName": "Kilross NS",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F91ED95",
    "addressOne": "Ballintogher",
    "addressTwo": "Co Sligo",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.1928044",
    "lng": "-8.4126944",
    "phone": "719130074",
    "email": "kilrossns@gmail.com"
  },
  {
    "i": "2587",
    "county": "Sligo",
    "rollNumber": "16136O",
    "schoolName": "Cliffoney NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F91YC85",
    "addressOne": "Ballinphull",
    "addressTwo": "Cliffoney",
    "addressThree": "Co. Sligo",
    "addressFour": "",
    "lat": "54.430444",
    "lng": "-8.453036",
    "phone": "719166578",
    "email": "cliffoneyns@gmail.com"
  },
  {
    "i": "2588",
    "county": "Sligo",
    "rollNumber": "16492N",
    "schoolName": "Rathlee NS",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F26PY11",
    "addressOne": "Easkey",
    "addressTwo": "Co. Sligo",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.2754028",
    "lng": "-9.0252998",
    "phone": "9649243",
    "email": "rathleens1@eircom.net"
  },
  {
    "i": "2591",
    "county": "Sligo",
    "rollNumber": "17021C",
    "schoolName": "SN Padraig Naofa",
    "SETHours": "60",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F91CX85",
    "addressOne": "Kilmacannon",
    "addressTwo": "Ballinfull",
    "addressThree": "Co. Sligo",
    "addressFour": "",
    "lat": "54.3472025",
    "lng": "-8.6207587",
    "phone": "719163548",
    "email": "maugherowschool@maugherowschool.com"
  },
  {
    "i": "2592",
    "county": "Sligo",
    "rollNumber": "17277O",
    "schoolName": "St Edwards NS",
    "SETHours": "115",
    "spClassTeachingPosts": "1",
    "mainSNA": "2.83",
    "spSNA": "2.83",
    "totalSNA": "5.66",
    "eircode": "F91DX64",
    "addressOne": "Ballytivnan",
    "addressTwo": "Sligo",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.2805952",
    "lng": "-8.4666313",
    "phone": "719143480",
    "email": "info@stedwards.ie"
  },
  {
    "i": "2594",
    "county": "Sligo",
    "rollNumber": "17599N",
    "schoolName": "SN Baile An Luig",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F91VK52",
    "addressOne": "Beal Tra",
    "addressTwo": "Sligeach",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.2296117",
    "lng": "-8.6343908",
    "phone": "719166883",
    "email": "ballinligns@gmail.com"
  },
  {
    "i": "2595",
    "county": "Sligo",
    "rollNumber": "17641J",
    "schoolName": "SN Realt Na Mara",
    "SETHours": "28",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F91TR29",
    "addressOne": "Rosses Point",
    "addressTwo": "Sligo",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.3078741",
    "lng": "-8.5609203",
    "phone": "719177251",
    "email": "snrealtnamara@gmail.com"
  },
  {
    "i": "2596",
    "county": "Sligo",
    "rollNumber": "17725P",
    "schoolName": "SN Bhride",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F91N528",
    "addressOne": "Carn",
    "addressTwo": "Moneygold",
    "addressThree": "Co. Sligo",
    "addressFour": "",
    "lat": "54.4110069",
    "lng": "-8.4935949",
    "phone": "719173081",
    "email": "scoilbridecarns@yahoo.com"
  },
  {
    "i": "2597",
    "county": "Sligo",
    "rollNumber": "17774F",
    "schoolName": "SN Lissara Naofa",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F56PN59",
    "addressOne": "Ballinacarrow",
    "addressTwo": "Ballymote",
    "addressThree": "Co. Sligo",
    "addressFour": "",
    "lat": "54.1333825",
    "lng": "-8.5624079",
    "phone": "719130350",
    "email": "stlassaranationalschool@gmail.com"
  },
  {
    "i": "2598",
    "county": "Sligo",
    "rollNumber": "17838F",
    "schoolName": "SN Eoin Naofa",
    "SETHours": "90",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "F91K032",
    "addressOne": "Baile Easa Dara",
    "addressTwo": "Co Sligeach",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.21234",
    "lng": "-8.5176962",
    "phone": "719167639",
    "email": "stjohnsballisodare@gmail.com"
  },
  {
    "i": "2600",
    "county": "Sligo",
    "rollNumber": "18029A",
    "schoolName": "SN Muire Gan Smal",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F91DW65",
    "addressOne": "Druimeanna",
    "addressTwo": "Tubbercurry",
    "addressThree": "Co Sligo",
    "addressFour": "",
    "lat": "54.0548022",
    "lng": "-8.7754093",
    "phone": "719186046",
    "email": "driminans3@gmail.com"
  },
  {
    "i": "2601",
    "county": "Sligo",
    "rollNumber": "18053U",
    "schoolName": "Sooey NS",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F52C862",
    "addressOne": "Sooey",
    "addressTwo": "Boyle",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "54.1663346",
    "lng": "-8.3944401",
    "phone": "719165845",
    "email": "sooeyns@gmail.com"
  },
  {
    "i": "2602",
    "county": "Sligo",
    "rollNumber": "18298E",
    "schoolName": "SN Cul Fada",
    "SETHours": "0",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F56HD30",
    "addressOne": "Culfadda",
    "addressTwo": "Ballymote",
    "addressThree": "Co. Sligo",
    "addressFour": "",
    "lat": "54.0263249",
    "lng": "-8.475818",
    "phone": "719182645",
    "email": "culfadda.ias@gmail.com"
  },
  {
    "i": "2603",
    "county": "Sligo",
    "rollNumber": "18334F",
    "schoolName": "SN Cnoc Mionna",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F56TX23",
    "addressOne": "Turlaghraun",
    "addressTwo": "Ballymote",
    "addressThree": "Co. Sligo",
    "addressFour": "",
    "lat": "54.1015829",
    "lng": "-8.4563672",
    "phone": "719189272",
    "email": "knockminnans56@gmail.com"
  },
  {
    "i": "2604",
    "county": "Sligo",
    "rollNumber": "18366S",
    "schoolName": "SN Aodain",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F91XV91",
    "addressOne": "Hollyfield",
    "addressTwo": "Ballintrillick",
    "addressThree": "Co. Sligo",
    "addressFour": "",
    "lat": "54.407002",
    "lng": "-8.4072281",
    "phone": "719176665",
    "email": "ballintrillickns@gmail.com"
  },
  {
    "i": "2605",
    "county": "Sligo",
    "rollNumber": "18543O",
    "schoolName": "SN Clochog",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "F52Y286",
    "addressOne": "Castlebaldwin",
    "addressTwo": "Boyle",
    "addressThree": "Co. Roscommon",
    "addressFour": "",
    "lat": "54.0775309",
    "lng": "-8.3790613",
    "phone": "719165655",
    "email": "cloghoguens@gmail.com"
  },
  {
    "i": "2606",
    "county": "Sligo",
    "rollNumber": "18575E",
    "schoolName": "SN Molaoise",
    "SETHours": "97.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "6.66",
    "spSNA": "0",
    "totalSNA": "6.66",
    "eircode": "F91W326",
    "addressOne": "Grange",
    "addressTwo": "Co. Sligo",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.3930917",
    "lng": "-8.5260426",
    "phone": "719163419",
    "email": "snmolaise@gmail.com"
  },
  {
    "i": "2607",
    "county": "Sligo",
    "rollNumber": "18580U",
    "schoolName": "SN Muire Gan Smal",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F91NT98",
    "addressOne": "Kilrusheighter",
    "addressTwo": "Templeboy",
    "addressThree": "Co. Sligo",
    "addressFour": "",
    "lat": "54.2591774",
    "lng": "-8.7745782",
    "phone": "9647300",
    "email": "kilrusheighterns1@gmail.com"
  },
  {
    "i": "2608",
    "county": "Sligo",
    "rollNumber": "18592E",
    "schoolName": "SN Naomh Iosef",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F91DH74",
    "addressOne": "Ardkill",
    "addressTwo": "Templeboy",
    "addressThree": "Co. Sligo",
    "addressFour": "",
    "lat": "54.2445304",
    "lng": "-8.8157827",
    "phone": "9647393",
    "email": "templeboyns@gmail.com"
  },
  {
    "i": "2609",
    "county": "Sligo",
    "rollNumber": "18715R",
    "schoolName": "SN Pairc Ard",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "F91YT97",
    "addressOne": "Dromard",
    "addressTwo": "Co Sligo",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.2517496",
    "lng": "-8.6794875",
    "phone": "719166891",
    "email": "5th6thhighpark@gmail.com"
  },
  {
    "i": "2610",
    "county": "Sligo",
    "rollNumber": "18979F",
    "schoolName": "SN Ursula",
    "SETHours": "157.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "F91WD27",
    "addressOne": "Strandhill Road",
    "addressTwo": "Sligo",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.2705631",
    "lng": "-8.4920311",
    "phone": "719162835",
    "email": "info@scoilursula.com"
  },
  {
    "i": "2611",
    "county": "Sligo",
    "rollNumber": "19389M",
    "schoolName": "Sn Muire Gan Smal",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F91DT35",
    "addressOne": "Drumbaun",
    "addressTwo": "Curry",
    "addressThree": "Co. Sligo",
    "addressFour": "",
    "lat": "54.0050086",
    "lng": "-8.7712537",
    "phone": "949254878",
    "email": "smgscurry@hotmail.com"
  },
  {
    "i": "2612",
    "county": "Sligo",
    "rollNumber": "19392B",
    "schoolName": "Scoil Naomh Aodain",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "F45VF54",
    "addressOne": "Monasteraden",
    "addressTwo": "Via Ballaghadereen",
    "addressThree": "Co. Sligo",
    "addressFour": "",
    "lat": "53.9437896",
    "lng": "-8.4942585",
    "phone": "949860924",
    "email": "monaiden@gmail.com"
  },
  {
    "i": "2613",
    "county": "Sligo",
    "rollNumber": "19408N",
    "schoolName": "Rathcormack NS",
    "SETHours": "72.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.66",
    "spSNA": "0",
    "totalSNA": "2.66",
    "eircode": "F91NX21",
    "addressOne": "Drumcliffe South",
    "addressTwo": "Co. Sligo",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.3170222",
    "lng": "-8.4788643",
    "phone": "719143962",
    "email": "office@rathcormacns.ie"
  },
  {
    "i": "2614",
    "county": "Sligo",
    "rollNumber": "19416M",
    "schoolName": "St Paul's NS Collooney",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F91AW27",
    "addressOne": "The Square",
    "addressTwo": "Collooey",
    "addressThree": "Co. Sligo",
    "addressFour": "",
    "lat": "54.1828958",
    "lng": "-8.4915397",
    "phone": "719130491",
    "email": "stpaulscollooney@gmail.com"
  },
  {
    "i": "2615",
    "county": "Sligo",
    "rollNumber": "19495L",
    "schoolName": "Carbury Nat Sch",
    "SETHours": "105",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "F91FW10",
    "addressOne": "The Mall",
    "addressTwo": "Sligo",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.2720747",
    "lng": "-8.4659245",
    "phone": "719161014",
    "email": "info@carburyschool.com"
  },
  {
    "i": "2616",
    "county": "Sligo",
    "rollNumber": "19635B",
    "schoolName": "Ransboro New Central",
    "SETHours": "95",
    "spClassTeachingPosts": "2",
    "mainSNA": "2.83",
    "spSNA": "5",
    "totalSNA": "7.83",
    "eircode": "F91TV77",
    "addressOne": "Ransboro",
    "addressTwo": "Knocknahur",
    "addressThree": "Co. Sligo",
    "addressFour": "",
    "lat": "54.2443789",
    "lng": "-8.540203",
    "phone": "719168117",
    "email": "info@ransboro.ie"
  },
  {
    "i": "2617",
    "county": "Sligo",
    "rollNumber": "19688W",
    "schoolName": "Dromore West Central",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "F26VW50",
    "addressOne": "Dromore West",
    "addressTwo": "Co. Sligo",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.2412955",
    "lng": "-8.8844777",
    "phone": "9647224",
    "email": "dromorewestcns.ias@gmail.com"
  },
  {
    "i": "2618",
    "county": "Mayo",
    "rollNumber": "19798G",
    "schoolName": "St Colmans Ns",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F56TY05",
    "addressOne": "Derrinabroc",
    "addressTwo": "Cloontia",
    "addressThree": "Ballymote",
    "addressFour": "Co. Sligo",
    "lat": "53.9640853",
    "lng": "-8.6272821",
    "phone": "949861003",
    "email": "derrinabrocns@gmail.com"
  },
  {
    "i": "2619",
    "county": "Sligo",
    "rollNumber": "19826I",
    "schoolName": "St Brendans Ns",
    "SETHours": "100",
    "spClassTeachingPosts": "2",
    "mainSNA": "4.83",
    "spSNA": "3.83",
    "totalSNA": "8.66",
    "eircode": "F91YTK2",
    "addressOne": "Cartron",
    "addressTwo": "Sligo",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.2810934",
    "lng": "-8.4838959",
    "phone": "719145449",
    "email": "secretary@stbrendanscartron.com"
  },
  {
    "i": "2620",
    "county": "Sligo",
    "rollNumber": "19910U",
    "schoolName": "Sligo Project School",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "F91XF51",
    "addressOne": "Abbey Quarter",
    "addressTwo": "Sligo",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.2699354",
    "lng": "-8.466134",
    "phone": "719143073",
    "email": "sligosp@gmx.com"
  },
  {
    "i": "2621",
    "county": "Sligo",
    "rollNumber": "19942K",
    "schoolName": "St Patricks Ns",
    "SETHours": "58",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "F91DP48",
    "addressOne": "Colgagh",
    "addressTwo": "Calry",
    "addressThree": "Sligo",
    "addressFour": "",
    "lat": "54.2856921",
    "lng": "-8.3961524",
    "phone": "719144288",
    "email": "calryns.ias@eircom.net"
  },
  {
    "i": "2622",
    "county": "Sligo",
    "rollNumber": "19964U",
    "schoolName": "Scoil Mhuire Gan Smal",
    "SETHours": "87.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "F56CP59",
    "addressOne": "Ballymote",
    "addressTwo": "Co. Sligo",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.0915075",
    "lng": "-8.5135329",
    "phone": "719183894",
    "email": "office@smgsballymote.ie"
  },
  {
    "i": "2623",
    "county": "Sligo",
    "rollNumber": "19974A",
    "schoolName": "Scoil Eoin Naofa",
    "SETHours": "117.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "2",
    "spSNA": "1",
    "totalSNA": "3",
    "eircode": "F91FK20",
    "addressOne": "Temple Street",
    "addressTwo": "Sligo",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.2670658",
    "lng": "-8.4767689",
    "phone": "719162537",
    "email": "scoileoinnaofa.ias@eircom.net"
  },
  {
    "i": "2624",
    "county": "Sligo",
    "rollNumber": "19985F",
    "schoolName": "Our Lady Of Mercy NS",
    "SETHours": "225",
    "spClassTeachingPosts": "2",
    "mainSNA": "4.83",
    "spSNA": "4",
    "totalSNA": "8.83",
    "eircode": "F91YY06",
    "addressOne": "Pearse Road",
    "addressTwo": "Sligo",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.268383",
    "lng": "-8.470232",
    "phone": "719171364",
    "email": "mercypssligo@eircom.net"
  },
  {
    "i": "2625",
    "county": "Sligo",
    "rollNumber": "20019J",
    "schoolName": "Holy Family School",
    "SETHours": "72.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "F91EW90",
    "addressOne": "Ballymote Road",
    "addressTwo": "Tubbercurry",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.0536438",
    "lng": "-8.7255381",
    "phone": "719186291",
    "email": "principalholyfamilyns@gmail.com"
  },
  {
    "i": "2626",
    "county": "Sligo",
    "rollNumber": "20044I",
    "schoolName": "Gaelscoil Chnoc Na Re",
    "SETHours": "0",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.33",
    "spSNA": "0",
    "totalSNA": "2.33",
    "eircode": "F91FH30",
    "addressOne": "Bothar Baile Ui Dhugain",
    "addressTwo": "Sligeach",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.2647918",
    "lng": "-8.5019532",
    "phone": "719174019",
    "email": "scoil@cnocnare.net"
  },
  {
    "i": "2627",
    "county": "Sligo",
    "rollNumber": "20113B",
    "schoolName": "Scoil Croi Naofa",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "F56TE24",
    "addressOne": "Bunnanadden",
    "addressTwo": "Co. Sligo",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.0537666",
    "lng": "-8.6040897",
    "phone": "719189064",
    "email": "carrowreagh.ias@eircom.net"
  },
  {
    "i": "2628",
    "county": "Sligo",
    "rollNumber": "20122C",
    "schoolName": "Scoil Mhuire Agus Iosaf",
    "SETHours": "70",
    "spClassTeachingPosts": "1",
    "mainSNA": "1.83",
    "spSNA": "2.83",
    "totalSNA": "4.66",
    "eircode": "F91A076",
    "addressOne": "Collooney",
    "addressTwo": "Co. Sligo",
    "addressThree": "",
    "addressFour": "",
    "lat": "54.1818682",
    "lng": "-8.4923689",
    "phone": "719167763",
    "email": "collooneyns@gmail.com"
  },
  {
    "i": "2629",
    "county": "Sligo",
    "rollNumber": "20385L",
    "schoolName": "Our Lady's NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "F91K09R",
    "addressOne": "Banada",
    "addressTwo": "Tourlestrane",
    "addressThree": "Co. Sligo",
    "addressFour": "",
    "lat": "54.039416",
    "lng": "-8.8318071",
    "phone": "719181219",
    "email": "banadans@outlook.com"
  },
  {
    "i": "2630",
    "county": "Tipperary",
    "rollNumber": "00606M",
    "schoolName": "Monard NS",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "E34VF97",
    "addressOne": "Monard",
    "addressTwo": "Solohead",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.5109345",
    "lng": "-8.2243558",
    "phone": "6247557",
    "email": "info@monardns.com"
  },
  {
    "i": "2631",
    "county": "Tipperary",
    "rollNumber": "01285A",
    "schoolName": "Tipperary Jnr Bn S",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "E34HD52",
    "addressOne": "St Michael's Street",
    "addressTwo": "Tipperary",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.4781724",
    "lng": "-8.1587319",
    "phone": "6251913",
    "email": "stmichaelsjbs@gmail.com"
  },
  {
    "i": "2632",
    "county": "Tipperary",
    "rollNumber": "01569O",
    "schoolName": "Ballycahill NS",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "E41RR68",
    "addressOne": "Ballycahill",
    "addressTwo": "Thurles",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.6882205",
    "lng": "-7.9072167",
    "phone": "50422492",
    "email": "ballycahillns@gmail.com"
  },
  {
    "i": "2633",
    "county": "Tipperary",
    "rollNumber": "01594N",
    "schoolName": "St Johns",
    "SETHours": "112.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "3.83",
    "spSNA": "1.66",
    "totalSNA": "5.49",
    "eircode": "E53N562",
    "addressOne": "Goldengrove Road",
    "addressTwo": "Roscrea",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.9599528",
    "lng": "-7.7999063",
    "phone": "50523903",
    "email": "scoileoinnaofa@gmail.com"
  },
  {
    "i": "2634",
    "county": "Tipperary",
    "rollNumber": "01862M",
    "schoolName": "Tipperary GNS",
    "SETHours": "75.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.33",
    "spSNA": "0",
    "totalSNA": "1.33",
    "eircode": "E34Y098",
    "addressOne": "St Michael's Street",
    "addressTwo": "Tipperary",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.4777457",
    "lng": "-8.1593075",
    "phone": "6233527",
    "email": "stmichaelsgnsinfo@gmail.com"
  },
  {
    "i": "2635",
    "county": "Tipperary",
    "rollNumber": "02237R",
    "schoolName": "Dualla NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "E25E288",
    "addressOne": "Dualla",
    "addressTwo": "Cashel",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.5419474",
    "lng": "-7.8164182",
    "phone": "6262241",
    "email": "duallans@gmail.com"
  },
  {
    "i": "2636",
    "county": "Tipperary",
    "rollNumber": "02428B",
    "schoolName": "Lackamore NS",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "V94V5D1",
    "addressOne": "Lackamore",
    "addressTwo": "Newport",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.694825",
    "lng": "-8.3222579",
    "phone": "61378360",
    "email": "lackamorens@gmail.com"
  },
  {
    "i": "2637",
    "county": "Tipperary",
    "rollNumber": "02670I",
    "schoolName": "San Isadoir",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "E25KX75",
    "addressOne": "Nodstown South",
    "addressTwo": "Boherlahan",
    "addressThree": "Cashel",
    "addressFour": "Co. Tipperary",
    "lat": "52.5722629",
    "lng": "-7.8928323",
    "phone": "50441184",
    "email": "boherlahanns@gmail.com"
  },
  {
    "i": "2638",
    "county": "Tipperary",
    "rollNumber": "04005G",
    "schoolName": "SN Naomh Peadar",
    "SETHours": "85",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "E41FY66",
    "addressOne": "Pouldine",
    "addressTwo": "Thurles",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.6324305",
    "lng": "-7.7799671",
    "phone": "50444439",
    "email": "office@moycarkeyns.ie"
  },
  {
    "i": "2639",
    "county": "Tipperary",
    "rollNumber": "04067F",
    "schoolName": "Convent Of Mercy",
    "SETHours": "87.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "V94X7F9",
    "addressOne": "Church Road",
    "addressTwo": "Newport",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.7108537",
    "lng": "-8.4111912",
    "phone": "61378622",
    "email": "newportconvent.ias@eircom.net"
  },
  {
    "i": "2640",
    "county": "Tipperary",
    "rollNumber": "04075E",
    "schoolName": "Moyglass NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "E91VY15",
    "addressOne": "Moyglass",
    "addressTwo": "Fethard",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.5275454",
    "lng": "-7.7079758",
    "phone": "526131885",
    "email": "adminmoyglassns@gmail.com"
  },
  {
    "i": "2641",
    "county": "Tipperary",
    "rollNumber": "04620D",
    "schoolName": "Thomastown NS",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "E25F840",
    "addressOne": "Ardobireen",
    "addressTwo": "Thomastown",
    "addressThree": "Golden",
    "addressFour": "Co. Tipperary",
    "lat": "52.4937031",
    "lng": "-8.021769",
    "phone": "6272471",
    "email": "thomastownnationalschool@gmail.com"
  },
  {
    "i": "2642",
    "county": "Tipperary",
    "rollNumber": "05144C",
    "schoolName": "New Inn BNS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.75",
    "spSNA": "0",
    "totalSNA": "1.75",
    "eircode": "E25VP64",
    "addressOne": "New Inn",
    "addressTwo": "Cashel",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.4426643",
    "lng": "-7.8816112",
    "phone": "527462336",
    "email": "newinnbns@gmail.com"
  },
  {
    "i": "2643",
    "county": "Tipperary",
    "rollNumber": "06658P",
    "schoolName": "Kiladangan NS",
    "SETHours": "65",
    "spClassTeachingPosts": "2",
    "mainSNA": "0",
    "spSNA": "4.75",
    "totalSNA": "4.75",
    "eircode": "E45DT27",
    "addressOne": "Kiladangan NS",
    "addressTwo": "Puckane",
    "addressThree": "Nenagh",
    "addressFour": "",
    "lat": "52.9307366",
    "lng": "-8.2388887",
    "phone": "6724030",
    "email": "kiladanganns@gmail.com"
  },
  {
    "i": "2644",
    "county": "Tipperary",
    "rollNumber": "06789H",
    "schoolName": "Lisronagh NS",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "E91X525",
    "addressOne": "Lisronagh",
    "addressTwo": "Clonmel",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.4176014",
    "lng": "-7.7041114",
    "phone": "526122167",
    "email": "lisnsadmin@eircom.net"
  },
  {
    "i": "2645",
    "county": "Tipperary",
    "rollNumber": "07245S",
    "schoolName": "Cullen NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "E34XR86",
    "addressOne": "Cullen",
    "addressTwo": "Co. Tipperary",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.5115887",
    "lng": "-8.2778402",
    "phone": "6247558",
    "email": "cullenns@gmail.com"
  },
  {
    "i": "2646",
    "county": "Tipperary",
    "rollNumber": "07358I",
    "schoolName": "SN Sceichin A Rince",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "E21YP73",
    "addressOne": "Skeheenarinky",
    "addressTwo": "Burncourt",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.3069323",
    "lng": "-8.1490531",
    "phone": "527467421",
    "email": "sceichinarince@gmail.com"
  },
  {
    "i": "2647",
    "county": "Tipperary",
    "rollNumber": "09190G",
    "schoolName": "Boher NS",
    "SETHours": "87.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "2.33",
    "spSNA": "1.66",
    "totalSNA": "3.99",
    "eircode": "V94T635",
    "addressOne": "Boher",
    "addressTwo": "Ballina",
    "addressThree": "Killaloe Po",
    "addressFour": "Co. Tipperary",
    "lat": "52.8020412",
    "lng": "-8.3676568",
    "phone": "61376199",
    "email": "admin.boherns@gmail.com"
  },
  {
    "i": "2648",
    "county": "Tipperary",
    "rollNumber": "09432E",
    "schoolName": "St Josephs Primary School",
    "SETHours": "80",
    "spClassTeachingPosts": "2",
    "mainSNA": "2.83",
    "spSNA": "3.32",
    "totalSNA": "6.15",
    "eircode": "E34Y161",
    "addressOne": "Murgasty Road",
    "addressTwo": "Tipperary Town",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.4793736",
    "lng": "-8.1623484",
    "phone": "867855932",
    "email": "josephschtipp.ias@eircom.net"
  },
  {
    "i": "2649",
    "county": "Tipperary",
    "rollNumber": "09967U",
    "schoolName": "Upper Newtown NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "E32DP70",
    "addressOne": "Newtown Upper",
    "addressTwo": "Faugheen",
    "addressThree": "Carrick-on-suir",
    "addressFour": "Co. Tipperary",
    "lat": "52.4026224",
    "lng": "-7.3935761",
    "phone": "51641551",
    "email": "newtownupperns@outlook.com"
  },
  {
    "i": "2651",
    "county": "Tipperary",
    "rollNumber": "10533R",
    "schoolName": "Ballydrehid NS",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "E21X224",
    "addressOne": "Ballydrehid",
    "addressTwo": "Cahir",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.4075715",
    "lng": "-7.9653426",
    "phone": "527442581",
    "email": "ballydrehidns@gmail.com"
  },
  {
    "i": "2652",
    "county": "Tipperary",
    "rollNumber": "11367I",
    "schoolName": "Portroe NS",
    "SETHours": "57.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "0.5",
    "spSNA": "4",
    "totalSNA": "4.5",
    "eircode": "E45D890",
    "addressOne": "Nenagh",
    "addressTwo": "Co. Tipperary",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.8822731",
    "lng": "-8.353192",
    "phone": "6723588",
    "email": "portroeprimary@gmail.com"
  },
  {
    "i": "2653",
    "county": "Tipperary",
    "rollNumber": "11384I",
    "schoolName": "Gurtagarry NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "E45FA43",
    "addressOne": "Gortagarry",
    "addressTwo": "Toomevara",
    "addressThree": "Nenagh",
    "addressFour": "Co. Tipperary",
    "lat": "52.8204882",
    "lng": "-7.9789713",
    "phone": "6726004",
    "email": "gurtagarryns@yahoo.co.uk"
  },
  {
    "i": "2654",
    "county": "Tipperary",
    "rollNumber": "11453B",
    "schoolName": "Lisnamrock NS",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "E41C858",
    "addressOne": "Coalbrook",
    "addressTwo": "Thurles",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.6118759",
    "lng": "-7.5864966",
    "phone": "529154515",
    "email": "secretary@lisnamrockns.ie"
  },
  {
    "i": "2655",
    "county": "Tipperary",
    "rollNumber": "11470B",
    "schoolName": "Slieveardagh NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "E41PD39",
    "addressOne": "Kyleballygalvan",
    "addressTwo": "The Commons",
    "addressThree": "Thurles",
    "addressFour": "Co. Tipperary",
    "lat": "52.6250118",
    "lng": "-7.5442282",
    "phone": "529154422",
    "email": "slieveardaghns@hotmail.com"
  },
  {
    "i": "2656",
    "county": "Tipperary",
    "rollNumber": "11605V",
    "schoolName": "Rosegreen NS",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "E25EF21",
    "addressOne": "Rosegreen",
    "addressTwo": "Cashel",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.4679632",
    "lng": "-7.8313909",
    "phone": "6261938",
    "email": "office@rosegreenns.ie"
  },
  {
    "i": "2657",
    "county": "Tipperary",
    "rollNumber": "11872V",
    "schoolName": "Clochar Na Toirbhirte",
    "SETHours": "127.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.66",
    "spSNA": "0",
    "totalSNA": "2.66",
    "eircode": "E32CA26",
    "addressOne": "Greenside South",
    "addressTwo": "Carrick-on-suir",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.3478749",
    "lng": "-7.4116666",
    "phone": "51640798",
    "email": "proffice@presentationcarrick.ie"
  },
  {
    "i": "2658",
    "county": "Tipperary",
    "rollNumber": "12124K",
    "schoolName": "Rear NS",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "V94XT02",
    "addressOne": "Rearcross",
    "addressTwo": "Newport",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.6870813",
    "lng": "-8.2374516",
    "phone": "6279211",
    "email": "rearcrossns@gmail.com"
  },
  {
    "i": "2659",
    "county": "Tipperary",
    "rollNumber": "12180U",
    "schoolName": "Presentation Primary School",
    "SETHours": "142.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "1",
    "spSNA": "1.5",
    "totalSNA": "2.5",
    "eircode": "E91XF62",
    "addressOne": "Convent Road",
    "addressTwo": "Clonmel",
    "addressThree": "Co. Waterford",
    "addressFour": "",
    "lat": "52.3483715",
    "lng": "-7.7180834",
    "phone": "526123548",
    "email": "presclon.ias@eircom.net"
  },
  {
    "i": "2660",
    "county": "Tipperary",
    "rollNumber": "12349L",
    "schoolName": "SN Muire Na Naingeal",
    "SETHours": "165",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "E91X768",
    "addressOne": "Sisters Of Charity",
    "addressTwo": "Mary Street",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.3541048",
    "lng": "-7.7043688",
    "phone": "526121099",
    "email": "info@sistersofcharityns.ie"
  },
  {
    "i": "2661",
    "county": "Tipperary",
    "rollNumber": "12540B",
    "schoolName": "Clonmore NS",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "E41XW82",
    "addressOne": "Clonmore",
    "addressTwo": "Templemore",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.8299157",
    "lng": "-7.7657793",
    "phone": "50432072",
    "email": "clonmorens1@gmail.com"
  },
  {
    "i": "2662",
    "county": "Tipperary",
    "rollNumber": "13404V",
    "schoolName": "Scoil Mhuire Gan Smál",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "E25VH05",
    "addressOne": "New Inn",
    "addressTwo": "Co. Tipperary",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.4409396",
    "lng": "-7.8841875",
    "phone": "527462122",
    "email": "info@newinngirlsschool.ie"
  },
  {
    "i": "2663",
    "county": "Tipperary",
    "rollNumber": "13678M",
    "schoolName": "Killurney NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "E91XN84",
    "addressOne": "Killurney",
    "addressTwo": "Clonmel",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.3962541",
    "lng": "-7.605907",
    "phone": "526133427",
    "email": "killurneyns@gmail.com"
  },
  {
    "i": "2664",
    "county": "Tipperary",
    "rollNumber": "13847J",
    "schoolName": "Hollyford NS",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "E34DX01",
    "addressOne": "Curraheen",
    "addressTwo": "Hollyford",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.6291723",
    "lng": "-8.1204835",
    "phone": "6277226",
    "email": "hollyfordns@gmail.com"
  },
  {
    "i": "2665",
    "county": "Tipperary",
    "rollNumber": "13867P",
    "schoolName": "Roscrea NS No 2",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "E53A078",
    "addressOne": "Rosemount",
    "addressTwo": "Roscrea",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.9543966",
    "lng": "-7.7939052",
    "phone": "50521636",
    "email": "cron.ias@eircom.net"
  },
  {
    "i": "2666",
    "county": "Tipperary",
    "rollNumber": "13991Q",
    "schoolName": "Birdhill NS",
    "SETHours": "75",
    "spClassTeachingPosts": "2",
    "mainSNA": "1.5",
    "spSNA": "3.83",
    "totalSNA": "5.33",
    "eircode": "V94KC95",
    "addressOne": "Birdhill",
    "addressTwo": "Killaloe",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.7465454",
    "lng": "-8.4370488",
    "phone": "61379058",
    "email": "birdhillns@gmail.com"
  },
  {
    "i": "2667",
    "county": "Tipperary",
    "rollNumber": "14008S",
    "schoolName": "SN Bhride",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.58",
    "spSNA": "0",
    "totalSNA": "1.58",
    "eircode": "E34DH79",
    "addressOne": "Donaskeagh",
    "addressTwo": "Co. Tipperary",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.5254386",
    "lng": "-8.0858838",
    "phone": "6271388",
    "email": "donaskeighns@yahoo.co.uk"
  },
  {
    "i": "2668",
    "county": "Tipperary",
    "rollNumber": "14181J",
    "schoolName": "Poulacapple NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "R95V324",
    "addressOne": "Mullinahone",
    "addressTwo": "Via Callan",
    "addressThree": "Co. Kilkenny",
    "addressFour": "",
    "lat": "52.5001775",
    "lng": "-7.4355954",
    "phone": "529153436",
    "email": "poulacapplens@gmail.com"
  },
  {
    "i": "2669",
    "county": "Tipperary",
    "rollNumber": "14426N",
    "schoolName": "Knockavilla NS",
    "SETHours": "60",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "E34TY07",
    "addressOne": "Killenure",
    "addressTwo": "Dundrum",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.5446132",
    "lng": "-8.003851",
    "phone": "6271533",
    "email": "knockavillans.ias@eircom.net"
  },
  {
    "i": "2670",
    "county": "Tipperary",
    "rollNumber": "14460N",
    "schoolName": "Killea NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "E41HW20",
    "addressOne": "Killea",
    "addressTwo": "Templemore",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.8289207",
    "lng": "-7.8709044",
    "phone": "50431939",
    "email": "killeans2020@gmail.com"
  },
  {
    "i": "2671",
    "county": "Tipperary",
    "rollNumber": "14791N",
    "schoolName": "Cappawhite NS",
    "SETHours": "52.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "1.75",
    "spSNA": "4",
    "totalSNA": "5.75",
    "eircode": "E34V598",
    "addressOne": "Cappagh",
    "addressTwo": "Cappawhite",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.5838561",
    "lng": "-8.1646976",
    "phone": "6275363",
    "email": "cappawhitens2@gmail.com"
  },
  {
    "i": "2672",
    "county": "Tipperary",
    "rollNumber": "15008A",
    "schoolName": "Shronell NS",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "E34KH30",
    "addressOne": "Lattin",
    "addressTwo": "Co. Tipperary",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.4703893",
    "lng": "-8.250067",
    "phone": "6255189",
    "email": "shronellns.ias@gmail.com"
  },
  {
    "i": "2673",
    "county": "Tipperary",
    "rollNumber": "15157R",
    "schoolName": "Mount Bruis NS",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "E34RD26",
    "addressOne": "Mount Bruis",
    "addressTwo": "Tipperary Town",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.4438046",
    "lng": "-8.2297066",
    "phone": "6255339",
    "email": "mountbruis@eircom.net"
  },
  {
    "i": "2674",
    "county": "Tipperary",
    "rollNumber": "15299O",
    "schoolName": "Gaile NS",
    "SETHours": "25",
    "spClassTeachingPosts": "1",
    "mainSNA": "0",
    "spSNA": "2",
    "totalSNA": "2",
    "eircode": "E41YK70",
    "addressOne": "Holycross",
    "addressTwo": "Thurles",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.6031188",
    "lng": "-7.8672579",
    "phone": "879663959",
    "email": "gaile.ias@eircom.net"
  },
  {
    "i": "2675",
    "county": "Tipperary",
    "rollNumber": "15362S",
    "schoolName": "SN Michil Naofa",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.75",
    "spSNA": "0",
    "totalSNA": "2.75",
    "eircode": "E41ED30",
    "addressOne": "Mullinahone",
    "addressTwo": "Thurles",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.5138849",
    "lng": "-7.5006405",
    "phone": "529153304",
    "email": "8888mull@gmail.com"
  },
  {
    "i": "2676",
    "county": "Tipperary",
    "rollNumber": "15560W",
    "schoolName": "Bishop Harty Ns",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "E45HF74",
    "addressOne": "Ballinree",
    "addressTwo": "Nenagh",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.868354",
    "lng": "-8.0950836",
    "phone": "6729155",
    "email": "bishophartyns@gmail.com"
  },
  {
    "i": "2677",
    "county": "Tipperary",
    "rollNumber": "15696B",
    "schoolName": "Silvermines NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "E45T658",
    "addressOne": "Silvermines",
    "addressTwo": "Nenagh",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.7918063",
    "lng": "-8.2383608",
    "phone": "6725444",
    "email": "silverminesns@gmail.com"
  },
  {
    "i": "2678",
    "county": "Tipperary",
    "rollNumber": "15778D",
    "schoolName": "St Marys NS",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "E45KT22",
    "addressOne": "Church Road",
    "addressTwo": "Nenagh",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.8673747",
    "lng": "-8.1989572",
    "phone": "6732566",
    "email": "stmarys2.ns@gmail.com"
  },
  {
    "i": "2679",
    "county": "Tipperary",
    "rollNumber": "15795D",
    "schoolName": "St Marys NS",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "E41F596",
    "addressOne": "Church Street",
    "addressTwo": "Templemore",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.7995473",
    "lng": "-7.8299809",
    "phone": "50432269",
    "email": "stmarynstemplemore@yahoo.ie"
  },
  {
    "i": "2680",
    "county": "Tipperary",
    "rollNumber": "15970S",
    "schoolName": "Ballytarsna NS",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "E25RW52",
    "addressOne": "Ballytarsna",
    "addressTwo": "Cashel",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.5787202",
    "lng": "-7.8379497",
    "phone": "50441323",
    "email": "littleflowerns@gmail.com"
  },
  {
    "i": "2681",
    "county": "Tipperary",
    "rollNumber": "16077B",
    "schoolName": "Ardfinnan NS",
    "SETHours": "130",
    "spClassTeachingPosts": "2",
    "mainSNA": "2.5",
    "spSNA": "4",
    "totalSNA": "6.5",
    "eircode": "E91X6F9",
    "addressOne": "Clonmel",
    "addressTwo": "Co. Tipperary",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.3091556",
    "lng": "-7.8809553",
    "phone": "527466397",
    "email": "ardfinnanns3@gmail.com"
  },
  {
    "i": "2682",
    "county": "Tipperary",
    "rollNumber": "16111V",
    "schoolName": "Killusty NS",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "E91XE12",
    "addressOne": "Killusty",
    "addressTwo": "Fethard",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.4498194",
    "lng": "-7.6340336",
    "phone": "526132314",
    "email": "killustyns@gmail.com"
  },
  {
    "i": "2683",
    "county": "Tipperary",
    "rollNumber": "16112A",
    "schoolName": "St Marys Convent",
    "SETHours": "140",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "E45DX78",
    "addressOne": "O'rahilly Street",
    "addressTwo": "Nenagh",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.8660124",
    "lng": "-8.2007635",
    "phone": "6731895",
    "email": "info@conventprimarynenagh.ie"
  },
  {
    "i": "2684",
    "county": "Tipperary",
    "rollNumber": "16166A",
    "schoolName": "Carrig NS",
    "SETHours": "20",
    "spClassTeachingPosts": "1",
    "mainSNA": "1",
    "spSNA": "1.66",
    "totalSNA": "2.66",
    "eircode": "R42TN60",
    "addressOne": "Carrig",
    "addressTwo": "Birr",
    "addressThree": "Co. Offaly",
    "addressFour": "",
    "lat": "53.0630821",
    "lng": "-7.9717126",
    "phone": "579120804",
    "email": "sncarrig@gmail.com"
  },
  {
    "i": "2685",
    "county": "Tipperary",
    "rollNumber": "16211C",
    "schoolName": "Two Mile Borris NS",
    "SETHours": "72.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "1",
    "spSNA": "0.25",
    "totalSNA": "1.25",
    "eircode": "E41T868",
    "addressOne": "Two Mile Borris",
    "addressTwo": "Thurles",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.6728332",
    "lng": "-7.7107174",
    "phone": "50444466",
    "email": "office@scoilmochaomhog.ie"
  },
  {
    "i": "2686",
    "county": "Tipperary",
    "rollNumber": "16250M",
    "schoolName": "Templetuohy NS",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.75",
    "spSNA": "0",
    "totalSNA": "1.75",
    "eircode": "E41FX03",
    "addressOne": "Main Street",
    "addressTwo": "Templetuohy",
    "addressThree": "Thurles",
    "addressFour": "Co. Tipperary",
    "lat": "52.7875551",
    "lng": "-7.7231894",
    "phone": "50453175",
    "email": "holyfamilytempletuohy@gmail.com"
  },
  {
    "i": "2687",
    "county": "Tipperary",
    "rollNumber": "16276H",
    "schoolName": "Carrig NS",
    "SETHours": "107.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "E45P227",
    "addressOne": "Ballycommon",
    "addressTwo": "Nenagh",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.8937746",
    "lng": "-8.2513742",
    "phone": "6724355",
    "email": "carrigns1@gmail.com"
  },
  {
    "i": "2688",
    "county": "Tipperary",
    "rollNumber": "16344V",
    "schoolName": "St Marys Jnr BNS",
    "SETHours": "112.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "1.33",
    "spSNA": "3.66",
    "totalSNA": "4.99",
    "eircode": "E45W880",
    "addressOne": "St Flannan Street",
    "addressTwo": "Nenagh",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.8675547",
    "lng": "-8.2006797",
    "phone": "6732005",
    "email": "stmarysjuniorboys@gmail.com"
  },
  {
    "i": "2689",
    "county": "Tipperary",
    "rollNumber": "16725K",
    "schoolName": "SN Mhuire Na Mbraithre",
    "SETHours": "80",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "E32X920",
    "addressOne": "John Street",
    "addressTwo": "Carrick-on-suir",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.3496022",
    "lng": "-7.4146752",
    "phone": "51641333",
    "email": "2greenschool@eircom.net"
  },
  {
    "i": "2690",
    "county": "Tipperary",
    "rollNumber": "16727O",
    "schoolName": "Scoil Na Mbraithre",
    "SETHours": "160",
    "spClassTeachingPosts": "1",
    "mainSNA": "3.5",
    "spSNA": "1",
    "totalSNA": "4.5",
    "eircode": "E45VW44",
    "addressOne": "Nenagh",
    "addressTwo": "Co. Tipperary",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.8661889",
    "lng": "-8.194347",
    "phone": "6732748",
    "email": "info@nenaghcbsp.ie"
  },
  {
    "i": "2691",
    "county": "Tipperary",
    "rollNumber": "16728Q",
    "schoolName": "St Marys NS",
    "SETHours": "130",
    "spClassTeachingPosts": "2",
    "mainSNA": "2.5",
    "spSNA": "3.32",
    "totalSNA": "5.82",
    "eircode": "E91HP70",
    "addressOne": "Irishtown",
    "addressTwo": "Clonmel",
    "addressThree": "Co Tipperary",
    "addressFour": "",
    "lat": "52.3524791",
    "lng": "-7.7121046",
    "phone": "526121594",
    "email": "stmaryscbsns@yahoo.ie"
  },
  {
    "i": "2692",
    "county": "Tipperary",
    "rollNumber": "16729S",
    "schoolName": "St Peter And Paul",
    "SETHours": "147.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "E91NF43",
    "addressOne": "Kickham Street",
    "addressTwo": "Clonmel",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.3567258",
    "lng": "-7.7004979",
    "phone": "526121964",
    "email": "peterandpauls2@eircom.net"
  },
  {
    "i": "2693",
    "county": "Tipperary",
    "rollNumber": "16810B",
    "schoolName": "Eochaille Ara NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "E45K372",
    "addressOne": "Newtown",
    "addressTwo": "Nenagh",
    "addressThree": "Co Tipperary",
    "addressFour": "",
    "lat": "52.8790737",
    "lng": "-8.2982326",
    "phone": "6723611",
    "email": "youghalarraschool@gmail.com"
  },
  {
    "i": "2694",
    "county": "Tipperary",
    "rollNumber": "16933R",
    "schoolName": "Loch Mor Maigh NS",
    "SETHours": "52.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "3.33",
    "spSNA": "6",
    "totalSNA": "9.33",
    "eircode": "E41NN12",
    "addressOne": "Loughmore",
    "addressTwo": "Templemore",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.756111",
    "lng": "-7.8331058",
    "phone": "50432225",
    "email": "loughmore.ias@eircom.net"
  },
  {
    "i": "2695",
    "county": "Tipperary",
    "rollNumber": "16979S",
    "schoolName": "St Colmcilles Primary School",
    "SETHours": "90",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "E41CR60",
    "addressOne": "Church Avenue",
    "addressTwo": "Templemore",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.794809",
    "lng": "-7.8327421",
    "phone": "50431616",
    "email": "STCOLMCILLENS@EIRCOM.NET"
  },
  {
    "i": "2696",
    "county": "Tipperary",
    "rollNumber": "17114J",
    "schoolName": "SN An Ghabhailin",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "E25YC60",
    "addressOne": "Golden",
    "addressTwo": "Cashel",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.499035",
    "lng": "-7.9785211",
    "phone": "6272164",
    "email": "goldenns@yahoo.ie"
  },
  {
    "i": "2697",
    "county": "Tipperary",
    "rollNumber": "17140K",
    "schoolName": "SN Baile Sluagh",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "E41X266",
    "addressOne": "Ballysloe",
    "addressTwo": "Gortnahoe",
    "addressThree": "Thurles",
    "addressFour": "",
    "lat": "52.6372016",
    "lng": "-7.6085284",
    "phone": "568834533",
    "email": "ballysloens@gmail.com"
  },
  {
    "i": "2698",
    "county": "Tipperary",
    "rollNumber": "17179O",
    "schoolName": "SN An Cillin",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.25",
    "spSNA": "0",
    "totalSNA": "1.25",
    "eircode": "R42AK00",
    "addressOne": "Birr",
    "addressTwo": "Co Offaly",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.089377",
    "lng": "-7.9389972",
    "phone": "579121682",
    "email": "killeenschool@eircom.net"
  },
  {
    "i": "2699",
    "county": "Tipperary",
    "rollNumber": "17237C",
    "schoolName": "SN Cill Barfhionn",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "E45AW72",
    "addressOne": "Coolbawn",
    "addressTwo": "Nenagh",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.9880581",
    "lng": "-8.2263382",
    "phone": "6728144",
    "email": "kilbarronns@gmail.com"
  },
  {
    "i": "2700",
    "county": "Tipperary",
    "rollNumber": "17244W",
    "schoolName": "SN Naomh Ruadhain",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "E45XP58",
    "addressOne": "Redwood",
    "addressTwo": "Lorrha",
    "addressThree": "Nenagh",
    "addressFour": "Co. Tipperary",
    "lat": "53.127129",
    "lng": "-8.1037527",
    "phone": "909747186",
    "email": "redwoodns@live.ie"
  },
  {
    "i": "2701",
    "county": "Tipperary",
    "rollNumber": "17276M",
    "schoolName": "Scoil Na Mbraithre",
    "SETHours": "97.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "E34KR44",
    "addressOne": "Murgasty Road",
    "addressTwo": "Tipperary",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.4782516",
    "lng": "-8.1635952",
    "phone": "6252656",
    "email": "monasteryschooltipp@gmail.com"
  },
  {
    "i": "2702",
    "county": "Tipperary",
    "rollNumber": "17296S",
    "schoolName": "SN Baile Na Hinse",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.33",
    "spSNA": "0",
    "totalSNA": "1.33",
    "eircode": "V94R234",
    "addressOne": "Ballinahinch",
    "addressTwo": "Birdhill",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.767236",
    "lng": "-8.3821121",
    "phone": "61379404",
    "email": "bhinch.ias@eircom.net"
  },
  {
    "i": "2703",
    "county": "Tipperary",
    "rollNumber": "17332T",
    "schoolName": "St Marys Parochial School",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "E91HK58",
    "addressOne": "Western Road",
    "addressTwo": "Clonmel",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.3539482",
    "lng": "-7.7145315",
    "phone": "867038121",
    "email": "office@stmarysparochialschool.com"
  },
  {
    "i": "2704",
    "county": "Tipperary",
    "rollNumber": "17486A",
    "schoolName": "SN Cleireachain",
    "SETHours": "80",
    "spClassTeachingPosts": "2",
    "mainSNA": "2",
    "spSNA": "4",
    "totalSNA": "6",
    "eircode": "E91WP77",
    "addressOne": "Clerihan",
    "addressTwo": "Clonmel",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.4103319",
    "lng": "-7.7555044",
    "phone": "526135400",
    "email": "officeclerihan@gmail.com"
  },
  {
    "i": "2705",
    "county": "Tipperary",
    "rollNumber": "17498H",
    "schoolName": "SN Naomh Sheosamh",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "E45VH70",
    "addressOne": "Toomevara",
    "addressTwo": "Nenagh",
    "addressThree": "Co Tipperary",
    "addressFour": "",
    "lat": "52.8475199",
    "lng": "-8.0330899",
    "phone": "6726088",
    "email": "info@toomevarans.com"
  },
  {
    "i": "2706",
    "county": "Tipperary",
    "rollNumber": "17511T",
    "schoolName": "SN Baile An Iubhair",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "E41PP30",
    "addressOne": "Thurles",
    "addressTwo": "Co. Tipperary",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.5659831",
    "lng": "-7.7608498",
    "phone": "529156807",
    "email": "mnighliasain@hotmail.com"
  },
  {
    "i": "2707",
    "county": "Tipperary",
    "rollNumber": "17512V",
    "schoolName": "SN Flannain Naofa",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "R42TK23",
    "addressOne": "Rathcabbin",
    "addressTwo": "Roscrea",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "53.1172464",
    "lng": "-8.0280451",
    "phone": "579139008",
    "email": "principal@rathcabbinns.ie"
  },
  {
    "i": "2708",
    "county": "Tipperary",
    "rollNumber": "17542H",
    "schoolName": "SN Rath Chaomhghin",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "E91TX38",
    "addressOne": "Rathkeevin",
    "addressTwo": "Clonmel",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.3731966",
    "lng": "-7.7837257",
    "phone": "526121680",
    "email": "rathkeevinns@gmail.com"
  },
  {
    "i": "2709",
    "county": "Tipperary",
    "rollNumber": "17543J",
    "schoolName": "Cloughjordan NS",
    "SETHours": "40",
    "spClassTeachingPosts": "2",
    "mainSNA": "1",
    "spSNA": "4",
    "totalSNA": "5",
    "eircode": "E53WC80",
    "addressOne": "Cloughjordan",
    "addressTwo": "Co. Tipperary",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.9437682",
    "lng": "-8.0449286",
    "phone": "50542431",
    "email": "stmichaelnscloughjordan@gmail.com"
  },
  {
    "i": "2710",
    "county": "Tipperary",
    "rollNumber": "17580P",
    "schoolName": "SN Gort Na Huaighe",
    "SETHours": "62.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "E41F857",
    "addressOne": "Gortnahoe",
    "addressTwo": "Thurles",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.6748787",
    "lng": "-7.6033226",
    "phone": "568834390",
    "email": "info@gortnahoens.ie"
  },
  {
    "i": "2711",
    "county": "Tipperary",
    "rollNumber": "17608L",
    "schoolName": "SN Lua Naofa",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "E45AH95",
    "addressOne": "Lorrha",
    "addressTwo": "Nenagh",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "53.0940689",
    "lng": "-8.1226362",
    "phone": "909747295",
    "email": "luanaofa@eircom.net"
  },
  {
    "i": "2712",
    "county": "Tipperary",
    "rollNumber": "17634M",
    "schoolName": "Scoil Ailbhe",
    "SETHours": "132.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "E41XY10",
    "addressOne": "Parnell Street",
    "addressTwo": "Thurles",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.6815059",
    "lng": "-7.8181455",
    "phone": "50421448",
    "email": "reception@scoilailbhe.ie"
  },
  {
    "i": "2713",
    "county": "Tipperary",
    "rollNumber": "17640H",
    "schoolName": "SN Colmain Naofa",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "E45T671",
    "addressOne": "Terryglass",
    "addressTwo": "Nenagh",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "53.0551555",
    "lng": "-8.2054473",
    "phone": "6722269",
    "email": "terryglassns@eircom.net"
  },
  {
    "i": "2714",
    "county": "Tipperary",
    "rollNumber": "17653Q",
    "schoolName": "Castle Iny NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "E41X386",
    "addressOne": "Castleiney",
    "addressTwo": "Templemore",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.7869056",
    "lng": "-7.7869659",
    "phone": "50432474",
    "email": "castleineyns@gmail.com"
  },
  {
    "i": "2715",
    "county": "Tipperary",
    "rollNumber": "17665A",
    "schoolName": "SN Gleann Guail",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "E41X921",
    "addressOne": "Glengoole North",
    "addressTwo": "Thurles",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.618635",
    "lng": "-7.6382204",
    "phone": "529156644",
    "email": "glengoolenationalschool@gmail.com"
  },
  {
    "i": "2716",
    "county": "Tipperary",
    "rollNumber": "17681V",
    "schoolName": "SN Na Maighne",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "E41D6K3",
    "addressOne": "Moyne",
    "addressTwo": "Thurles",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.7353925",
    "lng": "-7.71517",
    "phone": "50445375",
    "email": "admin@snamaighne.com"
  },
  {
    "i": "2717",
    "county": "Tipperary",
    "rollNumber": "17694H",
    "schoolName": "SN Chluainin",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "E91D838",
    "addressOne": "Cloneen",
    "addressTwo": "Fethard",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.4748278",
    "lng": "-7.5969843",
    "phone": "526131887",
    "email": "office@cloneenns.ie"
  },
  {
    "i": "2718",
    "county": "Tipperary",
    "rollNumber": "17703F",
    "schoolName": "SN Ard Croine",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "E45VH01",
    "addressOne": "Ardcroney",
    "addressTwo": "Nenagh",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.9365933",
    "lng": "-8.1550337",
    "phone": "6738269",
    "email": "ardcroney@eircom.net"
  },
  {
    "i": "2719",
    "county": "Tipperary",
    "rollNumber": "17712G",
    "schoolName": "SN Chiarda Naofa",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "E45T922",
    "addressOne": "Kilkeary",
    "addressTwo": "Nenagh",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.8324461",
    "lng": "-8.1123449",
    "phone": "6734599",
    "email": "kilkearyns@gmail.com"
  },
  {
    "i": "2720",
    "county": "Tipperary",
    "rollNumber": "17731K",
    "schoolName": "SN Iosef Naofa",
    "SETHours": "92.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "E41W132",
    "addressOne": "Templemore",
    "addressTwo": "Co. Tipperary",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.7974835",
    "lng": "-7.8277303",
    "phone": "50431141",
    "email": "principal@stjosephstemplemore.ie"
  },
  {
    "i": "2721",
    "county": "Tipperary",
    "rollNumber": "17779P",
    "schoolName": "Powerstown NS",
    "SETHours": "105",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "E91Y961",
    "addressOne": "Clonmel",
    "addressTwo": "Co. Tipperary",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.3719869",
    "lng": "-7.6636861",
    "phone": "526123178",
    "email": "powerstownns@gmail.com"
  },
  {
    "i": "2722",
    "county": "Tipperary",
    "rollNumber": "17783G",
    "schoolName": "SN Chuirt Doighte",
    "SETHours": "32.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "1",
    "spSNA": "3",
    "totalSNA": "4",
    "eircode": "E21PT44",
    "addressOne": "Burncourt",
    "addressTwo": "Cahir",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.3120761",
    "lng": "-8.0780481",
    "phone": "527467202",
    "email": "burncourtnationalschool@gmail.com"
  },
  {
    "i": "2723",
    "county": "Tipperary",
    "rollNumber": "17799V",
    "schoolName": "SN Na Haille",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "E34FF90",
    "addressOne": "Aill,",
    "addressTwo": "An Mhoin Ard",
    "addressThree": "Co Thiobrad Arann",
    "addressFour": "",
    "lat": "52.5556272",
    "lng": "-8.2113414",
    "phone": "6276952",
    "email": "ayleschool@gmail.com"
  },
  {
    "i": "2724",
    "county": "Tipperary",
    "rollNumber": "17850S",
    "schoolName": "SN Phadraig Naofa",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "E45K681",
    "addressOne": "Kylepark",
    "addressTwo": "Borrisokane",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "53.0110101",
    "lng": "-8.1890224",
    "phone": "6722163",
    "email": "kyleparknationalschool@gmail.com"
  },
  {
    "i": "2725",
    "county": "Tipperary",
    "rollNumber": "17940T",
    "schoolName": "SN Na Mbuachailli",
    "SETHours": "60",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "V94RX20",
    "addressOne": "Clonbealy",
    "addressTwo": "Newport",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.7136856",
    "lng": "-8.4004327",
    "phone": "61378700",
    "email": "newportbs.ias@eircom.net"
  },
  {
    "i": "2726",
    "county": "Tipperary",
    "rollNumber": "18062V",
    "schoolName": "SN An Grainseach",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "E91KT67",
    "addressOne": "Clonmel",
    "addressTwo": "Co. Tipperary",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.3389768",
    "lng": "-7.8243595",
    "phone": "526138252",
    "email": "nsgrange1956@gmail.com"
  },
  {
    "i": "2727",
    "county": "Tipperary",
    "rollNumber": "18085K",
    "schoolName": "Ballyneale NS",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "E32YV18",
    "addressOne": "Ballyneale",
    "addressTwo": "Carrick-on-suir",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.3743335",
    "lng": "-7.4662273",
    "phone": "51641417",
    "email": "ballynealens32@gmail.com"
  },
  {
    "i": "2728",
    "county": "Tipperary",
    "rollNumber": "18087O",
    "schoolName": "SN Odhran Naofa",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "E45EY97",
    "addressOne": "Ballinaclough",
    "addressTwo": "Nenagh",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.8173697",
    "lng": "-8.1544244",
    "phone": "6725455",
    "email": "ballinacloughns@gmail.com"
  },
  {
    "i": "2729",
    "county": "Tipperary",
    "rollNumber": "18135W",
    "schoolName": "Scoil Angela",
    "SETHours": "122.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.33",
    "spSNA": "0",
    "totalSNA": "2.33",
    "eircode": "E41ET35",
    "addressOne": "Ursuline Convent",
    "addressTwo": "Thurles",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.6812753",
    "lng": "-7.8116492",
    "phone": "50422561",
    "email": "info@scoilangela.ie"
  },
  {
    "i": "2730",
    "county": "Tipperary",
    "rollNumber": "18164G",
    "schoolName": "SN Buirgheas",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "E45FP97",
    "addressOne": "Nenagh",
    "addressTwo": "Co Tipperary",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.8286486",
    "lng": "-8.3044876",
    "phone": "6734515",
    "email": "burgessns@eircom.net"
  },
  {
    "i": "2731",
    "county": "Tipperary",
    "rollNumber": "18207V",
    "schoolName": "SN Baile An Atha",
    "SETHours": "127.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "1.5",
    "spSNA": "3.83",
    "totalSNA": "5.33",
    "eircode": "V94V8X6",
    "addressOne": "Grange Road",
    "addressTwo": "Ballina",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.811019",
    "lng": "-8.4370824",
    "phone": "61376340",
    "email": "office@ballinaprimaryschool.com"
  },
  {
    "i": "2732",
    "county": "Tipperary",
    "rollNumber": "18213Q",
    "schoolName": "SN Leamhach",
    "SETHours": "57.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "1.83",
    "spSNA": "4",
    "totalSNA": "5.83",
    "eircode": "E41NF72",
    "addressOne": "Leugh",
    "addressTwo": "Thurles",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.7076692",
    "lng": "-7.8436923",
    "phone": "50423111",
    "email": "leughns@eircom.net"
  },
  {
    "i": "2733",
    "county": "Tipperary",
    "rollNumber": "18285S",
    "schoolName": "SN Cill Chuimin",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "E41DK00",
    "addressOne": "Thurles",
    "addressTwo": "Co. Tipperary",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6909419",
    "lng": "-8.1464401",
    "phone": "6278144",
    "email": "kilcommonschool@gmail.com"
  },
  {
    "i": "2734",
    "county": "Tipperary",
    "rollNumber": "18322V",
    "schoolName": "SN An Droma",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "E41PC86",
    "addressOne": "Drom",
    "addressTwo": "Templemore",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.768551",
    "lng": "-7.8962404",
    "phone": "50451688",
    "email": "dromns@hotmail.com"
  },
  {
    "i": "2735",
    "county": "Tipperary",
    "rollNumber": "18326G",
    "schoolName": "SN Naomh Padraig",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "E91VX56",
    "addressOne": "Cill Chais",
    "addressTwo": "Clonmel",
    "addressThree": "Co Tipperary",
    "addressFour": "",
    "lat": "52.4038909",
    "lng": "-7.5374164",
    "phone": "526133397",
    "email": "kilcashns18@eircom.net"
  },
  {
    "i": "2736",
    "county": "Tipperary",
    "rollNumber": "18343G",
    "schoolName": "SN Chaoimhghin",
    "SETHours": "82.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "1.5",
    "spSNA": "4.33",
    "totalSNA": "5.83",
    "eircode": "E41VW24",
    "addressOne": "Littleton",
    "addressTwo": "Thurles",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.6375418",
    "lng": "-7.7356111",
    "phone": "50444493",
    "email": "office@littletonns.ie"
  },
  {
    "i": "2737",
    "county": "Tipperary",
    "rollNumber": "18345K",
    "schoolName": "SN Iosef Naofa",
    "SETHours": "190",
    "spClassTeachingPosts": "1",
    "mainSNA": "3",
    "spSNA": "2.75",
    "totalSNA": "5.75",
    "eircode": "E53Y449",
    "addressOne": "Corville",
    "addressTwo": "Roscrea",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.9388669",
    "lng": "-7.7843515",
    "phone": "50521485",
    "email": "info@corvillens.com"
  },
  {
    "i": "2738",
    "county": "Tipperary",
    "rollNumber": "18350D",
    "schoolName": "SN Na Hinse",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "E41YF62",
    "addressOne": "Bouladuff",
    "addressTwo": "Thurles",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.7174414",
    "lng": "-7.9106462",
    "phone": "50451553",
    "email": "inchns@gmail.com"
  },
  {
    "i": "2739",
    "county": "Tipperary",
    "rollNumber": "18369B",
    "schoolName": "SN Cill Ruadhain",
    "SETHours": "62.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "1",
    "spSNA": "4.41",
    "totalSNA": "5.41",
    "eircode": "E45PN25",
    "addressOne": "Nenagh",
    "addressTwo": "Co. Tipperary",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.8940334",
    "lng": "-8.1368344",
    "phone": "6734366",
    "email": "office@kilruaneschool.com"
  },
  {
    "i": "2740",
    "county": "Tipperary",
    "rollNumber": "18379E",
    "schoolName": "Barnane NS",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "E41PX67",
    "addressOne": "Barnane",
    "addressTwo": "Templemore",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.7898506",
    "lng": "-7.9115726",
    "phone": "50431196",
    "email": "barnanens@gmail.com"
  },
  {
    "i": "2741",
    "county": "Tipperary",
    "rollNumber": "18396E",
    "schoolName": "SN Rath Eilte",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.58",
    "spSNA": "0",
    "totalSNA": "1.58",
    "eircode": "E41YV10",
    "addressOne": "Thurles",
    "addressTwo": "Co Tipperary",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.7143658",
    "lng": "-7.7615344",
    "phone": "50445266",
    "email": "rahealtyns@gmail.com"
  },
  {
    "i": "2742",
    "county": "Tipperary",
    "rollNumber": "18435L",
    "schoolName": "Sacred Heart Primary School",
    "SETHours": "90.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "0.75",
    "spSNA": "2",
    "totalSNA": "2.75",
    "eircode": "E53T680",
    "addressOne": "Newline",
    "addressTwo": "Roscrea",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.9492577",
    "lng": "-7.7988845",
    "phone": "50521620",
    "email": "sacredheartroscreatipperary@gmail.com"
  },
  {
    "i": "2743",
    "county": "Tipperary",
    "rollNumber": "18443K",
    "schoolName": "SN Iosef Naofa",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "E53RK65",
    "addressOne": "Aglish",
    "addressTwo": "Roscrea",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "53.0405775",
    "lng": "-8.0858259",
    "phone": "6721271",
    "email": "nsaglish@gmail.com"
  },
  {
    "i": "2744",
    "county": "Tipperary",
    "rollNumber": "18459C",
    "schoolName": "Scoil Mhuire",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "E41NR76",
    "addressOne": "Cill Mheanman",
    "addressTwo": "Mullinahone Thurles",
    "addressThree": "Co Tipperary",
    "addressFour": "",
    "lat": "52.4860256",
    "lng": "-7.5039619",
    "phone": "529153542",
    "email": "kilvemnonns@eircom.net"
  },
  {
    "i": "2745",
    "county": "Tipperary",
    "rollNumber": "18465U",
    "schoolName": "SN Lios An Halla",
    "SETHours": "62.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "1.66",
    "spSNA": "2",
    "totalSNA": "3.66",
    "eircode": "E45CK68",
    "addressOne": "Lissenhall",
    "addressTwo": "Nenagh",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.8310639",
    "lng": "-8.238322",
    "phone": "6734627",
    "email": "liosanhalla@gmail.com"
  },
  {
    "i": "2746",
    "county": "Tipperary",
    "rollNumber": "18486F",
    "schoolName": "SN Cill Siolain",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "E91CT99",
    "addressOne": "Chapel Road",
    "addressTwo": "Kilsheelan",
    "addressThree": "Clonmel",
    "addressFour": "Co. Tipperary",
    "lat": "52.3633504",
    "lng": "-7.5816386",
    "phone": "526133317",
    "email": "kilsheelanns@gmail.com"
  },
  {
    "i": "2747",
    "county": "Tipperary",
    "rollNumber": "18501V",
    "schoolName": "Grangemockler Ns",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "E32AY83",
    "addressOne": "Grangemockler",
    "addressTwo": "Carrick-on-suir",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.4454659",
    "lng": "-7.4722083",
    "phone": "51647222",
    "email": "grangemocklerns@eircom.net"
  },
  {
    "i": "2748",
    "county": "Tipperary",
    "rollNumber": "18512D",
    "schoolName": "St Francis NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "1",
    "spSNA": "3",
    "totalSNA": "4",
    "eircode": "E34RK71",
    "addressOne": "Garryshane",
    "addressTwo": "Donohill",
    "addressThree": "Co Tipperary",
    "addressFour": "",
    "lat": "52.5397053",
    "lng": "-8.1404428",
    "phone": "6276288",
    "email": "stfrancisnsdonohill@gmail.com"
  },
  {
    "i": "2749",
    "county": "Tipperary",
    "rollNumber": "18528S",
    "schoolName": "Annacarty NS",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "E34X985",
    "addressOne": "Shanaknock",
    "addressTwo": "Annacarty",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.566121",
    "lng": "-8.1123899",
    "phone": "6271566",
    "email": "anacartyns@eircom.net"
  },
  {
    "i": "2750",
    "county": "Tipperary",
    "rollNumber": "18538V",
    "schoolName": "Scoil Mhuire",
    "SETHours": "52.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "1.5",
    "spSNA": "4",
    "totalSNA": "5.5",
    "eircode": "E91DX23",
    "addressOne": "Newcastle",
    "addressTwo": "Clonmel",
    "addressThree": "Co. Tippeary",
    "addressFour": "",
    "lat": "52.2715919",
    "lng": "-7.8082374",
    "phone": "526136527",
    "email": "principal@scoilmhuirenewcastle.ie"
  },
  {
    "i": "2751",
    "county": "Tipperary",
    "rollNumber": "18557C",
    "schoolName": "SN Teampall Doire",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "E45C853",
    "addressOne": "Templederry",
    "addressTwo": "Nenagh",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.7736931",
    "lng": "-8.0785873",
    "phone": "877716251",
    "email": "tderryns@gmail.com"
  },
  {
    "i": "2752",
    "county": "Tipperary",
    "rollNumber": "18582B",
    "schoolName": "Ballylooby NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "E21EC66",
    "addressOne": "Cahir",
    "addressTwo": "Co Tipperary",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.3262368",
    "lng": "-7.9858389",
    "phone": "527442165",
    "email": "ballyloobyns@eircom.net"
  },
  {
    "i": "2754",
    "county": "Tipperary",
    "rollNumber": "18775M",
    "schoolName": "SN Micheal Naofa",
    "SETHours": "125",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.5",
    "spSNA": "0",
    "totalSNA": "3.5",
    "eircode": "E41Y840",
    "addressOne": "Holycross",
    "addressTwo": "Thurles",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.6401847",
    "lng": "-7.8699257",
    "phone": "50443337",
    "email": "holycrossns@gmail.com"
  },
  {
    "i": "2755",
    "county": "Tipperary",
    "rollNumber": "19294B",
    "schoolName": "Lisvernane NS",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "E34PX49",
    "addressOne": "Lisvernane",
    "addressTwo": "The Glen Of Aherlow",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.4116372",
    "lng": "-8.226269",
    "phone": "6256288",
    "email": "info@lisvernanens.ie"
  },
  {
    "i": "2756",
    "county": "Tipperary",
    "rollNumber": "19305D",
    "schoolName": "Tankerstown NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "E34AP68",
    "addressOne": "Tankerstown",
    "addressTwo": "Bansha",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.4192194",
    "lng": "-8.012001",
    "phone": "6254588",
    "email": "tankerstownns@gmail.com"
  },
  {
    "i": "2757",
    "county": "Tipperary",
    "rollNumber": "19356U",
    "schoolName": "Killenaule NS",
    "SETHours": "95",
    "spClassTeachingPosts": "2",
    "mainSNA": "1",
    "spSNA": "4",
    "totalSNA": "5",
    "eircode": "E41RK33",
    "addressOne": "Killenaule",
    "addressTwo": "Thurles",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.5701769",
    "lng": "-7.6753565",
    "phone": "529156447",
    "email": "principal@killenaulens.com"
  },
  {
    "i": "2758",
    "county": "Tipperary",
    "rollNumber": "19422H",
    "schoolName": "Cloughjordan No 1 NS",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "E53YY82",
    "addressOne": "Townfields",
    "addressTwo": "Cloughjordan",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.9385749",
    "lng": "-8.0292743",
    "phone": "50542318",
    "email": "cloughjordannsno1@gmail.com"
  },
  {
    "i": "2759",
    "county": "Tipperary",
    "rollNumber": "19540N",
    "schoolName": "Clogheen Central NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "E21F651",
    "addressOne": "Clogheen",
    "addressTwo": "Co Tipperary",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.270425",
    "lng": "-7.990154",
    "phone": "527465370",
    "email": "clogheenschool@hotmail.com"
  },
  {
    "i": "2760",
    "county": "Tipperary",
    "rollNumber": "19640R",
    "schoolName": "Scoil Mhuire",
    "SETHours": "50.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "E53Y589",
    "addressOne": "Lismackin",
    "addressTwo": "Roscrea",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.8970284",
    "lng": "-7.8130655",
    "phone": "50543308",
    "email": "lismackin@gmail.com"
  },
  {
    "i": "2761",
    "county": "Tipperary",
    "rollNumber": "19645E",
    "schoolName": "St Oliver Plunketts Ns",
    "SETHours": "242.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "E91NW22",
    "addressOne": "Mountain View",
    "addressTwo": "Elm Park",
    "addressThree": "Clonmel",
    "addressFour": "Co. Tipperary",
    "lat": "52.360411",
    "lng": "-7.7165368",
    "phone": "526121016",
    "email": "stolivers@eircom.net"
  },
  {
    "i": "2762",
    "county": "Tipperary",
    "rollNumber": "19677R",
    "schoolName": "Scoil Iosagain",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "E41DY88",
    "addressOne": "Upperchurch",
    "addressTwo": "Thurles",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.7013382",
    "lng": "-8.0217352",
    "phone": "50454331",
    "email": "upperchurchns@gmail.com"
  },
  {
    "i": "2763",
    "county": "Tipperary",
    "rollNumber": "19689B",
    "schoolName": "Bansha NS",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "E34KX68",
    "addressOne": "Bansha",
    "addressTwo": "Co Tipperary",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.4476261",
    "lng": "-8.0656091",
    "phone": "6254660",
    "email": "banshaschool@gmail.com"
  },
  {
    "i": "2764",
    "county": "Tipperary",
    "rollNumber": "19690J",
    "schoolName": "Clonoulty Central NS",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "E25E370",
    "addressOne": "Clonouty",
    "addressTwo": "Cashel",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.6025381",
    "lng": "-7.9590089",
    "phone": "50442029",
    "email": "clonoultyschool@gmail.com"
  },
  {
    "i": "2765",
    "county": "Tipperary",
    "rollNumber": "19692N",
    "schoolName": "St John The Baptist",
    "SETHours": "132.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.25",
    "spSNA": "0",
    "totalSNA": "1.25",
    "eircode": "E25V627",
    "addressOne": "Old Road",
    "addressTwo": "Cashel",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.509937",
    "lng": "-7.8852052",
    "phone": "6261833",
    "email": "reception@cashelprimaryschools.ie"
  },
  {
    "i": "2766",
    "county": "Tipperary",
    "rollNumber": "19696V",
    "schoolName": "Cashel Deanery",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "E25NV05",
    "addressOne": "Cashel",
    "addressTwo": "Co Tipperary",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.5093557",
    "lng": "-7.885205",
    "phone": "6261833",
    "email": "thedeaneryschool@gmail.com"
  },
  {
    "i": "2767",
    "county": "Tipperary",
    "rollNumber": "19874T",
    "schoolName": "Presentation Primary School",
    "SETHours": "122.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "2.83",
    "spSNA": "1.66",
    "totalSNA": "4.49",
    "eircode": "E41V967",
    "addressOne": "Cathedral Street",
    "addressTwo": "Thurles",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.6817216",
    "lng": "-7.8078741",
    "phone": "50422331",
    "email": "info@presprimarythurles.ie"
  },
  {
    "i": "2768",
    "county": "Tipperary",
    "rollNumber": "19879G",
    "schoolName": "Naomh Padraig Jn",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "E41X337",
    "addressOne": "Drangan",
    "addressTwo": "Thurles",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.517315",
    "lng": "-7.5879206",
    "phone": "529152278",
    "email": "office@dranganns.ie"
  },
  {
    "i": "2769",
    "county": "Tipperary",
    "rollNumber": "19880O",
    "schoolName": "Naomh Padraig Sn",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "E41X337",
    "addressOne": "Newtown",
    "addressTwo": "Drangan",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.517315",
    "lng": "-7.5879206",
    "phone": "529152278",
    "email": "office@dranganns.ie"
  },
  {
    "i": "2770",
    "county": "Tipperary",
    "rollNumber": "19937R",
    "schoolName": "Gaelscoil Aonach",
    "SETHours": "62.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "E45AK02",
    "addressOne": "Bóthar Naomh Chonlain",
    "addressTwo": "An Taonach",
    "addressThree": "Co. Thiobraid árann",
    "addressFour": "",
    "lat": "52.8687258",
    "lng": "-8.2078325",
    "phone": "6733509",
    "email": "oifig@gaelscoilau.ie"
  },
  {
    "i": "2771",
    "county": "Tipperary",
    "rollNumber": "19968F",
    "schoolName": "Gaelscoil Durlas Eile",
    "SETHours": "65",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "E41A668",
    "addressOne": "Bóthar Na Naomh",
    "addressTwo": "Durlas",
    "addressThree": "Co. Thiobraid árann",
    "addressFour": "",
    "lat": "52.6793007",
    "lng": "-7.8239182",
    "phone": "50421497",
    "email": "oifig@gaelscoildurlas.ie"
  },
  {
    "i": "2772",
    "county": "Tipperary",
    "rollNumber": "20007C",
    "schoolName": "Gaelscoil Chluain Meala",
    "SETHours": "72.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "E91WT78",
    "addressOne": "Baile Gaelach",
    "addressTwo": "Cluain Meala",
    "addressThree": "Co. Thiobraid árainn",
    "addressFour": "",
    "lat": "52.3520551",
    "lng": "-7.7131556",
    "phone": "526127271",
    "email": "eolas@gaelscoilchluainmeala.ie"
  },
  {
    "i": "2773",
    "county": "Tipperary",
    "rollNumber": "20027I",
    "schoolName": "Gaelscoil Thiobraid Arann",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "E34F544",
    "addressOne": "Cnoc An Railéigh",
    "addressTwo": "Baile Thiobraid árann",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.471686",
    "lng": "-8.1497467",
    "phone": "6231240",
    "email": "tgaelscoil@yahoo.ie"
  },
  {
    "i": "2774",
    "county": "Tipperary",
    "rollNumber": "20062K",
    "schoolName": "Scoil Mhuire",
    "SETHours": "72.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "E45H928",
    "addressOne": "Nenagh Road",
    "addressTwo": "Borrisokane",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.9920106",
    "lng": "-8.1287699",
    "phone": "6727477",
    "email": "borrisokanens@gmail.com"
  },
  {
    "i": "2775",
    "county": "Tipperary",
    "rollNumber": "20085W",
    "schoolName": "Gaelscoil Charraig Na Siuire",
    "SETHours": "62.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "E32AK88",
    "addressOne": "Coolnamuck Road",
    "addressTwo": "Carrick-on-suir",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.3438921",
    "lng": "-7.4262901",
    "phone": "51640366",
    "email": "reception@gaelscoilcharraignasiuire.com"
  },
  {
    "i": "2776",
    "county": "Tipperary",
    "rollNumber": "20129Q",
    "schoolName": "Scoil Teampall Toinne",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "E21XP64",
    "addressOne": "Ballyporeen",
    "addressTwo": "Cahir",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.2711215",
    "lng": "-8.0971008",
    "phone": "527467536",
    "email": "scoil_tt@eircom.net"
  },
  {
    "i": "2777",
    "county": "Tipperary",
    "rollNumber": "20155R",
    "schoolName": "St John The Baptist Boys School",
    "SETHours": "180",
    "spClassTeachingPosts": "1",
    "mainSNA": "5",
    "spSNA": "2",
    "totalSNA": "7",
    "eircode": "E25V627",
    "addressOne": "Old Road",
    "addressTwo": "Cashel",
    "addressThree": "Co. Tipperary",
    "addressFour": "",
    "lat": "52.509937",
    "lng": "-7.8852052",
    "phone": "6261833",
    "email": "reception@cashelprimaryschools.ie"
  },
  {
    "i": "2778",
    "county": "Tipperary",
    "rollNumber": "20355C",
    "schoolName": "Holy Trinity NS",
    "SETHours": "135",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "E91TD43",
    "addressOne": "Rocklow Road",
    "addressTwo": "Fethard",
    "addressThree": "Co Tipperary",
    "addressFour": "",
    "lat": "52.4689271",
    "lng": "-7.6988273",
    "phone": "526131493",
    "email": "rocklowprincipal@gmail.com"
  },
  {
    "i": "2779",
    "county": "Tipperary",
    "rollNumber": "20451V",
    "schoolName": "Scoil Naomh Cualán",
    "SETHours": "75",
    "spClassTeachingPosts": "2",
    "mainSNA": "1.83",
    "spSNA": "4.5",
    "totalSNA": "6.33",
    "eircode": "E41EK29",
    "addressOne": "Borrisoleigh",
    "addressTwo": "Thurles",
    "addressThree": "Co Tipperary",
    "addressFour": "",
    "lat": "52.7478959",
    "lng": "-7.9592121",
    "phone": "50451473",
    "email": "scoilnaomhcualan@gmail.com"
  },
  {
    "i": "2780",
    "county": "Tipperary",
    "rollNumber": "20467N",
    "schoolName": "St Ailbe's NS",
    "SETHours": "62.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "1.83",
    "spSNA": "6.83",
    "totalSNA": "8.66",
    "eircode": "E34NY00",
    "addressOne": "Emly",
    "addressTwo": "Tipperary",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.4636259",
    "lng": "-8.3481423",
    "phone": "6257422",
    "email": "emlyns@eircom.net"
  },
  {
    "i": "2781",
    "county": "Tipperary",
    "rollNumber": "20475M",
    "schoolName": "Our Lady's NS",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "E41W352",
    "addressOne": "Thurles",
    "addressTwo": "Co. Tipperary",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.5892768",
    "lng": "-7.5421288",
    "phone": "529154533",
    "email": "ourladysns@gmail.com"
  },
  {
    "i": "2782",
    "county": "Tipperary",
    "rollNumber": "20504Q",
    "schoolName": "Rossmore NS",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "E25E722",
    "addressOne": "Rossmore",
    "addressTwo": "Cashel",
    "addressThree": "Co Tipperary",
    "addressFour": "",
    "lat": "52.6165849",
    "lng": "-8.0039854",
    "phone": "50442019",
    "email": "rossmorens@gmail.com"
  },
  {
    "i": "2783",
    "county": "Waterford",
    "rollNumber": "01395H",
    "schoolName": "Aglish NS",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "P51WA03",
    "addressOne": "Aglish",
    "addressTwo": "Cappoquin",
    "addressThree": "Co. Waterford",
    "addressFour": "",
    "lat": "52.0733167",
    "lng": "-7.8230573",
    "phone": "2496425",
    "email": "aglishnationalschool@gmail.com"
  },
  {
    "i": "2784",
    "county": "Waterford",
    "rollNumber": "01711O",
    "schoolName": "SN Cill Rosanta",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "X42XW57",
    "addressOne": "Kilrossanty",
    "addressTwo": "Kilmacthomas",
    "addressThree": "Co. Waterford",
    "addressFour": "",
    "lat": "52.1797646",
    "lng": "-7.5428854",
    "phone": "51291419",
    "email": "kilrossanty.ias@eircom.net"
  },
  {
    "i": "2785",
    "county": "Waterford",
    "rollNumber": "02889O",
    "schoolName": "SN An Chlais Mhor",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "P36ET78",
    "addressOne": "Clashmore",
    "addressTwo": "Co. Waterford",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.0109858",
    "lng": "-7.8188216",
    "phone": "2496404",
    "email": "clashmorens19@gmail.com"
  },
  {
    "i": "2786",
    "county": "Waterford",
    "rollNumber": "05548D",
    "schoolName": "Sn Baile Mhic Airt",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "X35CR20",
    "addressOne": "S.n. Bhaile Mhic Airt",
    "addressTwo": "Dún Garbhán",
    "addressThree": "Co. Phort Láirge",
    "addressFour": "",
    "lat": "52.0067506",
    "lng": "-7.6399254",
    "phone": "5846446",
    "email": "anseanphobal.ias@gmail.com"
  },
  {
    "i": "2787",
    "county": "Waterford",
    "rollNumber": "07441S",
    "schoolName": "Ballycurrane NS",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "P36FR50",
    "addressOne": "Clashmore",
    "addressTwo": "Via Youghal",
    "addressThree": "Co. Waterford",
    "addressFour": "",
    "lat": "52.0086107",
    "lng": "-7.7721777",
    "phone": "2496533",
    "email": "ballycurranens1@gmail.com"
  },
  {
    "i": "2788",
    "county": "Waterford",
    "rollNumber": "07737Q",
    "schoolName": "Villierstown NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "P51NY00",
    "addressOne": "Villierstown",
    "addressTwo": "Cappoquin",
    "addressThree": "Co. Waterford",
    "addressFour": "",
    "lat": "52.0880706",
    "lng": "-7.8462735",
    "phone": "2496301",
    "email": "villierstownns@gmail.com"
  },
  {
    "i": "2789",
    "county": "Waterford",
    "rollNumber": "11969N",
    "schoolName": "Carrickbeg NS",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "E32HP60",
    "addressOne": "Crehana",
    "addressTwo": "Carrick-beg",
    "addressThree": "Carick-on-suir",
    "addressFour": "Co. Waterford",
    "lat": "52.3316179",
    "lng": "-7.4039235",
    "phone": "51641286",
    "email": "info@crehanans.com"
  },
  {
    "i": "2790",
    "county": "Waterford",
    "rollNumber": "12007G",
    "schoolName": "Our Lady Of Good Counsel GNS",
    "SETHours": "92.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "X91TK37",
    "addressOne": "Abbey Road",
    "addressTwo": "Waterford",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.2651029",
    "lng": "-7.1018887",
    "phone": "51832984",
    "email": "principal.gns@gmail.com"
  },
  {
    "i": "2791",
    "county": "Waterford",
    "rollNumber": "12535I",
    "schoolName": "SN Ursula Naofa",
    "SETHours": "0",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.5",
    "spSNA": "0",
    "totalSNA": "5.5",
    "eircode": "X91HW77",
    "addressOne": "Inner Ring Road",
    "addressTwo": "Waterford",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.2472475",
    "lng": "-7.1132395",
    "phone": "51873788",
    "email": "stursulasoffice@gmail.com"
  },
  {
    "i": "2792",
    "county": "Waterford",
    "rollNumber": "13020D",
    "schoolName": "Our Lady Of Mercy NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "X42D867",
    "addressOne": "Carrigahilla",
    "addressTwo": "Stradbally",
    "addressThree": "Co. Waterford",
    "addressFour": "",
    "lat": "52.1375813",
    "lng": "-7.4666933",
    "phone": "51293336",
    "email": "ourladyofmercyns@gmail.com"
  },
  {
    "i": "2793",
    "county": "Waterford",
    "rollNumber": "13635R",
    "schoolName": "Ballyduff NS",
    "SETHours": "85",
    "spClassTeachingPosts": "3",
    "mainSNA": "1.83",
    "spSNA": "6.66",
    "totalSNA": "8.49",
    "eircode": "X91Y510",
    "addressOne": "Ballyduff West",
    "addressTwo": "Kilmeaden",
    "addressThree": "Co. Waterford",
    "addressFour": "",
    "lat": "52.2324422",
    "lng": "-7.2689824",
    "phone": "51384414",
    "email": "info@ballyduffns.com"
  },
  {
    "i": "2794",
    "county": "Waterford",
    "rollNumber": "14164J",
    "schoolName": "SN Lios Mor Mochuda",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "P51VW44",
    "addressOne": "North Mall",
    "addressTwo": "Lismore",
    "addressThree": "Co. Waterford",
    "addressFour": "",
    "lat": "52.1397598",
    "lng": "-7.9301103",
    "phone": "5854848",
    "email": "office@liosmormochudans.ie"
  },
  {
    "i": "2796",
    "county": "Waterford",
    "rollNumber": "14679T",
    "schoolName": "SN Baile Builearaigh",
    "SETHours": "0",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.75",
    "spSNA": "0",
    "totalSNA": "3.75",
    "eircode": "X91KF85",
    "addressOne": "Butlerstown",
    "addressTwo": "Co. Waterford",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.2230011",
    "lng": "-7.1802231",
    "phone": "51384304",
    "email": "butlersch@eircom.net"
  },
  {
    "i": "2797",
    "county": "Waterford",
    "rollNumber": "14989L",
    "schoolName": "Passage East NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "X91TX29",
    "addressOne": "Crooke",
    "addressTwo": "Passage East",
    "addressThree": "Co. Waterford",
    "addressFour": "",
    "lat": "52.2316789",
    "lng": "-6.9739471",
    "phone": "51382509",
    "email": "croppyboy4@gmail.com"
  },
  {
    "i": "2798",
    "county": "Waterford",
    "rollNumber": "15046I",
    "schoolName": "St Stephens NS",
    "SETHours": "192.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.5",
    "spSNA": "0",
    "totalSNA": "5.5",
    "eircode": "X91TH72",
    "addressOne": "25 Patrick Street",
    "addressTwo": "Waterford",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.2596726",
    "lng": "-7.1143677",
    "phone": "51871716",
    "email": "ststephensbns@gmail.com"
  },
  {
    "i": "2799",
    "county": "Waterford",
    "rollNumber": "15318P",
    "schoolName": "Glenbeg NS",
    "SETHours": "57.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "1",
    "spSNA": "3.83",
    "totalSNA": "4.83",
    "eircode": "X35P272",
    "addressOne": "Glenbeg",
    "addressTwo": "Dungarvan",
    "addressThree": "Co. Waterford",
    "addressFour": "",
    "lat": "52.070249",
    "lng": "-7.6782721",
    "phone": "5843266",
    "email": "office@glenbegnationalschool.ie"
  },
  {
    "i": "2800",
    "county": "Waterford",
    "rollNumber": "15540Q",
    "schoolName": "Ballyduff B 2 NS",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "P51C673",
    "addressOne": "Ballyduff",
    "addressTwo": "Co. Waterford",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.1420614",
    "lng": "-8.0510593",
    "phone": "5860134",
    "email": "bailedubh@gmail.com"
  },
  {
    "i": "2801",
    "county": "Waterford",
    "rollNumber": "15963V",
    "schoolName": "Rathgormack BNS",
    "SETHours": "65",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "E32PC85",
    "addressOne": "Carrick-on-suir",
    "addressTwo": "Co. Waterford",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.3059757",
    "lng": "-7.499856",
    "phone": "51646377",
    "email": "info@rathgormackns.com"
  },
  {
    "i": "2802",
    "county": "Waterford",
    "rollNumber": "16732H",
    "schoolName": "Scoil Naomh Seosamh",
    "SETHours": "95",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "X35P527",
    "addressOne": "Mitchell Street",
    "addressTwo": "Dungarvan",
    "addressThree": "Co. Waterford",
    "addressFour": "",
    "lat": "52.0878167",
    "lng": "-7.622931",
    "phone": "5842873",
    "email": "info@stjosephsprimary.ie"
  },
  {
    "i": "2803",
    "county": "Waterford",
    "rollNumber": "16748W",
    "schoolName": "SN Na Cille",
    "SETHours": "62.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "X42P897",
    "addressOne": "Kill",
    "addressTwo": "Kilmacthomas",
    "addressThree": "Co. Waterford",
    "addressFour": "",
    "lat": "52.176911",
    "lng": "-7.3343833",
    "phone": "51292349",
    "email": "killnswaterford@hotmail.com"
  },
  {
    "i": "2804",
    "county": "Waterford",
    "rollNumber": "16818R",
    "schoolName": "Sn Na Leanai",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "X35N821",
    "addressOne": "An Rinn",
    "addressTwo": "Dun Garbhan",
    "addressThree": "Co Phort Lairge",
    "addressFour": "",
    "lat": "52.0500187",
    "lng": "-7.5915601",
    "phone": "5846212",
    "email": "scoilnaleanai@gmail.com"
  },
  {
    "i": "2805",
    "county": "Waterford",
    "rollNumber": "16950R",
    "schoolName": "SN An Carraig Liath",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "X35CK23",
    "addressOne": "Ballyduff",
    "addressTwo": "Dungarvan",
    "addressThree": "Co. Waterford",
    "addressFour": "",
    "lat": "52.098485",
    "lng": "-7.6796972",
    "phone": "5844050",
    "email": "carrigleans@hotmail.com"
  },
  {
    "i": "2806",
    "county": "Waterford",
    "rollNumber": "16976M",
    "schoolName": "SN Deaglan",
    "SETHours": "165",
    "spClassTeachingPosts": "0",
    "mainSNA": "7.25",
    "spSNA": "0",
    "totalSNA": "7.25",
    "eircode": "X91H295",
    "addressOne": "Water Street",
    "addressTwo": "Waterford",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.2542294",
    "lng": "-7.1064659",
    "phone": "51855200",
    "email": "stdeclansoffice.ias@eircom.net"
  },
  {
    "i": "2807",
    "county": "Waterford",
    "rollNumber": "17133N",
    "schoolName": "SN An Baile Nua",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "X42VW64",
    "addressOne": "Newtown,",
    "addressTwo": "Kilmacthomas",
    "addressThree": "Co Waterford",
    "addressFour": "",
    "lat": "52.2215485",
    "lng": "-7.3897739",
    "phone": "51294677",
    "email": "thefoskins@hotmail.com"
  },
  {
    "i": "2808",
    "county": "Waterford",
    "rollNumber": "17159I",
    "schoolName": "SN An Garrain Bhain",
    "SETHours": "72.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "X35X762",
    "addressOne": "Garranbane",
    "addressTwo": "Dungarvan",
    "addressThree": "Co. Waterford",
    "addressFour": "",
    "lat": "52.1140472",
    "lng": "-7.5651796",
    "phone": "5841607",
    "email": "garranbanens@live.ie"
  },
  {
    "i": "2809",
    "county": "Waterford",
    "rollNumber": "17295Q",
    "schoolName": "SN Na Rinne",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "X35AK50",
    "addressOne": "Maoil A'chóirne",
    "addressTwo": "Rinn Ua Gcuanach",
    "addressThree": "Dún Garbhán",
    "addressFour": "Co. Phortláirge",
    "lat": "52.0490341",
    "lng": "-7.5892314",
    "phone": "5846372",
    "email": "snnarinne@gmail.com"
  },
  {
    "i": "2810",
    "county": "Waterford",
    "rollNumber": "17351A",
    "schoolName": "SN Naomh Mhuire",
    "SETHours": "230",
    "spClassTeachingPosts": "2",
    "mainSNA": "4.5",
    "spSNA": "4.83",
    "totalSNA": "9.33",
    "eircode": "X91HF65",
    "addressOne": "Ballygunner",
    "addressTwo": "Waterford",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.2256589",
    "lng": "-7.0659713",
    "phone": "51878388",
    "email": "office@ballygunner.ie"
  },
  {
    "i": "2811",
    "county": "Waterford",
    "rollNumber": "17522B",
    "schoolName": "Knockanore NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "P51XK58",
    "addressOne": "Knockanore",
    "addressTwo": "Tallow",
    "addressThree": "Co. Waterford",
    "addressFour": "",
    "lat": "52.0539018",
    "lng": "-7.8918209",
    "phone": "2497101",
    "email": "knockanorens1945@gmail.com"
  },
  {
    "i": "2813",
    "county": "Waterford",
    "rollNumber": "17535K",
    "schoolName": "Fionnabhair NS",
    "SETHours": "65",
    "spClassTeachingPosts": "2",
    "mainSNA": "1",
    "spSNA": "3.66",
    "totalSNA": "4.66",
    "eircode": "X91VK31",
    "addressOne": "Fenor",
    "addressTwo": "Tramore",
    "addressThree": "Co. Waterford",
    "addressFour": "",
    "lat": "52.1615242",
    "lng": "-7.2300103",
    "phone": "51381812",
    "email": "fenornationalschool@gmail.com"
  },
  {
    "i": "2814",
    "county": "Waterford",
    "rollNumber": "17536M",
    "schoolName": "SN Dun Aill",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "X91X86V",
    "addressOne": "Dunhill",
    "addressTwo": "Via Tramore",
    "addressThree": "Co. Waterford",
    "addressFour": "",
    "lat": "52.1734099",
    "lng": "-7.2631849",
    "phone": "51396383",
    "email": "dunhillns@gmail.com"
  },
  {
    "i": "2815",
    "county": "Waterford",
    "rollNumber": "17570M",
    "schoolName": "SN Na Bhfiodh",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "X42X968",
    "addressOne": "Fews",
    "addressTwo": "Kilmacthomas",
    "addressThree": "Co. Waterford",
    "addressFour": "",
    "lat": "52.2206162",
    "lng": "-7.4569363",
    "phone": "51294723",
    "email": "fewsns@gmail.com"
  },
  {
    "i": "2816",
    "county": "Waterford",
    "rollNumber": "17643N",
    "schoolName": "SN Cill Bhriain",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "E91KX97",
    "addressOne": "Ballinamult",
    "addressTwo": "Clonmel",
    "addressThree": "Co Waterford",
    "addressFour": "",
    "lat": "52.191339",
    "lng": "-7.6560191",
    "phone": "5847416",
    "email": "kilbrienns@gmail.com"
  },
  {
    "i": "2817",
    "county": "Waterford",
    "rollNumber": "17997C",
    "schoolName": "St Marys NS Grange",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "P36AT88",
    "addressOne": "Ballybrusa",
    "addressTwo": "Grange",
    "addressThree": "Via Youghal",
    "addressFour": "",
    "lat": "51.9815519",
    "lng": "-7.7436761",
    "phone": "2494583",
    "email": "grangens024@gmail.com"
  },
  {
    "i": "2818",
    "county": "Waterford",
    "rollNumber": "18048E",
    "schoolName": "SN Naomh Deaglan",
    "SETHours": "60",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "P36P527",
    "addressOne": "College Road",
    "addressTwo": "Ardmore",
    "addressThree": "Co. Waterford",
    "addressFour": "",
    "lat": "51.9512128",
    "lng": "-7.731263",
    "phone": "2494569",
    "email": "ardmorens@gmail.com"
  },
  {
    "i": "2819",
    "county": "Waterford",
    "rollNumber": "18077L",
    "schoolName": "SN Cnoc Machan",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "X42AD91",
    "addressOne": "Knockmahon",
    "addressTwo": "Bunmahon",
    "addressThree": "Co. Waterford",
    "addressFour": "",
    "lat": "52.1436584",
    "lng": "-7.3609376",
    "phone": "51292500",
    "email": "knockmahonns@gmail.com"
  },
  {
    "i": "2820",
    "county": "Waterford",
    "rollNumber": "18094L",
    "schoolName": "SN Dun Na Mainistreach",
    "SETHours": "140",
    "spClassTeachingPosts": "1",
    "mainSNA": "2",
    "spSNA": "0.83",
    "totalSNA": "2.83",
    "eircode": "X35NW50",
    "addressOne": "Sheares Street",
    "addressTwo": "Abbeyside",
    "addressThree": "Dungarvan",
    "addressFour": "Co. Waterford",
    "lat": "52.0901128",
    "lng": "-7.6114291",
    "phone": "5841102",
    "email": "abbeysidens@gmail.com"
  },
  {
    "i": "2821",
    "county": "Waterford",
    "rollNumber": "18108T",
    "schoolName": "Whitechurch NS Ceapach",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "X35N560",
    "addressOne": "Clonkerdon",
    "addressTwo": "Cappagh",
    "addressThree": "Dungarvan",
    "addressFour": "Co. Waterford",
    "lat": "52.1028564",
    "lng": "-7.7782954",
    "phone": "5868282",
    "email": "info@whitechurch.org"
  },
  {
    "i": "2822",
    "county": "Waterford",
    "rollNumber": "18167M",
    "schoolName": "SN Aine Nfa Seafield",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "X42TH28",
    "addressOne": "Seafield",
    "addressTwo": "Bonmahon",
    "addressThree": "Co. Waterford",
    "addressFour": "",
    "lat": "52.1543904",
    "lng": "-7.3834303",
    "phone": "51292213",
    "email": "seafieldns57@gmail.com"
  },
  {
    "i": "2823",
    "county": "Waterford",
    "rollNumber": "18235D",
    "schoolName": "SN Muire An Port Mor",
    "SETHours": "112.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.25",
    "spSNA": "0",
    "totalSNA": "1.25",
    "eircode": "X91AF80",
    "addressOne": "Ross Road",
    "addressTwo": "Ferrybank",
    "addressThree": "Waterford",
    "addressFour": "",
    "lat": "52.2682282",
    "lng": "-7.0990227",
    "phone": "51851399",
    "email": "admin@ferrybankbns.ie"
  },
  {
    "i": "2824",
    "county": "Waterford",
    "rollNumber": "18318H",
    "schoolName": "SN Naomh Parthalan",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "P36F827",
    "addressOne": "Cionn Saile Beag",
    "addressTwo": "Youghal",
    "addressThree": "Co Cork",
    "addressFour": "",
    "lat": "51.9671584",
    "lng": "-7.8087062",
    "phone": "2494247",
    "email": "principal1kns@gmail.com"
  },
  {
    "i": "2825",
    "county": "Waterford",
    "rollNumber": "18321T",
    "schoolName": "SN Muire Magh Deilge",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "X35HK12",
    "addressOne": "Modeligo",
    "addressTwo": "Dungarvan",
    "addressThree": "Co. Waterford",
    "addressFour": "",
    "lat": "52.1488577",
    "lng": "-7.7544409",
    "phone": "5868149",
    "email": "modeligons@eircom.net"
  },
  {
    "i": "2826",
    "county": "Waterford",
    "rollNumber": "18380M",
    "schoolName": "SN Faiche Liag",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "X91TW82",
    "addressOne": "Faithlegg",
    "addressTwo": "Co. Waterford",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.2619794",
    "lng": "-7.0029059",
    "phone": "51382415",
    "email": "faithlegg.ias@eircom.net"
  },
  {
    "i": "2827",
    "county": "Waterford",
    "rollNumber": "18462O",
    "schoolName": "Scoil Lorcain BNS",
    "SETHours": "172.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "4.5",
    "spSNA": "1.83",
    "totalSNA": "6.33",
    "eircode": "X91HY92",
    "addressOne": "St. John's Park",
    "addressTwo": "Waterford",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.243106",
    "lng": "-7.1060333",
    "phone": "51879288",
    "email": "office@scoillorcain.com"
  },
  {
    "i": "2828",
    "county": "Waterford",
    "rollNumber": "18488J",
    "schoolName": "Scoil Naomh Gobnait",
    "SETHours": "40",
    "spClassTeachingPosts": "2",
    "mainSNA": "1",
    "spSNA": "4",
    "totalSNA": "5",
    "eircode": "X35KF88",
    "addressOne": "Cul Na Smear",
    "addressTwo": "Dungarbhan",
    "addressThree": "Co Waterford",
    "addressFour": "",
    "lat": "52.1399423",
    "lng": "-7.6457806",
    "phone": "5842177",
    "email": "coolnasmearsch.ias@eircom.net"
  },
  {
    "i": "2829",
    "county": "Waterford",
    "rollNumber": "18509O",
    "schoolName": "An Teaghlaigh Naofa Girls Jn",
    "SETHours": "105",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.75",
    "spSNA": "0",
    "totalSNA": "2.75",
    "eircode": "X91XN28",
    "addressOne": "Military Road",
    "addressTwo": "Waterford",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.2603992",
    "lng": "-7.1243886",
    "phone": "51875993",
    "email": "juniorschool@mercywaterford.ie"
  },
  {
    "i": "2830",
    "county": "Waterford",
    "rollNumber": "18681D",
    "schoolName": "Christ Church NS",
    "SETHours": "70",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "X91DN40",
    "addressOne": "Lower Newtown",
    "addressTwo": "Waterford",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.2533541",
    "lng": "-7.1056017",
    "phone": "51876948",
    "email": "ccnsoffice4@gmail.com"
  },
  {
    "i": "2831",
    "county": "Waterford",
    "rollNumber": "18689T",
    "schoolName": "Our Lady Of Mercy Sn P.s.",
    "SETHours": "130",
    "spClassTeachingPosts": "0",
    "mainSNA": "6",
    "spSNA": "0",
    "totalSNA": "6",
    "eircode": "X91XN28",
    "addressOne": "Military Road",
    "addressTwo": "Waterford",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.2603992",
    "lng": "-7.1243886",
    "phone": "51875993",
    "email": "seniorschool@mercy-waterford.ie"
  },
  {
    "i": "2832",
    "county": "Waterford",
    "rollNumber": "18779U",
    "schoolName": "St Marys NS Touraneena",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "E91K6W7",
    "addressOne": "Ballinamult",
    "addressTwo": "Clonmel",
    "addressThree": "Co Waterford",
    "addressFour": "",
    "lat": "52.2030838",
    "lng": "-7.7152454",
    "phone": "5847446",
    "email": "office@touraneenans.ie"
  },
  {
    "i": "2833",
    "county": "Waterford",
    "rollNumber": "18793O",
    "schoolName": "Sc Naomh Eoin Le Dia",
    "SETHours": "65",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.25",
    "spSNA": "0",
    "totalSNA": "3.25",
    "eircode": "X91TX47",
    "addressOne": "Passage Road",
    "addressTwo": "Waterford",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.2515162",
    "lng": "-7.104161",
    "phone": "51876255",
    "email": "office@stjohnofgod.ie"
  },
  {
    "i": "2834",
    "county": "Waterford",
    "rollNumber": "19345P",
    "schoolName": "Ballymacarberry NS",
    "SETHours": "62.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "E91E426",
    "addressOne": "Ballymacarbry",
    "addressTwo": "Via Clonmel",
    "addressThree": "Co. Waterford",
    "addressFour": "",
    "lat": "52.2819265",
    "lng": "-7.740623",
    "phone": "526136349",
    "email": "ballymacns@gmail.com"
  },
  {
    "i": "2835",
    "county": "Waterford",
    "rollNumber": "19443P",
    "schoolName": "Clonea Ns",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "E32NP40",
    "addressOne": "Clonea-power",
    "addressTwo": "Carrick-on-suir",
    "addressThree": "Co. Waterford",
    "addressFour": "",
    "lat": "52.2794345",
    "lng": "-7.4395545",
    "phone": "51646249",
    "email": "info@cloneapowerschool.ie"
  },
  {
    "i": "2836",
    "county": "Waterford",
    "rollNumber": "19511G",
    "schoolName": "St Saviours Ns",
    "SETHours": "205",
    "spClassTeachingPosts": "2",
    "mainSNA": "7.25",
    "spSNA": "4.75",
    "totalSNA": "12",
    "eircode": "X91Y472",
    "addressOne": "Ballybeg Drive",
    "addressTwo": "Waterford",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.2399472",
    "lng": "-7.1456511",
    "phone": "51372621",
    "email": "secretary@stsavioursns.ie"
  },
  {
    "i": "2837",
    "county": "Waterford",
    "rollNumber": "19616U",
    "schoolName": "Scoil Mhuire",
    "SETHours": "100",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "P51W212",
    "addressOne": "Michael J Prendergast Road",
    "addressTwo": "Tallow",
    "addressThree": "Co. Waterford",
    "addressFour": "",
    "lat": "52.0911923",
    "lng": "-8.0040285",
    "phone": "5856717",
    "email": "scoilmhuiretallow@hotmail.com"
  },
  {
    "i": "2838",
    "county": "Waterford",
    "rollNumber": "19629G",
    "schoolName": "Holy Cross School",
    "SETHours": "210",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "X91E003",
    "addressOne": "Ballycarnane",
    "addressTwo": "Tramore",
    "addressThree": "Co. Waterford",
    "addressFour": "",
    "lat": "52.1602574",
    "lng": "-7.1657664",
    "phone": "51381036",
    "email": "holycrossnstramore@gmail.com"
  },
  {
    "i": "2839",
    "county": "Waterford",
    "rollNumber": "19726E",
    "schoolName": "Stradbally C. Of Ire. Ns",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "X42HN63",
    "addressOne": "Church Lane",
    "addressTwo": "Stradbally",
    "addressThree": "Co. Waterford",
    "addressFour": "",
    "lat": "52.1292455",
    "lng": "-7.4643877",
    "phone": "51293229",
    "email": "stjamesstradbally@gmail.com"
  },
  {
    "i": "2840",
    "county": "Waterford",
    "rollNumber": "19814B",
    "schoolName": "Scoil Gearbhain",
    "SETHours": "77.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.25",
    "spSNA": "0",
    "totalSNA": "1.25",
    "eircode": "X35NP84",
    "addressOne": "Clais Na Lachan",
    "addressTwo": "Dún Na Mainistreach",
    "addressThree": "Dún Garbhán",
    "addressFour": "Co. Phort Láirge",
    "lat": "52.1006428",
    "lng": "-7.5950922",
    "phone": "5842173",
    "email": "scoilgharbhain@cablesurf.com"
  },
  {
    "i": "2841",
    "county": "Waterford",
    "rollNumber": "19853L",
    "schoolName": "Gaelscoil Phort Lairge",
    "SETHours": "60",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "X91AX81",
    "addressOne": "Baile Gunnair",
    "addressTwo": "Port Láirge",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.2295307",
    "lng": "-7.0623757",
    "phone": "51879736",
    "email": "gsphortlairge@gmail.com"
  },
  {
    "i": "2842",
    "county": "Waterford",
    "rollNumber": "19885B",
    "schoolName": "Gaelscoil Philib Barún",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "X91FP29",
    "addressOne": "Cruabhaile Uachtarach",
    "addressTwo": "An Trá Mhór",
    "addressThree": "Co. Phort Láirge",
    "addressFour": "",
    "lat": "52.1687988",
    "lng": "-7.1460155",
    "phone": "51381329",
    "email": "eolas@pilibbarun.com"
  },
  {
    "i": "2843",
    "county": "Waterford",
    "rollNumber": "19947U",
    "schoolName": "Mount Sion Cbs NS",
    "SETHours": "180",
    "spClassTeachingPosts": "2",
    "mainSNA": "4.5",
    "spSNA": "4.5",
    "totalSNA": "9",
    "eircode": "X91NF77",
    "addressOne": "Barrack Street",
    "addressTwo": "Waterford",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.256129",
    "lng": "-7.1176369",
    "phone": "51377947",
    "email": "office.mountsion@gmail.com"
  },
  {
    "i": "2844",
    "county": "Waterford",
    "rollNumber": "19953P",
    "schoolName": "St Marys Ns",
    "SETHours": "135",
    "spClassTeachingPosts": "1",
    "mainSNA": "1.83",
    "spSNA": "0.83",
    "totalSNA": "2.66",
    "eircode": "X35TN99",
    "addressOne": "Youghal Road",
    "addressTwo": "Dungarvan",
    "addressThree": "Co. Waterford",
    "addressFour": "",
    "lat": "52.087567",
    "lng": "-7.6257697",
    "phone": "5841346",
    "email": "principal@stmarysdungarvan.ie"
  },
  {
    "i": "2845",
    "county": "Waterford",
    "rollNumber": "19955T",
    "schoolName": "Presentation Primary School",
    "SETHours": "197.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "4.5",
    "spSNA": "0.67",
    "totalSNA": "5.17",
    "eircode": "X91K132",
    "addressOne": "Slievekeale Road",
    "addressTwo": "Waterford",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.7893824",
    "lng": "-10.7855586",
    "phone": "51374995",
    "email": "info@presentationprimarywaterford.ie"
  },
  {
    "i": "2846",
    "county": "Waterford",
    "rollNumber": "19970P",
    "schoolName": "Portlaw NS",
    "SETHours": "110",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.33",
    "spSNA": "0",
    "totalSNA": "5.33",
    "eircode": "X91V343",
    "addressOne": "Convent Road",
    "addressTwo": "Portlaw",
    "addressThree": "Co. Waterford",
    "addressFour": "",
    "lat": "52.2904323",
    "lng": "-7.3151955",
    "phone": "51387454",
    "email": "secretaryportlawns@gmail.com"
  },
  {
    "i": "2847",
    "county": "Waterford",
    "rollNumber": "20050D",
    "schoolName": "Gaelscoil Na Ndeise",
    "SETHours": "110",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.75",
    "spSNA": "0",
    "totalSNA": "3.75",
    "eircode": "X91XK06",
    "addressOne": "Campas Charraig Phiarais",
    "addressTwo": "Bóthar Charraig Phiarais",
    "addressThree": "Port Láirge",
    "addressFour": "",
    "lat": "52.2607973",
    "lng": "-7.1504428",
    "phone": "51843222",
    "email": "gaelscoilnandeise@eircom.net"
  },
  {
    "i": "2848",
    "county": "Waterford",
    "rollNumber": "20076V",
    "schoolName": "Bun Scoil Bhothar Na Naomh",
    "SETHours": "127.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "P51TW59",
    "addressOne": "Deerpark Road",
    "addressTwo": "Lismore",
    "addressThree": "Co. Waterford",
    "addressFour": "",
    "lat": "52.1384846",
    "lng": "-7.9257745",
    "phone": "5854685",
    "email": "lismoreprimsch.ias@eircom.net"
  },
  {
    "i": "2849",
    "county": "Waterford",
    "rollNumber": "20116H",
    "schoolName": "Glor Na Mara Ns",
    "SETHours": "200",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.66",
    "spSNA": "0",
    "totalSNA": "3.66",
    "eircode": "X91Y924",
    "addressOne": "Convent Hill",
    "addressTwo": "Tramore",
    "addressThree": "Co. Waterford",
    "addressFour": "",
    "lat": "52.1659488",
    "lng": "-7.1534151",
    "phone": "51386104",
    "email": "glornamaraoffice@gmail.com"
  },
  {
    "i": "2850",
    "county": "Waterford",
    "rollNumber": "20143K",
    "schoolName": "Waterpark NS",
    "SETHours": "0",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.66",
    "spSNA": "0",
    "totalSNA": "3.66",
    "eircode": "X91D540",
    "addressOne": "Park Road",
    "addressTwo": "Waterford",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.2564382",
    "lng": "-7.1010165",
    "phone": "51853071",
    "email": "info@waterparkns.com"
  },
  {
    "i": "2851",
    "county": "Waterford",
    "rollNumber": "20157V",
    "schoolName": "Bunscoil Gleann Sidheain",
    "SETHours": "72.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "2",
    "spSNA": "5",
    "totalSNA": "7",
    "eircode": "P51E732",
    "addressOne": "Cappoquin",
    "addressTwo": "Co. Waterford",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.1458034",
    "lng": "-7.8391729",
    "phone": "5854015",
    "email": "bsgleannsidheain.ias@eircom.net"
  },
  {
    "i": "2852",
    "county": "Waterford",
    "rollNumber": "20160K",
    "schoolName": "Waterford Educate Together Ns",
    "SETHours": "143",
    "spClassTeachingPosts": "2",
    "mainSNA": "7.16",
    "spSNA": "4.41",
    "totalSNA": "11.57",
    "eircode": "X91NN9F",
    "addressOne": "Paráid Na Bpáisti",
    "addressTwo": "Carrickphierish Road",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.2607726",
    "lng": "-7.1478496",
    "phone": "51355714",
    "email": "admin@wetns.ie"
  },
  {
    "i": "2853",
    "county": "Waterford",
    "rollNumber": "20170N",
    "schoolName": "Scoil Choill Mhic Thomaisin",
    "SETHours": "62.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "X42YY36",
    "addressOne": "Rossmore",
    "addressTwo": "Kilmacthomas",
    "addressThree": "Co. Waterford",
    "addressFour": "",
    "lat": "52.205474",
    "lng": "-7.4173848",
    "phone": "51294627",
    "email": "kilmacps@gmail.com"
  },
  {
    "i": "2854",
    "county": "Waterford",
    "rollNumber": "20219R",
    "schoolName": "St Paul's BNS",
    "SETHours": "182.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "8",
    "spSNA": "4",
    "totalSNA": "12",
    "eircode": "X91YX80",
    "addressOne": "Church Road",
    "addressTwo": "Waterford",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.2498588",
    "lng": "-7.1337712",
    "phone": "51376752",
    "email": "stpaulwaterford@gmail.com"
  },
  {
    "i": "2855",
    "county": "Waterford",
    "rollNumber": "20261Q",
    "schoolName": "Newtown Jn School",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "X91ET86",
    "addressOne": "Lower Newtown",
    "addressTwo": "Waterford City",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.2529815",
    "lng": "-7.1018091",
    "phone": "51850851",
    "email": "office@njs.ie"
  },
  {
    "i": "2856",
    "county": "Waterford",
    "rollNumber": "20446F",
    "schoolName": "Tramore Educate Together NS",
    "SETHours": "68.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.33",
    "spSNA": "0",
    "totalSNA": "3.33",
    "eircode": "X91X27Y",
    "addressOne": "Pond Road",
    "addressTwo": "Tramore",
    "addressThree": "Co. Waterford",
    "addressFour": "",
    "lat": "52.1639363",
    "lng": "-7.1499352",
    "phone": "51390443",
    "email": "principal@tramoreetns.ie"
  },
  {
    "i": "2857",
    "county": "Westmeath",
    "rollNumber": "00934G",
    "schoolName": "Presentation Convent (jnr)",
    "SETHours": "132.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "3.5",
    "spSNA": "1.66",
    "totalSNA": "5.16",
    "eircode": "N91YD83",
    "addressOne": "Harbour Street",
    "addressTwo": "Mullingar",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.5283965",
    "lng": "-7.3426107",
    "phone": "449342166",
    "email": "adminjnr@presentationmullingar.ie"
  },
  {
    "i": "2858",
    "county": "Westmeath",
    "rollNumber": "00941D",
    "schoolName": "SN Bhride",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "N91PP71",
    "addressOne": "Emper",
    "addressTwo": "Ballynacargy",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.5958053",
    "lng": "-7.5894684",
    "phone": "449373388",
    "email": "emperns.ias@eircom.net"
  },
  {
    "i": "2859",
    "county": "Westmeath",
    "rollNumber": "01731U",
    "schoolName": "Ballynacargy Mixed NS",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "N91TW13",
    "addressOne": "Ballynacargy",
    "addressTwo": "Co. Westmeath",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.5847369",
    "lng": "-7.5363602",
    "phone": "449373300",
    "email": "principal.ballynacargyns@gmail.com"
  },
  {
    "i": "2860",
    "county": "Westmeath",
    "rollNumber": "02263S",
    "schoolName": "Crowenstown NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "N91X7DV",
    "addressOne": "Crowenstown",
    "addressTwo": "Delvin",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.6112277",
    "lng": "-7.0369525",
    "phone": "449664585",
    "email": "stpatsns@yahoo.ie"
  },
  {
    "i": "2861",
    "county": "Westmeath",
    "rollNumber": "03936C",
    "schoolName": "SN An Chuil",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "N91E3FN",
    "addressOne": "Coole",
    "addressTwo": "Mullingar",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.699931",
    "lng": "-7.3723758",
    "phone": "449661669",
    "email": "coolescoilmhuire@gmail.com"
  },
  {
    "i": "2862",
    "county": "Westmeath",
    "rollNumber": "05513H",
    "schoolName": "Castlepollard Mixed NS",
    "SETHours": "82.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "N91Y206",
    "addressOne": "Water Street",
    "addressTwo": "Castlepollard",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.6815554",
    "lng": "-7.2961493",
    "phone": "449661865",
    "email": "cpns3h@gmail.com"
  },
  {
    "i": "2863",
    "county": "Westmeath",
    "rollNumber": "05916G",
    "schoolName": "St. Anne's NS",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "N91A5R7",
    "addressOne": "Main Street",
    "addressTwo": "Tyrellspass",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.3888652",
    "lng": "-7.3757224",
    "phone": "449223298",
    "email": "tyrrellspassns@yahoo.ie"
  },
  {
    "i": "2864",
    "county": "Westmeath",
    "rollNumber": "07722D",
    "schoolName": "St Peters NS Snr",
    "SETHours": "60",
    "spClassTeachingPosts": "2",
    "mainSNA": "0",
    "spSNA": "2.5",
    "totalSNA": "2.5",
    "eircode": "N37XY50",
    "addressOne": "Excise Street",
    "addressTwo": "Athlone",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.4216708",
    "lng": "-7.9426455",
    "phone": "906492363",
    "email": "stpetersgns@gmail.com"
  },
  {
    "i": "2865",
    "county": "Westmeath",
    "rollNumber": "08037Q",
    "schoolName": "Tang NS",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "N39H266",
    "addressOne": "Clogher",
    "addressTwo": "Tang",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.5346743",
    "lng": "-7.7930284",
    "phone": "906432495",
    "email": "tangns1@gmail.com"
  },
  {
    "i": "2866",
    "county": "Westmeath",
    "rollNumber": "08100U",
    "schoolName": "SN Phadraig",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "N91FX92",
    "addressOne": "Edmonstown",
    "addressTwo": "Killucan",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.5329967",
    "lng": "-7.1696819",
    "phone": "449374411",
    "email": "edmontonns@gmail.com"
  },
  {
    "i": "2867",
    "county": "Westmeath",
    "rollNumber": "10857U",
    "schoolName": "Castlepollard Paroc.n S",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "N91C954",
    "addressOne": "Pakenhamhall Road",
    "addressTwo": "Castlepollard",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.6794599",
    "lng": "-7.3022561",
    "phone": "449661463",
    "email": "parochialschool@gmail.com"
  },
  {
    "i": "2868",
    "county": "Westmeath",
    "rollNumber": "13571R",
    "schoolName": "Drumraney Mixed NS",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "N37V240",
    "addressOne": "Drumraney",
    "addressTwo": "Athlone",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.4763833",
    "lng": "-7.7488904",
    "phone": "449356009",
    "email": "drumraneyns@eircom.net"
  },
  {
    "i": "2869",
    "county": "Westmeath",
    "rollNumber": "14450K",
    "schoolName": "St Feighans Mxd NS",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.33",
    "spSNA": "0",
    "totalSNA": "1.33",
    "eircode": "N91D958",
    "addressOne": "Fore",
    "addressTwo": "Castlepollard",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.6774341",
    "lng": "-7.2223479",
    "phone": "449666181",
    "email": "forens.ias@eircom.net"
  },
  {
    "i": "2870",
    "county": "Westmeath",
    "rollNumber": "15291V",
    "schoolName": "Streamstown Mixed NS",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "N91XE40",
    "addressOne": "Streamstown",
    "addressTwo": "Co. Westmeath",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.4296459",
    "lng": "-7.5599982",
    "phone": "449226901",
    "email": "streamstownschool@gmail.com"
  },
  {
    "i": "2871",
    "county": "Westmeath",
    "rollNumber": "15307K",
    "schoolName": "Dalystown NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "N91W207",
    "addressOne": "Dalystown",
    "addressTwo": "Mullingar",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.4351496",
    "lng": "-7.3855048",
    "phone": "449223604",
    "email": "dalystownns@gmail.com"
  },
  {
    "i": "2872",
    "county": "Westmeath",
    "rollNumber": "15512L",
    "schoolName": "St Brigid's Primary School",
    "SETHours": "92.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.33",
    "spSNA": "0",
    "totalSNA": "3.33",
    "eircode": "N37TF86",
    "addressOne": "Station Road",
    "addressTwo": "Moate",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.3975927",
    "lng": "-7.7242345",
    "phone": "906481740",
    "email": "stbrigidsmoate@gmail.com"
  },
  {
    "i": "2873",
    "county": "Westmeath",
    "rollNumber": "16092U",
    "schoolName": "Athlone NS",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "N37CX20",
    "addressOne": "Arcadia",
    "addressTwo": "Athlone",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.4322467",
    "lng": "-7.9390404",
    "phone": "906474911",
    "email": "athlonemixednational@gmail.com"
  },
  {
    "i": "2874",
    "county": "Westmeath",
    "rollNumber": "16304J",
    "schoolName": "Milltownpass NS",
    "SETHours": "40",
    "spClassTeachingPosts": "1",
    "mainSNA": "0",
    "spSNA": "2",
    "totalSNA": "2",
    "eircode": "N91D792",
    "addressOne": "Milltownpass",
    "addressTwo": "Co Westmeath",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.4426124",
    "lng": "-7.2482183",
    "phone": "449222512",
    "email": "milltownpassns@gmail.com"
  },
  {
    "i": "2875",
    "county": "Westmeath",
    "rollNumber": "16340N",
    "schoolName": "Ballinagore Mixed NS",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "N91XF57",
    "addressOne": "Ballinagore",
    "addressTwo": "Kilbeggan",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.4080483",
    "lng": "-7.4626328",
    "phone": "579332165",
    "email": "school.ballinagore@gmail.com"
  },
  {
    "i": "2876",
    "county": "Westmeath",
    "rollNumber": "16639R",
    "schoolName": "Sn Deaghan O Ceallaigh",
    "SETHours": "62.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "N37X273",
    "addressOne": "The Batteries",
    "addressTwo": "Athlone",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.4236641",
    "lng": "-7.9539447",
    "phone": "906492000",
    "email": "deankellyboysns@hotmail.com"
  },
  {
    "i": "2877",
    "county": "Westmeath",
    "rollNumber": "16838A",
    "schoolName": "St. Colmcille's NS",
    "SETHours": "100",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "N91F652",
    "addressOne": "Gainstown",
    "addressTwo": "Mullingar",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.4828989",
    "lng": "-7.3262582",
    "phone": "449343219",
    "email": "gainstownns.ias@gmail.com"
  },
  {
    "i": "2878",
    "county": "Westmeath",
    "rollNumber": "16868J",
    "schoolName": "Baile Na Gceallach NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "N91HEE3",
    "addressOne": "Collinstown",
    "addressTwo": "Mullingar",
    "addressThree": "Co Westmeath",
    "addressFour": "",
    "lat": "53.649859",
    "lng": "-7.2180276",
    "phone": "449666150",
    "email": "stmarysnscollinstown@gmail.com"
  },
  {
    "i": "2879",
    "county": "Westmeath",
    "rollNumber": "16914N",
    "schoolName": "Baile Coireil NS",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "N91KC84",
    "addressOne": "Coralstown",
    "addressTwo": "Mullingar",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.4848457",
    "lng": "-7.1911454",
    "phone": "449374889",
    "email": "coralstown.nationalschool@gmail.com"
  },
  {
    "i": "2880",
    "county": "Westmeath",
    "rollNumber": "16961W",
    "schoolName": "Kilcumeragh NS",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "N37HN96",
    "addressOne": "Kilcrumreragh",
    "addressTwo": "Rosemount",
    "addressThree": "Moate",
    "addressFour": "",
    "lat": "53.4254583",
    "lng": "-7.6449296",
    "phone": "906436220",
    "email": "rosemountns@hotmail.com"
  },
  {
    "i": "2881",
    "county": "Westmeath",
    "rollNumber": "17025K",
    "schoolName": "SN Na Ndun",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "N91T229",
    "addressOne": "Mullingar",
    "addressTwo": "Co. Westmeath",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.5072564",
    "lng": "-7.2429973",
    "phone": "449340718",
    "email": "downsns@eircom.net"
  },
  {
    "i": "2882",
    "county": "Westmeath",
    "rollNumber": "17089N",
    "schoolName": "Cluain Maolain NS",
    "SETHours": "90",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "C15H3CR",
    "addressOne": "Main Street",
    "addressTwo": "Clonmellon",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.6644733",
    "lng": "-7.013721",
    "phone": "469433301",
    "email": "principal@clonmellonns.ie"
  },
  {
    "i": "2883",
    "county": "Westmeath",
    "rollNumber": "17102C",
    "schoolName": "Cluain Buinne NS",
    "SETHours": "60",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.16",
    "spSNA": "0",
    "totalSNA": "2.16",
    "eircode": "N37EA21",
    "addressOne": "Clonbonny",
    "addressTwo": "Athlone",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.397088",
    "lng": "-7.8863179",
    "phone": "906474656",
    "email": "clonbonnyns@gmail.com"
  },
  {
    "i": "2884",
    "county": "Westmeath",
    "rollNumber": "17167H",
    "schoolName": "Bl Oliver Plunkett NS",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "N37E303",
    "addressOne": "Lake Road",
    "addressTwo": "Moate",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3968929",
    "lng": "-7.7282163",
    "phone": "906481862",
    "email": "stoliverplunkettbns@gmail.com"
  },
  {
    "i": "2885",
    "county": "Westmeath",
    "rollNumber": "17182D",
    "schoolName": "Mhichil Naofa NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "N91X659",
    "addressOne": "School Road",
    "addressTwo": "Castletown Geoghegan",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.4436405",
    "lng": "-7.4953522",
    "phone": "449226255",
    "email": "stmichaelsctg@eircom.net"
  },
  {
    "i": "2886",
    "county": "Westmeath",
    "rollNumber": "17189R",
    "schoolName": "Rath Eoghan NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "N91TV25",
    "addressOne": "Rathowen",
    "addressTwo": "Mullingar",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.6532942",
    "lng": "-7.5203828",
    "phone": "436676161",
    "email": "stmarysrathowen@yahoo.ie"
  },
  {
    "i": "2887",
    "county": "Westmeath",
    "rollNumber": "17236A",
    "schoolName": "Boher NS",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "N91Y663",
    "addressOne": "Boher",
    "addressTwo": "Streamstown",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.4617665",
    "lng": "-7.5944729",
    "phone": "906436289",
    "email": "boherns1@eircom.net"
  },
  {
    "i": "2888",
    "county": "Westmeath",
    "rollNumber": "17290G",
    "schoolName": "Dysart Ns",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "N91CH98",
    "addressOne": "Dysart",
    "addressTwo": "Mullingar",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.4701543",
    "lng": "-7.4605132",
    "phone": "449226175",
    "email": "principaldysartns@gmail.com"
  },
  {
    "i": "2889",
    "county": "Westmeath",
    "rollNumber": "17327D",
    "schoolName": "Holy Family Primary School",
    "SETHours": "115",
    "spClassTeachingPosts": "2",
    "mainSNA": "2.83",
    "spSNA": "4",
    "totalSNA": "6.83",
    "eircode": "N91Y225",
    "addressOne": "Curraghmore",
    "addressTwo": "Mullingar",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.5297468",
    "lng": "-7.2908501",
    "phone": "449342549",
    "email": "curraghmoreschool@eircom.net"
  },
  {
    "i": "2890",
    "county": "Westmeath",
    "rollNumber": "17432A",
    "schoolName": "Magh Mora NS",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "N91FA00",
    "addressOne": "Moyvore",
    "addressTwo": "Co Westmeath",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.5349068",
    "lng": "-7.6263554",
    "phone": "449355375",
    "email": "moyvorens@eircom.net"
  },
  {
    "i": "2891",
    "county": "Westmeath",
    "rollNumber": "17606H",
    "schoolName": "Naomh Micheal NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "N91FN29",
    "addressOne": "Castletown-finea",
    "addressTwo": "Mullingar",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.7537621",
    "lng": "-7.3326469",
    "phone": "436681382",
    "email": "stmichaelsnscastletown@gmail.com"
  },
  {
    "i": "2892",
    "county": "Westmeath",
    "rollNumber": "17708P",
    "schoolName": "Sc Ciarain",
    "SETHours": "62.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "N37AH98",
    "addressOne": "Twyford",
    "addressTwo": "Baylin",
    "addressThree": "Athlone",
    "addressFour": "Co. Westmeath",
    "lat": "53.4338529",
    "lng": "-7.8422966",
    "phone": "906485257",
    "email": "baylinnsinfo@eircom.net"
  },
  {
    "i": "2893",
    "county": "Westmeath",
    "rollNumber": "17743R",
    "schoolName": "Naomh Muire NS",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "N91YN53",
    "addressOne": "Finea",
    "addressTwo": "Mullingar",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.7774064",
    "lng": "-7.3759052",
    "phone": "436681384",
    "email": "fineanationalschool@gmail.com"
  },
  {
    "i": "2894",
    "county": "Westmeath",
    "rollNumber": "17806P",
    "schoolName": "Cill Cleithe NS",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.33",
    "spSNA": "0",
    "totalSNA": "1.33",
    "eircode": "N37K8V0",
    "addressOne": "Kilcleagh",
    "addressTwo": "Castledaly",
    "addressThree": "Moate",
    "addressFour": "Co. Westmeath",
    "lat": "53.3743677",
    "lng": "-7.8078463",
    "phone": "906481026",
    "email": "kilcleaghns.ias@eircom.net"
  },
  {
    "i": "2895",
    "county": "Westmeath",
    "rollNumber": "17882I",
    "schoolName": "SN Aodha Naofa",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "N91XF20",
    "addressOne": "Rahugh",
    "addressTwo": "Kilbeggan",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3459326",
    "lng": "-7.4064231",
    "phone": "449223584",
    "email": "rahughschool@gmail.com"
  },
  {
    "i": "2896",
    "county": "Westmeath",
    "rollNumber": "17903N",
    "schoolName": "Corr Na Madadh NS",
    "SETHours": "125",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "N37TR23",
    "addressOne": "Cornamaddy",
    "addressTwo": "Athlone",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.4350602",
    "lng": "-7.9027395",
    "phone": "906478360",
    "email": "cornamaddy123@gmail.com"
  },
  {
    "i": "2897",
    "county": "Westmeath",
    "rollNumber": "17932U",
    "schoolName": "Odhran Naofa NS",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "N91Y682",
    "addressOne": "Sonna",
    "addressTwo": "Slanemore",
    "addressThree": "Mullingar",
    "addressFour": "Co Westmeath",
    "lat": "53.5590803",
    "lng": "-7.4820965",
    "phone": "449373323",
    "email": "daithifee@yahoo.co.uk"
  },
  {
    "i": "2898",
    "county": "Westmeath",
    "rollNumber": "17991N",
    "schoolName": "Eoin Naofa NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "N91HY28",
    "addressOne": "High Street",
    "addressTwo": "Ballymore",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.49046",
    "lng": "-7.6791702",
    "phone": "449356537",
    "email": "eoinnaofa1@hotmail.com"
  },
  {
    "i": "2899",
    "county": "Westmeath",
    "rollNumber": "18036U",
    "schoolName": "Diarmada NS",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "N91WC61",
    "addressOne": "Castlepollard",
    "addressTwo": "Co. Westmeath",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.6438688",
    "lng": "-7.2987783",
    "phone": "449661890",
    "email": "whitehall.ias@eircom.net"
  },
  {
    "i": "2900",
    "county": "Westmeath",
    "rollNumber": "18193N",
    "schoolName": "SN Naomh Fiontan",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "N91CF40",
    "addressOne": "Lismacaffrey",
    "addressTwo": "Mullingar",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.7133449",
    "lng": "-7.4592628",
    "phone": "436685233",
    "email": "stfintansnslismacaffrey@gmail.com"
  },
  {
    "i": "2901",
    "county": "Westmeath",
    "rollNumber": "18212O",
    "schoolName": "Scoil Na Maighdine Mhuire",
    "SETHours": "147.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "3",
    "spSNA": "2",
    "totalSNA": "5",
    "eircode": "N91YD83",
    "addressOne": "Harbour Street",
    "addressTwo": "Mullingar",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.5283965",
    "lng": "-7.3426107",
    "phone": "449340933",
    "email": "adminsnr@presentationmullingar.ie"
  },
  {
    "i": "2902",
    "county": "Westmeath",
    "rollNumber": "18262G",
    "schoolName": "Lochan An Bhealaigh NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "N91KN56",
    "addressOne": "Loughanavally",
    "addressTwo": "Mullingar",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.4865654",
    "lng": "-7.5232382",
    "phone": "449226417",
    "email": "loughanavallyns@gmail.com"
  },
  {
    "i": "2903",
    "county": "Westmeath",
    "rollNumber": "18381O",
    "schoolName": "Scoil Na Mbraithre",
    "SETHours": "212.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "6.32",
    "spSNA": "3.32",
    "totalSNA": "9.64",
    "eircode": "N91HE22",
    "addressOne": "College Street",
    "addressTwo": "Mullingar",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.5261048",
    "lng": "-7.3469829",
    "phone": "449341517",
    "email": "admin@stmarysmullingar.ie"
  },
  {
    "i": "2904",
    "county": "Westmeath",
    "rollNumber": "18405C",
    "schoolName": "SN Phoil Naofa",
    "SETHours": "107.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "1.66",
    "spSNA": "1.66",
    "totalSNA": "3.32",
    "eircode": "N37E973",
    "addressOne": "Lyster Street",
    "addressTwo": "Athlone",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.4205069",
    "lng": "-7.9423855",
    "phone": "906494315",
    "email": "stpaulsnsathlone@gmail.com"
  },
  {
    "i": "2905",
    "county": "Westmeath",
    "rollNumber": "18484B",
    "schoolName": "Mhuire NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "N91AV61",
    "addressOne": "Rath Airne",
    "addressTwo": "Mullingar",
    "addressThree": "Co Westmeath",
    "addressFour": "",
    "lat": "53.5247293",
    "lng": "-7.0976957",
    "phone": "449374310",
    "email": "stmarysraharney@gmail.com"
  },
  {
    "i": "2906",
    "county": "Westmeath",
    "rollNumber": "18505G",
    "schoolName": "Naomh Clar NS",
    "SETHours": "97.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.66",
    "spSNA": "0",
    "totalSNA": "4.66",
    "eircode": "N37XV00",
    "addressOne": "Tubberclare",
    "addressTwo": "Athlone",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.4923365",
    "lng": "-7.8565957",
    "phone": "906485126",
    "email": "info@tubberclarens.ie"
  },
  {
    "i": "2907",
    "county": "Westmeath",
    "rollNumber": "18533L",
    "schoolName": "Scoil Mhuire",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "N91FP46",
    "addressOne": "Taghmon",
    "addressTwo": "Mullingar",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.5872826",
    "lng": "-7.3037475",
    "phone": "449372301",
    "email": "taughmonns@gmail.com"
  },
  {
    "i": "2908",
    "county": "Westmeath",
    "rollNumber": "18591C",
    "schoolName": "Naomh Tomas NS",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "N91HD26",
    "addressOne": "Ballydorey",
    "addressTwo": "Rathowen",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.6581142",
    "lng": "-7.5352661",
    "phone": "436676210",
    "email": "stthomasns@gmail.com"
  },
  {
    "i": "2909",
    "county": "Westmeath",
    "rollNumber": "18598Q",
    "schoolName": "Earnain Mxd NS",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "N91CTP4",
    "addressOne": "Castletown",
    "addressTwo": "Delvin",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.6183422",
    "lng": "-7.0883151",
    "phone": "449664539",
    "email": "sternansdelvin@gmail.com"
  },
  {
    "i": "2910",
    "county": "Westmeath",
    "rollNumber": "18640M",
    "schoolName": "Naomh Iosef NS",
    "SETHours": "100",
    "spClassTeachingPosts": "2",
    "mainSNA": "4.49",
    "spSNA": "4.83",
    "totalSNA": "9.32",
    "eircode": "N91PP66",
    "addressOne": "Rathwire",
    "addressTwo": "Killucan",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.50755",
    "lng": "-7.139023",
    "phone": "449374591",
    "email": "stjosephs@rathwirens.ie"
  },
  {
    "i": "2911",
    "county": "Westmeath",
    "rollNumber": "18679Q",
    "schoolName": "An Ghrianan NS",
    "SETHours": "105",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.83",
    "spSNA": "0",
    "totalSNA": "5.83",
    "eircode": "N37K129",
    "addressOne": "Mount Temple",
    "addressTwo": "Moate",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.4241434",
    "lng": "-7.7678517",
    "phone": "906481085",
    "email": "mount.temple18@gmail.com"
  },
  {
    "i": "2912",
    "county": "Westmeath",
    "rollNumber": "18744B",
    "schoolName": "SN Na Naomh Uile",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "N91DE70",
    "addressOne": "Church Avenue",
    "addressTwo": "Mullingar",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.5244529",
    "lng": "-7.3396352",
    "phone": "449348206",
    "email": "allsaintsns@gmail.com"
  },
  {
    "i": "2913",
    "county": "Westmeath",
    "rollNumber": "18764H",
    "schoolName": "Ard Na Gcraith NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "2",
    "spSNA": "2",
    "totalSNA": "4",
    "eircode": "N37YY16",
    "addressOne": "Ardnagrath",
    "addressTwo": "Walderstown",
    "addressThree": "Co. Westmeath",
    "addressFour": "Co Westmeath",
    "lat": "53.4831281",
    "lng": "-7.7905433",
    "phone": "906485572",
    "email": "ardnagrath1@eircom.net"
  },
  {
    "i": "2914",
    "county": "Westmeath",
    "rollNumber": "18812P",
    "schoolName": "Loch An Ghair NS",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "N91TD95",
    "addressOne": "Loughegar",
    "addressTwo": "Mullingar",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.5708179",
    "lng": "-7.2730261",
    "phone": "449372986",
    "email": "lochanghair@gmail.com"
  },
  {
    "i": "2915",
    "county": "Westmeath",
    "rollNumber": "18864L",
    "schoolName": "SN An Cusan",
    "SETHours": "160",
    "spClassTeachingPosts": "1",
    "mainSNA": "5.49",
    "spSNA": "1.83",
    "totalSNA": "7.32",
    "eircode": "N37TD88",
    "addressOne": "Coosan",
    "addressTwo": "Athlone",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.4466089",
    "lng": "-7.9341764",
    "phone": "906478356",
    "email": "coosanns@gmail.com"
  },
  {
    "i": "2916",
    "county": "Westmeath",
    "rollNumber": "19008U",
    "schoolName": "Scoil Phadraig",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "N91YA24",
    "addressOne": "Milltown",
    "addressTwo": "Mullingar",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.539427",
    "lng": "-7.5453043",
    "phone": "449355373",
    "email": "milltown_ns@yahoo.ie"
  },
  {
    "i": "2917",
    "county": "Westmeath",
    "rollNumber": "19205W",
    "schoolName": "Naomh Tola NS",
    "SETHours": "77.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "2",
    "spSNA": "2",
    "totalSNA": "4",
    "eircode": "N91XH26",
    "addressOne": "Hiskinstown",
    "addressTwo": "Delvin",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.5851333",
    "lng": "-7.1314683",
    "phone": "449664457",
    "email": "st.tolas@hotmail.com"
  },
  {
    "i": "2918",
    "county": "Westmeath",
    "rollNumber": "19350I",
    "schoolName": "SN Chruimin Naofa",
    "SETHours": "70",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "N91EK68",
    "addressOne": "Rathyganny",
    "addressTwo": "Multyfarnham",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.6239799",
    "lng": "-7.4001749",
    "phone": "449371122",
    "email": "karl@stcremins.ie"
  },
  {
    "i": "2919",
    "county": "Westmeath",
    "rollNumber": "19607T",
    "schoolName": "Kilpatrick Ns",
    "SETHours": "97.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.66",
    "spSNA": "0",
    "totalSNA": "3.66",
    "eircode": "N91H003",
    "addressOne": "Kilpatrick",
    "addressTwo": "Mullingar",
    "addressThree": "Co Westmeath",
    "addressFour": "",
    "lat": "53.5118098",
    "lng": "-7.3972556",
    "phone": "449348156",
    "email": "stkennykilpatrick@gmail.com"
  },
  {
    "i": "2920",
    "county": "Westmeath",
    "rollNumber": "19632S",
    "schoolName": "Ballinahowen Ns",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "N37F744",
    "addressOne": "Athlone",
    "addressTwo": "Co Westmeath",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.3496905",
    "lng": "-7.8508141",
    "phone": "906430044",
    "email": "principalballinahownns@gmail.com"
  },
  {
    "i": "2921",
    "county": "Westmeath",
    "rollNumber": "19650U",
    "schoolName": "Scoil Cholmain Naofa",
    "SETHours": "212.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "7.66",
    "spSNA": "0",
    "totalSNA": "7.66",
    "eircode": "N91DX74",
    "addressOne": "Bellview",
    "addressTwo": "Mullingar",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.528488",
    "lng": "-7.3278762",
    "phone": "449340901",
    "email": "reception@stcolmansns.com"
  },
  {
    "i": "2922",
    "county": "Westmeath",
    "rollNumber": "19848S",
    "schoolName": "St Etchens NS",
    "SETHours": "187.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "3",
    "spSNA": "3.32",
    "totalSNA": "6.32",
    "eircode": "N91CV96",
    "addressOne": "Mullingar Road",
    "addressTwo": "Kinnegad",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.4565947",
    "lng": "-7.1029895",
    "phone": "449375463",
    "email": "stetchens.ns@gmail.com"
  },
  {
    "i": "2923",
    "county": "Westmeath",
    "rollNumber": "19948W",
    "schoolName": "Sc Na Gceithre Maistri",
    "SETHours": "182.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "N37RP03",
    "addressOne": "Lios Í­ Mhulláin",
    "addressTwo": "áth Luain",
    "addressThree": "Co. Na Hiarmhí­",
    "addressFour": "",
    "lat": "53.427304",
    "lng": "-7.9179638",
    "phone": "906465794",
    "email": "oifig4maistri@gmail.com"
  },
  {
    "i": "2924",
    "county": "Westmeath",
    "rollNumber": "20002P",
    "schoolName": "Gaelscoil An Mhuilinn",
    "SETHours": "82.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "N91VN56",
    "addressOne": "Bóthar An ághasaigh",
    "addressTwo": "An Muileann Gcearr",
    "addressThree": "Co. Na Hiarmhí­",
    "addressFour": "",
    "lat": "53.5280326",
    "lng": "-7.3567849",
    "phone": "449344754",
    "email": "gaelscoilanmhuilinn@eircom.net"
  },
  {
    "i": "2925",
    "county": "Westmeath",
    "rollNumber": "20063M",
    "schoolName": "Scoil An Chlochair Cill Bheagan",
    "SETHours": "80",
    "spClassTeachingPosts": "1",
    "mainSNA": "3",
    "spSNA": "2",
    "totalSNA": "5",
    "eircode": "N91FY53",
    "addressOne": "Dublin Road",
    "addressTwo": "Kilbeggan",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.3674105",
    "lng": "-7.4932684",
    "phone": "579333558",
    "email": "office@kilbeggannationalschool.com"
  },
  {
    "i": "2926",
    "county": "Westmeath",
    "rollNumber": "20073P",
    "schoolName": "St Marys Ns",
    "SETHours": "302.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "6.33",
    "spSNA": "0",
    "totalSNA": "6.33",
    "eircode": "N37PX01",
    "addressOne": "Gracepark Road",
    "addressTwo": "Athlone",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.4254794",
    "lng": "-7.9334489",
    "phone": "906472321",
    "email": "stmarysathlone@gmail.com"
  },
  {
    "i": "2927",
    "county": "Westmeath",
    "rollNumber": "20188J",
    "schoolName": "Mullingar Educate Together",
    "SETHours": "267.5",
    "spClassTeachingPosts": "5",
    "mainSNA": "6.83",
    "spSNA": "11.66",
    "totalSNA": "18.49",
    "eircode": "N91N722",
    "addressOne": "Rathgowan",
    "addressTwo": "Mullingar",
    "addressThree": "Co. Westmeath",
    "addressFour": "",
    "lat": "53.5257206",
    "lng": "-7.3643085",
    "phone": "449348005",
    "email": "mullingar.etns@gmail.com"
  },
  {
    "i": "2928",
    "county": "Westmeath",
    "rollNumber": "20238V",
    "schoolName": "Gaelscoil An Choillí­n",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "N91NW80",
    "addressOne": "An Coillí­n Mór",
    "addressTwo": "An Muileann Gcearr",
    "addressThree": "Co. Na Hiarmhí­",
    "addressFour": "",
    "lat": "53.5552655",
    "lng": "-7.3561302",
    "phone": "449330443",
    "email": "gaelscoilanchoillin@eircom.net"
  },
  {
    "i": "2929",
    "county": "Westmeath",
    "rollNumber": "20439I",
    "schoolName": "Scoil Chroi Naofa",
    "SETHours": "100",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "N91CP38",
    "addressOne": "Rochfortbridge",
    "addressTwo": "Co. Westmeath",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.4151276",
    "lng": "-7.3037036",
    "phone": "449222389",
    "email": "scoilchroinaofarb@gmail.com"
  },
  {
    "i": "2930",
    "county": "Wexford",
    "rollNumber": "01840C",
    "schoolName": "St Canice S Convent",
    "SETHours": "97.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "Y34VH61",
    "addressOne": "Rosbercon",
    "addressTwo": "New Ross",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.3977049",
    "lng": "-6.9527345",
    "phone": "51422813",
    "email": "stcanicesns@gmail.com"
  },
  {
    "i": "2931",
    "county": "Wexford",
    "rollNumber": "03633H",
    "schoolName": "Scoil Náisiúnta Bhantiarna Lourdes",
    "SETHours": "150",
    "spClassTeachingPosts": "1",
    "mainSNA": "2",
    "spSNA": "1.83",
    "totalSNA": "3.83",
    "eircode": "Y21R820",
    "addressOne": "Hospital Hill",
    "addressTwo": "Bunclody",
    "addressThree": "Enniscorthy",
    "addressFour": "Co. Wexford",
    "lat": "52.6511623",
    "lng": "-6.6541528",
    "phone": "539377380",
    "email": "secretarybunclodyns@gmail.com"
  },
  {
    "i": "2932",
    "county": "Wexford",
    "rollNumber": "05070W",
    "schoolName": "SN Baile Muirne",
    "SETHours": "35",
    "spClassTeachingPosts": "1",
    "mainSNA": "2",
    "spSNA": "1.83",
    "totalSNA": "3.83",
    "eircode": "Y21PR60",
    "addressOne": "Ballymurn",
    "addressTwo": "Enniscorthy",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.441087",
    "lng": "-6.4746565",
    "phone": "539138435",
    "email": "office@ballymurnns.ie"
  },
  {
    "i": "2933",
    "county": "Wexford",
    "rollNumber": "06959G",
    "schoolName": "Clonroche NS",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "Y21PY59",
    "addressOne": "Clonroche",
    "addressTwo": "Enniscorthy",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.4474876",
    "lng": "-6.7246762",
    "phone": "539244441",
    "email": "clonrochens.ias@eircom.net"
  },
  {
    "i": "2934",
    "county": "Wexford",
    "rollNumber": "08221J",
    "schoolName": "St Senans National Sch",
    "SETHours": "285",
    "spClassTeachingPosts": "4",
    "mainSNA": "6.83",
    "spSNA": "9.66",
    "totalSNA": "16.49",
    "eircode": "Y21EV70",
    "addressOne": "Templeshannon",
    "addressTwo": "Enniscorthy",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.5045383",
    "lng": "-6.5566604",
    "phone": "539234169",
    "email": "info@stsenansps.ie"
  },
  {
    "i": "2935",
    "county": "Wexford",
    "rollNumber": "09184L",
    "schoolName": "Shielbeggan Convent",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "Y34Y656",
    "addressOne": "Shielbaggan",
    "addressTwo": "New Ross",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.2580436",
    "lng": "-6.8749667",
    "phone": "51562410",
    "email": "shielbagganns.ias@gmail.com"
  },
  {
    "i": "2936",
    "county": "Wexford",
    "rollNumber": "10780L",
    "schoolName": "Ballyoughter NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "Y25X778",
    "addressOne": "Ballyoughter",
    "addressTwo": "Gorey",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.6145743",
    "lng": "-6.366077",
    "phone": "539382000",
    "email": "office@ballyoughterns.ie"
  },
  {
    "i": "2937",
    "county": "Wexford",
    "rollNumber": "11361T",
    "schoolName": "Faythe Convent",
    "SETHours": "172.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "5.75",
    "spSNA": "2",
    "totalSNA": "7.75",
    "eircode": "Y35YT38",
    "addressOne": "99 The Faythe",
    "addressTwo": "Wexford",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.3310751",
    "lng": "-6.4541135",
    "phone": "539123105",
    "email": "faythepriomhoide@gmail.com"
  },
  {
    "i": "2938",
    "county": "Wexford",
    "rollNumber": "11380A",
    "schoolName": "Sacred Heart NS, Caim",
    "SETHours": "72.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "Y21YR64",
    "addressOne": "Caim",
    "addressTwo": "Enniscorthy",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.5122343",
    "lng": "-6.6799015",
    "phone": "539255534",
    "email": "caimnationalschool@gmail.com"
  },
  {
    "i": "2939",
    "county": "Wexford",
    "rollNumber": "11986N",
    "schoolName": "Convent Of Mercy",
    "SETHours": "182.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "6",
    "spSNA": "0",
    "totalSNA": "6",
    "eircode": "Y35DR12",
    "addressOne": "Whitemill Road",
    "addressTwo": "Wexford",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.3288004",
    "lng": "-6.4771264",
    "phone": "539123331",
    "email": "kennedyparkns@eircom.net"
  },
  {
    "i": "2940",
    "county": "Wexford",
    "rollNumber": "12741L",
    "schoolName": "Marshalstown NS",
    "SETHours": "82.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "Y21E954",
    "addressOne": "Marshalstown",
    "addressTwo": "Enniscorthy",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.5478747",
    "lng": "-6.6035384",
    "phone": "539388935",
    "email": "marshalstownns@gmail.com"
  },
  {
    "i": "2941",
    "county": "Wexford",
    "rollNumber": "12841P",
    "schoolName": "St Patricks NS",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "Y21KX52",
    "addressOne": "Ballyroebuck",
    "addressTwo": "Bunclody",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.650875",
    "lng": "-6.5514219",
    "phone": "539377410",
    "email": "ballyroebuckns@gmail.com"
  },
  {
    "i": "2942",
    "county": "Wexford",
    "rollNumber": "13299E",
    "schoolName": "Glanbrian NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "Y21FV38",
    "addressOne": "Gallinastraw",
    "addressTwo": "Glenbrien",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.464718",
    "lng": "-6.5003952",
    "phone": "539138398",
    "email": "glenbrienns@gmail.com"
  },
  {
    "i": "2943",
    "county": "Wexford",
    "rollNumber": "13335F",
    "schoolName": "Court NS",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "Y25WN22",
    "addressOne": "Court",
    "addressTwo": "Gorey",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.5539446",
    "lng": "-6.3421776",
    "phone": "539389342",
    "email": "info@courtns.ie"
  },
  {
    "i": "2944",
    "county": "Wexford",
    "rollNumber": "13999J",
    "schoolName": "Kilnamanagh Community NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "Y25HT63",
    "addressOne": "Knockskimolin",
    "addressTwo": "Outlart",
    "addressThree": "Gorey",
    "addressFour": "Co. Wexford",
    "lat": "52.5189235",
    "lng": "-6.3639197",
    "phone": "539136555",
    "email": "kilnamanaghcns@wwetb.ie"
  },
  {
    "i": "2945",
    "county": "Wexford",
    "rollNumber": "14254K",
    "schoolName": "SN Mhuire",
    "SETHours": "72.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "Y35A029",
    "addressOne": "Danescastle",
    "addressTwo": "Carrig-on-bannow",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.2393911",
    "lng": "-6.7321471",
    "phone": "51561414",
    "email": "secretary@danescastlens.com"
  },
  {
    "i": "2946",
    "county": "Wexford",
    "rollNumber": "14492D",
    "schoolName": "Curracloe NS",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "Y21W628",
    "addressOne": "Curracloe",
    "addressTwo": "Enniscorthy",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.3926646",
    "lng": "-6.3918765",
    "phone": "539137283",
    "email": "info@curracloens.ie"
  },
  {
    "i": "2947",
    "county": "Wexford",
    "rollNumber": "14668O",
    "schoolName": "Ballaghkeene NS",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "Y21K577",
    "addressOne": "Ballaghkeane",
    "addressTwo": "Enniscorthy",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.481409",
    "lng": "-6.4286695",
    "phone": "539136500",
    "email": "ballaghkeene@gmail.com"
  },
  {
    "i": "2948",
    "county": "Wexford",
    "rollNumber": "14777T",
    "schoolName": "Kilmyshall NS",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "Y21E726",
    "addressOne": "Kilmyshall",
    "addressTwo": "Bunclody",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.6273091",
    "lng": "-6.6560003",
    "phone": "539377451",
    "email": "kilmyshallns1970@gmail.com"
  },
  {
    "i": "2949",
    "county": "Wexford",
    "rollNumber": "14900P",
    "schoolName": "Gusserane NS",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "Y34HV08",
    "addressOne": "Gusserane",
    "addressTwo": "New Ross",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.3083512",
    "lng": "-6.8596859",
    "phone": "51562107",
    "email": "gusseranens@gmail.com"
  },
  {
    "i": "2950",
    "county": "Wexford",
    "rollNumber": "14903V",
    "schoolName": "St Josephs NS",
    "SETHours": "90",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.75",
    "spSNA": "0",
    "totalSNA": "3.75",
    "eircode": "Y25Y952",
    "addressOne": "Kilmuckridge",
    "addressTwo": "Gorey",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.5086982",
    "lng": "-6.2883924",
    "phone": "539130144",
    "email": "cillmhucraise@eircom.net"
  },
  {
    "i": "2951",
    "county": "Wexford",
    "rollNumber": "14909K",
    "schoolName": "St Leonards NS",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "Y34KP84",
    "addressOne": "St. Leonards",
    "addressTwo": "Ballycullane",
    "addressThree": "New Ross",
    "addressFour": "Co. Wexford",
    "lat": "52.2596286",
    "lng": "-6.8042184",
    "phone": "51562570",
    "email": "stleonardsns@gmail.com"
  },
  {
    "i": "2952",
    "county": "Wexford",
    "rollNumber": "15177A",
    "schoolName": "Carrigduff Nat School",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "Y21TP49",
    "addressOne": "Carrigduff",
    "addressTwo": "Bunclody",
    "addressThree": "Enniscorthy",
    "addressFour": "Co. Wexford",
    "lat": "52.657108",
    "lng": "-6.6653067",
    "phone": "539377346",
    "email": "officecarrigduffns@gmail.com"
  },
  {
    "i": "2953",
    "county": "Wexford",
    "rollNumber": "15354T",
    "schoolName": "Camolin NS",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "Y21F8H2",
    "addressOne": "Camolin",
    "addressTwo": "Enniscorthy",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.6152551",
    "lng": "-6.4262932",
    "phone": "539383455",
    "email": "camolinnationalschool@gmail.com"
  },
  {
    "i": "2954",
    "county": "Wexford",
    "rollNumber": "15367F",
    "schoolName": "Riverchapel NS",
    "SETHours": "222.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.83",
    "spSNA": "0",
    "totalSNA": "5.83",
    "eircode": "Y25DE28",
    "addressOne": "Riverchapel",
    "addressTwo": "Gorey",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.6382196",
    "lng": "-6.2341705",
    "phone": "539425540",
    "email": "riverchapelns@eircom.net"
  },
  {
    "i": "2955",
    "county": "Wexford",
    "rollNumber": "15407O",
    "schoolName": "Sn Baile Thomais",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "Y25W259",
    "addressOne": "Ballythomas",
    "addressTwo": "Gorey",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.7653626",
    "lng": "-6.3599186",
    "phone": "539428343",
    "email": "ballythomasns@gmail.com"
  },
  {
    "i": "2956",
    "county": "Wexford",
    "rollNumber": "15419V",
    "schoolName": "Oulart NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "Y25XK24",
    "addressOne": "Oulart",
    "addressTwo": "Gorey",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.5026469",
    "lng": "-6.3899012",
    "phone": "539136177",
    "email": "oulartns2@gmail.com"
  },
  {
    "i": "2957",
    "county": "Wexford",
    "rollNumber": "15420G",
    "schoolName": "Ballycanew NS",
    "SETHours": "142.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "4.83",
    "spSNA": "7.75",
    "totalSNA": "12.58",
    "eircode": "Y25Y6W8",
    "addressOne": "Ballycanew",
    "addressTwo": "Gorey",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.6104719",
    "lng": "-6.3065812",
    "phone": "539427496",
    "email": "ballycanewns@gmail.com"
  },
  {
    "i": "2958",
    "county": "Wexford",
    "rollNumber": "15937U",
    "schoolName": "Monaseed NS",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "Y25RF40",
    "addressOne": "Monaseed",
    "addressTwo": "Gorey",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.7158202",
    "lng": "-6.402851",
    "phone": "539428330",
    "email": "monaseedns@gmail.com"
  },
  {
    "i": "2959",
    "county": "Wexford",
    "rollNumber": "15940J",
    "schoolName": "Tombrack NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "Y21HV12",
    "addressOne": "Tombrack",
    "addressTwo": "Ferns",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.6003647",
    "lng": "-6.5510893",
    "phone": "539366738",
    "email": "tombrackns@gmail.com"
  },
  {
    "i": "2960",
    "county": "Wexford",
    "rollNumber": "15962T",
    "schoolName": "Ballindaggin NS",
    "SETHours": "75",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "Y21A371",
    "addressOne": "Ballindaggin",
    "addressTwo": "Enniscorthy",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.5681213",
    "lng": "-6.6781827",
    "phone": "539388728",
    "email": "stcolmansnsballindaggin@gmail.com"
  },
  {
    "i": "2961",
    "county": "Wexford",
    "rollNumber": "16023B",
    "schoolName": "Rathgarogue NS",
    "SETHours": "75",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "Y34H291",
    "addressOne": "Rathgarogue",
    "addressTwo": "New Ross",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.4281487",
    "lng": "-6.8650614",
    "phone": "51424779",
    "email": "principal@rathgaroguens.com"
  },
  {
    "i": "2962",
    "county": "Wexford",
    "rollNumber": "16072O",
    "schoolName": "Newbawn NS",
    "SETHours": "80",
    "spClassTeachingPosts": "1",
    "mainSNA": "1",
    "spSNA": "1",
    "totalSNA": "2",
    "eircode": "Y35WT27",
    "addressOne": "Newbawn",
    "addressTwo": "Co. Wexford",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.3418219",
    "lng": "-6.7945677",
    "phone": "51428416",
    "email": "shnsnewbawn@gmail.com"
  },
  {
    "i": "2963",
    "county": "Wexford",
    "rollNumber": "16145P",
    "schoolName": "Bunscoil Loreto",
    "SETHours": "272.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "5.75",
    "spSNA": "0",
    "totalSNA": "5.75",
    "eircode": "Y25HD34",
    "addressOne": "St Michael's Road",
    "addressTwo": "Gorey",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.6739356",
    "lng": "-6.2897251",
    "phone": "539421827",
    "email": "bunscoilloreto@gmail.com"
  },
  {
    "i": "2964",
    "county": "Wexford",
    "rollNumber": "16409A",
    "schoolName": "St Marys NS",
    "SETHours": "72.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "Y25AE64",
    "addressOne": "Ballygarrett",
    "addressTwo": "Gorey",
    "addressThree": "Co Wexford",
    "addressFour": "",
    "lat": "52.576423",
    "lng": "-6.2306536",
    "phone": "539427196",
    "email": "principal@bgns.ie"
  },
  {
    "i": "2965",
    "county": "Wexford",
    "rollNumber": "16605A",
    "schoolName": "Kilrane NS",
    "SETHours": "180",
    "spClassTeachingPosts": "3",
    "mainSNA": "5",
    "spSNA": "6.33",
    "totalSNA": "11.33",
    "eircode": "Y35RT21",
    "addressOne": "Kilrane",
    "addressTwo": "Rosslare Harbour",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.2412346",
    "lng": "-6.3527957",
    "phone": "539133303",
    "email": "kilranens.ias@eircom.net"
  },
  {
    "i": "2966",
    "county": "Wexford",
    "rollNumber": "16673R",
    "schoolName": "SN Baile Cuisin",
    "SETHours": "75",
    "spClassTeachingPosts": "1",
    "mainSNA": "3.5",
    "spSNA": "2",
    "totalSNA": "5.5",
    "eircode": "Y35FF98",
    "addressOne": "Cushinstown",
    "addressTwo": "Foulksmills",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.3752061",
    "lng": "-6.856025",
    "phone": "51428612",
    "email": "cushinstownns@eircom.net"
  },
  {
    "i": "2967",
    "county": "Wexford",
    "rollNumber": "16828U",
    "schoolName": "SN Bearna Na H-aille",
    "SETHours": "70",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "Y21FN23",
    "addressOne": "The Oil",
    "addressTwo": "Oylegate",
    "addressThree": "Enniscorthy",
    "addressFour": "Co Wexford",
    "lat": "52.424619",
    "lng": "-6.5245638",
    "phone": "539138509",
    "email": "oylegatens.ias@eircom.net"
  },
  {
    "i": "2968",
    "county": "Wexford",
    "rollNumber": "16833N",
    "schoolName": "Kiltealy NS",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.83",
    "spSNA": "0",
    "totalSNA": "2.83",
    "eircode": "Y21WN15",
    "addressOne": "Kiltealy",
    "addressTwo": "Enniscorthy",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.5668061",
    "lng": "-6.7425906",
    "phone": "539255446",
    "email": "kiltealyns@gmail.com"
  },
  {
    "i": "2969",
    "county": "Wexford",
    "rollNumber": "16841M",
    "schoolName": "SN Nmh Brighde",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.67",
    "spSNA": "0",
    "totalSNA": "2.67",
    "eircode": "Y21XA58",
    "addressOne": "Blackwater",
    "addressTwo": "Enniscorthy",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.445667",
    "lng": "-6.347643",
    "phone": "539127314",
    "email": "stbrigidsns.ias@eircom.net"
  },
  {
    "i": "2970",
    "county": "Wexford",
    "rollNumber": "16879O",
    "schoolName": "SN Clochar Mhuire",
    "SETHours": "77.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "Y35E516",
    "addressOne": "Rosslare",
    "addressTwo": "Co. Wexford",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.2831389",
    "lng": "-6.3937158",
    "phone": "539132501",
    "email": "scoilmhuirensrosslare@gmail.com"
  },
  {
    "i": "2971",
    "county": "Wexford",
    "rollNumber": "16992K",
    "schoolName": "Clongeen Mxd NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "Y35XD28",
    "addressOne": "Clongeen",
    "addressTwo": "Foulksmills",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.2968154",
    "lng": "-6.7702722",
    "phone": "51565713",
    "email": "principal.clongeenns@gmail.com"
  },
  {
    "i": "2972",
    "county": "Wexford",
    "rollNumber": "17005E",
    "schoolName": "SN An Ghleanna",
    "SETHours": "70",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "Y21DX47",
    "addressOne": "Glynn",
    "addressTwo": "Enniscorthy",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.3729377",
    "lng": "-6.5808327",
    "phone": "539128449",
    "email": "glynnprincipal@gmail.com"
  },
  {
    "i": "2973",
    "county": "Wexford",
    "rollNumber": "17017L",
    "schoolName": "SN Phadraig",
    "SETHours": "60",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.75",
    "spSNA": "0",
    "totalSNA": "2.75",
    "eircode": "Y35VY98",
    "addressOne": "Crossabeg",
    "addressTwo": "Co Wexford",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.3886279",
    "lng": "-6.5078484",
    "phone": "539159035",
    "email": "spnscrossabeg@gmail.com"
  },
  {
    "i": "2974",
    "county": "Wexford",
    "rollNumber": "17117P",
    "schoolName": "SN Cul Greine",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "Y25AN29",
    "addressOne": "Coolgreany",
    "addressTwo": "Gorey",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.7630095",
    "lng": "-6.2344099",
    "phone": "858570276",
    "email": "coolgreanyns@gmail.com"
  },
  {
    "i": "2975",
    "county": "Wexford",
    "rollNumber": "17194K",
    "schoolName": "SN Baile Ui Coileain",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "Y34YY76",
    "addressOne": "Ballycullane",
    "addressTwo": "New Ross",
    "addressThree": "Co Wexford",
    "addressFour": "",
    "lat": "52.2796626",
    "lng": "-6.8390258",
    "phone": "51562542",
    "email": "office@ballycullanens.com"
  },
  {
    "i": "2976",
    "county": "Wexford",
    "rollNumber": "17217T",
    "schoolName": "Scoil Na Mbraithre",
    "SETHours": "120",
    "spClassTeachingPosts": "2",
    "mainSNA": "1.83",
    "spSNA": "2.66",
    "totalSNA": "4.49",
    "eircode": "Y35H343",
    "addressOne": "Green Street",
    "addressTwo": "Wexford",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.3330584",
    "lng": "-6.464661",
    "phone": "539141324",
    "email": "office@cbsprimarywexford.com"
  },
  {
    "i": "2977",
    "county": "Wexford",
    "rollNumber": "17235V",
    "schoolName": "SN Chaomhain Torrchoill",
    "SETHours": "75",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "Y25RY86",
    "addressOne": "Gorey",
    "addressTwo": "Co Wexford",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.7064477",
    "lng": "-6.2117413",
    "phone": "539420321",
    "email": "tarahillns@eircom.net"
  },
  {
    "i": "2978",
    "county": "Wexford",
    "rollNumber": "17354G",
    "schoolName": "SN Padraig",
    "SETHours": "42.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "3.16",
    "spSNA": "2",
    "totalSNA": "5.16",
    "eircode": "Y25Y825",
    "addressOne": "Island Upper",
    "addressTwo": "Craanford",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.6793922",
    "lng": "-6.3930666",
    "phone": "539428333",
    "email": "craanfordns@gmail.com"
  },
  {
    "i": "2979",
    "county": "Wexford",
    "rollNumber": "17373K",
    "schoolName": "SN Clochar Mhuire",
    "SETHours": "117.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.83",
    "spSNA": "0",
    "totalSNA": "4.83",
    "eircode": "Y35X084",
    "addressOne": "St John's Road",
    "addressTwo": "Wexford",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.3378808",
    "lng": "-6.4712594",
    "phone": "539123294",
    "email": "officemercy@gmail.com"
  },
  {
    "i": "2980",
    "county": "Wexford",
    "rollNumber": "17443F",
    "schoolName": "SN Fionntain",
    "SETHours": "90",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "Y35NP27",
    "addressOne": "Chapel Street",
    "addressTwo": "Taghmon",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.3247215",
    "lng": "-6.653567",
    "phone": "539134219",
    "email": "stfintanstaghmon@gmail.com"
  },
  {
    "i": "2981",
    "county": "Wexford",
    "rollNumber": "17450C",
    "schoolName": "SN Mhaodhoig",
    "SETHours": "77.5",
    "spClassTeachingPosts": "4",
    "mainSNA": "1",
    "spSNA": "9.66",
    "totalSNA": "10.66",
    "eircode": "Y34DC82",
    "addressOne": "Poulfur",
    "addressTwo": "Fethard-on-sea",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.2033901",
    "lng": "-6.8558267",
    "phone": "51397193",
    "email": "poulfurns.ias@eircom.net"
  },
  {
    "i": "2982",
    "county": "Wexford",
    "rollNumber": "17471K",
    "schoolName": "SN Shean Bhoth",
    "SETHours": "15",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "Y34V129",
    "addressOne": "Rosbercon",
    "addressTwo": "New Ross",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.3811755",
    "lng": "-7.0034028",
    "phone": "51880308",
    "email": "shanboghns@gmail.com"
  },
  {
    "i": "2983",
    "county": "Wexford",
    "rollNumber": "17510R",
    "schoolName": "SN Treasa Nfa",
    "SETHours": "42.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "1",
    "spSNA": "0.83",
    "totalSNA": "1.83",
    "eircode": "Y25P620",
    "addressOne": "Ballyellis",
    "addressTwo": "Gorey",
    "addressThree": "Co Wexford",
    "addressFour": "",
    "lat": "52.6975261",
    "lng": "-6.4587359",
    "phone": "539426159",
    "email": "ballyellisns@eircom.net"
  },
  {
    "i": "2984",
    "county": "Wexford",
    "rollNumber": "17519M",
    "schoolName": "SN Caislean Dochraill",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "Y21N968",
    "addressOne": "Ballycarney",
    "addressTwo": "Enniscorthy",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.5840825",
    "lng": "-6.6098472",
    "phone": "539388892",
    "email": "castledockrellnschool@gmail.com"
  },
  {
    "i": "2985",
    "county": "Wexford",
    "rollNumber": "17526J",
    "schoolName": "SN Abbain",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "Y21VY56",
    "addressOne": "Adamstown",
    "addressTwo": "Enniscorthy",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.3925726",
    "lng": "-6.7175689",
    "phone": "539240694",
    "email": "scoilabbain@gmail.com"
  },
  {
    "i": "2986",
    "county": "Wexford",
    "rollNumber": "17554O",
    "schoolName": "SN Nmh Seosaimh",
    "SETHours": "67.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "1.17",
    "spSNA": "3.83",
    "totalSNA": "5",
    "eircode": "Y35YW81",
    "addressOne": "Hilltown",
    "addressTwo": "Ballymitty",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.2786867",
    "lng": "-6.7150781",
    "phone": "51561324",
    "email": "ballymittyschool@eircom.net"
  },
  {
    "i": "2987",
    "county": "Wexford",
    "rollNumber": "17610V",
    "schoolName": "SN Baile Fada",
    "SETHours": "7.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "Y25E376",
    "addressOne": "Ballyfad",
    "addressTwo": "Gorey",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.7669731",
    "lng": "-6.2695455",
    "phone": "40237799",
    "email": "ballyfadns@gmail.com"
  },
  {
    "i": "2988",
    "county": "Wexford",
    "rollNumber": "17612C",
    "schoolName": "St Garvans Ns",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "Y35E773",
    "addressOne": "Carrowreigh",
    "addressTwo": "Taghmon",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.3513822",
    "lng": "-6.6863067",
    "phone": "539134294",
    "email": "secretary@stgarvansns.ie"
  },
  {
    "i": "2989",
    "county": "Wexford",
    "rollNumber": "17638U",
    "schoolName": "St Joseph's NS",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "Y21V091",
    "addressOne": "Donard",
    "addressTwo": "Poulpeasty",
    "addressThree": "Clonroche, Enniscorthy",
    "addressFour": "Co Wexford",
    "lat": "52.4499683",
    "lng": "-6.7907624",
    "phone": "539244295",
    "email": "donardns@live.ie"
  },
  {
    "i": "2990",
    "county": "Wexford",
    "rollNumber": "17656W",
    "schoolName": "SN Olibheir Beannuithe",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "Y34CY63",
    "addressOne": "Duncannon",
    "addressTwo": "Co. Wexford",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.2250378",
    "lng": "-6.9316362",
    "phone": "51389206",
    "email": "info@duncannonns.com"
  },
  {
    "i": "2991",
    "county": "Wexford",
    "rollNumber": "17707N",
    "schoolName": "SN Rath An Iubhair",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "Y21V228",
    "addressOne": "Rathnure",
    "addressTwo": "Enniscorthy",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.498765",
    "lng": "-6.7669405",
    "phone": "539255161",
    "email": "secretary@rathnurens.ie"
  },
  {
    "i": "2992",
    "county": "Wexford",
    "rollNumber": "17734Q",
    "schoolName": "Scoil Eoin Baiste",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "Y21HN47",
    "addressOne": "Galbally",
    "addressTwo": "Ballyhogue",
    "addressThree": "Enniscorthy",
    "addressFour": "Co. Wexford",
    "lat": "52.3985888",
    "lng": "-6.6400378",
    "phone": "539247622",
    "email": "principal.scoileoinbaiste@gmail.com"
  },
  {
    "i": "2993",
    "county": "Wexford",
    "rollNumber": "17768K",
    "schoolName": "Scoil Ghormáin Naofa",
    "SETHours": "65",
    "spClassTeachingPosts": "1",
    "mainSNA": "3.33",
    "spSNA": "1",
    "totalSNA": "4.33",
    "eircode": "Y25DY05",
    "addressOne": "Castletown",
    "addressTwo": "Inch",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.7218651",
    "lng": "-6.1884661",
    "phone": "40237596",
    "email": "cns.iaswx@gmail.com"
  },
  {
    "i": "2994",
    "county": "Wexford",
    "rollNumber": "17769M",
    "schoolName": "SN Mhuire",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "Y35DE08",
    "addressOne": "Grahormack",
    "addressTwo": "Tagoat",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.2463527",
    "lng": "-6.3877558",
    "phone": "539132926",
    "email": "tagoatsecretary@gmail.com"
  },
  {
    "i": "2995",
    "county": "Wexford",
    "rollNumber": "17800D",
    "schoolName": "SN Seosamh Nfa",
    "SETHours": "80",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "Y21TW82",
    "addressOne": "Bree",
    "addressTwo": "Enniscorty",
    "addressThree": "Co Wexford",
    "addressFour": "",
    "lat": "52.4342335",
    "lng": "-6.6086613",
    "phone": "539247725",
    "email": "secretary@breens.ie"
  },
  {
    "i": "2996",
    "county": "Wexford",
    "rollNumber": "17812K",
    "schoolName": "St Marys NS",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "Y21FX21",
    "addressOne": "Parnell Avenue",
    "addressTwo": "Enniscorthy",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.4976824",
    "lng": "-6.5726789",
    "phone": "539235728",
    "email": "principal1stmarys@gmail.com"
  },
  {
    "i": "2997",
    "county": "Wexford",
    "rollNumber": "17841R",
    "schoolName": "Sn Mhuire",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "Y21Y898",
    "addressOne": "Ballyhogue",
    "addressTwo": "Bree",
    "addressThree": "Enniscorthy",
    "addressFour": "Co. Wexford",
    "lat": "52.4140516",
    "lng": "-6.5754958",
    "phone": "539247677",
    "email": "ballyhoguens@yahoo.ie"
  },
  {
    "i": "2998",
    "county": "Wexford",
    "rollNumber": "17858L",
    "schoolName": "SN Coill An Iarainn",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "Y25VK29",
    "addressOne": "Kilanerin",
    "addressTwo": "Gorey",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.7306021",
    "lng": "-6.2860368",
    "phone": "40237405",
    "email": "kilanerinns@gmail.com"
  },
  {
    "i": "2999",
    "county": "Wexford",
    "rollNumber": "17913Q",
    "schoolName": "SN Mhuire",
    "SETHours": "112.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "3",
    "spSNA": "4.41",
    "totalSNA": "7.41",
    "eircode": "Y35X620",
    "addressOne": "Barntown",
    "addressTwo": "Co. Wexford",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.3376396",
    "lng": "-6.5427685",
    "phone": "539120376",
    "email": "info@barntownns.ie"
  },
  {
    "i": "3000",
    "county": "Wexford",
    "rollNumber": "18010C",
    "schoolName": "Davidstown Primary School",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.25",
    "spSNA": "0",
    "totalSNA": "2.25",
    "eircode": "Y21E772",
    "addressOne": "Davidstown Primary School",
    "addressTwo": "Enniscorthy",
    "addressThree": "Co Wexford",
    "addressFour": "",
    "lat": "52.4798937",
    "lng": "-6.6366244",
    "phone": "539234745",
    "email": "info@davidstownps.ie"
  },
  {
    "i": "3001",
    "county": "Wexford",
    "rollNumber": "18133S",
    "schoolName": "Fionntain Nfa NS",
    "SETHours": "55",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "Y35TE83",
    "addressOne": "Mayglass",
    "addressTwo": "Bridgetown",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.2439721",
    "lng": "-6.5162011",
    "phone": "539135279",
    "email": "mgns@eircom.net"
  },
  {
    "i": "3002",
    "county": "Wexford",
    "rollNumber": "18191J",
    "schoolName": "SN Raithin",
    "SETHours": "42.5",
    "spClassTeachingPosts": "2.5",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "Y21E129",
    "addressOne": "Raheen",
    "addressTwo": "Enniscorthy",
    "addressThree": "Co Wexford",
    "addressFour": "",
    "lat": "52.3916523",
    "lng": "-6.7958223",
    "phone": "51428258",
    "email": "raheenns.ias@eircom.net"
  },
  {
    "i": "3003",
    "county": "Wexford",
    "rollNumber": "18280I",
    "schoolName": "Scoil Naomh Ioseph",
    "SETHours": "180",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.5",
    "spSNA": "0",
    "totalSNA": "3.5",
    "eircode": "Y25E135",
    "addressOne": "Gorey",
    "addressTwo": "Co. Wexford",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.6784046",
    "lng": "-6.3123625",
    "phone": "539421178",
    "email": "podgegorey@yahoo.ie"
  },
  {
    "i": "3004",
    "county": "Wexford",
    "rollNumber": "18308E",
    "schoolName": "SN Moin Na Gcaor",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "Y21TR52",
    "addressOne": "Monageer",
    "addressTwo": "Ballysimon",
    "addressThree": "Enniscorthy",
    "addressFour": "Co. Wexford",
    "lat": "52.5259018",
    "lng": "-6.4796015",
    "phone": "539234453",
    "email": "monageerns@gmail.com"
  },
  {
    "i": "3005",
    "county": "Wexford",
    "rollNumber": "18315B",
    "schoolName": "SN Padraig Nfa",
    "SETHours": "45",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "Y21RK00",
    "addressOne": "Courtnacuddy",
    "addressTwo": "Enniscorthy",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.4814077",
    "lng": "-6.6932666",
    "phone": "539244284",
    "email": "courtnacuddyns@gmail.com"
  },
  {
    "i": "3006",
    "county": "Wexford",
    "rollNumber": "18336J",
    "schoolName": "Boolavogue NS",
    "SETHours": "50",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.33",
    "spSNA": "0",
    "totalSNA": "2.33",
    "eircode": "Y21NW02",
    "addressOne": "Boolavogue",
    "addressTwo": "Ferns",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.5551488",
    "lng": "-6.4202905",
    "phone": "539366998",
    "email": "principal@boolavoguens.ie"
  },
  {
    "i": "3007",
    "county": "Wexford",
    "rollNumber": "18387D",
    "schoolName": "SN Catriona Nfa",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.25",
    "spSNA": "0",
    "totalSNA": "0.25",
    "eircode": "Y34KD29",
    "addressOne": "Ballyhack",
    "addressTwo": "Arthurstown",
    "addressThree": "New Ross",
    "addressFour": "Co. Wexford",
    "lat": "52.2515492",
    "lng": "-6.9599811",
    "phone": "51389368",
    "email": "ballyhackschool@gmail.com"
  },
  {
    "i": "3008",
    "county": "Wexford",
    "rollNumber": "18558E",
    "schoolName": "SN Baile An Phiarsaigh",
    "SETHours": "82.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "3.5",
    "spSNA": "1.83",
    "totalSNA": "5.33",
    "eircode": "Y35F663",
    "addressOne": "Piercestown",
    "addressTwo": "Drinagh",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.286667",
    "lng": "-6.4879416",
    "phone": "539158854",
    "email": "piercestownns@gmail.com"
  },
  {
    "i": "3009",
    "county": "Wexford",
    "rollNumber": "18684J",
    "schoolName": "SN Bhaile Mhuirne",
    "SETHours": "80",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "Y35D326",
    "addressOne": "Murrintown",
    "addressTwo": "Co Wexford",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.2862581",
    "lng": "-6.5203728",
    "phone": "539139277",
    "email": "murrintownnationalschool@gmail.com"
  },
  {
    "i": "3010",
    "county": "Wexford",
    "rollNumber": "18687P",
    "schoolName": "Ballyduff NS",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "Y21XY30",
    "addressOne": "Ballyduff",
    "addressTwo": "Camolin",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.6369557",
    "lng": "-6.4683339",
    "phone": "539383436",
    "email": "ballyduffnswex@hotmail.com"
  },
  {
    "i": "3011",
    "county": "Wexford",
    "rollNumber": "18707S",
    "schoolName": "Castlebridge NS",
    "SETHours": "102.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.75",
    "spSNA": "0",
    "totalSNA": "3.75",
    "eircode": "Y35Y208",
    "addressOne": "Castlebridge",
    "addressTwo": "Co. Wexford",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.3870143",
    "lng": "-6.4503542",
    "phone": "539159442",
    "email": "castlebridgens@gmail.com"
  },
  {
    "i": "3012",
    "county": "Wexford",
    "rollNumber": "18714P",
    "schoolName": "St Edans NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "Y21KF25",
    "addressOne": "Clone Road",
    "addressTwo": "Ferns",
    "addressThree": "Enniscorthy",
    "addressFour": "Co. Wexford",
    "lat": "52.5844683",
    "lng": "-6.493965",
    "phone": "539366511",
    "email": "stedansschool@gmail.com"
  },
  {
    "i": "3013",
    "county": "Wexford",
    "rollNumber": "18824W",
    "schoolName": "St Iberius NS",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "Y35N970",
    "addressOne": "Davitt Road South",
    "addressTwo": "Wexford",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.3370251",
    "lng": "-6.4689959",
    "phone": "539122843",
    "email": "iberiusns.ias@gmail.com"
  },
  {
    "i": "3014",
    "county": "Wexford",
    "rollNumber": "18839M",
    "schoolName": "SN Na Scrine",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "Y21PC52",
    "addressOne": "Screen",
    "addressTwo": "Enniscorthy",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.4115242",
    "lng": "-6.4083484",
    "phone": "539137142",
    "email": "screen.ns@gmail.com"
  },
  {
    "i": "3015",
    "county": "Wexford",
    "rollNumber": "19317K",
    "schoolName": "Rathangan NS",
    "SETHours": "85",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.75",
    "spSNA": "0",
    "totalSNA": "3.75",
    "eircode": "Y35KT65",
    "addressOne": "Rathangan",
    "addressTwo": "Duncormick",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.232865",
    "lng": "-6.6163943",
    "phone": "51563167",
    "email": "principal.rathanganns@gmail.com"
  },
  {
    "i": "3016",
    "county": "Wexford",
    "rollNumber": "19352M",
    "schoolName": "Sc Nais Realta Na Mara",
    "SETHours": "175",
    "spClassTeachingPosts": "1",
    "mainSNA": "2.67",
    "spSNA": "0.83",
    "totalSNA": "3.5",
    "eircode": "Y35YX20",
    "addressOne": "Ballask",
    "addressTwo": "Kilmore",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.2074956",
    "lng": "-6.5462837",
    "phone": "539135230",
    "email": "kilmorens@gmail.com"
  },
  {
    "i": "3017",
    "county": "Wexford",
    "rollNumber": "19419S",
    "schoolName": "Gorey Central School",
    "SETHours": "115",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "Y25XH11",
    "addressOne": "Charlotte Row",
    "addressTwo": "Gorey",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.6737619",
    "lng": "-6.297857",
    "phone": "539421745",
    "email": "goreycentralschool@gmail.com"
  },
  {
    "i": "3018",
    "county": "Wexford",
    "rollNumber": "19528A",
    "schoolName": "Ramsgrange Central NS",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "Y34HX56",
    "addressOne": "Ramsgrange",
    "addressTwo": "Co. Wexford",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.2457343",
    "lng": "-6.9201814",
    "phone": "51389363",
    "email": "stjamesns@eircom.net"
  },
  {
    "i": "3019",
    "county": "Wexford",
    "rollNumber": "19604N",
    "schoolName": "Scoil Mhuire",
    "SETHours": "122.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.75",
    "spSNA": "0",
    "totalSNA": "4.75",
    "eircode": "Y34PD77",
    "addressOne": "Ballinamona",
    "addressTwo": "Campile",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.3105576",
    "lng": "-6.9571909",
    "phone": "51388255",
    "email": "horeswoodprincipal@gmail.com"
  },
  {
    "i": "3020",
    "county": "Wexford",
    "rollNumber": "19739N",
    "schoolName": "Scoil Mhuire Coolcotts",
    "SETHours": "350.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "10.25",
    "spSNA": "7.66",
    "totalSNA": "17.91",
    "eircode": "Y35TR29",
    "addressOne": "Coolcotts",
    "addressTwo": "Wexford",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.3362517",
    "lng": "-6.4840977",
    "phone": "539144761",
    "email": "scoilmhuire@coolcotts.com"
  },
  {
    "i": "3021",
    "county": "Wexford",
    "rollNumber": "19741A",
    "schoolName": "Scoil Mhuire",
    "SETHours": "70",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "Y35DE42",
    "addressOne": "Broadway",
    "addressTwo": "Co. Wexford",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.2194169",
    "lng": "-6.3885851",
    "phone": "539131113",
    "email": "ourladysislandns@gmail.com"
  },
  {
    "i": "3022",
    "county": "Wexford",
    "rollNumber": "19890R",
    "schoolName": "Naomh Maodhog NS",
    "SETHours": "95",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "Y21H9P8",
    "addressOne": "Main Street",
    "addressTwo": "Ferns",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.5906856",
    "lng": "-6.4982119",
    "phone": "539366205",
    "email": "fernsschool@gmail.com"
  },
  {
    "i": "3023",
    "county": "Wexford",
    "rollNumber": "20003R",
    "schoolName": "St Aidans Parish School",
    "SETHours": "495",
    "spClassTeachingPosts": "7",
    "mainSNA": "8.59",
    "spSNA": "7.16",
    "totalSNA": "15.75",
    "eircode": "Y21WD30",
    "addressOne": "Convent Road",
    "addressTwo": "Enniscorthy",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.504513",
    "lng": "-6.5725107",
    "phone": "539235809",
    "email": "info@staidansps.ie"
  },
  {
    "i": "3024",
    "county": "Wexford",
    "rollNumber": "20008E",
    "schoolName": "Gaelscoil Loch Garman",
    "SETHours": "62.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "Y35XW99",
    "addressOne": "An Charraig Bhán Thuaidh",
    "addressTwo": "Loch Garman",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.3278497",
    "lng": "-6.4734216",
    "phone": "539124227",
    "email": "gaelscoilcharman@eircom.net"
  },
  {
    "i": "3025",
    "county": "Wexford",
    "rollNumber": "20057R",
    "schoolName": "Gaelscoil Inis Corthaidh",
    "SETHours": "85",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "Y21PP59",
    "addressOne": "Drom Guail",
    "addressTwo": "Inis Corthaidh",
    "addressThree": "Co. Loch Garman",
    "addressFour": "",
    "lat": "52.4983807",
    "lng": "-6.5487336",
    "phone": "539237422",
    "email": "muinteoirjudy@gmail.com"
  },
  {
    "i": "3026",
    "county": "Wexford",
    "rollNumber": "20165U",
    "schoolName": "Gaelscoil Mhoshiolog",
    "SETHours": "62.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "Y25VP62",
    "addressOne": "An Chraobach",
    "addressTwo": "Bóthar Charn An Bhua",
    "addressThree": "Guaire",
    "addressFour": "Co. Loch Garman",
    "lat": "52.67452",
    "lng": "-6.3159165",
    "phone": "539484028",
    "email": "eolasgm@gmail.com"
  },
  {
    "i": "3027",
    "county": "Wexford",
    "rollNumber": "20214H",
    "schoolName": "Gorey Educate Together Ns",
    "SETHours": "227.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "8.32",
    "spSNA": "7.83",
    "totalSNA": "16.15",
    "eircode": "Y25DX23",
    "addressOne": "Kilnahue Lane",
    "addressTwo": "Gorey",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.67494",
    "lng": "-6.3167496",
    "phone": "539489662",
    "email": "info@goreyeducatetogether.ie"
  },
  {
    "i": "3028",
    "county": "Wexford",
    "rollNumber": "20333P",
    "schoolName": "Wexford Educate Together NS",
    "SETHours": "67.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "3.83",
    "spSNA": "0.83",
    "totalSNA": "4.66",
    "eircode": "Y35C520",
    "addressOne": "Whitemill",
    "addressTwo": "Clonard",
    "addressThree": "Wexford",
    "addressFour": "",
    "lat": "52.3284878",
    "lng": "-6.4876891",
    "phone": "539184573",
    "email": "secretary@wexfordetns.ie"
  },
  {
    "i": "3029",
    "county": "Wexford",
    "rollNumber": "20458M",
    "schoolName": "New Ross Educate Together NS",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "Y34AY71",
    "addressOne": "Barrett's Park",
    "addressTwo": "New Ross",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.4048602",
    "lng": "-6.9354952",
    "phone": "51445398",
    "email": "office@newrossetns.ie"
  },
  {
    "i": "3030",
    "county": "Wexford",
    "rollNumber": "20481H",
    "schoolName": "Bunscoil Nic Amhlaidh",
    "SETHours": "175",
    "spClassTeachingPosts": "3",
    "mainSNA": "4.34",
    "spSNA": "5.49",
    "totalSNA": "9.83",
    "eircode": "Y34XT89",
    "addressOne": "Castlemoyle",
    "addressTwo": "New Ross",
    "addressThree": "Co. Wexford",
    "addressFour": "",
    "lat": "52.4017573",
    "lng": "-6.9293983",
    "phone": "51425586",
    "email": "newrossjuniorschool@gmail.com"
  },
  {
    "i": "3031",
    "county": "Wexford",
    "rollNumber": "20482J",
    "schoolName": "Bunscoil Ris",
    "SETHours": "187.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "3",
    "spSNA": "4",
    "totalSNA": "7",
    "eircode": "Y34XN32",
    "addressOne": "Castlemoyle",
    "addressTwo": "New Ross",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.4016101",
    "lng": "-6.9306541",
    "phone": "51448378",
    "email": "gmoran@bunscoilris.ie"
  },
  {
    "i": "3032",
    "county": "Wicklow",
    "rollNumber": "00973Q",
    "schoolName": "Grange Con NS",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "W91TV06",
    "addressOne": "Grangecon",
    "addressTwo": "Dunlavin",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "52.9950352",
    "lng": "-6.7432424",
    "phone": "45403111",
    "email": "grangeconns1965@gmail.com"
  },
  {
    "i": "3033",
    "county": "Wicklow",
    "rollNumber": "00984V",
    "schoolName": "Glenealy 1 NS",
    "SETHours": "52.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "A67CD78",
    "addressOne": "Glenealy",
    "addressTwo": "Co. Wicklow",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.9629454",
    "lng": "-6.1520837",
    "phone": "40444884",
    "email": "secretary@glenealy2ns.com"
  },
  {
    "i": "3034",
    "county": "Wicklow",
    "rollNumber": "01782O",
    "schoolName": "SN Naomh Padraig",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "Y14NW50",
    "addressOne": "Barnacleagh",
    "addressTwo": "Arklow",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "52.7950339",
    "lng": "-6.2346292",
    "phone": "40239602",
    "email": "bcjohnstown@gmail.com"
  },
  {
    "i": "3035",
    "county": "Wicklow",
    "rollNumber": "06176U",
    "schoolName": "Blessington 1 NS",
    "SETHours": "37.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.75",
    "spSNA": "0",
    "totalSNA": "0.75",
    "eircode": "W91YX06",
    "addressOne": "Blessington Demesne",
    "addressTwo": "Blessington",
    "addressThree": "Co Wicklow",
    "addressFour": "",
    "lat": "53.1792698",
    "lng": "-6.5423113",
    "phone": "45900879",
    "email": "blessington1ns@gmail.com"
  },
  {
    "i": "3036",
    "county": "Wicklow",
    "rollNumber": "07246U",
    "schoolName": "Ravenswell Primary School",
    "SETHours": "193.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "3.83",
    "spSNA": "4",
    "totalSNA": "7.83",
    "eircode": "A98EF88",
    "addressOne": "Ravenswell",
    "addressTwo": "Bray",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "53.2083773",
    "lng": "-6.1123821",
    "phone": "12860498",
    "email": "office@ravenswell.ie"
  },
  {
    "i": "3037",
    "county": "Wicklow",
    "rollNumber": "09760V",
    "schoolName": "Powerscourt NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "A98K7X6",
    "addressOne": "Cookstown Road",
    "addressTwo": "Enniskerry",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "53.1884284",
    "lng": "-6.1673611",
    "phone": "12863862",
    "email": "office@powerscourtns.ie"
  },
  {
    "i": "3038",
    "county": "Wicklow",
    "rollNumber": "10111O",
    "schoolName": "Lacken Mxd NS",
    "SETHours": "50",
    "spClassTeachingPosts": "4",
    "mainSNA": "1",
    "spSNA": "7.15",
    "totalSNA": "8.15",
    "eircode": "W91CY82",
    "addressOne": "Lacken",
    "addressTwo": "Blessington",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "53.1388442",
    "lng": "-6.491135",
    "phone": "45865086",
    "email": "lackenschool@eircom.net"
  },
  {
    "i": "3039",
    "county": "Wicklow",
    "rollNumber": "10131U",
    "schoolName": "Moin An Bhealaigh NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "W91NY66",
    "addressOne": "Valleymount",
    "addressTwo": "Blessington",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "53.1065698",
    "lng": "-6.5245543",
    "phone": "45867289",
    "email": "valleymountoffice@eircom.net"
  },
  {
    "i": "3040",
    "county": "Wicklow",
    "rollNumber": "10683N",
    "schoolName": "Kilbride NS",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "W91HK44",
    "addressOne": "Manor Kilbride",
    "addressTwo": "Blessington",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "53.1981599",
    "lng": "-6.4673917",
    "phone": "14582550",
    "email": "kilbrideschool@hotmail.com"
  },
  {
    "i": "3041",
    "county": "Wicklow",
    "rollNumber": "11372B",
    "schoolName": "Brittas Bay Mxd NS",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "A67XP71",
    "addressOne": "Ballynacarrig",
    "addressTwo": "Britta's Bay",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "52.9015181",
    "lng": "-6.0506612",
    "phone": "40447488",
    "email": "brittasbaynationalschool@gmail.com"
  },
  {
    "i": "3042",
    "county": "Wicklow",
    "rollNumber": "11649S",
    "schoolName": "Nuns Cross NS",
    "SETHours": "75",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "A67HK70",
    "addressOne": "Nun's Cross",
    "addressTwo": "Ashford",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "53.0178123",
    "lng": "-6.1260628",
    "phone": "40440700",
    "email": "secretary@nunscross.ie"
  },
  {
    "i": "3043",
    "county": "Wicklow",
    "rollNumber": "12413R",
    "schoolName": "Donaghmore NS",
    "SETHours": "10",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "W91XY32",
    "addressOne": "Donoughmore",
    "addressTwo": "Donard",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "52.9901204",
    "lng": "-6.6268834",
    "phone": "45404615",
    "email": "donoughmorens@gmail.com"
  },
  {
    "i": "3044",
    "county": "Wicklow",
    "rollNumber": "12529N",
    "schoolName": "St Saviours NS",
    "SETHours": "47.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "1",
    "spSNA": "1",
    "totalSNA": "2",
    "eircode": "A67PV00",
    "addressOne": "Station Road",
    "addressTwo": "Rathdrum",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "52.9304587",
    "lng": "-6.2287917",
    "phone": "40446512",
    "email": "saviours.ias@eircom.net"
  },
  {
    "i": "3045",
    "county": "Wicklow",
    "rollNumber": "12554M",
    "schoolName": "St Patrick's NS",
    "SETHours": "152.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "5",
    "spSNA": "0",
    "totalSNA": "5",
    "eircode": "A63EY42",
    "addressOne": "Church Road",
    "addressTwo": "Greystones",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "53.1488574",
    "lng": "-6.0692431",
    "phone": "12875684",
    "email": "admin@stpns.ie"
  },
  {
    "i": "3046",
    "county": "Wicklow",
    "rollNumber": "12688K",
    "schoolName": "Kiltegan NS",
    "SETHours": "7.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "W91A292",
    "addressOne": "Kiltegan",
    "addressTwo": "Co. Wicklow",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.9062035",
    "lng": "-6.6042215",
    "phone": "596473444",
    "email": "kilteganns.ias@eircom.net"
  },
  {
    "i": "3047",
    "county": "Wicklow",
    "rollNumber": "13224T",
    "schoolName": "St Kevin's Ballycoog Ns",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "Y14Y248",
    "addressOne": "Ballycoog",
    "addressTwo": "Avoca",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "52.8277833",
    "lng": "-6.2644814",
    "phone": "40235511",
    "email": "ballycoogns@gmail.com"
  },
  {
    "i": "3048",
    "county": "Wicklow",
    "rollNumber": "13246G",
    "schoolName": "Moneystown NS",
    "SETHours": "52.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "2",
    "spSNA": "2",
    "totalSNA": "4",
    "eircode": "A98VF83",
    "addressOne": "Moneystown",
    "addressTwo": "Roundwood Bray",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "53.0038145",
    "lng": "-6.1988861",
    "phone": "40445477",
    "email": "oifig@moneystownns.ie"
  },
  {
    "i": "3049",
    "county": "Wicklow",
    "rollNumber": "13597M",
    "schoolName": "St Andrews NS",
    "SETHours": "115",
    "spClassTeachingPosts": "0",
    "mainSNA": "4",
    "spSNA": "0",
    "totalSNA": "4",
    "eircode": "A98PY88",
    "addressOne": "Newcourt Road",
    "addressTwo": "Bray",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "53.1893076",
    "lng": "-6.1010237",
    "phone": "12867161",
    "email": "info@standrewsbray.ie"
  },
  {
    "i": "3050",
    "county": "Wicklow",
    "rollNumber": "13679O",
    "schoolName": "Delgany NS",
    "SETHours": "92.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.83",
    "spSNA": "0",
    "totalSNA": "3.83",
    "eircode": "A63A657",
    "addressOne": "Delgany",
    "addressTwo": "Co. Wicklow",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.1330103",
    "lng": "-6.0861135",
    "phone": "12876907",
    "email": "delganyns.ias@eircom.net"
  },
  {
    "i": "3051",
    "county": "Wicklow",
    "rollNumber": "14045B",
    "schoolName": "Carysfort Mxd NS",
    "SETHours": "75",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "Y14XE30",
    "addressOne": "Knockanrahan",
    "addressTwo": "Arklow",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "52.7902422",
    "lng": "-6.1642848",
    "phone": "40232690",
    "email": "info@carysfortnsarklow.ie"
  },
  {
    "i": "3052",
    "county": "Wicklow",
    "rollNumber": "14269A",
    "schoolName": "Jonathan Swift Ns",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "W91Y9DY",
    "addressOne": "Dunlavin",
    "addressTwo": "Co. Wicklow",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.0567986",
    "lng": "-6.7042768",
    "phone": "45401611",
    "email": "jsn.ias@eircom.net"
  },
  {
    "i": "3053",
    "county": "Wicklow",
    "rollNumber": "14398L",
    "schoolName": "Glebe Ns",
    "SETHours": "95",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "A67X782",
    "addressOne": "Church Hill",
    "addressTwo": "Wicklow Town",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "52.9829383",
    "lng": "-6.046745",
    "phone": "40468310",
    "email": "glebewicklow@gmail.com"
  },
  {
    "i": "3054",
    "county": "Wicklow",
    "rollNumber": "14829M",
    "schoolName": "Scoil San Eoin",
    "SETHours": "12.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "A67VY99",
    "addressOne": "Redcross",
    "addressTwo": "Co. Wicklow",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.8873428",
    "lng": "-6.1464278",
    "phone": "40441727",
    "email": "lgreeneredcross@gmail.com"
  },
  {
    "i": "3055",
    "county": "Wicklow",
    "rollNumber": "14972R",
    "schoolName": "All Saints NS",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "Y14YY46",
    "addressOne": "Carnew",
    "addressTwo": "Co. Wicklow",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.7097849",
    "lng": "-6.4998897",
    "phone": "539426513",
    "email": "school@allsaintscarnew.net"
  },
  {
    "i": "3056",
    "county": "Wicklow",
    "rollNumber": "15359G",
    "schoolName": "Shillelagh No 1 NS",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "Y14VH31",
    "addressOne": "Ballard",
    "addressTwo": "Shillelagh",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "52.7547231",
    "lng": "-6.5399277",
    "phone": "539429141",
    "email": "shillelagh@eircom.net"
  },
  {
    "i": "3057",
    "county": "Wicklow",
    "rollNumber": "15676S",
    "schoolName": "Padraig Naofa NS",
    "SETHours": "157.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "4.5",
    "spSNA": "3.66",
    "totalSNA": "8.16",
    "eircode": "A67HP90",
    "addressOne": "St Patricks Road",
    "addressTwo": "Wicklow",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.9785875",
    "lng": "-6.0472151",
    "phone": "40467415",
    "email": "stpatswicklow@gmail.com"
  },
  {
    "i": "3058",
    "county": "Wicklow",
    "rollNumber": "16027J",
    "schoolName": "SN Muire",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "W91DX22",
    "addressOne": "Stratford-on-slaney",
    "addressTwo": "Baltinglass",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "52.9887635",
    "lng": "-6.6726249",
    "phone": "596481279",
    "email": "stratfordns@gmail.com"
  },
  {
    "i": "3059",
    "county": "Wicklow",
    "rollNumber": "16573N",
    "schoolName": "St Brigids School",
    "SETHours": "150",
    "spClassTeachingPosts": "0",
    "mainSNA": "6.58",
    "spSNA": "0",
    "totalSNA": "6.58",
    "eircode": "A63WR64",
    "addressOne": "Trafalgar Road",
    "addressTwo": "Greystones",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "53.1472907",
    "lng": "-6.0634517",
    "phone": "12876113",
    "email": "office@stbgns.ie"
  },
  {
    "i": "3060",
    "county": "Wicklow",
    "rollNumber": "16634H",
    "schoolName": "St Laurence O'toole's Ns",
    "SETHours": "90",
    "spClassTeachingPosts": "1",
    "mainSNA": "3.33",
    "spSNA": "1",
    "totalSNA": "4.33",
    "eircode": "A98RP49",
    "addressOne": "Roundwood",
    "addressTwo": "Bray",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "53.0638654",
    "lng": "-6.226168",
    "phone": "12818399",
    "email": "roundwoodns@gmail.com"
  },
  {
    "i": "3061",
    "county": "Wicklow",
    "rollNumber": "16872A",
    "schoolName": "Cronan Naofa NS",
    "SETHours": "257.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "7",
    "spSNA": "2",
    "totalSNA": "9",
    "eircode": "A98NW42",
    "addressOne": "Vevay Crescent",
    "addressTwo": "Vevay Road",
    "addressThree": "Bray",
    "addressFour": "Co. Wicklow",
    "lat": "53.1991",
    "lng": "-6.1076432",
    "phone": "12860440",
    "email": "officestcronans@gmail.com"
  },
  {
    "i": "3062",
    "county": "Wicklow",
    "rollNumber": "16924Q",
    "schoolName": "Caoimhin Naofa NS",
    "SETHours": "62.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "3.16",
    "spSNA": "3.66",
    "totalSNA": "6.82",
    "eircode": "A98TR96",
    "addressOne": "Glendalough",
    "addressTwo": "Co. Wicklow",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.0102135",
    "lng": "-6.3017886",
    "phone": "40445460",
    "email": "office@scng.eu"
  },
  {
    "i": "3063",
    "county": "Wicklow",
    "rollNumber": "17091A",
    "schoolName": "SN Muire",
    "SETHours": "115",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "W91YN0P",
    "addressOne": "Main Street",
    "addressTwo": "Blessington",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "53.1721912",
    "lng": "-6.5294304",
    "phone": "45865501",
    "email": "principalstmarysjns@outlook.ie"
  },
  {
    "i": "3064",
    "county": "Wicklow",
    "rollNumber": "17181B",
    "schoolName": "St Josephs NS",
    "SETHours": "235",
    "spClassTeachingPosts": "5",
    "mainSNA": "2.83",
    "spSNA": "8.82",
    "totalSNA": "11.65",
    "eircode": "Y14X856",
    "addressOne": "Templerainey",
    "addressTwo": "Arklow",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "52.808906",
    "lng": "-6.1513813",
    "phone": "40232984",
    "email": "iosaifns@gmail.com"
  },
  {
    "i": "3065",
    "county": "Wicklow",
    "rollNumber": "17223O",
    "schoolName": "SN Muire Is Gearard",
    "SETHours": "57.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "A98DP70",
    "addressOne": "St. Mary's & St. Gerard's Ns",
    "addressTwo": "Enniskerry",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "53.1937004",
    "lng": "-6.1744809",
    "phone": "12868851",
    "email": "info@enniskerryns.ie"
  },
  {
    "i": "3066",
    "county": "Wicklow",
    "rollNumber": "17228B",
    "schoolName": "Clochar Muire NS",
    "SETHours": "62.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.83",
    "spSNA": "0",
    "totalSNA": "0.83",
    "eircode": "A67KW18",
    "addressOne": "Rathdrum",
    "addressTwo": "Co. Wicklow",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.9355202",
    "lng": "-6.2338243",
    "phone": "40446256",
    "email": "ourladysschool@gmail.com"
  },
  {
    "i": "3067",
    "county": "Wicklow",
    "rollNumber": "17265H",
    "schoolName": "Rathdrum Boys NS",
    "SETHours": "80",
    "spClassTeachingPosts": "0",
    "mainSNA": "4.33",
    "spSNA": "0",
    "totalSNA": "4.33",
    "eircode": "A67X381",
    "addressOne": "Rathdrum",
    "addressTwo": "Co. Wicklow",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.932666",
    "lng": "-6.2343217",
    "phone": "40446585",
    "email": "bnsrathdrum@gmail.com"
  },
  {
    "i": "3068",
    "county": "Wicklow",
    "rollNumber": "17304O",
    "schoolName": "Annacurra NS",
    "SETHours": "50",
    "spClassTeachingPosts": "2",
    "mainSNA": "1",
    "spSNA": "2.83",
    "totalSNA": "3.83",
    "eircode": "Y14TX83",
    "addressOne": "Annacurra",
    "addressTwo": "Tinahely",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "52.8415364",
    "lng": "-6.3562723",
    "phone": "40236669",
    "email": "annacurrans@gmail.com"
  },
  {
    "i": "3069",
    "county": "Wicklow",
    "rollNumber": "17500O",
    "schoolName": "SN Muire Mxd",
    "SETHours": "27.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "A67R296",
    "addressOne": "Barndarrig",
    "addressTwo": "Co. Wicklow",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.9157535",
    "lng": "-6.1123659",
    "phone": "40448322",
    "email": "barndarrigns@eircom.net"
  },
  {
    "i": "3070",
    "county": "Wicklow",
    "rollNumber": "17537O",
    "schoolName": "Scoil Padraig Naofa",
    "SETHours": "0",
    "spClassTeachingPosts": "0",
    "mainSNA": "10.81",
    "spSNA": "0",
    "totalSNA": "10.81",
    "eircode": "A98F652",
    "addressOne": "Vevay Road",
    "addressTwo": "Bray",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "53.1998595",
    "lng": "-6.1091498",
    "phone": "12860504",
    "email": "office@stpatsbray.com"
  },
  {
    "i": "3071",
    "county": "Wicklow",
    "rollNumber": "17576B",
    "schoolName": "Scoil An Choroin Mhuire",
    "SETHours": "165",
    "spClassTeachingPosts": "2",
    "mainSNA": "4",
    "spSNA": "2.83",
    "totalSNA": "6.83",
    "eircode": "A67P680",
    "addressOne": "Dominican Campus",
    "addressTwo": "Wicklow",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "52.9780089",
    "lng": "-6.0400129",
    "phone": "40467939",
    "email": "secretary@holyrosaryschool.ie"
  },
  {
    "i": "3072",
    "county": "Wicklow",
    "rollNumber": "17720F",
    "schoolName": "Scoil Naomh Caoimhghin",
    "SETHours": "157.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "3",
    "spSNA": "0.33",
    "totalSNA": "3.33",
    "eircode": "A63AD73",
    "addressOne": "Rathdown Road",
    "addressTwo": "Greystones",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "53.1489646",
    "lng": "-6.0748573",
    "phone": "12876660",
    "email": "office@stkevins.ie"
  },
  {
    "i": "3073",
    "county": "Wicklow",
    "rollNumber": "17810G",
    "schoolName": "Sn Nicolais Naofa",
    "SETHours": "97.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "1.5",
    "spSNA": "5",
    "totalSNA": "6.5",
    "eircode": "W91YY22",
    "addressOne": "Dunluain",
    "addressTwo": "Co Cill Mhantain",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.0551181",
    "lng": "-6.6987702",
    "phone": "45401495",
    "email": "snndunlavin@gmail.com"
  },
  {
    "i": "3074",
    "county": "Wicklow",
    "rollNumber": "17826V",
    "schoolName": "Scoil Na Coróine Mhuire",
    "SETHours": "142.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.66",
    "spSNA": "0",
    "totalSNA": "1.66",
    "eircode": "A67X257",
    "addressOne": "Ballinahinch",
    "addressTwo": "Ashford",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "53.0155277",
    "lng": "-6.1063545",
    "phone": "40440424",
    "email": "scoilnacoroinemhuireashford@gmail.com"
  },
  {
    "i": "3075",
    "county": "Wicklow",
    "rollNumber": "17907V",
    "schoolName": "Crossbridge NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "Y14YH51",
    "addressOne": "Crossbridge",
    "addressTwo": "Tinahely",
    "addressThree": "Co Wicklow",
    "addressFour": "",
    "lat": "52.8159669",
    "lng": "-6.4956929",
    "phone": "40238523",
    "email": "crossbridgens@eircom.net"
  },
  {
    "i": "3076",
    "county": "Wicklow",
    "rollNumber": "17920N",
    "schoolName": "Donard NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.83",
    "spSNA": "0",
    "totalSNA": "1.83",
    "eircode": "W91TW42",
    "addressOne": "Barrack Street",
    "addressTwo": "Donard",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "53.0230827",
    "lng": "-6.6155983",
    "phone": "45404884",
    "email": "donardnswicklow@gmail.com"
  },
  {
    "i": "3077",
    "county": "Wicklow",
    "rollNumber": "18033O",
    "schoolName": "Kilcommon NS",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "Y14Y302",
    "addressOne": "Kilcommon",
    "addressTwo": "Churchlands",
    "addressThree": "Tinahely",
    "addressFour": "Co. Wicklow",
    "lat": "52.7932738",
    "lng": "-6.4588754",
    "phone": "40238192",
    "email": "info@kilcommon.net"
  },
  {
    "i": "3078",
    "county": "Wicklow",
    "rollNumber": "18054W",
    "schoolName": "Hollywood NS",
    "SETHours": "47.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.5",
    "spSNA": "0",
    "totalSNA": "1.5",
    "eircode": "W91N260",
    "addressOne": "Hollywood Village",
    "addressTwo": "Hollywood",
    "addressThree": "Co Wicklow",
    "addressFour": "",
    "lat": "53.0915922",
    "lng": "-6.6007777",
    "phone": "45864014",
    "email": "hollywoodnatschool@gmail.com"
  },
  {
    "i": "3079",
    "county": "Wicklow",
    "rollNumber": "18118W",
    "schoolName": "Coolfancy NS",
    "SETHours": "32.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "Y14VY60",
    "addressOne": "Cul Fhasaigh",
    "addressTwo": "Tinahely",
    "addressThree": "Co Wicklow",
    "addressFour": "",
    "lat": "52.7636898",
    "lng": "-6.4322928",
    "phone": "40234866",
    "email": "coolfancynationalschool@gmail.com"
  },
  {
    "i": "3080",
    "county": "Wicklow",
    "rollNumber": "18198A",
    "schoolName": "Padraig Naofa NS",
    "SETHours": "67.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "Y14X588",
    "addressOne": "Avoca",
    "addressTwo": "Co Wicklow",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.8519714",
    "lng": "-6.2066376",
    "phone": "40235331",
    "email": "avocans@hotmail.com"
  },
  {
    "i": "3081",
    "county": "Wicklow",
    "rollNumber": "18242A",
    "schoolName": "Carnew NS",
    "SETHours": "122.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "6.83",
    "spSNA": "2.33",
    "totalSNA": "9.16",
    "eircode": "Y14XR62",
    "addressOne": "Carnew",
    "addressTwo": "Arklow",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "52.7119271",
    "lng": "-6.5043308",
    "phone": "539426315",
    "email": "carnewns@gmail.com"
  },
  {
    "i": "3082",
    "county": "Wicklow",
    "rollNumber": "18357R",
    "schoolName": "SN Padraig Naofa",
    "SETHours": "25",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "A98CC62",
    "addressOne": "Curtlestown",
    "addressTwo": "Enniskerry",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "53.1862658",
    "lng": "-6.2126259",
    "phone": "35312861649",
    "email": "curtlestownns@gmail.com"
  },
  {
    "i": "3083",
    "county": "Wicklow",
    "rollNumber": "18365Q",
    "schoolName": "Kilmacanogue NS",
    "SETHours": "85",
    "spClassTeachingPosts": "0",
    "mainSNA": "3.5",
    "spSNA": "0",
    "totalSNA": "3.5",
    "eircode": "A98D602",
    "addressOne": "Kilmacanogue",
    "addressTwo": "Bray",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "53.1683531",
    "lng": "-6.1403396",
    "phone": "12861934",
    "email": "kilmacanoguens@gmail.com"
  },
  {
    "i": "3084",
    "county": "Wicklow",
    "rollNumber": "18434J",
    "schoolName": "Rathcoyle NS",
    "SETHours": "17.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "W91PN26",
    "addressOne": "Rathcoyle Upper",
    "addressTwo": "Rathdangan",
    "addressThree": "Kiltegan",
    "addressFour": "Co. Wicklow",
    "lat": "52.9167417",
    "lng": "-6.5249798",
    "phone": "596473355",
    "email": "trionambyrne@gmail.com"
  },
  {
    "i": "3085",
    "county": "Wicklow",
    "rollNumber": "18464S",
    "schoolName": "St. Peter's Primary School",
    "SETHours": "105",
    "spClassTeachingPosts": "1",
    "mainSNA": "2.5",
    "spSNA": "0.75",
    "totalSNA": "3.25",
    "eircode": "A98YH93",
    "addressOne": "Hawthorn Road",
    "addressTwo": "Bray",
    "addressThree": "Co Wicklow",
    "addressFour": "",
    "lat": "53.2069974",
    "lng": "-6.1175679",
    "phone": "12860062",
    "email": "stpetersbray@gmail.com"
  },
  {
    "i": "3086",
    "county": "Wicklow",
    "rollNumber": "18470N",
    "schoolName": "Naomh Brid NS",
    "SETHours": "22.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "Y14W864",
    "addressOne": "Knockananna",
    "addressTwo": "Arklow",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "52.8731109",
    "lng": "-6.4971104",
    "phone": "596471364",
    "email": "snbknockananna@gmail.com"
  },
  {
    "i": "3087",
    "county": "Wicklow",
    "rollNumber": "18473T",
    "schoolName": "An Chroi Ro Naofa NS",
    "SETHours": "120",
    "spClassTeachingPosts": "0",
    "mainSNA": "3",
    "spSNA": "0",
    "totalSNA": "3",
    "eircode": "Y14YH98",
    "addressOne": "Main Street",
    "addressTwo": "Aughrim",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "52.8569988",
    "lng": "-6.3207818",
    "phone": "40236279",
    "email": "aughrimns.ias@eircom.net"
  },
  {
    "i": "3088",
    "county": "Wicklow",
    "rollNumber": "18489L",
    "schoolName": "Tinahely NS",
    "SETHours": "35",
    "spClassTeachingPosts": "2",
    "mainSNA": "0",
    "spSNA": "2.83",
    "totalSNA": "2.83",
    "eircode": "Y14DC85",
    "addressOne": "Tinahely",
    "addressTwo": "Arklow",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.7978822",
    "lng": "-6.4583075",
    "phone": "40238209",
    "email": "tinahelyns@gmail.com"
  },
  {
    "i": "3089",
    "county": "Wicklow",
    "rollNumber": "18502A",
    "schoolName": "SN Naomh Brid",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "W91H762",
    "addressOne": "Talbotstown",
    "addressTwo": "Kiltegan",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "52.9255465",
    "lng": "-6.6331634",
    "phone": "596473179",
    "email": "talbotstownprincipal@gmail.com"
  },
  {
    "i": "3090",
    "county": "Wicklow",
    "rollNumber": "19339U",
    "schoolName": "Stratford Lodge Ns",
    "SETHours": "35",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "W91KX75",
    "addressOne": "Baltinglass",
    "addressTwo": "Co Wicklow",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.9424818",
    "lng": "-6.709576",
    "phone": "596481919",
    "email": "stratfordlodge@gmail.com"
  },
  {
    "i": "3091",
    "county": "Wicklow",
    "rollNumber": "19573F",
    "schoolName": "St Laurences NS",
    "SETHours": "230",
    "spClassTeachingPosts": "1",
    "mainSNA": "6.66",
    "spSNA": "0.33",
    "totalSNA": "6.99",
    "eircode": "A63Y6P9",
    "addressOne": "Kindlestown",
    "addressTwo": "Greystones",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "53.1411659",
    "lng": "-6.0856186",
    "phone": "12876198",
    "email": "office@stlaurences.ie"
  },
  {
    "i": "3092",
    "county": "Wicklow",
    "rollNumber": "19584K",
    "schoolName": "Scoil Chualann",
    "SETHours": "85",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.5",
    "spSNA": "0",
    "totalSNA": "2.5",
    "eircode": "A98VP93",
    "addressOne": "Bóthar Vevay",
    "addressTwo": "Bré",
    "addressThree": "Co. Chill Mhantáin",
    "addressFour": "",
    "lat": "53.1921874",
    "lng": "-6.1040131",
    "phone": "12861388",
    "email": "oifigsc@scoilchualann.ie"
  },
  {
    "i": "3093",
    "county": "Wicklow",
    "rollNumber": "19734D",
    "schoolName": "St Francis NS",
    "SETHours": "42.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "A63YX22",
    "addressOne": "Church Lane",
    "addressTwo": "Newcastle",
    "addressThree": "Greystones",
    "addressFour": "",
    "lat": "53.0731962",
    "lng": "-6.0751724",
    "phone": "12819631",
    "email": "saintfrancisns@gmail.com"
  },
  {
    "i": "3094",
    "county": "Wicklow",
    "rollNumber": "19748O",
    "schoolName": "Scoil Mhuire Na Naird",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "0.5",
    "spSNA": "0",
    "totalSNA": "0.5",
    "eircode": "Y14W866",
    "addressOne": "Shillelagh",
    "addressTwo": "Co Wicklow",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.7624312",
    "lng": "-6.5273535",
    "phone": "539429166",
    "email": "muirenanaird.ias@gmail.com"
  },
  {
    "i": "3095",
    "county": "Wicklow",
    "rollNumber": "19754J",
    "schoolName": "Bray School Project NS",
    "SETHours": "100",
    "spClassTeachingPosts": "2",
    "mainSNA": "5",
    "spSNA": "4",
    "totalSNA": "9",
    "eircode": "A98RT02",
    "addressOne": "Killarney Rd",
    "addressTwo": "Ballywaltrim",
    "addressThree": "Bray",
    "addressFour": "Co Wicklow",
    "lat": "53.1883773",
    "lng": "-6.1261746",
    "phone": "12864242",
    "email": "office@brayschoolproject.ie"
  },
  {
    "i": "3096",
    "county": "Wicklow",
    "rollNumber": "20016D",
    "schoolName": "Gaelscoil Ui Cheadaigh",
    "SETHours": "62.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "1.58",
    "spSNA": "0",
    "totalSNA": "1.58",
    "eircode": "A98YH48",
    "addressOne": "Bóthar Vevay",
    "addressTwo": "Bré",
    "addressThree": "Co.chill Mhantáin",
    "addressFour": "",
    "lat": "53.1993613",
    "lng": "-6.1093187",
    "phone": "12865044",
    "email": "oifig@gaelscoiluicheadaigh.ie"
  },
  {
    "i": "3097",
    "county": "Wicklow",
    "rollNumber": "20039P",
    "schoolName": "Scoil Naomh Iosaf",
    "SETHours": "162.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "2.83",
    "spSNA": "5",
    "totalSNA": "7.83",
    "eircode": "W91EF95",
    "addressOne": "Lathaleer",
    "addressTwo": "Baltinglass",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "52.9368727",
    "lng": "-6.7009217",
    "phone": "596481083",
    "email": "scoilnaomhiosafbaltinglass@gmail.com"
  },
  {
    "i": "3098",
    "county": "Wicklow",
    "rollNumber": "20045K",
    "schoolName": "Gaelscoil Chill Mhantáin",
    "SETHours": "75",
    "spClassTeachingPosts": "0",
    "mainSNA": "2.75",
    "spSNA": "0",
    "totalSNA": "2.75",
    "eircode": "A67N797",
    "addressOne": "Former Abbey Community College",
    "addressTwo": "Wicklow",
    "addressThree": "Co Wicklow",
    "addressFour": "",
    "lat": "52.9825707",
    "lng": "-6.0488364",
    "phone": "40467177",
    "email": "gaelscoil@gmail.com"
  },
  {
    "i": "3099",
    "county": "Wicklow",
    "rollNumber": "20080M",
    "schoolName": "Gaelscoil An Inbhir Mhoir",
    "SETHours": "160",
    "spClassTeachingPosts": "1",
    "mainSNA": "2",
    "spSNA": "2",
    "totalSNA": "4",
    "eircode": "Y14XV50",
    "addressOne": "Bóthar Emoclew",
    "addressTwo": "An Tinbhear Mór",
    "addressThree": "Co. Chill Mhantáin",
    "addressFour": "",
    "lat": "52.7922756",
    "lng": "-6.1744247",
    "phone": "40239199",
    "email": "oifig@gaelscoilim.ie"
  },
  {
    "i": "3100",
    "county": "Wicklow",
    "rollNumber": "20110S",
    "schoolName": "SN Mhuire Sn School",
    "SETHours": "150",
    "spClassTeachingPosts": "0",
    "mainSNA": "5",
    "spSNA": "0",
    "totalSNA": "5",
    "eircode": "W91RX84",
    "addressOne": "Blessington",
    "addressTwo": "Co. Wicklow",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.1737685",
    "lng": "-6.530722",
    "phone": "45900499",
    "email": "info@stmarysns.ie"
  },
  {
    "i": "3101",
    "county": "Wicklow",
    "rollNumber": "20178G",
    "schoolName": "Wicklow Educate Together Ns",
    "SETHours": "222.5",
    "spClassTeachingPosts": "3",
    "mainSNA": "5.5",
    "spSNA": "7.5",
    "totalSNA": "13",
    "eircode": "A67E371",
    "addressOne": "Hawkstown Road",
    "addressTwo": "Wicklow Town",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.9801149",
    "lng": "-6.0645097",
    "phone": "40462786",
    "email": "info@wicklowetns.com"
  },
  {
    "i": "3102",
    "county": "Wicklow",
    "rollNumber": "20208M",
    "schoolName": "St Coen's NS",
    "SETHours": "152.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "3.83",
    "spSNA": "3.66",
    "totalSNA": "7.49",
    "eircode": "A67CY68",
    "addressOne": "Merrymeeting",
    "addressTwo": "Rathnew",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "52.9882035",
    "lng": "-6.0764823",
    "phone": "40431200",
    "email": "info@stcoens.ie"
  },
  {
    "i": "3103",
    "county": "Wicklow",
    "rollNumber": "20242M",
    "schoolName": "Blessington Educate Together",
    "SETHours": "20",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "W91DK23",
    "addressOne": "Red Lane",
    "addressTwo": "Blessington",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "53.1793423",
    "lng": "-6.5068028",
    "phone": "45865281",
    "email": "office@betns.ie"
  },
  {
    "i": "3104",
    "county": "Wicklow",
    "rollNumber": "20243O",
    "schoolName": "Gael Scoil Na Lochanna",
    "SETHours": "40",
    "spClassTeachingPosts": "0",
    "mainSNA": "1",
    "spSNA": "0",
    "totalSNA": "1",
    "eircode": "W91A403",
    "addressOne": "Cill Moloma",
    "addressTwo": "Baile Coimí­n",
    "addressThree": "Co. Chill Mhantáin",
    "addressFour": "",
    "lat": "53.1616689",
    "lng": "-6.5524471",
    "phone": "45900525",
    "email": "priomhoide@gaelscoilnalochanna.com"
  },
  {
    "i": "3105",
    "county": "Wicklow",
    "rollNumber": "20278K",
    "schoolName": "Newtownmountkennedy Primary School",
    "SETHours": "190",
    "spClassTeachingPosts": "4",
    "mainSNA": "3.58",
    "spSNA": "9.66",
    "totalSNA": "13.24",
    "eircode": "A63FP76",
    "addressOne": "Newtownmountkennedy",
    "addressTwo": "Co. Wicklow",
    "addressThree": "",
    "addressFour": "",
    "lat": "53.0900827",
    "lng": "-6.1158186",
    "phone": "12810048",
    "email": "office@newtownprimary.ie"
  },
  {
    "i": "3106",
    "county": "Wicklow",
    "rollNumber": "20300A",
    "schoolName": "Greystones Educate Together NS",
    "SETHours": "192.5",
    "spClassTeachingPosts": "2",
    "mainSNA": "5.83",
    "spSNA": "5.66",
    "totalSNA": "11.49",
    "eircode": "A63YE36",
    "addressOne": "Blacklion",
    "addressTwo": "Greystones",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "53.1518038",
    "lng": "-6.0847633",
    "phone": "12871817",
    "email": "contact@greystoneset.ie"
  },
  {
    "i": "3107",
    "county": "Wicklow",
    "rollNumber": "20301C",
    "schoolName": "Gaelscoil Na Gcloch Liath",
    "SETHours": "70",
    "spClassTeachingPosts": "0",
    "mainSNA": "2",
    "spSNA": "0",
    "totalSNA": "2",
    "eircode": "A63AN22",
    "addressOne": "Blacklion",
    "addressTwo": "Greystones",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "53.1517411",
    "lng": "-6.0870114",
    "phone": "12010718",
    "email": "rita@gscl.ie"
  },
  {
    "i": "3108",
    "county": "Wicklow",
    "rollNumber": "20346B",
    "schoolName": "Kilcoole Primary School",
    "SETHours": "247.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "8.83",
    "spSNA": "0",
    "totalSNA": "8.83",
    "eircode": "A63XT71",
    "addressOne": "Main Street",
    "addressTwo": "Kilcoole",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "53.1108866",
    "lng": "-6.0673727",
    "phone": "12874649",
    "email": "kilcooleprimaryschool@gmail.com"
  },
  {
    "i": "3109",
    "county": "Wicklow",
    "rollNumber": "20466L",
    "schoolName": "St Fergal's NS",
    "SETHours": "192.5",
    "spClassTeachingPosts": "0",
    "mainSNA": "6.83",
    "spSNA": "0",
    "totalSNA": "6.83",
    "eircode": "A98A521",
    "addressOne": "Ballywaltrim",
    "addressTwo": "Bray",
    "addressThree": "Co. Wicklow",
    "addressFour": "",
    "lat": "53.1868895",
    "lng": "-6.1249294",
    "phone": "12868033",
    "email": "principal@stfergalsnsbray.ie"
  },
  {
    "i": "3110",
    "county": "Wicklow",
    "rollNumber": "20469R",
    "schoolName": "St John's Sn School",
    "SETHours": "145",
    "spClassTeachingPosts": "2",
    "mainSNA": "3.5",
    "spSNA": "4",
    "totalSNA": "7.5",
    "eircode": "Y14PA97",
    "addressOne": "Coolgreaney Road",
    "addressTwo": "Arklow",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.7981054",
    "lng": "-6.1659677",
    "phone": "40232545",
    "email": "principal@stjohnsarklow.ie"
  },
  {
    "i": "3111",
    "county": "Wicklow",
    "rollNumber": "20470C",
    "schoolName": "St Michael's And St Peter's Jn School",
    "SETHours": "185",
    "spClassTeachingPosts": "3",
    "mainSNA": "4",
    "spSNA": "5.32",
    "totalSNA": "9.32",
    "eircode": "Y14R239",
    "addressOne": "Hickey's Hill;",
    "addressTwo": "Arklow",
    "addressThree": "",
    "addressFour": "",
    "lat": "52.7970877",
    "lng": "-6.1563038",
    "phone": "40239861",
    "email": "office@ssmichaelandpeter.ie"
  },
  {
    "i": "3112",
    "county": "Wicklow",
    "rollNumber": "20473I",
    "schoolName": "Greystones Community Ns",
    "SETHours": "130.5",
    "spClassTeachingPosts": "1",
    "mainSNA": "4",
    "spSNA": "1",
    "totalSNA": "5",
    "eircode": "A63RY64",
    "addressOne": "Greystones Rugby Club",
    "addressTwo": "Mill Road",
    "addressThree": "Greystones",
    "addressFour": "",
    "lat": "53.1342885",
    "lng": "-6.0665428",
    "phone": "874007442",
    "email": "admin@greystonescns.ie"
  },
  {
    "i": "3113",
    "county": "Wicklow",
    "rollNumber": "20524W",
    "schoolName": "Newtownmountkennedy Educate Together NS",
    "SETHours": "30",
    "spClassTeachingPosts": "0",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "",
    "addressOne": "Ntmk Educate Together Ns",
    "addressTwo": "Newtownmountkennedy",
    "addressThree": "Co Wicklow",
    "addressFour": "",
    "lat": "52.6732221",
    "lng": "-7.2899519"
  },
  {
    "i": "3113",
    "county": "Dublin",
    "rollNumber": "20543D",
    "schoolName": "Sallynoggin ETNS",
    "SETHours": "20.5",
    "spClassTeachingPosts": "",
    "mainSNA": "0",
    "spSNA": "0",
    "totalSNA": "0",
    "eircode": "A96P210",
    "addressOne": "Sallynoggin ETNS",
    "addressTwo": "Eblana Avenue",
    "addressThree": "Dun Laoghaire",
    "addressFour": "Co Dublin",
    "lat": "53.2934465",
    "lng": "-6.1536005"
  }
]

export default SCHOOLS_DETAILS